import * as dn from "react";
import M, { memo as mr, useRef as Ue, useEffect as pe, useState as de, useMemo as Vn, useContext as We, forwardRef as Ol, Children as nh, createContext as sn, useCallback as ft, lazy as Gs, useReducer as ra, Suspense as BE, Fragment as ll, useLayoutEffect as ME, Component as LE, isValidElement as ul, cloneElement as y0, createElement as Fr } from "react";
import { useIntl as ye, FormattedMessage as en, IntlProvider as l3, createIntl as u3 } from "react-intl";
import or from "lodash.clonedeep";
import c3 from "lodash.set";
import * as d3 from "react-dom";
import $E from "react-dom";
import Wr from "markdown-to-jsx";
import { QueryClient as f3, QueryClientProvider as h3, useMutation as Ut, useQueryClient as up, useInfiniteQuery as cp, useQuery as p3 } from "@tanstack/react-query";
import { ReactQueryDevtools as m3 } from "@tanstack/react-query-devtools";
import ic from "posthog-js";
import { CookiesProvider as g3, useCookies as jE } from "react-cookie";
import { DEFAULT_LOCALE as HE, ALL_LOCALES as v3, ALL_LOCALES_WITH_LABELS as y3 } from "@apolitical/contracts";
import cl from "truncate";
import Sc from "lodash.isequal";
import UE from "lodash.get";
import { ErrorBoundary as E3 } from "react-error-boundary";
import { ReactMultiEmail as b3 } from "react-multi-email";
var Zl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Or(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function zE(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var qE = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var a = arguments[i];
        if (a) {
          var s = typeof a;
          if (s === "string" || s === "number")
            r.push(a);
          else if (Array.isArray(a)) {
            if (a.length) {
              var o = n.apply(null, a);
              o && r.push(o);
            }
          } else if (s === "object") {
            if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
              r.push(a.toString());
              continue;
            }
            for (var l in a)
              t.call(a, l) && a[l] && r.push(l);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(qE);
var T3 = qE.exports;
const te = /* @__PURE__ */ Or(T3), _3 = ({
  element: e = "span",
  showOnFocus: t = !0,
  children: n,
  className: r = "",
  ...i
}) => M.createElement(e, {
  ...i,
  className: te("hidden", r, { "show-on-focus": t }),
  children: n
}), ht = mr(_3), C3 = ({
  element: e = "span",
  children: t = null,
  ...n
}) => M.createElement(e, { ...n, "aria-hidden": !0 }, t), dp = mr(C3);
var rh = { exports: {} }, so = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var E0;
function x3() {
  if (E0)
    return so;
  E0 = 1;
  var e = M, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(o, l, u) {
    var c, d = {}, f = null, p = null;
    u !== void 0 && (f = "" + u), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (c in l)
      r.call(l, c) && !a.hasOwnProperty(c) && (d[c] = l[c]);
    if (o && o.defaultProps)
      for (c in l = o.defaultProps, l)
        d[c] === void 0 && (d[c] = l[c]);
    return { $$typeof: t, type: o, key: f, ref: p, props: d, _owner: i.current };
  }
  return so.Fragment = n, so.jsx = s, so.jsxs = s, so;
}
var oo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b0;
function w3() {
  return b0 || (b0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = M, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), o = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), g = Symbol.iterator, m = "@@iterator";
    function y(K) {
      if (K === null || typeof K != "object")
        return null;
      var Ee = g && K[g] || K[m];
      return typeof Ee == "function" ? Ee : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(K) {
      {
        for (var Ee = arguments.length, ke = new Array(Ee > 1 ? Ee - 1 : 0), qe = 1; qe < Ee; qe++)
          ke[qe - 1] = arguments[qe];
        b("error", K, ke);
      }
    }
    function b(K, Ee, ke) {
      {
        var qe = v.ReactDebugCurrentFrame, vt = qe.getStackAddendum();
        vt !== "" && (Ee += "%s", ke = ke.concat([vt]));
        var Nt = ke.map(function(dt) {
          return String(dt);
        });
        Nt.unshift("Warning: " + Ee), Function.prototype.apply.call(console[K], console, Nt);
      }
    }
    var _ = !1, T = !1, x = !1, A = !1, R = !1, P;
    P = Symbol.for("react.module.reference");
    function L(K) {
      return !!(typeof K == "string" || typeof K == "function" || K === r || K === a || R || K === i || K === u || K === c || A || K === p || _ || T || x || typeof K == "object" && K !== null && (K.$$typeof === f || K.$$typeof === d || K.$$typeof === s || K.$$typeof === o || K.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      K.$$typeof === P || K.getModuleId !== void 0));
    }
    function I(K, Ee, ke) {
      var qe = K.displayName;
      if (qe)
        return qe;
      var vt = Ee.displayName || Ee.name || "";
      return vt !== "" ? ke + "(" + vt + ")" : ke;
    }
    function O(K) {
      return K.displayName || "Context";
    }
    function S(K) {
      if (K == null)
        return null;
      if (typeof K.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof K == "function")
        return K.displayName || K.name || null;
      if (typeof K == "string")
        return K;
      switch (K) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof K == "object")
        switch (K.$$typeof) {
          case o:
            var Ee = K;
            return O(Ee) + ".Consumer";
          case s:
            var ke = K;
            return O(ke._context) + ".Provider";
          case l:
            return I(K, K.render, "ForwardRef");
          case d:
            var qe = K.displayName || null;
            return qe !== null ? qe : S(K.type) || "Memo";
          case f: {
            var vt = K, Nt = vt._payload, dt = vt._init;
            try {
              return S(dt(Nt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, H = 0, q, N, Q, J, D, C, Z;
    function B() {
    }
    B.__reactDisabledLog = !0;
    function j() {
      {
        if (H === 0) {
          q = console.log, N = console.info, Q = console.warn, J = console.error, D = console.group, C = console.groupCollapsed, Z = console.groupEnd;
          var K = {
            configurable: !0,
            enumerable: !0,
            value: B,
            writable: !0
          };
          Object.defineProperties(console, {
            info: K,
            log: K,
            warn: K,
            error: K,
            group: K,
            groupCollapsed: K,
            groupEnd: K
          });
        }
        H++;
      }
    }
    function z() {
      {
        if (H--, H === 0) {
          var K = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, K, {
              value: q
            }),
            info: F({}, K, {
              value: N
            }),
            warn: F({}, K, {
              value: Q
            }),
            error: F({}, K, {
              value: J
            }),
            group: F({}, K, {
              value: D
            }),
            groupCollapsed: F({}, K, {
              value: C
            }),
            groupEnd: F({}, K, {
              value: Z
            })
          });
        }
        H < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var U = v.ReactCurrentDispatcher, $;
    function ae(K, Ee, ke) {
      {
        if ($ === void 0)
          try {
            throw Error();
          } catch (vt) {
            var qe = vt.stack.trim().match(/\n( *(at )?)/);
            $ = qe && qe[1] || "";
          }
        return `
` + $ + K;
      }
    }
    var Y = !1, ee;
    {
      var se = typeof WeakMap == "function" ? WeakMap : Map;
      ee = new se();
    }
    function re(K, Ee) {
      if (!K || Y)
        return "";
      {
        var ke = ee.get(K);
        if (ke !== void 0)
          return ke;
      }
      var qe;
      Y = !0;
      var vt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Nt;
      Nt = U.current, U.current = null, j();
      try {
        if (Ee) {
          var dt = function() {
            throw Error();
          };
          if (Object.defineProperty(dt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(dt, []);
            } catch (ii) {
              qe = ii;
            }
            Reflect.construct(K, [], dt);
          } else {
            try {
              dt.call();
            } catch (ii) {
              qe = ii;
            }
            K.call(dt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ii) {
            qe = ii;
          }
          K();
        }
      } catch (ii) {
        if (ii && qe && typeof ii.stack == "string") {
          for (var st = ii.stack.split(`
`), vn = qe.stack.split(`
`), Wt = st.length - 1, Gt = vn.length - 1; Wt >= 1 && Gt >= 0 && st[Wt] !== vn[Gt]; )
            Gt--;
          for (; Wt >= 1 && Gt >= 0; Wt--, Gt--)
            if (st[Wt] !== vn[Gt]) {
              if (Wt !== 1 || Gt !== 1)
                do
                  if (Wt--, Gt--, Gt < 0 || st[Wt] !== vn[Gt]) {
                    var Xn = `
` + st[Wt].replace(" at new ", " at ");
                    return K.displayName && Xn.includes("<anonymous>") && (Xn = Xn.replace("<anonymous>", K.displayName)), typeof K == "function" && ee.set(K, Xn), Xn;
                  }
                while (Wt >= 1 && Gt >= 0);
              break;
            }
        }
      } finally {
        Y = !1, U.current = Nt, z(), Error.prepareStackTrace = vt;
      }
      var Ja = K ? K.displayName || K.name : "", v0 = Ja ? ae(Ja) : "";
      return typeof K == "function" && ee.set(K, v0), v0;
    }
    function Ae(K, Ee, ke) {
      return re(K, !1);
    }
    function Oe(K) {
      var Ee = K.prototype;
      return !!(Ee && Ee.isReactComponent);
    }
    function Ce(K, Ee, ke) {
      if (K == null)
        return "";
      if (typeof K == "function")
        return re(K, Oe(K));
      if (typeof K == "string")
        return ae(K);
      switch (K) {
        case u:
          return ae("Suspense");
        case c:
          return ae("SuspenseList");
      }
      if (typeof K == "object")
        switch (K.$$typeof) {
          case l:
            return Ae(K.render);
          case d:
            return Ce(K.type, Ee, ke);
          case f: {
            var qe = K, vt = qe._payload, Nt = qe._init;
            try {
              return Ce(Nt(vt), Ee, ke);
            } catch {
            }
          }
        }
      return "";
    }
    var ue = Object.prototype.hasOwnProperty, fe = {}, Se = v.ReactDebugCurrentFrame;
    function Fe(K) {
      if (K) {
        var Ee = K._owner, ke = Ce(K.type, K._source, Ee ? Ee.type : null);
        Se.setExtraStackFrame(ke);
      } else
        Se.setExtraStackFrame(null);
    }
    function nt(K, Ee, ke, qe, vt) {
      {
        var Nt = Function.call.bind(ue);
        for (var dt in K)
          if (Nt(K, dt)) {
            var st = void 0;
            try {
              if (typeof K[dt] != "function") {
                var vn = Error((qe || "React class") + ": " + ke + " type `" + dt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof K[dt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw vn.name = "Invariant Violation", vn;
              }
              st = K[dt](Ee, dt, qe, ke, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Wt) {
              st = Wt;
            }
            st && !(st instanceof Error) && (Fe(vt), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", qe || "React class", ke, dt, typeof st), Fe(null)), st instanceof Error && !(st.message in fe) && (fe[st.message] = !0, Fe(vt), E("Failed %s type: %s", ke, st.message), Fe(null));
          }
      }
    }
    var mt = Array.isArray;
    function Ze(K) {
      return mt(K);
    }
    function rt(K) {
      {
        var Ee = typeof Symbol == "function" && Symbol.toStringTag, ke = Ee && K[Symbol.toStringTag] || K.constructor.name || "Object";
        return ke;
      }
    }
    function Qe(K) {
      try {
        return ie(K), !1;
      } catch {
        return !0;
      }
    }
    function ie(K) {
      return "" + K;
    }
    function me(K) {
      if (Qe(K))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", rt(K)), ie(K);
    }
    var Pe = v.ReactCurrentOwner, ge = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, X, xe, ve;
    ve = {};
    function Ne(K) {
      if (ue.call(K, "ref")) {
        var Ee = Object.getOwnPropertyDescriptor(K, "ref").get;
        if (Ee && Ee.isReactWarning)
          return !1;
      }
      return K.ref !== void 0;
    }
    function Tt(K) {
      if (ue.call(K, "key")) {
        var Ee = Object.getOwnPropertyDescriptor(K, "key").get;
        if (Ee && Ee.isReactWarning)
          return !1;
      }
      return K.key !== void 0;
    }
    function Ge(K, Ee) {
      if (typeof K.ref == "string" && Pe.current && Ee && Pe.current.stateNode !== Ee) {
        var ke = S(Pe.current.type);
        ve[ke] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', S(Pe.current.type), K.ref), ve[ke] = !0);
      }
    }
    function gt(K, Ee) {
      {
        var ke = function() {
          X || (X = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ee));
        };
        ke.isReactWarning = !0, Object.defineProperty(K, "key", {
          get: ke,
          configurable: !0
        });
      }
    }
    function qt(K, Ee) {
      {
        var ke = function() {
          xe || (xe = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Ee));
        };
        ke.isReactWarning = !0, Object.defineProperty(K, "ref", {
          get: ke,
          configurable: !0
        });
      }
    }
    var wt = function(K, Ee, ke, qe, vt, Nt, dt) {
      var st = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: K,
        key: Ee,
        ref: ke,
        props: dt,
        // Record the component responsible for creating this element.
        _owner: Nt
      };
      return st._store = {}, Object.defineProperty(st._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(st, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: qe
      }), Object.defineProperty(st, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: vt
      }), Object.freeze && (Object.freeze(st.props), Object.freeze(st)), st;
    };
    function wn(K, Ee, ke, qe, vt) {
      {
        var Nt, dt = {}, st = null, vn = null;
        ke !== void 0 && (me(ke), st = "" + ke), Tt(Ee) && (me(Ee.key), st = "" + Ee.key), Ne(Ee) && (vn = Ee.ref, Ge(Ee, vt));
        for (Nt in Ee)
          ue.call(Ee, Nt) && !ge.hasOwnProperty(Nt) && (dt[Nt] = Ee[Nt]);
        if (K && K.defaultProps) {
          var Wt = K.defaultProps;
          for (Nt in Wt)
            dt[Nt] === void 0 && (dt[Nt] = Wt[Nt]);
        }
        if (st || vn) {
          var Gt = typeof K == "function" ? K.displayName || K.name || "Unknown" : K;
          st && gt(dt, Gt), vn && qt(dt, Gt);
        }
        return wt(K, st, vn, vt, qe, Pe.current, dt);
      }
    }
    var At = v.ReactCurrentOwner, Rr = v.ReactDebugCurrentFrame;
    function Qn(K) {
      if (K) {
        var Ee = K._owner, ke = Ce(K.type, K._source, Ee ? Ee.type : null);
        Rr.setExtraStackFrame(ke);
      } else
        Rr.setExtraStackFrame(null);
    }
    var U1;
    U1 = !1;
    function z1(K) {
      return typeof K == "object" && K !== null && K.$$typeof === t;
    }
    function f0() {
      {
        if (At.current) {
          var K = S(At.current.type);
          if (K)
            return `

Check the render method of \`` + K + "`.";
        }
        return "";
      }
    }
    function e3(K) {
      {
        if (K !== void 0) {
          var Ee = K.fileName.replace(/^.*[\\\/]/, ""), ke = K.lineNumber;
          return `

Check your code at ` + Ee + ":" + ke + ".";
        }
        return "";
      }
    }
    var h0 = {};
    function t3(K) {
      {
        var Ee = f0();
        if (!Ee) {
          var ke = typeof K == "string" ? K : K.displayName || K.name;
          ke && (Ee = `

Check the top-level render call using <` + ke + ">.");
        }
        return Ee;
      }
    }
    function p0(K, Ee) {
      {
        if (!K._store || K._store.validated || K.key != null)
          return;
        K._store.validated = !0;
        var ke = t3(Ee);
        if (h0[ke])
          return;
        h0[ke] = !0;
        var qe = "";
        K && K._owner && K._owner !== At.current && (qe = " It was passed a child from " + S(K._owner.type) + "."), Qn(K), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ke, qe), Qn(null);
      }
    }
    function m0(K, Ee) {
      {
        if (typeof K != "object")
          return;
        if (Ze(K))
          for (var ke = 0; ke < K.length; ke++) {
            var qe = K[ke];
            z1(qe) && p0(qe, Ee);
          }
        else if (z1(K))
          K._store && (K._store.validated = !0);
        else if (K) {
          var vt = y(K);
          if (typeof vt == "function" && vt !== K.entries)
            for (var Nt = vt.call(K), dt; !(dt = Nt.next()).done; )
              z1(dt.value) && p0(dt.value, Ee);
        }
      }
    }
    function n3(K) {
      {
        var Ee = K.type;
        if (Ee == null || typeof Ee == "string")
          return;
        var ke;
        if (typeof Ee == "function")
          ke = Ee.propTypes;
        else if (typeof Ee == "object" && (Ee.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Ee.$$typeof === d))
          ke = Ee.propTypes;
        else
          return;
        if (ke) {
          var qe = S(Ee);
          nt(ke, K.props, "prop", qe, K);
        } else if (Ee.PropTypes !== void 0 && !U1) {
          U1 = !0;
          var vt = S(Ee);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", vt || "Unknown");
        }
        typeof Ee.getDefaultProps == "function" && !Ee.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function r3(K) {
      {
        for (var Ee = Object.keys(K.props), ke = 0; ke < Ee.length; ke++) {
          var qe = Ee[ke];
          if (qe !== "children" && qe !== "key") {
            Qn(K), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", qe), Qn(null);
            break;
          }
        }
        K.ref !== null && (Qn(K), E("Invalid attribute `ref` supplied to `React.Fragment`."), Qn(null));
      }
    }
    function g0(K, Ee, ke, qe, vt, Nt) {
      {
        var dt = L(K);
        if (!dt) {
          var st = "";
          (K === void 0 || typeof K == "object" && K !== null && Object.keys(K).length === 0) && (st += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var vn = e3(vt);
          vn ? st += vn : st += f0();
          var Wt;
          K === null ? Wt = "null" : Ze(K) ? Wt = "array" : K !== void 0 && K.$$typeof === t ? (Wt = "<" + (S(K.type) || "Unknown") + " />", st = " Did you accidentally export a JSX literal instead of a component?") : Wt = typeof K, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Wt, st);
        }
        var Gt = wn(K, Ee, ke, vt, Nt);
        if (Gt == null)
          return Gt;
        if (dt) {
          var Xn = Ee.children;
          if (Xn !== void 0)
            if (qe)
              if (Ze(Xn)) {
                for (var Ja = 0; Ja < Xn.length; Ja++)
                  m0(Xn[Ja], K);
                Object.freeze && Object.freeze(Xn);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              m0(Xn, K);
        }
        return K === r ? r3(Gt) : n3(Gt), Gt;
      }
    }
    function i3(K, Ee, ke) {
      return g0(K, Ee, ke, !0);
    }
    function a3(K, Ee, ke) {
      return g0(K, Ee, ke, !1);
    }
    var s3 = a3, o3 = i3;
    oo.Fragment = r, oo.jsx = s3, oo.jsxs = o3;
  }()), oo;
}
process.env.NODE_ENV === "production" ? rh.exports = x3() : rh.exports = w3();
var h = rh.exports;
const A3 = 50, S3 = 8, k3 = (e, t) => {
  if (!e)
    return !1;
  const n = Ue(null), r = t || n;
  return pe(() => {
    const i = r.current, a = () => {
      if (i) {
        const s = parseInt(i.style.height.replace("px", "")) || 0, o = i.scrollHeight, l = Math.abs(o - s);
        o !== s && l > S3 && (i.style.height = `${o}px`, i.scrollHeight >= A3 ? i.classList.contains("single-line") && i.classList.remove("single-line") : i.classList.contains("single-line") || i.classList.add("single-line"));
      }
    };
    if (i)
      return a(), i.addEventListener("input", a), () => i.removeEventListener("input", a);
  }, []), r;
}, D3 = () => {
  const [e, t] = de(window.location.pathname), n = () => {
    const r = window.location.pathname;
    t(r);
  };
  return pe(() => (window.addEventListener("popstate", n), () => {
    window.removeEventListener("popstate", n);
  }), []), e;
}, dl = (e, t) => {
  const n = Ue(!1);
  pe(() => {
    n.current ? e() : n.current = !0;
  }, t);
};
function fl(e, t, n) {
  var r = this, i = Ue(null), a = Ue(0), s = Ue(null), o = Ue([]), l = Ue(), u = Ue(), c = Ue(e), d = Ue(!0);
  c.current = e;
  var f = typeof window < "u", p = !t && t !== 0 && f;
  if (typeof e != "function")
    throw new TypeError("Expected a function");
  t = +t || 0;
  var g = !!(n = n || {}).leading, m = !("trailing" in n) || !!n.trailing, y = "maxWait" in n, v = "debounceOnServer" in n && !!n.debounceOnServer, E = y ? Math.max(+n.maxWait || 0, t) : null;
  pe(function() {
    return d.current = !0, function() {
      d.current = !1;
    };
  }, []);
  var b = Vn(function() {
    var _ = function(L) {
      var I = o.current, O = l.current;
      return o.current = l.current = null, a.current = L, u.current = c.current.apply(O, I);
    }, T = function(L, I) {
      p && cancelAnimationFrame(s.current), s.current = p ? requestAnimationFrame(L) : setTimeout(L, I);
    }, x = function(L) {
      if (!d.current)
        return !1;
      var I = L - i.current;
      return !i.current || I >= t || I < 0 || y && L - a.current >= E;
    }, A = function(L) {
      return s.current = null, m && o.current ? _(L) : (o.current = l.current = null, u.current);
    }, R = function L() {
      var I = Date.now();
      if (x(I))
        return A(I);
      if (d.current) {
        var O = t - (I - i.current), S = y ? Math.min(O, E - (I - a.current)) : O;
        T(L, S);
      }
    }, P = function() {
      if (f || v) {
        var L = Date.now(), I = x(L);
        if (o.current = [].slice.call(arguments), l.current = r, i.current = L, I) {
          if (!s.current && d.current)
            return a.current = i.current, T(R, t), g ? _(i.current) : u.current;
          if (y)
            return T(R, t), _(i.current);
        }
        return s.current || T(R, t), u.current;
      }
    };
    return P.cancel = function() {
      s.current && (p ? cancelAnimationFrame(s.current) : clearTimeout(s.current)), a.current = 0, o.current = i.current = l.current = s.current = null;
    }, P.isPending = function() {
      return !!s.current;
    }, P.flush = function() {
      return s.current ? A(Date.now()) : u.current;
    }, P;
  }, [g, y, t, E, m, p, f, v]);
  return b;
}
function WE(e, t, n) {
  var r = n === void 0 ? {} : n, i = r.leading, a = r.trailing;
  return fl(e, t, { maxWait: t, leading: i === void 0 || i, trailing: a === void 0 || a });
}
let q1;
const Ua = (e = !0, t = !1, n = "window") => {
  if (!e)
    return;
  const [r, i] = M.useState(0) || [!1, () => {
  }];
  pe(() => (o(), window.addEventListener("resize", u), window.addEventListener("hashchange", u), window.addEventListener("hiddenSectionVisible", l), () => {
    clearTimeout(q1), u.flush(), window.removeEventListener("resize", u), window.removeEventListener("hashchange", u), window.removeEventListener("hiddenSectionVisible", l);
  }), n === "window" ? [] : [n]);
  const s = () => {
    if (n)
      return n === "window" ? window.innerWidth : n.offsetWidth;
  }, o = () => {
    i(s());
  }, l = ({ detail: c }) => {
    const { id: d } = c;
    n === "window" || !n.closest(`#${d}`) || s() === r || o();
  }, u = WE(
    () => {
      s() !== r && (t && (clearTimeout(q1), document.body.classList.add("is-resizing"), q1 = setTimeout(() => {
        document.body.classList.remove("is-resizing");
      }, 550)), o());
    },
    500,
    { leading: !0 }
  );
  return r;
}, fp = () => {
  const { id: e } = We(zt), [t, n] = de(void 0);
  return pe(() => {
    if (!e) {
      n("/home/");
      return;
    }
    const r = O3("apolitical_locale");
    if (r) {
      n(`/${r}`);
      return;
    }
    n(`/${HE}`);
  }, [e]), t;
};
function O3(e) {
  const t = document.cookie.match(new RegExp("(^|;\\s*)" + e + "=([^;]*)"));
  return t ? decodeURIComponent(t[2]) : null;
}
const N3 = ({
  scrollPosition: e = 0,
  // The position on the page to scroll past
  offset: t = { down: 0, up: 10 },
  // An optional buffer
  callbacks: { scrollDown: n = () => {
  }, scrollUp: r = () => {
  } }
}) => {
  if (!window)
    return;
  const [i, a] = M.useState({
    current: 0,
    past: 0
  }) || [!1, () => {
  }], [s, o] = M.useState({
    scrollDown: !1,
    scrollUp: !1
  }) || [!1, () => {
  }];
  pe(() => (l(), window.addEventListener("scroll", u), () => {
    u.flush(), window.removeEventListener("scroll", u);
  }), []);
  const l = () => {
    const c = window.scrollY, d = i.current, f = c - d, p = f > 0 ? "down" : "up";
    if (a({ current: c, past: d }), p === "down") {
      c >= e + t.down && !s.scrollDown && (!s.scrollUp || f > t.up) && (n(), o({ scrollUp: !1, scrollDown: !0 }));
      return;
    }
    Math.abs(f) >= t.up && !s.scrollUp && (r(), o({ scrollUp: !0, scrollDown: !1 }));
  }, u = WE(() => {
    l();
  }, 250);
  return i;
}, VE = (e = [], t = !0) => {
  e = Array.isArray(e) ? e : [e];
  const n = Ue(!1);
  dl(() => {
    if (window && window.location && window.location.hash) {
      if (n.current)
        return;
      const r = document.getElementById(window.location.hash.replace("#", ""));
      r && (r.scrollIntoView(t ? { behavior: "smooth" } : null), n.current = !0);
    }
  }, e);
}, KE = (e = !1) => {
  if (!e)
    return { showTooltip: !1, tooltipProps: {} };
  const [t, n] = de(!1);
  return {
    showTooltip: t,
    tooltipProps: {
      onClick: () => n(!0),
      onKeyDown: (r) => {
        (r.key === "Enter" || r.key === " ") && (r.preventDefault(), r.stopPropagation(), n(!t));
      },
      onMouseOver: () => n(!0),
      onMouseOut: () => n(!1),
      onFocus: () => n(!0),
      onBlur: () => n(!1)
    }
  };
};
const T0 = {}, I3 = Ol(
  ({
    id: e,
    styling: t = {},
    isOpen: n = !1,
    isLoading: r = !1,
    children: i,
    className: a = "",
    functions: s = {},
    callbacks: o = {},
    accessibility: l = {},
    ...u
  }, c) => {
    const d = ye(), [f] = de(e || Date.now().toString()), p = Ue(null), g = c || p, [m, y] = de(n ? "open" : "hidden"), { extraPadding: v = !0, hasPointer: E = !1, hasForm: b = !1 } = t, { onOpen: _ = () => {
    }, onClose: T = () => {
    } } = o, { readToScreenreadersWhenClosed: x = !1, ...A } = l, R = T0[f];
    pe(() => {
      const O = g == null ? void 0 : g.current;
      if (O)
        return O.addEventListener("transitionend", P), () => {
          O.removeEventListener("transitionend", P);
        };
    }, []), pe(() => {
      if (m !== "open")
        return;
      const O = (S) => {
        S.key === "Escape" && (S.stopPropagation(), S.preventDefault(), y("closed"));
      };
      return document.addEventListener("keyup", O), () => {
        document.removeEventListener("keyup", O);
      };
    }, [m]);
    const P = ({ propertyName: O }) => {
      O === "opacity" && (R !== !1 && clearTimeout(R), y((S) => (S === "open" ? _() : S === "closed" && T(), S === "opening" ? "open" : S === "closing" ? "closed" : S === "closed" ? "hidden" : S)));
    };
    dl(() => {
      R !== !1 && clearTimeout(R);
      let O = "open";
      n ? y("opening") : (y("closing"), O = "hidden"), T0[f || ""] = setTimeout(() => {
        y(O);
      }, 300);
    }, [n]);
    const L = {
      "aria-live": "polite",
      ...u,
      ...A
    };
    s && s.onBlur && (L.onBlur = s.onBlur);
    const I = {
      className: "content"
    };
    return x ? I.className = te("content", { hidden: m === "hidden" }) : I.hidden = m === "hidden", /* @__PURE__ */ h.jsx(
      "aside",
      {
        ref: g,
        id: f,
        className: te("tooltip text-medium", m, a, {
          loading: r,
          "extra-padding": v,
          "has-pointer": E,
          bottom: E === "bottom",
          "has-form": b
        }),
        ...L,
        children: /* @__PURE__ */ h.jsx("div", { ...I, children: r ? /* @__PURE__ */ h.jsx("p", { children: d.formatMessage({ id: "tooltip_loading" }) }) : typeof i == "string" ? /* @__PURE__ */ h.jsx("p", { children: i }) : i })
      }
    );
  }
), Ys = mr(I3), Nl = (e, t) => {
  Array.isArray(t) || (t = [t]);
  const n = or(e);
  return t.forEach(({ type: r, value: i }) => {
    c3(n, r, i);
  }), n;
}, GE = (e) => {
  const t = [];
  return e.forEach((n) => {
    const r = parseInt(n);
    isNaN(r) || t.push(r);
  }), t.sort((n, r) => n - r);
}, YE = (e, t, n) => {
  let r = n.mobile;
  for (const i in t) {
    const a = parseInt(String(t[i]));
    if (e >= a)
      r = n[a];
    else if (e < a)
      break;
  }
  return r;
}, P3 = (e) => e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`), R3 = (e = "") => e.replace(/(?:^\w|[A-Z]|\b\w)/g, (t) => t.toUpperCase()).replace(/[&\s]+/g, ""), F3 = (e = "") => e.charAt(0).toUpperCase() + e.slice(1), jie = (e = "") => e.replace(/(?:^\w|[A-Z]|\b\w)/g, (t) => t.toUpperCase()), _i = "https://assets.apolitical.co/", Io = {
  general: "hello@apolitical.co",
  support: "concierge@apolitical.co",
  "data-protection": {
    default: "dpo@apolitical.co",
    eu: "dpo.agl@apolitical.foundation"
  }
}, Ql = {
  ARTICLE: "microcourseArticle",
  DISCUSSION: "microcourseDiscussion",
  QUIZ: "assessmentQuiz"
}, _0 = "SU:", kc = "DELETED", B3 = "Invalid token error: Logging user out...", Hie = "250,000+", Uie = "160+", Rs = /@{{([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})}}/g, M3 = new RegExp("(?<=^|\\s)@([A-Za-z]+(?:[- ]?[A-Za-z]*)*)$"), ZE = {
  LOCAL_STORAGE: {},
  SESSION_STORAGE: {
    EMAIL: "email"
  }
};
function zie(e) {
  return e ? {
    "--icon": `url(${_i}icons/${e}.svg)`
  } : {};
}
const ka = {
  milliseconds: {
    inSecond: 1e3,
    inMinute: 6e4,
    inHour: 36e5,
    inDay: 864e5
  },
  year: {
    weeks: 52,
    days: 365
  }
}, L3 = (e, t = "en") => new Date(e).toLocaleString(t, { day: "numeric", month: "short" }), QE = (e, t = "en") => new Date(e).toLocaleString(t, {
  weekday: "long",
  day: "numeric",
  month: "short",
  year: "numeric"
}), ih = (e) => {
  let t;
  const n = Dc(), r = Dc(new Date(e));
  try {
    t = n.getTime() - r.getTime();
  } catch {
    return "";
  }
  const i = t / ka.milliseconds.inHour, a = Math.floor(t / ka.milliseconds.inDay);
  if (a < 1)
    return i < 1 ? { path: "now" } : { path: "hours", number: Math.floor(i) };
  if (a < 7)
    return { path: "days", number: a };
  const s = Math.floor(a / 7);
  return s <= ka.year.weeks ? { path: "weeks", number: s } : { path: "years", number: Math.floor(a / ka.year.days) };
}, Dc = (e) => {
  const n = (e || /* @__PURE__ */ new Date()).toUTCString();
  return new Date(n);
}, $3 = (e, t, n) => {
  let r;
  const i = Dc(), a = Dc(new Date(e));
  try {
    r = i.getTime() - a.getTime();
  } catch {
    return !1;
  }
  switch (n) {
    case "seconds":
      return r / ka.milliseconds.inSecond <= t;
    case "minutes":
      return r / ka.milliseconds.inMinute <= t;
    case "hours":
      return r / ka.milliseconds.inHour <= t;
  }
  return !1;
}, j3 = (e, t) => {
  const n = new Date(e);
  return Math.abs((/* @__PURE__ */ new Date()).getTime() - n.getTime()) / (1e3 * 60 * 60 * 24) < t;
}, C0 = (e) => new Promise((t) => setTimeout(t, e)), H3 = () => {
  let e = !1;
  return typeof window < "u" && (e = !!(window && window.location && window.location.href && window.location.href.includes("localhost"))), e;
}, hn = {
  /* Common  */
  apolitical: "Apolitical",
  dates_now: "now",
  dates_hours: "{number}h",
  dates_days: "{number}d",
  dates_weeks: "{number}w",
  dates_years: "{number}y",
  /* Cards */
  card_carousel_viewAll: "View all",
  card_label_communityPage: "Community",
  card_label_event: "Event",
  card_label_learningHub: "Programme",
  card_label_listPage: "List",
  card_label_microcourse: "Course",
  card_label_qaQuestion: "Q&A",
  card_label_solutionArticle: "Article",
  card_bootcamp: "Email boot camp",
  card_ended: "Ended",
  card_new: "New",
  card_registered: "Registered",
  card_partner: "{partner} and {number} more",
  card_contributors_event: "Multiple speakers",
  card_contributors_solutionArticle: "Multiple authors",
  card_answers: "{number, plural, =0 {0 answers} one {# answer} other {# answers}}",
  card_time_ago: "{time} ago",
  card_time_read: "{time} min read",
  card_watch: "Watch recording",
  card_member_type_owner: "Admin",
  card_member_type_member: "Member",
  card_member_count: "{count} members",
  card_cta_people: "View profile",
  card_cta_communityPage: "Join now",
  card_cta_event: "Register now",
  card_cta_microcourse: "Enrol now",
  card_cta_communityPage_loading: "Joining...",
  card_cta_event_loading: "Registering...",
  card_cta_microcourse_loading: "Enrolling...",
  card_cta_communityPage_done: "Joined",
  card_cta_event_done: "Registered",
  card_cta_microcourse_done: "Enrolled",
  carousel_pagination_previous: "previous",
  carousel_pagination_previousSlide: "Previous slide",
  carousel_pagination_next: "next",
  carousel_pagination_nextSlide: "Next slide",
  carousel_pagination_slide: "Slide {number} of {total}",
  carousel_pagination_ariaLive: "On {direction} slide: {count, plural, one {1 card} other {# cards}} available",
  carousel_pagination_ariaLive_slide: "On slide {slide}: {count, plural, one {1 card} other {# cards}} available",
  /* Communities */
  activitySection_notFoundError: "Post not found",
  activitySection_language_switcher_info: "Our global community means you might see replies in other languages, even with a filter.",
  activitySection_language_switcher_all_languages_option: "Languages: All",
  activitiesFeed_sorting_label: "Choose feed sorting method",
  activitiesFeed_rankingMethod_recent: "Recent",
  activitiesFeed_rankingMethod_popular: "Popular",
  activitiesFeed_rankingMethod_internalTesting: "Testing",
  activitiesFeed_noActivities_inCategories: "There are no posts of this type yet.",
  activitiesFeed_noActivities: "Activities will appear here.",
  activitiesFeed_noActivities_button: "Explore Communities",
  communityDetails_members: "Members",
  communityDetails_viewAll: "View all",
  communityDetails_invite: "Invite colleagues",
  community_joinToPost: "Join community to create a post.",
  community_sortSuccess: "Feed ordered by {order}",
  joinCommunityButton: "Join community",
  joinCommunityButton_short: "Join",
  joinCommunityButton_joining: "Joining...",
  joinCommunityButton_member: "Member",
  joinCommunityButton_member_aria: "Leave community",
  joinCommunityButton_options_menu: "Options menu",
  joinCommunityButton_leaving: "Leaving...",
  joinCommunityButton_closed_tooltip: "Please contact the admin of this closed community if you would like to join it.",
  joinCommunityButton_aria_live: "You are {action} this community",
  member_apolitical: "Apolitical",
  member_community: "Community post",
  member_deleted: "Deleted user",
  member_profile: "Update profile",
  member_createdAt_community: "{time} ago in <link>{community}</link>",
  member_createdNow_community: "now in <link>{community}</link>",
  membersList: "Members",
  membersList_admin: "Admin",
  membersList_profile: "Update profile",
  membersList_modal_title: "Update profile",
  /* Courses */
  courseStructure_section: "{number, plural, =0 {Start here} other {Section #}}",
  courseStructure_section_end: "End here",
  courseStructure_time_left: "left",
  courseStructure_time_completed: "Completed",
  courseProgression_done: "<percent>{number}%</percent> done",
  courseProgression_timeLeft: "left",
  "lessonType_analyse-data": "Analyse data",
  "lessonType_analyse-scenarios": "Analyse scenarios",
  "lessonType_attend-webinar": "Attend webinar",
  "lessonType_brainstorm-ideas": "Brainstorm ideas",
  "lessonType_discuss-with-peers": "Discuss with peers",
  "lessonType_discuss-with-team": "Discuss with team",
  "lessonType_do-activity": "Do activity",
  "lessonType_do-assessment": "Do assessment",
  "lessonType_explore-casebook": "Explore casebook",
  "lessonType_fill-out-workbook": "Fill out workbook",
  "lessonType_fill-out-worksheet": "Fill out worksheet",
  "lessonType_investigate-interview": "Investigate interview",
  "lessonType_listen-to-audio": "Listen to audio",
  "lessonType_listen-to-audiocast": "Listen to audiocast",
  "lessonType_listen-to-podcast": "Listen to podcast",
  "lessonType_read-article": "Read article",
  "lessonType_read-article-by-expert": "Read article by expert",
  "lessonType_read-article-by-public-servant": "Read article by public servant",
  "lessonType_read-conclusion": "Read conclusion",
  "lessonType_read-infographic": "Read infographic",
  "lessonType_read-introduction": "Read introduction",
  "lessonType_read-resource": "Read resource",
  "lessonType_reflect-on-content": "Reflect on content",
  "lessonType_share-experiences": "Share experiences",
  "lessonType_take-quiz": "Take quiz",
  "lessonType_use-toolkit": "Use toolkit",
  "lessonType_watch-video": "Watch video",
  "lessonType_watch-webinar": "Watch webinar",
  markCompleteButton: "Mark as complete",
  markCompleteButton_completed: "Lesson complete",
  /* Discussion */
  discussion_action_answer: "answer",
  discussion_action_comment: "comment",
  discussion_action_edit: "Edit",
  discussion_action_poll: "poll",
  discussion_action_post: "post",
  discussion_action_response: "response",
  discussion_action_reply: "reply",
  discussion_action_question: "question",
  discussion_edited: "Edited",
  discussion_delete_title: "Delete {action}",
  discussion_delete_text: "<p>Are you sure you want to delete your {action}?</p><p>This can't be undone.</p>",
  discussion_delete_cancel: "Cancel",
  discussion_delete_delete: "Delete",
  discussion_delete_error: "We are unable to delete your {action} at the moment. Please try again later or contact us if problem persists.",
  discussion_pinned_post: "Pinned Post",
  discussion_reply: "Reply",
  discussion_report_subject: "Report a post on Apolitical",
  discussion_report_body: `I'd like to report the {contentType} <{contentSlug}> at {contentUrl}.


Please explain why you're reporting this post. Reasons could include: inappropriate language, harassment, spam, hate speech, false information, among others. Include as much detail as you feel comfortable.

Thank you for helping to protect the Apolitical community from abusive content.`,
  discussionFormCard_placeholder: "Create post",
  discussionFormCard_placeholder_long: "Write a post or ask a question...",
  discussionFormCard_overlay_title: "Discard post",
  discussionFormCard_overlay_text: "Are you sure you want to leave without posting? Changes you have made will not be saved.",
  discussionFormCard_overlay_cta_discard: "Discard",
  discussionFormCard_overlay_cta_continue: "Continue editing",
  discussion_form_postType_label: "Post type",
  "discussion_form__postType_no-category": "Post",
  discussion_form_title: "Write your {action}",
  discussion_form_titleField_label: "Title",
  discussion_form_titleField_placeholder: "Write something...",
  discussion_form_titleField_error: "Please enter a title or a body for your post.",
  discussion_form_question_label: "Question",
  discussion_form_question_placeholder: "Question",
  discussion_form_option_label: "Options",
  discussion_form_option_placeholder: "Option {number}",
  discussion_form_option_cta: "Add option",
  discussion_form_multiplePollAnswers: "Allow multiple answers",
  discussion_form_placeholder: "Write a {action}...",
  discussion_form_label: "Body",
  discussion_form_label_action: "Your {action}",
  discussion_form_explainer: "Try to make your {action} specific and practical. Be respectful and kind. See our <a>community guidelines</a>",
  discussion_form_success: "Your {action} has been submitted.",
  discussion_form_post: "Create post",
  discussion_form_posting: "Posting...",
  discussion_form_save: "Save",
  discussion_form_saving: "Saving...",
  discussion_form_cancel: "Cancel",
  discussion_form_submitting: "Submitting...",
  discussion_form_placeholder_post: "Share a question, insight, or announcement with the community",
  discussion_form_error: "We are unable to process your {action} right now. Please try again later or contact us if the problem persists",
  discussion_form_error_tooLong: "Please keep your content to {maxLength, plural, one {1 character} other {# characters}}.",
  discussion_form_error_tooMany: "You have posted too many times in a row. Please wait and try again.",
  discussion_form_error_loggedOut: "Please log in to submit your {action}.",
  discussion_form_error_noPermission: "You do not have permission to {action}.",
  discussion_form_error_alreadyExists: "This {action} already exists.",
  discussion_form_title_question: "Start a conversation",
  discussion_form_placeholder_question: "Ask your question here",
  discussion_form_explainer_question: "Unsure what you can post? See our <a>community guidelines</a>.",
  discussion_likes: "{number, plural, =0 {0 likes} one {# like} other {# likes}}",
  discussion_likes_short: "{number}",
  discussion_likes_showAll: "Show all...",
  discussion_likes_like: "Like this {action}",
  discussion_likes_unlike: "Unlike {action}",
  discussion_likes_show: "Show who liked this {action}",
  discussion_moreMenu_edit: "Edit",
  discussion_moreMenu_delete: "Delete",
  discussion_moreMenu_pin: "Pin post",
  discussion_moreMenu_unpin: "Unpin post",
  discussion_moreMenu_report: "Report",
  discussion_comments_screenReader: "See {count, plural, =0 {0 comments} one {# comment} other {# comments}}",
  discussion_comments: "{count, plural, =0 {0 comments} one {# comment} other {# comments}}",
  discussion_comments_loading: "... comments",
  discussion_responses_answer: "Answers",
  discussion_responses_comment: "Comments",
  discussion_responses_title: "{action} ({count})",
  discussion_responses_empty: "Be the first to respond",
  discussion_responses_empty_answer: "Be the first to answer this question",
  discussion_responses_placeholder: "Write a comment...",
  discussion_share_copy_link: "Copy link",
  discussion_share_copy_link_success: "Link copied to clipboard",
  discussion_thread_show: "Show {count} {count, select, 1 {reply} other {replies}}",
  discussion_thread_hide: "Hide replies",
  discussion_thread_loadMore: "Load more replies",
  profileModalLauncher_successMessage: "Your post has been created",
  profileModalLauncher_title: "Your profile is incomplete",
  profileModalLauncher_text: "A complete profile builds trust and amplifies your voice across the community. Ensure all your details are up to date including a photo and a bio.",
  /* Form */
  contactFooter_title: "Contact us",
  contactFooter_text: "We're always open to new ideas, so please reach out to see how we can collaborate.",
  contactFooter_phone: "+44 203 608 2241",
  contactFooter_email: "hello@apolitical.co",
  contactForm_name: "Name",
  contactForm_email: "Email address",
  contactForm_organisation: "Government department or organisation",
  contactForm_interests: "I'm interested in",
  contactForm_interests_publishingCourse: "Publishing or creating a course",
  contactForm_interests_buyingCourse: "Buying courses for my team",
  contactForm_interests_learningExperience: "Customised learning experiences",
  contactForm_interests_somethingElse: "Something else",
  contactForm_message: "Message",
  dropdown_menu_multiselect_all: "All",
  dropdown_menu_multiselect_none: "None",
  emailHelperTextBox_fallback_title: "Who can join",
  emailHelperTextBox_fallback_text: "Apolitical is a private community for public servants and policymakers.",
  emailHelperTextBox_default_title: "Who can join",
  emailHelperTextBox_default_text: "Apolitical is a private community for public servants and policymakers. <link>Learn more</link>.",
  emailHelperTextBox_autoApproved_title: "Email check",
  emailHelperTextBox_autoApproved_text: "Great! Looks like you are using a **government email domain we recognise.** You will be **auto-approved** once you sign up.",
  emailHelperTextBox_unrecognisedEmail_title: "Not a recognised government email",
  emailHelperTextBox_unrecognisedEmail_text: "To confirm you work in government or policy, please add more details below. <link>Learn more</link>.",
  emailHelperTextBox_pendingApproval_title: "Email is pending approval",
  emailHelperTextBox_pendingApproval_text: "Looks like this email has been used to sign up to Apolitical before, but <strong>we have not yet approved it.</strong> If you cannot wait to join, contact <mail>concierge@apolitical.co</mail>.",
  emailHelperTextBox_emailUnverified_title: "Hello again!",
  emailHelperTextBox_emailUnverified_text: "It looks like you're already an Apolitical member. To access your account, please verify your email address. <link>Click here to get a verification code sent to your email</link>.",
  emailHelperTextBox_emailAlreadyExists_title: "Email is already registered",
  emailHelperTextBox_emailAlreadyExists_text: "Looks like this email has been used to sign up to Apolitical before, try <link>logging in</link> instead. If you're still having issues, contact <mail>concierge@apolitical.co</mail>.",
  emailHelperTextBox_error_verificationFailedToSend_title: "Verification code failed to send",
  emailHelperTextBox_error_verificationFailedToSend_text: "Error details: <em>{error}</em>{br}<link>Click here to try again</link>.{br}If you continue to have problems, contact us at <mail>concierge@apolitical.co</mail>",
  emailHelperTextBox_error_noFunction: "Cannot resend verification code.",
  form_fieldWrapper_required: "required",
  form_fieldWrapper_characterLimit: "Character limit:",
  form_fieldWrapper_characterLimit_aria_default: "You have {remaining, plural, =0 {no characters} one {1 character} other {# characters}} remaining.",
  form_fieldWrapper_characterLimit_aria_over: "You are {over, plural, one {1 character} other {# characters}} over the limit. Please shorten your text to {limit} characters.",
  form_fieldWrapper_characterLimit_info: "You can enter up to {limit} characters",
  form_error_generalError: "Sorry, something has gone. Please refresh the page and try again.",
  form_error_required: "Please fill in this required field",
  form_error_numbers: "Numbers are not allowed in this text field",
  form_error_email: "Please enter a valid email address",
  form_error_url: "Please enter a valid URL",
  form_error_multipleInputs_same: "Please enter a unique value into each field",
  form_cancel: "Cancel",
  form_submit: "Submit",
  form_submitting: "Submitting form...",
  form_submitted: "Submitted",
  form_success: "Thank you for submitting the form!",
  form_multipleInputs_label: "Input {number}",
  form_multipleInputs_filledInCount: "{number}/{total}",
  form_multipleInputs_filledInCount_aria: "{number} out of {total} available inputs have been filled in",
  form_multipleInputs_remove: "Remove this input",
  inviteForm_email_placeholder: "Add email addresses...",
  inviteForm_title: "Know someone who might like to join this workshop?",
  inviteForm_label: "Invite your colleagues by typing or pasting their email addresses below",
  inviteForm_message_label: "Add an invitation note",
  inviteForm_message_placeholder: "Add a personal note to your invitation...",
  inviteForm_ctaMessage: "Send",
  inviteForm_success: "Invitation Sent!",
  inviteForm_error: "Something went wrong!",
  inviteForm_ctaTryAgain: "Try again!",
  inviteForm_ctaSendMoreInvites: "Send more invites",
  inviteForm_ctaDone: "Done",
  inputAutocomplete_placeholder: "Start typing...",
  passwordRules_unmatched_text: "Passwords do not match",
  passwordRules_intro: "We advise you not to use your name or email in your password.",
  passwordRules_rule_label: "Password",
  passwordRules_rule_8Characters: "must be longer than 8 characters",
  passwordRules_rule_numberSymbol: "must include a number and a symbol",
  passwordRules_rule_lowercaseUppercase: "must include both lower and upper case characters",
  passwordRules_notMet: "Your password does not meet this requirement",
  passwordRules_currentPassword_label: "Current password",
  passwordRules_newPassword_label: "New password",
  passwordRules_confirmPassword_label: "Confirm new password",
  profileForm_image: "Upload photo",
  profileForm_name: "Full name",
  profileForm_name_placeholder: "What's your name, so people can recognise you?",
  profileForm_jobTitle: "Job title",
  profileForm_jobTitle_placeholder: "What's your current job title?",
  profileForm_organization: "Organisation",
  profileForm_organization_placeholder: "Where do you work?",
  profileForm_location: "Location",
  profileForm_location_placeholder: "Add your city",
  profileForm_location_error: "Please choose a location from the list.",
  profileForm_bio: "Bio",
  profileForm_bio_placeholder: "Tell us more about yourself...",
  profileForm_cta: "Save",
  profileForm_cta_submitting: "Saving...",
  profileForm_cta_submitted: "Saved",
  profileImageChange_cta_uploading: "Uploading image...",
  profileImageChange_cta_change: "Change photo",
  profileImageChange_cta_upload: "+ Add profile photo",
  profileImageChange_error: "There was an error uploading the image. Please try a different file format or reduce the file size to less than 5MB. Contact us if problem persists.",
  publishArticleForm_title_label: "Title",
  publishArticleForm_title_placeholder: "Write a snappy title",
  publishArticleForm_subtitle_label: "Subtitle",
  publishArticleForm_subtitle_placeholder: "Your topic, in a nutshell",
  publishArticleForm_body_label: "Body",
  publishArticleForm_body_placeholder: "Type or paste your article here",
  publishArticleForm_tags_label: "Tags (select up to three)",
  publishArticleForm_cover_image_label: "Cover image",
  publishArticleForm__tags_topic_CitiesAndLocalGovernment: "Cities and local government",
  publishArticleForm__tags_topic_Climate: "Energy and climate",
  publishArticleForm__tags_topic_DigitalAndData: "Digital, data and AI",
  publishArticleForm__tags_topic_Education: "Education",
  publishArticleForm__tags_topic_EquityJusticeAndInclusion: "Inclusion",
  publishArticleForm__tags_topic_HealthAndSocialCare: "Health and social care",
  publishArticleForm__tags_topic_Innovation: "Innovation",
  publishArticleForm__tags_topic_LeadershipAndSkills: "Leadership and skills",
  publishArticleForm__tags_topic_LifeInGovernment: "Life in government",
  publishArticleForm__tags_topic_Policymaking: "Policymaking",
  publishArticleForm__tags_topic_TransportAndInfrastructure: "Transport and infrastructure",
  publishArticleForm__tags_topic_WorkAndTheEconomy: "Work and the economy",
  publishArticleForm_tags_error_over_three: "You must select no more than three options.",
  publishArticleForm_tags_error_required: "Please select at least one option.",
  publishArticleForm_disclaimer: "Ready to publish? Before you do, consider the following: Have you thoroughly proofread your writing? Are you confident in your arguments? Have you included hyperlinks to the necessary resources to support your article?",
  publishArticleForm_cta_submit: "Publish article",
  publishArticleForm_cta_submit_edit: "Save",
  publishArticleForm_cta_submitting: "Publishing...",
  publishArticleForm_cta_submitting_edit: "Saving...",
  publishArticleForm_cta_submitted: "Published!",
  publishArticleForm_cta_submitted_edit: "Saved!",
  publishArticleForm_aria_success: "Your article is being published. You will be redirected to your article in a moment.",
  publishArticleForm_aria_success_edit: "Your article is being saved. You will be redirected to your article in a moment.",
  publishArticleForm_error: "Sorry, something went wrong.",
  publishArticleForm_error_underMinLength: "Please add at least {length, plural, one {1 character} other {# characters}}.",
  publishArticleForm_error_loggedOut: "You need to be logged in to publish an article. Please log in and try again.",
  publishArticleForm_progressBar: "Your article is being published",
  publishArticleForm_selectImage_button: "Select a cover image",
  publishArticleForm_replaceImage_button: "Replace Image",
  ratings_text: "Rate answer",
  ratings_stars: "{number} out of {total}",
  ratings_low: "this is incorrect or confusing",
  ratings_high: "this is a fantastic answer",
  ratings_success: "Thank you!",
  richTextEditor_placeholder: "Write something...",
  richTextEditor_toolbar: "Formatting options",
  richTextEditor_bold: "Bold",
  richTextEditor_heading_three: "Heading",
  richTextEditor_italic: "Italic",
  richTextEditor_strikeThrough: "Strikethrough",
  richTextEditor_link: "Link",
  richTextEditor_link_text: "Text:",
  richTextEditor_link_text_aria: "Text to be linked:",
  richTextEditor_link_url: "Link:",
  richTextEditor_link_placeholder: "Type or paste URL",
  richTextEditor_link_error_required: "Please enter a URL to link to",
  richTextEditor_link_open: "Open: {link}",
  richTextEditor_link_open_text: "Opens in a new window",
  richTextEditor_link_edit: "Edit",
  richTextEditor_link_remove: "Remove",
  richTextEditor_link_button: "Add link",
  richTextEditor_link_enrichedUrl_aria: "Remove this preview for {title}",
  richTextEditor_link_enrichedUrl_aria_fallback: "the link",
  richTextEditor_link_enrichedUrl_aria_live: "The link preview has been removed from your post",
  richTextEditor_ol_list: "Numbered list",
  richTextEditor_ul_list: "Bullet-point list",
  richTextEditor_block_quote: "Quote",
  richTextEditor_mention_fallback: "Can't find who you're looking for? Invite them to the community",
  search_label: "Search for:",
  search_placeholder: "Ask Apolitical",
  search_clear: "Clear search",
  search_cta: "Search",
  showpassword_show: "Show",
  showpassword_hide: "Hide",
  showpassword_aria_show: "Your password is hidden. Click to show.",
  showpassword_aria_hide: "Your password is visible. Click to hide.",
  signup_title: "Sign up",
  signup_full_name: "Full name",
  signup_full_name_placeholder: "Lionel Messi",
  signup_email_address: "Work email",
  signup_email_address_placeholder: "lionel.messi@argentina.gov",
  signup_job_title: "Job title",
  signup_job_title_placeholder: "e.g. Senior Policy Advisor",
  signup_organization: "Organisation",
  signup_organization_placeholder: "e.g. Department of Justice",
  signup_url: "Link to official government bio / LinkedIn <small>(optional)</small>",
  signup_url_placeholder: "https://organisation.com/bio",
  signup_expectation: "What do you want to know<small>Optional, but we will use your response to build the session!</small>",
  signup_expectation_placeholder: "What do you want to know?",
  signup_terms: "I accept Apolitical's <terms>Terms of Service</terms>, <privacy>Privacy Policy</privacy> and that I'll get essential emails for my use of Apolitical",
  signup_error: "We're really sorry, but we've had a problem trying to sign you up. This could be an issue with our system, so we suggest you try again later.",
  signup_button_join: "Join for free",
  signup_button_login: "Log in",
  signup_submitting: "Submitting form...",
  signup_success_title: "Thank you for applying to join Apolitical!",
  signup_success_text: "<p>Once we've vetted your application, you'll get a secure login link to help you get started.</p><p>Please note that trust is everything to our community, so you can't login until your identity has been verified.</p>",
  /* Polls */
  poll_instructions: "Select one{allowMultipleVotes, select, true { or more} other {}}",
  poll_num_votes: "{number, plural, one {# vote} other {# votes}}",
  poll_remove_vote_button: "Remove vote{number, plural, =0 {} one {} other {s}}",
  poll_aria_votes: "You have {number, plural, =0 {not voted on this poll} other {voted for:}}",
  replies_feed_missing_polls_vote_message: "Please vote above to view all the comments",
  /* General */
  tableOfContents: "Table of contents",
  timeToComplete_hours: "{time, plural, =0 {} one {1 hour} other {# hours}}",
  timeToComplete_hours_short: "{time}h",
  timeToComplete_minutes: "{time, plural, =0 {} one {1 minute} other {# minutes}}",
  timeToComplete_minutes_short: "{time}m",
  timeToComplete_range: "{early} - {late}",
  timeToComplete_range_aria: "between {early} and {late}",
  tooltip_loading: "Loading...",
  return_to_nav_button: "Back to top",
  progressTracker: "Step {current} of {total}",
  /* Layout */
  cookieBanner_title: "Cookies and your privacy",
  cookieBanner_text: "We take your trust and privacy very seriously. Apolitical uses safe cookies (small files on your device) to run the site. You can reject non-essential cookies, but some site features may not work without them.",
  cookieBanner_buttons_settings: "Change my settings",
  cookieBanner_buttons_reject: "Reject all",
  cookieBanner_buttons_accept: "Accept all",
  footer_platform: "Platform",
  footer_platform_events: "Events",
  footer_platform_courses: "Courses",
  footer_platform_qanda: "Q&A",
  footer_platform_articles: "Articles",
  footer_platform_communities: "Communities",
  footer_community: "Community",
  footer_community_support: "Support FAQ",
  footer_community_post: "Post on Apolitical",
  footer_community_join: "Who can join",
  footer_community_guidelines: "Guidelines & values",
  footer_company: "Company",
  footer_company_news: "News",
  footer_company_insights: "Insights",
  footer_company_story: "Our story",
  footer_company_team: "Meet our team",
  footer_company_careers: "Careers",
  footer_company_partner: "Partner with us",
  footer_company_contact: "Get in touch",
  footer_legal: "Legal",
  footer_legal_privacy: "Privacy policy",
  footer_legal_terms: "Terms & conditions",
  footer_legal_cookie: "Cookie policy",
  footer_legal_accessibility: "Accessibility statement",
  footer_legal_ai: "AI principles",
  footer_legal_dataProtection: "Data protection officer",
  footer_legal_euDataProtection: "EU data protection officer",
  footer_contact: "Contact",
  footer_contact_london: "London address",
  footer_contact_london_address: "251 Southwark Bridge Road{br}London, SE1 6FL{br}United Kingdom",
  footer_contact_registered: "Registered address",
  footer_contact_registered_address: "20–22 Wenlock Road{br}London, N1 7GU{br}United Kingdom",
  footer_contact_berlin: "Berlin address",
  footer_contact_berlin_address: "Torstraße 220{br}10115 Berlin{br}Germany",
  footer_contact_washington: "Washington DC Address",
  footer_contact_washington_address: "1100 15th St NW{br}Washington, DC 20005{br}United States",
  footer_contact_support: "For platform support",
  footer_contact_business: "For business inquiries",
  footer_social_linkedin: "LinkedIn",
  footer_social_twitter: "Twitter",
  footer_social_facebook: "Facebook",
  footer_copyright: "Copyright © {currentYear} Apolitical Group Limited",
  header_skip: "Skip to main content",
  header_language_switcher: "Change language",
  header_search_show: "Show search bar",
  header_search_hide: "Close search bar",
  header_menu_show: "Show navigation",
  header_menu_hide: "Close navigation",
  header_home_loggedOut: "Home",
  header_home_loggedIn: "My Home",
  header_communities: "Communities",
  header_topics: "Topics",
  header_topics_explore: "Explore",
  header_topics_explore_events: "Events",
  header_topics_explore_courses: "Courses",
  "header_topics_explore_q-and-a": "Q&A",
  header_topics_explore_articles: "Articles",
  header_topics_explore_communities: "Communities",
  header_topics_topics: "Topics",
  header_topics_topics_climate: "Energy and climate",
  "header_topics_topics_cities-and-local-government": "Cities and local government",
  "header_topics_topics_digital-and-data": "Digital, data and AI",
  header_topics_topics_education: "Education",
  "header_topics_topics_equity-justice-and-inclusion": "Inclusion",
  "header_topics_topics_health-and-social-care": "Health and social care",
  header_topics_topics_innovation: "Innovation",
  "header_topics_topics_leadership-and-skills": "Leadership and skills",
  "header_topics_topics_life-in-government": "Life in government",
  header_topics_topics_policymaking: "Policymaking",
  "header_topics_topics_transport-and-infrastructure": "Transport and infrastructure",
  "header_topics_topics_work-and-the-economy": "Work and the economy",
  header_partners: "For partners",
  header_account: "My account",
  header_account_show: "Show account menu",
  header_account_hide: "Close account menu",
  header_account_profile: "My profile",
  header_account_settings: "Settings & privacy",
  "header_account_log-out": "Log out",
  header_buttons_login: "Log in",
  header_buttons_signup: "Sign up",
  header_language_unavailable_en: "This page is only available in English. <link>Learn more →</link>",
  "header_language_unavailable_sr-Cyrl": "Ова страница је доступна само на енглеском. <link>Сазнајте више →</link>",
  header_language_unavailable_de: "Diese Seite ist nur auf Englisch verfügbar. <link>Mehr erfahren →</link>",
  "header_language_unavailable_fr-CA": "Cette page est uniquement disponible en anglais. <link>En savoir plus →</link>",
  header_language_unavailable_ko: "이 페이지는 영어로만 제공됩니다. <link>자세히 알아보기 →</link>",
  header_language_unavailable_it: "Questa pagina è disponibile solo in inglese. <link>Scopri di più →</link>",
  header_language_unavailable_pl: "Ta strona jest dostępna tylko w języku angielskim. <link>Dowiedz się więcej →</link>",
  header_language_unavailable_ja: "このページは英語でのみ利用可能です。<link>詳細はこちら →</link>",
  header_language_unavailable_ar: "هذه الصفحة متوفرة باللغة الإنجليزية فقط. <link>اعرف المزيد →</link>",
  header_language_unavailable_es: "Esta página sólo está disponible en inglés. <link>Más información →</link>",
  header_language_unavailable_fr: "Cette page est uniquement disponible en anglais. <link>En savoir plus →</link>",
  header_language_unavailable_pt: "Esta página está disponível apenas em inglês. <link>Saiba mais →</link>",
  header_language_unavailable_id: "Halaman ini tidak tersedia dalam bahasa yang dipilih. <link>Pelajari lebih lanjut →</link>",
  "header_language_unavailable_pt-BR": "Esta página não está disponível no idioma selecionado. <link>Saiba mais →</link>",
  "header_language_unavailable_es-419": "Esta página sólo está disponible en inglés. <link>Más información →</link>",
  pageLayout_browserTooSmall: "Sorry, your device is too small to view this content properly. Please change to a different orientation or another device.",
  pageLayout_error: "An error occurred while rendering this page. Please refresh the page or try again later.",
  /* Loaders */
  loadingBlock_loading: "Loading...",
  loadingBlock_almostDone: "Almost done...",
  loadingBlock_complete: "Complete!",
  progressBar: "{number}% loaded",
  /* Modals */
  discussionFormModal_title: "Create a post",
  discussionFormModal_cta: "Create post",
  inviteModal_title: "You’re registered",
  inviteModal_formTitle: "Know someone who might like to join this workshop?",
  inviteModal_formLabel: "Invite your colleagues by typing or pasting their email addresses below.",
  inviteModal_cta: "Send",
  overlay_close: "Close",
  profileModal_title: "Update your profile",
  /* Navigation */
  breadcrumbs_label: "Go back to:",
  breadcrumbs_currentPage: "Current page:",
  filters_all: "Show all",
  filters_disabled: "{name} - no results",
  languageSwitcher_label: "I would like to read this article in...",
  languageSwitcher_translation_original: "original language",
  languageSwitcher_translation_human: "translated by person",
  languageSwitcher_translation_machine: "translated by machine",
  languageSwitcher_selected: "{language} - currently selected",
  languageSwitcher_disclaimer: "This content is machine translated and will occasionally get gendered language or other direct translations wrong. We’re trying to resolve this but in the meantime, if you notice something very wrong, let us know at <link>{email}</link>",
  loadMore_button: "Load more",
  loadMore_endOfFeed: "You're all caught up",
  loadMore_error: "We're having trouble loading more content. Please refresh the page or try again later.",
  moreMenu: "See more options",
  navigationMenu_links_homepage: "Home",
  navigationMenu_links_events: "Events",
  navigationMenu_links_microcourses: "Courses",
  "navigationMenu_links_q-and-a": "Q&A",
  navigationMenu_links_articles: "Articles",
  navigationMenu_links_communities: "Communities",
  shareLinks_label: "Share",
  shareLinks_link_linkedin: "Share on LinkedIn",
  shareLinks_link_twitter: "Share on Twitter",
  shareLinks_link_facebook: "Share on Facebook",
  shareLinks_link_email: "Share by email",
  "shareLinks_link_clipboard-copy": "Copy the link",
  tags_community: "From the community",
  /** Sections */
  editSection_placeholder_description: "Add some details",
  editSection_placeholder_cta: "add",
  editSection_edit: "Edit",
  /* Pages */
  notFoundError_title: "We can't find that page",
  notFoundError_text: "Sorry about that. We all mess up sometimes - read some ‘fail’ stories below.",
  notFoundError_post_1: "Why public servants must learn to fail — and 3 tips for how to do it",
  notFoundError_post_2: "What failure has taught me",
  notFoundError_post_3: "How to learn from failure without causing a scandal",
  notFoundError_cta: "View more articles",
  /* Text */
  collapsibleSection_summary: "Find out more",
  contentTypeLabel_event: "Event",
  contentTypeLabel_learningHub: "Programme",
  contentTypeLabel_listPage: "List",
  contentTypeLabel_microcourse: "Course",
  contentTypeLabel_qaQuestion: "Q&A",
  contentTypeLabel_solutionArticle: "Article",
  contentTypeLabel_communityPage: "Community",
  hideShowTextBox_hide: "View less",
  hideShowTextBox_show: "View more",
  markdown_collapsibleSection_summary: "Resources",
  markdown_skip_video: "Skip past video",
  markdown_skip_padlet: "Skip past interactive board",
  markdown_skip_poll: "Skip past poll",
  markdown_skip_survey: "Skip past survey",
  markdown_skip: "Skip to next section",
  markdown_iframe_title: "Course information",
  markdown_iframe_video: "Video",
  markdown_iframe_padlet: "Interactive board",
  markdown_iframe_poll: "Poll",
  markdown_iframe_survey: "Survey",
  /* User */
  member_connection_accept: "Accept",
  member_connection_cancel: "Cancel Request",
  member_connection_connect: "Connect",
  member_connection_connected: "Connected",
  member_connection_pending: "Pending",
  member_connection_remove: "Remove Connection",
  member_connection_requested: "Requested",
  member_show_email_hide: "Email visible only to connections",
  member_show_email_private: "Private profile email hidden",
  member_show_email_show: "Show contact info",
  member_show_email_tooltip: "Copy email address",
  member_show_email_tooltip_copied: "Email copied to clipboard",
  member_show_email_tooltip_mine: "Visible only to your connections",
  member_show_email_tooltip_private: "The privacy setting for this profile is private"
}, U3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Me gustaría leer este artículo en...",
  languageSwitcher_translation_original: "idioma original",
  languageSwitcher_translation_human: "traducido por un humano",
  languageSwitcher_translation_machine: "traducido por máquina",
  languageSwitcher_disclaimer: "Este contenido fue traducido automáticamente y ocasionalmente tendrá errores de género u otras traducciones directas. Estamos intentando resolver este problema, pero mientras tanto, si notas algún error grave, escríbenos a <link>{email}</link>"
}, z3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Je voudrais lire cet article dans...",
  languageSwitcher_translation_original: "langue originale",
  languageSwitcher_translation_human: "traduit par un humain",
  languageSwitcher_translation_machine: "traduit par machine",
  languageSwitcher_disclaimer: "Ce contenu est traduit automatiquement et contiendra d’évantuelles erreurs de genre ou d’autres traductions directes. Nous essayons de résoudre ce problème, mais en attendant, si vous remarquez une erreur importante, faites-le nous savoir à <link>{email}</link>",
  /* Text */
  collapsibleSection_summary: "En savoir plus"
}, q3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Eu gostaria de ler este artigo em...",
  languageSwitcher_translation_original: "linguagem original",
  languageSwitcher_translation_human: "traduzido por um humano",
  languageSwitcher_translation_machine: "traduzido por máquina",
  languageSwitcher_disclaimer: "Este conteúdo foi traduzido automaticamente e, ocasionalmente, poderão ocorrer erros de linguagem de gênero ou outras traduções diretas. Estamos tentando resolver isso, porém se perceber algo errado por favor nos avise em <link>{email}</link>"
}, W3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Saya ingin membaca artikel ini dalam...",
  languageSwitcher_translation_original: "bahasa asli",
  languageSwitcher_translation_human: "diterjemahkan oleh manusia",
  languageSwitcher_translation_machine: "diterjemahkan oleh mesin",
  languageSwitcher_disclaimer: "Konten ini telah diterjemahkan secara otomatis dan terkadang mungkin terdapat kesalahan dalam penerjemahan gender atau terjemahan langsung lainnya. Kami sedang berusaha memperbaiki hal ini, tetapi jika Anda menemukan kesalahan, mohon beri tahu kami di <link>{email}</link>"
}, V3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Eu gostaria de ler este artigo em...",
  languageSwitcher_translation_original: "idioma original",
  languageSwitcher_translation_human: "traduzido por humano",
  languageSwitcher_translation_machine: "traduzido por máquina",
  languageSwitcher_disclaimer: "Este conteúdo foi traduzido automaticamente e, ocasionalmente, podem ocorrer erros de linguagem de gênero ou outras traduções diretas. Estamos trabalhando para resolver isso, mas se você perceber algo errado, por favor nos avise em <link>{email}</link>"
}, K3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Me gustaría leer este artículo en...",
  languageSwitcher_translation_original: "idioma original",
  languageSwitcher_translation_human: "traducido por un humano",
  languageSwitcher_translation_machine: "traducido por máquina",
  languageSwitcher_disclaimer: "Este contenido fue traducido automáticamente y ocasionalmente tendrá errores de género u otras traducciones directas. Estamos intentando resolver este problema, pero mientras tanto, si notas algún error grave, escríbenos a <link>{email}</link>"
}, G3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "أود قراءة هذه المقالة بـ...",
  languageSwitcher_translation_original: "اللغة الأصلية",
  languageSwitcher_translation_human: "مترجمة بواسطة إنسان",
  languageSwitcher_translation_machine: "مترجمة آلياً",
  languageSwitcher_disclaimer: "تمت ترجمة هذا المحتوى تلقائياً وقد يحتوي على أخطاء في النوع أو ترجمات حرفية أخرى. نحن نحاول معالجة هذه المشكلة، ولكن في الوقت الحالي، إذا لاحظت خطأً مهماً، يرجى إعلامنا على <link>{email}</link>",
  /* Text */
  collapsibleSection_summary: "اقرأ المزيد"
}, Y3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "この記事を以下の言語で読みたい...",
  languageSwitcher_translation_original: "原文",
  languageSwitcher_translation_human: "人による翻訳",
  languageSwitcher_translation_machine: "機械翻訳",
  languageSwitcher_disclaimer: "このコンテンツは自動的に翻訳されており、性別の誤りや直訳などが含まれている可能性があります。現在、これらの問題の解決に取り組んでいますが、重大な誤りにお気づきの場合は、<link>{email}</link> までご連絡ください。",
  /* Text */
  collapsibleSection_summary: "もっと読む"
}, Z3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Chciał(a)bym przeczytać ten artykuł w...",
  languageSwitcher_translation_original: "język oryginalny",
  languageSwitcher_translation_human: "przetłumaczone przez człowieka",
  languageSwitcher_translation_machine: "przetłumaczone maszynowo",
  languageSwitcher_disclaimer: "Treść została przetłumaczona automatycznie i może zawierać błędy związane z rodzajem gramatycznym lub inne dosłowne tłumaczenia. Pracujemy nad ich poprawą, ale jeśli zauważysz poważny błąd, daj nam znać na adres <link>{email}</link>",
  /* Text */
  collapsibleSection_summary: "Czytaj więcej"
}, Q3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Vorrei leggere questo articolo in...",
  languageSwitcher_translation_original: "lingua originale",
  languageSwitcher_translation_human: "tradotto da un essere umano",
  languageSwitcher_translation_machine: "tradotto automaticamente",
  languageSwitcher_disclaimer: "Questo contenuto è stato tradotto automaticamente e potrebbe contenere errori di genere o altre traduzioni letterali. Stiamo lavorando per risolvere questi problemi, ma se noti un errore importante, faccelo sapere a <link>{email}</link>",
  /* Text */
  collapsibleSection_summary: "Scopri di più"
}, X3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Желео бих да читам овај чланак на...",
  languageSwitcher_translation_original: "оригиналном језику",
  languageSwitcher_translation_human: "превео човек",
  languageSwitcher_translation_machine: "машински превод",
  languageSwitcher_disclaimer: "Овај садржај је аутоматски преведен и може садржати грешке у роду или друге дословне преводе. Трудимо се да решимо овај проблем, али у међувремену, ако приметите озбиљну грешку, јавите нам на <link>{email}</link>",
  /* Text */
  collapsibleSection_summary: "Сазнајте више"
}, J3 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "이 기사를 다음 언어로 읽고 싶습니다...",
  languageSwitcher_translation_original: "원본 언어",
  languageSwitcher_translation_human: "사람이 번역함",
  languageSwitcher_translation_machine: "기계 번역",
  languageSwitcher_disclaimer: "이 콘텐츠는 자동으로 번역되었으며, 성별 오류나 직역 등 부정확한 부분이 포함될 수 있습니다. 저희는 이 문제를 해결하기 위해 노력하고 있으며, 중요한 오류를 발견하셨다면 <link>{email}</link>로 알려주세요.",
  /* Text */
  collapsibleSection_summary: "자세히 보기"
}, e7 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Je voudrais lire cet article dans...",
  languageSwitcher_translation_original: "langue originale",
  languageSwitcher_translation_human: "traduit par un humain",
  languageSwitcher_translation_machine: "traduit par machine",
  languageSwitcher_disclaimer: "Ce contenu est traduit automatiquement et contiendra d’évantuelles erreurs de genre ou d’autres traductions directes. Nous essayons de résoudre ce problème, mais en attendant, si vous remarquez une erreur importante, faites-le nous savoir à <link>{email}</link>",
  /* Text */
  collapsibleSection_summary: "En savoir plus"
}, t7 = {
  ...hn,
  /* Navigation */
  languageSwitcher_label: "Ich möchte diesen Artikel lesen auf...",
  languageSwitcher_translation_original: "Originalsprache",
  languageSwitcher_translation_human: "von einem Menschen übersetzt",
  languageSwitcher_translation_machine: "maschinell übersetzt",
  languageSwitcher_disclaimer: "Dieser Inhalt wurde automatisch übersetzt und kann Fehler bei der Geschlechtszuordnung oder andere Ungenauigkeiten enthalten. Wir arbeiten daran, diese Probleme zu beheben. Wenn Ihnen ein schwerwiegender Fehler auffällt, informieren Sie uns bitte unter <link>{email}</link>.",
  /* Text */
  collapsibleSection_summary: "Mehr erfahren"
}, hp = (e, t = hn) => e in t, wr = (e, t, n, r, i = {}) => {
  let a = "";
  return hp(`${t}_${n}`) ? a = e({ id: `${t}_${n}` }, i) : a = e({ id: t }, { [r]: n, ...i }), a;
}, n7 = (e, t, n) => {
  if (!e || e === 0)
    return "0";
  t || (t = 0), n || (n = ["k", "m", "b", "t"]);
  let r = e.toString();
  t = Math.pow(10, t);
  for (let i = n.length - 1; i >= 0; i--) {
    const a = Math.pow(10, (i + 1) * 3);
    if (a <= e) {
      e = Math.round(e * t / a) / t, e === 1e3 && i < n.length - 1 && (e = 1, i++), r = `${e}${n[i]}`;
      break;
    }
  }
  return r;
}, ac = (e, t) => M.Children.map(e, (n) => Object.is(n, null) ? n : M.cloneElement(n, {
  ...t
})), r7 = (e = 0) => {
  setTimeout(() => {
    const t = document.querySelector(".splash-screen");
    t && t.remove(), window.prerenderReady = !0;
  }, e);
}, i7 = (e) => {
  var a, s;
  const n = [
    "name",
    "organization",
    "jobTitle",
    "biography"
  ].every((o) => {
    const l = e[o];
    return l != null && l !== "";
  }), r = ((a = e.image) == null ? void 0 : a.thumbnail) !== void 0, i = ((s = e.location) == null ? void 0 : s.en) !== void 0;
  return n && r && i;
}, a7 = (e, t, n) => !t.id || !t.name ? "" : t.error ? n.replace(/{{name}}/g, kc).replace(/{{id}}/g, kc) : n.replace(/{{name}}/g, t.name).replace(/{{id}}/g, t.id), XE = async ({
  text: e,
  template: t,
  mentions: n,
  listMembers: r = () => Promise.resolve([])
}) => {
  var a;
  if (!n)
    return e;
  const i = e.match(Rs);
  if (!i)
    return e;
  for (const s of i) {
    const o = s.replace(Rs, (c, d) => d), l = n[o];
    if (!l)
      continue;
    const u = {};
    if (typeof l == "object")
      u.name = l.error ? l.error : ((a = l == null ? void 0 : l.data) == null ? void 0 : a.name) || "", u.id = l.id || "", u.error = l.error;
    else {
      const c = l;
      if (c.startsWith(_0))
        try {
          const d = c.replace(_0, "");
          u.id = d, await r({ id: d }).then((f) => {
            const { name: p, error: g } = f;
            u.name = g || p || "", u.error = g;
          });
        } catch {
          e.replace(s, "@");
          continue;
        }
      else
        continue;
    }
    e = e.replace(s, u.name ? a7(e, u, t) : s);
  }
  return e;
}, pp = (e) => {
  const t = e.startsWith("http") ? e : `https://${e}`, r = new URL(t).hostname;
  return { full: t, pretty: r };
}, JE = (e) => new URLSearchParams(window.location.search).get(e), hl = (e = "") => e.replace(/\s+/g, "").length > 0, x0 = (e) => {
  const t = e.length > 8, n = /[0-9]/.test(e) && /[`!@#$%^&*()_+\-=[\]{}£;':"\\|,.<>/?~]/.test(e), r = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])").test(
    e
  );
  return {
    isValid: t && n && r,
    matchingRules: {
      isMoreThanEightCharacters: t,
      includesNumberAndSymbol: n,
      includesLowerAndUppercase: r
    }
  };
};
function ia(e) {
  return window != null && window.btoa ? window.btoa(
    encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, (t, n) => String.fromCharCode("0x" + n))
  ) : (console.error("window.btoa is not supported"), e);
}
const je = ({
  variant: e = "primary",
  size: t = "medium",
  styling: n = { muted: !1, fullWidth: !1 },
  icon: r = !1,
  href: i = !1,
  element: a = "button",
  onClick: s = !1,
  className: o = "",
  disabled: l = !1,
  tooltip: u = "",
  forceTooltip: c = !1,
  screenreaderText: d = !1,
  children: f = !1,
  ...p
}) => {
  const m = Ua(typeof t == "object"), { showTooltip: y, tooltipProps: v } = KE(!!u);
  if (typeof t == "object" && typeof m == "number") {
    const T = Object.assign({}, t), x = GE(Object.keys(T));
    t = YE(m, x, T);
  }
  !l && u && !c && (u = "");
  const E = [];
  typeof t == "string" && E.push(t), r && (E.push("icon"), typeof r == "object" ? (E.push(r.icon), r.position ? E.push(r.position) : E.push("left"), r.hover && E.push(`hover_${r.hover}`), r.animate && (E.push("animate"), typeof r.animate == "string" && E.push(r.animate))) : (E.push(r), !r.includes("right") && !r.includes("left") && E.push("left")));
  const b = {
    ...p,
    className: te(e, o, E, {
      "no-text": !f,
      disabled: l,
      button: i,
      muted: n.muted,
      "full-width": n.fullWidth
    }),
    onClick: (T) => {
      (!i || i[0] === "#") && s && (T.preventDefault(), T.stopPropagation()), s && s(T);
    },
    disabled: typeof l == "object" && "isClickable" in l ? !l.isClickable : l
  };
  i && (a = "a", b.href = i);
  const _ = M.createElement(
    a,
    b,
    f || (d ? /* @__PURE__ */ h.jsx(ht, { showOnFocus: !1, children: d }) : null)
  );
  return c || l && u ? /* @__PURE__ */ h.jsxs("span", { className: "button-container", ...v, children: [
    /* @__PURE__ */ h.jsx(
      Ys,
      {
        isOpen: y,
        accessibility: { readToScreenreadersWhenClosed: !0 },
        children: u
      }
    ),
    _
  ] }) : _;
}, Il = ({ buttons: e, wrappers: t = [], className: n = "", ...r }) => {
  const i = e.length > 1 ? "ul" : "p", a = e.map((s, o) => {
    var l;
    return i === "p" ? /* @__PURE__ */ h.jsx(je, { ...s }, o) : /* @__PURE__ */ h.jsx("li", { className: ((l = t[o]) == null ? void 0 : l.className) || "", children: /* @__PURE__ */ h.jsx(je, { ...s }) }, o);
  });
  return M.createElement(i, {
    className: te("button-wrapper", n),
    ...r,
    children: a
  });
};
const Zr = ({ className: e = "", maxWidth: t = !1 }) => {
  const n = t ? { "--max-width": `${t / 16}rem` } : {};
  return /* @__PURE__ */ h.jsx("hr", { className: te(e, { "has-max-width": t }), style: n });
}, w0 = {
  card: {
    range: [
      {
        height: 320,
        width: 320
      },
      {
        height: 425,
        width: 687
      },
      {
        height: 510,
        width: 768
      }
    ],
    sizes: "(min-width: 1024px) 720px, 30vw"
  },
  responsiveCard: {
    range: [
      {
        height: 125,
        width: 200
      },
      {
        height: 188,
        width: 300
      },
      {
        height: 313,
        width: 500
      }
    ],
    sizes: "(min-width: 1024px) 720px, 30vw"
  },
  banner: {
    range: [
      {
        height: 124,
        width: 425
      },
      {
        height: 320,
        width: 768
      },
      {
        height: 510,
        width: 1368
      }
    ],
    sizes: "(min-width: 1024px) 975px, 50vw"
  },
  feed: {
    range: [
      {
        height: 270,
        width: 124
      },
      {
        height: 320,
        width: 425
      },
      {
        height: 425,
        width: 687
      }
    ],
    sizes: "(min-width: 1024px) 510px, 20vw"
  },
  highlightSection: {
    range: [
      {
        height: 200,
        width: 674
      },
      {
        height: 400,
        width: 1348
      },
      {
        height: 1e3,
        width: 1e3
      },
      {
        height: 2e3,
        width: 2e3
      }
    ],
    sizes: "(max-width: 500px) 674px, (max-width: 1024px) 1348px, (max-width: 1200px) 1000px, 2000px"
  },
  thumbnail: {
    range: [
      {
        height: 124,
        width: 124
      },
      {
        height: 320,
        width: 320
      },
      {
        height: 510,
        width: 510
      }
    ],
    sizes: "(min-width: 1024px) 453px, 20vw"
  },
  fallback: {
    range: [
      {
        height: 124,
        width: 375
      },
      {
        height: 320,
        width: 687
      },
      {
        height: 510,
        width: 990
      }
    ],
    sizes: "(min-width: 1024px) 885px, 35vw"
  }
}, s7 = ({
  aspect: e,
  range: t,
  sizes: n
}) => {
  const { range: r, sizes: i } = e ? w0[e] : w0.fallback;
  return { range: t && t.length > 0 ? t : r, sizes: n || i };
}, o7 = ({ format: e, height: t, query: n, width: r }) => {
  let i = `w=${r}&h=${t}`;
  return i = e ? `${i}&fm=${e}` : i, i = n ? `${i}&${n}` : i, i;
}, W1 = ({ format: e, range: t, url: n, query: r }) => t.map(({ height: i, width: a }) => `${n}?${o7({
  format: e,
  height: i,
  query: r,
  width: a
})} ${a}w`).join(", ");
const za = ({ image: e, className: t, testId: n }) => {
  const {
    description: r,
    height: i,
    type: a,
    color: s,
    query: o,
    url: l,
    width: u,
    loading: c,
    decoding: d,
    fetchPriority: f
  } = e, { range: p, sizes: g } = s7(e), m = W1({ format: "avif", query: o, range: p, url: l }), y = W1({ format: "webp", query: o, range: p, url: l }), v = W1({ format: "", query: o, range: p, url: l });
  let E = {};
  return s && (E = { "--color": s }), a && a.includes("svg") ? /* @__PURE__ */ h.jsx("picture", { className: t, style: E, children: /* @__PURE__ */ h.jsx(
    "img",
    {
      src: l,
      alt: r,
      loading: c || "lazy",
      decoding: d || "async",
      fetchpriority: f || "auto",
      width: u,
      height: i,
      "data-testid": n || "image"
    }
  ) }) : /* @__PURE__ */ h.jsxs("picture", { className: t, style: E, children: [
    a !== "image/gif" && /* @__PURE__ */ h.jsx(
      "source",
      {
        type: "image/avif",
        srcSet: m,
        sizes: g,
        "data-testid": "source"
      }
    ),
    /* @__PURE__ */ h.jsx("source", { type: "image/webp", srcSet: y, sizes: g, "data-testid": "source" }),
    /* @__PURE__ */ h.jsx(
      "img",
      {
        srcSet: v,
        sizes: g,
        src: l,
        alt: r,
        loading: c || "lazy",
        decoding: d || "async",
        fetchpriority: f || "auto",
        width: u,
        height: i,
        "data-testid": n || "image"
      }
    )
  ] });
};
const qie = ({ image: e, className: t = "", testId: n }) => /* @__PURE__ */ h.jsx(
  "div",
  {
    className: `image-container ${t}`,
    "data-testid": n || "image-container",
    children: e && /* @__PURE__ */ h.jsx(za, { image: { ...e }, className: "image" })
  }
), qa = ({
  href: e,
  children: t,
  fallbackElement: n,
  meta: r,
  className: i = "",
  onClick: a,
  gtmContext: s,
  gtmType: o,
  ...l
}) => {
  const { forceOnClick: u = !1 } = r || {};
  if (e) {
    const d = { ...l };
    return a && (d.onClick = a), s && (d["data-gtm-event-context"] = s), o && (d["data-gtm-event-type"] = o), /* @__PURE__ */ h.jsx("a", { href: e, className: te("gtm-trackable", i), ...d, children: t });
  }
  const c = {};
  return u && (c.onClick = a), n ? M.createElement(n, {
    children: t,
    className: i,
    ...l,
    ...c
  }) : /* @__PURE__ */ h.jsx(h.Fragment, { children: t });
};
const l7 = Ol(
  ({ className: e = "", children: t }, n) => {
    const r = Ue(null), i = n || r;
    return /* @__PURE__ */ h.jsx(
      "aside",
      {
        ref: i,
        className: te("popover", e),
        "aria-live": "polite",
        children: t
      }
    );
  }
), Pl = ({ parent: e = document.body, children: t }) => typeof document == "object" ? $E.createPortal(t, e) : null, u7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pl
}, Symbol.toStringTag, { value: "Module" }));
const Wie = ({
  currentStep: e = 1,
  steps: t = 1
}) => /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
  /* @__PURE__ */ h.jsx(ht, { children: /* @__PURE__ */ h.jsx(
    en,
    {
      id: "progressTracker",
      values: { current: e, total: t }
    }
  ) }),
  /* @__PURE__ */ h.jsx("div", { className: "progress-tracker", children: /* @__PURE__ */ h.jsx("div", { className: "dots-wrapper", children: new Array(t).fill("").map((n, r) => {
    const i = r + 1;
    return /* @__PURE__ */ h.jsxs("div", { className: "dot-wrapper", children: [
      /* @__PURE__ */ h.jsx(
        "div",
        {
          className: te("dot", {
            active: i === e,
            completed: i < e
          }),
          "data-testid": "progress-dot"
        }
      ),
      /* @__PURE__ */ h.jsx(
        "div",
        {
          className: te("line", {
            active: i < e
          })
        }
      )
    ] }, r);
  }) }) })
] });
const Vie = ({ elementId: e, offset: t = 20 }) => {
  const n = ye(), r = () => {
    const i = document.getElementById(e);
    if (!i)
      return;
    const a = document.getElementById("header");
    a && window.scrollTo({
      top: i.offsetTop - a.clientHeight - t
    });
  };
  return /* @__PURE__ */ h.jsx(
    je,
    {
      variant: "secondary",
      className: "return-to-nav",
      onClick: r,
      "data-gtm-event-context": "ListPageMobile",
      "data-gtm-event-type": "back-to-nav-button-click",
      screenreaderText: n.formatMessage({ id: "return_to_nav_button" })
    }
  );
};
const Kie = ({ items: e, className: t = "", ...n }) => /* @__PURE__ */ h.jsx("ul", { className: te("buckets", t), ...n, children: e.map(({ title: r, text: i, link: a, ...s }, o) => /* @__PURE__ */ h.jsx("li", { className: "bucket text-medium", children: /* @__PURE__ */ h.jsxs("a", { href: a, ...s, children: [
  /* @__PURE__ */ h.jsx("p", { className: "title", children: r }),
  /* @__PURE__ */ h.jsx("p", { children: i })
] }) }, o)) }), A0 = 300, S0 = "ease-in-out";
class c7 {
  constructor(t) {
    this.el = t, this.summary = t.querySelector("summary"), this.content = t.querySelector(".content"), this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.summary.addEventListener("click", (n) => this.onClick(n));
  }
  cleanUp() {
    this.summary.removeEventListener("click", (t) => this.onClick(t));
  }
  onClick(t) {
    t.preventDefault(), t.stopPropagation(), this.el.style.overflow = "hidden", this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink();
  }
  shrink() {
    this.isClosing = !0;
    const t = `${this.el.offsetHeight}px`, n = `${this.summary.offsetHeight}px`;
    this.animation && this.animation.cancel(), this.animation = this.el.animate(
      {
        height: [t, n]
      },
      {
        duration: A0,
        easing: S0
      }
    ), this.animation.onfinish = () => this.onAnimationFinish(!1), this.animation.oncancel = () => this.isClosing = !1;
  }
  open() {
    this.el.style.height = `${this.el.offsetHeight}px`, this.el.open = !0, window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = !0;
    const t = `${this.el.offsetHeight}px`, n = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    this.animation && this.animation.cancel(), this.animation = this.el.animate(
      {
        height: [t, n]
      },
      {
        duration: A0,
        easing: S0
      }
    ), this.animation.onfinish = () => this.onAnimationFinish(!0), this.animation.oncancel = () => this.isExpanding = !1;
  }
  onAnimationFinish(t) {
    this.el.open = t, this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.el.style.height = this.el.style.overflow = "";
  }
}
const mp = ({
  label: e = !1,
  className: t = "",
  children: n,
  shouldAnimate: r = !1
}) => {
  const i = ye(), a = Ue(null);
  return pe(() => {
    let s;
    return r && (s = new c7(a.current)), () => {
      r && s && s.cleanUp();
    };
  }, []), /* @__PURE__ */ h.jsxs(
    "details",
    {
      ref: a,
      className: te("collapsible-section", t, {
        "should-animate": r
      }),
      children: [
        /* @__PURE__ */ h.jsx("summary", { children: e || i.formatMessage({ id: "collapsibleSection_summary" }) }),
        /* @__PURE__ */ h.jsx("div", { className: "content", children: n })
      ]
    }
  );
}, k0 = {
  cube: "box",
  graduationCap: "graduation-cap",
  person: "user",
  speech: "speech-bubble_round",
  star: "star_empty_thin"
}, d7 = (e) => {
  let t = e;
  return Object.keys(k0).includes(e) && (t = k0[e]), `url(${_i}icons/${t}.svg)`;
};
const D0 = {
  customCard: "custom",
  microcourse: "course",
  courseJourney: "course",
  solutionArticle: "article",
  qaQuestion: "question",
  listPage: "list",
  learningHub: "learning-hub",
  communityPage: "communityPage"
}, f7 = ({
  contentType: e,
  customIcon: t,
  customLabel: n,
  className: r = ""
}) => {
  const i = ye(), a = t ? { "--custom-icon": d7(t) } : {}, s = hp(`contentTypeLabel_${e}`) ? i.formatMessage({ id: `contentTypeLabel_${e}` }) : !1;
  return !n && !s ? null : /* @__PURE__ */ h.jsx(
    "small",
    {
      className: te(
        "content-type-label text-small",
        e in D0 ? D0[e] : e,
        r,
        {
          "has-custom-icon": t
        }
      ),
      style: a,
      "data-testid": "content-type-label",
      children: n || s
    }
  );
};
const ur = ({
  variant: e = "primary",
  icon: t,
  styling: n = {},
  className: r = "",
  children: i,
  ...a
}) => {
  const { showHighlight: s = !1, background: o = "default" } = n, l = t ? { "--icon": `url(${_i}icons/${t}.svg)` } : {};
  return /* @__PURE__ */ h.jsx(
    "div",
    {
      className: te("highlighted-text-box", e, r, {
        "has-icon": t,
        "show-highlight": s,
        [o]: o !== "default"
      }),
      style: l,
      ...a,
      children: i
    }
  );
};
const Ci = ({
  variant: e = "empty",
  text: t = !1,
  button: n = !1,
  className: r = ""
}) => {
  let i = n && !!Object.keys(n).length;
  const a = typeof n == "object" && "breakpoints" in n, s = Ua(a);
  if (a && typeof n == "object" && typeof s == "number") {
    const d = Object.assign({}, n.breakpoints), f = GE(Object.keys(d));
    i = YE(s, f, d);
  }
  const {
    breakpoints: o,
    text: l = "",
    component: u,
    ...c
  } = n;
  return /* @__PURE__ */ h.jsx(
    ur,
    {
      variant: "subtle",
      className: te("empty-state-box", e, r),
      children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        t && typeof t == "string" ? /* @__PURE__ */ h.jsx(Wr, { options: { forceBlock: !0 }, children: t }) : t,
        i && typeof n == "object" && (u || /* @__PURE__ */ h.jsx(
          je,
          {
            ...c,
            variant: n.variant ? n.variant : "secondary",
            children: l
          }
        ))
      ] })
    }
  );
};
const ah = ({ children: e, ...t }) => /* @__PURE__ */ h.jsx("p", { ...t, children: e }), e4 = { q: ah, blockquote: ah };
for (let e = 1; e <= 6; e++)
  e4[`h${e}`] = { component: ah, props: { className: "title" } };
const h7 = ({
  type: e = "default",
  className: t = "",
  heading: n = !1,
  children: r,
  ...i
}) => /* @__PURE__ */ h.jsxs("div", { ...i, className: te("helper-text-box text-small", e, t), children: [
  n && /* @__PURE__ */ h.jsx("p", { className: "title", children: n }),
  typeof r == "string" ? /* @__PURE__ */ h.jsx(
    Wr,
    {
      options: {
        wrapper: M.Fragment,
        forceBlock: !0,
        overrides: e4
      },
      children: r
    }
  ) : /* @__PURE__ */ h.jsx("p", { children: r })
] });
const p7 = ({
  id: e,
  className: t = "",
  show: n = !1,
  hide: r = !1,
  text: i,
  markdownOptions: a,
  fadeStyle: s = "default",
  children: o
}) => {
  const l = ye(), u = Ue(null);
  e || (e = Date.now().toString());
  const [c, d] = de(""), [f, p] = de("closed");
  pe(() => {
    const y = u.current;
    if (y)
      return y.addEventListener("transitionend", g), () => {
        y.removeEventListener("transitionend", g);
      };
  }, []), pe(() => {
    if (!i || typeof i != "string")
      return;
    const y = i.split(`
`);
    d(
      y.length < 3 ? `${i.substring(0, 400)}...` : y.slice(0, 3).join(`
`)
    );
  }, [i]), pe(() => {
    f === "ready-to-close" && p("closing");
  }, [f]);
  const g = ({ propertyName: y }) => {
    y === "max-height" && p((v) => v === "opening" ? "open" : v === "closing" ? "closed" : v);
  }, m = ["opening", "open"].includes(f);
  return /* @__PURE__ */ h.jsxs(
    ur,
    {
      variant: "subtle",
      className: te("hide-show-text-box", t),
      children: [
        /* @__PURE__ */ h.jsx("div", { ref: u, id: e, className: te("content", f, s), children: i ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
          /* @__PURE__ */ h.jsx(Wr, { options: { forceBlock: !0, ...a }, children: f === "closed" ? c : i }),
          f !== "closed" && o
        ] }) : o }),
        /* @__PURE__ */ h.jsx("p", { className: "cta", children: /* @__PURE__ */ h.jsx(
          je,
          {
            variant: "tertiary",
            icon: { icon: "navigation_arrow", position: "left", animate: !0 },
            styling: { muted: !0 },
            className: te({ "rotate-180": m }),
            onClick: () => {
              p(m ? "ready-to-close" : "opening");
            },
            "aria-expanded": m,
            "aria-controls": e,
            children: m ? r || l.formatMessage({ id: "hideShowTextBox_hide" }) : n || l.formatMessage({ id: "hideShowTextBox_show" })
          }
        ) })
      ]
    }
  );
};
const Gie = ({
  element: e = "ul",
  layout: t = "vertical",
  variant: n = "default",
  items: r = [],
  styling: i = {},
  className: a = ""
}) => {
  const { hasBorder: s = !1, zebraStriping: o = !1 } = i;
  return M.createElement(e, {
    className: te("icon-bulleted-list text-medium", n, a, {
      "has-border": s,
      "has-zebra-stripes": o,
      [t]: e !== "dl"
    }),
    children: r.map((l, u) => {
      const c = { wrapper: M.Fragment, forceInline: !0 }, d = {
        "--icon": `url(${_i}icons/${l.icon}.svg)`
      };
      return e === "dl" ? /* @__PURE__ */ h.jsxs(M.Fragment, { children: [
        /* @__PURE__ */ h.jsx("dt", { style: d, children: /* @__PURE__ */ h.jsx(Wr, { options: c, children: l.dt || "" }) }, `dt-${u}`),
        /* @__PURE__ */ h.jsx("dd", { children: typeof l.text == "string" ? /* @__PURE__ */ h.jsx(Wr, { options: c, children: l.text }) : l.text }, `dd-${u}`)
      ] }, `dl-${u}`) : /* @__PURE__ */ h.jsx("li", { style: d, children: typeof l.text == "string" ? /* @__PURE__ */ h.jsx(Wr, { options: c, children: l.text }) : l.text }, u);
    })
  });
}, on = () => M.Fragment, m7 = ({ children: e }) => /* @__PURE__ */ h.jsx(ur, { variant: "secondary", children: e }), g7 = ({ children: e }) => typeof e == "object" && Object.keys(e || {}).length === 1 ? /* @__PURE__ */ h.jsx("p", { className: "center", children: e }) : /* @__PURE__ */ h.jsx("div", { className: "center", children: e }), v7 = ["span", "strong", "h1", "h2", "h3", "h4", "h5", "h6", "p"], y7 = ({ children: e }) => {
  const t = ye();
  if (!e)
    return null;
  let n = t.formatMessage({
    id: "markdown_collapsibleSection_summary"
  });
  const r = [];
  for (const a of nh.toArray(e))
    if (!(!a || typeof a == "string" || typeof a == "number"))
      if (M.isValidElement(a) && a.type === "summary") {
        if (a.props && a.props.children) {
          for (const s of nh.toArray(a.props.children))
            if (!(!s || typeof s == "string" || typeof s == "number") && M.isValidElement(s)) {
              const o = s.type;
              if (v7.includes(o)) {
                for (n = s.props.children; typeof n != "string" && (Array.isArray(n) && n[0].props && n[0].props.children && n[0].props.children[0]); )
                  n = n[0].props.children[0];
                break;
              }
            }
        }
      } else
        r.push(a);
  const i = n ? n.toString() : "";
  return /* @__PURE__ */ h.jsx(
    mp,
    {
      label: i,
      className: ["Sources", "Resources"].includes(i) ? "discrete-links" : "",
      children: r.map((a) => a)
    }
  );
}, E7 = ({
  children: e,
  ...t
}) => {
  if (t.class)
    switch (t.class) {
      case "casestudy":
        return /* @__PURE__ */ h.jsx(ur, { variant: "secondary", children: e });
      case "general-textbox":
      case "highlight-box":
        return /* @__PURE__ */ h.jsx(ur, { variant: "primary", children: e });
      case "pink-textbox":
        return /* @__PURE__ */ h.jsx(ur, { variant: "tertiary", children: e });
      case "content":
        return typeof e == "object" && Object.keys(e || {}).length === 1 ? /* @__PURE__ */ h.jsx("p", { children: e }) : e;
      default:
        return /* @__PURE__ */ h.jsx("div", { ...t, children: e });
    }
  return /* @__PURE__ */ h.jsx("div", { ...t, children: e });
}, br = ({ children: e }) => /* @__PURE__ */ h.jsx(h.Fragment, { children: e }), t4 = sn({
  badges: [],
  isLoading: !0
});
function b7() {
  return We(t4);
}
const T7 = ({ children: e, badges: t }) => /* @__PURE__ */ h.jsx(t4.Provider, { value: t, children: e }), _7 = ({ showDevTools: e = !0, children: t }) => {
  const n = new f3({
    // default options we would like on all queries can be overridden individually
    defaultOptions: {
      queries: {
        // data should not refetch if the window is refocussed
        refetchOnWindowFocus: !1,
        // data should go stale after 1 minute
        staleTime: 6e4
      }
    }
  });
  return /* @__PURE__ */ h.jsxs(h3, { client: n, children: [
    t,
    e && /* @__PURE__ */ h.jsx(m3, { initialIsOpen: !1 })
  ] });
};
var n4 = sn({ client: ic });
function C7(e) {
  var t = e.children, n = e.client, r = e.apiKey, i = e.options, a = Vn(function() {
    return n && r && console.warn("[PostHog.js] You have provided both a client and an apiKey to PostHogProvider. The apiKey will be ignored in favour of the client."), n && i && console.warn("[PostHog.js] You have provided both a client and options to PostHogProvider. The options will be ignored in favour of the client."), n || (r && (ic.__loaded && console.warn("[PostHog.js] was already loaded elsewhere. This may cause issues."), ic.init(r, i)), ic);
  }, [n, r]);
  return M.createElement(n4.Provider, { value: { client: a } }, t);
}
var x7 = function() {
  var e = We(n4).client;
  return e;
};
function O0(e) {
  var t = x7(), n = de(), r = n[0], i = n[1];
  return pe(function() {
    return t.onFeatureFlags(function() {
      i(t.isFeatureEnabled(e));
    });
  }, [t, e]), r;
}
const w7 = ({ children: e, user: t }) => t.isLoading ? null : process.env.REACT_APP_PUBLIC_POSTHOG_KEY ? /* @__PURE__ */ h.jsx(
  C7,
  {
    apiKey: atob(process.env.REACT_APP_PUBLIC_POSTHOG_KEY),
    options: {
      api_host: "/ph",
      autocapture: !1,
      disable_session_recording: !0,
      persistence_name: "flags",
      secure_cookie: !0,
      ui_host: "eu.posthog.com",
      bootstrap: {
        // The distinct ID is the user's ID if they are logged in, or a random ID otherwise
        distinctID: t.id || "00000000-0000-0000-0000-000000000000",
        isIdentifiedID: !!t.id
      }
    },
    children: e
  }
) : /* @__PURE__ */ h.jsx(h.Fragment, { children: e });
var A7 = /* @__PURE__ */ ((e) => (e.COMMUNITY_RANKING = "community-ranking", e))(A7 || {});
const S7 = {
  en: hn,
  es: U3,
  fr: z3,
  pt: q3,
  id: W3,
  "pt-BR": V3,
  "es-419": K3,
  "sr-Cyrl": X3,
  de: t7,
  "fr-CA": e7,
  ko: J3,
  it: Q3,
  pl: Z3,
  ja: Y3,
  ar: G3
}, k7 = ({ children: e, locale: t, messages: n }) => {
  const r = t || HE, i = {
    ...S7[r],
    ...n || {}
  };
  return /* @__PURE__ */ h.jsx(l3, { locale: r, messages: i, children: e });
}, r4 = sn({}), zt = sn({ isLoading: !0 });
function gp() {
  return We(zt);
}
const D7 = ({ children: e, user: t, updateDetails: n }) => /* @__PURE__ */ h.jsx(zt.Provider, { value: { ...t, updateDetails: n }, children: e }), i4 = sn({
  registerOverlay: () => {
  },
  unregisterOverlay: () => {
  }
}), O7 = () => We(i4), N7 = ({ children: e }) => {
  const [t, n] = de([]);
  pe(() => {
    t.length > 0 ? document.body.classList.add("has-overlay") : document.body.classList.remove("has-overlay");
  }, [t]);
  const r = ft((a) => {
    n((s) => [...s, a]);
  }, []), i = ft((a) => {
    n(
      (s) => s.filter((o) => o !== a)
    );
  }, []);
  return /* @__PURE__ */ h.jsx(i4.Provider, { value: { registerOverlay: r, unregisterOverlay: i }, children: e });
}, Yie = ({ bootstrap: e, children: t, intl: n, showDevTools: r }) => {
  const [i, a] = de({ isLoading: !0 }), [s, o] = de({ badges: [], isLoading: !0 }), l = (n == null ? void 0 : n.locale) || localStorage.getItem("language") || "en", [u, c] = de(l), d = (f) => {
    localStorage.setItem("language", f), c(f);
  };
  return pe(() => {
    e().then((f) => {
      Array.isArray(f) ? (a({ ...f[0], isLoading: !1 }), o({ badges: f[1], isLoading: !1 })) : a({ ...f, isLoading: !1 }), r7(5e3);
    }).catch((f) => {
      f.message === B3 && window.location.pathname !== "/logout" && (window.location.href = "/logout"), a({ isLoading: !1 }), o({ badges: [], isLoading: !1 });
    });
  }, []), /* @__PURE__ */ h.jsx(r4.Provider, { value: { language: u, updateLanguage: d }, children: /* @__PURE__ */ h.jsx(
    k7,
    {
      locale: u,
      messages: n == null ? void 0 : n.messages,
      children: /* @__PURE__ */ h.jsx(g3, { children: /* @__PURE__ */ h.jsx(D7, { user: i, updateDetails: a, children: /* @__PURE__ */ h.jsx(T7, { badges: s, children: /* @__PURE__ */ h.jsx(N7, { children: /* @__PURE__ */ h.jsx(_7, { showDevTools: r, children: /* @__PURE__ */ h.jsx(w7, { user: i, children: t }) }) }) }) }) })
    }
  ) });
}, I7 = (e) => {
  const t = ye(), n = Date.now().toString(), r = We(zt);
  let i = "default", a = e.src;
  a.includes("youtube") || a.includes("vimeo") ? i = "video" : a.includes("riddle") || a.includes("sli.do") ? i = "poll" : a.includes("padlet") ? i = "padlet" : a.includes("surveysparrow") && (i = "survey", r != null && r.id && (a = `${a}&user_id=${r.id}`));
  const s = `content-after-iframe-${n}`;
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(
      ht,
      {
        element: "a",
        href: `#${s}`,
        onClick: (o) => {
          o.preventDefault(), o.stopPropagation();
          const l = document.getElementById(s);
          l == null || l.scrollIntoView({ behavior: "smooth" }), l == null || l.focus();
        },
        children: t.formatMessage({
          id: `markdown_skip${i === "default" ? "" : `_${i}`}`
        })
      }
    ),
    /* @__PURE__ */ h.jsx(
      "iframe",
      {
        ...e,
        src: a,
        title: t.formatMessage({
          id: `markdown_iframe${i === "default" ? "" : `_${i}`}`
        })
      }
    ),
    /* @__PURE__ */ h.jsx("span", { id: s, tabIndex: 0 })
  ] });
}, N0 = (e) => {
  let t = "";
  return e && typeof e != "string" && typeof e != "number" && typeof e != "boolean" && "type" in e && (t = e.type), t;
}, P7 = ({
  children: e,
  ...t
}) => {
  const n = ye();
  let r = { ...t };
  t.href && (t.href.includes("http:") || t.href.includes("https:")) && !t.target && (r.target = "_blank");
  let i = e, a = !1;
  for (const o of nh.toArray(e))
    if (!(!o || typeof o == "string" || typeof o == "number") && M.isValidElement(o)) {
      const l = o.type;
      if (["button", "center", "span", "strong"].includes(l) && o.props && o.props.children && o.props.children[0])
        for ((l === "button" || N0(o.props.children[0]) === "button") && (a = !0), i = o.props.children[0]; i && typeof i != "string" && !(typeof i == "boolean" || typeof i == "number" || !M.isValidElement(i)); )
          if (i.props && i.props.children && i.props.children[0])
            i = i.props.children[0], i && N0(i) === "button" && (a = !0);
          else
            break;
    }
  const s = `@${kc}`;
  return i === s || Array.isArray(i) && i[0] === s ? (delete r.href, delete r.target, /* @__PURE__ */ h.jsxs("span", { ...r, className: "mention deleted-user", children: [
    "@",
    n.formatMessage({ id: "member_deleted" })
  ] })) : a ? (r = { ...r, className: "button primary medium" }, /* @__PURE__ */ h.jsx("p", { className: "center", children: /* @__PURE__ */ h.jsx(je, { variant: "primary", size: "medium", ...r, children: i }) })) : /* @__PURE__ */ h.jsx("a", { ...r, children: i });
}, I0 = ({ children: e, ...t }) => /* @__PURE__ */ h.jsx("span", { className: te({ url: t == null ? void 0 : t.href }), children: e });
const R7 = {
  default: {
    a: P7,
    // Override psuedo-code
    // We give the content team psuedo-code short cuts to use in Contentful
    CollapsibleSection: mp,
    TextBox: ur,
    CaseStudy: m7,
    // Override embedded HTML
    // Our content team previously used real HTML, which we need to tear out and replace with React components
    style: on,
    details: y7,
    div: E7,
    iframe: I7,
    center: g7,
    script: on
  },
  "text-only": {
    h1: on,
    h2: on,
    h3: on,
    h4: on,
    h5: on,
    h6: on,
    style: on,
    details: on,
    div: on,
    TextBox: on,
    CollapsibleSection: on,
    CaseStudy: on,
    blockquote: on,
    iframe: on,
    button: on
  }
}, Fs = ({
  element: e = "div",
  className: t = "",
  options: n = {},
  children: r,
  overrideType: i = "default",
  styling: a = {}
}) => {
  if (!r)
    return null;
  const { highlightTitles: s = !1 } = a;
  r = r.replace(/^<br\/?>/, "");
  const o = {
    wrapper: M.Fragment,
    forceBlock: !0
  };
  let l = R7[i];
  return n.overrides && (l = { ...l, ...n.overrides }), M.createElement(e, {
    className: te("markdown-text", t, {
      "highlight-titles": s
    }),
    children: /* @__PURE__ */ h.jsx(Wr, { options: { ...o, ...n, overrides: l }, children: r })
  });
};
const F7 = ({
  maxWidth: e = !1,
  title: t,
  subtitle: n,
  children: r,
  className: i = "",
  ctaButton: a
}) => {
  const s = e ? { "--max-width": `${e / 16}rem` } : {};
  return /* @__PURE__ */ h.jsxs("section", { className: te("page-heading", i), children: [
    /* @__PURE__ */ h.jsxs("div", { className: te("content", { "has-max-width": e }), style: s, children: [
      /* @__PURE__ */ h.jsxs("div", { className: te("content-wrapper", { "has-max-width": e }), children: [
        t && t.text && M.createElement(
          t.element || "h1",
          { className: "title" },
          t.text
        ),
        n && n.text && M.createElement(
          n.element || "h2",
          { className: "text-medium" },
          n.text
        )
      ] }),
      a && /* @__PURE__ */ h.jsx(
        je,
        {
          ...a,
          className: te("cta-button", "gtm-trackable"),
          "data-gtm-event-context": "CreateNewArticle",
          "data-gtm-event-type": "create-article-click",
          children: a.text
        }
      )
    ] }),
    r
  ] });
};
const Ti = ({
  size: e = "medium",
  variant: t = "default",
  className: n = "",
  icon: r,
  tooltip: i = "",
  children: a,
  element: s = "span",
  ...o
}) => {
  const l = {
    "--icon": `url(${_i}icons/${r}.svg)`
  }, { showTooltip: u, tooltipProps: c } = KE(!!i), d = {}, f = i ? typeof i == "string" ? `tooltip-${ia(i)}` : i.id : void 0, p = i ? typeof i == "string" ? i : i.text : void 0;
  i && f && (d["aria-describedby"] = f);
  const g = M.createElement(i ? "button" : s, {
    className: te("pill", e, t, n, {
      "has-icon": r
    }),
    style: l,
    children: a,
    ...c,
    ...d,
    ...o
  });
  return i ? M.createElement(
    s,
    { className: "pill-wrapper" },
    /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      g,
      /* @__PURE__ */ h.jsx(Ys, { id: f, isOpen: u, children: p })
    ] })
  ) : g;
};
const pl = ({
  element: e = "p",
  children: t = null,
  className: n = "",
  ...r
}) => M.createElement(
  e,
  {
    ...r,
    className: te("status-banner text-small", n),
    "aria-live": "assertive"
  },
  t
), B7 = {
  globe: "globe",
  heart: "heart_empty_thick",
  pencil: "pencil",
  star: "star_empty",
  "speech-bubble": "speech-bubble_round"
};
const M7 = (e) => e.toLowerCase().replace(/\s+/g, "-"), L7 = ({ slug: e }) => {
  const t = ye(), n = "badgeName", { badges: r } = b7(), i = r == null ? void 0 : r.find((d) => d.slug === e);
  if (!i)
    return null;
  const { name: a, icon: s, colour: o, description: l } = i, u = M7(a), c = t.formatMessage({
    id: `${n}_${u}`,
    defaultMessage: a
  });
  return /* @__PURE__ */ h.jsx(
    Ti,
    {
      className: te("user-badge", o == null ? void 0 : o.toLowerCase()),
      icon: s && B7[s],
      element: "li",
      tooltip: l,
      children: c
    }
  );
};
var Cn = /* @__PURE__ */ ((e) => (e.Communities = "communities", e.Platform = "platform", e))(Cn || {});
const $7 = ({ userBadges: e, badgeOptions: { scopes: t } }) => {
  if (Object.keys(e).length === 0 || !t)
    return;
  const n = t.flatMap((r) => {
    var i;
    return (i = e == null ? void 0 : e[r.scope]) == null ? void 0 : i[r.area];
  }).filter(Boolean);
  return /* @__PURE__ */ h.jsx("ul", { className: "badges-list", children: n.map((r, i) => /* @__PURE__ */ h.jsx(L7, { slug: r }, `${i}-${r}`)) });
};
var a4 = /* @__PURE__ */ ((e) => (e.Accepted = "accepted", e.Cancelled = "cancelled", e.Declined = "declined", e.Pending = "pending", e.Removed = "removed", e))(a4 || {}), s4 = /* @__PURE__ */ ((e) => (e.In = "in", e.Out = "out", e))(s4 || {});
const { In: j7, Out: P0 } = s4, { Pending: V1, Accepted: R0, Cancelled: H7, Removed: U7 } = a4, z7 = ({
  functions: e,
  connection: t = {
    status: null,
    direction: null
  },
  disableConnect: n = !1,
  meta: { topLevelButton: r = !1 } = {},
  ...i
}) => {
  const { formatMessage: a } = ye(), { status: s, direction: o } = t, { onAccept: l, onCancel: u, onRemove: c, onRequest: d } = e, [f, p] = de(!1), [g, m] = de(s), [y, v] = de(o);
  pe(() => {
    m(s), v(o);
  }, [s, o]);
  const E = async (b, _) => {
    try {
      p(!0), await b() && (_ != null && _.status && m(_.status), _ != null && _.direction && v(_.direction));
    } finally {
      p(!1);
    }
  };
  return g === V1 && y === P0 ? /* @__PURE__ */ h.jsx(
    je,
    {
      onClick: async () => {
        await E(l, { status: R0 });
      },
      disabled: f,
      variant: r ? "primary" : "secondary",
      size: "small",
      icon: {
        icon: "user-plus"
      },
      ...i,
      children: a({ id: "member_connection_accept" })
    }
  ) : g === V1 && y === j7 ? /* @__PURE__ */ h.jsxs("div", { className: "connection-cta-wrapper", children: [
    /* @__PURE__ */ h.jsx(
      "span",
      {
        className: "button secondary connection-cta pending small icon clock left",
        ...i,
        children: a({ id: "member_connection_pending" })
      }
    ),
    u && /* @__PURE__ */ h.jsx(
      Ph,
      {
        options: [
          {
            onClick: async () => {
              await E(u, { status: H7 });
            },
            text: a({ id: "member_connection_cancel" })
          }
        ]
      }
    )
  ] }) : g === R0 ? /* @__PURE__ */ h.jsxs("div", { className: "connection-cta-wrapper", children: [
    /* @__PURE__ */ h.jsx(
      "span",
      {
        className: "button secondary connection-cta connected small icon tick left",
        ...i,
        children: a({ id: "member_connection_connected" })
      }
    ),
    c && /* @__PURE__ */ h.jsx(
      Ph,
      {
        options: [
          {
            onClick: async () => {
              await E(c, { status: U7 });
            },
            text: a({ id: "member_connection_remove" })
          }
        ]
      }
    )
  ] }) : !g && d && !n ? /* @__PURE__ */ h.jsx(
    je,
    {
      onClick: async () => {
        await E(d, { status: V1, direction: P0 });
      },
      variant: r ? "primary" : "secondary",
      size: "small",
      disabled: f,
      icon: {
        icon: "user-plus"
      },
      ...i,
      children: a({ id: "member_connection_connect" })
    }
  ) : /* @__PURE__ */ h.jsx(h.Fragment, {});
};
const q7 = ({
  styling: e = {},
  progress: t = 0,
  text: n = !1,
  className: r = ""
}) => {
  const i = ye(), {
    showText: a = !1,
    layout: s = "bar",
    size: o = "default",
    color: l = "default"
  } = e, u = t > 75 ? 100 : t > 50 ? 75 : t > 25 ? 50 : t > 5 ? 25 : 0, c = { "--progress": `${t}%` };
  return /* @__PURE__ */ h.jsx(
    "span",
    {
      className: te(`progress-bar section-${u}`, s, r, {
        [o]: o !== "default",
        [l !== "default" ? l : ""]: l !== "default"
      }),
      style: c,
      children: M.createElement(a ? "span" : ht, {
        className: a ? "text" : "",
        children: n || i.formatMessage({ id: "progressBar" }, { number: t })
      })
    }
  );
}, o4 = mr(q7);
const K1 = "loadingBlock_", W7 = ({
  progress: e = 0,
  steps: t = !1,
  className: n = ""
}) => {
  const r = ye();
  t || (t = {
    0: { text: r.formatMessage({ id: `${K1}loading` }) },
    75: { text: r.formatMessage({ id: `${K1}almostDone` }) },
    100: { text: r.formatMessage({ id: `${K1}complete` }) }
  });
  let i = null;
  const a = Object.keys(t);
  for (let o = 0; o < a.length && !(e < parseInt(a[o])); o++)
    i = a[o];
  const s = i && t[i].icon ? {
    "--icon": `url(${_i}icons/${t[i].icon}.svg)`
  } : {};
  return /* @__PURE__ */ h.jsxs(
    ur,
    {
      className: te("loading-block", n, {
        "has-icon": i && t[i].icon
      }),
      variant: "subtle",
      style: s,
      children: [
        i && /* @__PURE__ */ h.jsx("span", { className: "step", children: t[i].text }),
        /* @__PURE__ */ h.jsx(o4, { progress: e })
      ]
    }
  );
}, V7 = mr(W7);
const Dr = ({ element: e = "div", className: t = "", ...n }) => /* @__PURE__ */ h.jsx(
  dp,
  {
    element: e,
    className: te("loading-placeholder", t),
    ...n
  }
);
const sh = {
  header: ["logo", "link", "link", "search"],
  sidebar: ["text", "text", "text", "text", "text"],
  "cards-section": ["subtitle", "cards"],
  heading: ["title"],
  cards: ["card", "card", "card", "card"],
  carousel: ["cards", "controls"],
  "carousel-with-title": ["title", "cards", "controls"],
  answers: ["text", "text", "text"],
  "text-page": [
    "title",
    "text",
    "text",
    "text",
    "text",
    "subtitle",
    "text",
    "text",
    "text",
    "text",
    "subtitle",
    "text",
    "text",
    "text",
    "text"
  ],
  "form-with-answers": [
    "question",
    "subtitle",
    "form",
    "answers",
    "answers",
    "answers",
    "answers",
    "answers"
  ],
  "general-website-page": ["banner", "text-page"],
  "overview-page": [
    "header",
    "sidebar",
    "title",
    "text",
    "cards-section",
    "cards-section",
    "footer"
  ],
  member: ["profile-picture", "text", "text"],
  "course-navigation": ["button", "button"],
  "course-lesson-page": ["breadcrumb", "course-navigation", "text-page"],
  "course-lesson-quiz": ["text-page", "quiz-box"]
}, l4 = (e, t) => e in sh ? /* @__PURE__ */ h.jsx("div", { className: e, children: sh[e].map((n, r) => l4(n, r)) }, t) : /* @__PURE__ */ h.jsx(Dr, { className: e }, t), vp = ({ layout: e = "overview-page", ...t }) => /* @__PURE__ */ h.jsx("div", { className: te("loading-state", e), ...t, children: sh[e].map((n, r) => l4(n, r)) }), u4 = (e) => {
  const t = e && e.toUpperCase().trim().split(" ");
  return Array.isArray(t) && t.length > 1 && t[0] !== "" ? t[1] === "" ? t[0][0] : t[0][0] + t[t.length - 1][0] : e ? e.substr(0, 1) : "";
}, Xl = ["#5AB6A3", "#A2D7AF", "#806056", "#3962B3"], K7 = (e) => {
  const t = Math.ceil(26 / Xl.length), n = u4(e).toLowerCase();
  if (n === "")
    return Xl[0];
  const r = n.charCodeAt(0) - 96;
  for (let i = 0; i < Xl.length; i++)
    if (r <= t * (i + 1))
      return Xl[i];
};
const F0 = 256, aa = ({
  className: e = "",
  src: t = "",
  name: n,
  alt: r,
  width: i = F0,
  height: a = F0,
  showInitials: s = !0,
  ...o
}) => {
  const [l, u] = de(!1), c = Ue(null), d = r ?? n;
  pe(() => {
    const p = c.current;
    if (!p)
      return;
    const g = p.getContext("2d");
    if (!g)
      return;
    const m = i, y = a;
    typeof window < "u" && window.devicePixelRatio && (p.width = m * window.devicePixelRatio, p.height = y * window.devicePixelRatio, g.scale(window.devicePixelRatio, window.devicePixelRatio)), g.fillStyle = K7(n), g.fillRect(0, 0, m, y), g.font = `${m / 3}px Arial`, g.textAlign = "center", g.fillStyle = "white", g.fillText(u4(n), m / 2, y / 1.6);
  }, [n]);
  let f = !1;
  return t && t !== "" && !l && (t.includes("http") || t.includes("//")) && (f = !0), /* @__PURE__ */ h.jsx(
    "figure",
    {
      className: te("profile-picture", e, { error: l }),
      ...o,
      children: f ? /* @__PURE__ */ h.jsx(
        "img",
        {
          src: t,
          alt: d,
          onError: () => {
            u(!0);
          },
          width: i,
          height: a
        }
      ) : s ? /* @__PURE__ */ h.jsx("canvas", { ref: c }) : /* @__PURE__ */ h.jsx("span", { className: "fallback" })
    }
  );
};
var rn = /* @__PURE__ */ ((e) => (e.DISCUSSION_FORM_SUBMITTED = "discussionFormSubmitted", e.DISCUSSION_POST_ADDED = "discussionPostAdded", e.DISCUSSION_POST_CLICKED = "discussionPostClicked", e.MEMBER_CLICKED = "memberClicked", e))(rn || {});
const yp = (e) => e === "apolitical" ? {
  image: `${_i}logos/member_apolitical.svg`
} : e === "community" || e === "deleted" || typeof e == "object" && !e.name ? {
  image: `${_i}logos/member_community.svg`
} : {
  name: e.name,
  role: e.jobTitle || "",
  organisation: e.organization || "",
  // TODO: See how we handle i18n for location here
  country: e.location && e.location.en || "",
  url: `/profiles/${e.id}`,
  image: e.image && e.image.thumbnail,
  badges: e.badges
}, G7 = ({
  role: e = "",
  organisation: t = "",
  country: n = "",
  maximumCharacters: r = 80
}) => {
  const i = e !== "", a = t !== "", s = n !== "";
  if (!i && !a && !s)
    return "";
  const o = `${e}${i && a ? ` — ${t}` : t}`;
  let l = `${o}${(i || a) && s ? `, ${n}` : n}`;
  return l.length > r && (l = o), l.length > r && (l = cl(l, r)), l;
};
const Y7 = Gs(() => Promise.resolve().then(() => u7)), Z7 = Gs(
  () => Promise.resolve().then(() => uie)
);
let Jl = null;
const ea = ({
  element: e = "div",
  member: t = "community",
  alt: n = "",
  additionalContent: r = !1,
  styling: i = {},
  functions: a = {},
  gtmContext: s = "member",
  gtmType: o = "member-click",
  className: l = "",
  badges: u,
  connection: c,
  ...d
}) => {
  var q, N, Q, J, D, C;
  const f = ye(), { profile: p, connections: g, ...m } = a, {
    size: y = "medium",
    variant: v = "inline",
    isCondensed: E = !0,
    additionalContentNewLine: b = !1
  } = i, _ = We(zt), T = p && _ && typeof _.id == "string", [x, A] = de(!1), R = yp(t);
  R.name || (R.name = f.formatMessage({
    id: `member_${typeof t == "string" ? t : "community"}`
  }));
  const { name: P, image: L } = R;
  let { url: I } = R;
  typeof t == "object" && t.link !== void 0 && (t.link === !1 ? I = void 0 : I = t.link);
  const O = G7(R), S = r && r.createdAt ? ih(r.createdAt) : !1, F = r && r.createdAt ? QE(r.createdAt) : "", H = !I && T;
  return M.createElement(e, {
    ...d,
    className: te("member text-medium", y, v, l, {
      "has-profile-link": T
    }),
    ...m,
    children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsxs(
        qa,
        {
          href: I,
          className: te({ "details-wrapper": H }),
          fallbackElement: H ? "div" : void 0,
          gtmType: o,
          gtmContext: s,
          meta: { forceOnClick: !0 },
          onClick: (Z) => {
            if (Z == null || Z.preventDefault(), Z == null || Z.stopPropagation(), !I) {
              H && A(!0);
              return;
            }
            Jl && clearTimeout(Jl), Jl = setTimeout(() => {
              window.location.href = I;
            }, 150);
            const B = new CustomEvent(rn.MEMBER_CLICKED, {
              detail: { link: I, timeout: Jl }
            });
            document.dispatchEvent(B);
          },
          children: [
            /* @__PURE__ */ h.jsx(aa, { name: P, src: L, alt: n }),
            /* @__PURE__ */ h.jsxs("div", { className: "details", children: [
              /* @__PURE__ */ h.jsxs(
                "div",
                {
                  className: te("name", { "new-line": b }),
                  "data-testid": "member-name",
                  children: [
                    /* @__PURE__ */ h.jsx("span", { children: P }),
                    (u == null ? void 0 : u.showBadges) && (R == null ? void 0 : R.badges) && /* @__PURE__ */ h.jsx($7, { userBadges: R.badges, badgeOptions: u }),
                    r && /* @__PURE__ */ h.jsxs(
                      "span",
                      {
                        className: te("additional-content", {
                          "new-line": b
                        }),
                        children: [
                          r.createdAt && S && !((q = r == null ? void 0 : r.customMessage) != null && q.text) && /* @__PURE__ */ h.jsx(
                            "span",
                            {
                              className: "date",
                              title: F,
                              "aria-label": F,
                              "data-testid": "date",
                              children: f.formatMessage(
                                { id: `dates_${S.path}` },
                                { number: S.number }
                              )
                            }
                          ),
                          r.createdAt && S && ((N = r == null ? void 0 : r.customMessage) == null ? void 0 : N.text) && /* @__PURE__ */ h.jsx("span", { children: f.formatMessage(
                            {
                              id: S.path === "now" ? (Q = r.customMessage) == null ? void 0 : Q.nowText : (J = r.customMessage) == null ? void 0 : J.text
                            },
                            {
                              time: f.formatMessage(
                                { id: `dates_${S.path}` },
                                { number: S.number }
                              ),
                              community: (C = (D = r.customMessage) == null ? void 0 : D.link) == null ? void 0 : C.text,
                              link: (Z) => {
                                var B, j;
                                return /* @__PURE__ */ h.jsx(
                                  "a",
                                  {
                                    href: `${(j = (B = r.customMessage) == null ? void 0 : B.link) == null ? void 0 : j.url}`,
                                    onClick: (z) => z.stopPropagation(),
                                    children: Z
                                  }
                                );
                              }
                            }
                          ) }),
                          r.didEdit && /* @__PURE__ */ h.jsx("em", { children: f.formatMessage({ id: "discussion_edited" }) })
                        ]
                      }
                    )
                  ]
                }
              ),
              O && !b && /* @__PURE__ */ h.jsx(
                "small",
                {
                  className: te({ "text-medium": y === "large" }),
                  "data-testid": "member-details",
                  children: E ? O : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
                    R.role,
                    R.organisation ? ` — ${R.organisation}` : /* @__PURE__ */ h.jsx(h.Fragment, {}),
                    /* @__PURE__ */ h.jsx("span", { className: "location", children: R.country })
                  ] })
                }
              )
            ] })
          ]
        }
      ),
      g && /* @__PURE__ */ h.jsx(z7, { connection: c, functions: g }),
      O && p && T ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        /* @__PURE__ */ h.jsx(
          je,
          {
            variant: "tertiary",
            size: "small",
            onClick: (Z) => {
              Z.preventDefault(), Z.stopPropagation(), A(!0);
            },
            "data-testid": "profile-button",
            children: f.formatMessage({ id: "member_profile" })
          }
        ),
        /* @__PURE__ */ h.jsx(Y7, { children: /* @__PURE__ */ h.jsx(
          Z7,
          {
            form: p,
            showModal: x,
            content: {
              title: f.formatMessage({ id: "member_profile" })
            },
            functions: {
              onClose: () => {
                A(!1);
              }
            },
            className: "in-portal"
          }
        ) })
      ] }) : /* @__PURE__ */ h.jsx(h.Fragment, {})
    ] })
  });
}, Q7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ea
}, Symbol.toStringTag, { value: "Module" }));
const B0 = {
  small: 24,
  medium: 48
}, c4 = ({
  element: e = "div",
  contributors: { total: t, data: n } = { total: void 0, data: [] },
  styling: { showText: r, size: i, showGap: a, showPlaceholders: s } = {
    showText: !0,
    size: "medium",
    showGap: !0,
    showPlaceholders: !1
  },
  cutoff: o = 2,
  multipleText: l,
  className: u = "",
  ...c
}) => {
  const d = ye();
  return !n || n.length === 0 ? null : M.createElement(e, {
    ...c,
    className: te("contributors", u, i, { "has-gap": a }),
    children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx("ul", { children: n.map((f, p) => {
        let g, m = "";
        if (p < o) {
          const { name: y = "", image: v = "" } = yp(f);
          if (s)
            return /* @__PURE__ */ h.jsx(Dr, { element: "li", className: "contributor" }, p);
          g = /* @__PURE__ */ h.jsx(
            aa,
            {
              name: y,
              src: v,
              width: B0[i || "medium"],
              height: B0[i || "medium"]
            }
          );
        } else if (p === o) {
          const y = (t || n.length) - o;
          g = /* @__PURE__ */ h.jsxs(
            "small",
            {
              className: te({ "large-number": y > 99 }),
              children: [
                "+",
                n7(y, 0)
              ]
            }
          ), m = "number-left";
        }
        return g ? /* @__PURE__ */ h.jsx("li", { className: te("contributor", m), children: g }, p) : null;
      }) }),
      r && /* @__PURE__ */ h.jsx("span", { className: "label", children: typeof r == "string" ? r : n.length === 1 ? typeof n[0] == "string" ? d.formatMessage({ id: `member_${n[0]}` }) : cl(n[0].name || "", 20) : l || null })
    ] })
  });
};
const d4 = ({
  element: e = "section",
  children: t,
  className: n,
  variant: r,
  additionalContent: i,
  ...a
}) => {
  let s = typeof t == "string" ? /* @__PURE__ */ h.jsx("p", { children: t }) : t;
  return i && (s = /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx("div", { className: "modal-content", children: typeof t == "string" ? /* @__PURE__ */ h.jsx("p", { children: t }) : t }),
    /* @__PURE__ */ h.jsx("div", { className: "modal-additional-content", children: typeof i == "string" ? /* @__PURE__ */ h.jsx("p", { children: i }) : i })
  ] })), M.createElement(e, {
    className: te("modal", n, {
      "success-section": r === "success"
    }),
    children: s,
    ...a
  });
};
var oh = { exports: {} }, eu = { exports: {} }, _t = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M0;
function X7() {
  if (M0)
    return _t;
  M0 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function b(T) {
    if (typeof T == "object" && T !== null) {
      var x = T.$$typeof;
      switch (x) {
        case t:
          switch (T = T.type, T) {
            case l:
            case u:
            case r:
            case a:
            case i:
            case d:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case o:
                case c:
                case g:
                case p:
                case s:
                  return T;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function _(T) {
    return b(T) === u;
  }
  return _t.AsyncMode = l, _t.ConcurrentMode = u, _t.ContextConsumer = o, _t.ContextProvider = s, _t.Element = t, _t.ForwardRef = c, _t.Fragment = r, _t.Lazy = g, _t.Memo = p, _t.Portal = n, _t.Profiler = a, _t.StrictMode = i, _t.Suspense = d, _t.isAsyncMode = function(T) {
    return _(T) || b(T) === l;
  }, _t.isConcurrentMode = _, _t.isContextConsumer = function(T) {
    return b(T) === o;
  }, _t.isContextProvider = function(T) {
    return b(T) === s;
  }, _t.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === t;
  }, _t.isForwardRef = function(T) {
    return b(T) === c;
  }, _t.isFragment = function(T) {
    return b(T) === r;
  }, _t.isLazy = function(T) {
    return b(T) === g;
  }, _t.isMemo = function(T) {
    return b(T) === p;
  }, _t.isPortal = function(T) {
    return b(T) === n;
  }, _t.isProfiler = function(T) {
    return b(T) === a;
  }, _t.isStrictMode = function(T) {
    return b(T) === i;
  }, _t.isSuspense = function(T) {
    return b(T) === d;
  }, _t.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === r || T === u || T === a || T === i || T === d || T === f || typeof T == "object" && T !== null && (T.$$typeof === g || T.$$typeof === p || T.$$typeof === s || T.$$typeof === o || T.$$typeof === c || T.$$typeof === y || T.$$typeof === v || T.$$typeof === E || T.$$typeof === m);
  }, _t.typeOf = b, _t;
}
var Ct = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L0;
function J7() {
  return L0 || (L0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function b(re) {
      return typeof re == "string" || typeof re == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      re === r || re === u || re === a || re === i || re === d || re === f || typeof re == "object" && re !== null && (re.$$typeof === g || re.$$typeof === p || re.$$typeof === s || re.$$typeof === o || re.$$typeof === c || re.$$typeof === y || re.$$typeof === v || re.$$typeof === E || re.$$typeof === m);
    }
    function _(re) {
      if (typeof re == "object" && re !== null) {
        var Ae = re.$$typeof;
        switch (Ae) {
          case t:
            var Oe = re.type;
            switch (Oe) {
              case l:
              case u:
              case r:
              case a:
              case i:
              case d:
                return Oe;
              default:
                var Ce = Oe && Oe.$$typeof;
                switch (Ce) {
                  case o:
                  case c:
                  case g:
                  case p:
                  case s:
                    return Ce;
                  default:
                    return Ae;
                }
            }
          case n:
            return Ae;
        }
      }
    }
    var T = l, x = u, A = o, R = s, P = t, L = c, I = r, O = g, S = p, F = n, H = a, q = i, N = d, Q = !1;
    function J(re) {
      return Q || (Q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), D(re) || _(re) === l;
    }
    function D(re) {
      return _(re) === u;
    }
    function C(re) {
      return _(re) === o;
    }
    function Z(re) {
      return _(re) === s;
    }
    function B(re) {
      return typeof re == "object" && re !== null && re.$$typeof === t;
    }
    function j(re) {
      return _(re) === c;
    }
    function z(re) {
      return _(re) === r;
    }
    function U(re) {
      return _(re) === g;
    }
    function $(re) {
      return _(re) === p;
    }
    function ae(re) {
      return _(re) === n;
    }
    function Y(re) {
      return _(re) === a;
    }
    function ee(re) {
      return _(re) === i;
    }
    function se(re) {
      return _(re) === d;
    }
    Ct.AsyncMode = T, Ct.ConcurrentMode = x, Ct.ContextConsumer = A, Ct.ContextProvider = R, Ct.Element = P, Ct.ForwardRef = L, Ct.Fragment = I, Ct.Lazy = O, Ct.Memo = S, Ct.Portal = F, Ct.Profiler = H, Ct.StrictMode = q, Ct.Suspense = N, Ct.isAsyncMode = J, Ct.isConcurrentMode = D, Ct.isContextConsumer = C, Ct.isContextProvider = Z, Ct.isElement = B, Ct.isForwardRef = j, Ct.isFragment = z, Ct.isLazy = U, Ct.isMemo = $, Ct.isPortal = ae, Ct.isProfiler = Y, Ct.isStrictMode = ee, Ct.isSuspense = se, Ct.isValidElementType = b, Ct.typeOf = _;
  }()), Ct;
}
var $0;
function Ep() {
  return $0 || ($0 = 1, process.env.NODE_ENV === "production" ? eu.exports = X7() : eu.exports = J7()), eu.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var G1, j0;
function ex() {
  if (j0)
    return G1;
  j0 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var s = {}, o = 0; o < 10; o++)
        s["_" + String.fromCharCode(o)] = o;
      var l = Object.getOwnPropertyNames(s).map(function(c) {
        return s[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return G1 = i() ? Object.assign : function(a, s) {
    for (var o, l = r(a), u, c = 1; c < arguments.length; c++) {
      o = Object(arguments[c]);
      for (var d in o)
        t.call(o, d) && (l[d] = o[d]);
      if (e) {
        u = e(o);
        for (var f = 0; f < u.length; f++)
          n.call(o, u[f]) && (l[u[f]] = o[u[f]]);
      }
    }
    return l;
  }, G1;
}
var Y1, H0;
function bp() {
  if (H0)
    return Y1;
  H0 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Y1 = e, Y1;
}
var Z1, U0;
function f4() {
  return U0 || (U0 = 1, Z1 = Function.call.bind(Object.prototype.hasOwnProperty)), Z1;
}
var Q1, z0;
function tx() {
  if (z0)
    return Q1;
  z0 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = bp(), n = {}, r = f4();
    e = function(a) {
      var s = "Warning: " + a;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(a, s, o, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in a)
        if (r(a, c)) {
          var d;
          try {
            if (typeof a[c] != "function") {
              var f = Error(
                (l || "React class") + ": " + o + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = a[c](s, c, l, o, null, t);
          } catch (g) {
            d = g;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + o + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var p = u ? u() : "";
            e(
              "Failed " + o + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Q1 = i, Q1;
}
var X1, q0;
function nx() {
  if (q0)
    return X1;
  q0 = 1;
  var e = Ep(), t = ex(), n = bp(), r = f4(), i = tx(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(o) {
    var l = "Warning: " + o;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return X1 = function(o, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(D) {
      var C = D && (u && D[u] || D[c]);
      if (typeof C == "function")
        return C;
    }
    var f = "<<anonymous>>", p = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: E(),
      arrayOf: b,
      element: _(),
      elementType: T(),
      instanceOf: x,
      node: L(),
      objectOf: R,
      oneOf: A,
      oneOfType: P,
      shape: O,
      exact: S
    };
    function g(D, C) {
      return D === C ? D !== 0 || 1 / D === 1 / C : D !== D && C !== C;
    }
    function m(D, C) {
      this.message = D, this.data = C && typeof C == "object" ? C : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function y(D) {
      if (process.env.NODE_ENV !== "production")
        var C = {}, Z = 0;
      function B(z, U, $, ae, Y, ee, se) {
        if (ae = ae || f, ee = ee || $, se !== n) {
          if (l) {
            var re = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw re.name = "Invariant Violation", re;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ae = ae + ":" + $;
            !C[Ae] && // Avoid spamming the console because they are often not actionable except for lib authors
            Z < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + ee + "` prop on `" + ae + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), C[Ae] = !0, Z++);
          }
        }
        return U[$] == null ? z ? U[$] === null ? new m("The " + Y + " `" + ee + "` is marked as required " + ("in `" + ae + "`, but its value is `null`.")) : new m("The " + Y + " `" + ee + "` is marked as required in " + ("`" + ae + "`, but its value is `undefined`.")) : null : D(U, $, ae, Y, ee);
      }
      var j = B.bind(null, !1);
      return j.isRequired = B.bind(null, !0), j;
    }
    function v(D) {
      function C(Z, B, j, z, U, $) {
        var ae = Z[B], Y = q(ae);
        if (Y !== D) {
          var ee = N(ae);
          return new m(
            "Invalid " + z + " `" + U + "` of type " + ("`" + ee + "` supplied to `" + j + "`, expected ") + ("`" + D + "`."),
            { expectedType: D }
          );
        }
        return null;
      }
      return y(C);
    }
    function E() {
      return y(s);
    }
    function b(D) {
      function C(Z, B, j, z, U) {
        if (typeof D != "function")
          return new m("Property `" + U + "` of component `" + j + "` has invalid PropType notation inside arrayOf.");
        var $ = Z[B];
        if (!Array.isArray($)) {
          var ae = q($);
          return new m("Invalid " + z + " `" + U + "` of type " + ("`" + ae + "` supplied to `" + j + "`, expected an array."));
        }
        for (var Y = 0; Y < $.length; Y++) {
          var ee = D($, Y, j, z, U + "[" + Y + "]", n);
          if (ee instanceof Error)
            return ee;
        }
        return null;
      }
      return y(C);
    }
    function _() {
      function D(C, Z, B, j, z) {
        var U = C[Z];
        if (!o(U)) {
          var $ = q(U);
          return new m("Invalid " + j + " `" + z + "` of type " + ("`" + $ + "` supplied to `" + B + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(D);
    }
    function T() {
      function D(C, Z, B, j, z) {
        var U = C[Z];
        if (!e.isValidElementType(U)) {
          var $ = q(U);
          return new m("Invalid " + j + " `" + z + "` of type " + ("`" + $ + "` supplied to `" + B + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(D);
    }
    function x(D) {
      function C(Z, B, j, z, U) {
        if (!(Z[B] instanceof D)) {
          var $ = D.name || f, ae = J(Z[B]);
          return new m("Invalid " + z + " `" + U + "` of type " + ("`" + ae + "` supplied to `" + j + "`, expected ") + ("instance of `" + $ + "`."));
        }
        return null;
      }
      return y(C);
    }
    function A(D) {
      if (!Array.isArray(D))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), s;
      function C(Z, B, j, z, U) {
        for (var $ = Z[B], ae = 0; ae < D.length; ae++)
          if (g($, D[ae]))
            return null;
        var Y = JSON.stringify(D, function(se, re) {
          var Ae = N(re);
          return Ae === "symbol" ? String(re) : re;
        });
        return new m("Invalid " + z + " `" + U + "` of value `" + String($) + "` " + ("supplied to `" + j + "`, expected one of " + Y + "."));
      }
      return y(C);
    }
    function R(D) {
      function C(Z, B, j, z, U) {
        if (typeof D != "function")
          return new m("Property `" + U + "` of component `" + j + "` has invalid PropType notation inside objectOf.");
        var $ = Z[B], ae = q($);
        if (ae !== "object")
          return new m("Invalid " + z + " `" + U + "` of type " + ("`" + ae + "` supplied to `" + j + "`, expected an object."));
        for (var Y in $)
          if (r($, Y)) {
            var ee = D($, Y, j, z, U + "." + Y, n);
            if (ee instanceof Error)
              return ee;
          }
        return null;
      }
      return y(C);
    }
    function P(D) {
      if (!Array.isArray(D))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var C = 0; C < D.length; C++) {
        var Z = D[C];
        if (typeof Z != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Q(Z) + " at index " + C + "."
          ), s;
      }
      function B(j, z, U, $, ae) {
        for (var Y = [], ee = 0; ee < D.length; ee++) {
          var se = D[ee], re = se(j, z, U, $, ae, n);
          if (re == null)
            return null;
          re.data && r(re.data, "expectedType") && Y.push(re.data.expectedType);
        }
        var Ae = Y.length > 0 ? ", expected one of type [" + Y.join(", ") + "]" : "";
        return new m("Invalid " + $ + " `" + ae + "` supplied to " + ("`" + U + "`" + Ae + "."));
      }
      return y(B);
    }
    function L() {
      function D(C, Z, B, j, z) {
        return F(C[Z]) ? null : new m("Invalid " + j + " `" + z + "` supplied to " + ("`" + B + "`, expected a ReactNode."));
      }
      return y(D);
    }
    function I(D, C, Z, B, j) {
      return new m(
        (D || "React class") + ": " + C + " type `" + Z + "." + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + j + "`."
      );
    }
    function O(D) {
      function C(Z, B, j, z, U) {
        var $ = Z[B], ae = q($);
        if (ae !== "object")
          return new m("Invalid " + z + " `" + U + "` of type `" + ae + "` " + ("supplied to `" + j + "`, expected `object`."));
        for (var Y in D) {
          var ee = D[Y];
          if (typeof ee != "function")
            return I(j, z, U, Y, N(ee));
          var se = ee($, Y, j, z, U + "." + Y, n);
          if (se)
            return se;
        }
        return null;
      }
      return y(C);
    }
    function S(D) {
      function C(Z, B, j, z, U) {
        var $ = Z[B], ae = q($);
        if (ae !== "object")
          return new m("Invalid " + z + " `" + U + "` of type `" + ae + "` " + ("supplied to `" + j + "`, expected `object`."));
        var Y = t({}, Z[B], D);
        for (var ee in Y) {
          var se = D[ee];
          if (r(D, ee) && typeof se != "function")
            return I(j, z, U, ee, N(se));
          if (!se)
            return new m(
              "Invalid " + z + " `" + U + "` key `" + ee + "` supplied to `" + j + "`.\nBad object: " + JSON.stringify(Z[B], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(D), null, "  ")
            );
          var re = se($, ee, j, z, U + "." + ee, n);
          if (re)
            return re;
        }
        return null;
      }
      return y(C);
    }
    function F(D) {
      switch (typeof D) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !D;
        case "object":
          if (Array.isArray(D))
            return D.every(F);
          if (D === null || o(D))
            return !0;
          var C = d(D);
          if (C) {
            var Z = C.call(D), B;
            if (C !== D.entries) {
              for (; !(B = Z.next()).done; )
                if (!F(B.value))
                  return !1;
            } else
              for (; !(B = Z.next()).done; ) {
                var j = B.value;
                if (j && !F(j[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function H(D, C) {
      return D === "symbol" ? !0 : C ? C["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && C instanceof Symbol : !1;
    }
    function q(D) {
      var C = typeof D;
      return Array.isArray(D) ? "array" : D instanceof RegExp ? "object" : H(C, D) ? "symbol" : C;
    }
    function N(D) {
      if (typeof D > "u" || D === null)
        return "" + D;
      var C = q(D);
      if (C === "object") {
        if (D instanceof Date)
          return "date";
        if (D instanceof RegExp)
          return "regexp";
      }
      return C;
    }
    function Q(D) {
      var C = N(D);
      switch (C) {
        case "array":
        case "object":
          return "an " + C;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + C;
        default:
          return C;
      }
    }
    function J(D) {
      return !D.constructor || !D.constructor.name ? f : D.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, X1;
}
var J1, W0;
function rx() {
  if (W0)
    return J1;
  W0 = 1;
  var e = bp();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, J1 = function() {
    function r(s, o, l, u, c, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, J1;
}
if (process.env.NODE_ENV !== "production") {
  var ix = Ep(), ax = !0;
  oh.exports = nx()(ix.isElement, ax);
} else
  oh.exports = rx()();
var h4 = oh.exports;
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var p4 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Oc = /* @__PURE__ */ p4.join(","), m4 = typeof Element > "u", Ba = m4 ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Nc = !m4 && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Ic = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), a = i === "" || i === "true", s = a || n && t && e(t.parentNode);
  return s;
}, sx = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, g4 = function(t, n, r) {
  if (Ic(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(Oc));
  return n && Ba.call(t, Oc) && i.unshift(t), i = i.filter(r), i;
}, v4 = function e(t, n, r) {
  for (var i = [], a = Array.from(t); a.length; ) {
    var s = a.shift();
    if (!Ic(s, !1))
      if (s.tagName === "SLOT") {
        var o = s.assignedElements(), l = o.length ? o : s.children, u = e(l, !0, r);
        r.flatten ? i.push.apply(i, u) : i.push({
          scopeParent: s,
          candidates: u
        });
      } else {
        var c = Ba.call(s, Oc);
        c && r.filter(s) && (n || !t.includes(s)) && i.push(s);
        var d = s.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(s), f = !Ic(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(s));
        if (d && f) {
          var p = e(d === !0 ? s.children : d.children, !0, r);
          r.flatten ? i.push.apply(i, p) : i.push({
            scopeParent: s,
            candidates: p
          });
        } else
          a.unshift.apply(a, s.children);
      }
  }
  return i;
}, y4 = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Yi = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || sx(t)) && !y4(t) ? 0 : t.tabIndex;
}, ox = function(t, n) {
  var r = Yi(t);
  return r < 0 && n && !y4(t) ? 0 : r;
}, lx = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, E4 = function(t) {
  return t.tagName === "INPUT";
}, ux = function(t) {
  return E4(t) && t.type === "hidden";
}, cx = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, dx = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, fx = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Nc(t), r = function(o) {
    return n.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(t.name));
  else
    try {
      i = r(t.name);
    } catch (s) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
    }
  var a = dx(i, t.form);
  return !a || a === t;
}, hx = function(t) {
  return E4(t) && t.type === "radio";
}, px = function(t) {
  return hx(t) && !fx(t);
}, mx = function(t) {
  var n, r = t && Nc(t), i = (n = r) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (r && r !== t) {
    var s, o, l;
    for (a = !!((s = i) !== null && s !== void 0 && (o = s.ownerDocument) !== null && o !== void 0 && o.contains(i) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !a && i; ) {
      var u, c, d;
      r = Nc(i), i = (u = r) === null || u === void 0 ? void 0 : u.host, a = !!((c = i) !== null && c !== void 0 && (d = c.ownerDocument) !== null && d !== void 0 && d.contains(i));
    }
  }
  return a;
}, V0 = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, gx = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = Ba.call(t, "details>summary:first-of-type"), s = a ? t.parentElement : t;
  if (Ba.call(s, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var o = t; t; ) {
        var l = t.parentElement, u = Nc(t);
        if (l && !l.shadowRoot && i(l) === !0)
          return V0(t);
        t.assignedSlot ? t = t.assignedSlot : !l && u !== t.ownerDocument ? t = u.host : t = l;
      }
      t = o;
    }
    if (mx(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return V0(t);
  return !1;
}, vx = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return Ba.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Pc = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Ic(n) || ux(n) || gx(n, t) || // For a details element with a summary, the summary element gets the focus
  cx(n) || vx(n));
}, lh = function(t, n) {
  return !(px(n) || Yi(n) < 0 || !Pc(t, n));
}, yx = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Ex = function e(t) {
  var n = [], r = [];
  return t.forEach(function(i, a) {
    var s = !!i.scopeParent, o = s ? i.scopeParent : i, l = ox(o, s), u = s ? e(i.candidates) : o;
    l === 0 ? s ? n.push.apply(n, u) : n.push(o) : r.push({
      documentOrder: a,
      tabIndex: l,
      item: i,
      isScope: s,
      content: u
    });
  }), r.sort(lx).reduce(function(i, a) {
    return a.isScope ? i.push.apply(i, a.content) : i.push(a.content), i;
  }, []).concat(n);
}, b4 = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = v4([t], n.includeContainer, {
    filter: lh.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: yx
  }) : r = g4(t, n.includeContainer, lh.bind(null, n)), Ex(r);
}, T4 = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = v4([t], n.includeContainer, {
    filter: Pc.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = g4(t, n.includeContainer, Pc.bind(null, n)), r;
}, xa = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ba.call(t, Oc) === !1 ? !1 : lh(n, t);
}, bx = /* @__PURE__ */ p4.concat("iframe").join(","), sc = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ba.call(t, bx) === !1 ? !1 : Pc(n, t);
};
const Tx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  focusable: T4,
  getTabIndex: Yi,
  isFocusable: sc,
  isTabbable: xa,
  tabbable: b4
}, Symbol.toStringTag, { value: "Module" }));
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function K0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function G0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? K0(Object(n), !0).forEach(function(r) {
      _x(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : K0(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _x(e, t, n) {
  return t = xx(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Cx(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function xx(e) {
  var t = Cx(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Y0 = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var r = t[t.length - 1];
      r !== n && r.pause();
    }
    var i = t.indexOf(n);
    i === -1 || t.splice(i, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), t.length > 0 && t[t.length - 1].unpause();
  }
}, wx = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Ax = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, Ho = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, Sx = function(t) {
  return Ho(t) && !t.shiftKey;
}, kx = function(t) {
  return Ho(t) && t.shiftKey;
}, Z0 = function(t) {
  return setTimeout(t, 0);
}, Q0 = function(t, n) {
  var r = -1;
  return t.every(function(i, a) {
    return n(i) ? (r = a, !1) : !0;
  }), r;
}, lo = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, tu = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Dx = [], Ox = function(t, n) {
  var r = (n == null ? void 0 : n.document) || document, i = (n == null ? void 0 : n.trapStack) || Dx, a = G0({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Sx,
    isKeyBackward: kx
  }, n), s = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, o, l = function(O, S, F) {
    return O && O[S] !== void 0 ? O[S] : a[F || S];
  }, u = function(O, S) {
    var F = typeof (S == null ? void 0 : S.composedPath) == "function" ? S.composedPath() : void 0;
    return s.containerGroups.findIndex(function(H) {
      var q = H.container, N = H.tabbableNodes;
      return q.contains(O) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (F == null ? void 0 : F.includes(q)) || N.find(function(Q) {
        return Q === O;
      });
    });
  }, c = function(O) {
    var S = a[O];
    if (typeof S == "function") {
      for (var F = arguments.length, H = new Array(F > 1 ? F - 1 : 0), q = 1; q < F; q++)
        H[q - 1] = arguments[q];
      S = S.apply(void 0, H);
    }
    if (S === !0 && (S = void 0), !S) {
      if (S === void 0 || S === !1)
        return S;
      throw new Error("`".concat(O, "` was specified but was not a node, or did not return a node"));
    }
    var N = S;
    if (typeof S == "string" && (N = r.querySelector(S), !N))
      throw new Error("`".concat(O, "` as selector refers to no known node"));
    return N;
  }, d = function() {
    var O = c("initialFocus");
    if (O === !1)
      return !1;
    if (O === void 0 || !sc(O, a.tabbableOptions))
      if (u(r.activeElement) >= 0)
        O = r.activeElement;
      else {
        var S = s.tabbableGroups[0], F = S && S.firstTabbableNode;
        O = F || c("fallbackFocus");
      }
    if (!O)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return O;
  }, f = function() {
    if (s.containerGroups = s.containers.map(function(O) {
      var S = b4(O, a.tabbableOptions), F = T4(O, a.tabbableOptions), H = S.length > 0 ? S[0] : void 0, q = S.length > 0 ? S[S.length - 1] : void 0, N = F.find(function(D) {
        return xa(D);
      }), Q = F.slice().reverse().find(function(D) {
        return xa(D);
      }), J = !!S.find(function(D) {
        return Yi(D) > 0;
      });
      return {
        container: O,
        tabbableNodes: S,
        focusableNodes: F,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: J,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: H,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: q,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: N,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: Q,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(C) {
          var Z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, B = S.indexOf(C);
          return B < 0 ? Z ? F.slice(F.indexOf(C) + 1).find(function(j) {
            return xa(j);
          }) : F.slice(0, F.indexOf(C)).reverse().find(function(j) {
            return xa(j);
          }) : S[B + (Z ? 1 : -1)];
        }
      };
    }), s.tabbableGroups = s.containerGroups.filter(function(O) {
      return O.tabbableNodes.length > 0;
    }), s.tabbableGroups.length <= 0 && !c("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (s.containerGroups.find(function(O) {
      return O.posTabIndexesFound;
    }) && s.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, p = function I(O) {
    var S = O.activeElement;
    if (S)
      return S.shadowRoot && S.shadowRoot.activeElement !== null ? I(S.shadowRoot) : S;
  }, g = function I(O) {
    if (O !== !1 && O !== p(document)) {
      if (!O || !O.focus) {
        I(d());
        return;
      }
      O.focus({
        preventScroll: !!a.preventScroll
      }), s.mostRecentlyFocusedNode = O, wx(O) && O.select();
    }
  }, m = function(O) {
    var S = c("setReturnFocus", O);
    return S || (S === !1 ? !1 : O);
  }, y = function(O) {
    var S = O.target, F = O.event, H = O.isBackward, q = H === void 0 ? !1 : H;
    S = S || tu(F), f();
    var N = null;
    if (s.tabbableGroups.length > 0) {
      var Q = u(S, F), J = Q >= 0 ? s.containerGroups[Q] : void 0;
      if (Q < 0)
        q ? N = s.tabbableGroups[s.tabbableGroups.length - 1].lastTabbableNode : N = s.tabbableGroups[0].firstTabbableNode;
      else if (q) {
        var D = Q0(s.tabbableGroups, function(U) {
          var $ = U.firstTabbableNode;
          return S === $;
        });
        if (D < 0 && (J.container === S || sc(S, a.tabbableOptions) && !xa(S, a.tabbableOptions) && !J.nextTabbableNode(S, !1)) && (D = Q), D >= 0) {
          var C = D === 0 ? s.tabbableGroups.length - 1 : D - 1, Z = s.tabbableGroups[C];
          N = Yi(S) >= 0 ? Z.lastTabbableNode : Z.lastDomTabbableNode;
        } else
          Ho(F) || (N = J.nextTabbableNode(S, !1));
      } else {
        var B = Q0(s.tabbableGroups, function(U) {
          var $ = U.lastTabbableNode;
          return S === $;
        });
        if (B < 0 && (J.container === S || sc(S, a.tabbableOptions) && !xa(S, a.tabbableOptions) && !J.nextTabbableNode(S)) && (B = Q), B >= 0) {
          var j = B === s.tabbableGroups.length - 1 ? 0 : B + 1, z = s.tabbableGroups[j];
          N = Yi(S) >= 0 ? z.firstTabbableNode : z.firstDomTabbableNode;
        } else
          Ho(F) || (N = J.nextTabbableNode(S));
      }
    } else
      N = c("fallbackFocus");
    return N;
  }, v = function(O) {
    var S = tu(O);
    if (!(u(S, O) >= 0)) {
      if (lo(a.clickOutsideDeactivates, O)) {
        o.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: a.returnFocusOnDeactivate
        });
        return;
      }
      lo(a.allowOutsideClick, O) || O.preventDefault();
    }
  }, E = function(O) {
    var S = tu(O), F = u(S, O) >= 0;
    if (F || S instanceof Document)
      F && (s.mostRecentlyFocusedNode = S);
    else {
      O.stopImmediatePropagation();
      var H, q = !0;
      if (s.mostRecentlyFocusedNode)
        if (Yi(s.mostRecentlyFocusedNode) > 0) {
          var N = u(s.mostRecentlyFocusedNode), Q = s.containerGroups[N].tabbableNodes;
          if (Q.length > 0) {
            var J = Q.findIndex(function(D) {
              return D === s.mostRecentlyFocusedNode;
            });
            J >= 0 && (a.isKeyForward(s.recentNavEvent) ? J + 1 < Q.length && (H = Q[J + 1], q = !1) : J - 1 >= 0 && (H = Q[J - 1], q = !1));
          }
        } else
          s.containerGroups.some(function(D) {
            return D.tabbableNodes.some(function(C) {
              return Yi(C) > 0;
            });
          }) || (q = !1);
      else
        q = !1;
      q && (H = y({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: s.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(s.recentNavEvent)
      })), g(H || s.mostRecentlyFocusedNode || d());
    }
    s.recentNavEvent = void 0;
  }, b = function(O) {
    var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    s.recentNavEvent = O;
    var F = y({
      event: O,
      isBackward: S
    });
    F && (Ho(O) && O.preventDefault(), g(F));
  }, _ = function(O) {
    if (Ax(O) && lo(a.escapeDeactivates, O) !== !1) {
      O.preventDefault(), o.deactivate();
      return;
    }
    (a.isKeyForward(O) || a.isKeyBackward(O)) && b(O, a.isKeyBackward(O));
  }, T = function(O) {
    var S = tu(O);
    u(S, O) >= 0 || lo(a.clickOutsideDeactivates, O) || lo(a.allowOutsideClick, O) || (O.preventDefault(), O.stopImmediatePropagation());
  }, x = function() {
    if (s.active)
      return Y0.activateTrap(i, o), s.delayInitialFocusTimer = a.delayInitialFocus ? Z0(function() {
        g(d());
      }) : g(d()), r.addEventListener("focusin", E, !0), r.addEventListener("mousedown", v, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", v, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", T, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", _, {
        capture: !0,
        passive: !1
      }), o;
  }, A = function() {
    if (s.active)
      return r.removeEventListener("focusin", E, !0), r.removeEventListener("mousedown", v, !0), r.removeEventListener("touchstart", v, !0), r.removeEventListener("click", T, !0), r.removeEventListener("keydown", _, !0), o;
  }, R = function(O) {
    var S = O.some(function(F) {
      var H = Array.from(F.removedNodes);
      return H.some(function(q) {
        return q === s.mostRecentlyFocusedNode;
      });
    });
    S && g(d());
  }, P = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(R) : void 0, L = function() {
    P && (P.disconnect(), s.active && !s.paused && s.containers.map(function(O) {
      P.observe(O, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return o = {
    get active() {
      return s.active;
    },
    get paused() {
      return s.paused;
    },
    activate: function(O) {
      if (s.active)
        return this;
      var S = l(O, "onActivate"), F = l(O, "onPostActivate"), H = l(O, "checkCanFocusTrap");
      H || f(), s.active = !0, s.paused = !1, s.nodeFocusedBeforeActivation = r.activeElement, S == null || S();
      var q = function() {
        H && f(), x(), L(), F == null || F();
      };
      return H ? (H(s.containers.concat()).then(q, q), this) : (q(), this);
    },
    deactivate: function(O) {
      if (!s.active)
        return this;
      var S = G0({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, O);
      clearTimeout(s.delayInitialFocusTimer), s.delayInitialFocusTimer = void 0, A(), s.active = !1, s.paused = !1, L(), Y0.deactivateTrap(i, o);
      var F = l(S, "onDeactivate"), H = l(S, "onPostDeactivate"), q = l(S, "checkCanReturnFocus"), N = l(S, "returnFocus", "returnFocusOnDeactivate");
      F == null || F();
      var Q = function() {
        Z0(function() {
          N && g(m(s.nodeFocusedBeforeActivation)), H == null || H();
        });
      };
      return N && q ? (q(m(s.nodeFocusedBeforeActivation)).then(Q, Q), this) : (Q(), this);
    },
    pause: function(O) {
      if (s.paused || !s.active)
        return this;
      var S = l(O, "onPause"), F = l(O, "onPostPause");
      return s.paused = !0, S == null || S(), A(), L(), F == null || F(), this;
    },
    unpause: function(O) {
      if (!s.paused || !s.active)
        return this;
      var S = l(O, "onUnpause"), F = l(O, "onPostUnpause");
      return s.paused = !1, S == null || S(), f(), x(), L(), F == null || F(), this;
    },
    updateContainerElements: function(O) {
      var S = [].concat(O).filter(Boolean);
      return s.containers = S.map(function(F) {
        return typeof F == "string" ? r.querySelector(F) : F;
      }), s.active && f(), L(), this;
    }
  }, o.updateContainerElements(t), o;
};
const Nx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFocusTrap: Ox
}, Symbol.toStringTag, { value: "Module" })), Ix = /* @__PURE__ */ zE(Nx), Px = /* @__PURE__ */ zE(Tx);
function Bs(e) {
  "@babel/helpers - typeof";
  return Bs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Bs(e);
}
function Rx(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function X0(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _4(r.key), r);
  }
}
function Fx(e, t, n) {
  return t && X0(e.prototype, t), n && X0(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Bx(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && uh(e, t);
}
function uh(e, t) {
  return uh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, uh(e, t);
}
function Mx(e) {
  var t = $x();
  return function() {
    var r = Rc(e), i;
    if (t) {
      var a = Rc(this).constructor;
      i = Reflect.construct(r, arguments, a);
    } else
      i = r.apply(this, arguments);
    return Lx(this, i);
  };
}
function Lx(e, t) {
  if (t && (Bs(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Po(e);
}
function Po(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $x() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Rc(e) {
  return Rc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Rc(e);
}
function jx(e, t, n) {
  return t = _4(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function _4(e) {
  var t = Hx(e, "string");
  return Bs(t) === "symbol" ? t : String(t);
}
function Hx(e, t) {
  if (Bs(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Bs(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var nu = M, He = h4, Ux = Ix, zx = Ux.createFocusTrap, qx = Px, Wx = qx.isFocusable, Tp = /* @__PURE__ */ function(e) {
  Bx(n, e);
  var t = Mx(n);
  function n(r) {
    var i;
    Rx(this, n), i = t.call(this, r), jx(Po(i), "getNodeForOption", function(o) {
      var l, u = (l = this.internalOptions[o]) !== null && l !== void 0 ? l : this.originalOptions[o];
      if (typeof u == "function") {
        for (var c = arguments.length, d = new Array(c > 1 ? c - 1 : 0), f = 1; f < c; f++)
          d[f - 1] = arguments[f];
        u = u.apply(void 0, d);
      }
      if (u === !0 && (u = void 0), !u) {
        if (u === void 0 || u === !1)
          return u;
        throw new Error("`".concat(o, "` was specified but was not a node, or did not return a node"));
      }
      var p = u;
      if (typeof u == "string") {
        var g;
        if (p = (g = this.getDocument()) === null || g === void 0 ? void 0 : g.querySelector(u), !p)
          throw new Error("`".concat(o, "` as selector refers to no known node"));
      }
      return p;
    }), i.handleDeactivate = i.handleDeactivate.bind(Po(i)), i.handlePostDeactivate = i.handlePostDeactivate.bind(Po(i)), i.handleClickOutsideDeactivates = i.handleClickOutsideDeactivates.bind(Po(i)), i.internalOptions = {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      returnFocusOnDeactivate: !1,
      // the rest of these are also related to deactivation of the trap, and we
      //  need to use them and control them as well
      checkCanReturnFocus: null,
      onDeactivate: i.handleDeactivate,
      onPostDeactivate: i.handlePostDeactivate,
      // we need to special-case this setting as well so that we can know if we should
      //  NOT return focus if the trap gets auto-deactivated as the result of an
      //  outside click (otherwise, we'll always think we should return focus because
      //  of how we manage that flag internally here)
      clickOutsideDeactivates: i.handleClickOutsideDeactivates
    }, i.originalOptions = {
      // because of the above `internalOptions`, we maintain our own flag for
      //  this option, and default it to `true` because that's focus-trap's default
      returnFocusOnDeactivate: !0,
      // because of the above `internalOptions`, we keep these separate since
      //  they're part of the deactivation process which we configure (internally) to
      //  be shared between focus-trap and focus-trap-react
      onDeactivate: null,
      onPostDeactivate: null,
      checkCanReturnFocus: null,
      // the user's setting, defaulted to false since focus-trap defaults this to false
      clickOutsideDeactivates: !1
    };
    var a = r.focusTrapOptions;
    for (var s in a)
      if (Object.prototype.hasOwnProperty.call(a, s)) {
        if (s === "returnFocusOnDeactivate" || s === "onDeactivate" || s === "onPostDeactivate" || s === "checkCanReturnFocus" || s === "clickOutsideDeactivates") {
          i.originalOptions[s] = a[s];
          continue;
        }
        i.internalOptions[s] = a[s];
      }
    return i.outsideClick = null, i.focusTrapElements = r.containerElements || [], i.updatePreviousElement(), i;
  }
  return Fx(n, [{
    key: "getDocument",
    value: function() {
      return this.props.focusTrapOptions.document || (typeof document < "u" ? document : void 0);
    }
  }, {
    key: "getReturnFocusNode",
    value: function() {
      var i = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
      return i || (i === !1 ? !1 : this.previouslyFocusedElement);
    }
    /** Update the previously focused element with the currently focused element. */
  }, {
    key: "updatePreviousElement",
    value: function() {
      var i = this.getDocument();
      i && (this.previouslyFocusedElement = i.activeElement);
    }
  }, {
    key: "deactivateTrap",
    value: function() {
      !this.focusTrap || !this.focusTrap.active || this.focusTrap.deactivate({
        // NOTE: we never let the trap return the focus since we do that ourselves
        returnFocus: !1,
        // we'll call this in our own post deactivate handler so make sure the trap doesn't
        //  do it prematurely
        checkCanReturnFocus: null,
        // let it call the user's original deactivate handler, if any, instead of
        //  our own which calls back into this function
        onDeactivate: this.originalOptions.onDeactivate
        // NOTE: for post deactivate, don't specify anything so that it calls the
        //  onPostDeactivate handler specified on `this.internalOptions`
        //  which will always be our own `handlePostDeactivate()` handler, which
        //  will finish things off by calling the user's provided onPostDeactivate
        //  handler, if any, at the right time
        // onPostDeactivate: NOTHING
      });
    }
  }, {
    key: "handleClickOutsideDeactivates",
    value: function(i) {
      var a = typeof this.originalOptions.clickOutsideDeactivates == "function" ? this.originalOptions.clickOutsideDeactivates.call(null, i) : this.originalOptions.clickOutsideDeactivates;
      return a && (this.outsideClick = {
        target: i.target,
        allowDeactivation: a
      }), a;
    }
  }, {
    key: "handleDeactivate",
    value: function() {
      this.originalOptions.onDeactivate && this.originalOptions.onDeactivate.call(null), this.deactivateTrap();
    }
  }, {
    key: "handlePostDeactivate",
    value: function() {
      var i = this, a = function() {
        var o = i.getReturnFocusNode(), l = !!// did the consumer allow it?
        (i.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
        o !== null && o !== void 0 && o.focus && // was there an outside click that allowed deactivation?
        (!i.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
        i.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
        //  as a result of the click-through) -- in which case do NOT restore focus
        //  to `returnFocusNode` because focus should remain on the outside node
        !Wx(i.outsideClick.target, i.internalOptions.tabbableOptions))), u = i.internalOptions.preventScroll, c = u === void 0 ? !1 : u;
        l && o.focus({
          preventScroll: c
        }), i.originalOptions.onPostDeactivate && i.originalOptions.onPostDeactivate.call(null), i.outsideClick = null;
      };
      this.originalOptions.checkCanReturnFocus ? this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()).then(a, a) : a();
    }
  }, {
    key: "setupFocusTrap",
    value: function() {
      if (this.focusTrap)
        this.props.active && !this.focusTrap.active && (this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
      else {
        var i = this.focusTrapElements.some(Boolean);
        i && (this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
      }
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.props.active && this.setupFocusTrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      if (this.focusTrap) {
        i.containerElements !== this.props.containerElements && this.focusTrap.updateContainerElements(this.props.containerElements);
        var a = !i.active && this.props.active, s = i.active && !this.props.active, o = !i.paused && this.props.paused, l = i.paused && !this.props.paused;
        if (a && (this.updatePreviousElement(), this.focusTrap.activate()), s) {
          this.deactivateTrap();
          return;
        }
        o && this.focusTrap.pause(), l && this.focusTrap.unpause();
      } else
        i.containerElements !== this.props.containerElements && (this.focusTrapElements = this.props.containerElements), this.props.active && (this.updatePreviousElement(), this.setupFocusTrap());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.deactivateTrap();
    }
  }, {
    key: "render",
    value: function() {
      var i = this, a = this.props.children ? nu.Children.only(this.props.children) : void 0;
      if (a) {
        if (a.type && a.type === nu.Fragment)
          throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
        var s = function(u) {
          var c = i.props.containerElements;
          a && (typeof a.ref == "function" ? a.ref(u) : a.ref && (a.ref.current = u)), i.focusTrapElements = c || [u];
        }, o = nu.cloneElement(a, {
          ref: s
        });
        return o;
      }
      return null;
    }
  }]), n;
}(nu.Component), uo = typeof Element > "u" ? Function : Element;
Tp.propTypes = {
  active: He.bool,
  paused: He.bool,
  focusTrapOptions: He.shape({
    document: He.object,
    onActivate: He.func,
    onPostActivate: He.func,
    checkCanFocusTrap: He.func,
    onPause: He.func,
    onPostPause: He.func,
    onUnpause: He.func,
    onPostUnpause: He.func,
    onDeactivate: He.func,
    onPostDeactivate: He.func,
    checkCanReturnFocus: He.func,
    initialFocus: He.oneOfType([He.instanceOf(uo), He.string, He.bool, He.func]),
    fallbackFocus: He.oneOfType([
      He.instanceOf(uo),
      He.string,
      // NOTE: does not support `false` as value (or return value from function)
      He.func
    ]),
    escapeDeactivates: He.oneOfType([He.bool, He.func]),
    clickOutsideDeactivates: He.oneOfType([He.bool, He.func]),
    returnFocusOnDeactivate: He.bool,
    setReturnFocus: He.oneOfType([He.instanceOf(uo), He.string, He.bool, He.func]),
    allowOutsideClick: He.oneOfType([He.bool, He.func]),
    preventScroll: He.bool,
    tabbableOptions: He.shape({
      displayCheck: He.oneOf(["full", "legacy-full", "non-zero-area", "none"]),
      getShadowRoot: He.oneOfType([He.bool, He.func])
    }),
    trapStack: He.array,
    isKeyForward: He.func,
    isKeyBackward: He.func
  }),
  containerElements: He.arrayOf(He.instanceOf(uo)),
  // DOM element ONLY
  children: He.oneOfType([
    He.element,
    // React element
    He.instanceOf(uo)
    // DOM element
  ])
  // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
  //  specify it here. It's expected to be set to the function returned from
  //  require('focus-trap'), or one with a compatible interface.
};
Tp.defaultProps = {
  active: !0,
  paused: !1,
  focusTrapOptions: {},
  _createFocusTrap: zx
};
var Vx = Tp;
const Kx = /* @__PURE__ */ Or(Vx);
const sa = ({
  id: e = "content-overlay",
  isOpen: t = !1,
  showDivider: n = !0,
  maxWidth: r,
  functions: { onOpen: i = () => {
  }, onClose: a = () => {
  } } = {},
  forceShow: { error: s = !1 } = {},
  title: o,
  children: l,
  buttons: u,
  className: c = "",
  gtmContext: d = "Modal"
}) => {
  const f = ye(), { registerOverlay: p, unregisterOverlay: g } = O7(), [m, y] = de(t), [v, E] = de(null), b = Ue(null), _ = (P) => {
    m && P.key === "Escape" && A(!1);
  }, T = (P) => {
    E(P.target);
  }, x = (P) => {
    v === b.current && P.target === b.current && A(!1), E(null);
  };
  pe(() => {
    if (m)
      return window.addEventListener("keyup", _), () => {
        window.removeEventListener("keyup", _);
      };
  }, [m]), pe(() => {
    const P = b.current;
    return P && (P.addEventListener("mousedown", T), P.addEventListener("mouseup", x)), () => {
      P && (P.removeEventListener("mousedown", T), P.removeEventListener("mouseup", x));
    };
  }, [v]);
  const A = (P) => {
    if (y(P), P)
      i(), p(e);
    else {
      if (m === P)
        return;
      a(), g(e);
    }
  };
  pe(() => (A(t), () => {
    m && g(e);
  }), [t]);
  const R = r ? { "--max-width": `${r / 16}rem` } : {};
  return /* @__PURE__ */ h.jsx(
    "div",
    {
      id: `${e}-overlay`,
      ref: b,
      className: te("overlay", {
        open: m,
        "in-portal": c.includes("in-portal")
      }),
      role: "dialog",
      children: /* @__PURE__ */ h.jsx(
        d4,
        {
          id: e,
          className: te("overlay-modal", c, {
            "has-max-width": r
          }),
          hidden: !m,
          style: R,
          children: t && /* @__PURE__ */ h.jsx(Kx, { containerElements: [b.current], children: /* @__PURE__ */ h.jsxs("div", { className: "overlay-content", children: [
            /* @__PURE__ */ h.jsxs("div", { className: "top", children: [
              o && /* @__PURE__ */ h.jsx("h2", { className: "modal-title", children: o }),
              /* @__PURE__ */ h.jsx(
                je,
                {
                  variant: "tertiary",
                  size: "medium",
                  icon: { icon: "close" },
                  onClick: () => A(!1),
                  className: "gtm-trackable",
                  "data-gtm-event-type": "close-modal-click",
                  "data-gtm-event-context": d,
                  screenreaderText: f.formatMessage({ id: "overlay_close" })
                }
              )
            ] }),
            n && /* @__PURE__ */ h.jsx(Zr, {}),
            l,
            u && /* @__PURE__ */ h.jsxs("div", { className: "bottom", children: [
              /* @__PURE__ */ h.jsx(Zr, {}),
              /* @__PURE__ */ h.jsx(Il, { buttons: u })
            ] }),
            s && /* @__PURE__ */ h.jsx(pl, { className: "error", children: s })
          ] }) })
        }
      )
    }
  );
}, Gx = (e, t) => ({
  "aria-haspopup": !0,
  "aria-expanded": t,
  "aria-controls": e
});
const Mi = "joinCommunityButton", C4 = ({
  isMember: e = !1,
  isOpen: t = !1,
  isShort: n = !1,
  disabled: r = !1,
  functions: { join: i, leave: a } = { join: () => {
  }, leave: () => {
  } }
}) => {
  const s = ye(), o = We(zt), l = o && typeof o.id == "string", u = r || !l, [c, d] = de(e), [f, p] = de(e ? "joined" : "notJoined"), [g, m] = de(!1), y = Ue(null);
  return pe(() => {
    f === "joining" ? p("joined") : f === "leaving" && p("notJoined");
  }, [c]), pe(() => {
    const v = (E) => {
      y.current && !y.current.contains(E.target) && m(!1);
    };
    return g && document.addEventListener("mousedown", v), () => {
      document.removeEventListener("mousedown", v);
    };
  }, [g]), /* @__PURE__ */ h.jsxs("div", { className: "root", children: [
    /* @__PURE__ */ h.jsx(
      je,
      {
        variant: c ? "secondary" : "primary",
        size: "medium",
        styling: { fullWidth: !0 },
        icon: c && f !== "leaving" ? { icon: "tick", position: "left" } : !1,
        tooltip: !t && !c ? s.formatMessage({ id: `${Mi}_closed_tooltip` }) : "",
        onClick: async (v) => {
          if (u)
            return;
          if (v.currentTarget.blur(), c) {
            m(!0);
            return;
          }
          p("joining");
          const E = new CustomEvent("ariaLive", {
            detail: {
              message: s.formatMessage(
                { id: `${Mi}_aria_live` },
                { action: "joining" }
              )
            }
          });
          document.dispatchEvent(E);
          const b = i;
          typeof b == "function" && setTimeout(async () => {
            await b();
          }, 500), d(!0);
        },
        className: te("join-community-button", f, {
          active: f === "joining"
        }),
        disabled: u,
        "data-testid": "join-button",
        "aria-label": c ? s.formatMessage({ id: `${Mi}_options_menu` }) : s.formatMessage({ id: `${Mi}` }),
        children: /* @__PURE__ */ h.jsx("span", { className: "text", "aria-hidden": "true", children: s.formatMessage({
          id: `${Mi}${["joining", "leaving"].includes(f) ? `_${f}` : c ? "_member" : n ? "_short" : ""}`
        }) })
      }
    ),
    g ? /* @__PURE__ */ h.jsx("div", { className: "leave-button-overlay", tabIndex: 0, children: /* @__PURE__ */ h.jsx("div", { className: "leave-button-container", ref: y, children: /* @__PURE__ */ h.jsx(
      je,
      {
        "data-testid": "leave-button",
        className: "leave-community-button",
        variant: "tertiary",
        size: "medium",
        onClick: async (v) => {
          if (u)
            return;
          p("leaving");
          const E = new CustomEvent("ariaLive", {
            detail: {
              message: s.formatMessage(
                { id: `${Mi}_aria_live` },
                { action: "leaving" }
              )
            }
          });
          document.dispatchEvent(E);
          const b = a;
          typeof b == "function" && setTimeout(async () => {
            await b();
          }, 500), d(!1), m(!1);
        },
        "aria-label": s.formatMessage({ id: `${Mi}_member_aria` }),
        children: s.formatMessage({ id: `${Mi}_member_aria` })
      }
    ) }) }) : null
  ] });
};
const ed = "communityDetails_", Zie = ({
  className: e = "",
  isMember: t = !1,
  isOpen: n = !1,
  slug: r,
  members: { number: i = 0, data: a = [] } = { number: 0, data: [] },
  functions: { invite: s, ...o }
}) => {
  const l = ye(), { id: u } = We(zt), c = u, d = 5, f = i || a.length, p = a.length ? a : Array(d).fill({}), g = `/communities/${r}/members` === window.location.pathname, m = t || n, y = !n && !t;
  return /* @__PURE__ */ h.jsxs("div", { className: te("community-details", e), children: [
    m ? /* @__PURE__ */ h.jsxs("div", { className: "member-details", children: [
      /* @__PURE__ */ h.jsxs("div", { className: "top", children: [
        /* @__PURE__ */ h.jsxs("h4", { children: [
          l.formatMessage({ id: `${ed}members` }),
          /* @__PURE__ */ h.jsx("span", { className: "count", children: f })
        ] }),
        g ? /* @__PURE__ */ h.jsx(h.Fragment, {}) : /* @__PURE__ */ h.jsx("p", { className: "text-small", children: /* @__PURE__ */ h.jsx("a", { href: `/communities/${r}/members`, children: l.formatMessage({ id: `${ed}viewAll` }) }) })
      ] }),
      c && /* @__PURE__ */ h.jsx(
        c4,
        {
          contributors: {
            total: i,
            data: p
          },
          styling: {
            size: "medium",
            showGap: !0,
            showPlaceholders: f === 0
          },
          cutoff: d
        }
      )
    ] }) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
    c ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx(
        C4,
        {
          isMember: t,
          isOpen: n,
          disabled: y,
          functions: { ...o }
        }
      ),
      t && /* @__PURE__ */ h.jsx(
        je,
        {
          variant: "primary",
          onClick: s,
          icon: { icon: "plus" },
          styling: { fullWidth: !0 },
          children: l.formatMessage({ id: `${ed}invite` })
        }
      )
    ] }) : /* @__PURE__ */ h.jsx(h.Fragment, {})
  ] });
};
const Uo = ({
  icon: e,
  className: t = "",
  children: n,
  shortText: r,
  ...i
}) => {
  const a = {};
  return r && (a["data-short-text"] = r), /* @__PURE__ */ h.jsx(
    je,
    {
      className: te("action-button", t),
      variant: "tertiary",
      size: { mobile: "small", 769: "medium" },
      icon: e,
      ...i,
      ...a,
      children: /* @__PURE__ */ h.jsx("span", { className: "inner-text", children: n })
    }
  );
}, Yx = "reply", ta = "00000000-0000-0000-0000-000000000000", Ms = "en";
function _p({ queryClient: e, queryKey: t }) {
  function n(r, i, a) {
    e.setQueryData(t, a);
  }
  return n;
}
function Cp({ queryClient: e, queryKey: t }) {
  async function n(r) {
    await e.cancelQueries({ queryKey: t });
    const i = e.getQueryData(t);
    return e.setQueryData(t, r), i;
  }
  return n;
}
var Rl = /* @__PURE__ */ ((e) => (e.Post = "post", e.Poll = "poll", e))(Rl || {});
const On = "poll-vote", x4 = (e, t = "en") => {
  var r;
  return e.verb !== Rl.Poll ? [] : (((r = e == null ? void 0 : e.latest_reactions) == null ? void 0 : r["poll-option"]) || []).map((i) => {
    var o, l, u, c, d;
    const a = ((o = i == null ? void 0 : i.own_children) == null ? void 0 : o["poll-vote"]) || [], s = ((l = i.data) == null ? void 0 : l.description) || {
      [t]: ""
    };
    return {
      id: i.id,
      label: s[t],
      numVotes: ((u = i == null ? void 0 : i.children_counts) == null ? void 0 : u["poll-vote"]) || 0,
      hasUserVoted: a.length > 0,
      userVote: { id: (c = a[0]) == null ? void 0 : c.id },
      position: ((d = i.data) == null ? void 0 : d.position) || 0
    };
  }).sort((i, a) => i.position - a.position);
};
function w4({ activity: e, reactionId: t, user: n }) {
  var a;
  const r = n == null ? void 0 : n.id;
  if (!r)
    return;
  const i = (a = e.latest_reactions) == null ? void 0 : a["poll-option"];
  if (i) {
    for (const s of i)
      if (s.id === t) {
        const o = {
          id: ta,
          activity_id: e.id,
          kind: On,
          data: {},
          created_at: (/* @__PURE__ */ new Date()).toISOString(),
          updated_at: (/* @__PURE__ */ new Date()).toISOString(),
          user_id: r,
          parent: s.id,
          latest_children: {},
          own_children: {},
          children_counts: {}
        };
        s.latest_children = s.latest_children || {}, s.latest_children[On] = s.latest_children[On] || [], s.latest_children[On].push(o), s.own_children = s.own_children || {}, s.own_children[On] = s.own_children[On] || [], s.own_children[On].push(o), s.children_counts = s.children_counts || {}, s.children_counts[On] = (s.children_counts[On] || 0) + 1;
        break;
      }
  }
}
function A4({
  activity: e,
  reactionId: t,
  correctReactionId: n,
  user: r
}) {
  var i;
  (i = e.latest_reactions) == null || i["poll-option"].forEach((a) => {
    var s;
    a.id === t && (a.latest_children[On].forEach((o) => {
      o.id === ta && o.user_id === (r == null ? void 0 : r.id) && (o.id = n);
    }), (s = a.own_children) == null || s[On].forEach((o) => {
      o.id === ta && o.user_id === (r == null ? void 0 : r.id) && (o.id = n);
    }));
  });
}
function S4({ activity: e, reactionId: t }) {
  var r, i, a;
  const n = (r = e.latest_reactions) == null ? void 0 : r["poll-option"];
  if (n)
    for (const s of n) {
      const o = (i = s.own_children) == null ? void 0 : i[On], l = (a = s.latest_children) == null ? void 0 : a[On];
      if (l) {
        const u = l.findIndex((c) => c.id === t);
        u !== -1 && (l.splice(u, 1), s.children_counts[On]--);
      }
      if (o) {
        const u = o.findIndex((c) => c.id === t);
        u !== -1 && o.splice(u, 1);
      }
    }
}
function Zx({ id: e, position: t, description: n }, r) {
  if (r != null && r.id)
    return {
      created_at: (/* @__PURE__ */ new Date()).toISOString(),
      updated_at: (/* @__PURE__ */ new Date()).toISOString(),
      id: e || ta,
      kind: "poll-option",
      data: {
        description: n,
        position: t
      },
      parent: ""
    };
}
function Qx() {
  return {
    latest_reactions: {
      like: [],
      reply: [],
      "poll-option": []
    },
    reaction_counts: {
      like: 0,
      reply: 0,
      "poll-option": 0
    },
    own_reactions: {
      like: [],
      reply: [],
      "poll-option": []
    }
  };
}
function Xx() {
  return {
    latest_children: {
      like: [],
      reply: []
    },
    children_counts: {
      like: 0,
      reply: 0
    },
    own_children: {
      like: [],
      reply: []
    }
  };
}
function Jx(e, t) {
  const n = e.map((r) => Zx(r, t));
  return {
    latest_reactions: {
      like: [],
      reply: [],
      "poll-option": n
    },
    reaction_counts: {
      like: 0,
      reply: 0,
      "poll-option": 0
    },
    own_reactions: {
      like: [],
      reply: [],
      "poll-option": []
    }
  };
}
function xp(e) {
  const { id: t = "", name: n = "", organization: r = "", jobTitle: i = "", image: a = {} } = e, { thumbnail: s = "" } = a;
  return {
    id: t,
    data: {
      name: n,
      organization: r,
      jobTitle: i,
      thumbnail: s
    }
  };
}
const J0 = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => n.includes("Id") ? t[n] = e[n] : t[`${n}Slug`] = e[n]), t;
}, Fl = (e) => {
  var t, n, r, i, a, s;
  return e && !e.error ? {
    id: e == null ? void 0 : e.id,
    name: (t = e == null ? void 0 : e.data) == null ? void 0 : t.name,
    organization: (n = e == null ? void 0 : e.data) == null ? void 0 : n.organization,
    jobTitle: (r = e == null ? void 0 : e.data) == null ? void 0 : r.jobTitle,
    location: (i = e == null ? void 0 : e.data) == null ? void 0 : i.location,
    image: {
      thumbnail: ((a = e == null ? void 0 : e.data) == null ? void 0 : a.thumbnail) || void 0
    },
    badges: (s = e == null ? void 0 : e.data) == null ? void 0 : s.badges
  } : "deleted";
};
function e6({ title: e, content: t, categories: n }) {
  const r = [];
  return n && !["no-category", ""].includes(n) && r.push(n), {
    title: e,
    content: t,
    categories: r,
    id: ta,
    time: (/* @__PURE__ */ new Date()).toISOString(),
    verb: Rl.Post
  };
}
function eg({
  title: e,
  options: t,
  settings: n,
  user: r,
  correctActivityId: i
}) {
  return {
    title: e,
    content: "",
    id: i || ta,
    time: (/* @__PURE__ */ new Date()).toISOString(),
    verb: Rl.Poll
  };
}
function tg({ activity: e, user: t }) {
  return {
    ...e,
    actor: xp(t),
    ...Qx()
  };
}
function ng({ activity: e, options: t, user: n }) {
  return {
    ...e,
    actor: xp(n),
    ...Jx(t, n)
  };
}
function Fc({
  activity: e,
  reaction: t
}) {
  var n, r, i;
  t ? (e.latest_reactions = {
    ...e.latest_reactions || {},
    like: [...((r = e.latest_reactions) == null ? void 0 : r.like) || [], t]
  }, e.own_reactions = {
    ...e.own_reactions || {},
    like: [...((i = e.own_reactions) == null ? void 0 : i.like) || [], t]
  }) : e.reaction_counts = {
    ...e.reaction_counts || {},
    like: (n = e.reaction_counts) != null && n.like ? e.reaction_counts.like + 1 : 1
  };
}
function k4({ activity: e, user: t }) {
  var n, r, i;
  e.reaction_counts = {
    ...e.reaction_counts || {},
    like: (n = e.reaction_counts) != null && n.like ? e.reaction_counts.like - 1 : 0
  }, t != null && t.id && (e.latest_reactions = {
    ...e.latest_reactions || {},
    like: (((r = e.latest_reactions) == null ? void 0 : r.like) || []).filter(
      ({ user_id: a }) => a !== t.id
    )
  }, e.own_reactions = {
    ...e.own_reactions || {},
    like: (((i = e.own_reactions) == null ? void 0 : i.like) || []).filter(
      ({ user_id: a }) => a !== t.id
    )
  });
}
function Bc({
  activity: e,
  reaction: t
}) {
  var n, r, i;
  t ? (e.latest_reactions = {
    ...e.latest_reactions || {},
    pin: [...((r = e.latest_reactions) == null ? void 0 : r.pin) || [], t]
  }, e.own_reactions = {
    ...e.own_reactions || {},
    pin: [...((i = e.own_reactions) == null ? void 0 : i.pin) || [], t]
  }) : e.reaction_counts = {
    ...e.reaction_counts || {},
    pin: (n = e.reaction_counts) != null && n.pin ? e.reaction_counts.pin + 1 : 1
  };
}
function D4({ activity: e }) {
  var t;
  e.reaction_counts = {
    ...e.reaction_counts || {},
    pin: (t = e.reaction_counts) != null && t.pin ? e.reaction_counts.pin - 1 : 0
  }, e.latest_reactions = {
    ...e.latest_reactions || {},
    pin: []
  }, e.own_reactions = {
    ...e.own_reactions || {},
    pin: []
  };
}
const t6 = (e, t) => {
  var E, b, _;
  const {
    actor: n,
    title: r,
    verb: i,
    content: a,
    time: s,
    id: o,
    own_reactions: l,
    latest_reactions: u,
    reaction_counts: c,
    mentioned_users: d,
    total_replies: f,
    additional_data: p,
    settings: g
  } = e, m = (((E = u == null ? void 0 : u.like) == null ? void 0 : E.length) || 0) > 0, y = (((b = l == null ? void 0 : l.like) == null ? void 0 : b.length) || 0) > 0, v = m ? (_ = u == null ? void 0 : u.like) == null ? void 0 : _.map((T) => {
    var x, A, R;
    return {
      id: (x = T == null ? void 0 : T.user) == null ? void 0 : x.id,
      name: (R = (A = T == null ? void 0 : T.user) == null ? void 0 : A.data) == null ? void 0 : R.name
    };
  }) : !1;
  return {
    id: o,
    title: r,
    author: Fl(n),
    body: a,
    type: i,
    // getstream returns UTC but doesn't include the Z needed to parse it correctly
    // https://getstream.io/activity-feeds/docs/node/adding_activities/#adding-activities-basic
    createdAt: s + "Z",
    slug: o,
    slugs: {},
    userLiked: y,
    likes: (c == null ? void 0 : c.like) || 0,
    comments: f || 0,
    peopleWhoLiked: v,
    data: { mentions: d, ...p || {} },
    pinned: (c == null ? void 0 : c.pin) && (c == null ? void 0 : c.pin) > 0 || !1,
    categories: ZC(
      (e == null ? void 0 : e.categories) || [],
      t || []
    ),
    pollOptions: x4(e, "en"),
    pollSettings: {
      showRemoveVote: g == null ? void 0 : g.show_remove_vote,
      allowMultipleVotes: g == null ? void 0 : g.allow_multiple_votes,
      deadlineAt: g == null ? void 0 : g.deadline_at,
      hideParticipants: g == null ? void 0 : g.hide_participants,
      numberOfWinners: g == null ? void 0 : g.number_of_winners,
      resultsVisibility: g == null ? void 0 : g.results_visibility
    }
  };
};
function n6(e) {
  return {
    pages: [
      {
        next: "",
        results: [e]
      }
    ],
    pageParams: [""]
  };
}
function r6(e, t, n) {
  const r = t.pages.length - 1, i = t.pages[r].results.length - 1;
  return n != null && n.replace ? t.pages[r].results[i] = e : t.pages[r].results.push(e), t;
}
function i6(e, t, n) {
  return n != null && n.replace ? t.pages[0].results[0] = e : t.pages[0].results = [e, ...t.pages[0].results], t;
}
function Ls(e, t, n) {
  return t ? n != null && n.append ? r6(e, t, n) : i6(e, t, n) : n6(e);
}
function Mn(e, t) {
  if (t)
    for (const { results: n } of t.pages) {
      const r = n.find(({ id: i }) => i === e);
      if (r)
        return r;
    }
}
function O4(e, t) {
  for (const { results: n } of t.pages) {
    const r = n.findIndex(({ id: i }) => i === e);
    if (r !== -1) {
      n.splice(r, 1);
      break;
    }
  }
  return t;
}
function wp(e) {
  var t;
  return ((t = e == null ? void 0 : e.pages) == null ? void 0 : t.reduce(
    (n, r) => [...n, ...r == null ? void 0 : r.results],
    []
  )) || [];
}
function a6({ activityId: e, replyId: t, content: n }) {
  return {
    activity_id: e,
    data: {
      content: n
    },
    id: ta,
    kind: Yx,
    parent: t || ""
  };
}
function rg({ reply: e, user: t }) {
  const n = xp(t);
  return {
    ...e,
    user_id: n.id,
    user: n,
    ...Xx()
  };
}
function ig({ reply: e, reaction: t }) {
  var n, r, i;
  t ? (e.latest_children = {
    ...e.latest_children || {},
    like: [...((r = e.latest_children) == null ? void 0 : r.like) || [], t]
  }, e.own_children = {
    ...e.own_children || {},
    like: [...((i = e.own_children) == null ? void 0 : i.like) || [], t]
  }) : e.children_counts = {
    ...e.children_counts || {},
    like: (n = e.children_counts) != null && n.like ? e.children_counts.like + 1 : 1
  };
}
function s6({ reply: e, user: t }) {
  var n, r, i;
  e.children_counts = {
    ...e.children_counts || {},
    like: (n = e.children_counts) != null && n.like ? e.children_counts.like - 1 : 0
  }, t != null && t.id && (e.latest_children = {
    ...e.latest_children || {},
    like: (((r = e.latest_children) == null ? void 0 : r.like) || []).filter(
      ({ user_id: a }) => a !== t.id
    )
  }, e.own_children = {
    ...e.own_children || {},
    like: (((i = e.own_children) == null ? void 0 : i.like) || []).filter(({ user_id: a }) => a !== t.id)
  });
}
const Ap = (e, t) => {
  const n = new CustomEvent(rn.DISCUSSION_POST_ADDED, {
    detail: { id: e, type: t }
  });
  document.dispatchEvent(n);
}, o6 = ({
  content: e,
  locale: t
}) => e[t] || e[Ms], l6 = ({
  content: e
}) => e.original;
let ag, td = 0;
const N4 = () => {
  pe(() => (document.addEventListener(
    rn.DISCUSSION_POST_ADDED,
    e
  ), () => {
    document.removeEventListener(
      rn.DISCUSSION_POST_ADDED,
      e
    );
  }), []);
  const e = (t) => {
    const { id: n, type: r } = t.detail;
    if (!n || !r || r === "activity")
      return;
    clearTimeout(ag);
    const i = document.getElementById(n);
    if (i) {
      i.scrollIntoView({ behavior: "smooth", block: "start" }), td = 0;
      return;
    }
    td++, !(td > 10) && (ag = setTimeout(() => {
      e(t);
    }, 50));
  };
};
var Kt = /* @__PURE__ */ ((e) => (e.Communities = "communities", e.Courses = "courses", e))(Kt || {}), et = /* @__PURE__ */ ((e) => (e.Answer = "answer", e.Poll = "poll", e.Post = "post", e.Response = "response", e.Reply = "reply", e.Question = "question", e))(et || {});
const $s = Object.freeze({
  id: "some-user-id-1",
  name: "some user name 1",
  organization: "some user organization 1",
  jobTitle: "some user job title 1",
  image: {
    thumbnail: "https://some-user-thumbnail.com/avatar1.png"
  },
  isLoading: !1
}), Qr = Object.freeze({
  id: "some-user-id-2",
  name: "some user name 2",
  organization: "some user organization 2",
  jobTitle: "some user job title 2",
  image: {
    thumbnail: "https://some-user-thumbnail.com/avatar2.png"
  },
  isLoading: !1
}), Sp = Object.freeze({
  actor: `SU:${$s.id}`,
  content: "some content 1",
  duration: "5.53ms",
  feed_id: "some-feed-id-1",
  foreign_id: "post:some-foriegn-id-1",
  id: "some-activity-id-1",
  object: "comment",
  time: "2023-11-24T17:52:36.162000",
  verb: "post"
}), u6 = Object.freeze({
  actor: `SU:${Qr.id}`,
  content: "some content 2",
  duration: "5.53ms",
  feed_id: "some-feed-id-2",
  foreign_id: "post:some-foriegn-id-2",
  id: "some-activity-id-2",
  object: "comment",
  time: "2023-11-24T17:54:36.162000",
  verb: "post"
}), c6 = Object.freeze({
  actor: `SU:${$s.id}`,
  content: "some content 3",
  duration: "5.53ms",
  feed_id: "some-feed-id-3",
  foreign_id: "post:some-foriegn-id-3",
  id: "some-activity-id-3",
  object: "comment",
  time: "2023-11-24T17:56:36.162000",
  verb: "post"
}), d6 = Object.freeze({
  actor: `SU:${Qr.id}`,
  content: "some content 4",
  duration: "5.53ms",
  feed_id: "some-feed-id-4",
  foreign_id: "post:some-foriegn-id-4",
  id: "some-activity-id-4",
  object: "comment",
  time: "2023-11-24T17:54:36.162000",
  verb: "post"
});
Object.freeze({
  id: "some-reaction-id-1",
  activity_id: Sp.id,
  kind: "like",
  created_at: "2023-11-24T17:58:36.162000",
  data: {},
  parent: "",
  updated_at: "2023-11-24T17:58:36.162000",
  user_id: Qr.id,
  children_counts: {},
  latest_children: {},
  latest_children_extra: {},
  own_children: {},
  user: {
    id: Qr.id,
    data: {},
    created_at: "2023-11-24T17:58:36.162000",
    updated_at: "2023-11-24T17:58:36.162000"
  }
});
Object.freeze({
  id: "some-reaction-id-1",
  activity_id: Sp.id,
  kind: "pin",
  created_at: "2023-11-24T17:58:36.162000",
  data: {},
  parent: "",
  updated_at: "2023-11-24T17:58:36.162000",
  user_id: Qr.id,
  children_counts: {},
  latest_children: {},
  latest_children_extra: {},
  own_children: {},
  user: {
    id: Qr.id,
    data: {},
    created_at: "2023-11-24T17:58:36.162000",
    updated_at: "2023-11-24T17:58:36.162000"
  }
});
Object.freeze({
  created_at: "2023-12-03T21:53:45.999851Z",
  updated_at: "2023-12-03T21:53:45.999851Z",
  id: "some-reply-id-1",
  user_id: Qr.id,
  user: {
    id: Qr.id,
    data: {},
    created_at: "2023-08-31T07:11:38.677184Z",
    updated_at: "2023-08-31T07:11:38.677184Z"
  },
  kind: "reply",
  activity_id: Sp.id,
  data: {
    content: "Some content 1..."
  },
  parent: "",
  latest_children: {},
  children_counts: {}
});
Object.freeze({
  created_at: "2023-12-03T21:53:45.999851Z",
  updated_at: "2023-12-03T21:53:45.999851Z",
  id: "some-reply-id-2",
  user_id: $s.id,
  user: {
    id: $s.id,
    data: {},
    created_at: "2023-08-31T07:11:38.677184Z",
    updated_at: "2023-08-31T07:11:38.677184Z"
  },
  kind: "reply",
  activity_id: u6.id,
  data: {
    content: "Some content 2..."
  },
  parent: "",
  latest_children: {},
  children_counts: {}
});
Object.freeze({
  created_at: "2023-12-03T21:53:45.999851Z",
  updated_at: "2023-12-03T21:53:45.999851Z",
  id: "some-reply-id-3",
  user_id: Qr.id,
  user: {
    id: Qr.id,
    data: {},
    created_at: "2023-08-31T07:11:38.677184Z",
    updated_at: "2023-08-31T07:11:38.677184Z"
  },
  kind: "reply",
  activity_id: c6.id,
  data: {
    content: "Some content 3..."
  },
  parent: "",
  latest_children: {},
  children_counts: {}
});
Object.freeze({
  created_at: "2023-12-03T21:53:45.999851Z",
  updated_at: "2023-12-03T21:53:45.999851Z",
  id: "some-reply-id-3",
  user_id: $s.id,
  user: {
    id: $s.id,
    data: {},
    created_at: "2023-08-31T07:11:38.677184Z",
    updated_at: "2023-08-31T07:11:38.677184Z"
  },
  kind: "reply",
  activity_id: d6.id,
  data: {
    content: "Some content 4..."
  },
  parent: "",
  latest_children: {},
  children_counts: {}
});
const f6 = ({
  question: e,
  answer: t,
  reply: n
}) => ({
  ...e && { questionSlug: e },
  ...t && { answerSlug: t },
  ...n && { replySlug: n }
}), h6 = (e, t = 10) => !e || e.length === 0 ? [] : e.slice(0, t);
function p6(e) {
  return ft(
    (t) => {
      var s, o, l, u;
      if (!t || !["ArrowUp", "ArrowDown"].includes(t.key || ""))
        return;
      t.stopPropagation(), t.preventDefault();
      const n = t.key === "ArrowUp" ? "up" : "down", r = (s = t.currentTarget) == null ? void 0 : s.parentElement;
      let i = r == null ? void 0 : r.nextElementSibling;
      if (n === "up") {
        const c = r == null ? void 0 : r.previousElementSibling;
        c ? i = c : (i = (o = r == null ? void 0 : r.parentElement) == null ? void 0 : o.lastElementChild, (i == null ? void 0 : i.getAttribute("data-index")) === "-1" && (i = i == null ? void 0 : i.previousElementSibling));
      } else
        (!i || (i == null ? void 0 : i.getAttribute("data-index")) === "-1") && (i = (l = r == null ? void 0 : r.parentElement) == null ? void 0 : l.firstElementChild);
      if (!i)
        return;
      const a = Number((i == null ? void 0 : i.getAttribute("data-index")) || "0");
      e([{ type: "tabbableLink", value: a }]), (u = i == null ? void 0 : i.querySelector("a,button")) == null || u.focus();
    },
    [e]
  );
}
const m6 = Gs(() => Promise.resolve().then(() => HR));
let zo = !1;
const nd = () => {
  zo !== !1 && (clearTimeout(zo), zo = !1);
}, g6 = 5;
let rd = null;
const v6 = ({
  element: e = "div",
  likes: t = 0,
  peopleWhoLiked: n = !1,
  isShort: r = !0,
  userLiked: i = !1,
  content: a = { type: et.Reply, slugs: {} },
  canLike: s = !0,
  activityId: o,
  basePath: l,
  parentId: u,
  functions: {
    createLike: c = () => {
    },
    deleteLike: d = () => {
    },
    listLikes: f = async () => ({ next: "", results: [] })
  }
}) => {
  const p = ye(), g = {
    numberOfLikes: t,
    userLikedContent: i,
    ignoreInteractions: !1,
    showLikers: !1,
    tabbableLink: 0,
    showLikesModal: !1
  }, [m, y] = ra(Nl, g), {
    numberOfLikes: v,
    userLikedContent: E,
    ignoreInteractions: b,
    showLikers: _,
    tabbableLink: T,
    showLikesModal: x
  } = m, A = p6(y);
  pe(() => {
    y([{ type: "userLikedContent", value: i }]);
  }, [i]);
  const R = Vn(
    () => h6(n, g6),
    [n]
  ), P = (S) => {
    if (S.preventDefault(), S.stopPropagation(), y([{ type: "showLikers", value: !1 }]), zo)
      return nd(), !1;
    if (nd(), b || !s)
      return !1;
    zo = setTimeout(L, 350);
  }, L = async () => {
    if (nd(), b || !s)
      return !1;
    let S = E ? v - 1 : v + 1;
    S < 0 && (S = 0), y([
      { type: "ignoreInteractions", value: !0 },
      { type: "numberOfLikes", value: S },
      { type: "userLikedContent", value: !E }
    ]);
    try {
      if (a && a.slugs) {
        const F = f6(a.slugs);
        E ? await d(F) : await c({
          ...F,
          payload: { contentPath: window.location.pathname }
        });
      }
    } catch {
      y([
        { type: "numberOfLikes", value: t },
        { type: "userLikedContent", value: i }
      ]);
    } finally {
      y([{ type: "ignoreInteractions", value: !1 }]);
    }
  }, I = () => {
    rd = setTimeout(() => {
      y([{ type: "showLikers", value: !1 }]);
    }, 500);
  }, O = () => {
    rd && clearTimeout(rd);
  };
  return M.createElement(
    e,
    {
      className: "likes-wrapper",
      onKeyDown: (S) => {
        S.key === "Escape" && y([{ type: "showLikers", value: !1 }]);
      },
      onMouseEnter: () => {
        O(), y([{ type: "showLikers", value: !0 }]);
      },
      onMouseLeave: () => {
        I();
      }
    },
    /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx(
        Uo,
        {
          className: te(
            "discussion-button text-medium action-button likes-button",
            {
              "show-spinner": b,
              "is-liked": E,
              disabled: !s
            }
          ),
          icon: {
            icon: E ? "heart" : "heart_empty",
            animate: "bounce"
          },
          shortText: `${v}`,
          disabled: !s,
          "data-testid": "like-button",
          "data-gtm-event-context": "Likes",
          "data-gtm-event-type": `like-${a.type}-click`,
          onClick: P,
          screenreaderText: s ? p.formatMessage(
            {
              id: `discussion_likes_${E ? "unlike" : "like"}`
            },
            {
              action: p.formatMessage({
                id: `discussion_action_${a.type}`
              })
            }
          ) : !1,
          "aria-pressed": E,
          children: /* @__PURE__ */ h.jsx("span", { "data-testid": "number-of-likes", className: "number-of-likes", children: p.formatMessage(
            { id: `discussion_likes${r ? "_short" : ""}` },
            { number: v }
          ) })
        }
      ),
      n && /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        /* @__PURE__ */ h.jsx(
          ht,
          {
            "data-testid": "like-a11y-button",
            element: "button",
            className: "tertiary small icon navigation_arrow",
            onFocus: () => {
              O();
            },
            onBlur: () => I,
            onClick: (S) => {
              var H;
              S.preventDefault(), S.stopPropagation(), O(), y([{ type: "showLikers", value: !0 }]);
              const F = (H = S.currentTarget.nextSibling) == null ? void 0 : H.childNodes[0];
              if (F) {
                const q = F.querySelector(
                  "li:first-child a"
                );
                q && (y([{ type: "tabbableLink", value: 0 }]), setTimeout(() => {
                  q.focus();
                }, 100));
              }
            },
            onKeyDown: (S) => {
              S.key === "Escape" && (S.preventDefault(), S.stopPropagation(), I());
            },
            "aria-expanded": _,
            "aria-controls": `likes-tooltip-${a.slug}`,
            children: /* @__PURE__ */ h.jsx(ht, { showOnFocus: !1, children: p.formatMessage(
              { id: "discussion_likes_show" },
              { action: a.type }
            ) })
          }
        ),
        /* @__PURE__ */ h.jsx(
          Ys,
          {
            id: `likes-tooltip-${a.slug}`,
            isOpen: _,
            isLoading: n.length === 0,
            children: n.length && /* @__PURE__ */ h.jsxs("ul", { children: [
              R.map((S, F) => {
                if (typeof S == "string")
                  return null;
                const H = {};
                return T !== F && (H.tabIndex = -1), /* @__PURE__ */ h.jsx(
                  "li",
                  {
                    "data-index": F,
                    children: /* @__PURE__ */ h.jsx(
                      qa,
                      {
                        href: S.id ? `/profiles/${S.id}` : void 0,
                        gtmContext: "Likes",
                        gtmType: "liked-name-click",
                        onFocus: () => O(),
                        onKeyDown: A,
                        ...H,
                        children: S.name ? S.name : /* @__PURE__ */ h.jsx("span", { className: "deleted-user", children: p.formatMessage({ id: "member_deleted" }) })
                      }
                    )
                  },
                  S.id || ia(S.name || "")
                );
              }),
              /* @__PURE__ */ h.jsx("li", { "data-index": R.length, className: "show-all", children: /* @__PURE__ */ h.jsx(
                je,
                {
                  variant: "tertiary",
                  size: { mobile: "small", 769: "medium" },
                  onClick: () => {
                    O(), I(), y([{ type: "showLikesModal", value: !0 }]);
                  },
                  onKeyDown: A,
                  children: p.formatMessage({ id: "discussion_likes_showAll" })
                }
              ) })
            ] })
          }
        ),
        x && /* @__PURE__ */ h.jsx(Pl, { children: /* @__PURE__ */ h.jsx(BE, { children: /* @__PURE__ */ h.jsx(
          m6,
          {
            activityId: o,
            basePath: l,
            parentId: u,
            likeCount: t,
            showModal: x,
            functions: {
              onClose: () => y([{ type: "showLikesModal", value: !1 }]),
              likes: {
                list: f
              }
            }
          }
        ) }) })
      ] })
    ] })
  );
};
function y6({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  queryClient: r,
  queryKey: i,
  user: a
}) {
  const { mutate: s } = Ut({
    mutationFn: e,
    onMutate: (o) => t((l) => {
      const u = tg({ activity: e6(o), user: a });
      return Ls(u, l);
    }),
    onError: n,
    onSuccess: (o, l, u) => {
      const c = tg({ activity: o, user: a });
      r.setQueryData(
        i,
        Ls(c, u, { replace: !0 })
      ), setTimeout(() => {
        Ap(c.id, "activity");
      }, 0);
    }
  });
  return s;
}
function E6({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  queryClient: r,
  queryKey: i,
  user: a
}) {
  const { mutateAsync: s } = Ut({
    mutationFn: e,
    onMutate: ({ options: o, title: l, settings: u }) => t((c) => {
      const d = ng({
        activity: eg({ title: l, options: o, settings: u, user: a }),
        options: o,
        user: a
      });
      return Ls(d, c);
    }),
    onError: (o, l, u) => {
      const c = (d) => {
        const f = d.pages;
        return f.forEach((p) => {
          p.results = p.results.filter((g) => g.id !== ta);
        }), {
          ...d,
          pages: f
        };
      };
      r.setQueryData(i, (d) => c(d)), n && n(o, l, u);
    },
    onSuccess: async (o, { options: l, title: u, settings: c }, d) => {
      const f = o, p = ng({
        activity: eg({
          title: u,
          options: l,
          settings: c,
          user: a,
          correctActivityId: f.body.id
        }),
        options: l.map((g, m) => ({ ...g, id: f.body.options[m] })),
        user: a
      });
      r.setQueryData(i, Ls(p, d, { replace: !0 })), setTimeout(() => {
        Ap(f.body.id, "activity");
      }, 0);
    }
  });
  return s;
}
function b6({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  queryClient: r,
  queryKey: i,
  user: a
}) {
  const { mutate: s } = Ut({
    mutationFn: e,
    onMutate: ({ activityId: o, reactionId: l }) => t((u) => {
      const c = Mn(o, u);
      return c && w4({ activity: c, reactionId: l, user: a }), u;
    }),
    onError: n,
    onSuccess: (o, { activityId: l, reactionId: u }, c) => {
      const d = Mn(l, c);
      d && A4({
        activity: d,
        reactionId: u,
        // @ts-expect-error: Working with API response no Reaction
        correctReactionId: o.body.id,
        user: a
      }), r.setQueryData(i, c);
    }
  });
  return s;
}
function T6({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n }
}) {
  const { mutate: r } = Ut({
    mutationFn: e,
    onMutate: ({ activityId: i, content: a, title: s }) => t((o) => {
      const l = Mn(i, o);
      return l && (l.content = a, l.title = s), o;
    }),
    onError: n
  });
  return r;
}
function _6({
  queryFns: {
    create: e,
    edit: t,
    like: n,
    list: r,
    remove: i,
    unlike: a,
    pin: s,
    unpin: o,
    createVote: l,
    createPoll: u,
    removeVote: c,
    removePoll: d
  },
  queryKey: f,
  filterOption: p
}) {
  const g = up(), m = gp(), y = { queryClient: g, queryKey: f }, v = {
    mutationHandlers: {
      error: _p(y),
      mutate: Cp(y)
    },
    user: m,
    ...y
  }, E = y6({ ...v, mutationFn: e }), b = T6({ ...v, mutationFn: t }), _ = C6({ ...v, mutationFn: n }), T = sg({ ...v, mutationFn: i }), x = S6({ ...v, mutationFn: a }), A = w6({ ...v, mutationFn: s }), R = k6({ ...v, mutationFn: o }), P = b6({
    ...v,
    mutationFn: l
  }), L = E6({
    ...v,
    mutationFn: u
  }), I = A6({
    ...v,
    mutationFn: c
  }), O = sg({
    ...v,
    mutationFn: d
  }), { activities: S, ...F } = x6({
    queryKey: f,
    queryFn: r,
    filterOption: p
  });
  return {
    activities: S,
    mutations: {
      create: E,
      edit: b,
      remove: T,
      like: _,
      unlike: x,
      pin: A,
      unpin: R,
      createVote: P,
      createPoll: L,
      removeVote: I,
      removePoll: O
    },
    user: m,
    ...F
  };
}
function C6({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  queryClient: r,
  queryKey: i
}) {
  const { mutate: a } = Ut({
    mutationFn: e,
    onMutate: ({ activityId: s }) => t((o) => {
      const l = Mn(s, o);
      return l && Fc({ activity: l }), o;
    }),
    onError: n,
    onSuccess: (s, { activityId: o }, l) => {
      const u = Mn(o, l);
      u && Fc({ activity: u, reaction: s }), r.setQueryData(i, l);
    }
  });
  return a;
}
function x6({
  queryFn: e,
  queryKey: t,
  filterOption: n
}) {
  const { data: r, error: i, isLoading: a, hasNextPage: s, fetchNextPage: o } = cp({
    queryKey: t,
    queryFn: e,
    initialPageParam: `${n == null ? void 0 : n.type}=${n == null ? void 0 : n.id}`,
    getNextPageParam: (l) => l != null && l.next ? `${l == null ? void 0 : l.next}&${n == null ? void 0 : n.type}=${n == null ? void 0 : n.id}` : null
  });
  return {
    activities: wp(r),
    error: i,
    isLoading: a,
    hasNextPage: s,
    fetchNextPage: o
  };
}
function w6({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  queryClient: r,
  queryKey: i
}) {
  const { mutate: a } = Ut({
    mutationFn: e,
    onMutate: ({ activityId: s }) => t((o) => {
      const l = Mn(s, o);
      return l && Bc({ activity: l }), o;
    }),
    onError: n,
    onSuccess: (s, { activityId: o }, l) => {
      const u = Mn(o, l);
      u && Bc({ activity: u, reaction: s }), r.setQueryData(i, l);
    }
  });
  return a;
}
function sg({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n }
}) {
  const { mutate: r } = Ut({
    mutationFn: e,
    onMutate: ({ activityId: i }) => t((a) => O4(i, a)),
    onError: n
  });
  return r;
}
function A6({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  user: r
}) {
  const { mutate: i } = Ut({
    mutationFn: e,
    onMutate: ({ activityId: a, reactionId: s }) => t((o) => {
      const l = Mn(a, o);
      return l && S4({ activity: l, reactionId: s }), o;
    }),
    onError: n
  });
  return i;
}
function S6({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  user: r
}) {
  const { mutate: i } = Ut({
    mutationFn: e,
    onMutate: ({ activityId: a }) => t((s) => {
      const o = Mn(a, s);
      return o && k4({ activity: o, user: r }), s;
    }),
    onError: n
  });
  return i;
}
function k6({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  user: r
}) {
  const { mutate: i } = Ut({
    mutationFn: e,
    onMutate: ({ activityId: a }) => t((s) => {
      const o = Mn(a, s);
      return o && D4({ activity: o, user: r }), s;
    }),
    onError: n
  });
  return i;
}
const D6 = [
  {
    id: "recent_with_pin",
    text: "recent",
    type: "ranking"
    /* RANKING */
  },
  {
    id: "community_feed_live",
    text: "popular",
    type: "ranking"
    /* RANKING */
  }
], Qie = ({
  basePath: e,
  parentId: t,
  isMember: n,
  isOwner: r,
  categories: i = [],
  functions: { activities: a, form: s, join: o, leave: l, likes: u, polls: c },
  profile: d,
  locale: f = Ms
}) => {
  const p = ye(), [g, m] = de([
    {
      id: "recent_with_pin",
      text: "recent",
      type: "ranking"
      /* RANKING */
    }
  ]), y = Vn(
    () => i == null ? void 0 : i.map(({ slug: Z, name: B }) => ({
      id: Z,
      text: B,
      type: "category"
      /* CATEGORY */
    })),
    [i]
  ), v = Vn(
    () => [...D6, ...y],
    [y]
  ), E = {
    ...a,
    ...c
  }, {
    activities: b,
    error: _,
    fetchNextPage: T,
    hasNextPage: x,
    isLoading: A,
    mutations: {
      create: R,
      edit: P,
      remove: L,
      like: I,
      unlike: O,
      pin: S,
      unpin: F,
      createPoll: H,
      createVote: q,
      removeVote: N,
      removePoll: Q
    }
  } = _6({
    queryKey: [e, t, "activities", g],
    queryFns: E,
    filterOption: g[0]
  }), [J, D] = de(null), C = () => {
    D(b.length), T();
  };
  return N4(), _ ? /* @__PURE__ */ h.jsx(Ci, { variant: "error", text: _.message }) : /* @__PURE__ */ h.jsxs("section", { className: "activities-feed", children: [
    /* @__PURE__ */ h.jsx(
      QC,
      {
        isCard: !0,
        parentId: t,
        categories: i,
        form: {
          content: {
            type: Rl.Post,
            slugs: {}
          },
          functions: {
            create: R,
            createPoll: H,
            ...s
          },
          meta: {
            isEditing: !1,
            isAutoFocused: !1,
            isPrepopulated: !1,
            showSuccessMessage: !1
          }
        },
        membershipRequiredToPost: {
          isMember: n,
          required: !0,
          join: o,
          leave: l,
          notMemberStateText: p.formatMessage({ id: "community_joinToPost" })
        }
      }
    ),
    /* @__PURE__ */ h.jsx(
      WR,
      {
        className: "activities-feed-filtering",
        options: v.map(({ id: Z, text: B }) => ({
          id: Z,
          text: p.formatMessage({
            id: `activitiesFeed_rankingMethod_${B}`,
            defaultMessage: B
          })
        })),
        defaultOptions: g.map(({ id: Z, text: B }) => ({
          id: Z,
          text: p.formatMessage({
            id: `activitiesFeed_rankingMethod_${B}`,
            defaultMessage: B
          })
        })),
        preventNoOptionSelected: !0,
        allowMultiple: !1,
        onChange: ({ current: Z, previous: B }) => {
          if (Z[0] === B[0])
            return;
          m([
            v.find((U) => U.id === Z[0])
          ]);
          const j = v.find((U) => U.id === Z[0]);
          if (!j)
            return;
          const z = new CustomEvent("ariaLive", {
            detail: {
              message: p.formatMessage(
                { id: "community_sortSuccess" },
                {
                  order: p.formatMessage({
                    id: `activitiesFeed_rankingMethod_${j.text}`,
                    defaultMessage: j.text
                  })
                }
              )
            }
          });
          document.dispatchEvent(z);
        },
        gtm: {
          context: "activitiesFeed_sorting"
        }
      }
    ),
    b == null ? void 0 : b.map((Z, B) => {
      var Y;
      const { id: j, own_reactions: z, latest_reactions: U } = Z, ae = (((Y = z == null ? void 0 : z.like) == null ? void 0 : Y.length) || 0) > 0 ? z == null ? void 0 : z.like[0].id : "";
      return /* @__PURE__ */ h.jsx(ll, { children: /* @__PURE__ */ h.jsx(
        H1,
        {
          content: {
            ...t6(Z, i),
            slugs: {
              question: `${e}/${t}`,
              answer: j
            },
            slug: j
          },
          links: {
            post: `${e}/${t}/${j}`,
            comments: `${e}/${t}/${j}`
          },
          gtmContext: "community",
          functions: {
            content: {
              createContent: () => null,
              deleteContent: () => L({ activityId: j }),
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              updateContent: (ee, { body: se, title: re }) => P({ activityId: j, content: se, title: re })
            },
            likes: {
              createLike: () => I({ activityId: j }),
              deleteLike: () => O({ activityId: j, reactionId: ae }),
              listLikes: (ee) => u.list({ activityId: j, ...ee })
            },
            comments: {
              openComments: () => null
            },
            pins: {
              createPin: () => S({ activityId: j }),
              // there will only ever be one pin so we can just grab the first one
              deletePin: () => F({ activityId: j, reactionId: U == null ? void 0 : U.pin[0].id })
            },
            polls: {
              createVote: ({ reactionId: ee }) => q({ activityId: j, reactionId: ee }),
              removeVote: ({ reactionId: ee }) => N({ activityId: j, reactionId: ee }),
              removePoll: () => Q({ activityId: j })
            },
            form: s
          },
          isTruncated: !0,
          styling: { showShareLinkButton: !0 },
          setFocus: B === J,
          userHasOwnerPermissions: r,
          userHasPermissions: n,
          badges: {
            showBadges: !0,
            scopes: [
              {
                scope: Cn.Communities,
                area: t || ""
              },
              {
                scope: Cn.Platform,
                area: "all"
              }
            ]
          },
          basePath: e,
          parentId: t
        }
      ) }, j);
    }),
    !A && /* @__PURE__ */ h.jsx(
      c1,
      {
        hasNextPage: x,
        loadNextPage: C,
        icon: { icon: "arrow-down", position: "right" },
        messages: {
          button: p.formatMessage({ id: "loadMore_button" }),
          error: p.formatMessage({ id: "loadMore_error" })
        }
      }
    ),
    b.length === 0 && !A && /* @__PURE__ */ h.jsx(ur, { className: "no-activities", variant: "muted", icon: "text--input", children: g[0].type === "category" ? /* @__PURE__ */ h.jsx("p", { children: p.formatMessage({ id: "activitiesFeed_noActivities_inCategories" }) }) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx("p", { children: p.formatMessage({ id: "activitiesFeed_noActivities" }) }),
      /* @__PURE__ */ h.jsx("p", { children: /* @__PURE__ */ h.jsx(je, { variant: "secondary", size: "small", href: "/communities", children: p.formatMessage({ id: "activitiesFeed_noActivities_button" }) }) })
    ] }) }),
    /* @__PURE__ */ h.jsx(XC, { form: d })
  ] });
}, Xie = {
  next: "id_lt=67ef0342-6f6e-4807-beea-5a9184ec140c&limit=5",
  results: [
    {
      created_at: "2023-12-03T18:47:44.081716Z",
      updated_at: "2023-12-03T18:47:44.081716Z",
      id: "256b921e-ffe6-410d-b754-ac1aaee989ce",
      user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
      user: {
        created_at: "2023-08-31T07:11:38.677184Z",
        updated_at: "2023-08-31T07:11:38.677184Z",
        id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
        data: {
          name: "Danu Tester",
          badges: {
            communities: {
              "community-slug": ["orange-badge", "badge-with-heart"]
            }
          }
        }
      },
      kind: "reply",
      activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
      data: {
        content: "Testing 17..."
      },
      parent: "",
      latest_children: {},
      children_counts: {}
    },
    {
      created_at: "2023-12-03T18:36:02.517688Z",
      updated_at: "2023-12-03T18:47:24.852582Z",
      id: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
      user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
      user: {
        created_at: "2023-08-31T07:11:38.677184Z",
        updated_at: "2023-08-31T07:11:38.677184Z",
        id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
        data: {
          name: "Danu Tester"
        }
      },
      kind: "reply",
      activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
      data: {
        content: "Testing 16 (edited)..."
      },
      parent: "",
      latest_children: {
        reply: [
          {
            created_at: "2023-12-03T19:28:09.799652Z",
            updated_at: "2023-12-03T19:28:09.799652Z",
            id: "bf1ec451-e7c3-4ebe-a60e-248b0ec2a671",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Testing 3..."
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T19:27:59.756761Z",
            updated_at: "2023-12-03T19:27:59.756761Z",
            id: "7887d921-e2ba-48ef-8089-db24536dbf70",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Testing 2..."
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T19:27:46.534650Z",
            updated_at: "2023-12-03T19:27:46.534650Z",
            id: "73f5bdf3-7080-48ac-a8dc-185f71b38b42",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Testing 1..."
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          }
        ]
      },
      own_children: {
        reply: [
          {
            created_at: "2023-12-03T19:28:09.799652Z",
            updated_at: "2023-12-03T19:28:09.799652Z",
            id: "bf1ec451-e7c3-4ebe-a60e-248b0ec2a671",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Testing 3..."
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T19:27:59.756761Z",
            updated_at: "2023-12-03T19:27:59.756761Z",
            id: "7887d921-e2ba-48ef-8089-db24536dbf70",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Testing 2..."
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T19:27:46.534650Z",
            updated_at: "2023-12-03T19:27:46.534650Z",
            id: "73f5bdf3-7080-48ac-a8dc-185f71b38b42",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Testing 1..."
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          }
        ]
      },
      children_counts: {
        reply: 3
      }
    },
    {
      created_at: "2023-12-03T17:47:45.107092Z",
      updated_at: "2023-12-03T17:47:45.107092Z",
      id: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
      user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
      user: {
        created_at: "2023-08-31T07:11:38.677184Z",
        updated_at: "2023-08-31T07:11:38.677184Z",
        id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
        data: {
          name: "Danu Tester"
        }
      },
      kind: "reply",
      activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
      data: {
        content: "Testing 14..."
      },
      parent: "",
      latest_children: {
        reply: [
          {
            created_at: "2023-12-03T18:47:10.603929Z",
            updated_at: "2023-12-03T18:47:10.603929Z",
            id: "c32b83d5-c5fc-4253-8531-eb99dcb01f28",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 8..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:47:04.856649Z",
            updated_at: "2023-12-03T18:47:04.856649Z",
            id: "5efd80e3-cb11-4748-8c64-f46b71df69c4",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 7..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:36:22.687552Z",
            updated_at: "2023-12-03T18:36:22.687552Z",
            id: "a3a2ebae-6df2-4dc0-beee-2296188b67aa",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 6..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:36:16.129336Z",
            updated_at: "2023-12-03T18:36:16.129336Z",
            id: "72948da5-bf3c-4bd5-9a21-2cee36e0ce8a",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 5..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T17:56:40.850756Z",
            updated_at: "2023-12-03T17:56:40.850756Z",
            id: "81ebc855-d1f6-4a2c-a788-a251bae406b6",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 4..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T17:56:34.103420Z",
            updated_at: "2023-12-03T17:56:34.103420Z",
            id: "ddc28de7-4e89-4572-8122-c95dceacc2fd",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 3..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T17:56:26.410145Z",
            updated_at: "2023-12-03T17:56:26.410145Z",
            id: "916ed4b6-ad87-47bc-9e00-7b0c46180276",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 2..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T17:56:19.921740Z",
            updated_at: "2023-12-03T17:56:19.921740Z",
            id: "92cddcb2-cbdc-4e69-9c8e-5afe3a607411",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 1..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          }
        ]
      },
      own_children: {
        reply: [
          {
            created_at: "2023-12-03T18:47:10.603929Z",
            updated_at: "2023-12-03T18:47:10.603929Z",
            id: "c32b83d5-c5fc-4253-8531-eb99dcb01f28",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 8..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:47:04.856649Z",
            updated_at: "2023-12-03T18:47:04.856649Z",
            id: "5efd80e3-cb11-4748-8c64-f46b71df69c4",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 7..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:36:22.687552Z",
            updated_at: "2023-12-03T18:36:22.687552Z",
            id: "a3a2ebae-6df2-4dc0-beee-2296188b67aa",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 6..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:36:16.129336Z",
            updated_at: "2023-12-03T18:36:16.129336Z",
            id: "72948da5-bf3c-4bd5-9a21-2cee36e0ce8a",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 5..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T17:56:40.850756Z",
            updated_at: "2023-12-03T17:56:40.850756Z",
            id: "81ebc855-d1f6-4a2c-a788-a251bae406b6",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: "Reply 4..."
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          }
        ]
      },
      children_counts: {
        reply: 8
      }
    },
    {
      created_at: "2023-12-03T17:47:40.066170Z",
      updated_at: "2023-12-03T17:47:40.066170Z",
      id: "9ed6a1d0-00b5-4a03-94d7-ac01e188e2e2",
      user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
      user: {
        created_at: "2023-08-31T07:11:38.677184Z",
        updated_at: "2023-08-31T07:11:38.677184Z",
        id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
        data: {
          name: "Danu Tester"
        }
      },
      kind: "reply",
      activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
      data: {
        content: "Testing 13..."
      },
      parent: "",
      latest_children: {},
      children_counts: {}
    },
    {
      created_at: "2023-12-03T17:47:33.107894Z",
      updated_at: "2023-12-03T17:47:33.107894Z",
      id: "67ef0342-6f6e-4807-beea-5a9184ec140c",
      user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
      user: {
        created_at: "2023-08-31T07:11:38.677184Z",
        updated_at: "2023-08-31T07:11:38.677184Z",
        id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
        data: {
          name: "Danu Tester"
        }
      },
      kind: "reply",
      activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
      data: {
        content: "Testing 12..."
      },
      parent: "",
      latest_children: {},
      children_counts: {}
    }
  ],
  duration: "6.48ms"
}, Jie = {
  next: "id_lt=67ef0342-6f6e-4807-beea-5a9184ec140c&limit=5",
  results: [
    {
      created_at: "2023-12-03T18:47:44.081716Z",
      updated_at: "2023-12-03T18:47:44.081716Z",
      id: "256b921e-ffe6-410d-b754-ac1aaee989ce",
      user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
      user: {
        created_at: "2023-08-31T07:11:38.677184Z",
        updated_at: "2023-08-31T07:11:38.677184Z",
        id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
        data: {
          name: "Danu Tester",
          badges: {
            communities: {
              "community-slug": ["orange-badge", "badge-with-heart"]
            }
          }
        }
      },
      kind: "reply",
      activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
      data: {
        content: { original: "Testing ENGLISH..." },
        locale: "en"
      },
      parent: "",
      latest_children: {},
      children_counts: {}
    },
    {
      created_at: "2023-12-03T18:36:02.517688Z",
      updated_at: "2023-12-03T18:47:24.852582Z",
      id: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
      user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
      user: {
        created_at: "2023-08-31T07:11:38.677184Z",
        updated_at: "2023-08-31T07:11:38.677184Z",
        id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
        data: {
          name: "Danu Tester"
        }
      },
      kind: "reply",
      activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
      data: {
        content: { original: "Testing ENGLISH 2..." },
        locale: "en"
      },
      parent: "",
      latest_children: {
        reply: [
          {
            created_at: "2023-12-03T19:28:09.799652Z",
            updated_at: "2023-12-03T19:28:09.799652Z",
            id: "bf1ec451-e7c3-4ebe-a60e-248b0ec2a671",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Testing 3..." }
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T19:27:59.756761Z",
            updated_at: "2023-12-03T19:27:59.756761Z",
            id: "7887d921-e2ba-48ef-8089-db24536dbf70",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Testing 2..." }
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T19:27:46.534650Z",
            updated_at: "2023-12-03T19:27:46.534650Z",
            id: "73f5bdf3-7080-48ac-a8dc-185f71b38b42",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Testing 1..." }
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          }
        ]
      },
      own_children: {
        reply: [
          {
            created_at: "2023-12-03T19:28:09.799652Z",
            updated_at: "2023-12-03T19:28:09.799652Z",
            id: "bf1ec451-e7c3-4ebe-a60e-248b0ec2a671",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Testing 3..." }
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T19:27:59.756761Z",
            updated_at: "2023-12-03T19:27:59.756761Z",
            id: "7887d921-e2ba-48ef-8089-db24536dbf70",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Testing 2..." }
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T19:27:46.534650Z",
            updated_at: "2023-12-03T19:27:46.534650Z",
            id: "73f5bdf3-7080-48ac-a8dc-185f71b38b42",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Testing 1..." }
            },
            parent: "ecb077fe-9f3d-4066-aca2-1ddbc9ac6de7",
            latest_children: {},
            children_counts: {}
          }
        ]
      },
      children_counts: {
        reply: 3
      }
    },
    {
      created_at: "2023-12-03T17:47:45.107092Z",
      updated_at: "2023-12-03T17:47:45.107092Z",
      id: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
      user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
      user: {
        created_at: "2023-08-31T07:11:38.677184Z",
        updated_at: "2023-08-31T07:11:38.677184Z",
        id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
        data: {
          name: "Danu Tester"
        }
      },
      kind: "reply",
      activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
      data: {
        content: { original: "Testing INDONESIAN..." },
        locale: "id"
      },
      parent: "",
      latest_children: {
        reply: [
          {
            created_at: "2023-12-03T18:47:10.603929Z",
            updated_at: "2023-12-03T18:47:10.603929Z",
            id: "c32b83d5-c5fc-4253-8531-eb99dcb01f28",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 8..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:47:04.856649Z",
            updated_at: "2023-12-03T18:47:04.856649Z",
            id: "5efd80e3-cb11-4748-8c64-f46b71df69c4",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 7..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:36:22.687552Z",
            updated_at: "2023-12-03T18:36:22.687552Z",
            id: "a3a2ebae-6df2-4dc0-beee-2296188b67aa",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 6..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:36:16.129336Z",
            updated_at: "2023-12-03T18:36:16.129336Z",
            id: "72948da5-bf3c-4bd5-9a21-2cee36e0ce8a",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 5..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T17:56:40.850756Z",
            updated_at: "2023-12-03T17:56:40.850756Z",
            id: "81ebc855-d1f6-4a2c-a788-a251bae406b6",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 4..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T17:56:34.103420Z",
            updated_at: "2023-12-03T17:56:34.103420Z",
            id: "ddc28de7-4e89-4572-8122-c95dceacc2fd",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 3..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T17:56:26.410145Z",
            updated_at: "2023-12-03T17:56:26.410145Z",
            id: "916ed4b6-ad87-47bc-9e00-7b0c46180276",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 2..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T17:56:19.921740Z",
            updated_at: "2023-12-03T17:56:19.921740Z",
            id: "92cddcb2-cbdc-4e69-9c8e-5afe3a607411",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 1..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          }
        ]
      },
      own_children: {
        reply: [
          {
            created_at: "2023-12-03T18:47:10.603929Z",
            updated_at: "2023-12-03T18:47:10.603929Z",
            id: "c32b83d5-c5fc-4253-8531-eb99dcb01f28",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 8..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:47:04.856649Z",
            updated_at: "2023-12-03T18:47:04.856649Z",
            id: "5efd80e3-cb11-4748-8c64-f46b71df69c4",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 7..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:36:22.687552Z",
            updated_at: "2023-12-03T18:36:22.687552Z",
            id: "a3a2ebae-6df2-4dc0-beee-2296188b67aa",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 6..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T18:36:16.129336Z",
            updated_at: "2023-12-03T18:36:16.129336Z",
            id: "72948da5-bf3c-4bd5-9a21-2cee36e0ce8a",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 5..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          },
          {
            created_at: "2023-12-03T17:56:40.850756Z",
            updated_at: "2023-12-03T17:56:40.850756Z",
            id: "81ebc855-d1f6-4a2c-a788-a251bae406b6",
            user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
            user: {
              created_at: "2023-08-31T07:11:38.677184Z",
              updated_at: "2023-08-31T07:11:38.677184Z",
              id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
              data: {
                name: "Danu Tester"
              }
            },
            kind: "reply",
            activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
            data: {
              content: { original: "Reply 4..." }
            },
            parent: "27a59e8f-f094-442f-88ec-1d5ec2f72790",
            latest_children: {},
            children_counts: {}
          }
        ]
      },
      children_counts: {
        reply: 8
      }
    },
    {
      created_at: "2023-12-03T17:47:40.066170Z",
      updated_at: "2023-12-03T17:47:40.066170Z",
      id: "9ed6a1d0-00b5-4a03-94d7-ac01e188e2e2",
      user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
      user: {
        created_at: "2023-08-31T07:11:38.677184Z",
        updated_at: "2023-08-31T07:11:38.677184Z",
        id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
        data: {
          name: "Danu Tester"
        }
      },
      kind: "reply",
      activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
      data: {
        content: { original: "Testing BRAZILLIAN..." },
        locale: "pt-BR"
      },
      parent: "",
      latest_children: {},
      children_counts: {}
    },
    {
      created_at: "2023-12-03T17:47:33.107894Z",
      updated_at: "2023-12-03T17:47:33.107894Z",
      id: "67ef0342-6f6e-4807-beea-5a9184ec140c",
      user_id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
      user: {
        created_at: "2023-08-31T07:11:38.677184Z",
        updated_at: "2023-08-31T07:11:38.677184Z",
        id: "3a1a02cf-b4d2-4425-b677-2818ec5d775c",
        data: {
          name: "Danu Tester"
        }
      },
      kind: "reply",
      activity_id: "c0ed39d0-8e0f-11ee-8080-8001137b7e08",
      data: {
        content: { original: "Testing NONE..." }
      },
      parent: "",
      latest_children: {},
      children_counts: {}
    }
  ],
  duration: "6.48ms"
};
const I4 = ({
  id: e = "character-limit",
  limit: t,
  valueLength: n,
  ...r
}) => {
  const i = ye(), a = "form_fieldWrapper_characterLimit";
  if (t === 0)
    return null;
  const s = t - n, o = Math.abs(n - t), l = n >= 0.99 * t, u = n >= 0.9 * t && n < 0.99 * t, c = n > t;
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(
      "small",
      {
        id: e,
        className: te("character-limit", {
          "near-limit": l,
          "approaching-limit": u
        }),
        "aria-live": "polite",
        "aria-label": c ? "" : i.formatMessage(
          { id: `${a}_aria_${s < 0 ? "over" : "default"}` },
          { remaining: s, over: o, limit: t }
        ),
        children: c ? i.formatMessage(
          { id: `${a}_aria_${s < 0 ? "over" : "default"}` },
          { remaining: s, over: o, limit: t }
        ) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
          /* @__PURE__ */ h.jsx("span", { className: "hidden", children: i.formatMessage({ id: a }) }),
          n,
          " / ",
          t
        ] })
      }
    ),
    /* @__PURE__ */ h.jsx(ht, { showOnFocus: !1, id: `${e}-info`, children: i.formatMessage({ id: `${a}_info` }, { limit: t }) })
  ] });
}, kp = (e) => (e == null ? void 0 : e.toString().length) || 0, O6 = (e, t) => {
  const n = {};
  return e === 0 || (n["data-character-limit"] = e, n.functions = {
    ...t,
    onChange: (r) => {
      kp(r) > e && (r = r == null ? void 0 : r.toString().slice(0, e)), t.onChange(r);
    }
  }), n;
};
const ru = "emailHelperTextBox_", N6 = ({
  id: e = "email-helper-textbox",
  type: t,
  email: n,
  redirectPath: r,
  resendVerificationCode: i
}) => {
  const a = ye(), [s, o] = de({
    path: `${ru}default`,
    type: "default",
    link: {},
    mail: {},
    error: ""
  }), [l, u] = de(!1), c = ft(
    (g) => {
      g.preventDefault(), g.stopPropagation();
      const m = (y) => {
        o({
          path: `${ru}error_verificationFailedToSend`,
          type: "error",
          link: {
            "data-gtm-event-context": "VerifyEmailBox",
            "data-gtm-event-type": "SendEmailClick",
            className: "gtm-trackable",
            onClick: (v) => c(v),
            href: "#",
            "data-testid": "send-verify-email-click"
          },
          mail: {
            href: "mailto:concierge@apolitical.co",
            className: "gtm-trackable",
            "data-gtm-event-context": "ErrorVerifyingBox",
            "data-gtm-event-type": "email-concierge-click"
          },
          error: y
        });
      };
      if (typeof i != "function") {
        m(a.formatMessage({ id: `${ru}error_noFunction` }));
        return;
      }
      u(!0), i(n).then(() => {
        sessionStorage.setItem(ZE.SESSION_STORAGE.EMAIL, n), window.location.href = r || "/signup/verify-email";
      }).catch((y) => {
        m(y.message);
      }).finally(() => {
        u(!1);
      });
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [n, r, i]
  );
  pe(
    () => {
      let g = ru, m = "default", y = {}, v = {};
      switch (t) {
        case "gov":
          g += "autoApproved", m = "success";
          break;
        case "nonGov":
          g += "unrecognisedEmail", m = "error", y = {
            href: "https://about.apolitical.co/who-can-join-the-community",
            "data-gtm-event-context": "NonGovEmailHelperTextBox",
            "data-gtm-event-type": "LearnMoreClick"
          };
          break;
        case "pending":
          g += "pendingApproval", m = "error", v = {
            href: "mailto:concierge@apolitical.co",
            className: "gtm-trackable",
            "data-gtm-event-context": "EmailExistsBox",
            "data-gtm-event-type": "email-concierge-click"
          };
          break;
        case "verify":
          g += "emailUnverified", m = "error", y = {
            href: "#",
            "data-gtm-event-context": "VerifyEmailBox",
            "data-gtm-event-type": "SendEmailClick",
            className: "gtm-trackable",
            onClick: (E) => c(E),
            "data-testid": "send-verify-email-click"
          };
          break;
        case "exists":
          g += "emailAlreadyExists", m = "error", y = {
            href: "/login",
            "data-gtm-event-context": "EmailExistsBox",
            "data-gtm-event-type": "login-click"
          }, v = {
            href: "mailto:concierge@apolitical.co",
            className: "gtm-trackable",
            "data-gtm-event-context": "EmailExistsBox",
            "data-gtm-event-type": "email-concierge-click"
          };
          break;
        default:
          g += "default", y = {
            href: "https://about.apolitical.co/who-can-join-the-community",
            "data-gtm-event-context": "DefaultEmailHelperTextBox",
            "data-gtm-event-type": "LearnMoreClick"
          };
          break;
      }
      o({ ...s, path: g, type: m, link: y, mail: v });
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [t]
  );
  const d = {};
  return ["link", "mail"].forEach((g) => {
    d[g] = Object.keys(s[g]).length ? (m) => /* @__PURE__ */ h.jsx("a", { ...s[g], children: m }) : (m) => m;
  }), /* @__PURE__ */ h.jsx(
    h7,
    {
      id: e,
      type: s.type,
      heading: l ? !1 : a.formatMessage({ id: `${s.path}_title` }),
      "aria-live": "assertive",
      children: l ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        /* @__PURE__ */ h.jsx(Dr, { element: "span" }),
        /* @__PURE__ */ h.jsx(Dr, { element: "span" })
      ] }) : (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // `values` are throwing a type error: https://github.com/formatjs/formatjs/issues/3633
        a.formatMessage(
          { id: `${s.path}_text` },
          {
            ...d,
            strong: (g) => /* @__PURE__ */ h.jsx("strong", { children: g }),
            em: (g) => /* @__PURE__ */ h.jsx("em", { children: g }),
            br: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
              /* @__PURE__ */ h.jsx("br", {}),
              /* @__PURE__ */ h.jsx("br", {})
            ] }),
            error: s.error
          }
        )
      )
    }
  );
}, Es = ({
  className: e = "",
  element: t = "input",
  id: n,
  inputRef: r,
  functions: i = { onChange: () => {
  } },
  name: a = n,
  placeholder: s,
  type: o = "text",
  value: l,
  autoFocus: u,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  label: c,
  styling: d = {},
  ...f
}) => {
  const p = Ue(), g = r || p, { autosizeToFit: m = !1 } = d;
  k3(m && t === "textarea", g), pe(() => {
    var v;
    u && ((v = g.current) == null || v.focus());
  }, []), !(f != null && f.autoComplete) && ["email"].includes(o) && (f.autoComplete = "email");
  const y = {};
  return t === "input" && (y.type = o), M.createElement(t, {
    ref: g,
    ...f,
    ...y,
    id: n,
    name: a,
    className: te(e, t, { autoresize: m }),
    value: l,
    placeholder: s,
    autoFocus: u,
    ...i,
    onChange: (v) => {
      const E = v.target;
      i.onChange(E.value);
    }
  });
};
const es = {
  UP: "ArrowUp",
  DOWN: "ArrowDown",
  ENTER: "Enter"
}, I6 = 500, P6 = ({
  id: e,
  name: t = e,
  value: n,
  placeholder: r,
  functions: i = {
    onChange: () => {
    },
    onKeyInput: async () => new Promise(() => {
    })
  },
  ...a
}) => {
  const { onChange: s = () => {
  }, onKeyInput: o = async () => {
  } } = i, [{ input: l, displayInput: u, debouncedInput: c }, d] = de({
    input: n,
    displayInput: n,
    debouncedInput: n
  }), [
    { predictions: f, activePredictionIndex: p, isPredictionSelected: g },
    m
  ] = de({
    predictions: [],
    activePredictionIndex: -1,
    isPredictionSelected: !!n
  }), { formatMessage: y } = ye();
  r || (r = y({ id: "inputAutocomplete_placeholder" })), pe(() => {
    const _ = setTimeout(() => {
      g || d((T) => ({ ...T, debouncedInput: l }));
    }, I6);
    return () => {
      clearTimeout(_);
    };
  }, [l, g]), pe(() => {
    c && !g ? (async () => {
      try {
        const T = await o(c) || [];
        m((x) => ({
          ...x,
          predictions: T
        }));
      } catch (T) {
        console.error("Error fetching predictions:", T), m((x) => ({ ...x, predictions: [] }));
      }
    })() : m((_) => ({ ..._, predictions: [] }));
  }, [c, g]), pe(() => {
    p >= 0 && f[p] && d((_) => ({
      ..._,
      displayInput: f[p].description
    }));
  }, [p, f]);
  const v = (_) => {
    [es.DOWN, es.UP, es.ENTER].includes(_.key) && (_.preventDefault(), _.key === es.DOWN && p < f.length - 1 ? m((T) => ({
      ...T,
      activePredictionIndex: p + 1
    })) : _.key === es.UP && p > 0 ? m((T) => ({
      ...T,
      activePredictionIndex: p - 1
    })) : _.key === es.ENTER && p > -1 && (s(f[p].description), d((T) => ({
      ...T,
      input: f[p].description
    })), m((T) => ({
      ...T,
      predictions: [],
      isPredictionSelected: !0
    }))));
  }, E = (_) => {
    s(_.target.value), d((T) => ({
      ...T,
      input: _.target.value,
      displayInput: _.target.value
    })), m((T) => ({
      ...T,
      activePredictionIndex: -1,
      isPredictionSelected: !1
    }));
  }, b = (_) => {
    s(_.description), d((T) => ({
      ...T,
      input: _.description,
      displayInput: _.description
    })), m((T) => ({
      ...T,
      isPredictionSelected: !0,
      predictions: []
    }));
  };
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(
      "input",
      {
        type: "text",
        value: u,
        onChange: E,
        onKeyDown: v,
        placeholder: r,
        name: t,
        id: e,
        ...a
      }
    ),
    /* @__PURE__ */ h.jsx("ul", { className: "predictions-list", children: f.map((_, T) => /* @__PURE__ */ h.jsx(
      "li",
      {
        onClick: () => b(_),
        onMouseEnter: () => m((x) => ({
          ...x,
          activePredictionIndex: T
        })),
        className: te("predictions-list-item", {
          active: T === p
        }),
        children: _.description
      },
      T
    )) })
  ] });
};
const P4 = ({
  className: e = "",
  disabled: t,
  element: n = "p",
  functions: r = { onChange: () => {
  } },
  id: i,
  inputRef: a,
  intlPath: s = !1,
  label: o,
  shownValue: l = !0,
  type: u = "checkbox",
  value: c,
  accessibilityOptions: { checkboxes: { navigateWithArrowKeys: d = !1 } = {} } = {},
  ...f
}) => {
  const p = ye(), { onChange: g, ...m } = r, y = () => {
    t || g(c ? null : l);
  }, v = /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(
      "input",
      {
        ref: a,
        id: i,
        name: i,
        type: u,
        value: l,
        checked: c,
        readOnly: !0,
        disabled: t,
        tabIndex: -1
      }
    ),
    /* @__PURE__ */ h.jsx(
      "span",
      {
        className: te("pretty-checkbox", {
          radio: u === "radio"
        }),
        "data-testid": "pretty-checkbox"
      }
    ),
    /* @__PURE__ */ h.jsx(
      "label",
      {
        htmlFor: i,
        onKeyDown: (E) => {
          (E.key === "Enter" || E.code === "Space") && (E.preventDefault(), E.stopPropagation(), y());
        },
        tabIndex: c || !d ? 0 : -1,
        children: o || p.formatMessage({
          id: s ? `${s}_${i}` : i
        })
      }
    )
  ] });
  return M.createElement(
    n,
    {
      onClick: (E) => {
        const b = E.target;
        b.nodeName.toLowerCase() === "a" || b.parentNode && b.parentNode.nodeName.toLowerCase() === "a" || (E.preventDefault(), E.stopPropagation(), y());
      },
      onKeyDown: d ? (E) => {
        var b, _, T;
        if (E.key !== "Tab")
          switch (E.code) {
            case "Enter":
            case "Space":
              E.stopPropagation(), E.preventDefault(), y();
              break;
            case "ArrowLeft":
            case "ArrowRight":
              E.stopPropagation(), E.preventDefault();
              const x = E.currentTarget;
              let A = x == null ? void 0 : x.nextElementSibling;
              if (E.key === "ArrowLeft") {
                const R = x == null ? void 0 : x.previousElementSibling;
                R ? A = R : A = (b = x == null ? void 0 : x.parentElement) == null ? void 0 : b.lastElementChild;
              } else
                A || (A = (_ = x == null ? void 0 : x.parentElement) == null ? void 0 : _.firstElementChild);
              A && ((T = A == null ? void 0 : A.querySelector("label")) == null || T.focus());
              break;
          }
      } : void 0,
      className: te(i, "checkbox-wrapper", e, {
        "is-checked": c
      }),
      ...f,
      ...m
    },
    v
  );
};
const R6 = mr(function({
  direction: t = "down"
}) {
  return /* @__PURE__ */ h.jsx(
    dp,
    {
      className: te("rotating-chevron", `direction-${t}`)
    }
  );
});
const F6 = ({
  className: e,
  options: t,
  initialValue: n,
  value: r,
  functions: i = { onChange: () => {
  }, onMultiSelectSubmit: () => {
  } },
  gtm: { context: a } = { context: "" },
  placeholder: s,
  multiSelect: o,
  multiSelectOptions: l,
  id: u
}) => {
  const c = ye(), [d, f] = de(!1), p = r || n, g = Array.isArray(p) ? [...p] : p ? [p] : [], [m, y] = de(g);
  let v;
  Array.isArray(m) && m.length === 1 && typeof m[0] == "string" ? v = t && m ? t.find((A) => A.id === m[0]) : t ? t[0] : { id: "", label: "" } : Array.isArray(m) && m.length === 1 && typeof m[0] != "string" ? v = m[0] : v = { id: "", label: "" }, pe(() => {
    y(g);
  }, [r, n]);
  const { onChange: E, onMultiSelectSubmit: b, ..._ } = i, T = (A) => {
    if (o) {
      let R = [];
      m != null && m.includes(A.id) ? R = m.filter((P) => P !== A.id) : R = [...m, A.id], y([...R]), E && E([...R]);
    } else
      y([A]), E && E(A.id), f(!1);
  }, x = (A) => {
    if (A === "all") {
      const R = (t == null ? void 0 : t.map((P) => P.id)) || [];
      y(R), E && E(R);
    } else
      y([]), E && E([]);
  };
  return /* @__PURE__ */ h.jsxs("div", { className: te("dropdown-wrapper", e), children: [
    /* @__PURE__ */ h.jsxs(
      "button",
      {
        className: "input",
        "aria-expanded": d,
        "aria-haspopup": "listbox",
        "aria-controls": "dropdown-list",
        onClick: (A) => {
          A.preventDefault(), A.stopPropagation(), f(!d);
        },
        "data-testid": "dropdown-selector",
        ..._,
        children: [
          o ? `${s} · ${m.length}` : v.label,
          /* @__PURE__ */ h.jsx(R6, { direction: d ? "up" : "down" })
        ]
      }
    ),
    /* @__PURE__ */ h.jsx(
      "select",
      {
        defaultValue: v.id,
        onChange: (A) => {
          A.preventDefault(), A.stopPropagation();
          const R = t && t.find((P) => P.id === A.target.value);
          T(R);
        },
        hidden: !d,
        ..._,
        children: t == null ? void 0 : t.map((A) => /* @__PURE__ */ h.jsx(
          "option",
          {
            value: A.id,
            className: "gtm-trackable",
            "data-gtm-event-type": `${A.id}-click`,
            "data-gtm-event-context": a,
            children: A.label
          },
          A.id
        ))
      }
    ),
    /* @__PURE__ */ h.jsxs(
      "div",
      {
        className: "menu-options input dropdown-menu",
        role: "menu",
        hidden: !d,
        children: [
          /* @__PURE__ */ h.jsxs("div", { className: "dropdown-menu-list", children: [
            (l == null ? void 0 : l.topbar) && /* @__PURE__ */ h.jsxs("div", { className: "action-bar", children: [
              /* @__PURE__ */ h.jsx("p", { children: `${m == null ? void 0 : m.length} selected` }),
              /* @__PURE__ */ h.jsxs("ul", { children: [
                /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx(
                  je,
                  {
                    variant: "tertiary",
                    size: "small",
                    onClick: () => x("all"),
                    className: "gtm-trackable",
                    "data-gtm-event-type": "all-click",
                    "data-gtm-event-context": a,
                    children: c.formatMessage({ id: "dropdown_menu_multiselect_all" })
                  }
                ) }),
                /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx(
                  je,
                  {
                    variant: "tertiary",
                    size: "small",
                    onClick: () => x("none"),
                    className: "gtm-trackable",
                    "data-gtm-event-type": "none-click",
                    "data-gtm-event-context": a,
                    children: c.formatMessage({ id: "dropdown_menu_multiselect_none" })
                  }
                ) })
              ] })
            ] }),
            /* @__PURE__ */ h.jsx("ul", { children: t == null ? void 0 : t.map((A) => {
              const R = A.id === v.id || (m == null ? void 0 : m.includes(A)) || (m == null ? void 0 : m.includes(A.id));
              return /* @__PURE__ */ h.jsx("li", { "data-testid": "dropdown-options", children: /* @__PURE__ */ h.jsxs(
                "button",
                {
                  className: te("gtm-trackable", {
                    selected: R,
                    "selected-single": R && !o
                  }),
                  "data-gtm-event-type": `${A.id}-click`,
                  "data-gtm-event-context": a,
                  onClick: (P) => {
                    P.preventDefault(), P.stopPropagation(), T(A);
                  },
                  role: "menuitem",
                  "aria-current": R,
                  "data-testid": R ? "current-selection" : "",
                  children: [
                    o && /* @__PURE__ */ h.jsx("span", { className: "pretty-checkbox", "data-testid": "pretty-checkbox" }),
                    /* @__PURE__ */ h.jsx("span", { className: te({ "menu-option-label": o }), children: A.label })
                  ]
                }
              ) }, A.id);
            }) })
          ] }),
          (l == null ? void 0 : l.submitSection) && /* @__PURE__ */ h.jsx("p", { className: "submit", children: /* @__PURE__ */ h.jsx(
            je,
            {
              variant: "secondary",
              onClick: () => {
                b && b(m), document.dispatchEvent(
                  new CustomEvent("dropdownMultiSelectSubmit", {
                    detail: {
                      id: u || "dropdown-multi-select",
                      value: m
                    }
                  })
                ), f(!1);
              },
              children: c.formatMessage({ id: "form_submit" })
            }
          ) })
        ]
      }
    )
  ] });
}, Ro = (e, t) => {
  switch (e) {
    case "required":
      if (!t || typeof t == "string" && t.trim().length === 0)
        return !0;
      break;
    case "no-numbers":
      if (t && !/^([^0-9]*)$/.test(t))
        return !0;
      break;
    case "valid-email":
      if (t && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(t))
        return !0;
      break;
    case "valid-url":
      if (t && !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=%]+$/i.test(t))
        return !0;
      break;
    default:
      return !1;
  }
  return !1;
};
let id = null;
const B6 = ({
  id: e,
  label: t,
  limit: n,
  value: r,
  placeholder: i,
  functions: a,
  error: s,
  multipleInputs: o,
  validation: l,
  fieldData: u,
  // Don't pass `type` back in, to avoid a loop
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  type: c,
  ...d
}) => {
  const f = ye(), {
    showCount: p = !1,
    label: g,
    defaultInputs: m = 1,
    maxInputs: y = 100,
    hasButton: v = !1,
    allowDuplicateValues: E = !1
  } = o || {}, [b, _] = de(
    r ? Array.isArray(r) ? r : [r] : Array(m).fill("")
  ), T = b.filter((L) => L !== ""), x = () => {
    if (!u)
      return;
    const L = or(u.fields).filter(
      ({ id: S, name: F }) => (S || (S = F || ""), S !== e && !S.includes(`${e}-`))
    ), I = [];
    b.map((S, F) => {
      if (y && F >= y)
        return;
      const H = or(l ?? []);
      e && (E || H.push({
        condition: (q) => {
          var D;
          const N = q[e].toLowerCase(), Q = ((D = q[`${e}-all`]) == null ? void 0 : D.length) ?? 0, J = new Set(
            q[`${e}-all`].map((C) => C.toLowerCase())
          );
          return J.has(N) && J.size < Q;
        },
        error: f == null ? void 0 : f.formatMessage({ id: "form_error_multipleInputs_same" })
      }), H.forEach((q) => {
        const { condition: N, error: Q } = q;
        if (typeof N == "function")
          q.condition = (J) => {
            var Z;
            let D = (Z = J == null ? void 0 : J[e]) == null ? void 0 : Z[F];
            D || (J[e] && !Array.isArray(J[e]) ? D = J[e] : D = "");
            const C = or(J);
            return C[e] = D, C[`${e}-all`] = J[e], typeof N == "function" && N(C) ? Q : !1;
          };
        else {
          const J = N;
          q.condition = (D) => {
            var Z;
            let C = (Z = D == null ? void 0 : D[e]) == null ? void 0 : Z[F];
            switch (C || (D[e] && !Array.isArray(D[e]) ? C = D[e] : C = ""), J) {
              case "required":
                Q || (q.error = f == null ? void 0 : f.formatMessage({ id: "form_error_required" }));
                break;
              case "no-numbers":
                Q || (q.error = f == null ? void 0 : f.formatMessage({ id: "form_error_numbers" }));
                break;
              case "valid-email":
                Q || (q.error = Q || (f == null ? void 0 : f.formatMessage({ id: "form_error_email" })));
                break;
              case "valid-url":
                Q || (q.error = f == null ? void 0 : f.formatMessage({ id: "form_error_url" }));
                break;
              default:
                console.warn("WARNING! No field validation condition has been set");
            }
            return Ro(J, C) ? q.error : !1;
          };
        }
      }), I.push({
        id: `${e}-${F}`,
        validation: H,
        value: S
      }));
    });
    const O = { fieldsToValidate: L.concat(I) };
    u.multipleInputs.includes(e) && (O.multipleInputs = u.multipleInputs.filter((S) => S !== e)), u.setFields((S) => ({ ...S, ...O }));
  };
  pe(() => {
    x();
  }, [b.length]), pe(() => {
    !u || !u.multipleInputs || u.multipleInputs.includes(e) && x();
  }, [u == null ? void 0 : u.multipleInputs]);
  const A = () => {
    (!y || b.length < y) && _([...b, ""]);
  }, R = (L) => {
    const I = document.getElementById(`${e}-${L + 1}`);
    I == null || I.focus();
  }, P = (L, I) => L.replace("{number}", I + 1);
  return /* @__PURE__ */ h.jsxs(
    "fieldset",
    {
      className: te("multiple-inputs field-wrapper", {
        "has-button": v,
        "has-legend": t
      }),
      children: [
        t ? /* @__PURE__ */ h.jsxs("legend", { className: "legend-as-label text-small", children: [
          t,
          p ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
            " ",
            /* @__PURE__ */ h.jsx(
              "small",
              {
                className: "filled-in-count",
                "aria-label": f.formatMessage(
                  { id: "form_multipleInputs_filledInCount_aria" },
                  { number: T.length, total: y }
                ),
                children: f.formatMessage(
                  { id: "form_multipleInputs_filledInCount" },
                  { number: T.length, total: y }
                )
              }
            )
          ] }) : ""
        ] }) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
        b.map((L, I) => {
          if (y && I >= y)
            return /* @__PURE__ */ h.jsx(h.Fragment, {});
          let O = !1;
          t ? O = /* @__PURE__ */ h.jsx(ht, { showOnFocus: !1, children: f.formatMessage(
            { id: "form_multipleInputs_label" },
            { number: I + 1 }
          ) }) : g && (O = P(g, I));
          const S = `${e}-${I}`, F = I + 1 > m;
          return /* @__PURE__ */ h.jsx(
            R4,
            {
              id: S,
              type: "text",
              label: O,
              value: L,
              placeholder: i ? P(i, I) : void 0,
              className: te({ "has-remove-button": F }),
              limit: n,
              error: s && typeof s != "string" ? s == null ? void 0 : s[S] : void 0,
              functions: {
                ...a,
                onFocus: () => {
                  v || I !== b.length - 1 || A();
                },
                onKeyDown: (H) => {
                  H.key === "Enter" && (H.preventDefault(), H.stopPropagation(), id && clearTimeout(id), I !== b.length - 1 ? R(I) : (A(), id = setTimeout(() => R(I), 100)));
                },
                onChange: (H) => {
                  const q = b[I].toLowerCase(), N = or(b);
                  N[I] = H, _(N), u == null || u.dispatch({ type: "removeError", payload: { key: S } }), E || N.forEach((Q, J) => {
                    hl(Q) && J !== I && Q.toLowerCase() === q && (u == null || u.dispatch({
                      type: "removeError",
                      payload: { key: `${e}-${J}` }
                    }));
                  }), a == null || a.onChange(N);
                }
              },
              siblings: F ? /* @__PURE__ */ h.jsx(
                je,
                {
                  variant: "tertiary",
                  size: "small",
                  icon: "close",
                  screenreaderText: f.formatMessage({
                    id: "form_multipleInputs_remove"
                  }),
                  onClick: () => {
                    const H = or(b);
                    H.splice(I, 1), _(H), u == null || u.dispatch({
                      type: "removeError",
                      payload: { key: S }
                    }), a == null || a.onChange(H);
                  }
                }
              ) : void 0,
              ...d
            },
            S
          );
        }),
        v ? /* @__PURE__ */ h.jsx(
          je,
          {
            ...v,
            onClick: A,
            disabled: !!(y && y <= b.length)
          }
        ) : /* @__PURE__ */ h.jsx(h.Fragment, {})
      ]
    }
  );
};
const og = ({
  className: e = "",
  functions: t = { onChange: () => {
  } },
  intlPath: n = !1,
  id: r,
  label: i,
  multiSelect: a = !1,
  name: s,
  options: o,
  required: l,
  type: u = "checkboxes",
  value: c,
  accessibilityOptions: d,
  styling: { displayOptionsAsPills: f = !1 } = {},
  multipleOptions: p,
  ...g
}) => {
  const m = ye(), y = a ? c : [], v = c;
  return /* @__PURE__ */ h.jsx(
    "ul",
    {
      ...g,
      className: te("options-wrapper", e, {
        "with-pills filters": f
      }),
      "data-testid": `ul-${r}`,
      children: o == null ? void 0 : o.map(
        ({
          id: E,
          label: b = !1,
          value: _ = E,
          disabled: T = void 0
        }) => {
          const x = `${r}_${E}`;
          T === void 0 && (T = p != null && p.limit ? y.length >= p.limit && !y.includes(_) : !1);
          const A = () => {
            if (T)
              return;
            let R;
            if (a) {
              const P = y == null ? void 0 : y.indexOf(_);
              Array.isArray(y) && P >= 0 ? (R = y, R.splice(P, 1)) : (!y || y.length === 0 ? R = [] : R = y, R.push(_));
            } else
              R = v === _ ? void 0 : _;
            t.onChange(R);
          };
          return /* @__PURE__ */ h.jsx(
            P4,
            {
              element: "li",
              id: x,
              type: u === "checkboxes" ? "checkbox" : "radio",
              shownValue: _,
              value: a ? y == null ? void 0 : y.includes(_) : v === _,
              functions: {
                ...t,
                onChange: A
              },
              intlPath: n,
              label: b || m.formatMessage({
                id: n ? `${n}_${E}` : E
              }),
              disabled: T,
              accessibilityOptions: d,
              className: te({
                disabled: T
              })
            },
            x
          );
        }
      )
    }
  );
};
const M6 = ({
  inputRef: e,
  type: t = "password",
  gtm: { context: n } = { context: void 0 },
  autoComplete: r = "on",
  ...i
}) => {
  const a = ye(), s = Ue(), o = e || s, [l, u] = de(!1), [c, d] = de(t), f = () => {
    var p;
    u(!l), d(l ? "password" : "text"), (p = o.current) == null || p.focus();
  };
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(
      "button",
      {
        type: "button",
        className: te("show-password gtm-trackable", {
          "password-visible": l
        }),
        "data-gtm-event-context": n,
        "data-gtm-event-type": `${l ? "hide" : "show"}-password-click`,
        onClick: f,
        "aria-label": a.formatMessage({
          id: `showpassword_aria_${l ? "hide" : "show"}`
        }),
        children: a.formatMessage({
          id: `showpassword_${l ? "hide" : "show"}`
        })
      }
    ),
    /* @__PURE__ */ h.jsx(
      Es,
      {
        inputRef: o,
        type: c,
        autoComplete: r,
        ...i
      }
    )
  ] });
};
const ts = {
  text: { component: Es },
  email: { component: Es },
  url: { component: Es },
  textarea: { component: Es, props: { element: "textarea", rows: 4, cols: 10 } },
  checkbox: { component: P4 },
  checkboxes: { component: og, props: { multiSelect: !0 } },
  radio: { component: og, props: { multiSelect: !1 } },
  select: { component: F6 },
  password: { component: M6 },
  autocomplete: { component: P6 },
  "multiple-inputs": { component: /* @__PURE__ */ h.jsx(h.Fragment, {}) }
  // Multiple inputs is a special case which is handled separately to the rest of the inputs, as it calls this file again. We never call the `component`, it's set here to avoid casing errors.
}, R4 = (e) => {
  const t = ye(), {
    id: n,
    intlPath: r = !1,
    className: i = "",
    error: a,
    functions: s = { onChange: () => {
    } },
    limit: o = 0,
    showRequiredLabels: l = !0,
    type: u,
    validation: c,
    value: d,
    submitOnEnter: f,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fieldData: p,
    siblings: g,
    ...m
  } = e;
  if (u && u === "multiple-inputs")
    return /* @__PURE__ */ h.jsx(B6, { ...e });
  const y = c && c.some(({ condition: F }) => F === "required"), v = kp(d), E = u && ts[u] && ts[u].component ? ts[u].component : Es, b = u && ["checkboxes", "radio"].includes(u), _ = u && ["autocomplete"].includes(u), T = a && `error-${n}`, x = `character-limit-${n}`, A = {};
  b ? A.element = "legend" : A.htmlFor = n;
  let R = {
    ...m,
    id: n,
    name: n,
    className: a ? "error" : "",
    type: u,
    required: y,
    "aria-required": y,
    functions: or(s),
    value: d
  };
  const P = (F) => {
    R["aria-describedby"] ? R["aria-describedby"] += ` ${F}` : R["aria-describedby"] = F;
  };
  if (o > 0) {
    const F = O6(o, s);
    P(`${x}-info`), R = {
      ...R,
      ...F
    }, F.functions && typeof F.functions == "object" && (R.functions = {
      ...R.functions,
      ...F.functions
    });
  }
  u && ts[u] && ts[u].props && (R = { ...R, ...ts[u].props }), b && (R.intlPath = `${r}_${n}`), a && (R["aria-invalid"] = !0, R["aria-errormessage"] = T, P(T));
  const L = m.label || t.formatMessage({ id: r ? `${r}_${n}` : n }), I = ({ ...F }) => a ? M.createElement(
    F.as || "p",
    {
      id: T,
      className: "error text-small",
      ...F
    },
    a
  ) : null;
  if (u && ["checkbox"].includes(u))
    return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx(
        E,
        {
          ...R,
          label: L,
          className: te("field-wrapper", i)
        }
      ),
      /* @__PURE__ */ h.jsx(I, { as: "p" })
    ] });
  const O = {};
  b ? A.className = "legend-as-label text-small" : O.className = "field-label";
  const S = ({ element: F, ...H }) => M.createElement(F || "label", {
    ...H,
    "data-testid": `label-${n}`
  });
  return /* @__PURE__ */ h.jsx(h.Fragment, { children: M.createElement(
    b ? "fieldset" : "div",
    {
      className: te(
        "field-wrapper text-small",
        i,
        `${u}-wrapper`,
        { "multiple-options-wrapper": b }
      )
    },
    /* @__PURE__ */ h.jsxs(h.Fragment, {
      /* If the `label` prop is `false`, don't render anything here; this lets us set a single label for all multiple inputs, for example */
      children: [
        m.label === !1 ? /* @__PURE__ */ h.jsx(h.Fragment, {}) : M.createElement(
          b ? M.Fragment : "p",
          O,
          /* @__PURE__ */ h.jsxs(S, { ...A, children: [
            L,
            y && l && /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
              " ",
              /* @__PURE__ */ h.jsxs("small", { children: [
                "(",
                t.formatMessage({ id: "form_fieldWrapper_required" }),
                ")"
              ] })
            ] })
          ] })
        ),
        M.createElement(
          b || _ ? "div" : "p",
          {
            className: "field-component"
          },
          /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
            /* @__PURE__ */ h.jsx(E, { ...R }),
            /* @__PURE__ */ h.jsx(
              I4,
              {
                id: x,
                limit: o,
                valueLength: v
              }
            ),
            g
          ] })
        ),
        /* @__PURE__ */ h.jsx(I, {})
      ]
    })
  ) });
}, L6 = (e, t) => {
  const { type: n, payload: r } = t, i = e.errors ? or(e.errors) : {}, a = e.values ? or(e.values) : {};
  switch (n) {
    case "updateValue":
      if (r != null && r.key && i[r == null ? void 0 : r.key] && delete i[r == null ? void 0 : r.key], r != null && r.key) {
        if (["isSubmitting", "formSubmitted", "errors"].includes(r == null ? void 0 : r.key))
          return {
            ...e,
            errors: i,
            [r == null ? void 0 : r.key]: r == null ? void 0 : r.value
          };
        a[r == null ? void 0 : r.key] = r == null ? void 0 : r.value;
      }
      return {
        ...e,
        errors: i,
        values: a
      };
    case "addError":
      return r != null && r.key && !i[r == null ? void 0 : r.key] && (i[r == null ? void 0 : r.key] = r == null ? void 0 : r.value), { ...e, errors: i };
    case "removeError":
      return r != null && r.key && i[r == null ? void 0 : r.key] && delete i[r == null ? void 0 : r.key], { ...e, errors: i };
    case "submitForm": {
      const {
        fields: s = [],
        dispatch: o = () => {
        },
        onSuccess: l = () => {
        },
        onFailure: u = () => {
        },
        intl: c
      } = r, d = or(Object.keys(i));
      for (const f of s)
        if (f.validation)
          for (let p = 0; p < f.validation.length; p++) {
            const { condition: g = "required", error: m = !1 } = f.validation[p];
            let y = !1;
            if (typeof g == "function") {
              const v = g(a);
              v && (y = m || v);
            } else {
              const v = a[f.id], E = g;
              switch (E) {
                case "required":
                  Ro(E, v) && (y = m || (c == null ? void 0 : c.formatMessage({ id: "form_error_required" })));
                  break;
                case "no-numbers": {
                  Ro(E, v) && (y = m || (c == null ? void 0 : c.formatMessage({ id: "form_error_numbers" })));
                  break;
                }
                case "valid-email": {
                  Ro(E, v) && (y = m || (c == null ? void 0 : c.formatMessage({ id: "form_error_email" })));
                  break;
                }
                case "valid-url": {
                  Ro(E, v) && (y = m || (c == null ? void 0 : c.formatMessage({ id: "form_error_url" })));
                  break;
                }
                default:
                  console.warn("WARNING! No field validation condition has been set");
              }
            }
            if (y) {
              o({
                type: "addError",
                payload: { key: f.id, value: y }
              }), d.push(f.id);
              break;
            }
          }
      return d.length === 0 ? l(a) : u(a, d), e;
    }
    case "formSubmitted":
      return {
        ...e,
        isSubmitting: !1,
        formSubmitted: !0,
        errors: {}
      };
    case "formSubmittedAndReset":
      return {
        isSubmitting: !1,
        formSubmitted: !0,
        errors: {}
      };
    default:
      return e;
  }
};
let ad = null;
const ti = ({
  element: e = "form",
  fields: t,
  className: n = "",
  id: r = t.length ? `form__${t[0].id}` : "form",
  formRef: i,
  intlPath: a = !1,
  button: s = {
    variant: "primary",
    size: "large",
    customOnSubmit: !1
  },
  secondaryActionButton: o = {
    variant: "secondary",
    size: "large"
  },
  meta: l,
  children: u,
  gtm: c = { context: "Form", event: "form-submit-click" },
  functions: d,
  ...f
}) => {
  const p = (t || []).filter((Y) => Y.type === "multiple-inputs").map((Y) => Y.id), [g, m] = de({
    fieldsToValidate: t,
    multipleInputs: p
  });
  pe(() => {
    g.multipleInputs.length || m((Y) => ({
      ...Y,
      fieldsToValidate: t,
      multipleInputs: p
    }));
  }, [t.length]);
  const { customOnSubmit: y, hideButton: v, ...E } = s, b = 40, {
    shouldShowCancelButton: _ = !1,
    shouldReset: T = !0,
    shouldHide: x = !0,
    showRequiredLabels: A = !0,
    showSuccessMessage: R = !1,
    shouldScrollOnSuccess: P = !0
  } = l || {}, {
    onSuccess: L = async () => {
    },
    onCancel: I = () => {
    },
    onCatch: O = () => {
    },
    onFailure: S = () => {
    }
  } = d || {}, F = ye(), H = {};
  t.length && t.forEach((Y) => {
    const ee = Y.id || Y.name;
    ee && (H[ee] = Y.value || "");
  });
  const [q, N] = ra(L6, {
    isSubmitting: !1,
    formSubmitted: !1,
    errors: {},
    values: H
  }), { errors: Q, isSubmitting: J, formSubmitted: D, values: C } = q;
  pe(() => {
    T && D && (ad = setTimeout(() => {
      N({
        type: "updateValue",
        payload: { key: "formSubmitted", value: !1 }
      });
    }, 3e3));
  }, [D]), pe(() => () => {
    ad && clearTimeout(ad);
  }, []), pe(() => {
    const Y = (ee) => {
      N({
        type: "updateValue",
        payload: { key: ee.detail.id, value: ee.detail.value }
      });
    };
    return document.addEventListener(
      "dropdownMultiSelectSubmit",
      Y
    ), () => {
      document.removeEventListener(
        "dropdownMultiSelectSubmit",
        Y
      );
    };
  }, []);
  const Z = Ue(null), B = i || Z, j = fl(() => {
    if (!J) {
      if (N({
        type: "updateValue",
        payload: { key: "isSubmitting", value: !0 }
      }), s.disabled) {
        typeof s.disabled == "object" && s.disabled.isClickable && N({
          type: "submitForm",
          payload: {
            fields: g.fieldsToValidate,
            dispatch: N,
            intl: F
          }
        });
        return;
      }
      N({
        type: "submitForm",
        payload: {
          fields: g.fieldsToValidate,
          dispatch: N,
          onSuccess: async (Y) => {
            P && U();
            try {
              await L(Y), N({ type: T ? "formSubmittedAndReset" : "formSubmitted" });
            } catch (ee) {
              O(ee), N({
                type: "updateValue",
                payload: { key: "isSubmitting", value: !1 }
              });
            }
          },
          onFailure: (Y, ee) => {
            U(), S(Y, ee), N({
              type: "updateValue",
              payload: { key: "isSubmitting", value: !1 }
            });
          },
          intl: F
        }
      });
    }
  }, 100);
  if (!t.length)
    return null;
  const z = {};
  s.children && (z.default = s.children), E.text && typeof E.text == "string" && (z.default = E.text), ["default", "submitting", "submitted"].forEach((Y) => {
    E.text && typeof E.text != "string" && Y in E.text ? z[Y] = E.text[Y] : z[Y] || (z[Y] = F.formatMessage({
      id: `form_${Y === "default" ? "submit" : Y}`
    }));
  }), delete E.text;
  const U = () => {
    var se;
    let Y = 0;
    if ((se = B == null ? void 0 : B.current) != null && se.id) {
      const re = document.getElementById(B.current.id);
      re && (Y = re.getBoundingClientRect().top + window.scrollY);
    }
    const ee = document.getElementById("header");
    ee && (Y = Y - ee.offsetHeight - b), Y < 0 && (Y = 0), window.scrollTo({ top: Y, behavior: "smooth" });
  }, $ = (Y) => {
    Y.preventDefault(), Y.stopPropagation(), !J && j();
  }, ae = [
    {
      ...E,
      icon: D ? { icon: "tick", position: "left" } : !1,
      className: te("gtm-trackable", E.className),
      onClick: $,
      disabled: J || D || s.disabled,
      "data-gtm-event-context": c.context,
      "data-gtm-event-type": c.event,
      children: z[J ? "submitting" : D ? "submitted" : "default"]
    }
  ];
  return _ && ae.unshift({
    ...o,
    className: te("gtm-trackable", o.className),
    "data-gtm-event-context": c.context,
    "data-gtm-event-type": c.event,
    disabled: J || D,
    onClick: I,
    children: o.text || F.formatMessage({ id: "form_cancel" })
  }), /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    M.createElement(
      e,
      {
        ...f,
        id: r,
        className: te("form", n),
        ref: B
      },
      /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        Q != null && Q.general ? /* @__PURE__ */ h.jsx(
          Ci,
          {
            variant: "error",
            text: F.formatMessage({ id: "form_error_generalError" })
          }
        ) : null,
        u,
        (!x || !J && !D || y) && t.map((Y, ee) => {
          const {
            id: se = Y.name || ee,
            component: re,
            functions: Ae = { onChange: () => {
            } },
            submitOnEnter: Oe = !1
          } = Y;
          if (re)
            return /* @__PURE__ */ h.jsx(re, { ...Y.props || {} }, `component-${se}-${ee}`);
          const Ce = (C == null ? void 0 : C[se]) || "", ue = {
            ...Ae,
            onChange: (fe) => {
              N({ type: "updateValue", payload: { key: se, value: fe } }), Ae.onChange(fe, N);
            }
          };
          return Oe && (ue.onKeyDown = (fe) => {
            fe.key === "Enter" && (fe.stopPropagation(), fe.preventDefault(), j()), Ae.onKeyDown && Ae.onKeyDown(fe);
          }), /* @__PURE__ */ h.jsx(
            R4,
            {
              intlPath: a,
              ...Y,
              showRequiredLabels: A,
              value: Ce,
              error: Y.type === "multiple-inputs" ? Q : Q == null ? void 0 : Q[se],
              functions: ue,
              fieldData: {
                fields: g.fieldsToValidate,
                multipleInputs: g.multipleInputs,
                setFields: m,
                dispatch: N
              }
            },
            se
          );
        }),
        v ? null : (J || D) && y ? y : /* @__PURE__ */ h.jsx(
          Il,
          {
            className: te("cta", {
              center: J || D,
              submitted: D
            }),
            buttons: ae
          }
        )
      ] })
    ),
    R && D && /* @__PURE__ */ h.jsx(pl, { className: "success", children: typeof R == "string" ? R : F.formatMessage({ id: "form_success" }) })
  ] });
};
const iu = "passwordRules_", F4 = "isMoreThanEightCharacters", B4 = "includesNumberAndSymbol", M4 = "includesLowerAndUppercase", $6 = {
  [F4]: "8Characters",
  [B4]: "numberSymbol",
  [M4]: "lowercaseUppercase"
}, j6 = ({
  matchingRules: e = {
    isMoreThanEightCharacters: !1,
    includesNumberAndSymbol: !1,
    includesLowerAndUppercase: !1
  },
  className: t = ""
}) => {
  const n = ye();
  return /* @__PURE__ */ h.jsxs("aside", { className: te("password-rules", t), children: [
    /* @__PURE__ */ h.jsx("small", { children: n.formatMessage({ id: `${iu}intro` }) }),
    /* @__PURE__ */ h.jsx("ul", { children: [F4, B4, M4].map(
      (r) => /* @__PURE__ */ h.jsxs(
        "li",
        {
          className: te({ matches: e[r] }),
          children: [
            /* @__PURE__ */ h.jsxs(ht, { children: [
              n.formatMessage({ id: `${iu}rule_label` }),
              " "
            ] }),
            /* @__PURE__ */ h.jsx("span", { children: n.formatMessage({ id: `${iu}rule_${$6[r]}` }) }),
            !e[r] && /* @__PURE__ */ h.jsxs(ht, { element: "strong", children: [
              " ",
              n.formatMessage({ id: `${iu}notMet` })
            ] })
          ]
        },
        `rule-${r}`
      )
    ) })
  ] });
}, H6 = mr(j6);
const eae = ({
  text: e = {},
  topRating: t = 5,
  functions: {
    createRating: n = () => null,
    updateRating: r = () => {
    },
    reportError: i = () => {
    }
  },
  className: a = "",
  hasLoaded: s = !1
}) => {
  const o = ye(), [l, u] = de({
    setUp: !1,
    id: null,
    rating: null,
    disabled: !0
  }), c = async () => {
    try {
      const v = await n();
      u((E) => ({
        ...E,
        setUp: !0,
        id: v && v.id,
        disabled: !1
      }));
    } catch (v) {
      u((E) => ({ ...E, setUp: !0, disabled: !0 })), i(v);
    }
  };
  if (pe(() => {
    s && !l.setUp && c();
  }, [s]), !s)
    return /* @__PURE__ */ h.jsx(Dr, { className: "rating-placeholder" });
  const { id: d, rating: f, disabled: p } = l, g = "ratings_", m = {
    text: o.formatMessage({ id: `${g}text` }),
    low: o.formatMessage({ id: `${g}low` }),
    high: o.formatMessage({ id: `${g}high` }),
    success: o.formatMessage({ id: `${g}success` }),
    ...e
  }, y = async (v) => {
    if (!(!d || p))
      try {
        u((E) => ({ ...E, rating: v, disabled: !0 })), await r({ id: d, value: v });
      } catch (E) {
        u((b) => ({ ...b, rating: null })), i(E);
      } finally {
        u((E) => ({ ...E, disabled: !1 }));
      }
  };
  return /* @__PURE__ */ h.jsxs("div", { className: te("rating", a), children: [
    /* @__PURE__ */ h.jsx("span", { className: "label", children: m[f ? "success" : "text"] }),
    /* @__PURE__ */ h.jsx("ol", { children: Array.from(new Array(t).keys()).map((v) => {
      const E = v + 1;
      return /* @__PURE__ */ h.jsx(
        "li",
        {
          className: te({ selected: f && E <= f }),
          children: /* @__PURE__ */ h.jsx(
            je,
            {
              variant: "tertiary",
              size: "small",
              icon: {
                icon: `star${!f || E > f ? "_empty" : ""}`,
                position: "left",
                hover: "star"
              },
              screenreaderText: `${o.formatMessage(
                { id: `${g}stars` },
                { number: E, total: t }
              )}${E === 1 || E === t ? ` - ${m[E === 1 ? "low" : "high"]}` : ""}`,
              onClick: (b) => {
                b.preventDefault(), b.stopPropagation(), y(E);
              },
              disabled: p
            }
          )
        },
        `rating-${E}`
      );
    }) })
  ] });
}, U6 = {
  id: "",
  showLinkEditor: !1,
  mentionPopover: {
    show: !1,
    selectedUser: 0,
    possibleUsers: [],
    position: null,
    numberOfUsers: null
  },
  lastAnchor: null,
  isInOverlay: !1,
  dispatch: () => {
  },
  enrichedUrl: void 0,
  onMention: () => {
  },
  getLinkPreview: () => Promise.resolve({}),
  reportError: (e) => {
    console.error(e);
  }
}, Di = sn(U6), z6 = {
  tabbableOption: "",
  setFocus: () => {
  },
  openTooltip: null,
  dispatch: () => {
  }
}, Bl = sn(z6);
var ne = /* @__PURE__ */ ((e) => (e.blockquote = "block_quote", e.bold = "bold", e.code = "code", e.codeblock = "code_block", e.heading = "heading", e.hr = "thematic_break", e.image = "image", e.italic = "italic", e.li = "list_item", e.link = "link", e.mention = "mention", e.ol = "ol_list", e.paragraph = "paragraph", e.ul = "ul_list", e.strikethrough = "strikeThrough", e.span = "span", e.h3 = "heading_three", e))(ne || {}), Ei = /* @__PURE__ */ ((e) => (e.delete = "delete_mark", e.emphasis = "emphasis_mark", e.code = "inline_code_mark", e.strong = "strong_mark", e))(Ei || {});
const q6 = ({
  attributes: e,
  children: t,
  element: n
}) => {
  const r = n;
  switch (r.type) {
    case ne.blockquote:
      return /* @__PURE__ */ h.jsx("blockquote", { className: "subtle", ...e, children: t });
    case ne.link:
      return /* @__PURE__ */ h.jsx("a", { ...e, children: t });
    case ne.li:
      return /* @__PURE__ */ h.jsx("li", { ...e, children: t });
    case ne.mention:
      const i = r;
      return i != null && i.name && i.name === kc ? /* @__PURE__ */ h.jsxs("span", { ...e, className: "mention deleted-user", children: [
        "@",
        /* @__PURE__ */ h.jsx(en, { id: "member_deleted" }),
        t
      ] }) : /* @__PURE__ */ h.jsxs("a", { ...e, className: "mention", children: [
        "@",
        (i == null ? void 0 : i.name) || "",
        t
      ] });
    case ne.ol:
      return /* @__PURE__ */ h.jsx("ol", { ...e, children: t });
    case ne.ul:
      return /* @__PURE__ */ h.jsx("ul", { ...e, children: t });
    case ne.span:
      return /* @__PURE__ */ h.jsx("span", { ...e, children: t });
    case ne.paragraph:
      return /* @__PURE__ */ h.jsx("p", { ...e, children: t });
    case ne.h3:
      return /* @__PURE__ */ h.jsx("h3", { ...e, children: t });
    default:
      return /* @__PURE__ */ h.jsx("span", { ...e, children: t });
  }
}, W6 = ({ attributes: e, children: t, leaf: n }) => {
  const r = n;
  return r[ne.bold] && (t = /* @__PURE__ */ h.jsx("strong", { children: t })), r[ne.italic] && (t = /* @__PURE__ */ h.jsx("em", { children: t })), r[ne.strikethrough] && (t = /* @__PURE__ */ h.jsx("s", { children: t })), /* @__PURE__ */ h.jsx("span", { ...e, children: t });
};
var V6 = Y6, L4 = "֑-߿יִ-﷽ﹰ-ﻼ", $4 = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", K6 = new RegExp("^[^" + $4 + "]*[" + L4 + "]"), G6 = new RegExp("^[^" + L4 + "]*[" + $4 + "]");
function Y6(e) {
  return e = String(e || ""), K6.test(e) ? "rtl" : G6.test(e) ? "ltr" : "neutral";
}
const j4 = /* @__PURE__ */ Or(V6);
function Z6(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Dp = Z6, Q6 = typeof Zl == "object" && Zl && Zl.Object === Object && Zl, X6 = Q6, J6 = X6, ew = typeof self == "object" && self && self.Object === Object && self, tw = J6 || ew || Function("return this")(), H4 = tw, nw = H4, rw = function() {
  return nw.Date.now();
}, iw = rw, aw = /\s/;
function sw(e) {
  for (var t = e.length; t-- && aw.test(e.charAt(t)); )
    ;
  return t;
}
var ow = sw, lw = ow, uw = /^\s+/;
function cw(e) {
  return e && e.slice(0, lw(e) + 1).replace(uw, "");
}
var dw = cw, fw = H4, hw = fw.Symbol, U4 = hw, lg = U4, z4 = Object.prototype, pw = z4.hasOwnProperty, mw = z4.toString, co = lg ? lg.toStringTag : void 0;
function gw(e) {
  var t = pw.call(e, co), n = e[co];
  try {
    e[co] = void 0;
    var r = !0;
  } catch {
  }
  var i = mw.call(e);
  return r && (t ? e[co] = n : delete e[co]), i;
}
var vw = gw, yw = Object.prototype, Ew = yw.toString;
function bw(e) {
  return Ew.call(e);
}
var Tw = bw, ug = U4, _w = vw, Cw = Tw, xw = "[object Null]", ww = "[object Undefined]", cg = ug ? ug.toStringTag : void 0;
function Aw(e) {
  return e == null ? e === void 0 ? ww : xw : cg && cg in Object(e) ? _w(e) : Cw(e);
}
var Sw = Aw;
function kw(e) {
  return e != null && typeof e == "object";
}
var Dw = kw, Ow = Sw, Nw = Dw, Iw = "[object Symbol]";
function Pw(e) {
  return typeof e == "symbol" || Nw(e) && Ow(e) == Iw;
}
var Rw = Pw, Fw = dw, dg = Dp, Bw = Rw, fg = 0 / 0, Mw = /^[-+]0x[0-9a-f]+$/i, Lw = /^0b[01]+$/i, $w = /^0o[0-7]+$/i, jw = parseInt;
function Hw(e) {
  if (typeof e == "number")
    return e;
  if (Bw(e))
    return fg;
  if (dg(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = dg(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Fw(e);
  var n = Lw.test(e);
  return n || $w.test(e) ? jw(e.slice(2), n ? 2 : 8) : Mw.test(e) ? fg : +e;
}
var Uw = Hw, zw = Dp, sd = iw, hg = Uw, qw = "Expected a function", Ww = Math.max, Vw = Math.min;
function Kw(e, t, n) {
  var r, i, a, s, o, l, u = 0, c = !1, d = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(qw);
  t = hg(t) || 0, zw(n) && (c = !!n.leading, d = "maxWait" in n, a = d ? Ww(hg(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f);
  function p(x) {
    var A = r, R = i;
    return r = i = void 0, u = x, s = e.apply(R, A), s;
  }
  function g(x) {
    return u = x, o = setTimeout(v, t), c ? p(x) : s;
  }
  function m(x) {
    var A = x - l, R = x - u, P = t - A;
    return d ? Vw(P, a - R) : P;
  }
  function y(x) {
    var A = x - l, R = x - u;
    return l === void 0 || A >= t || A < 0 || d && R >= a;
  }
  function v() {
    var x = sd();
    if (y(x))
      return E(x);
    o = setTimeout(v, m(x));
  }
  function E(x) {
    return o = void 0, f && r ? p(x) : (r = i = void 0, s);
  }
  function b() {
    o !== void 0 && clearTimeout(o), u = 0, r = l = i = o = void 0;
  }
  function _() {
    return o === void 0 ? s : E(sd());
  }
  function T() {
    var x = sd(), A = y(x);
    if (r = arguments, i = this, l = x, A) {
      if (o === void 0)
        return g(l);
      if (d)
        return clearTimeout(o), o = setTimeout(v, t), p(l);
    }
    return o === void 0 && (o = setTimeout(v, t)), s;
  }
  return T.cancel = b, T.flush = _, T;
}
var q4 = Kw;
const Gw = /* @__PURE__ */ Or(q4);
var Yw = q4, Zw = Dp, Qw = "Expected a function";
function Xw(e, t, n) {
  var r = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(Qw);
  return Zw(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Yw(e, t, {
    leading: r,
    maxWait: t,
    trailing: i
  });
}
var Jw = Xw;
const eA = /* @__PURE__ */ Or(Jw), pg = (e) => typeof e == "object" && e != null && e.nodeType === 1, mg = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", od = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return mg(n.overflowY, t) || mg(n.overflowX, t) || ((r) => {
      const i = ((a) => {
        if (!a.ownerDocument || !a.ownerDocument.defaultView)
          return null;
        try {
          return a.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!i && (i.clientHeight < r.scrollHeight || i.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, au = (e, t, n, r, i, a, s, o) => a < e && s > t || a > e && s < t ? 0 : a <= e && o <= n || s >= t && o >= n ? a - e - r : s > t && o < n || a < e && o > n ? s - t + i : 0, tA = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, gg = (e, t) => {
  var n, r, i, a;
  if (typeof document > "u")
    return [];
  const { scrollMode: s, block: o, inline: l, boundary: u, skipOverflowHiddenElements: c } = t, d = typeof u == "function" ? u : (q) => q !== u;
  if (!pg(e))
    throw new TypeError("Invalid target");
  const f = document.scrollingElement || document.documentElement, p = [];
  let g = e;
  for (; pg(g) && d(g); ) {
    if (g = tA(g), g === f) {
      p.push(g);
      break;
    }
    g != null && g === document.body && od(g) && !od(document.documentElement) || g != null && od(g, c) && p.push(g);
  }
  const m = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, y = (a = (i = window.visualViewport) == null ? void 0 : i.height) != null ? a : innerHeight, { scrollX: v, scrollY: E } = window, { height: b, width: _, top: T, right: x, bottom: A, left: R } = e.getBoundingClientRect(), { top: P, right: L, bottom: I, left: O } = ((q) => {
    const N = window.getComputedStyle(q);
    return { top: parseFloat(N.scrollMarginTop) || 0, right: parseFloat(N.scrollMarginRight) || 0, bottom: parseFloat(N.scrollMarginBottom) || 0, left: parseFloat(N.scrollMarginLeft) || 0 };
  })(e);
  let S = o === "start" || o === "nearest" ? T - P : o === "end" ? A + I : T + b / 2 - P + I, F = l === "center" ? R + _ / 2 - O + L : l === "end" ? x + L : R - O;
  const H = [];
  for (let q = 0; q < p.length; q++) {
    const N = p[q], { height: Q, width: J, top: D, right: C, bottom: Z, left: B } = N.getBoundingClientRect();
    if (s === "if-needed" && T >= 0 && R >= 0 && A <= y && x <= m && T >= D && A <= Z && R >= B && x <= C)
      return H;
    const j = getComputedStyle(N), z = parseInt(j.borderLeftWidth, 10), U = parseInt(j.borderTopWidth, 10), $ = parseInt(j.borderRightWidth, 10), ae = parseInt(j.borderBottomWidth, 10);
    let Y = 0, ee = 0;
    const se = "offsetWidth" in N ? N.offsetWidth - N.clientWidth - z - $ : 0, re = "offsetHeight" in N ? N.offsetHeight - N.clientHeight - U - ae : 0, Ae = "offsetWidth" in N ? N.offsetWidth === 0 ? 0 : J / N.offsetWidth : 0, Oe = "offsetHeight" in N ? N.offsetHeight === 0 ? 0 : Q / N.offsetHeight : 0;
    if (f === N)
      Y = o === "start" ? S : o === "end" ? S - y : o === "nearest" ? au(E, E + y, y, U, ae, E + S, E + S + b, b) : S - y / 2, ee = l === "start" ? F : l === "center" ? F - m / 2 : l === "end" ? F - m : au(v, v + m, m, z, $, v + F, v + F + _, _), Y = Math.max(0, Y + E), ee = Math.max(0, ee + v);
    else {
      Y = o === "start" ? S - D - U : o === "end" ? S - Z + ae + re : o === "nearest" ? au(D, Z, Q, U, ae + re, S, S + b, b) : S - (D + Q / 2) + re / 2, ee = l === "start" ? F - B - z : l === "center" ? F - (B + J / 2) + se / 2 : l === "end" ? F - C + $ + se : au(B, C, J, z, $ + se, F, F + _, _);
      const { scrollLeft: Ce, scrollTop: ue } = N;
      Y = Oe === 0 ? 0 : Math.max(0, Math.min(ue + Y / Oe, N.scrollHeight - Q / Oe + re)), ee = Ae === 0 ? 0 : Math.max(0, Math.min(Ce + ee / Ae, N.scrollWidth - J / Ae + se)), S += ue - Y, F += Ce - ee;
    }
    H.push({ el: N, top: Y, left: ee });
  }
  return H;
}, nA = (e) => e === !1 ? { block: "end", inline: "nearest" } : ((t) => t === Object(t) && Object.keys(t).length !== 0)(e) ? e : { block: "start", inline: "nearest" };
function rA(e, t) {
  if (!e.isConnected || !((i) => {
    let a = i;
    for (; a && a.parentNode; ) {
      if (a.parentNode === document)
        return !0;
      a = a.parentNode instanceof ShadowRoot ? a.parentNode.host : a.parentNode;
    }
    return !1;
  })(e))
    return;
  const n = ((i) => {
    const a = window.getComputedStyle(i);
    return { top: parseFloat(a.scrollMarginTop) || 0, right: parseFloat(a.scrollMarginRight) || 0, bottom: parseFloat(a.scrollMarginBottom) || 0, left: parseFloat(a.scrollMarginLeft) || 0 };
  })(e);
  if (((i) => typeof i == "object" && typeof i.behavior == "function")(t))
    return t.behavior(gg(e, t));
  const r = typeof t == "boolean" || t == null ? void 0 : t.behavior;
  for (const { el: i, top: a, left: s } of gg(e, nA(t))) {
    const o = a - n.top + n.bottom, l = s - n.left + n.right;
    i.scroll({ top: o, left: l, behavior: r });
  }
}
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function vg(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function un(e) {
  var t, n;
  return vg(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !(vg(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
var W4 = Symbol.for("immer-nothing"), yg = Symbol.for("immer-draftable"), Gn = Symbol.for("immer-state"), iA = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function In(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = iA[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var js = Object.getPrototypeOf;
function Ma(e) {
  return !!e && !!e[Gn];
}
function La(e) {
  var t;
  return e ? V4(e) || Array.isArray(e) || !!e[yg] || !!((t = e.constructor) != null && t[yg]) || i1(e) || a1(e) : !1;
}
var aA = Object.prototype.constructor.toString();
function V4(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = js(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === aA;
}
function Mc(e, t) {
  r1(e) === 0 ? Reflect.ownKeys(e).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function r1(e) {
  const t = e[Gn];
  return t ? t.type_ : Array.isArray(e) ? 1 : i1(e) ? 2 : a1(e) ? 3 : 0;
}
function ch(e, t) {
  return r1(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function K4(e, t, n) {
  const r = r1(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function sA(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function i1(e) {
  return e instanceof Map;
}
function a1(e) {
  return e instanceof Set;
}
function wa(e) {
  return e.copy_ || e.base_;
}
function dh(e, t) {
  if (i1(e))
    return new Map(e);
  if (a1(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = V4(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[Gn];
    let i = Reflect.ownKeys(r);
    for (let a = 0; a < i.length; a++) {
      const s = i[a], o = r[s];
      o.writable === !1 && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[s] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: o.enumerable,
        value: e[s]
      });
    }
    return Object.create(js(e), r);
  } else {
    const r = js(e);
    if (r !== null && n)
      return { ...e };
    const i = Object.create(r);
    return Object.assign(i, e);
  }
}
function Op(e, t = !1) {
  return s1(e) || Ma(e) || !La(e) || (r1(e) > 1 && (e.set = e.add = e.clear = e.delete = oA), Object.freeze(e), t && Object.entries(e).forEach(([n, r]) => Op(r, !0))), e;
}
function oA() {
  In(2);
}
function s1(e) {
  return Object.isFrozen(e);
}
var lA = {};
function $a(e) {
  const t = lA[e];
  return t || In(0, e), t;
}
var ml;
function G4() {
  return ml;
}
function uA(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function Eg(e, t) {
  t && ($a("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function fh(e) {
  hh(e), e.drafts_.forEach(cA), e.drafts_ = null;
}
function hh(e) {
  e === ml && (ml = e.parent_);
}
function bg(e) {
  return ml = uA(ml, e);
}
function cA(e) {
  const t = e[Gn];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function Tg(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[Gn].modified_ && (fh(t), In(4)), La(e) && (e = Lc(t, e), t.parent_ || $c(t, e)), t.patches_ && $a("Patches").generateReplacementPatches_(
    n[Gn].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = Lc(t, n, []), fh(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== W4 ? e : void 0;
}
function Lc(e, t, n) {
  if (s1(t))
    return t;
  const r = t[Gn];
  if (!r)
    return Mc(
      t,
      (i, a) => _g(e, r, t, i, a, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return $c(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const i = r.copy_;
    let a = i, s = !1;
    r.type_ === 3 && (a = new Set(i), i.clear(), s = !0), Mc(
      a,
      (o, l) => _g(e, r, i, o, l, n, s)
    ), $c(e, i, !1), n && e.patches_ && $a("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function _g(e, t, n, r, i, a, s) {
  if (process.env.NODE_ENV !== "production" && i === n && In(5), Ma(i)) {
    const o = a && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !ch(t.assigned_, r) ? a.concat(r) : void 0, l = Lc(e, i, o);
    if (K4(n, r, l), Ma(l))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else
    s && n.add(i);
  if (La(i) && !s1(i)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    Lc(e, i), (!t || !t.scope_.parent_) && typeof r != "symbol" && Object.prototype.propertyIsEnumerable.call(n, r) && $c(e, i);
  }
}
function $c(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Op(t, n);
}
function dA(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : G4(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = r, a = Np;
  n && (i = [r], a = gl);
  const { revoke: s, proxy: o } = Proxy.revocable(i, a);
  return r.draft_ = o, r.revoke_ = s, o;
}
var Np = {
  get(e, t) {
    if (t === Gn)
      return e;
    const n = wa(e);
    if (!ch(n, t))
      return fA(e, n, t);
    const r = n[t];
    return e.finalized_ || !La(r) ? r : r === ld(e.base_, t) ? (ud(e), e.copy_[t] = mh(r, e)) : r;
  },
  has(e, t) {
    return t in wa(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(wa(e));
  },
  set(e, t, n) {
    const r = Y4(wa(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const i = ld(wa(e), t), a = i == null ? void 0 : i[Gn];
      if (a && a.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (sA(n, i) && (n !== void 0 || ch(e.base_, t)))
        return !0;
      ud(e), ph(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return ld(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, ud(e), ph(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = wa(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    In(11);
  },
  getPrototypeOf(e) {
    return js(e.base_);
  },
  setPrototypeOf() {
    In(12);
  }
}, gl = {};
Mc(Np, (e, t) => {
  gl[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
gl.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && In(13), gl.set.call(this, e, t, void 0);
};
gl.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && In(14), Np.set.call(this, e[0], t, n, e[0]);
};
function ld(e, t) {
  const n = e[Gn];
  return (n ? wa(n) : e)[t];
}
function fA(e, t, n) {
  var i;
  const r = Y4(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (i = r.get) == null ? void 0 : i.call(e.draft_)
  ) : void 0;
}
function Y4(e, t) {
  if (!(t in e))
    return;
  let n = js(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = js(n);
  }
}
function ph(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && ph(e.parent_));
}
function ud(e) {
  e.copy_ || (e.copy_ = dh(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var hA = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const a = n;
        n = t;
        const s = this;
        return function(l = a, ...u) {
          return s.produce(l, (c) => n.call(this, c, ...u));
        };
      }
      typeof n != "function" && In(6), r !== void 0 && typeof r != "function" && In(7);
      let i;
      if (La(t)) {
        const a = bg(this), s = mh(t, void 0);
        let o = !0;
        try {
          i = n(s), o = !1;
        } finally {
          o ? fh(a) : hh(a);
        }
        return Eg(a, r), Tg(i, a);
      } else if (!t || typeof t != "object") {
        if (i = n(t), i === void 0 && (i = t), i === W4 && (i = void 0), this.autoFreeze_ && Op(i, !0), r) {
          const a = [], s = [];
          $a("Patches").generateReplacementPatches_(t, i, a, s), r(a, s);
        }
        return i;
      } else
        In(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (s, ...o) => this.produceWithPatches(s, (l) => t(l, ...o));
      let r, i;
      return [this.produce(t, n, (s, o) => {
        r = s, i = o;
      }), r, i];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    La(e) || In(8), Ma(e) && (e = pA(e));
    const t = bg(this), n = mh(e, void 0);
    return n[Gn].isManual_ = !0, hh(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[Gn];
    (!n || !n.isManual_) && In(9);
    const { scope_: r } = n;
    return Eg(r, t), Tg(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const i = t[n];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = $a("Patches").applyPatches_;
    return Ma(e) ? r(e, t) : this.produce(
      e,
      (i) => r(i, t)
    );
  }
};
function mh(e, t) {
  const n = i1(e) ? $a("MapSet").proxyMap_(e, t) : a1(e) ? $a("MapSet").proxySet_(e, t) : dA(e, t);
  return (t ? t.scope_ : G4()).drafts_.push(n), n;
}
function pA(e) {
  return Ma(e) || In(10, e), Z4(e);
}
function Z4(e) {
  if (!La(e) || s1(e))
    return e;
  const t = e[Gn];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = dh(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = dh(e, !0);
  return Mc(n, (r, i) => {
    K4(n, r, Z4(i));
  }), t && (t.finalized_ = !1), n;
}
var Yn = new hA(), Ip = Yn.produce;
Yn.produceWithPatches.bind(
  Yn
);
Yn.setAutoFreeze.bind(Yn);
Yn.setUseStrictShallowCopy.bind(Yn);
Yn.applyPatches.bind(Yn);
var Cg = Yn.createDraft.bind(Yn), xg = Yn.finishDraft.bind(Yn), mA = {
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var i = V.transform(n, t, {
        affinity: r
      });
      e.current = i, i == null && e.unref();
    }
  }
}, gA = {
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var i = Xe.transform(n, t, {
        affinity: r
      });
      e.current = i, i == null && e.unref();
    }
  }
}, vA = {
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var i = oe.transform(n, t, {
        affinity: r
      });
      e.current = i, i == null && e.unref();
    }
  }
}, jc = /* @__PURE__ */ new WeakMap(), Hc = /* @__PURE__ */ new WeakMap(), qo = /* @__PURE__ */ new WeakMap(), Q4 = /* @__PURE__ */ new WeakMap(), wg = /* @__PURE__ */ new WeakMap(), Ag = /* @__PURE__ */ new WeakMap(), Sg = /* @__PURE__ */ new WeakMap(), V = {
  ancestors(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, r = V.levels(e, t);
    return n ? r = r.slice(1) : r = r.slice(0, -1), r;
  },
  common(e, t) {
    for (var n = [], r = 0; r < e.length && r < t.length; r++) {
      var i = e[r], a = t[r];
      if (i !== a)
        break;
      n.push(i);
    }
    return n;
  },
  compare(e, t) {
    for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
      if (e[r] < t[r])
        return -1;
      if (e[r] > t[r])
        return 1;
    }
    return 0;
  },
  endsAfter(e, t) {
    var n = e.length - 1, r = e.slice(0, n), i = t.slice(0, n), a = e[n], s = t[n];
    return V.equals(r, i) && a > s;
  },
  endsAt(e, t) {
    var n = e.length, r = e.slice(0, n), i = t.slice(0, n);
    return V.equals(r, i);
  },
  endsBefore(e, t) {
    var n = e.length - 1, r = e.slice(0, n), i = t.slice(0, n), a = e[n], s = t[n];
    return V.equals(r, i) && a < s;
  },
  equals(e, t) {
    return e.length === t.length && e.every((n, r) => n === t[r]);
  },
  hasPrevious(e) {
    return e[e.length - 1] > 0;
  },
  isAfter(e, t) {
    return V.compare(e, t) === 1;
  },
  isAncestor(e, t) {
    return e.length < t.length && V.compare(e, t) === 0;
  },
  isBefore(e, t) {
    return V.compare(e, t) === -1;
  },
  isChild(e, t) {
    return e.length === t.length + 1 && V.compare(e, t) === 0;
  },
  isCommon(e, t) {
    return e.length <= t.length && V.compare(e, t) === 0;
  },
  isDescendant(e, t) {
    return e.length > t.length && V.compare(e, t) === 0;
  },
  isParent(e, t) {
    return e.length + 1 === t.length && V.compare(e, t) === 0;
  },
  isPath(e) {
    return Array.isArray(e) && (e.length === 0 || typeof e[0] == "number");
  },
  isSibling(e, t) {
    if (e.length !== t.length)
      return !1;
    var n = e.slice(0, -1), r = t.slice(0, -1), i = e[e.length - 1], a = t[t.length - 1];
    return i !== a && V.equals(n, r);
  },
  levels(e) {
    for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, r = [], i = 0; i <= e.length; i++)
      r.push(e.slice(0, i));
    return n && r.reverse(), r;
  },
  next(e) {
    if (e.length === 0)
      throw new Error("Cannot get the next path of a root path [".concat(e, "], because it has no next index."));
    var t = e[e.length - 1];
    return e.slice(0, -1).concat(t + 1);
  },
  operationCanTransformPath(e) {
    switch (e.type) {
      case "insert_node":
      case "remove_node":
      case "merge_node":
      case "split_node":
      case "move_node":
        return !0;
      default:
        return !1;
    }
  },
  parent(e) {
    if (e.length === 0)
      throw new Error("Cannot get the parent path of the root path [".concat(e, "]."));
    return e.slice(0, -1);
  },
  previous(e) {
    if (e.length === 0)
      throw new Error("Cannot get the previous path of a root path [".concat(e, "], because it has no previous index."));
    var t = e[e.length - 1];
    if (t <= 0)
      throw new Error("Cannot get the previous path of a first child path [".concat(e, "] because it would result in a negative index."));
    return e.slice(0, -1).concat(t - 1);
  },
  relative(e, t) {
    if (!V.isAncestor(t, e) && !V.equals(e, t))
      throw new Error("Cannot get the relative path of [".concat(e, "] inside ancestor [").concat(t, "], because it is not above or equal to the path."));
    return e.slice(t.length);
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!e)
      return null;
    var r = [...e], {
      affinity: i = "forward"
    } = n;
    if (e.length === 0)
      return r;
    switch (t.type) {
      case "insert_node": {
        var {
          path: a
        } = t;
        (V.equals(a, r) || V.endsBefore(a, r) || V.isAncestor(a, r)) && (r[a.length - 1] += 1);
        break;
      }
      case "remove_node": {
        var {
          path: s
        } = t;
        if (V.equals(s, r) || V.isAncestor(s, r))
          return null;
        V.endsBefore(s, r) && (r[s.length - 1] -= 1);
        break;
      }
      case "merge_node": {
        var {
          path: o,
          position: l
        } = t;
        V.equals(o, r) || V.endsBefore(o, r) ? r[o.length - 1] -= 1 : V.isAncestor(o, r) && (r[o.length - 1] -= 1, r[o.length] += l);
        break;
      }
      case "split_node": {
        var {
          path: u,
          position: c
        } = t;
        if (V.equals(u, r)) {
          if (i === "forward")
            r[r.length - 1] += 1;
          else if (i !== "backward")
            return null;
        } else
          V.endsBefore(u, r) ? r[u.length - 1] += 1 : V.isAncestor(u, r) && e[u.length] >= c && (r[u.length - 1] += 1, r[u.length] -= c);
        break;
      }
      case "move_node": {
        var {
          path: d,
          newPath: f
        } = t;
        if (V.equals(d, f))
          return r;
        if (V.isAncestor(d, r) || V.equals(d, r)) {
          var p = f.slice();
          return V.endsBefore(d, f) && d.length < f.length && (p[d.length - 1] -= 1), p.concat(r.slice(d.length));
        } else
          V.isSibling(d, f) && (V.isAncestor(f, r) || V.equals(f, r)) ? V.endsBefore(d, r) ? r[d.length - 1] -= 1 : r[d.length - 1] += 1 : V.endsBefore(f, r) || V.equals(f, r) || V.isAncestor(f, r) ? (V.endsBefore(d, r) && (r[d.length - 1] -= 1), r[f.length - 1] += 1) : V.endsBefore(d, r) && (V.equals(f, r) && (r[f.length - 1] += 1), r[d.length - 1] -= 1);
        break;
      }
    }
    return r;
  }
};
function vl(e) {
  "@babel/helpers - typeof";
  return vl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vl(e);
}
function yA(e, t) {
  if (vl(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (vl(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function EA(e) {
  var t = yA(e, "string");
  return vl(t) === "symbol" ? t : String(t);
}
function xn(e, t, n) {
  return t = EA(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function kg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var bA = (e, t, n) => {
  switch (n.type) {
    case "insert_node": {
      var {
        path: r,
        node: i
      } = n, a = be.parent(e, r), s = r[r.length - 1];
      if (s > a.children.length)
        throw new Error('Cannot apply an "insert_node" operation at path ['.concat(r, "] because the destination is past the end of the node."));
      if (a.children.splice(s, 0, i), t)
        for (var [o, l] of oe.points(t))
          t[l] = Xe.transform(o, n);
      break;
    }
    case "insert_text": {
      var {
        path: u,
        offset: c,
        text: d
      } = n;
      if (d.length === 0)
        break;
      var f = be.leaf(e, u), p = f.text.slice(0, c), g = f.text.slice(c);
      if (f.text = p + d + g, t)
        for (var [m, y] of oe.points(t))
          t[y] = Xe.transform(m, n);
      break;
    }
    case "merge_node": {
      var {
        path: v
      } = n, E = be.get(e, v), b = V.previous(v), _ = be.get(e, b), T = be.parent(e, v), x = v[v.length - 1];
      if (Ie.isText(E) && Ie.isText(_))
        _.text += E.text;
      else if (!Ie.isText(E) && !Ie.isText(_))
        _.children.push(...E.children);
      else
        throw new Error('Cannot apply a "merge_node" operation at path ['.concat(v, "] to nodes of different interfaces: ").concat(nn.stringify(E), " ").concat(nn.stringify(_)));
      if (T.children.splice(x, 1), t)
        for (var [A, R] of oe.points(t))
          t[R] = Xe.transform(A, n);
      break;
    }
    case "move_node": {
      var {
        path: P,
        newPath: L
      } = n;
      if (V.isAncestor(P, L))
        throw new Error("Cannot move a path [".concat(P, "] to new path [").concat(L, "] because the destination is inside itself."));
      var I = be.get(e, P), O = be.parent(e, P), S = P[P.length - 1];
      O.children.splice(S, 1);
      var F = V.transform(P, n), H = be.get(e, V.parent(F)), q = F[F.length - 1];
      if (H.children.splice(q, 0, I), t)
        for (var [N, Q] of oe.points(t))
          t[Q] = Xe.transform(N, n);
      break;
    }
    case "remove_node": {
      var {
        path: J
      } = n, D = J[J.length - 1], C = be.parent(e, J);
      if (C.children.splice(D, 1), t)
        for (var [Z, B] of oe.points(t)) {
          var j = Xe.transform(Z, n);
          if (t != null && j != null)
            t[B] = j;
          else {
            var z = void 0, U = void 0;
            for (var [$, ae] of be.texts(e))
              if (V.compare(ae, J) === -1)
                z = [$, ae];
              else {
                U = [$, ae];
                break;
              }
            var Y = !1;
            z && U && (V.equals(U[1], J) ? Y = !V.hasPrevious(U[1]) : Y = V.common(z[1], J).length < V.common(U[1], J).length), z && !Y ? (Z.path = z[1], Z.offset = z[0].text.length) : U ? (Z.path = U[1], Z.offset = 0) : t = null;
          }
        }
      break;
    }
    case "remove_text": {
      var {
        path: ee,
        offset: se,
        text: re
      } = n;
      if (re.length === 0)
        break;
      var Ae = be.leaf(e, ee), Oe = Ae.text.slice(0, se), Ce = Ae.text.slice(se + re.length);
      if (Ae.text = Oe + Ce, t)
        for (var [ue, fe] of oe.points(t))
          t[fe] = Xe.transform(ue, n);
      break;
    }
    case "set_node": {
      var {
        path: Se,
        properties: Fe,
        newProperties: nt
      } = n;
      if (Se.length === 0)
        throw new Error("Cannot set properties on the root node!");
      var mt = be.get(e, Se);
      for (var Ze in nt) {
        if (Ze === "children" || Ze === "text")
          throw new Error('Cannot set the "'.concat(Ze, '" property of nodes!'));
        var rt = nt[Ze];
        rt == null ? delete mt[Ze] : mt[Ze] = rt;
      }
      for (var Qe in Fe)
        nt.hasOwnProperty(Qe) || delete mt[Qe];
      break;
    }
    case "set_selection": {
      var {
        newProperties: ie
      } = n;
      if (ie == null)
        t = ie;
      else {
        if (t == null) {
          if (!oe.isRange(ie))
            throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(nn.stringify(ie), " when there is no current selection."));
          t = fo({}, ie);
        }
        for (var me in ie) {
          var Pe = ie[me];
          if (Pe == null) {
            if (me === "anchor" || me === "focus")
              throw new Error('Cannot remove the "'.concat(me, '" selection property'));
            delete t[me];
          } else
            t[me] = Pe;
        }
      }
      break;
    }
    case "split_node": {
      var {
        path: ge,
        position: X,
        properties: xe
      } = n;
      if (ge.length === 0)
        throw new Error('Cannot apply a "split_node" operation at path ['.concat(ge, "] because the root node cannot be split."));
      var ve = be.get(e, ge), Ne = be.parent(e, ge), Tt = ge[ge.length - 1], Ge;
      if (Ie.isText(ve)) {
        var gt = ve.text.slice(0, X), qt = ve.text.slice(X);
        ve.text = gt, Ge = fo(fo({}, xe), {}, {
          text: qt
        });
      } else {
        var wt = ve.children.slice(0, X), wn = ve.children.slice(X);
        ve.children = wt, Ge = fo(fo({}, xe), {}, {
          children: wn
        });
      }
      if (Ne.children.splice(Tt + 1, 0, Ge), t)
        for (var [At, Rr] of oe.points(t))
          t[Rr] = Xe.transform(At, n);
      break;
    }
  }
  return t;
}, TA = {
  transform(e, t) {
    e.children = Cg(e.children);
    var n = e.selection && Cg(e.selection);
    try {
      n = bA(e, n, t);
    } finally {
      e.children = xg(e.children), n ? e.selection = Ma(n) ? xg(n) : n : e.selection = null;
    }
  }
}, _A = {
  insertNodes(e, t, n) {
    e.insertNodes(t, n);
  },
  liftNodes(e, t) {
    e.liftNodes(t);
  },
  mergeNodes(e, t) {
    e.mergeNodes(t);
  },
  moveNodes(e, t) {
    e.moveNodes(t);
  },
  removeNodes(e, t) {
    e.removeNodes(t);
  },
  setNodes(e, t, n) {
    e.setNodes(t, n);
  },
  splitNodes(e, t) {
    e.splitNodes(t);
  },
  unsetNodes(e, t, n) {
    e.unsetNodes(t, n);
  },
  unwrapNodes(e, t) {
    e.unwrapNodes(t);
  },
  wrapNodes(e, t, n) {
    e.wrapNodes(t, n);
  }
}, CA = {
  collapse(e, t) {
    e.collapse(t);
  },
  deselect(e) {
    e.deselect();
  },
  move(e, t) {
    e.move(t);
  },
  select(e, t) {
    e.select(t);
  },
  setPoint(e, t, n) {
    e.setPoint(t, n);
  },
  setSelection(e, t) {
    e.setSelection(t);
  }
}, X4 = (e, t) => {
  for (var n in e) {
    var r = e[n], i = t[n];
    if (un(r) && un(i)) {
      if (!X4(r, i))
        return !1;
    } else if (Array.isArray(r) && Array.isArray(i)) {
      if (r.length !== i.length)
        return !1;
      for (var a = 0; a < r.length; a++)
        if (r[a] !== i[a])
          return !1;
    } else if (r !== i)
      return !1;
  }
  for (var s in t)
    if (e[s] === void 0 && t[s] !== void 0)
      return !1;
  return !0;
};
function xA(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function xi(e, t) {
  if (e == null)
    return {};
  var n = xA(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var wA = ["anchor", "focus"];
function Dg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function AA(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Dg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var oe = {
  edges(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, {
      anchor: r,
      focus: i
    } = e;
    return oe.isBackward(e) === n ? [r, i] : [i, r];
  },
  end(e) {
    var [, t] = oe.edges(e);
    return t;
  },
  equals(e, t) {
    return Xe.equals(e.anchor, t.anchor) && Xe.equals(e.focus, t.focus);
  },
  includes(e, t) {
    if (oe.isRange(t)) {
      if (oe.includes(e, t.anchor) || oe.includes(e, t.focus))
        return !0;
      var [n, r] = oe.edges(e), [i, a] = oe.edges(t);
      return Xe.isBefore(n, i) && Xe.isAfter(r, a);
    }
    var [s, o] = oe.edges(e), l = !1, u = !1;
    return Xe.isPoint(t) ? (l = Xe.compare(t, s) >= 0, u = Xe.compare(t, o) <= 0) : (l = V.compare(t, s.path) >= 0, u = V.compare(t, o.path) <= 0), l && u;
  },
  intersection(e, t) {
    var n = xi(e, wA), [r, i] = oe.edges(e), [a, s] = oe.edges(t), o = Xe.isBefore(r, a) ? a : r, l = Xe.isBefore(i, s) ? i : s;
    return Xe.isBefore(l, o) ? null : AA({
      anchor: o,
      focus: l
    }, n);
  },
  isBackward(e) {
    var {
      anchor: t,
      focus: n
    } = e;
    return Xe.isAfter(t, n);
  },
  isCollapsed(e) {
    var {
      anchor: t,
      focus: n
    } = e;
    return Xe.equals(t, n);
  },
  isExpanded(e) {
    return !oe.isCollapsed(e);
  },
  isForward(e) {
    return !oe.isBackward(e);
  },
  isRange(e) {
    return un(e) && Xe.isPoint(e.anchor) && Xe.isPoint(e.focus);
  },
  *points(e) {
    yield [e.anchor, "anchor"], yield [e.focus, "focus"];
  },
  start(e) {
    var [t] = oe.edges(e);
    return t;
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Ip(e, (r) => {
      if (r === null)
        return null;
      var {
        affinity: i = "inward"
      } = n, a, s;
      if (i === "inward") {
        var o = oe.isCollapsed(r);
        oe.isForward(r) ? (a = "forward", s = o ? a : "backward") : (a = "backward", s = o ? a : "forward");
      } else
        i === "outward" ? oe.isForward(r) ? (a = "backward", s = "forward") : (a = "forward", s = "backward") : (a = i, s = i);
      var l = Xe.transform(r.anchor, t, {
        affinity: a
      }), u = Xe.transform(r.focus, t, {
        affinity: s
      });
      if (!l || !u)
        return null;
      r.anchor = l, r.focus = u;
    });
  }
}, Og = (e) => un(e) && be.isNodeList(e.children) && !k.isEditor(e), De = {
  isAncestor(e) {
    return un(e) && be.isNodeList(e.children);
  },
  isElement: Og,
  isElementList(e) {
    return Array.isArray(e) && e.every((t) => De.isElement(t));
  },
  isElementProps(e) {
    return e.children !== void 0;
  },
  isElementType: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
    return Og(t) && t[r] === n;
  },
  matches(e, t) {
    for (var n in t)
      if (n !== "children" && e[n] !== t[n])
        return !1;
    return !0;
  }
}, SA = ["children"], kA = ["text"], Ng = /* @__PURE__ */ new WeakMap(), be = {
  ancestor(e, t) {
    var n = be.get(e, t);
    if (Ie.isText(n))
      throw new Error("Cannot get the ancestor node at path [".concat(t, "] because it refers to a text node instead: ").concat(nn.stringify(n)));
    return n;
  },
  ancestors(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var r of V.ancestors(t, n)) {
        var i = be.ancestor(e, r), a = [i, r];
        yield a;
      }
    }();
  },
  child(e, t) {
    if (Ie.isText(e))
      throw new Error("Cannot get the child of a text node: ".concat(nn.stringify(e)));
    var n = e.children[t];
    if (n == null)
      throw new Error("Cannot get child at index `".concat(t, "` in node: ").concat(nn.stringify(e)));
    return n;
  },
  children(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var {
        reverse: r = !1
      } = n, i = be.ancestor(e, t), {
        children: a
      } = i, s = r ? a.length - 1 : 0; r ? s >= 0 : s < a.length; ) {
        var o = be.child(i, s), l = t.concat(s);
        yield [o, l], s = r ? s - 1 : s + 1;
      }
    }();
  },
  common(e, t, n) {
    var r = V.common(t, n), i = be.get(e, r);
    return [i, r];
  },
  descendant(e, t) {
    var n = be.get(e, t);
    if (k.isEditor(n))
      throw new Error("Cannot get the descendant node at path [".concat(t, "] because it refers to the root editor node instead: ").concat(nn.stringify(n)));
    return n;
  },
  descendants(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [n, r] of be.nodes(e, t))
        r.length !== 0 && (yield [n, r]);
    }();
  },
  elements(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [n, r] of be.nodes(e, t))
        De.isElement(n) && (yield [n, r]);
    }();
  },
  extractProps(e) {
    if (De.isAncestor(e)) {
      var t = xi(e, SA);
      return t;
    } else {
      var t = xi(e, kA);
      return t;
    }
  },
  first(e, t) {
    for (var n = t.slice(), r = be.get(e, n); r && !(Ie.isText(r) || r.children.length === 0); )
      r = r.children[0], n.push(0);
    return [r, n];
  },
  fragment(e, t) {
    if (Ie.isText(e))
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(nn.stringify(e)));
    var n = Ip({
      children: e.children
    }, (r) => {
      var [i, a] = oe.edges(t), s = be.nodes(r, {
        reverse: !0,
        pass: (f) => {
          var [, p] = f;
          return !oe.includes(t, p);
        }
      });
      for (var [, o] of s) {
        if (!oe.includes(t, o)) {
          var l = be.parent(r, o), u = o[o.length - 1];
          l.children.splice(u, 1);
        }
        if (V.equals(o, a.path)) {
          var c = be.leaf(r, o);
          c.text = c.text.slice(0, a.offset);
        }
        if (V.equals(o, i.path)) {
          var d = be.leaf(r, o);
          d.text = d.text.slice(i.offset);
        }
      }
      k.isEditor(r) && (r.selection = null);
    });
    return n.children;
  },
  get(e, t) {
    for (var n = e, r = 0; r < t.length; r++) {
      var i = t[r];
      if (Ie.isText(n) || !n.children[i])
        throw new Error("Cannot find a descendant at path [".concat(t, "] in node: ").concat(nn.stringify(e)));
      n = n.children[i];
    }
    return n;
  },
  has(e, t) {
    for (var n = e, r = 0; r < t.length; r++) {
      var i = t[r];
      if (Ie.isText(n) || !n.children[i])
        return !1;
      n = n.children[i];
    }
    return !0;
  },
  isNode(e) {
    return Ie.isText(e) || De.isElement(e) || k.isEditor(e);
  },
  isNodeList(e) {
    if (!Array.isArray(e))
      return !1;
    var t = Ng.get(e);
    if (t !== void 0)
      return t;
    var n = e.every((r) => be.isNode(r));
    return Ng.set(e, n), n;
  },
  last(e, t) {
    for (var n = t.slice(), r = be.get(e, n); r && !(Ie.isText(r) || r.children.length === 0); ) {
      var i = r.children.length - 1;
      r = r.children[i], n.push(i);
    }
    return [r, n];
  },
  leaf(e, t) {
    var n = be.get(e, t);
    if (!Ie.isText(n))
      throw new Error("Cannot get the leaf node at path [".concat(t, "] because it refers to a non-leaf node: ").concat(nn.stringify(n)));
    return n;
  },
  levels(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return function* () {
      for (var r of V.levels(t, n)) {
        var i = be.get(e, r);
        yield [i, r];
      }
    }();
  },
  matches(e, t) {
    return De.isElement(e) && De.isElementProps(t) && De.matches(e, t) || Ie.isText(e) && Ie.isTextProps(t) && Ie.matches(e, t);
  },
  nodes(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var {
        pass: n,
        reverse: r = !1
      } = t, {
        from: i = [],
        to: a
      } = t, s = /* @__PURE__ */ new Set(), o = [], l = e; !(a && (r ? V.isBefore(o, a) : V.isAfter(o, a))); ) {
        if (s.has(l) || (yield [l, o]), !s.has(l) && !Ie.isText(l) && l.children.length !== 0 && (n == null || n([l, o]) === !1)) {
          s.add(l);
          var u = r ? l.children.length - 1 : 0;
          V.isAncestor(o, i) && (u = i[o.length]), o = o.concat(u), l = be.get(e, o);
          continue;
        }
        if (o.length === 0)
          break;
        if (!r) {
          var c = V.next(o);
          if (be.has(e, c)) {
            o = c, l = be.get(e, o);
            continue;
          }
        }
        if (r && o[o.length - 1] !== 0) {
          var d = V.previous(o);
          o = d, l = be.get(e, o);
          continue;
        }
        o = V.parent(o), l = be.get(e, o), s.add(l);
      }
    }();
  },
  parent(e, t) {
    var n = V.parent(t), r = be.get(e, n);
    if (Ie.isText(r))
      throw new Error("Cannot get the parent of path [".concat(t, "] because it does not exist in the root."));
    return r;
  },
  string(e) {
    return Ie.isText(e) ? e.text : e.children.map(be.string).join("");
  },
  texts(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function* () {
      for (var [n, r] of be.nodes(e, t))
        Ie.isText(n) && (yield [n, r]);
    }();
  }
};
function Ig(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Mt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ig(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ig(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Zi = {
  isNodeOperation(e) {
    return Zi.isOperation(e) && e.type.endsWith("_node");
  },
  isOperation(e) {
    if (!un(e))
      return !1;
    switch (e.type) {
      case "insert_node":
        return V.isPath(e.path) && be.isNode(e.node);
      case "insert_text":
        return typeof e.offset == "number" && typeof e.text == "string" && V.isPath(e.path);
      case "merge_node":
        return typeof e.position == "number" && V.isPath(e.path) && un(e.properties);
      case "move_node":
        return V.isPath(e.path) && V.isPath(e.newPath);
      case "remove_node":
        return V.isPath(e.path) && be.isNode(e.node);
      case "remove_text":
        return typeof e.offset == "number" && typeof e.text == "string" && V.isPath(e.path);
      case "set_node":
        return V.isPath(e.path) && un(e.properties) && un(e.newProperties);
      case "set_selection":
        return e.properties === null && oe.isRange(e.newProperties) || e.newProperties === null && oe.isRange(e.properties) || un(e.properties) && un(e.newProperties);
      case "split_node":
        return V.isPath(e.path) && typeof e.position == "number" && un(e.properties);
      default:
        return !1;
    }
  },
  isOperationList(e) {
    return Array.isArray(e) && e.every((t) => Zi.isOperation(t));
  },
  isSelectionOperation(e) {
    return Zi.isOperation(e) && e.type.endsWith("_selection");
  },
  isTextOperation(e) {
    return Zi.isOperation(e) && e.type.endsWith("_text");
  },
  inverse(e) {
    switch (e.type) {
      case "insert_node":
        return Mt(Mt({}, e), {}, {
          type: "remove_node"
        });
      case "insert_text":
        return Mt(Mt({}, e), {}, {
          type: "remove_text"
        });
      case "merge_node":
        return Mt(Mt({}, e), {}, {
          type: "split_node",
          path: V.previous(e.path)
        });
      case "move_node": {
        var {
          newPath: t,
          path: n
        } = e;
        if (V.equals(t, n))
          return e;
        if (V.isSibling(n, t))
          return Mt(Mt({}, e), {}, {
            path: t,
            newPath: n
          });
        var r = V.transform(n, e), i = V.transform(V.next(n), e);
        return Mt(Mt({}, e), {}, {
          path: r,
          newPath: i
        });
      }
      case "remove_node":
        return Mt(Mt({}, e), {}, {
          type: "insert_node"
        });
      case "remove_text":
        return Mt(Mt({}, e), {}, {
          type: "insert_text"
        });
      case "set_node": {
        var {
          properties: a,
          newProperties: s
        } = e;
        return Mt(Mt({}, e), {}, {
          properties: s,
          newProperties: a
        });
      }
      case "set_selection": {
        var {
          properties: o,
          newProperties: l
        } = e;
        return o == null ? Mt(Mt({}, e), {}, {
          properties: l,
          newProperties: null
        }) : l == null ? Mt(Mt({}, e), {}, {
          properties: null,
          newProperties: o
        }) : Mt(Mt({}, e), {}, {
          properties: l,
          newProperties: o
        });
      }
      case "split_node":
        return Mt(Mt({}, e), {}, {
          type: "merge_node",
          path: V.next(e.path)
        });
    }
  }
}, Pg = /* @__PURE__ */ new WeakMap(), DA = (e) => {
  var t = Pg.get(e);
  if (t !== void 0)
    return t;
  if (!un(e))
    return !1;
  var n = typeof e.addMark == "function" && typeof e.apply == "function" && typeof e.deleteFragment == "function" && typeof e.insertBreak == "function" && typeof e.insertSoftBreak == "function" && typeof e.insertFragment == "function" && typeof e.insertNode == "function" && typeof e.insertText == "function" && typeof e.isElementReadOnly == "function" && typeof e.isInline == "function" && typeof e.isSelectable == "function" && typeof e.isVoid == "function" && typeof e.normalizeNode == "function" && typeof e.onChange == "function" && typeof e.removeMark == "function" && typeof e.getDirtyPaths == "function" && (e.marks === null || un(e.marks)) && (e.selection === null || oe.isRange(e.selection)) && be.isNodeList(e.children) && Zi.isOperationList(e.operations);
  return Pg.set(e, n), n;
}, k = {
  above(e, t) {
    return e.above(t);
  },
  addMark(e, t, n) {
    e.addMark(t, n);
  },
  after(e, t, n) {
    return e.after(t, n);
  },
  before(e, t, n) {
    return e.before(t, n);
  },
  deleteBackward(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: n = "character"
    } = t;
    e.deleteBackward(n);
  },
  deleteForward(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: n = "character"
    } = t;
    e.deleteForward(n);
  },
  deleteFragment(e, t) {
    e.deleteFragment(t);
  },
  edges(e, t) {
    return e.edges(t);
  },
  elementReadOnly(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return e.elementReadOnly(t);
  },
  end(e, t) {
    return e.end(t);
  },
  first(e, t) {
    return e.first(t);
  },
  fragment(e, t) {
    return e.fragment(t);
  },
  hasBlocks(e, t) {
    return e.hasBlocks(t);
  },
  hasInlines(e, t) {
    return e.hasInlines(t);
  },
  hasPath(e, t) {
    return e.hasPath(t);
  },
  hasTexts(e, t) {
    return e.hasTexts(t);
  },
  insertBreak(e) {
    e.insertBreak();
  },
  insertFragment(e, t, n) {
    e.insertFragment(t, n);
  },
  insertNode(e, t) {
    e.insertNode(t);
  },
  insertSoftBreak(e) {
    e.insertSoftBreak();
  },
  insertText(e, t) {
    e.insertText(t);
  },
  isBlock(e, t) {
    return e.isBlock(t);
  },
  isEdge(e, t, n) {
    return e.isEdge(t, n);
  },
  isEditor(e) {
    return DA(e);
  },
  isElementReadOnly(e, t) {
    return e.isElementReadOnly(t);
  },
  isEmpty(e, t) {
    return e.isEmpty(t);
  },
  isEnd(e, t, n) {
    return e.isEnd(t, n);
  },
  isInline(e, t) {
    return e.isInline(t);
  },
  isNormalizing(e) {
    return e.isNormalizing();
  },
  isSelectable(e, t) {
    return e.isSelectable(t);
  },
  isStart(e, t, n) {
    return e.isStart(t, n);
  },
  isVoid(e, t) {
    return e.isVoid(t);
  },
  last(e, t) {
    return e.last(t);
  },
  leaf(e, t, n) {
    return e.leaf(t, n);
  },
  levels(e, t) {
    return e.levels(t);
  },
  marks(e) {
    return e.getMarks();
  },
  next(e, t) {
    return e.next(t);
  },
  node(e, t, n) {
    return e.node(t, n);
  },
  nodes(e, t) {
    return e.nodes(t);
  },
  normalize(e, t) {
    e.normalize(t);
  },
  parent(e, t, n) {
    return e.parent(t, n);
  },
  path(e, t, n) {
    return e.path(t, n);
  },
  pathRef(e, t, n) {
    return e.pathRef(t, n);
  },
  pathRefs(e) {
    return e.pathRefs();
  },
  point(e, t, n) {
    return e.point(t, n);
  },
  pointRef(e, t, n) {
    return e.pointRef(t, n);
  },
  pointRefs(e) {
    return e.pointRefs();
  },
  positions(e, t) {
    return e.positions(t);
  },
  previous(e, t) {
    return e.previous(t);
  },
  range(e, t, n) {
    return e.range(t, n);
  },
  rangeRef(e, t, n) {
    return e.rangeRef(t, n);
  },
  rangeRefs(e) {
    return e.rangeRefs();
  },
  removeMark(e, t) {
    e.removeMark(t);
  },
  setNormalizing(e, t) {
    e.setNormalizing(t);
  },
  start(e, t) {
    return e.start(t);
  },
  string(e, t, n) {
    return e.string(t, n);
  },
  unhangRange(e, t, n) {
    return e.unhangRange(t, n);
  },
  void(e, t) {
    return e.void(t);
  },
  withoutNormalizing(e, t) {
    e.withoutNormalizing(t);
  }
}, OA = {
  isSpan(e) {
    return Array.isArray(e) && e.length === 2 && e.every(V.isPath);
  }
};
function Rg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Fg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Rg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Xe = {
  compare(e, t) {
    var n = V.compare(e.path, t.path);
    return n === 0 ? e.offset < t.offset ? -1 : e.offset > t.offset ? 1 : 0 : n;
  },
  isAfter(e, t) {
    return Xe.compare(e, t) === 1;
  },
  isBefore(e, t) {
    return Xe.compare(e, t) === -1;
  },
  equals(e, t) {
    return e.offset === t.offset && V.equals(e.path, t.path);
  },
  isPoint(e) {
    return un(e) && typeof e.offset == "number" && V.isPath(e.path);
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Ip(e, (r) => {
      if (r === null)
        return null;
      var {
        affinity: i = "forward"
      } = n, {
        path: a,
        offset: s
      } = r;
      switch (t.type) {
        case "insert_node":
        case "move_node": {
          r.path = V.transform(a, t, n);
          break;
        }
        case "insert_text": {
          V.equals(t.path, a) && (t.offset < s || t.offset === s && i === "forward") && (r.offset += t.text.length);
          break;
        }
        case "merge_node": {
          V.equals(t.path, a) && (r.offset += t.position), r.path = V.transform(a, t, n);
          break;
        }
        case "remove_text": {
          V.equals(t.path, a) && t.offset <= s && (r.offset -= Math.min(s - t.offset, t.text.length));
          break;
        }
        case "remove_node": {
          if (V.equals(t.path, a) || V.isAncestor(t.path, a))
            return null;
          r.path = V.transform(a, t, n);
          break;
        }
        case "split_node": {
          if (V.equals(t.path, a)) {
            if (t.position === s && i == null)
              return null;
            (t.position < s || t.position === s && i === "forward") && (r.offset -= t.position, r.path = V.transform(a, t, Fg(Fg({}, n), {}, {
              affinity: "forward"
            })));
          } else
            r.path = V.transform(a, t, n);
          break;
        }
      }
    });
  }
}, Bg = void 0, nn = {
  setScrubber(e) {
    Bg = e;
  },
  stringify(e) {
    return JSON.stringify(e, Bg);
  }
}, NA = ["text"], IA = ["anchor", "focus"];
function Mg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ai(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ie = {
  equals(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      loose: r = !1
    } = n;
    function i(a) {
      var s = xi(a, NA);
      return s;
    }
    return X4(r ? i(e) : e, r ? i(t) : t);
  },
  isText(e) {
    return un(e) && typeof e.text == "string";
  },
  isTextList(e) {
    return Array.isArray(e) && e.every((t) => Ie.isText(t));
  },
  isTextProps(e) {
    return e.text !== void 0;
  },
  matches(e, t) {
    for (var n in t)
      if (n !== "text" && (!e.hasOwnProperty(n) || e[n] !== t[n]))
        return !1;
    return !0;
  },
  decorations(e, t) {
    var n = [ai({}, e)];
    for (var r of t) {
      var i = xi(r, IA), [a, s] = oe.edges(r), o = [], l = 0, u = a.offset, c = s.offset;
      for (var d of n) {
        var {
          length: f
        } = d.text, p = l;
        if (l += f, u <= p && l <= c) {
          Object.assign(d, i), o.push(d);
          continue;
        }
        if (u !== c && (u === l || c === p) || u > l || c < p || c === p && p !== 0) {
          o.push(d);
          continue;
        }
        var g = d, m = void 0, y = void 0;
        if (c < l) {
          var v = c - p;
          y = ai(ai({}, g), {}, {
            text: g.text.slice(v)
          }), g = ai(ai({}, g), {}, {
            text: g.text.slice(0, v)
          });
        }
        if (u > p) {
          var E = u - p;
          m = ai(ai({}, g), {}, {
            text: g.text.slice(0, E)
          }), g = ai(ai({}, g), {}, {
            text: g.text.slice(E)
          });
        }
        Object.assign(g, i), m && o.push(m), o.push(g), y && o.push(y);
      }
      n = o;
    }
    return n;
  }
}, Pp = (e) => e.selection ? e.selection : e.children.length > 0 ? k.end(e, []) : [0], Zs = (e, t) => {
  var [n] = k.node(e, t);
  return (r) => r === n;
}, Rp = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = !n, i = n ? LA(t) : t, a = Ve.None, s = Ve.None, o = 0, l = null, u = null;
  for (var c of i) {
    var d = c.codePointAt(0);
    if (!d)
      break;
    var f = ZA(c, d);
    if ([a, s] = r ? [s, f] : [f, a], bs(a, Ve.ZWJ) && bs(s, Ve.ExtPict) && (r ? l = Lg(t.substring(0, o)) : l = Lg(t.substring(0, t.length - o)), !l) || bs(a, Ve.RI) && bs(s, Ve.RI) && (u !== null ? u = !u : r ? u = !0 : u = tS(t.substring(0, t.length - o)), !u) || a !== Ve.None && s !== Ve.None && XA(a, s))
      break;
    o += c.length;
  }
  return o || 1;
}, PA = /\s/, RA = /[\u002B\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, FA = /['\u2018\u2019]/, BA = function(t) {
  for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = 0, i = !1; t.length > 0; ) {
    var a = Rp(t, n), [s, o] = Fp(t, a, n);
    if (MA(s, o, n))
      i = !0, r += a;
    else if (!i)
      r += a;
    else
      break;
    t = o;
  }
  return r;
}, Fp = (e, t, n) => {
  if (n) {
    var r = e.length - t;
    return [e.slice(r, e.length), e.slice(0, r)];
  }
  return [e.slice(0, t), e.slice(t)];
}, MA = function e(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (PA.test(t))
    return !1;
  if (FA.test(t)) {
    var i = Rp(n, r), [a, s] = Fp(n, i, r);
    if (e(a, s, r))
      return !0;
  }
  return !RA.test(t);
}, LA = function* (t) {
  for (var n = t.length - 1, r = 0; r < t.length; r++) {
    var i = t.charAt(n - r);
    if (jA(i.charCodeAt(0))) {
      var a = t.charAt(n - r - 1);
      if ($A(a.charCodeAt(0))) {
        yield a + i, r++;
        continue;
      }
    }
    yield i;
  }
}, $A = (e) => e >= 55296 && e <= 56319, jA = (e) => e >= 56320 && e <= 57343, Ve;
(function(e) {
  e[e.None = 0] = "None", e[e.Extend = 1] = "Extend", e[e.ZWJ = 2] = "ZWJ", e[e.RI = 4] = "RI", e[e.Prepend = 8] = "Prepend", e[e.SpacingMark = 16] = "SpacingMark", e[e.L = 32] = "L", e[e.V = 64] = "V", e[e.T = 128] = "T", e[e.LV = 256] = "LV", e[e.LVT = 512] = "LVT", e[e.ExtPict = 1024] = "ExtPict", e[e.Any = 2048] = "Any";
})(Ve || (Ve = {}));
var HA = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/, UA = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/, zA = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/, qA = /^[\u1100-\u115F\uA960-\uA97C]$/, WA = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/, VA = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/, KA = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/, GA = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/, YA = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/, ZA = (e, t) => {
  var n = Ve.Any;
  return e.search(HA) !== -1 && (n |= Ve.Extend), t === 8205 && (n |= Ve.ZWJ), t >= 127462 && t <= 127487 && (n |= Ve.RI), e.search(UA) !== -1 && (n |= Ve.Prepend), e.search(zA) !== -1 && (n |= Ve.SpacingMark), e.search(qA) !== -1 && (n |= Ve.L), e.search(WA) !== -1 && (n |= Ve.V), e.search(VA) !== -1 && (n |= Ve.T), e.search(KA) !== -1 && (n |= Ve.LV), e.search(GA) !== -1 && (n |= Ve.LVT), e.search(YA) !== -1 && (n |= Ve.ExtPict), n;
};
function bs(e, t) {
  return (e & t) !== 0;
}
var QA = [
  // GB6
  [Ve.L, Ve.L | Ve.V | Ve.LV | Ve.LVT],
  // GB7
  [Ve.LV | Ve.V, Ve.V | Ve.T],
  // GB8
  [Ve.LVT | Ve.T, Ve.T],
  // GB9
  [Ve.Any, Ve.Extend | Ve.ZWJ],
  // GB9a
  [Ve.Any, Ve.SpacingMark],
  // GB9b
  [Ve.Prepend, Ve.Any],
  // GB11
  [Ve.ZWJ, Ve.ExtPict],
  // GB12 and GB13
  [Ve.RI, Ve.RI]
];
function XA(e, t) {
  return QA.findIndex((n) => bs(e, n[0]) && bs(t, n[1])) === -1;
}
var JA = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/, Lg = (e) => e.search(JA) !== -1, eS = /(?:\uD83C[\uDDE6-\uDDFF])+$/g, tS = (e) => {
  var t = e.match(eS);
  if (t === null)
    return !1;
  var n = t[0].length / 2;
  return n % 2 === 1;
}, nS = {
  delete(e, t) {
    e.delete(t);
  },
  insertFragment(e, t, n) {
    e.insertFragment(t, n);
  },
  insertText(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    k.withoutNormalizing(e, () => {
      var {
        voids: r = !1
      } = n, {
        at: i = Pp(e)
      } = n;
      if (V.isPath(i) && (i = k.range(e, i)), oe.isRange(i))
        if (oe.isCollapsed(i))
          i = i.anchor;
        else {
          var a = oe.end(i);
          if (!r && k.void(e, {
            at: a
          }))
            return;
          var s = oe.start(i), o = k.pointRef(e, s), l = k.pointRef(e, a);
          le.delete(e, {
            at: i,
            voids: r
          });
          var u = o.unref(), c = l.unref();
          i = u || c, le.setSelection(e, {
            anchor: i,
            focus: i
          });
        }
      if (!(!r && k.void(e, {
        at: i
      }) || k.elementReadOnly(e, {
        at: i
      }))) {
        var {
          path: d,
          offset: f
        } = i;
        t.length > 0 && e.apply({
          type: "insert_text",
          path: d,
          offset: f,
          text: t
        });
      }
    });
  }
};
function $g(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function su(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $g(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $g(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var le = su(su(su(su({}, TA), _A), CA), nS), oc = /* @__PURE__ */ new WeakMap(), rS = (e) => oc.get(e) || !1, iS = (e, t, n) => {
  var r = oc.get(e) || !1;
  oc.set(e, !0);
  try {
    t(), n();
  } finally {
    oc.set(e, r);
  }
};
function J4(e, t, n) {
  var r = jc.get(e) || [], i = Hc.get(e) || /* @__PURE__ */ new Set(), a, s, o = (d) => {
    if (d) {
      var f = d.join(",");
      s.has(f) || (s.add(f), a.push(d));
    }
  };
  if (n) {
    a = [], s = /* @__PURE__ */ new Set();
    for (var l of r) {
      var u = n(l);
      o(u);
    }
  } else
    a = r, s = i;
  for (var c of t)
    o(c);
  jc.set(e, a), Hc.set(e, s);
}
var aS = (e, t) => {
  for (var n of k.pathRefs(e))
    mA.transform(n, t);
  for (var r of k.pointRefs(e))
    gA.transform(r, t);
  for (var i of k.rangeRefs(e))
    vA.transform(i, t);
  if (!rS(e)) {
    var a = V.operationCanTransformPath(t) ? (s) => V.transform(s, t) : void 0;
    J4(e, e.getDirtyPaths(t), a);
  }
  le.transform(e, t), e.operations.push(t), k.normalize(e, {
    operation: t
  }), t.type === "set_selection" && (e.marks = null), qo.get(e) || (qo.set(e, !0), Promise.resolve().then(() => {
    qo.set(e, !1), e.onChange({
      operation: t
    }), e.operations = [];
  }));
}, sS = (e, t) => {
  switch (t.type) {
    case "insert_text":
    case "remove_text":
    case "set_node": {
      var {
        path: n
      } = t;
      return V.levels(n);
    }
    case "insert_node": {
      var {
        node: r,
        path: i
      } = t, a = V.levels(i), s = Ie.isText(r) ? [] : Array.from(be.nodes(r), (L) => {
        var [, I] = L;
        return i.concat(I);
      });
      return [...a, ...s];
    }
    case "merge_node": {
      var {
        path: o
      } = t, l = V.ancestors(o), u = V.previous(o);
      return [...l, u];
    }
    case "move_node": {
      var {
        path: c,
        newPath: d
      } = t;
      if (V.equals(c, d))
        return [];
      var f = [], p = [];
      for (var g of V.ancestors(c)) {
        var m = V.transform(g, t);
        f.push(m);
      }
      for (var y of V.ancestors(d)) {
        var v = V.transform(y, t);
        p.push(v);
      }
      var E = p[p.length - 1], b = d[d.length - 1], _ = E.concat(b);
      return [...f, ...p, _];
    }
    case "remove_node": {
      var {
        path: T
      } = t, x = V.ancestors(T);
      return [...x];
    }
    case "split_node": {
      var {
        path: A
      } = t, R = V.levels(A), P = V.next(A);
      return [...R, P];
    }
    default:
      return [];
  }
}, oS = (e) => {
  var {
    selection: t
  } = e;
  return t ? be.fragment(e, t) : [];
}, lS = (e, t) => {
  var [n, r] = t;
  if (!Ie.isText(n)) {
    if (De.isElement(n) && n.children.length === 0) {
      var i = {
        text: ""
      };
      le.insertNodes(e, i, {
        at: r.concat(0),
        voids: !0
      });
      return;
    }
    for (var a = k.isEditor(n) ? !1 : De.isElement(n) && (e.isInline(n) || n.children.length === 0 || Ie.isText(n.children[0]) || e.isInline(n.children[0])), s = 0, o = 0; o < n.children.length; o++, s++) {
      var l = be.get(e, r);
      if (!Ie.isText(l)) {
        var u = l.children[s], c = l.children[s - 1], d = o === n.children.length - 1, f = Ie.isText(u) || De.isElement(u) && e.isInline(u);
        if (f !== a)
          le.removeNodes(e, {
            at: r.concat(s),
            voids: !0
          }), s--;
        else if (De.isElement(u)) {
          if (e.isInline(u)) {
            if (c == null || !Ie.isText(c)) {
              var p = {
                text: ""
              };
              le.insertNodes(e, p, {
                at: r.concat(s),
                voids: !0
              }), s++;
            } else if (d) {
              var g = {
                text: ""
              };
              le.insertNodes(e, g, {
                at: r.concat(s + 1),
                voids: !0
              }), s++;
            }
          }
        } else
          c != null && Ie.isText(c) && (Ie.equals(u, c, {
            loose: !0
          }) ? (le.mergeNodes(e, {
            at: r.concat(s),
            voids: !0
          }), s--) : c.text === "" ? (le.removeNodes(e, {
            at: r.concat(s - 1),
            voids: !0
          }), s--) : u.text === "" && (le.removeNodes(e, {
            at: r.concat(s),
            voids: !0
          }), s--));
      }
    }
  }
}, uS = (e, t) => {
  var {
    iteration: n,
    initialDirtyPathsLength: r
  } = t, i = r * 42;
  if (n > i)
    throw new Error("Could not completely normalize the editor after ".concat(i, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
  return !0;
}, cS = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    voids: r = !1,
    mode: i = "lowest",
    at: a = t.selection,
    match: s
  } = n;
  if (a) {
    var o = k.path(t, a), l = i === "lowest";
    for (var [u, c] of k.levels(t, {
      at: o,
      voids: r,
      match: s,
      reverse: l
    }))
      if (!Ie.isText(u)) {
        if (oe.isRange(a)) {
          if (V.isAncestor(c, a.anchor.path) && V.isAncestor(c, a.focus.path))
            return [u, c];
        } else if (!V.equals(o, c))
          return [u, c];
      }
  }
};
function jg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Hg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var dS = (e, t, n) => {
  var {
    selection: r
  } = e;
  if (r) {
    var i = (d, f) => {
      if (!Ie.isText(d))
        return !1;
      var [p, g] = k.parent(e, f);
      return !e.isVoid(p) || e.markableVoid(p);
    }, a = oe.isExpanded(r), s = !1;
    if (!a) {
      var [o, l] = k.node(e, r);
      if (o && i(o, l)) {
        var [u] = k.parent(e, l);
        s = u && e.markableVoid(u);
      }
    }
    if (a || s)
      le.setNodes(e, {
        [t]: n
      }, {
        match: i,
        split: !0,
        voids: !0
      });
    else {
      var c = Hg(Hg({}, k.marks(e) || {}), {}, {
        [t]: n
      });
      e.marks = c, qo.get(e) || e.onChange();
    }
  }
};
function Ug(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ug(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ug(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var fS = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = k.point(t, n, {
    edge: "end"
  }), a = k.end(t, []), s = {
    anchor: i,
    focus: a
  }, {
    distance: o = 1
  } = r, l = 0, u;
  for (var c of k.positions(t, zg(zg({}, r), {}, {
    at: s
  }))) {
    if (l > o)
      break;
    l !== 0 && (u = c), l++;
  }
  return u;
};
function qg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Wg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var hS = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = k.start(t, []), a = k.point(t, n, {
    edge: "start"
  }), s = {
    anchor: i,
    focus: a
  }, {
    distance: o = 1
  } = r, l = 0, u;
  for (var c of k.positions(t, Wg(Wg({}, r), {}, {
    at: s,
    reverse: !0
  }))) {
    if (l > o)
      break;
    l !== 0 && (u = c), l++;
  }
  return u;
}, pS = (e, t) => {
  var {
    selection: n
  } = e;
  n && oe.isCollapsed(n) && le.delete(e, {
    unit: t,
    reverse: !0
  });
}, mS = (e, t) => {
  var {
    selection: n
  } = e;
  n && oe.isCollapsed(n) && le.delete(e, {
    unit: t
  });
}, gS = function(t) {
  var {
    direction: n = "forward"
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    selection: r
  } = t;
  r && oe.isExpanded(r) && le.delete(t, {
    reverse: n === "backward"
  });
}, vS = (e, t) => [k.start(e, t), k.end(e, t)];
function Vg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Kg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var yS = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return k.above(t, Kg(Kg({}, n), {}, {
    match: (r) => De.isElement(r) && k.isElementReadOnly(t, r)
  }));
}, ES = (e, t) => k.point(e, t, {
  edge: "end"
}), bS = (e, t) => {
  var n = k.path(e, t, {
    edge: "start"
  });
  return k.node(e, n);
}, TS = (e, t) => {
  var n = k.range(e, t);
  return be.fragment(e, n);
};
function Gg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Yg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var _S = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return k.above(t, Yg(Yg({}, n), {}, {
    match: (r) => De.isElement(r) && k.isVoid(t, r)
  }));
}, CS = (e, t) => t.children.some((n) => De.isElement(n) && k.isBlock(e, n)), xS = (e, t) => t.children.some((n) => Ie.isText(n) || k.isInline(e, n)), wS = (e, t) => be.has(e, t), AS = (e, t) => t.children.every((n) => Ie.isText(n)), SS = (e) => {
  le.splitNodes(e, {
    always: !0
  });
}, kS = (e, t, n) => {
  le.insertNodes(e, t, n);
}, DS = (e) => {
  le.splitNodes(e, {
    always: !0
  });
};
function Zg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function OS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var NS = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    selection: i,
    marks: a
  } = t;
  if (i) {
    if (a) {
      var s = OS({
        text: n
      }, a);
      le.insertNodes(t, s, {
        at: r.at,
        voids: r.voids
      });
    } else
      le.insertText(t, n, r);
    t.marks = null;
  }
}, IS = (e, t) => !e.isInline(t), PS = (e, t, n) => k.isStart(e, t, n) || k.isEnd(e, t, n), RS = (e, t) => {
  var {
    children: n
  } = t, [r] = n;
  return n.length === 0 || n.length === 1 && Ie.isText(r) && r.text === "" && !e.isVoid(t);
}, FS = (e, t, n) => {
  var r = k.end(e, n);
  return Xe.equals(t, r);
}, BS = (e) => {
  var t = Q4.get(e);
  return t === void 0 ? !0 : t;
}, MS = (e, t, n) => {
  if (t.offset !== 0)
    return !1;
  var r = k.start(e, n);
  return Xe.equals(t, r);
}, LS = (e, t) => {
  var n = k.path(e, t, {
    edge: "end"
  });
  return k.node(e, n);
}, $S = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = k.path(t, n, r), a = be.leaf(t, i);
  return [a, i];
};
function jS(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: n = e.selection,
      reverse: r = !1,
      voids: i = !1
    } = t, {
      match: a
    } = t;
    if (a == null && (a = () => !0), !!n) {
      var s = [], o = k.path(e, n);
      for (var [l, u] of be.levels(e, o))
        if (a(l, u) && (s.push([l, u]), !i && De.isElement(l) && k.isVoid(e, l)))
          break;
      r && s.reverse(), yield* s;
    }
  }();
}
var HS = ["text"], US = ["text"], zS = function(t) {
  var {
    marks: n,
    selection: r
  } = t;
  if (!r)
    return null;
  var {
    anchor: i,
    focus: a
  } = r;
  if (n)
    return n;
  if (oe.isExpanded(r)) {
    var s = k.isEnd(t, i, i.path);
    if (s) {
      var o = k.after(t, i);
      o && (i = o);
    }
    var [l] = k.nodes(t, {
      match: Ie.isText,
      at: {
        anchor: i,
        focus: a
      }
    });
    if (l) {
      var [u] = l, c = xi(u, HS);
      return c;
    } else
      return {};
  }
  var {
    path: d
  } = i, [f] = k.leaf(t, d);
  if (i.offset === 0) {
    var p = k.previous(t, {
      at: d,
      match: Ie.isText
    }), g = k.above(t, {
      match: (_) => De.isElement(_) && k.isVoid(t, _) && t.markableVoid(_)
    });
    if (!g) {
      var m = k.above(t, {
        match: (_) => De.isElement(_) && k.isBlock(t, _)
      });
      if (p && m) {
        var [y, v] = p, [, E] = m;
        V.isAncestor(E, v) && (f = y);
      }
    }
  }
  var b = xi(f, US);
  return b;
}, qS = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    mode: r = "lowest",
    voids: i = !1
  } = n, {
    match: a,
    at: s = t.selection
  } = n;
  if (s) {
    var o = k.after(t, s, {
      voids: i
    });
    if (o) {
      var [, l] = k.last(t, []), u = [o.path, l];
      if (V.isPath(s) && s.length === 0)
        throw new Error("Cannot get the next node from the root node!");
      if (a == null)
        if (V.isPath(s)) {
          var [c] = k.parent(t, s);
          a = (f) => c.children.includes(f);
        } else
          a = () => !0;
      var [d] = k.nodes(t, {
        at: u,
        match: a,
        mode: r,
        voids: i
      });
      return d;
    }
  }
}, WS = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = k.path(t, n, r), a = be.get(t, i);
  return [a, i];
};
function VS(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: n = e.selection,
      mode: r = "all",
      universal: i = !1,
      reverse: a = !1,
      voids: s = !1,
      ignoreNonSelectable: o = !1
    } = t, {
      match: l
    } = t;
    if (l || (l = () => !0), !!n) {
      var u, c;
      if (OA.isSpan(n))
        u = n[0], c = n[1];
      else {
        var d = k.path(e, n, {
          edge: "start"
        }), f = k.path(e, n, {
          edge: "end"
        });
        u = a ? f : d, c = a ? d : f;
      }
      var p = be.nodes(e, {
        reverse: a,
        from: u,
        to: c,
        pass: (_) => {
          var [T] = _;
          return De.isElement(T) ? !!(!s && (k.isVoid(e, T) || k.isElementReadOnly(e, T)) || o && !k.isSelectable(e, T)) : !1;
        }
      }), g = [], m;
      for (var [y, v] of p)
        if (!(o && De.isElement(y) && !k.isSelectable(e, y))) {
          var E = m && V.compare(v, m[1]) === 0;
          if (!(r === "highest" && E)) {
            if (!l(y, v)) {
              if (i && !E && Ie.isText(y))
                return;
              continue;
            }
            if (r === "lowest" && E) {
              m = [y, v];
              continue;
            }
            var b = r === "lowest" ? m : [y, v];
            b && (i ? g.push(b) : yield b), m = [y, v];
          }
        }
      r === "lowest" && m && (i ? g.push(m) : yield m), i && (yield* g);
    }
  }();
}
var KS = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    force: r = !1,
    operation: i
  } = n, a = (c) => jc.get(c) || [], s = (c) => Hc.get(c) || /* @__PURE__ */ new Set(), o = (c) => {
    var d = a(c).pop(), f = d.join(",");
    return s(c).delete(f), d;
  };
  if (k.isNormalizing(t)) {
    if (r) {
      var l = Array.from(be.nodes(t), (c) => {
        var [, d] = c;
        return d;
      }), u = new Set(l.map((c) => c.join(",")));
      jc.set(t, l), Hc.set(t, u);
    }
    a(t).length !== 0 && k.withoutNormalizing(t, () => {
      for (var c of a(t))
        if (be.has(t, c)) {
          var d = k.node(t, c), [f, p] = d;
          De.isElement(f) && f.children.length === 0 && t.normalizeNode(d, {
            operation: i
          });
        }
      for (var g = a(t), m = g.length, y = 0; g.length !== 0; ) {
        if (!t.shouldNormalize({
          dirtyPaths: g,
          iteration: y,
          initialDirtyPathsLength: m,
          operation: i
        }))
          return;
        var v = o(t);
        if (be.has(t, v)) {
          var E = k.node(t, v);
          t.normalizeNode(E, {
            operation: i
          });
        }
        y++, g = a(t);
      }
    });
  }
}, GS = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = k.path(t, n, r), a = V.parent(i), s = k.node(t, a);
  return s;
}, YS = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: i = "forward"
  } = r, a = {
    current: n,
    affinity: i,
    unref() {
      var {
        current: o
      } = a, l = k.pathRefs(t);
      return l.delete(a), a.current = null, o;
    }
  }, s = k.pathRefs(t);
  return s.add(a), a;
}, ZS = (e) => {
  var t = wg.get(e);
  return t || (t = /* @__PURE__ */ new Set(), wg.set(e, t)), t;
}, QS = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    depth: i,
    edge: a
  } = r;
  if (V.isPath(n)) {
    if (a === "start") {
      var [, s] = be.first(t, n);
      n = s;
    } else if (a === "end") {
      var [, o] = be.last(t, n);
      n = o;
    }
  }
  return oe.isRange(n) && (a === "start" ? n = oe.start(n) : a === "end" ? n = oe.end(n) : n = V.common(n.anchor.path, n.focus.path)), Xe.isPoint(n) && (n = n.path), i != null && (n = n.slice(0, i)), n;
}, XS = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: i = "forward"
  } = r, a = {
    current: n,
    affinity: i,
    unref() {
      var {
        current: o
      } = a, l = k.pointRefs(t);
      return l.delete(a), a.current = null, o;
    }
  }, s = k.pointRefs(t);
  return s.add(a), a;
}, JS = (e) => {
  var t = Ag.get(e);
  return t || (t = /* @__PURE__ */ new Set(), Ag.set(e, t)), t;
}, ek = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    edge: i = "start"
  } = r;
  if (V.isPath(n)) {
    var a;
    if (i === "end") {
      var [, s] = be.last(t, n);
      a = s;
    } else {
      var [, o] = be.first(t, n);
      a = o;
    }
    var l = be.get(t, a);
    if (!Ie.isText(l))
      throw new Error("Cannot get the ".concat(i, " point in the node at path [").concat(n, "] because it has no ").concat(i, " text node."));
    return {
      path: a,
      offset: i === "end" ? l.text.length : 0
    };
  }
  if (oe.isRange(n)) {
    var [u, c] = oe.edges(n);
    return i === "start" ? u : c;
  }
  return n;
};
function tk(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function* () {
    var {
      at: n = e.selection,
      unit: r = "offset",
      reverse: i = !1,
      voids: a = !1,
      ignoreNonSelectable: s = !1
    } = t;
    if (!n)
      return;
    var o = k.range(e, n), [l, u] = oe.edges(o), c = i ? u : l, d = !1, f = "", p = 0, g = 0, m = 0;
    for (var [y, v] of k.nodes(e, {
      at: n,
      reverse: i,
      voids: a,
      ignoreNonSelectable: s
    })) {
      if (De.isElement(y)) {
        if (!a && (e.isVoid(y) || e.isElementReadOnly(y))) {
          yield k.start(e, v);
          continue;
        }
        if (e.isInline(y))
          continue;
        if (k.hasInlines(e, y)) {
          var E = V.isAncestor(v, u.path) ? u : k.end(e, v), b = V.isAncestor(v, l.path) ? l : k.start(e, v);
          f = k.string(e, {
            anchor: b,
            focus: E
          }, {
            voids: a
          }), d = !0;
        }
      }
      if (Ie.isText(y)) {
        var _ = V.equals(v, c.path);
        for (_ ? (g = i ? c.offset : y.text.length - c.offset, m = c.offset) : (g = y.text.length, m = i ? g : 0), (_ || d || r === "offset") && (yield {
          path: v,
          offset: m
        }, d = !1); ; ) {
          if (p === 0) {
            if (f === "")
              break;
            p = T(f, r, i), f = Fp(f, p, i)[1];
          }
          if (m = i ? m - p : m + p, g = g - p, g < 0) {
            p = -g;
            break;
          }
          p = 0, yield {
            path: v,
            offset: m
          };
        }
      }
    }
    function T(x, A, R) {
      return A === "character" ? Rp(x, R) : A === "word" ? BA(x, R) : A === "line" || A === "block" ? x.length : 1;
    }
  }();
}
var nk = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    mode: r = "lowest",
    voids: i = !1
  } = n, {
    match: a,
    at: s = t.selection
  } = n;
  if (s) {
    var o = k.before(t, s, {
      voids: i
    });
    if (o) {
      var [, l] = k.first(t, []), u = [o.path, l];
      if (V.isPath(s) && s.length === 0)
        throw new Error("Cannot get the previous node from the root node!");
      if (a == null)
        if (V.isPath(s)) {
          var [c] = k.parent(t, s);
          a = (f) => c.children.includes(f);
        } else
          a = () => !0;
      var [d] = k.nodes(t, {
        reverse: !0,
        at: u,
        match: a,
        mode: r,
        voids: i
      });
      return d;
    }
  }
}, rk = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: i = "forward"
  } = r, a = {
    current: n,
    affinity: i,
    unref() {
      var {
        current: o
      } = a, l = k.rangeRefs(t);
      return l.delete(a), a.current = null, o;
    }
  }, s = k.rangeRefs(t);
  return s.add(a), a;
}, ik = (e) => {
  var t = Sg.get(e);
  return t || (t = /* @__PURE__ */ new Set(), Sg.set(e, t)), t;
}, ak = (e, t, n) => {
  if (oe.isRange(t) && !n)
    return t;
  var r = k.start(e, t), i = k.end(e, n || t);
  return {
    anchor: r,
    focus: i
  };
};
function Qg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var ok = (e, t) => {
  var {
    selection: n
  } = e;
  if (n) {
    var r = (c, d) => {
      if (!Ie.isText(c))
        return !1;
      var [f, p] = k.parent(e, d);
      return !e.isVoid(f) || e.markableVoid(f);
    }, i = oe.isExpanded(n), a = !1;
    if (!i) {
      var [s, o] = k.node(e, n);
      if (s && r(s, o)) {
        var [l] = k.parent(e, o);
        a = l && e.markableVoid(l);
      }
    }
    if (i || a)
      le.unsetNodes(e, t, {
        match: r,
        split: !0,
        voids: !0
      });
    else {
      var u = sk({}, k.marks(e) || {});
      delete u[t], e.marks = u, qo.get(e) || e.onChange();
    }
  }
}, lk = (e, t) => {
  Q4.set(e, t);
}, uk = (e, t) => k.point(e, t, {
  edge: "start"
}), ck = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    voids: i = !1
  } = r, a = k.range(t, n), [s, o] = oe.edges(a), l = "";
  for (var [u, c] of k.nodes(t, {
    at: a,
    match: Ie.isText,
    voids: i
  })) {
    var d = u.text;
    V.equals(c, o.path) && (d = d.slice(0, o.offset)), V.equals(c, s.path) && (d = d.slice(s.offset)), l += d;
  }
  return l;
}, dk = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    voids: i = !1
  } = r, [a, s] = oe.edges(n);
  if (a.offset !== 0 || s.offset !== 0 || oe.isCollapsed(n) || V.hasPrevious(s.path))
    return n;
  var o = k.above(t, {
    at: s,
    match: (g) => De.isElement(g) && k.isBlock(t, g),
    voids: i
  }), l = o ? o[1] : [], u = k.start(t, a), c = {
    anchor: u,
    focus: s
  }, d = !0;
  for (var [f, p] of k.nodes(t, {
    at: c,
    match: Ie.isText,
    reverse: !0,
    voids: i
  })) {
    if (d) {
      d = !1;
      continue;
    }
    if (f.text !== "" || V.isBefore(p, l)) {
      s = {
        path: p,
        offset: f.text.length
      };
      break;
    }
  }
  return {
    anchor: a,
    focus: s
  };
}, fk = (e, t) => {
  var n = k.isNormalizing(e);
  k.setNormalizing(e, !1);
  try {
    t();
  } finally {
    k.setNormalizing(e, n);
  }
  k.normalize(e);
}, hk = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  k.withoutNormalizing(t, () => {
    var r, i, {
      reverse: a = !1,
      unit: s = "character",
      distance: o = 1,
      voids: l = !1
    } = n, {
      at: u = t.selection,
      hanging: c = !1
    } = n;
    if (u) {
      var d = !1;
      if (oe.isRange(u) && oe.isCollapsed(u) && (d = !0, u = u.anchor), Xe.isPoint(u)) {
        var f = k.void(t, {
          at: u,
          mode: "highest"
        });
        if (!l && f) {
          var [, p] = f;
          u = p;
        } else {
          var g = {
            unit: s,
            distance: o
          }, m = a ? k.before(t, u, g) || k.start(t, []) : k.after(t, u, g) || k.end(t, []);
          u = {
            anchor: u,
            focus: m
          }, c = !0;
        }
      }
      if (V.isPath(u)) {
        le.removeNodes(t, {
          at: u,
          voids: l
        });
        return;
      }
      if (!oe.isCollapsed(u)) {
        if (!c) {
          var [, y] = oe.edges(u), v = k.end(t, []);
          Xe.equals(y, v) || (u = k.unhangRange(t, u, {
            voids: l
          }));
        }
        var [E, b] = oe.edges(u), _ = k.above(t, {
          match: (Oe) => De.isElement(Oe) && k.isBlock(t, Oe),
          at: E,
          voids: l
        }), T = k.above(t, {
          match: (Oe) => De.isElement(Oe) && k.isBlock(t, Oe),
          at: b,
          voids: l
        }), x = _ && T && !V.equals(_[1], T[1]), A = V.equals(E.path, b.path), R = l ? null : (r = k.void(t, {
          at: E,
          mode: "highest"
        })) !== null && r !== void 0 ? r : k.elementReadOnly(t, {
          at: E,
          mode: "highest"
        }), P = l ? null : (i = k.void(t, {
          at: b,
          mode: "highest"
        })) !== null && i !== void 0 ? i : k.elementReadOnly(t, {
          at: b,
          mode: "highest"
        });
        if (R) {
          var L = k.before(t, E);
          L && _ && V.isAncestor(_[1], L.path) && (E = L);
        }
        if (P) {
          var I = k.after(t, b);
          I && T && V.isAncestor(T[1], I.path) && (b = I);
        }
        var O = [], S;
        for (var F of k.nodes(t, {
          at: u,
          voids: l
        })) {
          var [H, q] = F;
          S && V.compare(q, S) === 0 || (!l && De.isElement(H) && (k.isVoid(t, H) || k.isElementReadOnly(t, H)) || !V.isCommon(q, E.path) && !V.isCommon(q, b.path)) && (O.push(F), S = q);
        }
        var N = Array.from(O, (Oe) => {
          var [, Ce] = Oe;
          return k.pathRef(t, Ce);
        }), Q = k.pointRef(t, E), J = k.pointRef(t, b), D = "";
        if (!A && !R) {
          var C = Q.current, [Z] = k.leaf(t, C), {
            path: B
          } = C, {
            offset: j
          } = E, z = Z.text.slice(j);
          z.length > 0 && (t.apply({
            type: "remove_text",
            path: B,
            offset: j,
            text: z
          }), D = z);
        }
        if (N.reverse().map((Oe) => Oe.unref()).filter((Oe) => Oe !== null).forEach((Oe) => le.removeNodes(t, {
          at: Oe,
          voids: l
        })), !P) {
          var U = J.current, [$] = k.leaf(t, U), {
            path: ae
          } = U, Y = A ? E.offset : 0, ee = $.text.slice(Y, b.offset);
          ee.length > 0 && (t.apply({
            type: "remove_text",
            path: ae,
            offset: Y,
            text: ee
          }), D = ee);
        }
        !A && x && J.current && Q.current && le.mergeNodes(t, {
          at: J.current,
          hanging: !0,
          voids: l
        }), d && a && s === "character" && D.length > 1 && D.match(/[\u0E00-\u0E7F]+/) && le.insertText(t, D.slice(0, D.length - o));
        var se = Q.unref(), re = J.unref(), Ae = a ? se || re : re || se;
        n.at == null && Ae && le.select(t, Ae);
      }
    }
  });
}, pk = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  k.withoutNormalizing(t, () => {
    var {
      hanging: i = !1,
      voids: a = !1
    } = r, {
      at: s = Pp(t),
      batchDirty: o = !0
    } = r;
    if (n.length) {
      if (oe.isRange(s))
        if (i || (s = k.unhangRange(t, s, {
          voids: a
        })), oe.isCollapsed(s))
          s = s.anchor;
        else {
          var [, l] = oe.edges(s);
          if (!a && k.void(t, {
            at: l
          }))
            return;
          var u = k.pointRef(t, l);
          le.delete(t, {
            at: s
          }), s = u.unref();
        }
      else
        V.isPath(s) && (s = k.start(t, s));
      if (!(!a && k.void(t, {
        at: s
      }))) {
        var c = k.above(t, {
          at: s,
          match: (z) => De.isElement(z) && k.isInline(t, z),
          mode: "highest",
          voids: a
        });
        if (c) {
          var [, d] = c;
          if (k.isEnd(t, s, d)) {
            var f = k.after(t, d);
            s = f;
          } else if (k.isStart(t, s, d)) {
            var p = k.before(t, d);
            s = p;
          }
        }
        var g = k.above(t, {
          match: (z) => De.isElement(z) && k.isBlock(t, z),
          at: s,
          voids: a
        }), [, m] = g, y = k.isStart(t, s, m), v = k.isEnd(t, s, m), E = y && v, b = !y || y && v, _ = !v, [, T] = be.first({
          children: n
        }, []), [, x] = be.last({
          children: n
        }, []), A = [], R = (z) => {
          var [U, $] = z, ae = $.length === 0;
          return ae ? !1 : E ? !0 : !(b && V.isAncestor($, T) && De.isElement(U) && !t.isVoid(U) && !t.isInline(U) || _ && V.isAncestor($, x) && De.isElement(U) && !t.isVoid(U) && !t.isInline(U));
        };
        for (var P of be.nodes({
          children: n
        }, {
          pass: R
        }))
          R(P) && A.push(P);
        var L = [], I = [], O = [], S = !0, F = !1;
        for (var [H] of A)
          De.isElement(H) && !t.isInline(H) ? (S = !1, F = !0, I.push(H)) : S ? L.push(H) : O.push(H);
        var [q] = k.nodes(t, {
          at: s,
          match: (z) => Ie.isText(z) || k.isInline(t, z),
          mode: "highest",
          voids: a
        }), [, N] = q, Q = k.isStart(t, s, N), J = k.isEnd(t, s, N), D = k.pathRef(t, v && !O.length ? V.next(m) : m), C = k.pathRef(t, J ? V.next(N) : N);
        le.splitNodes(t, {
          at: s,
          match: (z) => F ? De.isElement(z) && k.isBlock(t, z) : Ie.isText(z) || k.isInline(t, z),
          mode: F ? "lowest" : "highest",
          always: F && (!y || L.length > 0) && (!v || O.length > 0),
          voids: a
        });
        var Z = k.pathRef(t, !Q || Q && J ? V.next(N) : N);
        if (le.insertNodes(t, L, {
          at: Z.current,
          match: (z) => Ie.isText(z) || k.isInline(t, z),
          mode: "highest",
          voids: a,
          batchDirty: o
        }), E && !L.length && I.length && !O.length && le.delete(t, {
          at: m,
          voids: a
        }), le.insertNodes(t, I, {
          at: D.current,
          match: (z) => De.isElement(z) && k.isBlock(t, z),
          mode: "lowest",
          voids: a,
          batchDirty: o
        }), le.insertNodes(t, O, {
          at: C.current,
          match: (z) => Ie.isText(z) || k.isInline(t, z),
          mode: "highest",
          voids: a,
          batchDirty: o
        }), !r.at) {
          var B;
          if (O.length > 0 && C.current ? B = V.previous(C.current) : I.length > 0 && D.current ? B = V.previous(D.current) : Z.current && (B = V.previous(Z.current)), B) {
            var j = k.end(t, B);
            le.select(t, j);
          }
        }
        Z.unref(), D.unref(), C.unref();
      }
    }
  });
}, mk = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    edge: r = "anchor"
  } = n, {
    selection: i
  } = t;
  if (i) {
    if (r === "anchor")
      le.select(t, i.anchor);
    else if (r === "focus")
      le.select(t, i.focus);
    else if (r === "start") {
      var [a] = oe.edges(i);
      le.select(t, a);
    } else if (r === "end") {
      var [, s] = oe.edges(i);
      le.select(t, s);
    }
  } else
    return;
}, gk = (e) => {
  var {
    selection: t
  } = e;
  t && e.apply({
    type: "set_selection",
    properties: t,
    newProperties: null
  });
}, vk = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    selection: r
  } = t, {
    distance: i = 1,
    unit: a = "character",
    reverse: s = !1
  } = n, {
    edge: o = null
  } = n;
  if (r) {
    o === "start" && (o = oe.isBackward(r) ? "focus" : "anchor"), o === "end" && (o = oe.isBackward(r) ? "anchor" : "focus");
    var {
      anchor: l,
      focus: u
    } = r, c = {
      distance: i,
      unit: a,
      ignoreNonSelectable: !0
    }, d = {};
    if (o == null || o === "anchor") {
      var f = s ? k.before(t, l, c) : k.after(t, l, c);
      f && (d.anchor = f);
    }
    if (o == null || o === "focus") {
      var p = s ? k.before(t, u, c) : k.after(t, u, c);
      p && (d.focus = p);
    }
    le.setSelection(t, d);
  }
}, yk = (e, t) => {
  var {
    selection: n
  } = e;
  if (t = k.range(e, t), n) {
    le.setSelection(e, t);
    return;
  }
  if (!oe.isRange(t))
    throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(nn.stringify(t)));
  e.apply({
    type: "set_selection",
    properties: n,
    newProperties: t
  });
};
function Xg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Jg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xg(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ek = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    selection: i
  } = t, {
    edge: a = "both"
  } = r;
  if (i) {
    a === "start" && (a = oe.isBackward(i) ? "focus" : "anchor"), a === "end" && (a = oe.isBackward(i) ? "anchor" : "focus");
    var {
      anchor: s,
      focus: o
    } = i, l = a === "anchor" ? s : o;
    le.setSelection(t, {
      [a === "anchor" ? "anchor" : "focus"]: Jg(Jg({}, l), n)
    });
  }
}, bk = (e, t) => {
  var {
    selection: n
  } = e, r = {}, i = {};
  if (n) {
    for (var a in t)
      (a === "anchor" && t.anchor != null && !Xe.equals(t.anchor, n.anchor) || a === "focus" && t.focus != null && !Xe.equals(t.focus, n.focus) || a !== "anchor" && a !== "focus" && t[a] !== n[a]) && (r[a] = n[a], i[a] = t[a]);
    Object.keys(r).length > 0 && e.apply({
      type: "set_selection",
      properties: r,
      newProperties: i
    });
  }
}, Tk = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  k.withoutNormalizing(t, () => {
    var {
      hanging: i = !1,
      voids: a = !1,
      mode: s = "lowest",
      batchDirty: o = !0
    } = r, {
      at: l,
      match: u,
      select: c
    } = r;
    if (be.isNode(n) && (n = [n]), n.length !== 0) {
      var [d] = n;
      if (l || (l = Pp(t), c !== !1 && (c = !0)), c == null && (c = !1), oe.isRange(l))
        if (i || (l = k.unhangRange(t, l, {
          voids: a
        })), oe.isCollapsed(l))
          l = l.anchor;
        else {
          var [, f] = oe.edges(l), p = k.pointRef(t, f);
          le.delete(t, {
            at: l
          }), l = p.unref();
        }
      if (Xe.isPoint(l)) {
        u == null && (Ie.isText(d) ? u = (L) => Ie.isText(L) : t.isInline(d) ? u = (L) => Ie.isText(L) || k.isInline(t, L) : u = (L) => De.isElement(L) && k.isBlock(t, L));
        var [g] = k.nodes(t, {
          at: l.path,
          match: u,
          mode: s,
          voids: a
        });
        if (g) {
          var [, m] = g, y = k.pathRef(t, m), v = k.isEnd(t, l, m);
          le.splitNodes(t, {
            at: l,
            match: u,
            mode: s,
            voids: a
          });
          var E = y.unref();
          l = v ? V.next(E) : E;
        } else
          return;
      }
      var b = V.parent(l), _ = l[l.length - 1];
      if (!(!a && k.void(t, {
        at: b
      }))) {
        if (o) {
          var T = [], x = V.levels(b);
          iS(t, () => {
            var L = function() {
              var S = b.concat(_);
              _++;
              var F = {
                type: "insert_node",
                path: S,
                node: I
              };
              t.apply(F), l = V.next(l), T.push(F), Ie.isText ? x.push(...Array.from(be.nodes(I), (H) => {
                var [, q] = H;
                return S.concat(q);
              })) : x.push(S);
            };
            for (var I of n)
              L();
          }, () => {
            J4(t, x, (L) => {
              var I = L;
              for (var O of T)
                if (V.operationCanTransformPath(O) && (I = V.transform(I, O), !I))
                  return null;
              return I;
            });
          });
        } else
          for (var A of n) {
            var R = b.concat(_);
            _++, t.apply({
              type: "insert_node",
              path: R,
              node: A
            }), l = V.next(l);
          }
        if (l = V.previous(l), c) {
          var P = k.end(t, l);
          P && le.select(t, P);
        }
      }
    }
  });
}, _k = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  k.withoutNormalizing(t, () => {
    var {
      at: r = t.selection,
      mode: i = "lowest",
      voids: a = !1
    } = n, {
      match: s
    } = n;
    if (s == null && (s = V.isPath(r) ? Zs(t, r) : (_) => De.isElement(_) && k.isBlock(t, _)), !!r) {
      var o = k.nodes(t, {
        at: r,
        match: s,
        mode: i,
        voids: a
      }), l = Array.from(o, (_) => {
        var [, T] = _;
        return k.pathRef(t, T);
      });
      for (var u of l) {
        var c = u.unref();
        if (c.length < 2)
          throw new Error("Cannot lift node at a path [".concat(c, "] because it has a depth of less than `2`."));
        var d = k.node(t, V.parent(c)), [f, p] = d, g = c[c.length - 1], {
          length: m
        } = f.children;
        if (m === 1) {
          var y = V.next(p);
          le.moveNodes(t, {
            at: c,
            to: y,
            voids: a
          }), le.removeNodes(t, {
            at: p,
            voids: a
          });
        } else if (g === 0)
          le.moveNodes(t, {
            at: c,
            to: p,
            voids: a
          });
        else if (g === m - 1) {
          var v = V.next(p);
          le.moveNodes(t, {
            at: c,
            to: v,
            voids: a
          });
        } else {
          var E = V.next(c), b = V.next(p);
          le.splitNodes(t, {
            at: E,
            voids: a
          }), le.moveNodes(t, {
            at: c,
            to: b,
            voids: a
          });
        }
      }
    }
  });
}, Ck = ["text"], xk = ["children"], eb = (e, t) => {
  if (De.isElement(t)) {
    var n = t;
    return k.isVoid(e, t) ? !0 : n.children.length === 1 ? eb(e, n.children[0]) : !1;
  } else
    return !k.isEditor(t);
}, wk = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  k.withoutNormalizing(t, () => {
    var {
      match: r,
      at: i = t.selection
    } = n, {
      hanging: a = !1,
      voids: s = !1,
      mode: o = "lowest"
    } = n;
    if (i) {
      if (r == null)
        if (V.isPath(i)) {
          var [l] = k.parent(t, i);
          r = (L) => l.children.includes(L);
        } else
          r = (L) => De.isElement(L) && k.isBlock(t, L);
      if (!a && oe.isRange(i) && (i = k.unhangRange(t, i, {
        voids: s
      })), oe.isRange(i))
        if (oe.isCollapsed(i))
          i = i.anchor;
        else {
          var [, u] = oe.edges(i), c = k.pointRef(t, u);
          le.delete(t, {
            at: i
          }), i = c.unref(), n.at == null && le.select(t, i);
        }
      var [d] = k.nodes(t, {
        at: i,
        match: r,
        voids: s,
        mode: o
      }), f = k.previous(t, {
        at: i,
        match: r,
        voids: s,
        mode: o
      });
      if (!(!d || !f)) {
        var [p, g] = d, [m, y] = f;
        if (!(g.length === 0 || y.length === 0)) {
          var v = V.next(y), E = V.common(g, y), b = V.isSibling(g, y), _ = Array.from(k.levels(t, {
            at: g
          }), (L) => {
            var [I] = L;
            return I;
          }).slice(E.length).slice(0, -1), T = k.above(t, {
            at: g,
            mode: "highest",
            match: (L) => _.includes(L) && eb(t, L)
          }), x = T && k.pathRef(t, T[1]), A, R;
          if (Ie.isText(p) && Ie.isText(m)) {
            var P = xi(p, Ck);
            R = m.text.length, A = P;
          } else if (De.isElement(p) && De.isElement(m)) {
            var P = xi(p, xk);
            R = m.children.length, A = P;
          } else
            throw new Error("Cannot merge the node at path [".concat(g, "] with the previous sibling because it is not the same kind: ").concat(nn.stringify(p), " ").concat(nn.stringify(m)));
          b || le.moveNodes(t, {
            at: g,
            to: v,
            voids: s
          }), x && le.removeNodes(t, {
            at: x.current,
            voids: s
          }), De.isElement(m) && k.isEmpty(t, m) || Ie.isText(m) && m.text === "" && y[y.length - 1] !== 0 ? le.removeNodes(t, {
            at: y,
            voids: s
          }) : t.apply({
            type: "merge_node",
            path: v,
            position: R,
            properties: A
          }), x && x.unref();
        }
      }
    }
  });
}, Ak = (e, t) => {
  k.withoutNormalizing(e, () => {
    var {
      to: n,
      at: r = e.selection,
      mode: i = "lowest",
      voids: a = !1
    } = t, {
      match: s
    } = t;
    if (r) {
      s == null && (s = V.isPath(r) ? Zs(e, r) : (p) => De.isElement(p) && k.isBlock(e, p));
      var o = k.pathRef(e, n), l = k.nodes(e, {
        at: r,
        match: s,
        mode: i,
        voids: a
      }), u = Array.from(l, (p) => {
        var [, g] = p;
        return k.pathRef(e, g);
      });
      for (var c of u) {
        var d = c.unref(), f = o.current;
        d.length !== 0 && e.apply({
          type: "move_node",
          path: d,
          newPath: f
        }), o.current && V.isSibling(f, d) && V.isAfter(f, d) && (o.current = V.next(o.current));
      }
      o.unref();
    }
  });
}, Sk = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  k.withoutNormalizing(t, () => {
    var {
      hanging: r = !1,
      voids: i = !1,
      mode: a = "lowest"
    } = n, {
      at: s = t.selection,
      match: o
    } = n;
    if (s) {
      o == null && (o = V.isPath(s) ? Zs(t, s) : (p) => De.isElement(p) && k.isBlock(t, p)), !r && oe.isRange(s) && (s = k.unhangRange(t, s, {
        voids: i
      }));
      var l = k.nodes(t, {
        at: s,
        match: o,
        mode: a,
        voids: i
      }), u = Array.from(l, (p) => {
        var [, g] = p;
        return k.pathRef(t, g);
      });
      for (var c of u) {
        var d = c.unref();
        if (d) {
          var [f] = k.node(t, d);
          t.apply({
            type: "remove_node",
            path: d,
            node: f
          });
        }
      }
    }
  });
}, kk = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  k.withoutNormalizing(t, () => {
    var {
      match: i,
      at: a = t.selection,
      compare: s,
      merge: o
    } = r, {
      hanging: l = !1,
      mode: u = "lowest",
      split: c = !1,
      voids: d = !1
    } = r;
    if (a) {
      if (i == null && (i = V.isPath(a) ? Zs(t, a) : (R) => De.isElement(R) && k.isBlock(t, R)), !l && oe.isRange(a) && (a = k.unhangRange(t, a, {
        voids: d
      })), c && oe.isRange(a)) {
        if (oe.isCollapsed(a) && k.leaf(t, a.anchor)[0].text.length > 0)
          return;
        var f = k.rangeRef(t, a, {
          affinity: "inward"
        }), [p, g] = oe.edges(a), m = u === "lowest" ? "lowest" : "highest", y = k.isEnd(t, g, g.path);
        le.splitNodes(t, {
          at: g,
          match: i,
          mode: m,
          voids: d,
          always: !y
        });
        var v = k.isStart(t, p, p.path);
        le.splitNodes(t, {
          at: p,
          match: i,
          mode: m,
          voids: d,
          always: !v
        }), a = f.unref(), r.at == null && le.select(t, a);
      }
      s || (s = (R, P) => R !== P);
      for (var [E, b] of k.nodes(t, {
        at: a,
        match: i,
        mode: u,
        voids: d
      })) {
        var _ = {}, T = {};
        if (b.length !== 0) {
          var x = !1;
          for (var A in n)
            A === "children" || A === "text" || s(n[A], E[A]) && (x = !0, E.hasOwnProperty(A) && (_[A] = E[A]), o ? n[A] != null && (T[A] = o(E[A], n[A])) : n[A] != null && (T[A] = n[A]));
          x && t.apply({
            type: "set_node",
            path: b,
            properties: _,
            newProperties: T
          });
        }
      }
    }
  });
}, Dk = (e, t) => {
  if (oe.isCollapsed(t))
    return t.anchor;
  var [, n] = oe.edges(t), r = k.pointRef(e, n);
  return le.delete(e, {
    at: t
  }), r.unref();
}, Ok = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  k.withoutNormalizing(t, () => {
    var {
      mode: r = "lowest",
      voids: i = !1
    } = n, {
      match: a,
      at: s = t.selection,
      height: o = 0,
      always: l = !1
    } = n;
    if (a == null && (a = (J) => De.isElement(J) && k.isBlock(t, J)), oe.isRange(s) && (s = Dk(t, s)), V.isPath(s)) {
      var u = s, c = k.point(t, u), [d] = k.parent(t, u);
      a = (J) => J === d, o = c.path.length - u.length + 1, s = c, l = !0;
    }
    if (s) {
      var f = k.pointRef(t, s, {
        affinity: "backward"
      }), p;
      try {
        var [g] = k.nodes(t, {
          at: s,
          match: a,
          mode: r,
          voids: i
        });
        if (!g)
          return;
        var m = k.void(t, {
          at: s,
          mode: "highest"
        }), y = 0;
        if (!i && m) {
          var [v, E] = m;
          if (De.isElement(v) && t.isInline(v)) {
            var b = k.after(t, E);
            if (!b) {
              var _ = {
                text: ""
              }, T = V.next(E);
              le.insertNodes(t, _, {
                at: T,
                voids: i
              }), b = k.point(t, T);
            }
            s = b, l = !0;
          }
          var x = s.path.length - E.length;
          o = x + 1, l = !0;
        }
        p = k.pointRef(t, s);
        var A = s.path.length - o, [, R] = g, P = s.path.slice(0, A), L = o === 0 ? s.offset : s.path[A] + y;
        for (var [I, O] of k.levels(t, {
          at: P,
          reverse: !0,
          voids: i
        })) {
          var S = !1;
          if (O.length < R.length || O.length === 0 || !i && De.isElement(I) && k.isVoid(t, I))
            break;
          var F = f.current, H = k.isEnd(t, F, O);
          if (l || !f || !k.isEdge(t, F, O)) {
            S = !0;
            var q = be.extractProps(I);
            t.apply({
              type: "split_node",
              path: O,
              position: L,
              properties: q
            });
          }
          L = O[O.length - 1] + (S || H ? 1 : 0);
        }
        if (n.at == null) {
          var N = p.current || k.end(t, []);
          le.select(t, N);
        }
      } finally {
        var Q;
        f.unref(), (Q = p) === null || Q === void 0 || Q.unref();
      }
    }
  });
}, Nk = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Array.isArray(n) || (n = [n]);
  var i = {};
  for (var a of n)
    i[a] = null;
  le.setNodes(t, i, r);
}, Ik = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  k.withoutNormalizing(t, () => {
    var {
      mode: r = "lowest",
      split: i = !1,
      voids: a = !1
    } = n, {
      at: s = t.selection,
      match: o
    } = n;
    if (s) {
      o == null && (o = V.isPath(s) ? Zs(t, s) : (p) => De.isElement(p) && k.isBlock(t, p)), V.isPath(s) && (s = k.range(t, s));
      var l = oe.isRange(s) ? k.rangeRef(t, s) : null, u = k.nodes(t, {
        at: s,
        match: o,
        mode: r,
        voids: a
      }), c = Array.from(
        u,
        (p) => {
          var [, g] = p;
          return k.pathRef(t, g);
        }
        // unwrapNode will call liftNode which does not support splitting the node when nested.
        // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
        // that wrap target node. So we reverse the order.
      ).reverse(), d = function() {
        var g = f.unref(), [m] = k.node(t, g), y = k.range(t, g);
        i && l && (y = oe.intersection(l.current, y)), le.liftNodes(t, {
          at: y,
          match: (v) => De.isAncestor(m) && m.children.includes(v),
          voids: a
        });
      };
      for (var f of c)
        d();
      l && l.unref();
    }
  });
};
function ev(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ev(Object(n), !0).forEach(function(r) {
      xn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ev(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Pk = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  k.withoutNormalizing(t, () => {
    var {
      mode: i = "lowest",
      split: a = !1,
      voids: s = !1
    } = r, {
      match: o,
      at: l = t.selection
    } = r;
    if (l) {
      if (o == null && (V.isPath(l) ? o = Zs(t, l) : t.isInline(n) ? o = (y) => De.isElement(y) && k.isInline(t, y) || Ie.isText(y) : o = (y) => De.isElement(y) && k.isBlock(t, y)), a && oe.isRange(l)) {
        var [u, c] = oe.edges(l), d = k.rangeRef(t, l, {
          affinity: "inward"
        });
        le.splitNodes(t, {
          at: c,
          match: o,
          voids: s
        }), le.splitNodes(t, {
          at: u,
          match: o,
          voids: s
        }), l = d.unref(), r.at == null && le.select(t, l);
      }
      var f = Array.from(k.nodes(t, {
        at: l,
        match: t.isInline(n) ? (y) => De.isElement(y) && k.isBlock(t, y) : (y) => k.isEditor(y),
        mode: "lowest",
        voids: s
      })), p = function() {
        var v = oe.isRange(l) ? oe.intersection(l, k.range(t, m)) : l;
        if (!v)
          return 0;
        var E = Array.from(k.nodes(t, {
          at: v,
          match: o,
          mode: i,
          voids: s
        }));
        if (E.length > 0) {
          var [b] = E, _ = E[E.length - 1], [, T] = b, [, x] = _;
          if (T.length === 0 && x.length === 0)
            return 0;
          var A = V.equals(T, x) ? V.parent(T) : V.common(T, x), R = k.range(t, T, x), P = k.node(t, A), [L] = P, I = A.length + 1, O = V.next(x.slice(0, I)), S = tv(tv({}, n), {}, {
            children: []
          });
          le.insertNodes(t, S, {
            at: O,
            voids: s
          }), le.moveNodes(t, {
            at: R,
            match: (F) => De.isAncestor(L) && L.children.includes(F),
            to: O.concat(0),
            voids: s
          });
        }
      }, g;
      for (var [, m] of f)
        g = p();
    }
  });
}, Rk = () => {
  var e = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isElementReadOnly: () => !1,
    isInline: () => !1,
    isSelectable: () => !0,
    isVoid: () => !1,
    markableVoid: () => !1,
    onChange: () => {
    },
    // Core
    apply: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return aS(e, ...r);
    },
    // Editor
    addMark: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return dS(e, ...r);
    },
    deleteBackward: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return pS(e, ...r);
    },
    deleteForward: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return mS(e, ...r);
    },
    deleteFragment: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return gS(e, ...r);
    },
    getFragment: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return oS(e, ...r);
    },
    insertBreak: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return SS(e, ...r);
    },
    insertSoftBreak: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return DS(e, ...r);
    },
    insertFragment: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return pk(e, ...r);
    },
    insertNode: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return kS(e, ...r);
    },
    insertText: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return NS(e, ...r);
    },
    normalizeNode: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return lS(e, ...r);
    },
    removeMark: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return ok(e, ...r);
    },
    getDirtyPaths: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return sS(e, ...r);
    },
    shouldNormalize: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return uS(e, ...r);
    },
    // Editor interface
    above: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return cS(e, ...r);
    },
    after: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return fS(e, ...r);
    },
    before: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return hS(e, ...r);
    },
    collapse: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return mk(e, ...r);
    },
    delete: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return hk(e, ...r);
    },
    deselect: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return gk(e, ...r);
    },
    edges: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return vS(e, ...r);
    },
    elementReadOnly: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return yS(e, ...r);
    },
    end: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return ES(e, ...r);
    },
    first: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return bS(e, ...r);
    },
    fragment: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return TS(e, ...r);
    },
    getMarks: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return zS(e, ...r);
    },
    hasBlocks: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return CS(e, ...r);
    },
    hasInlines: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return xS(e, ...r);
    },
    hasPath: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return wS(e, ...r);
    },
    hasTexts: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return AS(e, ...r);
    },
    insertNodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return Tk(e, ...r);
    },
    isBlock: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return IS(e, ...r);
    },
    isEdge: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return PS(e, ...r);
    },
    isEmpty: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return RS(e, ...r);
    },
    isEnd: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return FS(e, ...r);
    },
    isNormalizing: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return BS(e, ...r);
    },
    isStart: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return MS(e, ...r);
    },
    last: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return LS(e, ...r);
    },
    leaf: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return $S(e, ...r);
    },
    levels: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return jS(e, ...r);
    },
    liftNodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return _k(e, ...r);
    },
    mergeNodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return wk(e, ...r);
    },
    move: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return vk(e, ...r);
    },
    moveNodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return Ak(e, ...r);
    },
    next: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return qS(e, ...r);
    },
    node: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return WS(e, ...r);
    },
    nodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return VS(e, ...r);
    },
    normalize: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return KS(e, ...r);
    },
    parent: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return GS(e, ...r);
    },
    path: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return QS(e, ...r);
    },
    pathRef: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return YS(e, ...r);
    },
    pathRefs: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return ZS(e, ...r);
    },
    point: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return ek(e, ...r);
    },
    pointRef: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return XS(e, ...r);
    },
    pointRefs: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return JS(e, ...r);
    },
    positions: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return tk(e, ...r);
    },
    previous: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return nk(e, ...r);
    },
    range: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return ak(e, ...r);
    },
    rangeRef: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return rk(e, ...r);
    },
    rangeRefs: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return ik(e, ...r);
    },
    removeNodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return Sk(e, ...r);
    },
    select: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return yk(e, ...r);
    },
    setNodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return kk(e, ...r);
    },
    setNormalizing: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return lk(e, ...r);
    },
    setPoint: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return Ek(e, ...r);
    },
    setSelection: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return bk(e, ...r);
    },
    splitNodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return Ok(e, ...r);
    },
    start: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return uk(e, ...r);
    },
    string: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return ck(e, ...r);
    },
    unhangRange: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return dk(e, ...r);
    },
    unsetNodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return Nk(e, ...r);
    },
    unwrapNodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return Ik(e, ...r);
    },
    void: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return _S(e, ...r);
    },
    withoutNormalizing: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return fk(e, ...r);
    },
    wrapNodes: function() {
      for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
        r[i] = arguments[i];
      return Pk(e, ...r);
    }
  };
  return e;
}, Ia = [], Fk = function() {
  return Ia.some(function(e) {
    return e.activeTargets.length > 0;
  });
}, Bk = function() {
  return Ia.some(function(e) {
    return e.skippedTargets.length > 0;
  });
}, nv = "ResizeObserver loop completed with undelivered notifications.", Mk = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: nv
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = nv), window.dispatchEvent(e);
}, yl;
(function(e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(yl || (yl = {}));
var Pa = function(e) {
  return Object.freeze(e);
}, Lk = function() {
  function e(t, n) {
    this.inlineSize = t, this.blockSize = n, Pa(this);
  }
  return e;
}(), tb = function() {
  function e(t, n, r, i) {
    return this.x = t, this.y = n, this.width = r, this.height = i, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Pa(this);
  }
  return e.prototype.toJSON = function() {
    var t = this, n = t.x, r = t.y, i = t.top, a = t.right, s = t.bottom, o = t.left, l = t.width, u = t.height;
    return { x: n, y: r, top: i, right: a, bottom: s, left: o, width: l, height: u };
  }, e.fromRect = function(t) {
    return new e(t.x, t.y, t.width, t.height);
  }, e;
}(), Bp = function(e) {
  return e instanceof SVGElement && "getBBox" in e;
}, nb = function(e) {
  if (Bp(e)) {
    var t = e.getBBox(), n = t.width, r = t.height;
    return !n && !r;
  }
  var i = e, a = i.offsetWidth, s = i.offsetHeight;
  return !(a || s || e.getClientRects().length);
}, rv = function(e) {
  var t;
  if (e instanceof Element)
    return !0;
  var n = (t = e == null ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView;
  return !!(n && e instanceof n.Element);
}, $k = function(e) {
  switch (e.tagName) {
    case "INPUT":
      if (e.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, Wo = typeof window < "u" ? window : {}, ou = /* @__PURE__ */ new WeakMap(), iv = /auto|scroll/, jk = /^tb|vertical/, Hk = /msie|trident/i.test(Wo.navigator && Wo.navigator.userAgent), Br = function(e) {
  return parseFloat(e || "0");
}, Ss = function(e, t, n) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), n === void 0 && (n = !1), new Lk((n ? t : e) || 0, (n ? e : t) || 0);
}, av = Pa({
  devicePixelContentBoxSize: Ss(),
  borderBoxSize: Ss(),
  contentBoxSize: Ss(),
  contentRect: new tb(0, 0, 0, 0)
}), rb = function(e, t) {
  if (t === void 0 && (t = !1), ou.has(e) && !t)
    return ou.get(e);
  if (nb(e))
    return ou.set(e, av), av;
  var n = getComputedStyle(e), r = Bp(e) && e.ownerSVGElement && e.getBBox(), i = !Hk && n.boxSizing === "border-box", a = jk.test(n.writingMode || ""), s = !r && iv.test(n.overflowY || ""), o = !r && iv.test(n.overflowX || ""), l = r ? 0 : Br(n.paddingTop), u = r ? 0 : Br(n.paddingRight), c = r ? 0 : Br(n.paddingBottom), d = r ? 0 : Br(n.paddingLeft), f = r ? 0 : Br(n.borderTopWidth), p = r ? 0 : Br(n.borderRightWidth), g = r ? 0 : Br(n.borderBottomWidth), m = r ? 0 : Br(n.borderLeftWidth), y = d + u, v = l + c, E = m + p, b = f + g, _ = o ? e.offsetHeight - b - e.clientHeight : 0, T = s ? e.offsetWidth - E - e.clientWidth : 0, x = i ? y + E : 0, A = i ? v + b : 0, R = r ? r.width : Br(n.width) - x - T, P = r ? r.height : Br(n.height) - A - _, L = R + y + T + E, I = P + v + _ + b, O = Pa({
    devicePixelContentBoxSize: Ss(Math.round(R * devicePixelRatio), Math.round(P * devicePixelRatio), a),
    borderBoxSize: Ss(L, I, a),
    contentBoxSize: Ss(R, P, a),
    contentRect: new tb(d, l, R, P)
  });
  return ou.set(e, O), O;
}, ib = function(e, t, n) {
  var r = rb(e, n), i = r.borderBoxSize, a = r.contentBoxSize, s = r.devicePixelContentBoxSize;
  switch (t) {
    case yl.DEVICE_PIXEL_CONTENT_BOX:
      return s;
    case yl.BORDER_BOX:
      return i;
    default:
      return a;
  }
}, Uk = function() {
  function e(t) {
    var n = rb(t);
    this.target = t, this.contentRect = n.contentRect, this.borderBoxSize = Pa([n.borderBoxSize]), this.contentBoxSize = Pa([n.contentBoxSize]), this.devicePixelContentBoxSize = Pa([n.devicePixelContentBoxSize]);
  }
  return e;
}(), ab = function(e) {
  if (nb(e))
    return 1 / 0;
  for (var t = 0, n = e.parentNode; n; )
    t += 1, n = n.parentNode;
  return t;
}, zk = function() {
  var e = 1 / 0, t = [];
  Ia.forEach(function(s) {
    if (s.activeTargets.length !== 0) {
      var o = [];
      s.activeTargets.forEach(function(u) {
        var c = new Uk(u.target), d = ab(u.target);
        o.push(c), u.lastReportedSize = ib(u.target, u.observedBox), d < e && (e = d);
      }), t.push(function() {
        s.callback.call(s.observer, o, s.observer);
      }), s.activeTargets.splice(0, s.activeTargets.length);
    }
  });
  for (var n = 0, r = t; n < r.length; n++) {
    var i = r[n];
    i();
  }
  return e;
}, sv = function(e) {
  Ia.forEach(function(n) {
    n.activeTargets.splice(0, n.activeTargets.length), n.skippedTargets.splice(0, n.skippedTargets.length), n.observationTargets.forEach(function(i) {
      i.isActive() && (ab(i.target) > e ? n.activeTargets.push(i) : n.skippedTargets.push(i));
    });
  });
}, qk = function() {
  var e = 0;
  for (sv(e); Fk(); )
    e = zk(), sv(e);
  return Bk() && Mk(), e > 0;
}, cd, sb = [], Wk = function() {
  return sb.splice(0).forEach(function(e) {
    return e();
  });
}, Vk = function(e) {
  if (!cd) {
    var t = 0, n = document.createTextNode(""), r = { characterData: !0 };
    new MutationObserver(function() {
      return Wk();
    }).observe(n, r), cd = function() {
      n.textContent = "".concat(t ? t-- : t++);
    };
  }
  sb.push(e), cd();
}, Kk = function(e) {
  Vk(function() {
    requestAnimationFrame(e);
  });
}, lc = 0, Gk = function() {
  return !!lc;
}, Yk = 250, Zk = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, ov = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], lv = function(e) {
  return e === void 0 && (e = 0), Date.now() + e;
}, dd = !1, Qk = function() {
  function e() {
    var t = this;
    this.stopped = !0, this.listener = function() {
      return t.schedule();
    };
  }
  return e.prototype.run = function(t) {
    var n = this;
    if (t === void 0 && (t = Yk), !dd) {
      dd = !0;
      var r = lv(t);
      Kk(function() {
        var i = !1;
        try {
          i = qk();
        } finally {
          if (dd = !1, t = r - lv(), !Gk())
            return;
          i ? n.run(1e3) : t > 0 ? n.run(t) : n.start();
        }
      });
    }
  }, e.prototype.schedule = function() {
    this.stop(), this.run();
  }, e.prototype.observe = function() {
    var t = this, n = function() {
      return t.observer && t.observer.observe(document.body, Zk);
    };
    document.body ? n() : Wo.addEventListener("DOMContentLoaded", n);
  }, e.prototype.start = function() {
    var t = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), ov.forEach(function(n) {
      return Wo.addEventListener(n, t.listener, !0);
    }));
  }, e.prototype.stop = function() {
    var t = this;
    this.stopped || (this.observer && this.observer.disconnect(), ov.forEach(function(n) {
      return Wo.removeEventListener(n, t.listener, !0);
    }), this.stopped = !0);
  }, e;
}(), gh = new Qk(), uv = function(e) {
  !lc && e > 0 && gh.start(), lc += e, !lc && gh.stop();
}, Xk = function(e) {
  return !Bp(e) && !$k(e) && getComputedStyle(e).display === "inline";
}, Jk = function() {
  function e(t, n) {
    this.target = t, this.observedBox = n || yl.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var t = ib(this.target, this.observedBox, !0);
    return Xk(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, e;
}(), eD = function() {
  function e(t, n) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = n;
  }
  return e;
}(), lu = /* @__PURE__ */ new WeakMap(), cv = function(e, t) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n].target === t)
      return n;
  return -1;
}, uu = function() {
  function e() {
  }
  return e.connect = function(t, n) {
    var r = new eD(t, n);
    lu.set(t, r);
  }, e.observe = function(t, n, r) {
    var i = lu.get(t), a = i.observationTargets.length === 0;
    cv(i.observationTargets, n) < 0 && (a && Ia.push(i), i.observationTargets.push(new Jk(n, r && r.box)), uv(1), gh.schedule());
  }, e.unobserve = function(t, n) {
    var r = lu.get(t), i = cv(r.observationTargets, n), a = r.observationTargets.length === 1;
    i >= 0 && (a && Ia.splice(Ia.indexOf(r), 1), r.observationTargets.splice(i, 1), uv(-1));
  }, e.disconnect = function(t) {
    var n = this, r = lu.get(t);
    r.observationTargets.slice().forEach(function(i) {
      return n.unobserve(t, i.target);
    }), r.activeTargets.splice(0, r.activeTargets.length);
  }, e;
}(), tD = function() {
  function e(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof t != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    uu.connect(this, t);
  }
  return e.prototype.observe = function(t, n) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!rv(t))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    uu.observe(this, t, n);
  }, e.prototype.unobserve = function(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!rv(t))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    uu.unobserve(this, t);
  }, e.prototype.disconnect = function() {
    uu.disconnect(this);
  }, e.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, e;
}(), Oi = {};
Object.defineProperty(Oi, "__esModule", {
  value: !0
});
var nD = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), fd = {
  alt: "altKey",
  control: "ctrlKey",
  meta: "metaKey",
  shift: "shiftKey"
}, ob = {
  add: "+",
  break: "pause",
  cmd: "meta",
  command: "meta",
  ctl: "control",
  ctrl: "control",
  del: "delete",
  down: "arrowdown",
  esc: "escape",
  ins: "insert",
  left: "arrowleft",
  mod: nD ? "meta" : "control",
  opt: "alt",
  option: "alt",
  return: "enter",
  right: "arrowright",
  space: " ",
  spacebar: " ",
  up: "arrowup",
  win: "meta",
  windows: "meta"
}, Mp = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  " ": 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ";": 186,
  "=": 187,
  ",": 188,
  "-": 189,
  ".": 190,
  "/": 191,
  "`": 192,
  "[": 219,
  "\\": 220,
  "]": 221,
  "'": 222
};
for (var cu = 1; cu < 20; cu++)
  Mp["f" + cu] = 111 + cu;
function o1(e, t, n) {
  t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
  var r = e.map(function(s) {
    return lb(s, t);
  }), i = function(o) {
    return r.some(function(l) {
      return ub(l, o);
    });
  }, a = n == null ? i : i(n);
  return a;
}
function rD(e, t) {
  return o1(e, t);
}
function iD(e, t) {
  return o1(e, { byKey: !0 }, t);
}
function lb(e, t) {
  var n = t && t.byKey, r = {};
  e = e.replace("++", "+add");
  var i = e.split("+"), a = i.length;
  for (var s in fd)
    r[fd[s]] = !1;
  var o = !0, l = !1, u = void 0;
  try {
    for (var c = i[Symbol.iterator](), d; !(o = (d = c.next()).done); o = !0) {
      var f = d.value, p = f.endsWith("?") && f.length > 1;
      p && (f = f.slice(0, -1));
      var g = Lp(f), m = fd[g];
      if (f.length > 1 && !m && !ob[f] && !Mp[g])
        throw new TypeError('Unknown modifier: "' + f + '"');
      (a === 1 || !m) && (n ? r.key = g : r.which = cb(f)), m && (r[m] = p ? null : !0);
    }
  } catch (y) {
    l = !0, u = y;
  } finally {
    try {
      !o && c.return && c.return();
    } finally {
      if (l)
        throw u;
    }
  }
  return r;
}
function ub(e, t) {
  for (var n in e) {
    var r = e[n], i = void 0;
    if (r != null && (n === "key" && t.key != null ? i = t.key.toLowerCase() : n === "which" ? i = r === 91 && t.which === 93 ? 91 : t.which : i = t[n], !(i == null && r === !1) && i !== r))
      return !1;
  }
  return !0;
}
function cb(e) {
  e = Lp(e);
  var t = Mp[e] || e.toUpperCase().charCodeAt(0);
  return t;
}
function Lp(e) {
  return e = e.toLowerCase(), e = ob[e] || e, e;
}
var aD = Oi.default = o1, hd = Oi.isHotkey = o1;
Oi.isCodeHotkey = rD;
Oi.isKeyHotkey = iD;
Oi.parseHotkey = lb;
Oi.compareHotkey = ub;
Oi.toKeyCode = cb;
Oi.toKeyName = Lp;
function sD(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Hs(e, t) {
  if (e == null)
    return {};
  var n = sD(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function El(e) {
  "@babel/helpers - typeof";
  return El = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, El(e);
}
function oD(e, t) {
  if (El(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (El(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function lD(e) {
  var t = oD(e, "string");
  return El(t) === "symbol" ? t : String(t);
}
function cr(e, t, n) {
  return t = lD(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var $p = /* @__PURE__ */ sn(null), oa = () => {
  var e = We($p);
  if (!e)
    throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
  return e;
}, db = parseInt(M.version.split(".")[0], 10), uD = typeof navigator < "u" && typeof window < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, dv = typeof navigator < "u" && /Mac OS X/.test(navigator.userAgent), _n = typeof navigator < "u" && /Android/.test(navigator.userAgent), Ts = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), Fo = typeof navigator < "u" && /AppleWebKit(?!.*Chrome)/i.test(navigator.userAgent), cD = typeof navigator < "u" && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent), fb = typeof navigator < "u" && /Chrome/i.test(navigator.userAgent), dD = typeof navigator < "u" && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent), fD = _n && typeof navigator < "u" && /Chrome?\/(?:[0-5]?\d)(?:\.)/i.test(navigator.userAgent), hD = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent), pD = typeof navigator < "u" && /.*UCBrowser/.test(navigator.userAgent), mD = typeof navigator < "u" && /.*Wechat/.test(navigator.userAgent) && !/.*MacWechat/.test(navigator.userAgent), uc = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Li = (!dD || !fD) && !cD && // globalThis is undefined in older browsers
typeof globalThis < "u" && globalThis.InputEvent && // @ts-ignore The `getTargetRanges` property isn't recognized.
typeof globalThis.InputEvent.prototype.getTargetRanges == "function", jp = /* @__PURE__ */ new WeakMap(), Hp = /* @__PURE__ */ new WeakMap(), hb = /* @__PURE__ */ new WeakMap(), cc = /* @__PURE__ */ new WeakMap(), vh = /* @__PURE__ */ new WeakMap(), bl = /* @__PURE__ */ new WeakMap(), Ra = /* @__PURE__ */ new WeakMap(), Uc = /* @__PURE__ */ new WeakMap(), l1 = /* @__PURE__ */ new WeakMap(), yh = /* @__PURE__ */ new WeakMap(), Qi = /* @__PURE__ */ new WeakMap(), Da = /* @__PURE__ */ new WeakMap(), Vo = /* @__PURE__ */ new WeakMap(), Eh = /* @__PURE__ */ new WeakMap(), Up = /* @__PURE__ */ new WeakMap(), Sr = /* @__PURE__ */ new WeakMap(), bi = /* @__PURE__ */ new WeakMap(), Nn = /* @__PURE__ */ new WeakMap(), Vi = /* @__PURE__ */ new WeakMap(), Ki = /* @__PURE__ */ new WeakMap(), pb = /* @__PURE__ */ new WeakMap(), Us = Symbol("placeholder"), mb = Symbol("mark-placeholder"), gD = globalThis.Text, zp = (e) => e && e.ownerDocument && e.ownerDocument.defaultView || null, vD = (e) => na(e) && e.nodeType === 8, lr = (e) => na(e) && e.nodeType === 1, na = (e) => {
  var t = zp(e);
  return !!t && e instanceof t.Node;
}, bh = (e) => {
  var t = e && e.anchorNode && zp(e.anchorNode);
  return !!t && e instanceof t.Selection;
}, gb = (e) => na(e) && e.nodeType === 3, yD = (e) => e.clipboardData && e.clipboardData.getData("text/plain") !== "" && e.clipboardData.types.length === 1, ED = (e) => {
  var [t, n] = e;
  if (lr(t) && t.childNodes.length) {
    var r = n === t.childNodes.length, i = r ? n - 1 : n;
    for ([t, i] = vb(t, i, r ? "backward" : "forward"), r = i < n; lr(t) && t.childNodes.length; ) {
      var a = r ? t.childNodes.length - 1 : 0;
      t = TD(t, a, r ? "backward" : "forward");
    }
    n = r && t.textContent != null ? t.textContent.length : 0;
  }
  return [t, n];
}, bD = (e) => {
  for (var t = e && e.parentNode; t; ) {
    if (t.toString() === "[object ShadowRoot]")
      return !0;
    t = t.parentNode;
  }
  return !1;
}, vb = (e, t, n) => {
  for (var {
    childNodes: r
  } = e, i = r[t], a = t, s = !1, o = !1; (vD(i) || lr(i) && i.childNodes.length === 0 || lr(i) && i.getAttribute("contenteditable") === "false") && !(s && o); ) {
    if (a >= r.length) {
      s = !0, a = t - 1, n = "backward";
      continue;
    }
    if (a < 0) {
      o = !0, a = t + 1, n = "forward";
      continue;
    }
    i = r[a], t = a, a += n === "forward" ? 1 : -1;
  }
  return [i, t];
}, TD = (e, t, n) => {
  var [r] = vb(e, t, n);
  return r;
}, yb = (e) => {
  var t = "";
  if (gb(e) && e.nodeValue)
    return e.nodeValue;
  if (lr(e)) {
    for (var n of Array.from(e.childNodes))
      t += yb(n);
    var r = getComputedStyle(e).getPropertyValue("display");
    (r === "block" || r === "list" || e.tagName === "BR") && (t += `
`);
  }
  return t;
}, _D = /data-slate-fragment="(.+?)"/m, CD = (e) => {
  var t = e.getData("text/html"), [, n] = t.match(_D) || [];
  return n;
}, qp = (e, t, n) => {
  var {
    target: r
  } = t;
  if (lr(r) && r.matches('[contentEditable="false"]'))
    return !1;
  var {
    document: i
  } = ce.getWindow(e);
  if (i.contains(r))
    return ce.hasDOMNode(e, r, {
      editable: !0
    });
  var a = n.find((s) => {
    var {
      addedNodes: o,
      removedNodes: l
    } = s;
    for (var u of o)
      if (u === r || u.contains(r))
        return !0;
    for (var c of l)
      if (c === r || c.contains(r))
        return !0;
  });
  return !a || a === t ? !1 : qp(e, a, n);
}, xD = 0;
class wD {
  constructor() {
    cr(this, "id", void 0), this.id = "".concat(xD++);
  }
}
var ce = {
  androidPendingDiffs: (e) => Nn.get(e),
  androidScheduleFlush: (e) => {
    var t;
    (t = Up.get(e)) === null || t === void 0 || t();
  },
  blur: (e) => {
    var t = ce.toDOMNode(e, e), n = ce.findDocumentOrShadowRoot(e);
    Qi.set(e, !1), n.activeElement === t && t.blur();
  },
  deselect: (e) => {
    var {
      selection: t
    } = e, n = ce.findDocumentOrShadowRoot(e), r = n.getSelection();
    r && r.rangeCount > 0 && r.removeAllRanges(), t && le.deselect(e);
  },
  findDocumentOrShadowRoot: (e) => {
    var t = ce.toDOMNode(e, e), n = t.getRootNode();
    return (n instanceof Document || n instanceof ShadowRoot) && n.getSelection != null ? n : t.ownerDocument;
  },
  findEventRange: (e, t) => {
    "nativeEvent" in t && (t = t.nativeEvent);
    var {
      clientX: n,
      clientY: r,
      target: i
    } = t;
    if (n == null || r == null)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
    var a = ce.toSlateNode(e, t.target), s = ce.findPath(e, a);
    if (De.isElement(a) && k.isVoid(e, a)) {
      var o = i.getBoundingClientRect(), l = e.isInline(a) ? n - o.left < o.left + o.width - n : r - o.top < o.top + o.height - r, u = k.point(e, s, {
        edge: l ? "start" : "end"
      }), c = l ? k.before(e, u) : k.after(e, u);
      if (c) {
        var d = k.range(e, c);
        return d;
      }
    }
    var f, {
      document: p
    } = ce.getWindow(e);
    if (p.caretRangeFromPoint)
      f = p.caretRangeFromPoint(n, r);
    else {
      var g = p.caretPositionFromPoint(n, r);
      g && (f = p.createRange(), f.setStart(g.offsetNode, g.offset), f.setEnd(g.offsetNode, g.offset));
    }
    if (!f)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
    var m = ce.toSlateRange(e, f, {
      exactMatch: !1,
      suppressThrow: !1
    });
    return m;
  },
  findKey: (e, t) => {
    var n = Uc.get(t);
    return n || (n = new wD(), Uc.set(t, n)), n;
  },
  findPath: (e, t) => {
    for (var n = [], r = t; ; ) {
      var i = Hp.get(r);
      if (i == null) {
        if (k.isEditor(r))
          return n;
        break;
      }
      var a = jp.get(r);
      if (a == null)
        break;
      n.unshift(a), r = i;
    }
    throw new Error("Unable to find the path for Slate node: ".concat(nn.stringify(t)));
  },
  focus: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      retries: 5
    };
    if (!Qi.get(t)) {
      if (n.retries <= 0)
        throw new Error("Could not set focus, editor seems stuck with pending operations");
      if (t.operations.length > 0) {
        setTimeout(() => {
          ce.focus(t, {
            retries: n.retries - 1
          });
        }, 10);
        return;
      }
      var r = ce.toDOMNode(t, t), i = ce.findDocumentOrShadowRoot(t);
      if (i.activeElement !== r) {
        if (t.selection && i instanceof Document) {
          var a = i.getSelection(), s = ce.toDOMRange(t, t.selection);
          a == null || a.removeAllRanges(), a == null || a.addRange(s);
        }
        t.selection || (le.select(t, k.start(t, [])), t.onChange()), Qi.set(t, !0), r.focus({
          preventScroll: !0
        });
      }
    }
  },
  getWindow: (e) => {
    var t = hb.get(e);
    if (!t)
      throw new Error("Unable to find a host window element for this editor");
    return t;
  },
  hasDOMNode: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      editable: i = !1
    } = r, a = ce.toDOMNode(t, t), s;
    try {
      s = lr(n) ? n : n.parentElement;
    } catch (o) {
      if (o instanceof Error && !o.message.includes('Permission denied to access property "nodeType"'))
        throw o;
    }
    return s ? s.closest("[data-slate-editor]") === a && (!i || s.isContentEditable ? !0 : typeof s.isContentEditable == "boolean" && // isContentEditable exists only on HTMLElement, and on other nodes it will be undefined
    // this is the core logic that lets you know you got the right editor.selection instead of null when editor is contenteditable="false"(readOnly)
    s.closest('[contenteditable="false"]') === a || !!s.getAttribute("data-slate-zero-width")) : !1;
  },
  hasEditableTarget: (e, t) => na(t) && ce.hasDOMNode(e, t, {
    editable: !0
  }),
  hasRange: (e, t) => {
    var {
      anchor: n,
      focus: r
    } = t;
    return k.hasPath(e, n.path) && k.hasPath(e, r.path);
  },
  hasSelectableTarget: (e, t) => ce.hasEditableTarget(e, t) || ce.isTargetInsideNonReadonlyVoid(e, t),
  hasTarget: (e, t) => na(t) && ce.hasDOMNode(e, t),
  insertData: (e, t) => {
    e.insertData(t);
  },
  insertFragmentData: (e, t) => e.insertFragmentData(t),
  insertTextData: (e, t) => e.insertTextData(t),
  isComposing: (e) => !!Da.get(e),
  isFocused: (e) => !!Qi.get(e),
  isReadOnly: (e) => !!yh.get(e),
  isTargetInsideNonReadonlyVoid: (e, t) => {
    if (yh.get(e))
      return !1;
    var n = ce.hasTarget(e, t) && ce.toSlateNode(e, t);
    return De.isElement(n) && k.isVoid(e, n);
  },
  setFragmentData: (e, t, n) => e.setFragmentData(t, n),
  toDOMNode: (e, t) => {
    var n = l1.get(e), r = k.isEditor(t) ? cc.get(e) : n == null ? void 0 : n.get(ce.findKey(e, t));
    if (!r)
      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(nn.stringify(t)));
    return r;
  },
  toDOMPoint: (e, t) => {
    var [n] = k.node(e, t.path), r = ce.toDOMNode(e, n), i;
    k.void(e, {
      at: t
    }) && (t = {
      path: t.path,
      offset: 0
    });
    for (var a = "[data-slate-string], [data-slate-zero-width]", s = Array.from(r.querySelectorAll(a)), o = 0, l = 0; l < s.length; l++) {
      var u = s[l], c = u.childNodes[0];
      if (!(c == null || c.textContent == null)) {
        var {
          length: d
        } = c.textContent, f = u.getAttribute("data-slate-length"), p = f == null ? d : parseInt(f, 10), g = o + p, m = s[l + 1];
        if (t.offset === g && m !== null && m !== void 0 && m.hasAttribute("data-slate-mark-placeholder")) {
          var y, v = m.childNodes[0];
          i = [
            // COMPAT: If we don't explicity set the dom point to be on the actual
            // dom text element, chrome will put the selection behind the actual dom
            // text element, causing domRange.getBoundingClientRect() calls on a collapsed
            // selection to return incorrect zero values (https://bugs.chromium.org/p/chromium/issues/detail?id=435438)
            // which will cause issues when scrolling to it.
            v instanceof gD ? v : m,
            (y = m.textContent) !== null && y !== void 0 && y.startsWith("\uFEFF") ? 1 : 0
          ];
          break;
        }
        if (t.offset <= g) {
          var E = Math.min(d, Math.max(0, t.offset - o));
          i = [c, E];
          break;
        }
        o = g;
      }
    }
    if (!i)
      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(nn.stringify(t)));
    return i;
  },
  toDOMRange: (e, t) => {
    var {
      anchor: n,
      focus: r
    } = t, i = oe.isBackward(t), a = ce.toDOMPoint(e, n), s = oe.isCollapsed(t) ? a : ce.toDOMPoint(e, r), o = ce.getWindow(e), l = o.document.createRange(), [u, c] = i ? s : a, [d, f] = i ? a : s, p = lr(u) ? u : u.parentElement, g = !!p.getAttribute("data-slate-zero-width"), m = lr(d) ? d : d.parentElement, y = !!m.getAttribute("data-slate-zero-width");
    return l.setStart(u, g ? 1 : c), l.setEnd(d, y ? 1 : f), l;
  },
  toSlateNode: (e, t) => {
    var n = lr(t) ? t : t.parentElement;
    n && !n.hasAttribute("data-slate-node") && (n = n.closest("[data-slate-node]"));
    var r = n ? bl.get(n) : null;
    if (!r)
      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(n));
    return r;
  },
  toSlatePoint: (e, t, n) => {
    var {
      exactMatch: r,
      suppressThrow: i
    } = n, [a, s] = r ? t : ED(t), o = a.parentNode, l = null, u = 0;
    if (o) {
      var c, d, f = ce.toDOMNode(e, e), p = o.closest('[data-slate-void="true"]'), g = p && f.contains(p) ? p : null, m = o.closest("[data-slate-leaf]"), y = null;
      if (m) {
        if (l = m.closest('[data-slate-node="text"]'), l) {
          var v = ce.getWindow(e), E = v.document.createRange();
          E.setStart(l, 0), E.setEnd(a, s);
          var b = E.cloneContents(), _ = [...Array.prototype.slice.call(b.querySelectorAll("[data-slate-zero-width]")), ...Array.prototype.slice.call(b.querySelectorAll("[contenteditable=false]"))];
          _.forEach((F) => {
            if (_n && !r && F.hasAttribute("data-slate-zero-width") && F.textContent.length > 0 && F.textContext !== "\uFEFF") {
              F.textContent.startsWith("\uFEFF") && (F.textContent = F.textContent.slice(1));
              return;
            }
            F.parentNode.removeChild(F);
          }), u = b.textContent.length, y = l;
        }
      } else if (g) {
        for (var T = g.querySelectorAll("[data-slate-leaf]"), x = 0; x < T.length; x++) {
          var A = T[x];
          if (ce.hasDOMNode(e, A)) {
            m = A;
            break;
          }
        }
        m ? (l = m.closest('[data-slate-node="text"]'), y = m, u = y.textContent.length, y.querySelectorAll("[data-slate-zero-width]").forEach((F) => {
          u -= F.textContent.length;
        })) : u = 1;
      }
      y && u === y.textContent.length && // COMPAT: Android IMEs might remove the zero width space while composing,
      // and we don't add it for line-breaks.
      _n && y.getAttribute("data-slate-zero-width") === "z" && (c = y.textContent) !== null && c !== void 0 && c.startsWith("\uFEFF") && // COMPAT: If the parent node is a Slate zero-width space, editor is
      // because the text node should have no characters. However, during IME
      // composition the ASCII characters will be prepended to the zero-width
      // space, so subtract 1 from the offset to account for the zero-width
      // space character.
      (o.hasAttribute("data-slate-zero-width") || // COMPAT: In Firefox, `range.cloneContents()` returns an extra trailing '\n'
      // when the document ends with a new-line character. This results in the offset
      // length being off by one, so we need to subtract one to account for this.
      Ts && (d = y.textContent) !== null && d !== void 0 && d.endsWith(`

`)) && u--;
    }
    if (_n && !l && !r) {
      var R = o.hasAttribute("data-slate-node") ? o : o.closest("[data-slate-node]");
      if (R && ce.hasDOMNode(e, R, {
        editable: !0
      })) {
        var P = ce.toSlateNode(e, R), {
          path: L,
          offset: I
        } = k.start(e, ce.findPath(e, P));
        return R.querySelector("[data-slate-leaf]") || (I = s), {
          path: L,
          offset: I
        };
      }
    }
    if (!l) {
      if (i)
        return null;
      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(t));
    }
    var O = ce.toSlateNode(e, l), S = ce.findPath(e, O);
    return {
      path: S,
      offset: u
    };
  },
  toSlateRange: (e, t, n) => {
    var r, {
      exactMatch: i,
      suppressThrow: a
    } = n, s = bh(t) ? t.anchorNode : t.startContainer, o, l, u, c, d;
    if (s)
      if (bh(t)) {
        if (Ts && t.rangeCount > 1) {
          u = t.focusNode;
          var f = t.getRangeAt(0), p = t.getRangeAt(t.rangeCount - 1);
          if (u instanceof HTMLTableRowElement && f.startContainer instanceof HTMLTableRowElement && p.startContainer instanceof HTMLTableRowElement) {
            let x = function(A) {
              return A.childElementCount > 0 ? x(A.children[0]) : A;
            };
            var g = f.startContainer, m = p.startContainer, y = x(g.children[f.startOffset]), v = x(m.children[p.startOffset]);
            c = 0, v.childNodes.length > 0 ? o = v.childNodes[0] : o = v, y.childNodes.length > 0 ? u = y.childNodes[0] : u = y, v instanceof HTMLElement ? l = v.innerHTML.length : l = 0;
          } else
            f.startContainer === u ? (o = p.endContainer, l = p.endOffset, c = f.startOffset) : (o = f.startContainer, l = f.endOffset, c = p.startOffset);
        } else
          o = t.anchorNode, l = t.anchorOffset, u = t.focusNode, c = t.focusOffset;
        fb && bD(o) || Ts ? d = t.anchorNode === t.focusNode && t.anchorOffset === t.focusOffset : d = t.isCollapsed;
      } else
        o = t.startContainer, l = t.startOffset, u = t.endContainer, c = t.endOffset, d = t.collapsed;
    if (o == null || u == null || l == null || c == null)
      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(t));
    if (Ts && (r = u.textContent) !== null && r !== void 0 && r.endsWith(`

`) && c === u.textContent.length && c--, "getAttribute" in u && u.getAttribute("contenteditable") === "false" && u.getAttribute("data-slate-void") !== "true") {
      var E;
      u = o, c = ((E = o.textContent) === null || E === void 0 ? void 0 : E.length) || 0;
    }
    var b = ce.toSlatePoint(e, [o, l], {
      exactMatch: i,
      suppressThrow: a
    });
    if (!b)
      return null;
    var _ = d ? b : ce.toSlatePoint(e, [u, c], {
      exactMatch: i,
      suppressThrow: a
    });
    if (!_)
      return null;
    var T = {
      anchor: b,
      focus: _
    };
    return oe.isExpanded(T) && oe.isForward(T) && lr(u) && k.void(e, {
      at: T.focus,
      mode: "highest"
    }) && (T = k.unhangRange(e, T, {
      voids: !0
    })), T;
  }
};
function AD(e, t) {
  var {
    path: n,
    diff: r
  } = t;
  if (!k.hasPath(e, n))
    return !1;
  var i = be.get(e, n);
  if (!Ie.isText(i))
    return !1;
  if (r.start !== i.text.length || r.text.length === 0)
    return i.text.slice(r.start, r.start + r.text.length) === r.text;
  var a = V.next(n);
  if (!k.hasPath(e, a))
    return !1;
  var s = be.get(e, a);
  return Ie.isText(s) && s.text.startsWith(r.text);
}
function Eb(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return n.reduce((i, a) => i.slice(0, a.start) + a.text + i.slice(a.end), e);
}
function SD(e, t) {
  for (var n = Math.min(e.length, t.length), r = 0; r < n; r++)
    if (e.charAt(r) !== t.charAt(r))
      return r;
  return n;
}
function kD(e, t, n) {
  for (var r = Math.min(e.length, t.length, n), i = 0; i < r; i++)
    if (e.charAt(e.length - i - 1) !== t.charAt(t.length - i - 1))
      return i;
  return r;
}
function bb(e, t) {
  var {
    start: n,
    end: r,
    text: i
  } = t, a = e.slice(n, r), s = SD(a, i), o = Math.min(a.length - s, i.length - s), l = kD(a, i, o), u = {
    start: n + s,
    end: r - l,
    text: i.slice(s, i.length - l)
  };
  return u.start === u.end && u.text.length === 0 ? null : u;
}
function DD(e, t, n) {
  var r = Math.min(t.start, n.start), i = Math.max(0, Math.min(t.start + t.text.length, n.end) - n.start), a = Eb(e, t, n), s = Math.max(n.start + n.text.length, t.start + t.text.length + (t.start + t.text.length > n.start ? n.text.length : 0) - i), o = a.slice(r, s), l = Math.max(t.end, n.end - t.text.length + (t.end - t.start));
  return bb(e, {
    start: r,
    end: l,
    text: o
  });
}
function OD(e) {
  var {
    path: t,
    diff: n
  } = e;
  return {
    anchor: {
      path: t,
      offset: n.start
    },
    focus: {
      path: t,
      offset: n.end
    }
  };
}
function Th(e, t) {
  var {
    path: n,
    offset: r
  } = t;
  if (!k.hasPath(e, n))
    return null;
  var i = be.get(e, n);
  if (!Ie.isText(i))
    return null;
  var a = k.above(e, {
    match: (o) => De.isElement(o) && k.isBlock(e, o),
    at: n
  });
  if (!a)
    return null;
  for (; r > i.text.length; ) {
    var s = k.next(e, {
      at: n,
      match: Ie.isText
    });
    if (!s || !V.isDescendant(s[1], a[1]))
      return null;
    r -= i.text.length, i = s[0], n = s[1];
  }
  return {
    path: n,
    offset: r
  };
}
function fv(e, t) {
  var n = Th(e, t.anchor);
  if (!n)
    return null;
  if (oe.isCollapsed(t))
    return {
      anchor: n,
      focus: n
    };
  var r = Th(e, t.focus);
  return r ? {
    anchor: n,
    focus: r
  } : null;
}
function _h(e, t, n) {
  var r = Nn.get(e), i = r == null ? void 0 : r.find((c) => {
    var {
      path: d
    } = c;
    return V.equals(d, t.path);
  });
  if (!i || t.offset <= i.diff.start)
    return Xe.transform(t, n, {
      affinity: "backward"
    });
  var {
    diff: a
  } = i;
  if (t.offset <= a.start + a.text.length) {
    var s = {
      path: t.path,
      offset: a.start
    }, o = Xe.transform(s, n, {
      affinity: "backward"
    });
    return o ? {
      path: o.path,
      offset: o.offset + t.offset - a.start
    } : null;
  }
  var l = {
    path: t.path,
    offset: t.offset - a.text.length + a.end - a.start
  }, u = Xe.transform(l, n, {
    affinity: "backward"
  });
  return u ? n.type === "split_node" && V.equals(n.path, t.path) && l.offset < n.position && a.start < n.position ? u : {
    path: u.path,
    offset: u.offset + a.text.length - a.end + a.start
  } : null;
}
function hv(e, t, n) {
  var r = _h(e, t.anchor, n);
  if (!r)
    return null;
  if (oe.isCollapsed(t))
    return {
      anchor: r,
      focus: r
    };
  var i = _h(e, t.focus, n);
  return i ? {
    anchor: r,
    focus: i
  } : null;
}
function ND(e, t) {
  var {
    path: n,
    diff: r,
    id: i
  } = e;
  switch (t.type) {
    case "insert_text":
      return !V.equals(t.path, n) || t.offset >= r.end ? e : t.offset <= r.start ? {
        diff: {
          start: t.text.length + r.start,
          end: t.text.length + r.end,
          text: r.text
        },
        id: i,
        path: n
      } : {
        diff: {
          start: r.start,
          end: r.end + t.text.length,
          text: r.text
        },
        id: i,
        path: n
      };
    case "remove_text":
      return !V.equals(t.path, n) || t.offset >= r.end ? e : t.offset + t.text.length <= r.start ? {
        diff: {
          start: r.start - t.text.length,
          end: r.end - t.text.length,
          text: r.text
        },
        id: i,
        path: n
      } : {
        diff: {
          start: r.start,
          end: r.end - t.text.length,
          text: r.text
        },
        id: i,
        path: n
      };
    case "split_node":
      return !V.equals(t.path, n) || t.position >= r.end ? {
        diff: r,
        id: i,
        path: V.transform(n, t, {
          affinity: "backward"
        })
      } : t.position > r.start ? {
        diff: {
          start: r.start,
          end: Math.min(t.position, r.end),
          text: r.text
        },
        id: i,
        path: n
      } : {
        diff: {
          start: r.start - t.position,
          end: r.end - t.position,
          text: r.text
        },
        id: i,
        path: V.transform(n, t, {
          affinity: "forward"
        })
      };
    case "merge_node":
      return V.equals(t.path, n) ? {
        diff: {
          start: r.start + t.position,
          end: r.end + t.position,
          text: r.text
        },
        id: i,
        path: V.transform(n, t)
      } : {
        diff: r,
        id: i,
        path: V.transform(n, t)
      };
  }
  var a = V.transform(n, t);
  return a ? {
    diff: r,
    path: a,
    id: i
  } : null;
}
function pv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function du(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pv(Object(n), !0).forEach(function(r) {
      cr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var ID = 25, PD = 200, RD = function() {
}, FD = (e) => (e == null ? void 0 : e.constructor.name) === "DataTransfer";
function BD(e) {
  var {
    editor: t,
    scheduleOnDOMSelectionChange: n,
    onDOMSelectionChange: r
  } = e, i = !1, a = null, s = null, o = null, l = 0, u = !1, c = () => {
    var O = Ki.get(t);
    if (Ki.delete(t), O) {
      var {
        selection: S
      } = t, F = fv(t, O);
      F && (!S || !oe.equals(F, S)) && le.select(t, F);
    }
  }, d = () => {
    var O = Vi.get(t);
    if (Vi.delete(t), !!O) {
      if (O.at) {
        var S = Xe.isPoint(O.at) ? Th(t, O.at) : fv(t, O.at);
        if (!S)
          return;
        var F = k.range(t, S);
        (!t.selection || !oe.equals(t.selection, F)) && le.select(t, S);
      }
      O.run();
    }
  }, f = () => {
    if (s && (clearTimeout(s), s = null), o && (clearTimeout(o), o = null), !_() && !b()) {
      c();
      return;
    }
    i || (i = !0, setTimeout(() => i = !1)), b() && (i = "action");
    var O = t.selection && k.rangeRef(t, t.selection, {
      affinity: "forward"
    });
    bi.set(t, t.marks), RD("flush", Vi.get(t), Nn.get(t));
    for (var S = _(), F; F = (H = Nn.get(t)) === null || H === void 0 ? void 0 : H[0]; ) {
      var H, q, N = Sr.get(t);
      N !== void 0 && (Sr.delete(t), t.marks = N), N && u === !1 && (u = null);
      var Q = OD(F);
      (!t.selection || !oe.equals(t.selection, Q)) && le.select(t, Q), F.diff.text ? k.insertText(t, F.diff.text) : k.deleteFragment(t), Nn.set(t, (q = Nn.get(t)) === null || q === void 0 ? void 0 : q.filter((C) => {
        var {
          id: Z
        } = C;
        return Z !== F.id;
      })), AD(t, F) || (S = !1, Vi.delete(t), bi.delete(t), i = "action", Ki.delete(t), n.cancel(), r.cancel(), O == null || O.unref());
    }
    var J = O == null ? void 0 : O.unref();
    if (J && !Ki.get(t) && (!t.selection || !oe.equals(J, t.selection)) && le.select(t, J), b()) {
      d();
      return;
    }
    S && n(), n.flush(), r.flush(), c();
    var D = bi.get(t);
    bi.delete(t), D !== void 0 && (t.marks = D, t.onChange());
  }, p = (O) => {
    a && clearTimeout(a), a = setTimeout(() => {
      Da.set(t, !1), f();
    }, ID);
  }, g = (O) => {
    Da.set(t, !0), a && (clearTimeout(a), a = null);
  }, m = function() {
    var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, F = vh.get(t);
    if (F) {
      if (_() || S) {
        F.style.display = "none";
        return;
      }
      F.style.removeProperty("display");
    }
  }, y = (O, S) => {
    var F, H = (F = Nn.get(t)) !== null && F !== void 0 ? F : [];
    Nn.set(t, H);
    var q = be.leaf(t, O), N = H.findIndex((D) => V.equals(D.path, O));
    if (N < 0) {
      var Q = bb(q.text, S);
      Q && H.push({
        path: O,
        diff: S,
        id: l++
      }), m();
      return;
    }
    var J = DD(q.text, H[N].diff, S);
    if (!J) {
      H.splice(N, 1), m();
      return;
    }
    H[N] = du(du({}, H[N]), {}, {
      diff: J
    });
  }, v = function(S) {
    var {
      at: F
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    u = !1, Ki.delete(t), n.cancel(), r.cancel(), b() && f(), Vi.set(t, {
      at: F,
      run: S
    }), o = setTimeout(f);
  }, E = (O) => {
    var S;
    s && (clearTimeout(s), s = null);
    var {
      inputType: F
    } = O, H = null, q = O.dataTransfer || O.data || void 0;
    u !== !1 && F !== "insertText" && F !== "insertCompositionText" && (u = !1);
    var [N] = O.getTargetRanges();
    N && (H = ce.toSlateRange(t, N, {
      exactMatch: !1,
      suppressThrow: !0
    }));
    var Q = ce.getWindow(t), J = Q.getSelection();
    if (!H && J && (N = J, H = ce.toSlateRange(t, J, {
      exactMatch: !1,
      suppressThrow: !0
    })), H = (S = H) !== null && S !== void 0 ? S : t.selection, !!H) {
      var D = !0;
      if (F.startsWith("delete")) {
        if (oe.isExpanded(H)) {
          var [C, Z] = oe.edges(H), B = be.leaf(t, C.path);
          if (B.text.length === C.offset && Z.offset === 0) {
            var j = k.next(t, {
              at: C.path,
              match: Ie.isText
            });
            j && V.equals(j[1], Z.path) && (H = {
              anchor: Z,
              focus: Z
            });
          }
        }
        var z = F.endsWith("Backward") ? "backward" : "forward", [U, $] = oe.edges(H), [ae, Y] = k.leaf(t, U.path), ee = {
          text: "",
          start: U.offset,
          end: $.offset
        }, se = Nn.get(t), re = se == null ? void 0 : se.find((ge) => V.equals(ge.path, Y)), Ae = re ? [re.diff, ee] : [ee], Oe = Eb(ae.text, ...Ae);
        if (Oe.length === 0 && (D = !1), oe.isExpanded(H)) {
          if (D && V.equals(H.anchor.path, H.focus.path)) {
            var Ce = {
              path: H.anchor.path,
              offset: U.offset
            }, ue = k.range(t, Ce, Ce);
            return A(ue), y(H.anchor.path, {
              text: "",
              end: $.offset,
              start: U.offset
            });
          }
          return v(() => k.deleteFragment(t, {
            direction: z
          }), {
            at: H
          });
        }
      }
      switch (F) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag":
          return v(() => k.deleteFragment(t), {
            at: H
          });
        case "deleteContent":
        case "deleteContentForward": {
          var {
            anchor: fe
          } = H;
          if (D && oe.isCollapsed(H)) {
            var Se = be.leaf(t, fe.path);
            if (fe.offset < Se.text.length)
              return y(fe.path, {
                text: "",
                start: fe.offset,
                end: fe.offset + 1
              });
          }
          return v(() => k.deleteForward(t), {
            at: H
          });
        }
        case "deleteContentBackward": {
          var Fe, {
            anchor: nt
          } = H, mt = bh(N) ? N.isCollapsed : !!((Fe = N) !== null && Fe !== void 0 && Fe.collapsed);
          return D && mt && oe.isCollapsed(H) && nt.offset > 0 ? y(nt.path, {
            text: "",
            start: nt.offset - 1,
            end: nt.offset
          }) : v(() => k.deleteBackward(t), {
            at: H
          });
        }
        case "deleteEntireSoftLine":
          return v(() => {
            k.deleteBackward(t, {
              unit: "line"
            }), k.deleteForward(t, {
              unit: "line"
            });
          }, {
            at: H
          });
        case "deleteHardLineBackward":
          return v(() => k.deleteBackward(t, {
            unit: "block"
          }), {
            at: H
          });
        case "deleteSoftLineBackward":
          return v(() => k.deleteBackward(t, {
            unit: "line"
          }), {
            at: H
          });
        case "deleteHardLineForward":
          return v(() => k.deleteForward(t, {
            unit: "block"
          }), {
            at: H
          });
        case "deleteSoftLineForward":
          return v(() => k.deleteForward(t, {
            unit: "line"
          }), {
            at: H
          });
        case "deleteWordBackward":
          return v(() => k.deleteBackward(t, {
            unit: "word"
          }), {
            at: H
          });
        case "deleteWordForward":
          return v(() => k.deleteForward(t, {
            unit: "word"
          }), {
            at: H
          });
        case "insertLineBreak":
          return v(() => k.insertSoftBreak(t), {
            at: H
          });
        case "insertParagraph":
          return v(() => k.insertBreak(t), {
            at: H
          });
        case "insertCompositionText":
        case "deleteCompositionText":
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          if (FD(q))
            return v(() => ce.insertData(t, q), {
              at: H
            });
          var Ze = q ?? "";
          if (Sr.get(t) && (Ze = Ze.replace("\uFEFF", "")), F === "insertText" && /.*\n.*\n$/.test(Ze) && (Ze = Ze.slice(0, -1)), Ze.includes(`
`))
            return v(() => {
              var ge = Ze.split(`
`);
              ge.forEach((X, xe) => {
                X && k.insertText(t, X), xe !== ge.length - 1 && k.insertSoftBreak(t);
              });
            }, {
              at: H
            });
          if (V.equals(H.anchor.path, H.focus.path)) {
            var [rt, Qe] = oe.edges(H), ie = {
              start: rt.offset,
              end: Qe.offset,
              text: Ze
            };
            if (Ze && u && F === "insertCompositionText") {
              var me = u.start + u.text.search(/\S|$/), Pe = ie.start + ie.text.search(/\S|$/);
              Pe === me + 1 && ie.end === u.start + u.text.length ? (ie.start -= 1, u = null, L()) : u = !1;
            } else
              F === "insertText" ? u === null ? u = ie : u && oe.isCollapsed(H) && u.end + u.text.length === rt.offset ? u = du(du({}, u), {}, {
                text: u.text + Ze
              }) : u = !1 : u = !1;
            if (D) {
              y(rt.path, ie);
              return;
            }
          }
          return v(() => k.insertText(t, Ze), {
            at: H
          });
        }
      }
    }
  }, b = () => !!Vi.get(t), _ = () => {
    var O;
    return !!((O = Nn.get(t)) !== null && O !== void 0 && O.length);
  }, T = () => b() || _(), x = () => i, A = (O) => {
    Ki.set(t, O), s && (clearTimeout(s), s = null);
    var {
      selection: S
    } = t;
    if (O) {
      var F = !S || !V.equals(S.anchor.path, O.anchor.path), H = !S || !V.equals(S.anchor.path.slice(0, -1), O.anchor.path.slice(0, -1));
      (F && u || H) && (u = !1), (F || _()) && (s = setTimeout(f, PD));
    }
  }, R = () => {
    (b() || !_()) && f();
  }, P = (O) => {
    _() || (m(!0), setTimeout(m));
  }, L = () => {
    b() || (o = setTimeout(f));
  }, I = (O) => {
    if (!(_() || b()) && O.some((F) => qp(t, F, O))) {
      var S;
      (S = pb.get(t)) === null || S === void 0 || S();
    }
  };
  return {
    flush: f,
    scheduleFlush: L,
    hasPendingDiffs: _,
    hasPendingAction: b,
    hasPendingChanges: T,
    isFlushing: x,
    handleUserSelect: A,
    handleCompositionEnd: p,
    handleCompositionStart: g,
    handleDOMBeforeInput: E,
    handleKeyDown: P,
    handleDomMutations: I,
    handleInput: R
  };
}
function MD() {
  var e = Ue(!1);
  return pe(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e.current;
}
var Tl = uc ? ME : pe;
function LD(e, t, n) {
  var [r] = de(() => new MutationObserver(t));
  Tl(() => {
    r.takeRecords();
  }), pe(() => {
    if (!e.current)
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    return r.observe(e.current, n), () => r.disconnect();
  }, [r, e, n]);
}
var $D = ["node"];
function mv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jD(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mv(Object(n), !0).forEach(function(r) {
      cr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var HD = {
  subtree: !0,
  childList: !0,
  characterData: !0
}, UD = _n ? (e) => {
  var {
    node: t
  } = e, n = Hs(e, $D);
  if (!_n)
    return null;
  var r = oa(), i = MD(), [a] = de(() => BD(jD({
    editor: r
  }, n)));
  return LD(t, a.handleDomMutations, HD), Up.set(r, a.scheduleFlush), i && a.flush(), a;
} : () => null, zD = ["anchor", "focus"], qD = ["anchor", "focus"], WD = (e, t) => Object.keys(e).length === Object.keys(t).length && Object.keys(e).every((n) => t.hasOwnProperty(n) && e[n] === t[n]), Tb = (e, t) => {
  var n = Hs(e, zD), r = Hs(t, qD);
  return e[Us] === t[Us] && WD(n, r);
}, VD = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], i = t[n];
    if (!oe.equals(r, i) || !Tb(r, i))
      return !1;
  }
  return !0;
}, KD = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], i = t[n];
    if (r.anchor.offset !== i.anchor.offset || r.focus.offset !== i.focus.offset || !Tb(r, i))
      return !1;
  }
  return !0;
};
function gv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function GD(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gv(Object(n), !0).forEach(function(r) {
      cr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var YD = (e) => {
  var {
    isLast: t,
    leaf: n,
    parent: r,
    text: i
  } = e, a = oa(), s = ce.findPath(a, i), o = V.parent(s), l = !!n[mb];
  return a.isVoid(r) ? /* @__PURE__ */ M.createElement(pd, {
    length: be.string(r).length
  }) : n.text === "" && r.children[r.children.length - 1] === i && !a.isInline(r) && k.string(a, o) === "" ? /* @__PURE__ */ M.createElement(pd, {
    isLineBreak: !0,
    isMarkPlaceholder: l
  }) : n.text === "" ? /* @__PURE__ */ M.createElement(pd, {
    isMarkPlaceholder: l
  }) : t && n.text.slice(-1) === `
` ? /* @__PURE__ */ M.createElement(vv, {
    isTrailing: !0,
    text: n.text
  }) : /* @__PURE__ */ M.createElement(vv, {
    text: n.text
  });
}, vv = (e) => {
  var {
    text: t,
    isTrailing: n = !1
  } = e, r = Ue(null), i = () => "".concat(t ?? "").concat(n ? `
` : ""), [a] = de(i);
  return Tl(() => {
    var s = i();
    r.current && r.current.textContent !== s && (r.current.textContent = s);
  }), /* @__PURE__ */ M.createElement(ZD, {
    ref: r
  }, a);
}, ZD = /* @__PURE__ */ mr(/* @__PURE__ */ Ol((e, t) => /* @__PURE__ */ M.createElement("span", {
  "data-slate-string": !0,
  ref: t
}, e.children))), pd = (e) => {
  var {
    length: t = 0,
    isLineBreak: n = !1,
    isMarkPlaceholder: r = !1
  } = e, i = {
    "data-slate-zero-width": n ? "n" : "z",
    "data-slate-length": t
  };
  return r && (i["data-slate-mark-placeholder"] = !0), /* @__PURE__ */ M.createElement("span", GD({}, i), !_n || !n ? "\uFEFF" : null, n ? /* @__PURE__ */ M.createElement("br", null) : null);
};
function yv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _b(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yv(Object(n), !0).forEach(function(r) {
      cr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var QD = _n ? 300 : 0;
function XD(e, t) {
  e.current && (e.current.disconnect(), t && (e.current = null));
}
function Ev(e) {
  e.current && (clearTimeout(e.current), e.current = null);
}
var JD = (e) => {
  var {
    leaf: t,
    isLast: n,
    text: r,
    parent: i,
    renderPlaceholder: a,
    renderLeaf: s = (E) => /* @__PURE__ */ M.createElement(tO, _b({}, E))
  } = e, o = oa(), l = Ue(null), u = Ue(null), [c, d] = de(!1), f = Ue(null), p = ft((E) => {
    if (XD(l, E == null), E == null) {
      var b;
      vh.delete(o), (b = t.onPlaceholderResize) === null || b === void 0 || b.call(t, null);
    } else {
      if (vh.set(o, E), !l.current) {
        var _ = window.ResizeObserver || tD;
        l.current = new _(() => {
          var T;
          (T = t.onPlaceholderResize) === null || T === void 0 || T.call(t, E);
        });
      }
      l.current.observe(E), u.current = E;
    }
  }, [u, t, o]), g = /* @__PURE__ */ M.createElement(YD, {
    isLast: n,
    leaf: t,
    parent: i,
    text: r
  }), m = !!t[Us];
  if (pe(() => (m ? f.current || (f.current = setTimeout(() => {
    d(!0), f.current = null;
  }, QD)) : (Ev(f), d(!1)), () => Ev(f)), [m, d]), m && c) {
    var y = {
      children: t.placeholder,
      attributes: {
        "data-slate-placeholder": !0,
        style: {
          position: "absolute",
          top: 0,
          pointerEvents: "none",
          width: "100%",
          maxWidth: "100%",
          display: "block",
          opacity: "0.333",
          userSelect: "none",
          textDecoration: "none",
          // Fixes https://github.com/udecode/plate/issues/2315
          WebkitUserModify: Fo ? "inherit" : void 0
        },
        contentEditable: !1,
        ref: p
      }
    };
    g = /* @__PURE__ */ M.createElement(M.Fragment, null, a(y), g);
  }
  var v = {
    "data-slate-leaf": !0
  };
  return s({
    attributes: v,
    children: g,
    leaf: t,
    text: r
  });
}, eO = /* @__PURE__ */ M.memo(JD, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && Ie.equals(t.leaf, e.leaf) && t.leaf[Us] === e.leaf[Us]), tO = (e) => {
  var {
    attributes: t,
    children: n
  } = e;
  return /* @__PURE__ */ M.createElement("span", _b({}, t), n);
}, nO = (e) => {
  for (var {
    decorations: t,
    isLast: n,
    parent: r,
    renderPlaceholder: i,
    renderLeaf: a,
    text: s
  } = e, o = oa(), l = Ue(null), u = Ie.decorations(s, t), c = ce.findKey(o, s), d = [], f = 0; f < u.length; f++) {
    var p = u[f];
    d.push(/* @__PURE__ */ M.createElement(eO, {
      isLast: n && f === u.length - 1,
      key: "".concat(c.id, "-").concat(f),
      renderPlaceholder: i,
      leaf: p,
      text: s,
      parent: r,
      renderLeaf: a
    }));
  }
  var g = ft((m) => {
    var y = l1.get(o);
    m ? (y == null || y.set(c, m), Ra.set(s, m), bl.set(m, s)) : (y == null || y.delete(c), Ra.delete(s), l.current && bl.delete(l.current)), l.current = m;
  }, [l, o, c, s]);
  return /* @__PURE__ */ M.createElement("span", {
    "data-slate-node": "text",
    ref: g
  }, d);
}, Cb = /* @__PURE__ */ M.memo(nO, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && KD(t.decorations, e.decorations));
function bv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ch(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bv(Object(n), !0).forEach(function(r) {
      cr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var rO = (e) => {
  var {
    decorations: t,
    element: n,
    renderElement: r = (E) => /* @__PURE__ */ M.createElement(aO, Ch({}, E)),
    renderPlaceholder: i,
    renderLeaf: a,
    selection: s
  } = e, o = oa(), l = lO(), u = o.isInline(n), c = ce.findKey(o, n), d = ft((E) => {
    var b = l1.get(o);
    E ? (b == null || b.set(c, E), Ra.set(n, E), bl.set(E, n)) : (b == null || b.delete(c), Ra.delete(n));
  }, [o, c, n]), f = wb({
    decorations: t,
    node: n,
    renderElement: r,
    renderPlaceholder: i,
    renderLeaf: a,
    selection: s
  }), p = {
    "data-slate-node": "element",
    ref: d
  };
  if (u && (p["data-slate-inline"] = !0), !u && k.hasInlines(o, n)) {
    var g = be.string(n), m = j4(g);
    m === "rtl" && (p.dir = m);
  }
  if (k.isVoid(o, n)) {
    p["data-slate-void"] = !0, !l && u && (p.contentEditable = !1);
    var y = u ? "span" : "div", [[v]] = be.texts(n);
    f = /* @__PURE__ */ M.createElement(y, {
      "data-slate-spacer": !0,
      style: {
        height: "0",
        color: "transparent",
        outline: "none",
        position: "absolute"
      }
    }, /* @__PURE__ */ M.createElement(Cb, {
      renderPlaceholder: i,
      decorations: [],
      isLast: !1,
      parent: n,
      text: v
    })), jp.set(v, 0), Hp.set(v, n);
  }
  return r({
    attributes: p,
    children: f,
    element: n
  });
}, iO = /* @__PURE__ */ M.memo(rO, (e, t) => e.element === t.element && e.renderElement === t.renderElement && e.renderLeaf === t.renderLeaf && e.renderPlaceholder === t.renderPlaceholder && VD(e.decorations, t.decorations) && (e.selection === t.selection || !!e.selection && !!t.selection && oe.equals(e.selection, t.selection))), aO = (e) => {
  var {
    attributes: t,
    children: n,
    element: r
  } = e, i = oa(), a = i.isInline(r) ? "span" : "div";
  return /* @__PURE__ */ M.createElement(a, Ch(Ch({}, t), {}, {
    style: {
      position: "relative"
    }
  }), n);
}, xb = /* @__PURE__ */ sn(() => []), sO = () => We(xb), oO = /* @__PURE__ */ sn(!1), wb = (e) => {
  for (var {
    decorations: t,
    node: n,
    renderElement: r,
    renderPlaceholder: i,
    renderLeaf: a,
    selection: s
  } = e, o = sO(), l = oa(), u = ce.findPath(l, n), c = [], d = De.isElement(n) && !l.isInline(n) && k.hasInlines(l, n), f = 0; f < n.children.length; f++) {
    var p = u.concat(f), g = n.children[f], m = ce.findKey(l, g), y = k.range(l, p), v = s && oe.intersection(y, s), E = o([g, p]);
    for (var b of t) {
      var _ = oe.intersection(b, y);
      _ && E.push(_);
    }
    De.isElement(g) ? c.push(/* @__PURE__ */ M.createElement(oO.Provider, {
      key: "provider-".concat(m.id),
      value: !!v
    }, /* @__PURE__ */ M.createElement(iO, {
      decorations: E,
      element: g,
      key: m.id,
      renderElement: r,
      renderPlaceholder: i,
      renderLeaf: a,
      selection: v
    }))) : c.push(/* @__PURE__ */ M.createElement(Cb, {
      decorations: E,
      key: m.id,
      isLast: d && f === n.children.length - 1,
      parent: n,
      renderPlaceholder: i,
      renderLeaf: a,
      text: g
    })), jp.set(g, f), Hp.set(g, n);
  }
  return c;
}, Ab = /* @__PURE__ */ sn(!1), lO = () => We(Ab), Sb = /* @__PURE__ */ sn(null), Wa = () => {
  var e = We(Sb);
  if (!e)
    throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
  var {
    editor: t
  } = e;
  return t;
};
function uO() {
  var e = oa(), t = Ue(!1), n = Ue(0), r = ft(() => {
    if (!t.current) {
      t.current = !0;
      var i = ce.getWindow(e);
      i.cancelAnimationFrame(n.current), n.current = i.requestAnimationFrame(() => {
        t.current = !1;
      });
    }
  }, [e]);
  return pe(() => () => cancelAnimationFrame(n.current), []), {
    receivedUserInput: t,
    onUserInput: r
  };
}
var cO = 3, dO = {
  bold: "mod+b",
  compose: ["down", "left", "right", "up", "backspace", "enter"],
  moveBackward: "left",
  moveForward: "right",
  moveWordBackward: "ctrl+left",
  moveWordForward: "ctrl+right",
  deleteBackward: "shift?+backspace",
  deleteForward: "shift?+delete",
  extendBackward: "shift+left",
  extendForward: "shift+right",
  italic: "mod+i",
  insertSoftBreak: "shift+enter",
  splitBlock: "enter",
  undo: "mod+z"
}, fO = {
  moveLineBackward: "opt+up",
  moveLineForward: "opt+down",
  moveWordBackward: "opt+left",
  moveWordForward: "opt+right",
  deleteBackward: ["ctrl+backspace", "ctrl+h"],
  deleteForward: ["ctrl+delete", "ctrl+d"],
  deleteLineBackward: "cmd+shift?+backspace",
  deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
  deleteWordBackward: "opt+shift?+backspace",
  deleteWordForward: "opt+shift?+delete",
  extendLineBackward: "opt+shift+up",
  extendLineForward: "opt+shift+down",
  redo: "cmd+shift+z",
  transposeCharacter: "ctrl+t"
}, hO = {
  deleteWordBackward: "ctrl+shift?+backspace",
  deleteWordForward: "ctrl+shift?+delete",
  redo: ["ctrl+y", "ctrl+shift+z"]
}, Lt = (e) => {
  var t = dO[e], n = fO[e], r = hO[e], i = t && hd(t), a = n && hd(n), s = r && hd(r);
  return (o) => !!(i && i(o) || dv && a && a(o) || !dv && s && s(o));
}, jt = {
  isBold: Lt("bold"),
  isCompose: Lt("compose"),
  isMoveBackward: Lt("moveBackward"),
  isMoveForward: Lt("moveForward"),
  isDeleteBackward: Lt("deleteBackward"),
  isDeleteForward: Lt("deleteForward"),
  isDeleteLineBackward: Lt("deleteLineBackward"),
  isDeleteLineForward: Lt("deleteLineForward"),
  isDeleteWordBackward: Lt("deleteWordBackward"),
  isDeleteWordForward: Lt("deleteWordForward"),
  isExtendBackward: Lt("extendBackward"),
  isExtendForward: Lt("extendForward"),
  isExtendLineBackward: Lt("extendLineBackward"),
  isExtendLineForward: Lt("extendLineForward"),
  isItalic: Lt("italic"),
  isMoveLineBackward: Lt("moveLineBackward"),
  isMoveLineForward: Lt("moveLineForward"),
  isMoveWordBackward: Lt("moveWordBackward"),
  isMoveWordForward: Lt("moveWordForward"),
  isRedo: Lt("redo"),
  isSoftBreak: Lt("insertSoftBreak"),
  isSplitBlock: Lt("splitBlock"),
  isTransposeCharacter: Lt("transposeCharacter"),
  isUndo: Lt("undo")
}, pO = (e, t) => {
  var n = [], r = () => {
    n = [];
  }, i = (s) => {
    if (t.current) {
      var o = s.filter((l) => qp(e, l, s));
      n.push(...o);
    }
  };
  function a() {
    n.length > 0 && (n.reverse().forEach((s) => {
      s.type !== "characterData" && (s.removedNodes.forEach((o) => {
        s.target.insertBefore(o, s.nextSibling);
      }), s.addedNodes.forEach((o) => {
        s.target.removeChild(o);
      }));
    }), r());
  }
  return {
    registerMutations: i,
    restoreDOM: a,
    clear: r
  };
}, mO = {
  subtree: !0,
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0
};
class kb extends LE {
  constructor() {
    super(...arguments), cr(this, "context", null), cr(this, "manager", null), cr(this, "mutationObserver", null);
  }
  observe() {
    var t, {
      node: n
    } = this.props;
    if (!n.current)
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    (t = this.mutationObserver) === null || t === void 0 || t.observe(n.current, mO);
  }
  componentDidMount() {
    var {
      receivedUserInput: t
    } = this.props, n = this.context;
    this.manager = pO(n, t), this.mutationObserver = new MutationObserver(this.manager.registerMutations), this.observe();
  }
  getSnapshotBeforeUpdate() {
    var t, n, r, i = (t = this.mutationObserver) === null || t === void 0 ? void 0 : t.takeRecords();
    if (i != null && i.length) {
      var a;
      (a = this.manager) === null || a === void 0 || a.registerMutations(i);
    }
    return (n = this.mutationObserver) === null || n === void 0 || n.disconnect(), (r = this.manager) === null || r === void 0 || r.restoreDOM(), null;
  }
  componentDidUpdate() {
    var t;
    (t = this.manager) === null || t === void 0 || t.clear(), this.observe();
  }
  componentWillUnmount() {
    var t;
    (t = this.mutationObserver) === null || t === void 0 || t.disconnect();
  }
  render() {
    return this.props.children;
  }
}
cr(kb, "contextType", $p);
var gO = _n ? kb : (e) => {
  var {
    children: t
  } = e;
  return /* @__PURE__ */ M.createElement(M.Fragment, null, t);
}, vO = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "scrollSelectionIntoView", "style", "as", "disableDefaultStyles"], yO = ["text"];
function Tv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $r(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Tv(Object(n), !0).forEach(function(r) {
      cr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Tv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var EO = (e) => /* @__PURE__ */ M.createElement(M.Fragment, null, wb(e)), bO = (e) => {
  var t = ft((j) => /* @__PURE__ */ M.createElement(TO, $r({}, j)), []), {
    autoFocus: n,
    decorate: r = _O,
    onDOMBeforeInput: i,
    placeholder: a,
    readOnly: s = !1,
    renderElement: o,
    renderLeaf: l,
    renderPlaceholder: u = t,
    scrollSelectionIntoView: c = CO,
    style: d = {},
    as: f = "div",
    disableDefaultStyles: p = !1
  } = e, g = Hs(e, vO), m = Wa(), [y, v] = de(!1), E = Ue(null), b = Ue([]), [_, T] = de(), {
    onUserInput: x,
    receivedUserInput: A
  } = uO(), [, R] = ra((j) => j + 1, 0);
  pb.set(m, R), yh.set(m, s);
  var P = Vn(() => ({
    isDraggingInternally: !1,
    isUpdatingSelection: !1,
    latestElement: null,
    hasMarkPlaceholder: !1
  }), []);
  pe(() => {
    E.current && n && E.current.focus();
  }, [n]);
  var L = Ue(), I = Vn(() => eA(() => {
    var j = L.current;
    if ((_n || !ce.isComposing(m)) && (!P.isUpdatingSelection || j != null && j.isFlushing()) && !P.isDraggingInternally) {
      var z = ce.findDocumentOrShadowRoot(m), {
        activeElement: U
      } = z, $ = ce.toDOMNode(m, m), ae = z.getSelection();
      if (U === $ ? (P.latestElement = U, Qi.set(m, !0)) : Qi.delete(m), !ae)
        return le.deselect(m);
      var {
        anchorNode: Y,
        focusNode: ee
      } = ae, se = ce.hasEditableTarget(m, Y) || ce.isTargetInsideNonReadonlyVoid(m, Y), re = ce.hasEditableTarget(m, ee) || ce.isTargetInsideNonReadonlyVoid(m, ee);
      if (se && re) {
        var Ae = ce.toSlateRange(m, ae, {
          exactMatch: !1,
          suppressThrow: !0
        });
        Ae && (!ce.isComposing(m) && !(j != null && j.hasPendingChanges()) && !(j != null && j.isFlushing()) ? le.select(m, Ae) : j == null || j.handleUserSelect(Ae));
      }
      s && (!se || !re) && le.deselect(m);
    }
  }, 100), [m, s, P]), O = Vn(() => Gw(I, 0), [I]);
  L.current = UD({
    node: E,
    onDOMSelectionChange: I,
    scheduleOnDOMSelectionChange: O
  }), Tl(() => {
    var j, z, U;
    E.current && (U = zp(E.current)) ? (hb.set(m, U), cc.set(m, E.current), Ra.set(m, E.current), bl.set(E.current, m)) : Ra.delete(m);
    var {
      selection: $
    } = m, ae = ce.findDocumentOrShadowRoot(m), Y = ae.getSelection();
    if (!(!Y || !ce.isFocused(m) || (j = L.current) !== null && j !== void 0 && j.hasPendingAction())) {
      var ee = (Oe) => {
        var Ce = Y.type !== "None";
        if (!(!$ && !Ce)) {
          var ue = Y.focusNode, fe;
          if (Ts && Y.rangeCount > 1) {
            var Se = Y.getRangeAt(0), Fe = Y.getRangeAt(Y.rangeCount - 1);
            Se.startContainer === ue ? fe = Fe.endContainer : fe = Se.startContainer;
          } else
            fe = Y.anchorNode;
          var nt = cc.get(m), mt = !1;
          if (nt.contains(fe) && nt.contains(ue) && (mt = !0), Ce && mt && $ && !Oe) {
            var Ze = ce.toSlateRange(m, Y, {
              exactMatch: !0,
              // domSelection is not necessarily a valid Slate range
              // (e.g. when clicking on contentEditable:false element)
              suppressThrow: !0
            });
            if (Ze && oe.equals(Ze, $)) {
              var rt;
              if (!P.hasMarkPlaceholder || (rt = fe) !== null && rt !== void 0 && (rt = rt.parentElement) !== null && rt !== void 0 && rt.hasAttribute("data-slate-mark-placeholder"))
                return;
            }
          }
          if ($ && !ce.hasRange(m, $)) {
            m.selection = ce.toSlateRange(m, Y, {
              exactMatch: !1,
              suppressThrow: !0
            });
            return;
          }
          P.isUpdatingSelection = !0;
          var Qe = $ && ce.toDOMRange(m, $);
          return Qe ? (ce.isComposing(m) && !_n ? Y.collapseToEnd() : oe.isBackward($) ? Y.setBaseAndExtent(Qe.endContainer, Qe.endOffset, Qe.startContainer, Qe.startOffset) : Y.setBaseAndExtent(Qe.startContainer, Qe.startOffset, Qe.endContainer, Qe.endOffset), c(m, Qe)) : Y.removeAllRanges(), Qe;
        }
      };
      Y.rangeCount <= 1 && ee();
      var se = ((z = L.current) === null || z === void 0 ? void 0 : z.isFlushing()) === "action";
      if (!_n || !se) {
        setTimeout(() => {
          P.isUpdatingSelection = !1;
        });
        return;
      }
      var re = null, Ae = requestAnimationFrame(() => {
        if (se) {
          var Oe = (Ce) => {
            try {
              var ue = ce.toDOMNode(m, m);
              ue.focus(), ee(Ce);
            } catch {
            }
          };
          Oe(), re = setTimeout(() => {
            Oe(!0), P.isUpdatingSelection = !1;
          });
        }
      });
      return () => {
        cancelAnimationFrame(Ae), re && clearTimeout(re);
      };
    }
  });
  var S = ft((j) => {
    if (x(), !s && ce.hasEditableTarget(m, j.target) && !xO(j, i)) {
      var z;
      if (L.current)
        return L.current.handleDOMBeforeInput(j);
      O.flush(), I.flush();
      var {
        selection: U
      } = m, {
        inputType: $
      } = j, ae = j.dataTransfer || j.data || void 0, Y = $ === "insertCompositionText" || $ === "deleteCompositionText";
      if (Y && ce.isComposing(m))
        return;
      var ee = !1;
      if ($ === "insertText" && U && oe.isCollapsed(U) && // Only use native character insertion for single characters a-z or space for now.
      // Long-press events (hold a + press 4 = ä) to choose a special character otherwise
      // causes duplicate inserts.
      j.data && j.data.length === 1 && /[a-z ]/i.test(j.data) && // Chrome has issues correctly editing the start of nodes: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
      // When there is an inline element, e.g. a link, and you select
      // right after it (the start of the next node).
      U.anchor.offset !== 0) {
        var se, re;
        ee = !0, m.marks && (ee = !1);
        var {
          anchor: Ae
        } = U, [Oe, Ce] = ce.toDOMPoint(m, Ae), ue = (se = Oe.parentElement) === null || se === void 0 ? void 0 : se.closest("a"), fe = ce.getWindow(m);
        if (ee && ue && ce.hasDOMNode(m, ue)) {
          var Se, Fe = fe == null ? void 0 : fe.document.createTreeWalker(ue, NodeFilter.SHOW_TEXT).lastChild();
          Fe === Oe && ((Se = Fe.textContent) === null || Se === void 0 ? void 0 : Se.length) === Ce && (ee = !1);
        }
        if (ee && Oe.parentElement && (fe == null || (re = fe.getComputedStyle(Oe.parentElement)) === null || re === void 0 ? void 0 : re.whiteSpace) === "pre") {
          var nt = k.above(m, {
            at: Ae.path,
            match: (me) => De.isElement(me) && k.isBlock(m, me)
          });
          nt && be.string(nt[0]).includes("	") && (ee = !1);
        }
      }
      if (!$.startsWith("delete") || $.startsWith("deleteBy")) {
        var [mt] = j.getTargetRanges();
        if (mt) {
          var Ze = ce.toSlateRange(m, mt, {
            exactMatch: !1,
            suppressThrow: !1
          });
          if (!U || !oe.equals(U, Ze)) {
            ee = !1;
            var rt = !Y && m.selection && k.rangeRef(m, m.selection);
            le.select(m, Ze), rt && Vo.set(m, rt);
          }
        }
      }
      if (Y)
        return;
      if (ee || j.preventDefault(), U && oe.isExpanded(U) && $.startsWith("delete")) {
        var Qe = $.endsWith("Backward") ? "backward" : "forward";
        k.deleteFragment(m, {
          direction: Qe
        });
        return;
      }
      switch ($) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag": {
          k.deleteFragment(m);
          break;
        }
        case "deleteContent":
        case "deleteContentForward": {
          k.deleteForward(m);
          break;
        }
        case "deleteContentBackward": {
          k.deleteBackward(m);
          break;
        }
        case "deleteEntireSoftLine": {
          k.deleteBackward(m, {
            unit: "line"
          }), k.deleteForward(m, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineBackward": {
          k.deleteBackward(m, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineBackward": {
          k.deleteBackward(m, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineForward": {
          k.deleteForward(m, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineForward": {
          k.deleteForward(m, {
            unit: "line"
          });
          break;
        }
        case "deleteWordBackward": {
          k.deleteBackward(m, {
            unit: "word"
          });
          break;
        }
        case "deleteWordForward": {
          k.deleteForward(m, {
            unit: "word"
          });
          break;
        }
        case "insertLineBreak":
          k.insertSoftBreak(m);
          break;
        case "insertParagraph": {
          k.insertBreak(m);
          break;
        }
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          $ === "insertFromComposition" && ce.isComposing(m) && (v(!1), Da.set(m, !1)), (ae == null ? void 0 : ae.constructor.name) === "DataTransfer" ? ce.insertData(m, ae) : typeof ae == "string" && (ee ? b.current.push(() => k.insertText(m, ae)) : k.insertText(m, ae));
          break;
        }
      }
      var ie = (z = Vo.get(m)) === null || z === void 0 ? void 0 : z.unref();
      Vo.delete(m), ie && (!m.selection || !oe.equals(m.selection, ie)) && le.select(m, ie);
    }
  }, [m, I, x, i, s, O]), F = ft((j) => {
    j == null ? (I.cancel(), O.cancel(), cc.delete(m), Ra.delete(m), E.current && Li && E.current.removeEventListener("beforeinput", S)) : Li && j.addEventListener("beforeinput", S), E.current = j;
  }, [I, O, m, S]);
  Tl(() => {
    var j = ce.getWindow(m);
    return j.document.addEventListener("selectionchange", O), () => {
      j.document.removeEventListener("selectionchange", O);
    };
  }, [O]);
  var H = r([m, []]), q = a && m.children.length === 1 && Array.from(be.texts(m)).length === 1 && be.string(m) === "" && !y, N = ft((j) => {
    if (j && q) {
      var z;
      T((z = j.getBoundingClientRect()) === null || z === void 0 ? void 0 : z.height);
    } else
      T(void 0);
  }, [q]);
  if (q) {
    var Q = k.start(m, []);
    H.push({
      [Us]: !0,
      placeholder: a,
      onPlaceholderResize: N,
      anchor: Q,
      focus: Q
    });
  }
  var {
    marks: J
  } = m;
  if (P.hasMarkPlaceholder = !1, m.selection && oe.isCollapsed(m.selection) && J) {
    var {
      anchor: D
    } = m.selection, C = be.leaf(m, D.path), Z = Hs(C, yO);
    if (!Ie.equals(C, J, {
      loose: !0
    })) {
      P.hasMarkPlaceholder = !0;
      var B = Object.fromEntries(Object.keys(Z).map((j) => [j, null]));
      H.push($r($r($r({
        [mb]: !0
      }, B), J), {}, {
        anchor: D,
        focus: D
      }));
    }
  }
  return pe(() => {
    setTimeout(() => {
      var {
        selection: j
      } = m;
      if (j) {
        var {
          anchor: z
        } = j, U = be.leaf(m, z.path);
        if (J && !Ie.equals(U, J, {
          loose: !0
        })) {
          Sr.set(m, J);
          return;
        }
      }
      Sr.delete(m);
    });
  }), /* @__PURE__ */ M.createElement(Ab.Provider, {
    value: s
  }, /* @__PURE__ */ M.createElement(xb.Provider, {
    value: r
  }, /* @__PURE__ */ M.createElement(gO, {
    node: E,
    receivedUserInput: A
  }, /* @__PURE__ */ M.createElement(f, $r($r({
    role: s ? void 0 : "textbox",
    "aria-multiline": s ? void 0 : !0
  }, g), {}, {
    // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
    // have to use hacks to make these replacement-based features work.
    // For SSR situations HAS_BEFORE_INPUT_SUPPORT is false and results in prop
    // mismatch warning app moves to browser. Pass-through consumer props when
    // not CAN_USE_DOM (SSR) and default to falsy value
    spellCheck: Li || !uc ? g.spellCheck : !1,
    autoCorrect: Li || !uc ? g.autoCorrect : "false",
    autoCapitalize: Li || !uc ? g.autoCapitalize : "false",
    "data-slate-editor": !0,
    "data-slate-node": "value",
    // explicitly set this
    contentEditable: !s,
    // in some cases, a decoration needs access to the range / selection to decorate a text node,
    // then you will select the whole text node when you select part the of text
    // this magic zIndex="-1" will fix it
    zindex: -1,
    suppressContentEditableWarning: !0,
    ref: F,
    style: $r($r({}, p ? {} : $r({
      // Allow positioning relative to the editable element.
      position: "relative",
      // Preserve adjacent whitespace and new lines.
      whiteSpace: "pre-wrap",
      // Allow words to break if they are too long.
      wordWrap: "break-word"
    }, _ ? {
      minHeight: _
    } : {})), d),
    onBeforeInput: ft((j) => {
      if (!Li && !s && !yn(j, g.onBeforeInput) && ce.hasSelectableTarget(m, j.target) && (j.preventDefault(), !ce.isComposing(m))) {
        var z = j.data;
        k.insertText(m, z);
      }
    }, [g.onBeforeInput, m, s]),
    onInput: ft((j) => {
      if (!yn(j, g.onInput)) {
        if (L.current) {
          L.current.handleInput();
          return;
        }
        for (var z of b.current)
          z();
        b.current = [];
      }
    }, [g.onInput]),
    onBlur: ft((j) => {
      if (!(s || P.isUpdatingSelection || !ce.hasSelectableTarget(m, j.target) || yn(j, g.onBlur))) {
        var z = ce.findDocumentOrShadowRoot(m);
        if (P.latestElement !== z.activeElement) {
          var {
            relatedTarget: U
          } = j, $ = ce.toDOMNode(m, m);
          if (U !== $ && !(lr(U) && U.hasAttribute("data-slate-spacer"))) {
            if (U != null && na(U) && ce.hasDOMNode(m, U)) {
              var ae = ce.toSlateNode(m, U);
              if (De.isElement(ae) && !m.isVoid(ae))
                return;
            }
            if (Fo) {
              var Y = z.getSelection();
              Y == null || Y.removeAllRanges();
            }
            Qi.delete(m);
          }
        }
      }
    }, [s, P.isUpdatingSelection, P.latestElement, m, g.onBlur]),
    onClick: ft((j) => {
      if (ce.hasTarget(m, j.target) && !yn(j, g.onClick) && na(j.target)) {
        var z = ce.toSlateNode(m, j.target), U = ce.findPath(m, z);
        if (!k.hasPath(m, U) || be.get(m, U) !== z)
          return;
        if (j.detail === cO && U.length >= 1) {
          var $ = U;
          if (!(De.isElement(z) && k.isBlock(m, z))) {
            var ae, Y = k.above(m, {
              match: (ue) => De.isElement(ue) && k.isBlock(m, ue),
              at: U
            });
            $ = (ae = Y == null ? void 0 : Y[1]) !== null && ae !== void 0 ? ae : U.slice(0, 1);
          }
          var ee = k.range(m, $);
          le.select(m, ee);
          return;
        }
        if (s)
          return;
        var se = k.start(m, U), re = k.end(m, U), Ae = k.void(m, {
          at: se
        }), Oe = k.void(m, {
          at: re
        });
        if (Ae && Oe && V.equals(Ae[1], Oe[1])) {
          var Ce = k.range(m, se);
          le.select(m, Ce);
        }
      }
    }, [m, g.onClick, s]),
    onCompositionEnd: ft((j) => {
      if (ce.hasSelectableTarget(m, j.target)) {
        var z;
        if (ce.isComposing(m) && Promise.resolve().then(() => {
          v(!1), Da.set(m, !1);
        }), (z = L.current) === null || z === void 0 || z.handleCompositionEnd(j), yn(j, g.onCompositionEnd) || _n)
          return;
        if (!Fo && !hD && !uD && !mD && !pD && j.data) {
          var U = Sr.get(m);
          Sr.delete(m), U !== void 0 && (bi.set(m, m.marks), m.marks = U), k.insertText(m, j.data);
          var $ = bi.get(m);
          bi.delete(m), $ !== void 0 && (m.marks = $);
        }
      }
    }, [g.onCompositionEnd, m]),
    onCompositionUpdate: ft((j) => {
      ce.hasSelectableTarget(m, j.target) && !yn(j, g.onCompositionUpdate) && (ce.isComposing(m) || (v(!0), Da.set(m, !0)));
    }, [g.onCompositionUpdate, m]),
    onCompositionStart: ft((j) => {
      if (ce.hasSelectableTarget(m, j.target)) {
        var z;
        if ((z = L.current) === null || z === void 0 || z.handleCompositionStart(j), yn(j, g.onCompositionStart) || _n)
          return;
        v(!0);
        var {
          selection: U
        } = m;
        if (U && oe.isExpanded(U)) {
          k.deleteFragment(m);
          return;
        }
      }
    }, [g.onCompositionStart, m]),
    onCopy: ft((j) => {
      ce.hasSelectableTarget(m, j.target) && !yn(j, g.onCopy) && !_v(j) && (j.preventDefault(), ce.setFragmentData(m, j.clipboardData, "copy"));
    }, [g.onCopy, m]),
    onCut: ft((j) => {
      if (!s && ce.hasSelectableTarget(m, j.target) && !yn(j, g.onCut) && !_v(j)) {
        j.preventDefault(), ce.setFragmentData(m, j.clipboardData, "cut");
        var {
          selection: z
        } = m;
        if (z)
          if (oe.isExpanded(z))
            k.deleteFragment(m);
          else {
            var U = be.parent(m, z.anchor.path);
            k.isVoid(m, U) && le.delete(m);
          }
      }
    }, [s, m, g.onCut]),
    onDragOver: ft((j) => {
      if (ce.hasTarget(m, j.target) && !yn(j, g.onDragOver)) {
        var z = ce.toSlateNode(m, j.target);
        De.isElement(z) && k.isVoid(m, z) && j.preventDefault();
      }
    }, [g.onDragOver, m]),
    onDragStart: ft((j) => {
      if (!s && ce.hasTarget(m, j.target) && !yn(j, g.onDragStart)) {
        var z = ce.toSlateNode(m, j.target), U = ce.findPath(m, z), $ = De.isElement(z) && k.isVoid(m, z) || k.void(m, {
          at: U,
          voids: !0
        });
        if ($) {
          var ae = k.range(m, U);
          le.select(m, ae);
        }
        P.isDraggingInternally = !0, ce.setFragmentData(m, j.dataTransfer, "drag");
      }
    }, [s, m, g.onDragStart, P]),
    onDrop: ft((j) => {
      if (!s && ce.hasTarget(m, j.target) && !yn(j, g.onDrop)) {
        j.preventDefault();
        var z = m.selection, U = ce.findEventRange(m, j), $ = j.dataTransfer;
        le.select(m, U), P.isDraggingInternally && z && !oe.equals(z, U) && !k.void(m, {
          at: U,
          voids: !0
        }) && le.delete(m, {
          at: z
        }), ce.insertData(m, $), ce.isFocused(m) || ce.focus(m);
      }
      P.isDraggingInternally = !1;
    }, [s, m, g.onDrop, P]),
    onDragEnd: ft((j) => {
      !s && P.isDraggingInternally && g.onDragEnd && ce.hasTarget(m, j.target) && g.onDragEnd(j), P.isDraggingInternally = !1;
    }, [s, P, g, m]),
    onFocus: ft((j) => {
      if (!s && !P.isUpdatingSelection && ce.hasEditableTarget(m, j.target) && !yn(j, g.onFocus)) {
        var z = ce.toDOMNode(m, m), U = ce.findDocumentOrShadowRoot(m);
        if (P.latestElement = U.activeElement, Ts && j.target !== z) {
          z.focus();
          return;
        }
        Qi.set(m, !0);
      }
    }, [s, P, m, g.onFocus]),
    onKeyDown: ft((j) => {
      if (!s && ce.hasEditableTarget(m, j.target)) {
        var z;
        (z = L.current) === null || z === void 0 || z.handleKeyDown(j);
        var {
          nativeEvent: U
        } = j;
        if (ce.isComposing(m) && U.isComposing === !1 && (Da.set(m, !1), v(!1)), yn(j, g.onKeyDown) || ce.isComposing(m))
          return;
        var {
          selection: $
        } = m, ae = m.children[$ !== null ? $.focus.path[0] : 0], Y = j4(be.string(ae)) === "rtl";
        if (jt.isRedo(U)) {
          j.preventDefault();
          var ee = m;
          typeof ee.redo == "function" && ee.redo();
          return;
        }
        if (jt.isUndo(U)) {
          j.preventDefault();
          var se = m;
          typeof se.undo == "function" && se.undo();
          return;
        }
        if (jt.isMoveLineBackward(U)) {
          j.preventDefault(), le.move(m, {
            unit: "line",
            reverse: !0
          });
          return;
        }
        if (jt.isMoveLineForward(U)) {
          j.preventDefault(), le.move(m, {
            unit: "line"
          });
          return;
        }
        if (jt.isExtendLineBackward(U)) {
          j.preventDefault(), le.move(m, {
            unit: "line",
            edge: "focus",
            reverse: !0
          });
          return;
        }
        if (jt.isExtendLineForward(U)) {
          j.preventDefault(), le.move(m, {
            unit: "line",
            edge: "focus"
          });
          return;
        }
        if (jt.isMoveBackward(U)) {
          j.preventDefault(), $ && oe.isCollapsed($) ? le.move(m, {
            reverse: !Y
          }) : le.collapse(m, {
            edge: Y ? "end" : "start"
          });
          return;
        }
        if (jt.isMoveForward(U)) {
          j.preventDefault(), $ && oe.isCollapsed($) ? le.move(m, {
            reverse: Y
          }) : le.collapse(m, {
            edge: Y ? "start" : "end"
          });
          return;
        }
        if (jt.isMoveWordBackward(U)) {
          j.preventDefault(), $ && oe.isExpanded($) && le.collapse(m, {
            edge: "focus"
          }), le.move(m, {
            unit: "word",
            reverse: !Y
          });
          return;
        }
        if (jt.isMoveWordForward(U)) {
          j.preventDefault(), $ && oe.isExpanded($) && le.collapse(m, {
            edge: "focus"
          }), le.move(m, {
            unit: "word",
            reverse: Y
          });
          return;
        }
        if (Li) {
          if ((fb || Fo) && $ && (jt.isDeleteBackward(U) || jt.isDeleteForward(U)) && oe.isCollapsed($)) {
            var re = be.parent(m, $.anchor.path);
            if (De.isElement(re) && k.isVoid(m, re) && (k.isInline(m, re) || k.isBlock(m, re))) {
              j.preventDefault(), k.deleteBackward(m, {
                unit: "block"
              });
              return;
            }
          }
        } else {
          if (jt.isBold(U) || jt.isItalic(U) || jt.isTransposeCharacter(U)) {
            j.preventDefault();
            return;
          }
          if (jt.isSoftBreak(U)) {
            j.preventDefault(), k.insertSoftBreak(m);
            return;
          }
          if (jt.isSplitBlock(U)) {
            j.preventDefault(), k.insertBreak(m);
            return;
          }
          if (jt.isDeleteBackward(U)) {
            j.preventDefault(), $ && oe.isExpanded($) ? k.deleteFragment(m, {
              direction: "backward"
            }) : k.deleteBackward(m);
            return;
          }
          if (jt.isDeleteForward(U)) {
            j.preventDefault(), $ && oe.isExpanded($) ? k.deleteFragment(m, {
              direction: "forward"
            }) : k.deleteForward(m);
            return;
          }
          if (jt.isDeleteLineBackward(U)) {
            j.preventDefault(), $ && oe.isExpanded($) ? k.deleteFragment(m, {
              direction: "backward"
            }) : k.deleteBackward(m, {
              unit: "line"
            });
            return;
          }
          if (jt.isDeleteLineForward(U)) {
            j.preventDefault(), $ && oe.isExpanded($) ? k.deleteFragment(m, {
              direction: "forward"
            }) : k.deleteForward(m, {
              unit: "line"
            });
            return;
          }
          if (jt.isDeleteWordBackward(U)) {
            j.preventDefault(), $ && oe.isExpanded($) ? k.deleteFragment(m, {
              direction: "backward"
            }) : k.deleteBackward(m, {
              unit: "word"
            });
            return;
          }
          if (jt.isDeleteWordForward(U)) {
            j.preventDefault(), $ && oe.isExpanded($) ? k.deleteFragment(m, {
              direction: "forward"
            }) : k.deleteForward(m, {
              unit: "word"
            });
            return;
          }
        }
      }
    }, [s, m, g.onKeyDown]),
    onPaste: ft((j) => {
      !s && ce.hasEditableTarget(m, j.target) && !yn(j, g.onPaste) && (!Li || yD(j.nativeEvent) || Fo) && (j.preventDefault(), ce.insertData(m, j.clipboardData));
    }, [s, m, g.onPaste])
  }), /* @__PURE__ */ M.createElement(EO, {
    decorations: H,
    node: m,
    renderElement: o,
    renderPlaceholder: u,
    renderLeaf: l,
    selection: m.selection
  })))));
}, TO = (e) => {
  var {
    attributes: t,
    children: n
  } = e;
  return (
    // COMPAT: Artificially add a line-break to the end on the placeholder element
    // to prevent Android IMEs to pick up its content in autocorrect and to auto-capitalize the first letter
    /* @__PURE__ */ M.createElement("span", $r({}, t), n, _n && /* @__PURE__ */ M.createElement("br", null))
  );
}, _O = () => [], CO = (e, t) => {
  if (t.getBoundingClientRect && (!e.selection || e.selection && oe.isCollapsed(e.selection))) {
    var n = t.startContainer.parentElement;
    n.getBoundingClientRect = t.getBoundingClientRect.bind(t), rA(n, {
      scrollMode: "if-needed"
    }), delete n.getBoundingClientRect;
  }
}, yn = (e, t) => {
  if (!t)
    return !1;
  var n = t(e);
  return n ?? (e.isDefaultPrevented() || e.isPropagationStopped());
}, _v = (e) => na(e.target) && (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement), xO = (e, t) => {
  if (!t)
    return !1;
  var n = t(e);
  return n ?? e.defaultPrevented;
}, wO = /* @__PURE__ */ sn(!1), AO = /* @__PURE__ */ sn({});
function SO(e) {
  var t = Ue([]).current, n = Ue({
    editor: e
  }).current, r = ft((a) => {
    n.editor = a, t.forEach((s) => s(a));
  }, [t, n]), i = Vn(() => ({
    getSlate: () => n.editor,
    addEventListener: (a) => (t.push(a), () => {
      t.splice(t.indexOf(a), 1);
    })
  }), [t, n]);
  return {
    selectorContext: i,
    onChange: r
  };
}
var kO = ["editor", "children", "onChange", "onSelectionChange", "onValueChange", "initialValue"], DO = (e) => {
  var {
    editor: t,
    children: n,
    onChange: r,
    onSelectionChange: i,
    onValueChange: a,
    initialValue: s
  } = e, o = Hs(e, kO), [l, u] = M.useState(() => {
    if (!be.isNodeList(s))
      throw new Error("[Slate] initialValue is invalid! Expected a list of elements but got: ".concat(nn.stringify(s)));
    if (!k.isEditor(t))
      throw new Error("[Slate] editor is invalid! You passed: ".concat(nn.stringify(t)));
    return t.children = s, Object.assign(t, o), {
      v: 0,
      editor: t
    };
  }), {
    selectorContext: c,
    onChange: d
  } = SO(t), f = ft((m) => {
    var y;
    switch (r && r(t.children), m == null || (y = m.operation) === null || y === void 0 ? void 0 : y.type) {
      case "set_selection":
        i == null || i(t.selection);
        break;
      default:
        a == null || a(t.children);
    }
    u((v) => ({
      v: v.v + 1,
      editor: t
    })), d(t);
  }, [t, d, r, i, a]);
  pe(() => (Eh.set(t, f), () => {
    Eh.set(t, () => {
    });
  }), [t, f]);
  var [p, g] = de(ce.isFocused(t));
  return pe(() => {
    g(ce.isFocused(t));
  }, [t]), Tl(() => {
    var m = () => g(ce.isFocused(t));
    return db >= 17 ? (document.addEventListener("focusin", m), document.addEventListener("focusout", m), () => {
      document.removeEventListener("focusin", m), document.removeEventListener("focusout", m);
    }) : (document.addEventListener("focus", m, !0), document.addEventListener("blur", m, !0), () => {
      document.removeEventListener("focus", m, !0), document.removeEventListener("blur", m, !0);
    });
  }, []), /* @__PURE__ */ M.createElement(AO.Provider, {
    value: c
  }, /* @__PURE__ */ M.createElement(Sb.Provider, {
    value: l
  }, /* @__PURE__ */ M.createElement($p.Provider, {
    value: l.editor
  }, /* @__PURE__ */ M.createElement(wO.Provider, {
    value: p
  }, n))));
}, Cv = (e, t) => {
  var n = (t.top + t.bottom) / 2;
  return e.top <= n && e.bottom >= n;
}, xv = (e, t, n) => {
  var r = ce.toDOMRange(e, t).getBoundingClientRect(), i = ce.toDOMRange(e, n).getBoundingClientRect();
  return Cv(r, i) && Cv(i, r);
}, OO = (e, t) => {
  var n = k.range(e, oe.end(t)), r = Array.from(k.positions(e, {
    at: t
  })), i = 0, a = r.length, s = Math.floor(a / 2);
  if (xv(e, k.range(e, r[i]), n))
    return k.range(e, r[i], n);
  if (r.length < 2)
    return k.range(e, r[r.length - 1], n);
  for (; s !== r.length && s !== i; )
    xv(e, k.range(e, r[s]), n) ? a = s : i = s, s = Math.floor((i + a) / 2);
  return k.range(e, r[a], n);
};
function wv(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Av(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wv(Object(n), !0).forEach(function(r) {
      cr(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wv(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var NO = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x-slate-fragment", r = t, {
    apply: i,
    onChange: a,
    deleteBackward: s,
    addMark: o,
    removeMark: l
  } = r;
  return l1.set(r, /* @__PURE__ */ new WeakMap()), r.addMark = (u, c) => {
    var d, f;
    (d = Up.get(r)) === null || d === void 0 || d(), !Sr.get(r) && (f = Nn.get(r)) !== null && f !== void 0 && f.length && Sr.set(r, null), bi.delete(r), o(u, c);
  }, r.removeMark = (u) => {
    var c;
    !Sr.get(r) && (c = Nn.get(r)) !== null && c !== void 0 && c.length && Sr.set(r, null), bi.delete(r), l(u);
  }, r.deleteBackward = (u) => {
    if (u !== "line")
      return s(u);
    if (r.selection && oe.isCollapsed(r.selection)) {
      var c = k.above(r, {
        match: (g) => De.isElement(g) && k.isBlock(r, g),
        at: r.selection
      });
      if (c) {
        var [, d] = c, f = k.range(r, d, r.selection.anchor), p = OO(r, f);
        oe.isCollapsed(p) || le.delete(r, {
          at: p
        });
      }
    }
  }, r.apply = (u) => {
    var c = [], d = [], f = Nn.get(r);
    if (f != null && f.length) {
      var p = f.map((F) => ND(F, u)).filter(Boolean);
      Nn.set(r, p);
    }
    var g = Ki.get(r);
    g && Ki.set(r, hv(r, g, u));
    var m = Vi.get(r);
    if (m != null && m.at) {
      var y = Xe.isPoint(m == null ? void 0 : m.at) ? _h(r, m.at, u) : hv(r, m.at, u);
      Vi.set(r, y ? Av(Av({}, m), {}, {
        at: y
      }) : null);
    }
    switch (u.type) {
      case "insert_text":
      case "remove_text":
      case "set_node":
      case "split_node": {
        c.push(...ns(r, u.path));
        break;
      }
      case "set_selection": {
        var v;
        (v = Vo.get(r)) === null || v === void 0 || v.unref(), Vo.delete(r);
        break;
      }
      case "insert_node":
      case "remove_node": {
        c.push(...ns(r, V.parent(u.path)));
        break;
      }
      case "merge_node": {
        var E = V.previous(u.path);
        c.push(...ns(r, E));
        break;
      }
      case "move_node": {
        var b = V.common(V.parent(u.path), V.parent(u.newPath));
        c.push(...ns(r, b));
        var _;
        V.isBefore(u.path, u.newPath) ? (c.push(...ns(r, V.parent(u.path))), _ = u.newPath) : (c.push(...ns(r, V.parent(u.newPath))), _ = u.path);
        var T = be.get(t, V.parent(_)), x = ce.findKey(r, T), A = k.pathRef(r, V.parent(_));
        d.push([A, x]);
        break;
      }
    }
    i(u);
    for (var [R, P] of c) {
      var [L] = k.node(r, R);
      Uc.set(L, P);
    }
    for (var [I, O] of d)
      if (I.current) {
        var [S] = k.node(r, I.current);
        Uc.set(S, O);
      }
  }, r.setFragmentData = (u) => {
    var {
      selection: c
    } = r;
    if (c) {
      var [d, f] = oe.edges(c), p = k.void(r, {
        at: d.path
      }), g = k.void(r, {
        at: f.path
      });
      if (!(oe.isCollapsed(c) && !p)) {
        var m = ce.toDOMRange(r, c), y = m.cloneContents(), v = y.childNodes[0];
        if (y.childNodes.forEach((L) => {
          L.textContent && L.textContent.trim() !== "" && (v = L);
        }), g) {
          var [E] = g, b = m.cloneRange(), _ = ce.toDOMNode(r, E);
          b.setEndAfter(_), y = b.cloneContents();
        }
        if (p && (v = y.querySelector("[data-slate-spacer]")), Array.from(y.querySelectorAll("[data-slate-zero-width]")).forEach((L) => {
          var I = L.getAttribute("data-slate-zero-width") === "n";
          L.textContent = I ? `
` : "";
        }), gb(v)) {
          var T = v.ownerDocument.createElement("span");
          T.style.whiteSpace = "pre", T.appendChild(v), y.appendChild(T), v = T;
        }
        var x = r.getFragment(), A = JSON.stringify(x), R = window.btoa(encodeURIComponent(A));
        v.setAttribute("data-slate-fragment", R), u.setData("application/".concat(n), R);
        var P = y.ownerDocument.createElement("div");
        return P.appendChild(y), P.setAttribute("hidden", "true"), y.ownerDocument.body.appendChild(P), u.setData("text/html", P.innerHTML), u.setData("text/plain", yb(P)), y.ownerDocument.body.removeChild(P), u;
      }
    }
  }, r.insertData = (u) => {
    r.insertFragmentData(u) || r.insertTextData(u);
  }, r.insertFragmentData = (u) => {
    var c = u.getData("application/".concat(n)) || CD(u);
    if (c) {
      var d = decodeURIComponent(window.atob(c)), f = JSON.parse(d);
      return r.insertFragment(f), !0;
    }
    return !1;
  }, r.insertTextData = (u) => {
    var c = u.getData("text/plain");
    if (c) {
      var d = c.split(/\r\n|\r|\n/), f = !1;
      for (var p of d)
        f && le.splitNodes(r, {
          always: !0
        }), r.insertText(p), f = !0;
      return !0;
    }
    return !1;
  }, r.onChange = (u) => {
    var c = db < 18 ? $E.unstable_batchedUpdates : (d) => d();
    c(() => {
      var d = Eh.get(r);
      d && d(u), a(u);
    });
  }, r;
}, ns = (e, t) => {
  var n = [];
  for (var [r, i] of k.levels(e, {
    at: t
  })) {
    var a = ce.findKey(e, r);
    n.push([i, a]);
  }
  return n;
};
const xh = "MENTION: ", Db = {
  anchor: { offset: 0, path: [0, 0] },
  focus: { offset: 0, path: [0, 0] }
}, Sv = { "mention-popover": 35, default: -52 }, md = 16, Ob = (e, t, n) => {
  const r = Ue(null), { showLinkEditor: i, mentionPopover: a } = We(Di), s = t === "link-editor" ? i : a.show, o = [s];
  return e && t === "link-editor" && o.push(e.selection), pe(() => {
    var p, g;
    if (!(r != null && r.current) || !s)
      return;
    const l = r == null ? void 0 : r.current;
    if (!l)
      return;
    let u, c = 0;
    if (t === "mention-popover") {
      const { position: m } = a, y = (b) => {
        if (!k.hasPath(e, b.path))
          return !1;
        const _ = be.get(e, b.path);
        return k.isEditor(_) || De.isElement(_) ? b.offset <= _.children.length : Ie.isText(_) ? b.offset <= _.text.length : !1;
      };
      if (m && (!y(m == null ? void 0 : m.anchor) || !y(m == null ? void 0 : m.focus)))
        return;
      u = ce.toDOMRange(
        e,
        m || Db
      ).getBoundingClientRect();
      const E = (p = document.getElementById(n)) == null ? void 0 : p.getBoundingClientRect();
      l.style.setProperty(
        "--width",
        `${((E == null ? void 0 : E.width) || 0) / md}rem`
      ), c = (E == null ? void 0 : E.left) || 0;
    } else {
      const m = document.getSelection();
      m != null && m.toString().trim().length && (u = m == null ? void 0 : m.getRangeAt(0).getBoundingClientRect());
    }
    u || (u = (g = document.getElementById(n)) == null ? void 0 : g.getBoundingClientRect());
    const d = Sv[t] || Sv.default, f = ((u == null ? void 0 : u.top) || 0) + window.scrollY + d;
    c === 0 && (c = Math.max(
      ((u == null ? void 0 : u.left) || 0) - (l.offsetWidth - ((u == null ? void 0 : u.width) || 0)),
      0
    )), l.style.top = `${f / md}rem`, l.style.left = `${c / md}rem`;
  }, o), r;
}, IO = (e) => {
  const [t, n] = de(
    null
  );
  return pe(() => {
    const { selection: r } = e;
    if (!r) {
      n(null);
      return;
    }
    const [i] = k.nodes(e, {
      at: r,
      match: (a) => a.type === ne.link
    });
    if (i) {
      const a = i[0], s = pp(a.link), o = a.children[0], l = (o == null ? void 0 : o.text) || "";
      n({ ...s, text: l });
    } else
      n(null);
  }, [e, e.selection]), t;
};
var bn = /* @__PURE__ */ ((e) => (e.paragraph = "paragraph", e.heading = "heading", e.list = "list", e.listItem = "listItem", e.link = "link", e.mention = "mention", e.image = "image", e.blockquote = "blockquote", e.code = "code", e.html = "html", e.emphasis = "emphasis", e.strong = "strong", e.delete = "delete", e.inlineCode = "inlineCode", e.thematicBreak = "thematicBreak", e.text = "text", e.h3 = "heading_three", e))(bn || {});
const _s = {
  [ne.paragraph]: ne.paragraph,
  [ne.blockquote]: ne.blockquote,
  [ne.codeblock]: ne.codeblock,
  [ne.link]: ne.link,
  [ne.ul]: ne.ul,
  [ne.ol]: ne.ol,
  [ne.li]: ne.li,
  [ne.mention]: ne.mention,
  [ne.heading]: {
    1: "heading_one",
    2: "heading_two",
    3: "heading_three",
    4: "heading_four",
    5: "heading_five",
    6: "heading_six"
  },
  [Ei.emphasis]: ne.italic,
  [Ei.strong]: ne.bold,
  [Ei.delete]: ne.strikethrough,
  [Ei.code]: ne.code,
  [ne.hr]: ne.hr,
  [ne.image]: ne.image,
  [ne.h3]: ne.h3
};
function kv(e) {
  if (e)
    throw e;
}
var dc = Object.prototype.hasOwnProperty, Nb = Object.prototype.toString, Dv = Object.defineProperty, Ov = Object.getOwnPropertyDescriptor, Nv = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : Nb.call(t) === "[object Array]";
}, Iv = function(t) {
  if (!t || Nb.call(t) !== "[object Object]")
    return !1;
  var n = dc.call(t, "constructor"), r = t.constructor && t.constructor.prototype && dc.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || dc.call(t, i);
}, Pv = function(t, n) {
  Dv && n.name === "__proto__" ? Dv(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, Rv = function(t, n) {
  if (n === "__proto__")
    if (dc.call(t, n)) {
      if (Ov)
        return Ov(t, n).value;
    } else
      return;
  return t[n];
}, Ib = function e() {
  var t, n, r, i, a, s, o = arguments[0], l = 1, u = arguments.length, c = !1;
  for (typeof o == "boolean" && (c = o, o = arguments[1] || {}, l = 2), (o == null || typeof o != "object" && typeof o != "function") && (o = {}); l < u; ++l)
    if (t = arguments[l], t != null)
      for (n in t)
        r = Rv(o, n), i = Rv(t, n), o !== i && (c && i && (Iv(i) || (a = Nv(i))) ? (a ? (a = !1, s = r && Nv(r) ? r : []) : s = r && Iv(r) ? r : {}, Pv(o, { name: n, newValue: e(c, s, i) })) : typeof i < "u" && Pv(o, { name: n, newValue: i }));
  return o;
};
const gd = /* @__PURE__ */ Or(Ib);
function wh(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function PO() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let a = -1;
    const s = i.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    o(null, ...i);
    function o(l, ...u) {
      const c = e[++a];
      let d = -1;
      if (l) {
        s(l);
        return;
      }
      for (; ++d < i.length; )
        (u[d] === null || u[d] === void 0) && (u[d] = i[d]);
      i = u, c ? RO(c, o)(...u) : s(null, ...u);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function RO(e, t) {
  let n;
  return r;
  function r(...s) {
    const o = e.length > s.length;
    let l;
    o && s.push(i);
    try {
      l = e.apply(this, s);
    } catch (u) {
      const c = (
        /** @type {Error} */
        u
      );
      if (o && n)
        throw c;
      return i(c);
    }
    o || (l && l.then && typeof l.then == "function" ? l.then(a, i) : l instanceof Error ? i(l) : a(l));
  }
  function i(s, ...o) {
    n || (n = !0, t(s, ...o));
  }
  function a(s) {
    i(null, s);
  }
}
function Ko(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Fv(e.position) : "start" in e || "end" in e ? Fv(e) : "line" in e || "column" in e ? Ah(e) : "";
}
function Ah(e) {
  return Bv(e && e.line) + ":" + Bv(e && e.column);
}
function Fv(e) {
  return Ah(e && e.start) + "-" + Ah(e && e.end);
}
function Bv(e) {
  return e && typeof e == "number" ? e : 1;
}
class $n extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", a = {}, s = !1;
    if (n && ("line" in n && "column" in n ? a = { place: n } : "start" in n && "end" in n ? a = { place: n } : "type" in n ? a = {
      ancestors: [n],
      place: n.position
    } : a = { ...n }), typeof t == "string" ? i = t : !a.cause && t && (s = !0, i = t.message, a.cause = t), !a.ruleId && !a.source && typeof r == "string") {
      const l = r.indexOf(":");
      l === -1 ? a.ruleId = r : (a.source = r.slice(0, l), a.ruleId = r.slice(l + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const l = a.ancestors[a.ancestors.length - 1];
      l && (a.place = l.position);
    }
    const o = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = o ? o.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = o ? o.line : void 0, this.name = Ko(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = s && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
$n.prototype.file = "";
$n.prototype.name = "";
$n.prototype.reason = "";
$n.prototype.message = "";
$n.prototype.stack = "";
$n.prototype.column = void 0;
$n.prototype.line = void 0;
$n.prototype.ancestors = void 0;
$n.prototype.cause = void 0;
$n.prototype.fatal = void 0;
$n.prototype.place = void 0;
$n.prototype.ruleId = void 0;
$n.prototype.source = void 0;
const jr = { basename: FO, dirname: BO, extname: MO, join: LO, sep: "/" };
function FO(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Ml(e);
  let n = 0, r = -1, i = e.length, a;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (a) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (a = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let s = -1, o = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (a) {
        n = i + 1;
        break;
      }
    } else
      s < 0 && (a = !0, s = i + 1), o > -1 && (e.codePointAt(i) === t.codePointAt(o--) ? o < 0 && (r = i) : (o = -1, r = s));
  return n === r ? r = s : r < 0 && (r = e.length), e.slice(n, r);
}
function BO(e) {
  if (Ml(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else
      r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function MO(e) {
  Ml(e);
  let t = e.length, n = -1, r = 0, i = -1, a = 0, s;
  for (; t--; ) {
    const o = e.codePointAt(t);
    if (o === 47) {
      if (s) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (s = !0, n = t + 1), o === 46 ? i < 0 ? i = t : a !== 1 && (a = 1) : i > -1 && (a = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function LO(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Ml(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : $O(n);
}
function $O(e) {
  Ml(e);
  const t = e.codePointAt(0) === 47;
  let n = jO(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function jO(e, t) {
  let n = "", r = 0, i = -1, a = 0, s = -1, o, l;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      o = e.codePointAt(s);
    else {
      if (o === 47)
        break;
      o = 47;
    }
    if (o === 47) {
      if (!(i === s - 1 || a === 1))
        if (i !== s - 1 && a === 2) {
          if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (l = n.lastIndexOf("/"), l !== n.length - 1) {
                l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), i = s, a = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = s, a = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(i + 1, s) : n = e.slice(i + 1, s), r = s - i - 1;
      i = s, a = 0;
    } else
      o === 46 && a > -1 ? a++ : a = -1;
  }
  return n;
}
function Ml(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const HO = { cwd: UO };
function UO() {
  return "/";
}
function Sh(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function zO(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Sh(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return qO(e);
}
function qO(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const vd = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
let WO = class {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? Sh(t) ? n = { path: t } : typeof t == "string" || VO(t) ? n = { value: t } : n = t : n = {}, this.cwd = HO.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < vd.length; ) {
      const a = vd[r];
      a in n && n[a] !== void 0 && n[a] !== null && (this[a] = a === "history" ? [...n[a]] : n[a]);
    }
    let i;
    for (i in n)
      vd.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? jr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Ed(t, "basename"), yd(t, "basename"), this.path = jr.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? jr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    Mv(this.basename, "dirname"), this.path = jr.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? jr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (yd(t, "extname"), Mv(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = jr.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    Sh(t) && (t = zO(t)), Ed(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? jr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Ed(t, "stem"), yd(t, "stem"), this.path = jr.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new $n(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
};
function yd(e, t) {
  if (e && e.includes(jr.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + jr.sep + "`"
    );
}
function Ed(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Mv(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function VO(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const KO = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], a = function() {
      return i.apply(a, arguments);
    };
    Object.setPrototypeOf(a, r);
    const s = Object.getOwnPropertyNames(i);
    for (const o of s) {
      const l = Object.getOwnPropertyDescriptor(i, o);
      l && Object.defineProperty(a, o, l);
    }
    return a;
  }
), GO = {}.hasOwnProperty;
class Wp extends KO {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = PO();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Wp()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(gd(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (_d("data", this.frozen), this.namespace[t] = n, this) : GO.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (_d("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = fu(t), r = this.parser || this.Parser;
    return bd("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), bd("process", this.parser || this.Parser), Td("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(a, s) {
      const o = fu(t), l = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(o)
      );
      r.run(l, o, function(c, d, f) {
        if (c || !d || !f)
          return u(c);
        const p = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          d
        ), g = r.stringify(p, f);
        QO(g) ? f.value = g : f.result = g, u(
          c,
          /** @type {VFileWithOutput<CompileResult>} */
          f
        );
      });
      function u(c, d) {
        c || !d ? s(c) : a ? a(d) : n(void 0, d);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), bd("processSync", this.parser || this.Parser), Td("processSync", this.compiler || this.Compiler), this.process(t, i), $v("processSync", "process", n), r;
    function i(a, s) {
      n = !0, kv(a), r = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    Lv(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? a(void 0, r) : new Promise(a);
    function a(s, o) {
      const l = fu(n);
      i.run(t, l, u);
      function u(c, d, f) {
        const p = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          d || t
        );
        c ? o(c) : s ? s(p) : r(void 0, p, f);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, a), $v("runSync", "run", r), i;
    function a(s, o) {
      kv(s), i = o, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = fu(n), i = this.compiler || this.Compiler;
    return Td("stringify", i), Lv(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (_d("use", this.frozen), t != null)
      if (typeof t == "function")
        l(t, n);
      else if (typeof t == "object")
        Array.isArray(t) ? o(t) : s(t);
      else
        throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function a(u) {
      if (typeof u == "function")
        l(u, []);
      else if (typeof u == "object")
        if (Array.isArray(u)) {
          const [c, ...d] = (
            /** @type {PluginTuple<Array<unknown>>} */
            u
          );
          l(c, d);
        } else
          s(u);
      else
        throw new TypeError("Expected usable value, not `" + u + "`");
    }
    function s(u) {
      if (!("plugins" in u) && !("settings" in u))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      o(u.plugins), u.settings && (i.settings = gd(!0, i.settings, u.settings));
    }
    function o(u) {
      let c = -1;
      if (u != null)
        if (Array.isArray(u))
          for (; ++c < u.length; ) {
            const d = u[c];
            a(d);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + u + "`");
    }
    function l(u, c) {
      let d = -1, f = -1;
      for (; ++d < r.length; )
        if (r[d][0] === u) {
          f = d;
          break;
        }
      if (f === -1)
        r.push([u, ...c]);
      else if (c.length > 0) {
        let [p, ...g] = c;
        const m = r[f][1];
        wh(m) && wh(p) && (p = gd(!0, m, p)), r[f] = [u, p, ...g];
      }
    }
  }
}
const YO = new Wp().freeze();
function bd(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Td(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function _d(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Lv(e) {
  if (!wh(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function $v(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function fu(e) {
  return ZO(e) ? e : new WO(e);
}
function ZO(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function QO(e) {
  return typeof e == "string" || XO(e);
}
function XO(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const JO = {};
function eN(e, t) {
  const n = t || JO, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Pb(e, r, i);
}
function Pb(e, t, n) {
  if (tN(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return jv(e.children, t, n);
  }
  return Array.isArray(e) ? jv(e, t, n) : "";
}
function jv(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Pb(e[i], t, n);
  return r.join("");
}
function tN(e) {
  return !!(e && typeof e == "object");
}
const Hv = document.createElement("i");
function Vp(e) {
  const t = "&" + e + ";";
  Hv.innerHTML = t;
  const n = Hv.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function wi(e, t, n, r) {
  const i = e.length;
  let a = 0, s;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    s = Array.from(r), s.unshift(t, n), e.splice(...s);
  else
    for (n && e.splice(t, n); a < r.length; )
      s = r.slice(a, a + 1e4), s.unshift(t, 0), e.splice(...s), a += 1e4, t += 1e4;
}
function ar(e, t) {
  return e.length > 0 ? (wi(e, e.length, 0, t), e) : t;
}
const Uv = {}.hasOwnProperty;
function nN(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    rN(t, e[n]);
  return t;
}
function rN(e, t) {
  let n;
  for (n in t) {
    const i = (Uv.call(e, n) ? e[n] : void 0) || (e[n] = {}), a = t[n];
    let s;
    if (a)
      for (s in a) {
        Uv.call(i, s) || (i[s] = []);
        const o = a[s];
        iN(
          // @ts-expect-error Looks like a list.
          i[s],
          Array.isArray(o) ? o : o ? [o] : []
        );
      }
  }
}
function iN(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  wi(e, 0, 0, r);
}
function Rb(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function ks(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const zr = la(/[A-Za-z]/), kr = la(/[\dA-Za-z]/), aN = la(/[#-'*+\--9=?A-Z^-~]/);
function kh(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Dh = la(/\d/), sN = la(/[\dA-Fa-f]/), oN = la(/[!-/:-@[-`{-~]/);
function ze(e) {
  return e !== null && e < -2;
}
function Rn(e) {
  return e !== null && (e < 0 || e === 32);
}
function bt(e) {
  return e === -2 || e === -1 || e === 32;
}
const lN = la(/\p{P}|\p{S}/u), uN = la(/\s/);
function la(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Pt(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return s;
  function s(l) {
    return bt(l) ? (e.enter(n), o(l)) : t(l);
  }
  function o(l) {
    return bt(l) && a++ < i ? (e.consume(l), o) : (e.exit(n), t(l));
  }
}
const cN = {
  tokenize: dN
};
function dN(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), Pt(e, t, "linePrefix");
  }
  function i(o) {
    return e.enter("paragraph"), a(o);
  }
  function a(o) {
    const l = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = l), n = l, s(o);
  }
  function s(o) {
    if (o === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(o);
      return;
    }
    return ze(o) ? (e.consume(o), e.exit("chunkText"), a) : (e.consume(o), s);
  }
}
const fN = {
  tokenize: hN
}, zv = {
  tokenize: pN
};
function hN(e) {
  const t = this, n = [];
  let r = 0, i, a, s;
  return o;
  function o(b) {
    if (r < n.length) {
      const _ = n[r];
      return t.containerState = _[1], e.attempt(
        _[0].continuation,
        l,
        u
      )(b);
    }
    return u(b);
  }
  function l(b) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && E();
      const _ = t.events.length;
      let T = _, x;
      for (; T--; )
        if (t.events[T][0] === "exit" && t.events[T][1].type === "chunkFlow") {
          x = t.events[T][1].end;
          break;
        }
      v(r);
      let A = _;
      for (; A < t.events.length; )
        t.events[A][1].end = Object.assign({}, x), A++;
      return wi(
        t.events,
        T + 1,
        0,
        t.events.slice(_)
      ), t.events.length = A, u(b);
    }
    return o(b);
  }
  function u(b) {
    if (r === n.length) {
      if (!i)
        return f(b);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return g(b);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      zv,
      c,
      d
    )(b);
  }
  function c(b) {
    return i && E(), v(r), f(b);
  }
  function d(b) {
    return t.parser.lazy[t.now().line] = r !== n.length, s = t.now().offset, g(b);
  }
  function f(b) {
    return t.containerState = {}, e.attempt(
      zv,
      p,
      g
    )(b);
  }
  function p(b) {
    return r++, n.push([t.currentConstruct, t.containerState]), f(b);
  }
  function g(b) {
    if (b === null) {
      i && E(), v(0), e.consume(b);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: a,
      _tokenizer: i
    }), m(b);
  }
  function m(b) {
    if (b === null) {
      y(e.exit("chunkFlow"), !0), v(0), e.consume(b);
      return;
    }
    return ze(b) ? (e.consume(b), y(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, o) : (e.consume(b), m);
  }
  function y(b, _) {
    const T = t.sliceStream(b);
    if (_ && T.push(null), b.previous = a, a && (a.next = b), a = b, i.defineSkip(b.start), i.write(T), t.parser.lazy[b.start.line]) {
      let x = i.events.length;
      for (; x--; )
        if (
          // The token starts before the line ending…
          i.events[x][1].start.offset < s && // …and either is not ended yet…
          (!i.events[x][1].end || // …or ends after it.
          i.events[x][1].end.offset > s)
        )
          return;
      const A = t.events.length;
      let R = A, P, L;
      for (; R--; )
        if (t.events[R][0] === "exit" && t.events[R][1].type === "chunkFlow") {
          if (P) {
            L = t.events[R][1].end;
            break;
          }
          P = !0;
        }
      for (v(r), x = A; x < t.events.length; )
        t.events[x][1].end = Object.assign({}, L), x++;
      wi(
        t.events,
        R + 1,
        0,
        t.events.slice(A)
      ), t.events.length = x;
    }
  }
  function v(b) {
    let _ = n.length;
    for (; _-- > b; ) {
      const T = n[_];
      t.containerState = T[1], T[0].exit.call(t, e);
    }
    n.length = b;
  }
  function E() {
    i.write([null]), a = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function pN(e, t, n) {
  return Pt(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function qv(e) {
  if (e === null || Rn(e) || uN(e))
    return 1;
  if (lN(e))
    return 2;
}
function Kp(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const a = e[i].resolveAll;
    a && !r.includes(a) && (t = a(t, n), r.push(a));
  }
  return t;
}
const Oh = {
  name: "attention",
  tokenize: gN,
  resolveAll: mN
};
function mN(e, t) {
  let n = -1, r, i, a, s, o, l, u, c;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          l = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const d = Object.assign({}, e[r][1].end), f = Object.assign({}, e[n][1].start);
          Wv(d, -l), Wv(f, l), s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: Object.assign({}, e[r][1].end)
          }, o = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: f
          }, a = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, i = {
            type: l > 1 ? "strong" : "emphasis",
            start: Object.assign({}, s.start),
            end: Object.assign({}, o.end)
          }, e[r][1].end = Object.assign({}, s.start), e[n][1].start = Object.assign({}, o.end), u = [], e[r][1].end.offset - e[r][1].start.offset && (u = ar(u, [["enter", e[r][1], t], ["exit", e[r][1], t]])), u = ar(u, [["enter", i, t], ["enter", s, t], ["exit", s, t], ["enter", a, t]]), u = ar(u, Kp(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), u = ar(u, [["exit", a, t], ["enter", o, t], ["exit", o, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (c = 2, u = ar(u, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : c = 0, wi(e, r - 1, n - r + 3, u), n = r + u.length - c - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function gN(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = qv(r);
  let a;
  return s;
  function s(l) {
    return a = l, e.enter("attentionSequence"), o(l);
  }
  function o(l) {
    if (l === a)
      return e.consume(l), o;
    const u = e.exit("attentionSequence"), c = qv(l), d = !c || c === 2 && i || n.includes(l), f = !i || i === 2 && c || n.includes(r);
    return u._open = !!(a === 42 ? d : d && (i || !f)), u._close = !!(a === 42 ? f : f && (c || !d)), t(l);
  }
}
function Wv(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const vN = {
  name: "autolink",
  tokenize: yN
};
function yN(e, t, n) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(p) {
    return zr(p) ? (e.consume(p), s) : p === 64 ? n(p) : u(p);
  }
  function s(p) {
    return p === 43 || p === 45 || p === 46 || kr(p) ? (r = 1, o(p)) : u(p);
  }
  function o(p) {
    return p === 58 ? (e.consume(p), r = 0, l) : (p === 43 || p === 45 || p === 46 || kr(p)) && r++ < 32 ? (e.consume(p), o) : (r = 0, u(p));
  }
  function l(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : p === null || p === 32 || p === 60 || kh(p) ? n(p) : (e.consume(p), l);
  }
  function u(p) {
    return p === 64 ? (e.consume(p), c) : aN(p) ? (e.consume(p), u) : n(p);
  }
  function c(p) {
    return kr(p) ? d(p) : n(p);
  }
  function d(p) {
    return p === 46 ? (e.consume(p), r = 0, c) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : f(p);
  }
  function f(p) {
    if ((p === 45 || kr(p)) && r++ < 63) {
      const g = p === 45 ? f : d;
      return e.consume(p), g;
    }
    return n(p);
  }
}
const u1 = {
  tokenize: EN,
  partial: !0
};
function EN(e, t, n) {
  return r;
  function r(a) {
    return bt(a) ? Pt(e, i, "linePrefix")(a) : i(a);
  }
  function i(a) {
    return a === null || ze(a) ? t(a) : n(a);
  }
}
const Fb = {
  name: "blockQuote",
  tokenize: bN,
  continuation: {
    tokenize: TN
  },
  exit: _N
};
function bN(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    if (s === 62) {
      const o = r.containerState;
      return o.open || (e.enter("blockQuote", {
        _container: !0
      }), o.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), a;
    }
    return n(s);
  }
  function a(s) {
    return bt(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(s));
  }
}
function TN(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return bt(s) ? Pt(e, a, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : a(s);
  }
  function a(s) {
    return e.attempt(Fb, t, n)(s);
  }
}
function _N(e) {
  e.exit("blockQuote");
}
const Bb = {
  name: "characterEscape",
  tokenize: CN
};
function CN(e, t, n) {
  return r;
  function r(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), i;
  }
  function i(a) {
    return oN(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(a);
  }
}
const Mb = {
  name: "characterReference",
  tokenize: xN
};
function xN(e, t, n) {
  const r = this;
  let i = 0, a, s;
  return o;
  function o(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), l;
  }
  function l(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), a = 31, s = kr, c(d));
  }
  function u(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, s = sN, c) : (e.enter("characterReferenceValue"), a = 7, s = Dh, c(d));
  }
  function c(d) {
    if (d === 59 && i) {
      const f = e.exit("characterReferenceValue");
      return s === kr && !Vp(r.sliceSerialize(f)) ? n(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return s(d) && i++ < a ? (e.consume(d), c) : n(d);
  }
}
const Vv = {
  tokenize: AN,
  partial: !0
}, Kv = {
  name: "codeFenced",
  tokenize: wN,
  concrete: !0
};
function wN(e, t, n) {
  const r = this, i = {
    tokenize: T,
    partial: !0
  };
  let a = 0, s = 0, o;
  return l;
  function l(x) {
    return u(x);
  }
  function u(x) {
    const A = r.events[r.events.length - 1];
    return a = A && A[1].type === "linePrefix" ? A[2].sliceSerialize(A[1], !0).length : 0, o = x, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), c(x);
  }
  function c(x) {
    return x === o ? (s++, e.consume(x), c) : s < 3 ? n(x) : (e.exit("codeFencedFenceSequence"), bt(x) ? Pt(e, d, "whitespace")(x) : d(x));
  }
  function d(x) {
    return x === null || ze(x) ? (e.exit("codeFencedFence"), r.interrupt ? t(x) : e.check(Vv, m, _)(x)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), f(x));
  }
  function f(x) {
    return x === null || ze(x) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), d(x)) : bt(x) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Pt(e, p, "whitespace")(x)) : x === 96 && x === o ? n(x) : (e.consume(x), f);
  }
  function p(x) {
    return x === null || ze(x) ? d(x) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), g(x));
  }
  function g(x) {
    return x === null || ze(x) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), d(x)) : x === 96 && x === o ? n(x) : (e.consume(x), g);
  }
  function m(x) {
    return e.attempt(i, _, y)(x);
  }
  function y(x) {
    return e.enter("lineEnding"), e.consume(x), e.exit("lineEnding"), v;
  }
  function v(x) {
    return a > 0 && bt(x) ? Pt(e, E, "linePrefix", a + 1)(x) : E(x);
  }
  function E(x) {
    return x === null || ze(x) ? e.check(Vv, m, _)(x) : (e.enter("codeFlowValue"), b(x));
  }
  function b(x) {
    return x === null || ze(x) ? (e.exit("codeFlowValue"), E(x)) : (e.consume(x), b);
  }
  function _(x) {
    return e.exit("codeFenced"), t(x);
  }
  function T(x, A, R) {
    let P = 0;
    return L;
    function L(H) {
      return x.enter("lineEnding"), x.consume(H), x.exit("lineEnding"), I;
    }
    function I(H) {
      return x.enter("codeFencedFence"), bt(H) ? Pt(x, O, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(H) : O(H);
    }
    function O(H) {
      return H === o ? (x.enter("codeFencedFenceSequence"), S(H)) : R(H);
    }
    function S(H) {
      return H === o ? (P++, x.consume(H), S) : P >= s ? (x.exit("codeFencedFenceSequence"), bt(H) ? Pt(x, F, "whitespace")(H) : F(H)) : R(H);
    }
    function F(H) {
      return H === null || ze(H) ? (x.exit("codeFencedFence"), A(H)) : R(H);
    }
  }
}
function AN(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return s === null ? n(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a);
  }
  function a(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
const Cd = {
  name: "codeIndented",
  tokenize: kN
}, SN = {
  tokenize: DN,
  partial: !0
};
function kN(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return e.enter("codeIndented"), Pt(e, a, "linePrefix", 4 + 1)(u);
  }
  function a(u) {
    const c = r.events[r.events.length - 1];
    return c && c[1].type === "linePrefix" && c[2].sliceSerialize(c[1], !0).length >= 4 ? s(u) : n(u);
  }
  function s(u) {
    return u === null ? l(u) : ze(u) ? e.attempt(SN, s, l)(u) : (e.enter("codeFlowValue"), o(u));
  }
  function o(u) {
    return u === null || ze(u) ? (e.exit("codeFlowValue"), s(u)) : (e.consume(u), o);
  }
  function l(u) {
    return e.exit("codeIndented"), t(u);
  }
}
function DN(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return r.parser.lazy[r.now().line] ? n(s) : ze(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i) : Pt(e, a, "linePrefix", 4 + 1)(s);
  }
  function a(s) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "linePrefix" && o[2].sliceSerialize(o[1], !0).length >= 4 ? t(s) : ze(s) ? i(s) : n(s);
  }
}
const ON = {
  name: "codeText",
  tokenize: PN,
  resolve: NN,
  previous: IN
};
function NN(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function IN(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function PN(e, t, n) {
  let r = 0, i, a;
  return s;
  function s(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), o(d);
  }
  function o(d) {
    return d === 96 ? (e.consume(d), r++, o) : (e.exit("codeTextSequence"), l(d));
  }
  function l(d) {
    return d === null ? n(d) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), l) : d === 96 ? (a = e.enter("codeTextSequence"), i = 0, c(d)) : ze(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), l) : (e.enter("codeTextData"), u(d));
  }
  function u(d) {
    return d === null || d === 32 || d === 96 || ze(d) ? (e.exit("codeTextData"), l(d)) : (e.consume(d), u);
  }
  function c(d) {
    return d === 96 ? (e.consume(d), i++, c) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(d)) : (a.type = "codeTextData", u(d));
  }
}
class RN {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const a = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && ho(this.left, r), a.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), ho(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), ho(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        ho(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        ho(this.left, n.reverse());
      }
  }
}
function ho(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Lb(e) {
  const t = {};
  let n = -1, r, i, a, s, o, l, u;
  const c = new RN(e);
  for (; ++n < c.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = c.get(n), n && r[1].type === "chunkFlow" && c.get(n - 1)[1].type === "listItemPrefix" && (l = r[1]._tokenizer.events, a = 0, a < l.length && l[a][1].type === "lineEndingBlank" && (a += 2), a < l.length && l[a][1].type === "content"))
      for (; ++a < l.length && l[a][1].type !== "content"; )
        l[a][1].type === "chunkText" && (l[a][1]._isInFirstContentOfListItem = !0, a++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, FN(c, n)), n = t[n], u = !0);
    else if (r[1]._container) {
      for (a = n, i = void 0; a-- && (s = c.get(a), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (i && (c.get(i)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", i = a);
      i && (r[1].end = Object.assign({}, c.get(i)[1].start), o = c.slice(i, n), o.unshift(r), c.splice(i, n - i + 1, o));
    }
  }
  return wi(e, 0, Number.POSITIVE_INFINITY, c.slice(0)), !u;
}
function FN(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const a = [], s = n._tokenizer || r.parser[n.contentType](n.start), o = s.events, l = [], u = {};
  let c, d, f = -1, p = n, g = 0, m = 0;
  const y = [m];
  for (; p; ) {
    for (; e.get(++i)[1] !== p; )
      ;
    a.push(i), p._tokenizer || (c = r.sliceStream(p), p.next || c.push(null), d && s.defineSkip(p.start), p._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(c), p._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), d = p, p = p.next;
  }
  for (p = n; ++f < o.length; )
    // Find a void token that includes a break.
    o[f][0] === "exit" && o[f - 1][0] === "enter" && o[f][1].type === o[f - 1][1].type && o[f][1].start.line !== o[f][1].end.line && (m = f + 1, y.push(m), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (s.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : y.pop(), f = y.length; f--; ) {
    const v = o.slice(y[f], y[f + 1]), E = a.pop();
    l.push([E, E + v.length - 1]), e.splice(E, 2, v);
  }
  for (l.reverse(), f = -1; ++f < l.length; )
    u[g + l[f][0]] = g + l[f][1], g += l[f][1] - l[f][0] - 1;
  return u;
}
const BN = {
  tokenize: $N,
  resolve: LN
}, MN = {
  tokenize: jN,
  partial: !0
};
function LN(e) {
  return Lb(e), e;
}
function $N(e, t) {
  let n;
  return r;
  function r(o) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(o);
  }
  function i(o) {
    return o === null ? a(o) : ze(o) ? e.check(MN, s, a)(o) : (e.consume(o), i);
  }
  function a(o) {
    return e.exit("chunkContent"), e.exit("content"), t(o);
  }
  function s(o) {
    return e.consume(o), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function jN(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), Pt(e, a, "linePrefix");
  }
  function a(s) {
    if (s === null || ze(s))
      return n(s);
    const o = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && o && o[1].type === "linePrefix" && o[2].sliceSerialize(o[1], !0).length >= 4 ? t(s) : e.interrupt(r.parser.constructs.flow, n, t)(s);
  }
}
function $b(e, t, n, r, i, a, s, o, l) {
  const u = l || Number.POSITIVE_INFINITY;
  let c = 0;
  return d;
  function d(v) {
    return v === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(v), e.exit(a), f) : v === null || v === 32 || v === 41 || kh(v) ? n(v) : (e.enter(r), e.enter(s), e.enter(o), e.enter("chunkString", {
      contentType: "string"
    }), m(v));
  }
  function f(v) {
    return v === 62 ? (e.enter(a), e.consume(v), e.exit(a), e.exit(i), e.exit(r), t) : (e.enter(o), e.enter("chunkString", {
      contentType: "string"
    }), p(v));
  }
  function p(v) {
    return v === 62 ? (e.exit("chunkString"), e.exit(o), f(v)) : v === null || v === 60 || ze(v) ? n(v) : (e.consume(v), v === 92 ? g : p);
  }
  function g(v) {
    return v === 60 || v === 62 || v === 92 ? (e.consume(v), p) : p(v);
  }
  function m(v) {
    return !c && (v === null || v === 41 || Rn(v)) ? (e.exit("chunkString"), e.exit(o), e.exit(s), e.exit(r), t(v)) : c < u && v === 40 ? (e.consume(v), c++, m) : v === 41 ? (e.consume(v), c--, m) : v === null || v === 32 || v === 40 || kh(v) ? n(v) : (e.consume(v), v === 92 ? y : m);
  }
  function y(v) {
    return v === 40 || v === 41 || v === 92 ? (e.consume(v), m) : m(v);
  }
}
function jb(e, t, n, r, i, a) {
  const s = this;
  let o = 0, l;
  return u;
  function u(p) {
    return e.enter(r), e.enter(i), e.consume(p), e.exit(i), e.enter(a), c;
  }
  function c(p) {
    return o > 999 || p === null || p === 91 || p === 93 && !l || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !o && "_hiddenFootnoteSupport" in s.parser.constructs ? n(p) : p === 93 ? (e.exit(a), e.enter(i), e.consume(p), e.exit(i), e.exit(r), t) : ze(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), c) : (e.enter("chunkString", {
      contentType: "string"
    }), d(p));
  }
  function d(p) {
    return p === null || p === 91 || p === 93 || ze(p) || o++ > 999 ? (e.exit("chunkString"), c(p)) : (e.consume(p), l || (l = !bt(p)), p === 92 ? f : d);
  }
  function f(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), o++, d) : d(p);
  }
}
function Hb(e, t, n, r, i, a) {
  let s;
  return o;
  function o(f) {
    return f === 34 || f === 39 || f === 40 ? (e.enter(r), e.enter(i), e.consume(f), e.exit(i), s = f === 40 ? 41 : f, l) : n(f);
  }
  function l(f) {
    return f === s ? (e.enter(i), e.consume(f), e.exit(i), e.exit(r), t) : (e.enter(a), u(f));
  }
  function u(f) {
    return f === s ? (e.exit(a), l(s)) : f === null ? n(f) : ze(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), Pt(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), c(f));
  }
  function c(f) {
    return f === s || f === null || ze(f) ? (e.exit("chunkString"), u(f)) : (e.consume(f), f === 92 ? d : c);
  }
  function d(f) {
    return f === s || f === 92 ? (e.consume(f), c) : c(f);
  }
}
function Go(e, t) {
  let n;
  return r;
  function r(i) {
    return ze(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : bt(i) ? Pt(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
const HN = {
  name: "definition",
  tokenize: zN
}, UN = {
  tokenize: qN,
  partial: !0
};
function zN(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(p) {
    return e.enter("definition"), s(p);
  }
  function s(p) {
    return jb.call(
      r,
      e,
      o,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function o(p) {
    return i = ks(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), l) : n(p);
  }
  function l(p) {
    return Rn(p) ? Go(e, u)(p) : u(p);
  }
  function u(p) {
    return $b(
      e,
      c,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function c(p) {
    return e.attempt(UN, d, d)(p);
  }
  function d(p) {
    return bt(p) ? Pt(e, f, "whitespace")(p) : f(p);
  }
  function f(p) {
    return p === null || ze(p) ? (e.exit("definition"), r.parser.defined.push(i), t(p)) : n(p);
  }
}
function qN(e, t, n) {
  return r;
  function r(o) {
    return Rn(o) ? Go(e, i)(o) : n(o);
  }
  function i(o) {
    return Hb(e, a, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(o);
  }
  function a(o) {
    return bt(o) ? Pt(e, s, "whitespace")(o) : s(o);
  }
  function s(o) {
    return o === null || ze(o) ? t(o) : n(o);
  }
}
const WN = {
  name: "hardBreakEscape",
  tokenize: VN
};
function VN(e, t, n) {
  return r;
  function r(a) {
    return e.enter("hardBreakEscape"), e.consume(a), i;
  }
  function i(a) {
    return ze(a) ? (e.exit("hardBreakEscape"), t(a)) : n(a);
  }
}
const KN = {
  name: "headingAtx",
  tokenize: YN,
  resolve: GN
};
function GN(e, t) {
  let n = e.length - 2, r = 3, i, a;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, a = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, wi(e, r, n - r + 1, [["enter", i, t], ["enter", a, t], ["exit", a, t], ["exit", i, t]])), e;
}
function YN(e, t, n) {
  let r = 0;
  return i;
  function i(c) {
    return e.enter("atxHeading"), a(c);
  }
  function a(c) {
    return e.enter("atxHeadingSequence"), s(c);
  }
  function s(c) {
    return c === 35 && r++ < 6 ? (e.consume(c), s) : c === null || Rn(c) ? (e.exit("atxHeadingSequence"), o(c)) : n(c);
  }
  function o(c) {
    return c === 35 ? (e.enter("atxHeadingSequence"), l(c)) : c === null || ze(c) ? (e.exit("atxHeading"), t(c)) : bt(c) ? Pt(e, o, "whitespace")(c) : (e.enter("atxHeadingText"), u(c));
  }
  function l(c) {
    return c === 35 ? (e.consume(c), l) : (e.exit("atxHeadingSequence"), o(c));
  }
  function u(c) {
    return c === null || c === 35 || Rn(c) ? (e.exit("atxHeadingText"), o(c)) : (e.consume(c), u);
  }
}
const ZN = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Gv = ["pre", "script", "style", "textarea"], QN = {
  name: "htmlFlow",
  tokenize: tI,
  resolveTo: eI,
  concrete: !0
}, XN = {
  tokenize: rI,
  partial: !0
}, JN = {
  tokenize: nI,
  partial: !0
};
function eI(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function tI(e, t, n) {
  const r = this;
  let i, a, s, o, l;
  return u;
  function u(B) {
    return c(B);
  }
  function c(B) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(B), d;
  }
  function d(B) {
    return B === 33 ? (e.consume(B), f) : B === 47 ? (e.consume(B), a = !0, m) : B === 63 ? (e.consume(B), i = 3, r.interrupt ? t : D) : zr(B) ? (e.consume(B), s = String.fromCharCode(B), y) : n(B);
  }
  function f(B) {
    return B === 45 ? (e.consume(B), i = 2, p) : B === 91 ? (e.consume(B), i = 5, o = 0, g) : zr(B) ? (e.consume(B), i = 4, r.interrupt ? t : D) : n(B);
  }
  function p(B) {
    return B === 45 ? (e.consume(B), r.interrupt ? t : D) : n(B);
  }
  function g(B) {
    const j = "CDATA[";
    return B === j.charCodeAt(o++) ? (e.consume(B), o === j.length ? r.interrupt ? t : O : g) : n(B);
  }
  function m(B) {
    return zr(B) ? (e.consume(B), s = String.fromCharCode(B), y) : n(B);
  }
  function y(B) {
    if (B === null || B === 47 || B === 62 || Rn(B)) {
      const j = B === 47, z = s.toLowerCase();
      return !j && !a && Gv.includes(z) ? (i = 1, r.interrupt ? t(B) : O(B)) : ZN.includes(s.toLowerCase()) ? (i = 6, j ? (e.consume(B), v) : r.interrupt ? t(B) : O(B)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(B) : a ? E(B) : b(B));
    }
    return B === 45 || kr(B) ? (e.consume(B), s += String.fromCharCode(B), y) : n(B);
  }
  function v(B) {
    return B === 62 ? (e.consume(B), r.interrupt ? t : O) : n(B);
  }
  function E(B) {
    return bt(B) ? (e.consume(B), E) : L(B);
  }
  function b(B) {
    return B === 47 ? (e.consume(B), L) : B === 58 || B === 95 || zr(B) ? (e.consume(B), _) : bt(B) ? (e.consume(B), b) : L(B);
  }
  function _(B) {
    return B === 45 || B === 46 || B === 58 || B === 95 || kr(B) ? (e.consume(B), _) : T(B);
  }
  function T(B) {
    return B === 61 ? (e.consume(B), x) : bt(B) ? (e.consume(B), T) : b(B);
  }
  function x(B) {
    return B === null || B === 60 || B === 61 || B === 62 || B === 96 ? n(B) : B === 34 || B === 39 ? (e.consume(B), l = B, A) : bt(B) ? (e.consume(B), x) : R(B);
  }
  function A(B) {
    return B === l ? (e.consume(B), l = null, P) : B === null || ze(B) ? n(B) : (e.consume(B), A);
  }
  function R(B) {
    return B === null || B === 34 || B === 39 || B === 47 || B === 60 || B === 61 || B === 62 || B === 96 || Rn(B) ? T(B) : (e.consume(B), R);
  }
  function P(B) {
    return B === 47 || B === 62 || bt(B) ? b(B) : n(B);
  }
  function L(B) {
    return B === 62 ? (e.consume(B), I) : n(B);
  }
  function I(B) {
    return B === null || ze(B) ? O(B) : bt(B) ? (e.consume(B), I) : n(B);
  }
  function O(B) {
    return B === 45 && i === 2 ? (e.consume(B), q) : B === 60 && i === 1 ? (e.consume(B), N) : B === 62 && i === 4 ? (e.consume(B), C) : B === 63 && i === 3 ? (e.consume(B), D) : B === 93 && i === 5 ? (e.consume(B), J) : ze(B) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(XN, Z, S)(B)) : B === null || ze(B) ? (e.exit("htmlFlowData"), S(B)) : (e.consume(B), O);
  }
  function S(B) {
    return e.check(JN, F, Z)(B);
  }
  function F(B) {
    return e.enter("lineEnding"), e.consume(B), e.exit("lineEnding"), H;
  }
  function H(B) {
    return B === null || ze(B) ? S(B) : (e.enter("htmlFlowData"), O(B));
  }
  function q(B) {
    return B === 45 ? (e.consume(B), D) : O(B);
  }
  function N(B) {
    return B === 47 ? (e.consume(B), s = "", Q) : O(B);
  }
  function Q(B) {
    if (B === 62) {
      const j = s.toLowerCase();
      return Gv.includes(j) ? (e.consume(B), C) : O(B);
    }
    return zr(B) && s.length < 8 ? (e.consume(B), s += String.fromCharCode(B), Q) : O(B);
  }
  function J(B) {
    return B === 93 ? (e.consume(B), D) : O(B);
  }
  function D(B) {
    return B === 62 ? (e.consume(B), C) : B === 45 && i === 2 ? (e.consume(B), D) : O(B);
  }
  function C(B) {
    return B === null || ze(B) ? (e.exit("htmlFlowData"), Z(B)) : (e.consume(B), C);
  }
  function Z(B) {
    return e.exit("htmlFlow"), t(B);
  }
}
function nI(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return ze(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : n(s);
  }
  function a(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
function rI(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(u1, t, n);
  }
}
const iI = {
  name: "htmlText",
  tokenize: aI
};
function aI(e, t, n) {
  const r = this;
  let i, a, s;
  return o;
  function o(D) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(D), l;
  }
  function l(D) {
    return D === 33 ? (e.consume(D), u) : D === 47 ? (e.consume(D), T) : D === 63 ? (e.consume(D), b) : zr(D) ? (e.consume(D), R) : n(D);
  }
  function u(D) {
    return D === 45 ? (e.consume(D), c) : D === 91 ? (e.consume(D), a = 0, g) : zr(D) ? (e.consume(D), E) : n(D);
  }
  function c(D) {
    return D === 45 ? (e.consume(D), p) : n(D);
  }
  function d(D) {
    return D === null ? n(D) : D === 45 ? (e.consume(D), f) : ze(D) ? (s = d, N(D)) : (e.consume(D), d);
  }
  function f(D) {
    return D === 45 ? (e.consume(D), p) : d(D);
  }
  function p(D) {
    return D === 62 ? q(D) : D === 45 ? f(D) : d(D);
  }
  function g(D) {
    const C = "CDATA[";
    return D === C.charCodeAt(a++) ? (e.consume(D), a === C.length ? m : g) : n(D);
  }
  function m(D) {
    return D === null ? n(D) : D === 93 ? (e.consume(D), y) : ze(D) ? (s = m, N(D)) : (e.consume(D), m);
  }
  function y(D) {
    return D === 93 ? (e.consume(D), v) : m(D);
  }
  function v(D) {
    return D === 62 ? q(D) : D === 93 ? (e.consume(D), v) : m(D);
  }
  function E(D) {
    return D === null || D === 62 ? q(D) : ze(D) ? (s = E, N(D)) : (e.consume(D), E);
  }
  function b(D) {
    return D === null ? n(D) : D === 63 ? (e.consume(D), _) : ze(D) ? (s = b, N(D)) : (e.consume(D), b);
  }
  function _(D) {
    return D === 62 ? q(D) : b(D);
  }
  function T(D) {
    return zr(D) ? (e.consume(D), x) : n(D);
  }
  function x(D) {
    return D === 45 || kr(D) ? (e.consume(D), x) : A(D);
  }
  function A(D) {
    return ze(D) ? (s = A, N(D)) : bt(D) ? (e.consume(D), A) : q(D);
  }
  function R(D) {
    return D === 45 || kr(D) ? (e.consume(D), R) : D === 47 || D === 62 || Rn(D) ? P(D) : n(D);
  }
  function P(D) {
    return D === 47 ? (e.consume(D), q) : D === 58 || D === 95 || zr(D) ? (e.consume(D), L) : ze(D) ? (s = P, N(D)) : bt(D) ? (e.consume(D), P) : q(D);
  }
  function L(D) {
    return D === 45 || D === 46 || D === 58 || D === 95 || kr(D) ? (e.consume(D), L) : I(D);
  }
  function I(D) {
    return D === 61 ? (e.consume(D), O) : ze(D) ? (s = I, N(D)) : bt(D) ? (e.consume(D), I) : P(D);
  }
  function O(D) {
    return D === null || D === 60 || D === 61 || D === 62 || D === 96 ? n(D) : D === 34 || D === 39 ? (e.consume(D), i = D, S) : ze(D) ? (s = O, N(D)) : bt(D) ? (e.consume(D), O) : (e.consume(D), F);
  }
  function S(D) {
    return D === i ? (e.consume(D), i = void 0, H) : D === null ? n(D) : ze(D) ? (s = S, N(D)) : (e.consume(D), S);
  }
  function F(D) {
    return D === null || D === 34 || D === 39 || D === 60 || D === 61 || D === 96 ? n(D) : D === 47 || D === 62 || Rn(D) ? P(D) : (e.consume(D), F);
  }
  function H(D) {
    return D === 47 || D === 62 || Rn(D) ? P(D) : n(D);
  }
  function q(D) {
    return D === 62 ? (e.consume(D), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(D);
  }
  function N(D) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), Q;
  }
  function Q(D) {
    return bt(D) ? Pt(e, J, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(D) : J(D);
  }
  function J(D) {
    return e.enter("htmlTextData"), s(D);
  }
}
const Gp = {
  name: "labelEnd",
  tokenize: dI,
  resolveTo: cI,
  resolveAll: uI
}, sI = {
  tokenize: fI
}, oI = {
  tokenize: hI
}, lI = {
  tokenize: pI
};
function uI(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function cI(e, t) {
  let n = e.length, r = 0, i, a, s, o;
  for (; n--; )
    if (i = e[n][1], a) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (s) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (s = n);
  const l = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, u = {
    type: "label",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[s][1].end)
  }, c = {
    type: "labelText",
    start: Object.assign({}, e[a + r + 2][1].end),
    end: Object.assign({}, e[s - 2][1].start)
  };
  return o = [["enter", l, t], ["enter", u, t]], o = ar(o, e.slice(a + 1, a + r + 3)), o = ar(o, [["enter", c, t]]), o = ar(o, Kp(t.parser.constructs.insideSpan.null, e.slice(a + r + 4, s - 3), t)), o = ar(o, [["exit", c, t], e[s - 2], e[s - 1], ["exit", u, t]]), o = ar(o, e.slice(s + 1)), o = ar(o, [["exit", l, t]]), wi(e, a, e.length, o), e;
}
function dI(e, t, n) {
  const r = this;
  let i = r.events.length, a, s;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      a = r.events[i][1];
      break;
    }
  return o;
  function o(f) {
    return a ? a._inactive ? d(f) : (s = r.parser.defined.includes(ks(r.sliceSerialize({
      start: a.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(f), e.exit("labelMarker"), e.exit("labelEnd"), l) : n(f);
  }
  function l(f) {
    return f === 40 ? e.attempt(sI, c, s ? c : d)(f) : f === 91 ? e.attempt(oI, c, s ? u : d)(f) : s ? c(f) : d(f);
  }
  function u(f) {
    return e.attempt(lI, c, d)(f);
  }
  function c(f) {
    return t(f);
  }
  function d(f) {
    return a._balanced = !0, n(f);
  }
}
function fI(e, t, n) {
  return r;
  function r(d) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), i;
  }
  function i(d) {
    return Rn(d) ? Go(e, a)(d) : a(d);
  }
  function a(d) {
    return d === 41 ? c(d) : $b(e, s, o, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(d);
  }
  function s(d) {
    return Rn(d) ? Go(e, l)(d) : c(d);
  }
  function o(d) {
    return n(d);
  }
  function l(d) {
    return d === 34 || d === 39 || d === 40 ? Hb(e, u, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(d) : c(d);
  }
  function u(d) {
    return Rn(d) ? Go(e, c)(d) : c(d);
  }
  function c(d) {
    return d === 41 ? (e.enter("resourceMarker"), e.consume(d), e.exit("resourceMarker"), e.exit("resource"), t) : n(d);
  }
}
function hI(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return jb.call(r, e, a, s, "reference", "referenceMarker", "referenceString")(o);
  }
  function a(o) {
    return r.parser.defined.includes(ks(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(o) : n(o);
  }
  function s(o) {
    return n(o);
  }
}
function pI(e, t, n) {
  return r;
  function r(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), i;
  }
  function i(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), t) : n(a);
  }
}
const mI = {
  name: "labelStartImage",
  tokenize: gI,
  resolveAll: Gp.resolveAll
};
function gI(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(o), e.exit("labelImageMarker"), a;
  }
  function a(o) {
    return o === 91 ? (e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelImage"), s) : n(o);
  }
  function s(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const vI = {
  name: "labelStartLink",
  tokenize: yI,
  resolveAll: Gp.resolveAll
};
function yI(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const xd = {
  name: "lineEnding",
  tokenize: EI
};
function EI(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), Pt(e, t, "linePrefix");
  }
}
const fc = {
  name: "thematicBreak",
  tokenize: bI
};
function bI(e, t, n) {
  let r = 0, i;
  return a;
  function a(u) {
    return e.enter("thematicBreak"), s(u);
  }
  function s(u) {
    return i = u, o(u);
  }
  function o(u) {
    return u === i ? (e.enter("thematicBreakSequence"), l(u)) : r >= 3 && (u === null || ze(u)) ? (e.exit("thematicBreak"), t(u)) : n(u);
  }
  function l(u) {
    return u === i ? (e.consume(u), r++, l) : (e.exit("thematicBreakSequence"), bt(u) ? Pt(e, o, "whitespace")(u) : o(u));
  }
}
const Sn = {
  name: "list",
  tokenize: CI,
  continuation: {
    tokenize: xI
  },
  exit: AI
}, TI = {
  tokenize: SI,
  partial: !0
}, _I = {
  tokenize: wI,
  partial: !0
};
function CI(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, s = 0;
  return o;
  function o(p) {
    const g = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (g === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : Dh(p)) {
      if (r.containerState.type || (r.containerState.type = g, e.enter(g, {
        _container: !0
      })), g === "listUnordered")
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(fc, n, u)(p) : u(p);
      if (!r.interrupt || p === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), l(p);
    }
    return n(p);
  }
  function l(p) {
    return Dh(p) && ++s < 10 ? (e.consume(p), l) : (!r.interrupt || s < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), u(p)) : n(p);
  }
  function u(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, e.check(
      u1,
      // Can’t be empty when interrupting.
      r.interrupt ? n : c,
      e.attempt(TI, f, d)
    );
  }
  function c(p) {
    return r.containerState.initialBlankLine = !0, a++, f(p);
  }
  function d(p) {
    return bt(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), f) : n(p);
  }
  function f(p) {
    return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(p);
  }
}
function xI(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(u1, i, a);
  function i(o) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Pt(e, t, "listItemIndent", r.containerState.size + 1)(o);
  }
  function a(o) {
    return r.containerState.furtherBlankLines || !bt(o) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, s(o)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(_I, t, s)(o));
  }
  function s(o) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Pt(e, e.attempt(Sn, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o);
  }
}
function wI(e, t, n) {
  const r = this;
  return Pt(e, i, "listItemIndent", r.containerState.size + 1);
  function i(a) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === r.containerState.size ? t(a) : n(a);
  }
}
function AI(e) {
  e.exit(this.containerState.type);
}
function SI(e, t, n) {
  const r = this;
  return Pt(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1);
  function i(a) {
    const s = r.events[r.events.length - 1];
    return !bt(a) && s && s[1].type === "listItemPrefixWhitespace" ? t(a) : n(a);
  }
}
const Yv = {
  name: "setextUnderline",
  tokenize: DI,
  resolveTo: kI
};
function kI(e, t) {
  let n = e.length, r, i, a;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
  const s = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, ["enter", s, t]), e.splice(a + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[a][1].end)) : e[r][1] = s, e.push(["exit", s, t]), e;
}
function DI(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(u) {
    let c = r.events.length, d;
    for (; c--; )
      if (r.events[c][1].type !== "lineEnding" && r.events[c][1].type !== "linePrefix" && r.events[c][1].type !== "content") {
        d = r.events[c][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (e.enter("setextHeadingLine"), i = u, s(u)) : n(u);
  }
  function s(u) {
    return e.enter("setextHeadingLineSequence"), o(u);
  }
  function o(u) {
    return u === i ? (e.consume(u), o) : (e.exit("setextHeadingLineSequence"), bt(u) ? Pt(e, l, "lineSuffix")(u) : l(u));
  }
  function l(u) {
    return u === null || ze(u) ? (e.exit("setextHeadingLine"), t(u)) : n(u);
  }
}
const OI = {
  tokenize: NI
};
function NI(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    u1,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      Pt(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(BN, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const II = {
  resolveAll: zb()
}, PI = Ub("string"), RI = Ub("text");
function Ub(e) {
  return {
    tokenize: t,
    resolveAll: zb(
      e === "text" ? FI : void 0
    )
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], a = n.attempt(i, s, o);
    return s;
    function s(c) {
      return u(c) ? a(c) : o(c);
    }
    function o(c) {
      if (c === null) {
        n.consume(c);
        return;
      }
      return n.enter("data"), n.consume(c), l;
    }
    function l(c) {
      return u(c) ? (n.exit("data"), a(c)) : (n.consume(c), l);
    }
    function u(c) {
      if (c === null)
        return !0;
      const d = i[c];
      let f = -1;
      if (d)
        for (; ++f < d.length; ) {
          const p = d[f];
          if (!p.previous || p.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function zb(e) {
  return t;
  function t(n, r) {
    let i = -1, a;
    for (; ++i <= n.length; )
      a === void 0 ? n[i] && n[i][1].type === "data" && (a = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== a + 2 && (n[a][1].end = n[i - 1][1].end, n.splice(a + 2, i - a - 2), i = a + 2), a = void 0);
    return e ? e(n, r) : n;
  }
}
function FI(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let a = i.length, s = -1, o = 0, l;
      for (; a--; ) {
        const u = i[a];
        if (typeof u == "string") {
          for (s = u.length; u.charCodeAt(s - 1) === 32; )
            o++, s--;
          if (s)
            break;
          s = -1;
        } else if (u === -2)
          l = !0, o++;
        else if (u !== -1) {
          a++;
          break;
        }
      }
      if (o) {
        const u = {
          type: n === e.length || l || o < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - o,
            offset: r.end.offset - o,
            _index: r.start._index + a,
            _bufferIndex: a ? s : r.start._bufferIndex + s
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, u.start), r.start.offset === r.end.offset ? Object.assign(r, u) : (e.splice(
          n,
          0,
          ["enter", u, t],
          ["exit", u, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function BI(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, a = [];
  let s = [], o = [];
  const l = {
    consume: E,
    enter: b,
    exit: _,
    attempt: A(T),
    check: A(x),
    interrupt: A(x, {
      interrupt: !0
    })
  }, u = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: p,
    sliceSerialize: f,
    now: g,
    defineSkip: m,
    write: d
  };
  let c = t.tokenize.call(u, l);
  return t.resolveAll && a.push(t), u;
  function d(I) {
    return s = ar(s, I), y(), s[s.length - 1] !== null ? [] : (R(t, 0), u.events = Kp(a, u.events, u), u.events);
  }
  function f(I, O) {
    return LI(p(I), O);
  }
  function p(I) {
    return MI(s, I);
  }
  function g() {
    const { line: I, column: O, offset: S, _index: F, _bufferIndex: H } = r;
    return {
      line: I,
      column: O,
      offset: S,
      _index: F,
      _bufferIndex: H
    };
  }
  function m(I) {
    i[I.line] = I.column, L();
  }
  function y() {
    let I;
    for (; r._index < s.length; ) {
      const O = s[r._index];
      if (typeof O == "string")
        for (I = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === I && r._bufferIndex < O.length; )
          v(O.charCodeAt(r._bufferIndex));
      else
        v(O);
    }
  }
  function v(I) {
    c = c(I);
  }
  function E(I) {
    ze(I) ? (r.line++, r.column = 1, r.offset += I === -3 ? 2 : 1, L()) : I !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === s[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = I;
  }
  function b(I, O) {
    const S = O || {};
    return S.type = I, S.start = g(), u.events.push(["enter", S, u]), o.push(S), S;
  }
  function _(I) {
    const O = o.pop();
    return O.end = g(), u.events.push(["exit", O, u]), O;
  }
  function T(I, O) {
    R(I, O.from);
  }
  function x(I, O) {
    O.restore();
  }
  function A(I, O) {
    return S;
    function S(F, H, q) {
      let N, Q, J, D;
      return Array.isArray(F) ? Z(F) : "tokenize" in F ? (
        // @ts-expect-error Looks like a construct.
        Z([F])
      ) : C(F);
      function C(U) {
        return $;
        function $(ae) {
          const Y = ae !== null && U[ae], ee = ae !== null && U.null, se = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Y) ? Y : Y ? [Y] : [],
            ...Array.isArray(ee) ? ee : ee ? [ee] : []
          ];
          return Z(se)(ae);
        }
      }
      function Z(U) {
        return N = U, Q = 0, U.length === 0 ? q : B(U[Q]);
      }
      function B(U) {
        return $;
        function $(ae) {
          return D = P(), J = U, U.partial || (u.currentConstruct = U), U.name && u.parser.constructs.disable.null.includes(U.name) ? z() : U.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            O ? Object.assign(Object.create(u), O) : u,
            l,
            j,
            z
          )(ae);
        }
      }
      function j(U) {
        return I(J, D), H;
      }
      function z(U) {
        return D.restore(), ++Q < N.length ? B(N[Q]) : q;
      }
    }
  }
  function R(I, O) {
    I.resolveAll && !a.includes(I) && a.push(I), I.resolve && wi(
      u.events,
      O,
      u.events.length - O,
      I.resolve(u.events.slice(O), u)
    ), I.resolveTo && (u.events = I.resolveTo(u.events, u));
  }
  function P() {
    const I = g(), O = u.previous, S = u.currentConstruct, F = u.events.length, H = Array.from(o);
    return {
      restore: q,
      from: F
    };
    function q() {
      r = I, u.previous = O, u.currentConstruct = S, u.events.length = F, o = H, L();
    }
  }
  function L() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function MI(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, a = t.end._bufferIndex;
  let s;
  if (n === i)
    s = [e[n].slice(r, a)];
  else {
    if (s = e.slice(n, i), r > -1) {
      const o = s[0];
      typeof o == "string" ? s[0] = o.slice(r) : s.shift();
    }
    a > 0 && s.push(e[i].slice(0, a));
  }
  return s;
}
function LI(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const a = e[n];
    let s;
    if (typeof a == "string")
      s = a;
    else
      switch (a) {
        case -5: {
          s = "\r";
          break;
        }
        case -4: {
          s = `
`;
          break;
        }
        case -3: {
          s = `\r
`;
          break;
        }
        case -2: {
          s = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i)
            continue;
          s = " ";
          break;
        }
        default:
          s = String.fromCharCode(a);
      }
    i = a === -2, r.push(s);
  }
  return r.join("");
}
const $I = {
  42: Sn,
  43: Sn,
  45: Sn,
  48: Sn,
  49: Sn,
  50: Sn,
  51: Sn,
  52: Sn,
  53: Sn,
  54: Sn,
  55: Sn,
  56: Sn,
  57: Sn,
  62: Fb
}, jI = {
  91: HN
}, HI = {
  [-2]: Cd,
  [-1]: Cd,
  32: Cd
}, UI = {
  35: KN,
  42: fc,
  45: [Yv, fc],
  60: QN,
  61: Yv,
  95: fc,
  96: Kv,
  126: Kv
}, zI = {
  38: Mb,
  92: Bb
}, qI = {
  [-5]: xd,
  [-4]: xd,
  [-3]: xd,
  33: mI,
  38: Mb,
  42: Oh,
  60: [vN, iI],
  91: vI,
  92: [WN, Bb],
  93: Gp,
  95: Oh,
  96: ON
}, WI = {
  null: [Oh, II]
}, VI = {
  null: [42, 95]
}, KI = {
  null: []
}, GI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: VI,
  contentInitial: jI,
  disable: KI,
  document: $I,
  flow: UI,
  flowInitial: HI,
  insideSpan: WI,
  string: zI,
  text: qI
}, Symbol.toStringTag, { value: "Module" }));
function YI(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    nN([GI, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(cN),
    document: i(fN),
    flow: i(OI),
    string: i(PI),
    text: i(RI)
  };
  return r;
  function i(a) {
    return s;
    function s(o) {
      return BI(r, a, o);
    }
  }
}
function ZI(e) {
  for (; !Lb(e); )
    ;
  return e;
}
const Zv = /[\0\t\n\r]/g;
function QI() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(a, s, o) {
    const l = [];
    let u, c, d, f, p;
    for (a = t + (typeof a == "string" ? a.toString() : new TextDecoder(s || void 0).decode(a)), d = 0, t = "", n && (a.charCodeAt(0) === 65279 && d++, n = void 0); d < a.length; ) {
      if (Zv.lastIndex = d, u = Zv.exec(a), f = u && u.index !== void 0 ? u.index : a.length, p = a.charCodeAt(f), !u) {
        t = a.slice(d);
        break;
      }
      if (p === 10 && d === f && r)
        l.push(-3), r = void 0;
      else
        switch (r && (l.push(-5), r = void 0), d < f && (l.push(a.slice(d, f)), e += f - d), p) {
          case 0: {
            l.push(65533), e++;
            break;
          }
          case 9: {
            for (c = Math.ceil(e / 4) * 4, l.push(-2); e++ < c; )
              l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      d = f + 1;
    }
    return o && (r && l.push(-5), t && l.push(t), l.push(null)), l;
  }
}
const XI = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function JI(e) {
  return e.replace(XI, eP);
}
function eP(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), a = i === 120 || i === 88;
    return Rb(n.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return Vp(n) || e;
}
const qb = {}.hasOwnProperty;
function tP(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), nP(n)(
    ZI(
      YI(n).document().write(QI()(e, t, !0))
    )
  );
}
function nP(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(Se),
      autolinkProtocol: P,
      autolinkEmail: P,
      atxHeading: a(Oe),
      blockQuote: a(Y),
      characterEscape: P,
      characterReference: P,
      codeFenced: a(ee),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: a(ee, s),
      codeText: a(se, s),
      codeTextData: P,
      data: P,
      codeFlowValue: P,
      definition: a(re),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: a(Ae),
      hardBreakEscape: a(Ce),
      hardBreakTrailing: a(Ce),
      htmlFlow: a(ue, s),
      htmlFlowData: P,
      htmlText: a(ue, s),
      htmlTextData: P,
      image: a(fe),
      label: s,
      link: a(Se),
      listItem: a(nt),
      listItemValue: f,
      listOrdered: a(Fe, d),
      listUnordered: a(Fe),
      paragraph: a(mt),
      reference: B,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: a(Oe),
      strong: a(Ze),
      thematicBreak: a(Qe)
    },
    exit: {
      atxHeading: l(),
      atxHeadingSequence: T,
      autolink: l(),
      autolinkEmail: ae,
      autolinkProtocol: $,
      blockQuote: l(),
      characterEscapeValue: L,
      characterReferenceMarkerHexadecimal: z,
      characterReferenceMarkerNumeric: z,
      characterReferenceValue: U,
      codeFenced: l(y),
      codeFencedFence: m,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: g,
      codeFlowValue: L,
      codeIndented: l(v),
      codeText: l(H),
      codeTextData: L,
      data: L,
      definition: l(),
      definitionDestinationString: _,
      definitionLabelString: E,
      definitionTitleString: b,
      emphasis: l(),
      hardBreakEscape: l(O),
      hardBreakTrailing: l(O),
      htmlFlow: l(S),
      htmlFlowData: L,
      htmlText: l(F),
      htmlTextData: L,
      image: l(N),
      label: J,
      labelText: Q,
      lineEnding: I,
      link: l(q),
      listItem: l(),
      listOrdered: l(),
      listUnordered: l(),
      paragraph: l(),
      referenceString: j,
      resourceDestinationString: D,
      resourceTitleString: C,
      resource: Z,
      setextHeading: l(R),
      setextHeadingLineSequence: A,
      setextHeadingText: x,
      strong: l(),
      thematicBreak: l()
    }
  };
  Wb(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(ie) {
    let me = {
      type: "root",
      children: []
    };
    const Pe = {
      stack: [me],
      tokenStack: [],
      config: t,
      enter: o,
      exit: u,
      buffer: s,
      resume: c,
      data: n
    }, ge = [];
    let X = -1;
    for (; ++X < ie.length; )
      if (ie[X][1].type === "listOrdered" || ie[X][1].type === "listUnordered")
        if (ie[X][0] === "enter")
          ge.push(X);
        else {
          const xe = ge.pop();
          X = i(ie, xe, X);
        }
    for (X = -1; ++X < ie.length; ) {
      const xe = t[ie[X][0]];
      qb.call(xe, ie[X][1].type) && xe[ie[X][1].type].call(
        Object.assign(
          {
            sliceSerialize: ie[X][2].sliceSerialize
          },
          Pe
        ),
        ie[X][1]
      );
    }
    if (Pe.tokenStack.length > 0) {
      const xe = Pe.tokenStack[Pe.tokenStack.length - 1];
      (xe[1] || Qv).call(Pe, void 0, xe[0]);
    }
    for (me.position = {
      start: $i(
        ie.length > 0 ? ie[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: $i(
        ie.length > 0 ? ie[ie.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, X = -1; ++X < t.transforms.length; )
      me = t.transforms[X](me) || me;
    return me;
  }
  function i(ie, me, Pe) {
    let ge = me - 1, X = -1, xe = !1, ve, Ne, Tt, Ge;
    for (; ++ge <= Pe; ) {
      const gt = ie[ge];
      switch (gt[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          gt[0] === "enter" ? X++ : X--, Ge = void 0;
          break;
        }
        case "lineEndingBlank": {
          gt[0] === "enter" && (ve && !Ge && !X && !Tt && (Tt = ge), Ge = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Ge = void 0;
      }
      if (!X && gt[0] === "enter" && gt[1].type === "listItemPrefix" || X === -1 && gt[0] === "exit" && (gt[1].type === "listUnordered" || gt[1].type === "listOrdered")) {
        if (ve) {
          let qt = ge;
          for (Ne = void 0; qt--; ) {
            const wt = ie[qt];
            if (wt[1].type === "lineEnding" || wt[1].type === "lineEndingBlank") {
              if (wt[0] === "exit")
                continue;
              Ne && (ie[Ne][1].type = "lineEndingBlank", xe = !0), wt[1].type = "lineEnding", Ne = qt;
            } else if (!(wt[1].type === "linePrefix" || wt[1].type === "blockQuotePrefix" || wt[1].type === "blockQuotePrefixWhitespace" || wt[1].type === "blockQuoteMarker" || wt[1].type === "listItemIndent"))
              break;
          }
          Tt && (!Ne || Tt < Ne) && (ve._spread = !0), ve.end = Object.assign(
            {},
            Ne ? ie[Ne][1].start : gt[1].end
          ), ie.splice(Ne || ge, 0, ["exit", ve, gt[2]]), ge++, Pe++;
        }
        if (gt[1].type === "listItemPrefix") {
          const qt = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, gt[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          ve = qt, ie.splice(ge, 0, ["enter", qt, gt[2]]), ge++, Pe++, Tt = void 0, Ge = !0;
        }
      }
    }
    return ie[me][1]._spread = xe, Pe;
  }
  function a(ie, me) {
    return Pe;
    function Pe(ge) {
      o.call(this, ie(ge), ge), me && me.call(this, ge);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function o(ie, me, Pe) {
    this.stack[this.stack.length - 1].children.push(ie), this.stack.push(ie), this.tokenStack.push([me, Pe]), ie.position = {
      start: $i(me.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function l(ie) {
    return me;
    function me(Pe) {
      ie && ie.call(this, Pe), u.call(this, Pe);
    }
  }
  function u(ie, me) {
    const Pe = this.stack.pop(), ge = this.tokenStack.pop();
    if (ge)
      ge[0].type !== ie.type && (me ? me.call(this, ie, ge[0]) : (ge[1] || Qv).call(this, ie, ge[0]));
    else
      throw new Error(
        "Cannot close `" + ie.type + "` (" + Ko({
          start: ie.start,
          end: ie.end
        }) + "): it’s not open"
      );
    Pe.position.end = $i(ie.end);
  }
  function c() {
    return eN(this.stack.pop());
  }
  function d() {
    this.data.expectingFirstListItemValue = !0;
  }
  function f(ie) {
    if (this.data.expectingFirstListItemValue) {
      const me = this.stack[this.stack.length - 2];
      me.start = Number.parseInt(this.sliceSerialize(ie), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.lang = ie;
  }
  function g() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.meta = ie;
  }
  function m() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function y() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.value = ie.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function v() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.value = ie.replace(/(\r?\n|\r)$/g, "");
  }
  function E(ie) {
    const me = this.resume(), Pe = this.stack[this.stack.length - 1];
    Pe.label = me, Pe.identifier = ks(
      this.sliceSerialize(ie)
    ).toLowerCase();
  }
  function b() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.title = ie;
  }
  function _() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.url = ie;
  }
  function T(ie) {
    const me = this.stack[this.stack.length - 1];
    if (!me.depth) {
      const Pe = this.sliceSerialize(ie).length;
      me.depth = Pe;
    }
  }
  function x() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function A(ie) {
    const me = this.stack[this.stack.length - 1];
    me.depth = this.sliceSerialize(ie).codePointAt(0) === 61 ? 1 : 2;
  }
  function R() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function P(ie) {
    const Pe = this.stack[this.stack.length - 1].children;
    let ge = Pe[Pe.length - 1];
    (!ge || ge.type !== "text") && (ge = rt(), ge.position = {
      start: $i(ie.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, Pe.push(ge)), this.stack.push(ge);
  }
  function L(ie) {
    const me = this.stack.pop();
    me.value += this.sliceSerialize(ie), me.position.end = $i(ie.end);
  }
  function I(ie) {
    const me = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const Pe = me.children[me.children.length - 1];
      Pe.position.end = $i(ie.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(me.type) && (P.call(this, ie), L.call(this, ie));
  }
  function O() {
    this.data.atHardBreak = !0;
  }
  function S() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.value = ie;
  }
  function F() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.value = ie;
  }
  function H() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.value = ie;
  }
  function q() {
    const ie = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const me = this.data.referenceType || "shortcut";
      ie.type += "Reference", ie.referenceType = me, delete ie.url, delete ie.title;
    } else
      delete ie.identifier, delete ie.label;
    this.data.referenceType = void 0;
  }
  function N() {
    const ie = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const me = this.data.referenceType || "shortcut";
      ie.type += "Reference", ie.referenceType = me, delete ie.url, delete ie.title;
    } else
      delete ie.identifier, delete ie.label;
    this.data.referenceType = void 0;
  }
  function Q(ie) {
    const me = this.sliceSerialize(ie), Pe = this.stack[this.stack.length - 2];
    Pe.label = JI(me), Pe.identifier = ks(me).toLowerCase();
  }
  function J() {
    const ie = this.stack[this.stack.length - 1], me = this.resume(), Pe = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, Pe.type === "link") {
      const ge = ie.children;
      Pe.children = ge;
    } else
      Pe.alt = me;
  }
  function D() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.url = ie;
  }
  function C() {
    const ie = this.resume(), me = this.stack[this.stack.length - 1];
    me.title = ie;
  }
  function Z() {
    this.data.inReference = void 0;
  }
  function B() {
    this.data.referenceType = "collapsed";
  }
  function j(ie) {
    const me = this.resume(), Pe = this.stack[this.stack.length - 1];
    Pe.label = me, Pe.identifier = ks(
      this.sliceSerialize(ie)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function z(ie) {
    this.data.characterReferenceType = ie.type;
  }
  function U(ie) {
    const me = this.sliceSerialize(ie), Pe = this.data.characterReferenceType;
    let ge;
    Pe ? (ge = Rb(
      me,
      Pe === "characterReferenceMarkerNumeric" ? 10 : 16
    ), this.data.characterReferenceType = void 0) : ge = Vp(me);
    const X = this.stack.pop();
    X.value += ge, X.position.end = $i(ie.end);
  }
  function $(ie) {
    L.call(this, ie);
    const me = this.stack[this.stack.length - 1];
    me.url = this.sliceSerialize(ie);
  }
  function ae(ie) {
    L.call(this, ie);
    const me = this.stack[this.stack.length - 1];
    me.url = "mailto:" + this.sliceSerialize(ie);
  }
  function Y() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function ee() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function se() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function re() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ae() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Oe() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Ce() {
    return {
      type: "break"
    };
  }
  function ue() {
    return {
      type: "html",
      value: ""
    };
  }
  function fe() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Se() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Fe(ie) {
    return {
      type: "list",
      ordered: ie.type === "listOrdered",
      start: null,
      spread: ie._spread,
      children: []
    };
  }
  function nt(ie) {
    return {
      type: "listItem",
      spread: ie._spread,
      checked: null,
      children: []
    };
  }
  function mt() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Ze() {
    return {
      type: "strong",
      children: []
    };
  }
  function rt() {
    return {
      type: "text",
      value: ""
    };
  }
  function Qe() {
    return {
      type: "thematicBreak"
    };
  }
}
function $i(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Wb(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Wb(e, r) : rP(e, r);
  }
}
function rP(e, t) {
  let n;
  for (n in t)
    if (qb.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function Qv(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + Ko({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + Ko({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + Ko({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
function iP(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return tP(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function Vb(e, t) {
  var l, u, c;
  const n = {
    ..._s,
    ...t == null ? void 0 : t.nodeTypes,
    [ne.heading]: {
      ..._s[ne.heading],
      ...(l = t == null ? void 0 : t.nodeTypes) == null ? void 0 : l[ne.heading]
    }
  }, r = (t == null ? void 0 : t.linkDestinationKey) ?? "link", i = (t == null ? void 0 : t.imageSourceKey) ?? "link", a = (t == null ? void 0 : t.imageCaptionKey) ?? "caption";
  let s = [{ text: "" }];
  const o = e.children;
  switch (o && Array.isArray(o) && o.length > 0 && (s = o.flatMap(
    (d) => Vb(
      {
        ...d,
        ordered: e.ordered || !1
      },
      t
    )
  )), e.type) {
    case bn.heading:
      return {
        type: n[ne.heading][e.depth || 1],
        // we need to flag the type of heading in the children to ensure it renders as the correct heading type
        children: s.map((d) => ({
          ...d,
          [n[ne.heading][e.depth || 1]]: !0
        }))
      };
    case bn.list:
      return {
        type: e.ordered ? n[ne.ol] : n[ne.ul],
        children: s
      };
    case bn.listItem:
      return { type: n[ne.li], children: s };
    case bn.paragraph:
      return { type: n[ne.paragraph], children: s };
    case bn.link:
      return {
        type: n[ne.link],
        [r]: e.url,
        children: s
      };
    case bn.image:
      return {
        type: n[ne.image],
        children: [{ text: "" }],
        [i]: e.url,
        [a]: e.alt
      };
    case bn.blockquote:
      return { type: n[ne.blockquote], children: s };
    case bn.code:
      return {
        type: n[ne.codeblock],
        language: e.lang,
        children: [{ text: e.value }]
      };
    case bn.html:
      return (u = e.value) != null && u.includes("<br>") ? {
        break: !0,
        type: n[ne.paragraph],
        children: [{ text: ((c = e.value) == null ? void 0 : c.replace(/<br>/g, "")) || "" }]
      } : { type: ne.paragraph, children: [{ text: e.value || "" }] };
    case bn.emphasis:
      return {
        [n[Ei.emphasis]]: !0,
        ...wd(s),
        ...hu(s)
      };
    case bn.strong:
      return {
        [n[Ei.strong]]: !0,
        ...wd(s),
        ...hu(s)
      };
    case bn.delete:
      return {
        [n[Ei.delete]]: !0,
        ...wd(s),
        ...hu(s)
      };
    case bn.inlineCode:
      return {
        [n[Ei.code]]: !0,
        text: e.value,
        ...hu(s)
      };
    case bn.thematicBreak:
      return {
        type: n[ne.hr],
        children: [{ text: "" }]
      };
    case "text":
    default:
      return { text: e.value || "" };
  }
}
const wd = (e) => ({
  text: e.map((t) => t == null ? void 0 : t.text).join("")
});
function hu(e) {
  return e.reduce((t, n) => (Object.keys(n).forEach(function(r) {
    r === "children" || r === "type" || r === "text" || (t[r] = n[r]);
  }), t), {});
}
const aP = function(t) {
  const n = (r) => r.children.map((i) => Vb(i, t));
  this.Compiler = n;
}, sP = (e, t = (n) => {
}) => {
  YO().use(iP).use(aP).process(e).then((n) => {
    const r = or(n.result), i = (s) => {
      const o = s;
      [ne.li, ne.blockquote].includes(o.type) && o.children.map((l, u) => {
        const c = l;
        c.type === ne.paragraph && o.children.splice(u, 1, ...c.children);
      }), "children" in s && s.children && s.children.forEach((l) => i(l));
    };
    r.forEach(i);
    const a = (s) => {
      for (let o = 0; o < s.length; o++) {
        const l = s[o], u = l;
        if (u.type === ne.link) {
          const c = u.children && u.children[0];
          if (c && "text" in c && c.text.includes(xh)) {
            const d = u, f = c.text.replace(xh, ""), p = "link" in d && d.link ? d.link : "";
            d.type = ne.mention, d.id = p, d.name = f, d.children = [{ text: "" }], s[o + 1] || s.splice(o + 1, 0, { text: " " }), o++;
          }
        }
        "children" in l && l.children && a(l.children);
      }
    };
    a(r), r.map((s) => {
      "children" in s && s.children && s.children.map((o, l) => {
        if ("text" in o && o.text) {
          const u = o.text.match(/~~(.*?)~~/g);
          u && u.map((c) => {
            const d = c.replace(/~~/g, ""), f = o.text.indexOf(c), p = o.text.substring(0, f), g = o.text.substring(f + c.length), m = [
              { text: p },
              { text: d, [ne.strikethrough]: !0 },
              { text: g }
            ];
            s.children.splice(l, 1, ...m);
          });
        }
      });
    }), t(r);
  });
}, Yp = (e) => {
  const t = document.getElementById(e);
  if (t) {
    const n = t.querySelector(".input");
    n && (n == null || n.focus());
  }
}, oP = (e, t) => {
  const { selection: n } = e;
  if (!n)
    return [null, null];
  let [r, i] = k.parent(e, n, { edge: "end" }), a = r;
  for (; a.type !== t && i.length > 0 && i.length !== 1; )
    i = V.parent(i), r = be.get(e, i), a = r;
  return a.type === t ? [r, i] : [null, null];
}, lP = (e) => {
  const { selection: t } = e;
  return t ? k.string(e, t) : null;
}, Xv = (e) => {
  let t = "";
  for (const n of be.descendants(e)) {
    const [r] = n, i = r;
    i.text && (t += i.text);
  }
  return t;
}, uP = (e) => {
  for (const [t] of be.descendants(e)) {
    const n = t;
    if (n.type === ne.link)
      return n.link;
  }
  return null;
}, Jv = {
  "mod+b": ne.bold,
  "mod+i": ne.italic,
  "mod+shift+x": ne.strikethrough,
  "mod+k": ne.link,
  "mod+shift+7": ne.ol,
  "mod+shift+8": ne.ul,
  "mod+shift+9": ne.blockquote
}, cP = (e, t, n, r) => {
  for (const i in Jv)
    if (aD(i, e)) {
      e.stopPropagation(), e.preventDefault();
      const a = Jv[i];
      if (a === ne.link) {
        n([{ type: "showLinkEditor", value: !0 }]);
        return;
      }
      if (bP(a)) {
        eT(t, a, r);
        return;
      }
      Qb(t, a, r);
    }
}, Kb = (e, t, n, r) => {
  var c;
  const { selectedUser: i, possibleUsers: a } = t, s = a[i];
  if (!s)
    return;
  const o = s.userId || "", l = (c = s.user) == null ? void 0 : c.name;
  n([{ type: "mentionPopover", value: { ...t, show: !1 } }]);
  const u = {
    type: ne.mention,
    id: o,
    name: l,
    children: [{ text: "" }]
  };
  le.select(e, (t == null ? void 0 : t.position) || Db), le.insertNodes(e, [u, { text: " " }]), le.move(e, { distance: 1, unit: "offset" }), Yp(r);
}, dP = async ({
  editor: e,
  isShowing: t,
  numberOfUsers: n,
  listMembers: r,
  dispatch: i
}) => {
  const { selection: a } = e;
  if (a && oe.isCollapsed(a)) {
    const [s] = oe.edges(a), o = k.start(e, s.path), l = k.range(e, o, s), c = k.string(e, l).match(M3);
    if (c) {
      const d = c.index || 0, f = { path: s.path, offset: d }, p = { path: s.path, offset: d + c[0].length }, g = k.range(e, f, p), m = k.after(e, s), y = k.range(e, s, m);
      if (k.string(e, y).match(/^(\s|\.|,|\?|!|:|;|'|"|`|$)/)) {
        const b = c[1];
        let _ = [];
        r && (_ = await r({ name: b })), i([
          {
            type: "mentionPopover",
            value: {
              show: _.length > 0 ? !0 : n !== null,
              selectedUser: 0,
              possibleUsers: _,
              position: _.length > 0 ? g : null,
              numberOfUsers: _.length > 0 ? _.length : null
            }
          }
        ]);
        return;
      }
    }
  }
  t && i([
    {
      type: "mentionPopover",
      value: {
        show: !1,
        selectedUser: 0,
        possibleUsers: [],
        position: null,
        numberOfUsers: null
      }
    }
  ]);
}, Gb = (e) => {
  let t = document.body;
  if (e !== !1) {
    const n = document.getElementById(e);
    n && (t = n);
  }
  return t;
}, rs = (e) => typeof e.text == "string", fP = [
  ne.hr,
  ne.image,
  ne.mention
], Ad = "<br>";
function Yb(e, t = { nodeTypes: _s }) {
  const {
    nodeTypes: n = _s,
    ignoreParagraphNewline: r = !1,
    listDepth: i = 0
  } = t, a = e.text || "";
  let s = e.type || "";
  const o = {
    ..._s,
    ...n,
    heading: {
      ..._s[ne.heading],
      ...n[ne.heading]
    }
  }, l = [o[ne.ul], o[ne.ol]];
  let u = a;
  if (!rs(e) && s !== ne.mention && (u = e.children.map((c) => {
    const d = rs(c) ? !1 : l.includes(c.type || ""), f = l.includes(e.type || "");
    let p = !1;
    return !rs(e) && Array.isArray(e.children) && (p = e.children.some(
      (g) => !rs(g) && g.type === o.link
    )), Yb(
      { ...c, parentType: s },
      {
        nodeTypes: o,
        // WOAH.
        // what we're doing here is pretty tricky, it relates to the block below where
        // we check for ignoreParagraphNewline and set type to paragraph.
        // We want to strip out empty paragraphs sometimes, but other times we don't.
        // If we're the descendant of a list, we know we don't want a bunch
        // of whitespace. If we're parallel to a link we also don't want
        // to respect neighboring paragraphs
        ignoreParagraphNewline: (r || d || f || p) && // if we have c.break, never ignore empty paragraph new line
        !c.break,
        // track depth of nested lists so we can add proper spacing
        listDepth: l.includes(c.type || "") ? i + 1 : i,
        inBlockquote: s === o[ne.blockquote] || e.parentType === o[ne.blockquote]
      }
    );
  }).join("")), !r && (a === "" || a === `
`) && e.parentType === o[ne.paragraph] && s !== o[ne.mention] && (s = o[ne.paragraph], u = Ad), !(u === "" && !fP.find((c) => o[c] === s)))
    switch (u !== Ad && rs(e) && (e[ne.strikethrough] && e[ne.bold] && e[ne.italic] ? u = is(u, "~~***") : e[ne.bold] && e[ne.italic] ? u = is(u, "***") : (e[ne.bold] && (u = is(u, "**")), e[ne.italic] && (u = is(u, "_")), e[ne.strikethrough] && (u = is(u, "~~")), e[ne.code] && (u = is(u, "`")))), s) {
      case o[ne.heading][1]:
        return `# ${u}
`;
      case o[ne.heading][2]:
        return `## ${u}
`;
      case o[ne.heading][3]:
        return `### ${u}
`;
      case o[ne.heading][4]:
        return `#### ${u}
`;
      case o[ne.heading][5]:
        return `##### ${u}
`;
      case o[ne.heading][6]:
        return `###### ${u}
`;
      case o[ne.blockquote]:
        return `> ${u}

`;
      case o[ne.codeblock]:
        return `\`\`\`${e.language || ""}
${u}
\`\`\`
`;
      case o[ne.link]:
        return `[${u}](${e.link || ""})`;
      case o.image:
        return `![${e.caption}](${e.link || ""})`;
      case o[ne.mention]:
        const { id: c } = e;
        return e ? `@{{${c}}}` : u;
      case o[ne.ul]:
      case o[ne.ol]:
        return `
${u}

`;
      case o[ne.li]:
        const d = e && e.parentType === o[ne.ol], f = e.children.length === 1 && rs(e.children[0]);
        let p = "";
        for (let g = 0; i > g; g++)
          d ? p += "   " : p += "  ";
        return t.inBlockquote && (p = "> " + p), `
${p}${d ? "1." : "-"} ${u}${f ? `
` : ""}`;
      case o[ne.paragraph]:
        return u === Ad ? "" : `${u}

`;
      case o[ne.hr]:
        return `---
`;
      default:
        return u;
    }
}
function is(e, t) {
  const n = e.trim(), r = n, i = `${t}${r}${e9(t)}`;
  if (r.length === e.length)
    return i;
  const a = t + r + e9(t);
  return e.replace(n, a);
}
const e9 = (e) => e.split("").reverse().join(""), hP = (e) => e.map((t) => Yb(t)).join("").trim();
const pP = ({
  onFallbackClick: e = () => {
  }
}) => {
  const t = ye(), n = Wa(), { dispatch: r, isInOverlay: i, mentionPopover: a, id: s, onMention: o } = We(Di), { show: l, selectedUser: u, possibleUsers: c } = a, d = Ob(n, "mention-popover", `toolbar-${s}`);
  if (!l)
    return /* @__PURE__ */ h.jsx(h.Fragment, {});
  const f = Gb(i);
  return /* @__PURE__ */ h.jsx(Pl, { parent: f, children: /* @__PURE__ */ h.jsx(
    l7,
    {
      ref: d,
      className: "mention-popover",
      onKeyDown: (p) => {
        p.key === "Escape" && (p.preventDefault(), p.stopPropagation(), r([{ type: "showMentionPopover", value: !1 }]));
      },
      children: /* @__PURE__ */ h.jsxs("ul", { children: [
        c.map(({ userId: p, user: g }, m) => /* @__PURE__ */ h.jsx(
          ea,
          {
            element: "li",
            className: te({ selected: m === u }),
            member: { id: p, ...g, link: !1 },
            functions: {
              onClick: (y) => {
                y.preventDefault(), y.stopPropagation();
                const v = { ...a, selectedUser: m };
                r([
                  {
                    type: "mentionPopover",
                    value: v
                  }
                ]), Kb(n, v, r, s), o && o({ id: p || "", name: g.name || "" });
              }
            }
          },
          p
        )),
        /* @__PURE__ */ h.jsx(
          ea,
          {
            element: "li",
            className: te("fallback", {
              selected: c.length === u
            }),
            member: {
              id: "0",
              name: t.formatMessage({ id: "richTextEditor_mention_fallback" }),
              image: {
                thumbnail: `${_i}icons/invite-user.svg`
              },
              link: !1
            },
            functions: {
              onClick: (p) => {
                p.preventDefault(), p.stopPropagation(), e(), r([
                  {
                    type: "mentionPopover",
                    value: {
                      show: !1,
                      selectedUser: 0,
                      possibleUsers: [],
                      position: null
                    }
                  }
                ]);
              }
            }
          }
        )
      ] })
    }
  ) });
};
const Nh = ({ formID: e, label: t, showLabel: n }) => {
  const { visible: r = "", screenreader: i = "" } = t || {};
  return n ? /* @__PURE__ */ h.jsx(
    "label",
    {
      htmlFor: `${e}-input`,
      className: "rte-label text-small",
      onClick: (a) => {
        a.preventDefault(), a.stopPropagation();
        const s = new CustomEvent("focusEditor", {
          detail: { id: `rte-${e}-input` }
        });
        window.dispatchEvent(s);
      },
      children: r
    }
  ) : /* @__PURE__ */ h.jsx(ht, { element: "label", showOnFocus: !1, htmlFor: `${e}-input`, children: i });
}, Zp = ({
  id: e,
  active: t,
  hasDivider: n = !1,
  callback: r,
  className: i = "",
  children: a,
  "aria-pressed": s,
  ...o
}) => {
  const l = ye(), u = Wa(), { id: c, dispatch: d } = We(Di), {
    tabbableOption: f,
    setFocus: p,
    openTooltip: g,
    dispatch: m
  } = We(Bl), y = {};
  return e !== f && (y.tabIndex = -1), s !== null && (y["aria-pressed"] = typeof s == "boolean" ? s : t), /* @__PURE__ */ h.jsxs(
    "li",
    {
      id: `${c}-${e}`,
      className: te(e, { "has-divider": n }),
      onMouseEnter: () => {
        m([{ type: "openTooltip", value: e }]);
      },
      onMouseLeave: () => {
        m([{ type: "openTooltip", value: null }]);
      },
      onFocus: () => {
        m([{ type: "openTooltip", value: e }]);
      },
      onBlur: (v) => {
        v.stopPropagation(), m([{ type: "openTooltip", value: null }]), u.selection && d({
          type: "lastAnchor",
          value: u.selection.anchor
        });
      },
      contentEditable: !1,
      children: [
        /* @__PURE__ */ h.jsxs(
          "button",
          {
            ...o,
            ...y,
            className: te(e, i, { active: t }),
            onClick: (v) => {
              v.stopPropagation(), v.preventDefault();
            },
            onMouseDown: (v) => {
              v.stopPropagation(), v.preventDefault(), r();
            },
            onKeyDown: (v) => {
              var E, b, _, T;
              if (v.key !== "Tab")
                switch (v.key) {
                  case "Enter":
                    v.stopPropagation(), v.preventDefault(), r();
                    break;
                  case "ArrowLeft":
                  case "ArrowRight":
                    v.stopPropagation(), v.preventDefault();
                    const x = v.currentTarget.closest("li");
                    let A = x == null ? void 0 : x.nextElementSibling;
                    if (v.key === "ArrowLeft") {
                      const L = x == null ? void 0 : x.previousElementSibling;
                      L ? A = L : A = (E = x == null ? void 0 : x.parentElement) == null ? void 0 : E.lastElementChild;
                    } else
                      A || (A = (b = x == null ? void 0 : x.parentElement) == null ? void 0 : b.firstElementChild);
                    const R = A == null ? void 0 : A.className.split(" ")[0];
                    R && (p(R), (_ = A == null ? void 0 : A.querySelector("button")) == null || _.focus());
                    break;
                  default:
                    const P = v.currentTarget.closest("fieldset");
                    if (P) {
                      (T = P == null ? void 0 : P.previousElementSibling) == null || T.focus();
                      break;
                    }
                }
            },
            children: [
              /* @__PURE__ */ h.jsx(ht, { showOnFocus: !1, children: l.formatMessage({ id: `richTextEditor_${e}` }) }),
              /* @__PURE__ */ h.jsx(
                Ys,
                {
                  id: `tooltip-${e}`,
                  styling: { extraPadding: !1, hasPointer: "bottom" },
                  isOpen: g === e,
                  accessibility: { "aria-hidden": !0 },
                  children: l.formatMessage({ id: `richTextEditor_${e}` })
                }
              )
            ]
          }
        ),
        a
      ]
    }
  );
}, t9 = [ne.ol, ne.ul], Zb = (e, t) => {
  const { selection: n } = e;
  if (!n)
    return !1;
  const [r] = Array.from(
    k.nodes(e, {
      at: k.unhangRange(e, n),
      match: (i) => {
        const a = i;
        return !k.isEditor(i) && De.isElement(i) && a.type === t;
      }
    })
  );
  return !!r;
}, mP = (e) => {
  const [t] = k.nodes(e, {
    match: (n) => n.type === ne.blockquote
  });
  return !!t;
}, Qb = (e, t, n) => {
  try {
    const r = mP(e), i = Zb(e, t), a = t9.includes(t);
    le.unwrapNodes(e, {
      match: (l) => {
        const u = l;
        return !k.isEditor(u) && De.isElement(u) && t9.includes(u.type);
      },
      split: !0
    });
    const o = {
      type: i ? ne.paragraph : a ? ne.li : t
    };
    if (le.setNodes(e, o), a)
      if (i) {
        const { selection: l } = e;
        if (!l)
          return;
        const [u, c] = k.parent(e, l, { edge: "end" });
        Array.from(
          k.nodes(e, {
            at: c,
            match: (f) => {
              const p = f;
              return !k.isEditor(f) && De.isElement(f) && p.type === ne.li;
            }
          })
        ).forEach(([f, p]) => {
          be.string(f).trim() === "" && le.removeNodes(e, { at: p });
        });
      } else {
        if (r) {
          const u = {
            type: ne.blockquote,
            children: []
          };
          le.wrapNodes(e, u);
        }
        const l = { type: t, children: [] };
        le.wrapNodes(e, l);
      }
  } catch (r) {
    const i = r.message;
    n(`Error toggling block: ${i}`);
  }
}, n9 = ({ format: e, hasDivider: t = !1 }) => {
  const { reportError: n } = We(Di), { setFocus: r } = We(Bl), i = Wa(), a = Zb(i, e);
  return /* @__PURE__ */ h.jsx(
    Zp,
    {
      id: e,
      active: a,
      hasDivider: t,
      callback: () => {
        Qb(i, e, n), r(a ? null : e);
      }
    }
  );
}, Yo = (e) => {
  const [t] = k.nodes(e, {
    match: (n) => {
      const r = n;
      return !k.isEditor(n) && De.isElement(n) && r.type === ne.link;
    }
  });
  return !!t;
}, gP = (e, t, n, r) => {
  e.selection && Qp(e, t, n, r);
}, vP = (e, t, n, r) => {
  const { selection: i } = e;
  if (i && oe.isCollapsed(i)) {
    const [s] = k.nodes(e, {
      match: (o) => {
        const l = o;
        return !k.isEditor(o) && De.isElement(o) && l.type === ne.link;
      }
    });
    if (s) {
      const [o, l] = s, u = { link: t };
      le.setNodes(e, u, { at: l }), Yp(n);
    }
  } else
    Qp(e, t, n, r);
}, Qp = (e, t, n, r = (i) => {
  console.error(i);
}) => {
  try {
    Yo(e) && Xb(e);
    const { selection: i } = e, a = i && oe.isCollapsed(i), s = {
      type: ne.link,
      link: t,
      children: a ? [{ text: t }] : []
    };
    a ? (le.insertNodes(e, s), le.move(e, { distance: 1, unit: "offset" })) : (le.wrapNodes(e, s, { split: !0 }), le.collapse(e, { edge: "end" }), le.insertNodes(e, { text: "" }), le.move(e, { distance: 1, unit: "offset" })), Yp(n);
  } catch (i) {
    const a = i.message;
    r(`Error in wrapLink: ${a}`);
  }
}, Xb = (e) => {
  le.unwrapNodes(e, {
    match: (t) => {
      const n = t;
      return !k.isEditor(t) && De.isElement(t) && n.type === ne.link;
    }
  });
};
let Sd = null;
const yP = () => {
  const e = ye(), t = "richTextEditor_link_", {
    id: n,
    isInOverlay: r,
    enrichedUrl: i,
    dispatch: a,
    getLinkPreview: s,
    showLinkEditor: o,
    reportError: l
  } = We(Di), u = Wa(), c = IO(u), d = (c == null ? void 0 : c.text) || lP(u), f = i !== !1, [p, g] = de(Yo(u)), m = Ob(u, "link-editor", `${n}-link`), y = Ue(null);
  pe(() => {
    var T;
    !p && o && ((T = y.current) == null || T.focus());
  }, [p]), pe(() => {
    Sd && clearTimeout(Sd), Sd = setTimeout(() => {
      g(Yo(u));
    }, 500);
  }, [u.selection]);
  const v = [], E = ["open", "edit", "remove"].map((T) => {
    const x = {
      variant: "tertiary",
      size: "small",
      children: e.formatMessage(
        { id: `${t}${T}` },
        { link: c == null ? void 0 : c.pretty }
      )
    };
    switch (v.push({ className: T }), T) {
      case "open":
        x.href = (c == null ? void 0 : c.full) || "", x.onClick = (A) => {
          A.preventDefault(), A.stopPropagation(), window.open((c == null ? void 0 : c.full) || "", "_blank"), a([{ type: "showLinkEditor", value: !1 }]);
        }, x.children = /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
          x.children,
          /* @__PURE__ */ h.jsx(ht, { children: e.formatMessage({ id: `${t}${T}_text` }) })
        ] });
        break;
      case "edit":
        x.onClick = () => {
          g(!1);
        };
        break;
      case "remove":
        x.onClick = () => {
          const A = [
            { type: "showLinkEditor", value: !1 }
          ];
          Yo(u) && (Xb(u), A.push({ type: "lastAnchor", value: null }), i && (c == null ? void 0 : c.full) === (i == null ? void 0 : i.url) && A.push({ type: "enrichedUrl", value: !1 })), a(A);
        };
        break;
    }
    return x;
  }), b = [
    {
      id: "url",
      type: "url",
      inputRef: y,
      label: e.formatMessage({ id: `${t}url` }),
      placeholder: e.formatMessage({ id: `${t}placeholder` }),
      value: (c == null ? void 0 : c.full) || "",
      validation: [
        {
          condition: "required",
          error: e.formatMessage({ id: `${t}error_required` })
        },
        { condition: "valid-url" }
      ],
      submitOnEnter: !0,
      autoFocus: !0,
      functions: {
        onChange: () => {
        },
        onKeyDown: (T) => {
          if (T.key === "Tab") {
            if (!u)
              return;
            T.preventDefault(), T.stopPropagation();
            const x = k.end(u, []);
            le.select(u, x), ce.focus(u);
          }
        }
      }
    }
  ];
  d && b.unshift({
    component: () => /* @__PURE__ */ h.jsxs("p", { children: [
      /* @__PURE__ */ h.jsx("strong", { "aria-label": e.formatMessage({ id: `${t}text_aria` }), children: e.formatMessage({ id: `${t}text` }) }),
      " ",
      d
    ] })
  });
  const _ = Gb(r);
  return /* @__PURE__ */ h.jsx(Pl, { parent: _, children: /* @__PURE__ */ h.jsx(
    Ys,
    {
      ref: m,
      id: `${n}-link-editor`,
      className: "link-editor",
      isOpen: o,
      styling: { extraPadding: !1, hasForm: !p },
      functions: {
        onBlur: () => {
          a([{ type: "showLinkEditor", value: !1 }]);
        }
      },
      callbacks: {
        onOpen: () => {
          setTimeout(() => {
            var T;
            return (T = y.current) == null ? void 0 : T.focus();
          });
        }
      },
      children: p ? /* @__PURE__ */ h.jsx(Il, { wrappers: v, buttons: E }) : /* @__PURE__ */ h.jsx(
        ti,
        {
          element: "fieldset",
          id: `${n}-link-editor`,
          className: te({ "show-labels": d }),
          meta: { shouldReset: !0, showRequiredLabels: !1 },
          functions: {
            onSuccess: async (T) => {
              setTimeout(async () => {
                a([{ type: "showLinkEditor", value: !1 }]);
                let x = T.url;
                if (T.url) {
                  const { full: A } = pp(T.url);
                  x = A, c != null && c.full ? vP(u, x, n, l) : gP(u, x, n, l), a({ type: "lastAnchor", value: null });
                }
                if (T.url && s && (!f || i && (c == null ? void 0 : c.full) === i.url)) {
                  const A = await s(x);
                  A.url && a([{ type: "enrichedUrl", value: A }]);
                }
              });
            }
          },
          fields: b,
          button: {
            text: e.formatMessage({ id: `${t}button` }),
            variant: "tertiary",
            size: "small"
          }
        }
      )
    }
  ) });
}, EP = () => {
  const e = Wa(), { dispatch: t } = We(Di), { setFocus: n } = We(Bl), [r, i] = de(!1);
  return pe(() => {
    i(Yo(e));
  }, [e.selection]), /* @__PURE__ */ h.jsx(
    Zp,
    {
      id: "link",
      active: r,
      hasDivider: !0,
      callback: () => {
        t([{ type: "showLinkEditor", value: !0 }]), n(r ? null : "link"), i(!0);
      },
      "aria-pressed": null
    }
  );
}, bP = (e) => [ne.bold, ne.italic, ne.strikethrough].includes(
  e
), Jb = (e, t) => {
  const n = k.marks(e);
  return n ? n[t] === !0 : !1;
}, eT = (e, t, n) => {
  try {
    Jb(e, t) ? k.removeMark(e, t) : k.addMark(e, t, !0);
  } catch (r) {
    const i = r.message;
    n(`Error toggling mark: ${i}`);
  }
}, TP = ({ format: e, hasDivider: t = !1 }) => {
  const { reportError: n } = We(Di), { setFocus: r } = We(Bl), i = Wa(), a = Jb(i, e);
  return /* @__PURE__ */ h.jsx(
    Zp,
    {
      id: e,
      active: a,
      hasDivider: t,
      callback: () => {
        eT(i, e, n), r(a ? null : e);
      }
    }
  );
}, pu = [
  ne.bold,
  ne.italic,
  ne.strikethrough
], _P = [
  ne.ol,
  ne.ul,
  ne.blockquote
];
const CP = ({
  styling: e = { showHeadingOption: !1 },
  ...t
}) => {
  const n = ye(), { id: r } = We(Di), i = {
    tabbableOption: pu[0],
    openTooltip: null
  }, [a, s] = ra(Nl, i), o = (l) => {
    l && s([{ type: "tabbableOption", value: l || pu[0] }]);
  };
  return /* @__PURE__ */ h.jsxs(Bl.Provider, { value: { ...a, setFocus: o, dispatch: s }, children: [
    /* @__PURE__ */ h.jsxs("fieldset", { id: `toolbar-${r}`, className: "toolbar", ...t, children: [
      /* @__PURE__ */ h.jsx(ht, { element: "legend", showOnFocus: !1, children: n.formatMessage({ id: "richTextEditor_toolbar" }) }),
      /* @__PURE__ */ h.jsxs("ul", { children: [
        (e == null ? void 0 : e.showHeadingOption) && /* @__PURE__ */ h.jsx(n9, { format: ne.h3, hasDivider: !0 }, ne.h3),
        pu.map((l, u) => /* @__PURE__ */ h.jsx(TP, { format: l, hasDivider: u === pu.length - 1 }, l)),
        /* @__PURE__ */ h.jsx(EP, {}),
        _P.map((l, u) => /* @__PURE__ */ h.jsx(n9, { format: l, hasDivider: u === 1 }, l))
      ] })
    ] }),
    /* @__PURE__ */ h.jsx(yP, {})
  ] });
}, xP = mr(CP);
function wP(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      n.hasOwnProperty(r) && (e[r] = n[r]);
  }
  return e;
}
function Ih(e, t) {
  return Array(t + 1).join(e);
}
function AP(e) {
  return e.replace(/^\n*/, "");
}
function SP(e) {
  for (var t = e.length; t > 0 && e[t - 1] === `
`; )
    t--;
  return e.substring(0, t);
}
var kP = [
  "ADDRESS",
  "ARTICLE",
  "ASIDE",
  "AUDIO",
  "BLOCKQUOTE",
  "BODY",
  "CANVAS",
  "CENTER",
  "DD",
  "DIR",
  "DIV",
  "DL",
  "DT",
  "FIELDSET",
  "FIGCAPTION",
  "FIGURE",
  "FOOTER",
  "FORM",
  "FRAMESET",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "HEADER",
  "HGROUP",
  "HR",
  "HTML",
  "ISINDEX",
  "LI",
  "MAIN",
  "MENU",
  "NAV",
  "NOFRAMES",
  "NOSCRIPT",
  "OL",
  "OUTPUT",
  "P",
  "PRE",
  "SECTION",
  "TABLE",
  "TBODY",
  "TD",
  "TFOOT",
  "TH",
  "THEAD",
  "TR",
  "UL"
];
function Xp(e) {
  return Jp(e, kP);
}
var tT = [
  "AREA",
  "BASE",
  "BR",
  "COL",
  "COMMAND",
  "EMBED",
  "HR",
  "IMG",
  "INPUT",
  "KEYGEN",
  "LINK",
  "META",
  "PARAM",
  "SOURCE",
  "TRACK",
  "WBR"
];
function nT(e) {
  return Jp(e, tT);
}
function DP(e) {
  return iT(e, tT);
}
var rT = [
  "A",
  "TABLE",
  "THEAD",
  "TBODY",
  "TFOOT",
  "TH",
  "TD",
  "IFRAME",
  "SCRIPT",
  "AUDIO",
  "VIDEO"
];
function OP(e) {
  return Jp(e, rT);
}
function NP(e) {
  return iT(e, rT);
}
function Jp(e, t) {
  return t.indexOf(e.nodeName) >= 0;
}
function iT(e, t) {
  return e.getElementsByTagName && t.some(function(n) {
    return e.getElementsByTagName(n).length;
  });
}
var gn = {};
gn.paragraph = {
  filter: "p",
  replacement: function(e) {
    return `

` + e + `

`;
  }
};
gn.lineBreak = {
  filter: "br",
  replacement: function(e, t, n) {
    return n.br + `
`;
  }
};
gn.heading = {
  filter: ["h1", "h2", "h3", "h4", "h5", "h6"],
  replacement: function(e, t, n) {
    var r = Number(t.nodeName.charAt(1));
    if (n.headingStyle === "setext" && r < 3) {
      var i = Ih(r === 1 ? "=" : "-", e.length);
      return `

` + e + `
` + i + `

`;
    } else
      return `

` + Ih("#", r) + " " + e + `

`;
  }
};
gn.blockquote = {
  filter: "blockquote",
  replacement: function(e) {
    return e = e.replace(/^\n+|\n+$/g, ""), e = e.replace(/^/gm, "> "), `

` + e + `

`;
  }
};
gn.list = {
  filter: ["ul", "ol"],
  replacement: function(e, t) {
    var n = t.parentNode;
    return n.nodeName === "LI" && n.lastElementChild === t ? `
` + e : `

` + e + `

`;
  }
};
gn.listItem = {
  filter: "li",
  replacement: function(e, t, n) {
    e = e.replace(/^\n+/, "").replace(/\n+$/, `
`).replace(/\n/gm, `
    `);
    var r = n.bulletListMarker + "   ", i = t.parentNode;
    if (i.nodeName === "OL") {
      var a = i.getAttribute("start"), s = Array.prototype.indexOf.call(i.children, t);
      r = (a ? Number(a) + s : s + 1) + ".  ";
    }
    return r + e + (t.nextSibling && !/\n$/.test(e) ? `
` : "");
  }
};
gn.indentedCodeBlock = {
  filter: function(e, t) {
    return t.codeBlockStyle === "indented" && e.nodeName === "PRE" && e.firstChild && e.firstChild.nodeName === "CODE";
  },
  replacement: function(e, t, n) {
    return `

    ` + t.firstChild.textContent.replace(/\n/g, `
    `) + `

`;
  }
};
gn.fencedCodeBlock = {
  filter: function(e, t) {
    return t.codeBlockStyle === "fenced" && e.nodeName === "PRE" && e.firstChild && e.firstChild.nodeName === "CODE";
  },
  replacement: function(e, t, n) {
    for (var r = t.firstChild.getAttribute("class") || "", i = (r.match(/language-(\S+)/) || [null, ""])[1], a = t.firstChild.textContent, s = n.fence.charAt(0), o = 3, l = new RegExp("^" + s + "{3,}", "gm"), u; u = l.exec(a); )
      u[0].length >= o && (o = u[0].length + 1);
    var c = Ih(s, o);
    return `

` + c + i + `
` + a.replace(/\n$/, "") + `
` + c + `

`;
  }
};
gn.horizontalRule = {
  filter: "hr",
  replacement: function(e, t, n) {
    return `

` + n.hr + `

`;
  }
};
gn.inlineLink = {
  filter: function(e, t) {
    return t.linkStyle === "inlined" && e.nodeName === "A" && e.getAttribute("href");
  },
  replacement: function(e, t) {
    var n = t.getAttribute("href"), r = zc(t.getAttribute("title"));
    return r && (r = ' "' + r + '"'), "[" + e + "](" + n + r + ")";
  }
};
gn.referenceLink = {
  filter: function(e, t) {
    return t.linkStyle === "referenced" && e.nodeName === "A" && e.getAttribute("href");
  },
  replacement: function(e, t, n) {
    var r = t.getAttribute("href"), i = zc(t.getAttribute("title"));
    i && (i = ' "' + i + '"');
    var a, s;
    switch (n.linkReferenceStyle) {
      case "collapsed":
        a = "[" + e + "][]", s = "[" + e + "]: " + r + i;
        break;
      case "shortcut":
        a = "[" + e + "]", s = "[" + e + "]: " + r + i;
        break;
      default:
        var o = this.references.length + 1;
        a = "[" + e + "][" + o + "]", s = "[" + o + "]: " + r + i;
    }
    return this.references.push(s), a;
  },
  references: [],
  append: function(e) {
    var t = "";
    return this.references.length && (t = `

` + this.references.join(`
`) + `

`, this.references = []), t;
  }
};
gn.emphasis = {
  filter: ["em", "i"],
  replacement: function(e, t, n) {
    return e.trim() ? n.emDelimiter + e + n.emDelimiter : "";
  }
};
gn.strong = {
  filter: ["strong", "b"],
  replacement: function(e, t, n) {
    return e.trim() ? n.strongDelimiter + e + n.strongDelimiter : "";
  }
};
gn.code = {
  filter: function(e) {
    var t = e.previousSibling || e.nextSibling, n = e.parentNode.nodeName === "PRE" && !t;
    return e.nodeName === "CODE" && !n;
  },
  replacement: function(e) {
    if (!e)
      return "";
    e = e.replace(/\r?\n|\r/g, " ");
    for (var t = /^`|^ .*?[^ ].* $|`$/.test(e) ? " " : "", n = "`", r = e.match(/`+/gm) || []; r.indexOf(n) !== -1; )
      n = n + "`";
    return n + t + e + t + n;
  }
};
gn.image = {
  filter: "img",
  replacement: function(e, t) {
    var n = zc(t.getAttribute("alt")), r = t.getAttribute("src") || "", i = zc(t.getAttribute("title")), a = i ? ' "' + i + '"' : "";
    return r ? "![" + n + "](" + r + a + ")" : "";
  }
};
function zc(e) {
  return e ? e.replace(/(\n+\s*)+/g, `
`) : "";
}
function aT(e) {
  this.options = e, this._keep = [], this._remove = [], this.blankRule = {
    replacement: e.blankReplacement
  }, this.keepReplacement = e.keepReplacement, this.defaultRule = {
    replacement: e.defaultReplacement
  }, this.array = [];
  for (var t in e.rules)
    this.array.push(e.rules[t]);
}
aT.prototype = {
  add: function(e, t) {
    this.array.unshift(t);
  },
  keep: function(e) {
    this._keep.unshift({
      filter: e,
      replacement: this.keepReplacement
    });
  },
  remove: function(e) {
    this._remove.unshift({
      filter: e,
      replacement: function() {
        return "";
      }
    });
  },
  forNode: function(e) {
    if (e.isBlank)
      return this.blankRule;
    var t;
    return (t = kd(this.array, e, this.options)) || (t = kd(this._keep, e, this.options)) || (t = kd(this._remove, e, this.options)) ? t : this.defaultRule;
  },
  forEach: function(e) {
    for (var t = 0; t < this.array.length; t++)
      e(this.array[t], t);
  }
};
function kd(e, t, n) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    if (IP(i, t, n))
      return i;
  }
}
function IP(e, t, n) {
  var r = e.filter;
  if (typeof r == "string") {
    if (r === t.nodeName.toLowerCase())
      return !0;
  } else if (Array.isArray(r)) {
    if (r.indexOf(t.nodeName.toLowerCase()) > -1)
      return !0;
  } else if (typeof r == "function") {
    if (r.call(e, t, n))
      return !0;
  } else
    throw new TypeError("`filter` needs to be a string, array, or function");
}
function PP(e) {
  var t = e.element, n = e.isBlock, r = e.isVoid, i = e.isPre || function(d) {
    return d.nodeName === "PRE";
  };
  if (!(!t.firstChild || i(t))) {
    for (var a = null, s = !1, o = null, l = r9(o, t, i); l !== t; ) {
      if (l.nodeType === 3 || l.nodeType === 4) {
        var u = l.data.replace(/[ \r\n\t]+/g, " ");
        if ((!a || / $/.test(a.data)) && !s && u[0] === " " && (u = u.substr(1)), !u) {
          l = Dd(l);
          continue;
        }
        l.data = u, a = l;
      } else if (l.nodeType === 1)
        n(l) || l.nodeName === "BR" ? (a && (a.data = a.data.replace(/ $/, "")), a = null, s = !1) : r(l) || i(l) ? (a = null, s = !0) : a && (s = !1);
      else {
        l = Dd(l);
        continue;
      }
      var c = r9(o, l, i);
      o = l, l = c;
    }
    a && (a.data = a.data.replace(/ $/, ""), a.data || Dd(a));
  }
}
function Dd(e) {
  var t = e.nextSibling || e.parentNode;
  return e.parentNode.removeChild(e), t;
}
function r9(e, t, n) {
  return e && e.parentNode === t || n(t) ? t.nextSibling || t.parentNode : t.firstChild || t.nextSibling || t.parentNode;
}
var em = typeof window < "u" ? window : {};
function RP() {
  var e = em.DOMParser, t = !1;
  try {
    new e().parseFromString("", "text/html") && (t = !0);
  } catch {
  }
  return t;
}
function FP() {
  var e = function() {
  };
  return BP() ? e.prototype.parseFromString = function(t) {
    var n = new window.ActiveXObject("htmlfile");
    return n.designMode = "on", n.open(), n.write(t), n.close(), n;
  } : e.prototype.parseFromString = function(t) {
    var n = document.implementation.createHTMLDocument("");
    return n.open(), n.write(t), n.close(), n;
  }, e;
}
function BP() {
  var e = !1;
  try {
    document.implementation.createHTMLDocument("").open();
  } catch {
    em.ActiveXObject && (e = !0);
  }
  return e;
}
var MP = RP() ? em.DOMParser : FP();
function LP(e, t) {
  var n;
  if (typeof e == "string") {
    var r = $P().parseFromString(
      // DOM parsers arrange elements in the <head> and <body>.
      // Wrapping in a custom element ensures elements are reliably arranged in
      // a single element.
      '<x-turndown id="turndown-root">' + e + "</x-turndown>",
      "text/html"
    );
    n = r.getElementById("turndown-root");
  } else
    n = e.cloneNode(!0);
  return PP({
    element: n,
    isBlock: Xp,
    isVoid: nT,
    isPre: t.preformattedCode ? jP : null
  }), n;
}
var Od;
function $P() {
  return Od = Od || new MP(), Od;
}
function jP(e) {
  return e.nodeName === "PRE" || e.nodeName === "CODE";
}
function HP(e, t) {
  return e.isBlock = Xp(e), e.isCode = e.nodeName === "CODE" || e.parentNode.isCode, e.isBlank = UP(e), e.flankingWhitespace = zP(e, t), e;
}
function UP(e) {
  return !nT(e) && !OP(e) && /^\s*$/i.test(e.textContent) && !DP(e) && !NP(e);
}
function zP(e, t) {
  if (e.isBlock || t.preformattedCode && e.isCode)
    return { leading: "", trailing: "" };
  var n = qP(e.textContent);
  return n.leadingAscii && i9("left", e, t) && (n.leading = n.leadingNonAscii), n.trailingAscii && i9("right", e, t) && (n.trailing = n.trailingNonAscii), { leading: n.leading, trailing: n.trailing };
}
function qP(e) {
  var t = e.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
  return {
    leading: t[1],
    // whole string for whitespace-only strings
    leadingAscii: t[2],
    leadingNonAscii: t[3],
    trailing: t[4],
    // empty for whitespace-only strings
    trailingNonAscii: t[5],
    trailingAscii: t[6]
  };
}
function i9(e, t, n) {
  var r, i, a;
  return e === "left" ? (r = t.previousSibling, i = / $/) : (r = t.nextSibling, i = /^ /), r && (r.nodeType === 3 ? a = i.test(r.nodeValue) : n.preformattedCode && r.nodeName === "CODE" ? a = !1 : r.nodeType === 1 && !Xp(r) && (a = i.test(r.textContent))), a;
}
var WP = Array.prototype.reduce, VP = [
  [/\\/g, "\\\\"],
  [/\*/g, "\\*"],
  [/^-/g, "\\-"],
  [/^\+ /g, "\\+ "],
  [/^(=+)/g, "\\$1"],
  [/^(#{1,6}) /g, "\\$1 "],
  [/`/g, "\\`"],
  [/^~~~/g, "\\~~~"],
  [/\[/g, "\\["],
  [/\]/g, "\\]"],
  [/^>/g, "\\>"],
  [/_/g, "\\_"],
  [/^(\d+)\. /g, "$1\\. "]
];
function _l(e) {
  if (!(this instanceof _l))
    return new _l(e);
  var t = {
    rules: gn,
    headingStyle: "setext",
    hr: "* * *",
    bulletListMarker: "*",
    codeBlockStyle: "indented",
    fence: "```",
    emDelimiter: "_",
    strongDelimiter: "**",
    linkStyle: "inlined",
    linkReferenceStyle: "full",
    br: "  ",
    preformattedCode: !1,
    blankReplacement: function(n, r) {
      return r.isBlock ? `

` : "";
    },
    keepReplacement: function(n, r) {
      return r.isBlock ? `

` + r.outerHTML + `

` : r.outerHTML;
    },
    defaultReplacement: function(n, r) {
      return r.isBlock ? `

` + n + `

` : n;
    }
  };
  this.options = wP({}, t, e), this.rules = new aT(this.options);
}
_l.prototype = {
  /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */
  turndown: function(e) {
    if (!YP(e))
      throw new TypeError(
        e + " is not a string, or an element/document/fragment node."
      );
    if (e === "")
      return "";
    var t = sT.call(this, new LP(e, this.options));
    return KP.call(this, t);
  },
  /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */
  use: function(e) {
    if (Array.isArray(e))
      for (var t = 0; t < e.length; t++)
        this.use(e[t]);
    else if (typeof e == "function")
      e(this);
    else
      throw new TypeError("plugin must be a Function or an Array of Functions");
    return this;
  },
  /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  addRule: function(e, t) {
    return this.rules.add(e, t), this;
  },
  /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  keep: function(e) {
    return this.rules.keep(e), this;
  },
  /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */
  remove: function(e) {
    return this.rules.remove(e), this;
  },
  /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */
  escape: function(e) {
    return VP.reduce(function(t, n) {
      return t.replace(n[0], n[1]);
    }, e);
  }
};
function sT(e) {
  var t = this;
  return WP.call(e.childNodes, function(n, r) {
    r = new HP(r, t.options);
    var i = "";
    return r.nodeType === 3 ? i = r.isCode ? r.nodeValue : t.escape(r.nodeValue) : r.nodeType === 1 && (i = GP.call(t, r)), oT(n, i);
  }, "");
}
function KP(e) {
  var t = this;
  return this.rules.forEach(function(n) {
    typeof n.append == "function" && (e = oT(e, n.append(t.options)));
  }), e.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
}
function GP(e) {
  var t = this.rules.forNode(e), n = sT.call(this, e), r = e.flankingWhitespace;
  return (r.leading || r.trailing) && (n = n.trim()), r.leading + t.replacement(n, e, this.options) + r.trailing;
}
function oT(e, t) {
  var n = SP(e), r = AP(t), i = Math.max(e.length - n.length, t.length - r.length), a = `

`.substring(0, i);
  return n + a + r;
}
function YP(e) {
  return e != null && (typeof e == "string" || e.nodeType && (e.nodeType === 1 || e.nodeType === 9 || e.nodeType === 11));
}
var ZP = {
  /**
   * Check if a value is a `History` object.
   */
  isHistory(e) {
    return un(e) && Array.isArray(e.redos) && Array.isArray(e.undos) && (e.redos.length === 0 || Zi.isOperationList(e.redos[0].operations)) && (e.undos.length === 0 || Zi.isOperationList(e.undos[0].operations));
  }
}, Nd = /* @__PURE__ */ new WeakMap(), Id = /* @__PURE__ */ new WeakMap(), Cs = {
  /**
   * Check if a value is a `HistoryEditor` object.
   */
  isHistoryEditor(e) {
    return ZP.isHistory(e.history) && k.isEditor(e);
  },
  /**
   * Get the merge flag's current value.
   */
  isMerging(e) {
    return Id.get(e);
  },
  /**
   * Get the saving flag's current value.
   */
  isSaving(e) {
    return Nd.get(e);
  },
  /**
   * Redo to the previous saved state.
   */
  redo(e) {
    e.redo();
  },
  /**
   * Undo to the previous saved state.
   */
  undo(e) {
    e.undo();
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging(e, t) {
    var n = Cs.isMerging(e);
    Id.set(e, !1), t(), Id.set(e, n);
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without saving any of
   * their operations into the history.
   */
  withoutSaving(e, t) {
    var n = Cs.isSaving(e);
    Nd.set(e, !1), t(), Nd.set(e, n);
  }
}, QP = (e) => {
  var t = e, {
    apply: n
  } = t;
  return t.history = {
    undos: [],
    redos: []
  }, t.redo = () => {
    var {
      history: r
    } = t, {
      redos: i
    } = r;
    if (i.length > 0) {
      var a = i[i.length - 1];
      a.selectionBefore && le.setSelection(t, a.selectionBefore), Cs.withoutSaving(t, () => {
        k.withoutNormalizing(t, () => {
          for (var s of a.operations)
            t.apply(s);
        });
      }), r.redos.pop(), t.writeHistory("undos", a);
    }
  }, t.undo = () => {
    var {
      history: r
    } = t, {
      undos: i
    } = r;
    if (i.length > 0) {
      var a = i[i.length - 1];
      Cs.withoutSaving(t, () => {
        k.withoutNormalizing(t, () => {
          var s = a.operations.map(Zi.inverse).reverse();
          for (var o of s)
            t.apply(o);
          a.selectionBefore && le.setSelection(t, a.selectionBefore);
        });
      }), t.writeHistory("redos", a), r.undos.pop();
    }
  }, t.apply = (r) => {
    var {
      operations: i,
      history: a
    } = t, {
      undos: s
    } = a, o = s[s.length - 1], l = o && o.operations[o.operations.length - 1], u = Cs.isSaving(t), c = Cs.isMerging(t);
    if (u == null && (u = JP(r)), u) {
      if (c == null && (o == null ? c = !1 : i.length !== 0 ? c = !0 : c = XP(r, l)), o && c)
        o.operations.push(r);
      else {
        var d = {
          operations: [r],
          selectionBefore: t.selection
        };
        t.writeHistory("undos", d);
      }
      for (; s.length > 100; )
        s.shift();
      a.redos = [];
    }
    n(r);
  }, t.writeHistory = (r, i) => {
    t.history[r].push(i);
  }, t;
}, XP = (e, t) => !!(t && e.type === "insert_text" && t.type === "insert_text" && e.offset === t.offset + t.text.length && V.equals(e.path, t.path) || t && e.type === "remove_text" && t.type === "remove_text" && e.offset + e.text.length === t.offset && V.equals(e.path, t.path)), JP = (e, t) => e.type !== "set_selection";
const eR = (e, t) => {
  const { apply: n } = e;
  try {
    e.apply = (r) => {
      if (r.type === "remove_node" && "type" in r.node && r.node.type === ne.link) {
        const i = r.node;
        if (i.link) {
          const a = new CustomEvent("linkRemoved", {
            detail: { url: i.link }
          });
          window.dispatchEvent(a);
        }
      }
      n(r);
    };
  } catch (r) {
    const i = r.message;
    t(`Error in withLinkRemovalListener: ${i}`);
  }
  return e;
};
var tR = aR, nR = /^(?:\w+:)?\/\/(\S+)$/, rR = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/, iR = /^[^\s\.]+\.\S{2,}$/;
function aR(e) {
  if (typeof e != "string")
    return !1;
  var t = e.match(nR);
  if (!t)
    return !1;
  var n = t[1];
  return n ? !!(rR.test(n) || iR.test(n)) : !1;
}
const sR = /* @__PURE__ */ Or(tR), oR = (e, t, n) => {
  const { insertText: r, isInline: i } = e;
  try {
    e.isInline = (a) => {
      const s = a;
      return [ne.link].includes(s.type) || i(a);
    }, e.insertText = (a) => {
      a && sR(a) ? Qp(e, a, t) : r(a);
    };
  } catch (a) {
    const s = a.message;
    n(`Error in withInlines: ${s}`);
  }
  return e;
}, lR = (e, t) => {
  const { isInline: n, isVoid: r, markableVoid: i } = e;
  try {
    e.isInline = (a) => a.type === ne.mention ? !0 : n(a), e.isVoid = (a) => a.type === ne.mention ? !0 : r(a), e.markableVoid = (a) => a.type === ne.mention || i(a);
  } catch (a) {
    const s = a.message;
    t(`Error in withMentions: ${s}`);
  }
  return e;
}, uR = (e, t) => {
  const { normalizeNode: n } = e;
  try {
    e.normalizeNode = ([r, i]) => {
      if (r.type === ne.link && be.string(r).trim() === "") {
        le.removeNodes(e, { at: i });
        return;
      }
      n([r, i]);
    };
  } catch (r) {
    const i = r.message;
    t(`Error in withoutEmptyLinks: ${i}`);
  }
  return e;
};
const lT = ({
  id: e = "rich-text-editor",
  value: t,
  placeholder: n,
  maxLength: r = 0,
  meta: i,
  functions: a,
  autoFocus: s,
  data: o,
  styling: l,
  ...u
}) => {
  const c = ye(), d = H3();
  typeof s > "u" && (s = !0);
  const { isInOverlay: f = !1 } = i || {}, {
    listMembers: p,
    clickMentionFallback: g,
    onChange: m = () => {
    },
    onChangeData: y = () => {
    },
    getLinkPreview: v = () => Promise.resolve({}),
    onMention: E = () => {
    },
    reportError: b = (z) => {
      console.error(z);
    }
  } = a || {}, _ = [
    {
      type: ne.paragraph,
      children: [{ text: "" }]
    }
  ];
  t === "<br>" && (t = "");
  const T = {
    editorKey: null,
    originalValue: t || "",
    initialValue: t ? null : _,
    showLinkEditor: !1,
    mentionPopover: {
      show: !1,
      selectedUser: 0,
      possibleUsers: [],
      position: null,
      numberOfUsers: null
    },
    lastAnchor: null,
    stringValue: "",
    lastKey: null,
    hasInteracted: !1,
    hasLoaded: !1,
    enrichedUrl: !1
  }, [x, A] = ra(Nl, T), {
    editorKey: R,
    originalValue: P,
    initialValue: L,
    stringValue: I,
    lastAnchor: O,
    lastKey: S,
    hasInteracted: F,
    hasLoaded: H,
    enrichedUrl: q,
    mentionPopover: N
  } = x, Q = async (z) => {
    const U = await v(z);
    U.url && A([{ type: "enrichedUrl", value: U }]);
  }, J = `rte-${e}`, D = ft(
    (z) => /* @__PURE__ */ h.jsx(q6, { ...z }),
    []
  ), C = ft((z) => /* @__PURE__ */ h.jsx(W6, { ...z }), []), Z = Vn(
    () => eR(
      oR(
        lR(
          uR(QP(NO(Rk())), b),
          b
        ),
        J,
        b
      ),
      b
    ),
    []
  ), B = (z) => {
    if (!Z || z !== J)
      return;
    const U = k.end(Z, []);
    le.select(Z, U), ce.focus(Z);
  };
  pe(() => {
    const z = (U) => {
      var Y;
      const $ = U, ae = ((Y = $ == null ? void 0 : $.detail) == null ? void 0 : Y.id) || null;
      ae && B(ae);
    };
    return window.addEventListener("focusEditor", z), () => {
      window.removeEventListener("focusEditor", z);
    };
  }, []), pe(() => {
    if (Z.children.length > 0 && !H) {
      if (A([{ type: "hasLoaded", value: !0 }]), !s)
        return;
      B(J);
    }
  }, [Z.children.length, L]), pe(() => {
    P && (async () => {
      let U = or(P);
      if (U.endsWith("<br/>") && (U = U.slice(0, -5)), U.includes("<")) {
        _l.prototype.escape = (ae) => ae;
        const $ = new _l();
        $.addRule("br", {
          filter: ["br"],
          replacement: (ae) => ae + `

`
        }), U = $.turndown(U);
      }
      o && o.mentions && (U = await XE({
        text: U,
        template: `[${xh}{{name}}]({{id}})`,
        mentions: o.mentions,
        listMembers: p || (() => Promise.resolve([]))
      })), sP(U, ($) => {
        const ae = [
          { type: "initialValue", value: $ },
          { type: "editorKey", value: P.toString() }
        ];
        o != null && o.link && (ae.push({ type: "enrichedUrl", value: o.link }), o.link.url && Q(o.link.url)), A(ae), setTimeout(() => {
          A([{ type: "stringValue", value: Xv(Z) }]);
        }, 150);
      });
    })();
  }, [P]), pe(() => {
    if (q === void 0 && Z) {
      const U = uP(Z);
      U && Q(U);
    }
    const z = (U) => {
      var Y;
      const $ = U, ae = ((Y = $ == null ? void 0 : $.detail) == null ? void 0 : Y.url) || null;
      ae && q && q.url === ae && A([{ type: "enrichedUrl", value: void 0 }]);
    };
    return window.addEventListener("linkRemoved", z), () => {
      window.removeEventListener("linkRemoved", z);
    };
  }, [q]), pe(() => {
    if (t) {
      Rs.lastIndex = 0;
      const z = t.match(Rs);
      z && z.length === 1 && z[0].length === t.length && !F && A([{ type: "originalValue", value: t }]);
    }
    t !== "" || !Z || Sc(P, t) && !F || (k.withoutNormalizing(Z, () => {
      le.delete(Z, {
        at: {
          anchor: k.start(Z, []),
          focus: k.end(Z, [])
        }
      }), le.deselect(Z), Z.children.length !== 0 && le.unwrapNodes(Z, { at: [0] }), le.insertNodes(Z, _, { at: [0] });
    }), A([
      { type: "initialValue", value: _ },
      { type: "lastAnchor", value: null },
      { type: "enrichedUrl", value: !1 }
    ]));
  }, [t]), pe(() => {
    y({ link: q });
  }, [q]), pe(() => {
    I === "" && q && A([{ type: "enrichedUrl", value: void 0 }]);
  }, [I]);
  const j = fl(() => {
    dP({
      editor: Z,
      isShowing: N.show,
      numberOfUsers: N.numberOfUsers,
      listMembers: p,
      dispatch: A
    });
  }, 100);
  return L ? /* @__PURE__ */ h.jsx("div", { id: J, className: "rich-text-editor input text-medium", children: /* @__PURE__ */ h.jsxs(
    Di.Provider,
    {
      value: {
        ...x,
        id: J,
        isInOverlay: f,
        dispatch: A,
        onMention: E,
        reportError: b
      },
      children: [
        /* @__PURE__ */ h.jsxs(
          DO,
          {
            editor: Z,
            initialValue: L,
            onChange: (z) => {
              if (Z.operations.some(($) => $.type !== "set_selection")) {
                let $ = hP(z);
                $ === "<br>" && ($ = ""), m($, q), A([{ type: "stringValue", value: Xv(Z) }]), F || A([{ type: "hasInteracted", value: !0 }]), j(), d && console.log({ serialized: $, json: z });
              }
            },
            ...u,
            children: [
              /* @__PURE__ */ h.jsx(
                bO,
                {
                  className: "editor",
                  renderElement: D,
                  renderLeaf: C,
                  placeholder: n || c.formatMessage({ id: "richTextEditor_placeholder" }),
                  autoFocus: s,
                  tabIndex: 0,
                  onPaste: async (z) => {
                    const U = q !== !1, $ = z.clipboardData.getData("text");
                    if (((Y) => {
                      try {
                        return new URL(Y), !0;
                      } catch {
                        return !1;
                      }
                    })($)) {
                      let Y = $;
                      if ($) {
                        const { full: ee } = pp($);
                        Y = ee;
                      }
                      if ($ && v && !U) {
                        const ee = await v(Y);
                        ee.url && A([{ type: "enrichedUrl", value: ee }]);
                      }
                    }
                  },
                  onKeyDown: (z) => {
                    if (z.key === "Enter") {
                      N.show && (z.preventDefault(), z.stopPropagation(), Kb(Z, N, A, J));
                      const { selection: U } = Z;
                      if (U) {
                        const $ = oe.isCollapsed(U), [ae, Y] = k.node(Z, U, { depth: 1 });
                        let ee = ae, se = ee.type;
                        const re = ee.children[0];
                        if (se === ne.h3) {
                          z.preventDefault(), z.stopPropagation();
                          const Ae = k.start(Z, Y), Oe = k.end(Z, Y), Ce = Xe.equals(U.anchor, Ae), ue = Xe.equals(U.anchor, Oe);
                          if (Ce)
                            le.insertNodes(Z, _, { at: Y });
                          else if (ue)
                            le.insertNodes(Z, _, {
                              at: V.next(Y)
                            }), le.select(Z, k.end(Z, V.next(Y)));
                          else {
                            const fe = U.anchor, [, Se] = k.parent(Z, U);
                            le.splitNodes(Z, { at: fe }), le.setNodes(
                              Z,
                              { type: ne.paragraph },
                              { at: V.next(Se) }
                            );
                          }
                          return;
                        }
                        if (re && [ne.ol, ne.ul].includes(re.type) && (ee = re, se = re.type), ee && De.isElement(ee) && se !== ne.paragraph) {
                          if (se === ne.blockquote && !z.shiftKey) {
                            z.stopPropagation(), z.preventDefault(), le.insertNodes(Z, _);
                            return;
                          }
                          if ($) {
                            const [Ae, Oe] = k.parent(Z, U, {
                              edge: "end"
                            }), ue = Ae.type;
                            if ([ne.ul, ne.ol].includes(se))
                              if (z.stopPropagation(), z.preventDefault(), ue === ne.li && S === "Enter") {
                                Ae.children.length === 1 && "text" in Ae.children[0] && Ae.children[0].text === "" && le.removeNodes(Z, { at: Oe }), le.insertNodes(Z, _, {
                                  at: V.next(Y)
                                }), le.select(
                                  Z,
                                  k.end(Z, V.next(Y))
                                );
                                return;
                              } else {
                                const [fe, Se] = oP(Z, ne.li), Fe = {
                                  type: ne.li,
                                  children: [{ text: "" }]
                                };
                                le.insertNodes(Z, Fe, {
                                  at: V.next(Se)
                                }), le.select(
                                  Z,
                                  k.end(Z, V.next(Se))
                                );
                              }
                          }
                        }
                      }
                    } else if (z.key === "Escape") {
                      if (N.show) {
                        z.preventDefault(), z.stopPropagation(), A([
                          { type: "mentionPopover", value: { ...N, show: !1 } }
                        ]);
                        return;
                      }
                    } else if (["ArrowUp", "ArrowDown"].includes(z.key) && N.show) {
                      z.preventDefault(), z.stopPropagation();
                      const { selectedUser: U, possibleUsers: $ } = N;
                      let ae = z.key === "ArrowUp" ? U - 1 : U + 1;
                      ae < 0 && (ae = $.length - 1), ae >= $.length + 1 && (ae = 0), A([
                        {
                          type: "mentionPopover",
                          value: { ...N, selectedUser: ae }
                        }
                      ]);
                    }
                    A([{ type: "lastKey", value: z.key }]), cP(z, Z, A, b);
                  },
                  onBlur: () => {
                    Z.selection && A([{ type: "lastAnchor", value: Z.selection.anchor }]);
                  },
                  onFocus: () => {
                    if (O) {
                      if (!V.isPath(O.path) || !be.has(Z, O.path))
                        return;
                      const z = be.get(Z, O.path);
                      let U = 0;
                      if (Ie.isText(z) ? U = z.text.length : z.children && (U = z.children.length), O.offset > U)
                        return;
                      try {
                        le.select(Z, {
                          anchor: O,
                          focus: O
                        });
                      } catch ($) {
                        const ae = $.message;
                        b(`Error focusing editor: ${ae}`);
                      }
                    }
                  }
                }
              ),
              q ? /* @__PURE__ */ h.jsx(
                dT,
                {
                  data: q,
                  variant: "condensed",
                  onClick: () => {
                    A([{ type: "enrichedUrl", value: !1 }]);
                    const z = new CustomEvent("ariaLive", {
                      detail: {
                        message: c.formatMessage({
                          id: "richTextEditor_link_enrichedUrl_aria_live"
                        })
                      }
                    });
                    document.dispatchEvent(z);
                  },
                  "aria-label": c.formatMessage(
                    { id: "richTextEditor_link_enrichedUrl_aria" },
                    {
                      title: q.title || c.formatMessage({
                        id: "richTextEditor_link_enrichedUrl_aria_fallback"
                      })
                    }
                  )
                }
              ) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
              /* @__PURE__ */ h.jsx(xP, { styling: l == null ? void 0 : l.toolbar }),
              p ? /* @__PURE__ */ h.jsx(pP, { onFallbackClick: g }) : /* @__PURE__ */ h.jsx(h.Fragment, {})
            ]
          },
          R
        ),
        /* @__PURE__ */ h.jsx(
          I4,
          {
            id: `character-limit-${e}`,
            limit: r,
            valueLength: kp(I)
          }
        )
      ]
    }
  ) }) : /* @__PURE__ */ h.jsx(h.Fragment, {});
};
const nae = ({
  id: e = "form-toggle",
  label: t,
  options: n,
  initialValue: r,
  functions: { onChange: i = () => {
  } },
  isDisabled: a = !1,
  className: s = ""
}) => {
  const [o, l] = de(
    typeof r == "boolean" || typeof r == "string" ? r : n[0].value
  );
  pe(() => {
    r && l(r);
  }, [r]);
  const u = (c) => {
    a || (l(c), i(c));
  };
  return /* @__PURE__ */ h.jsxs(
    "div",
    {
      className: te("toggle", s),
      onClick: (c) => {
        c.preventDefault(), c.stopPropagation(), u(o === n[0].value ? n[1].value : n[0].value);
      },
      children: [
        /* @__PURE__ */ h.jsx("p", { children: t }),
        /* @__PURE__ */ h.jsx(
          "ul",
          {
            className: te("toggle-options", {
              disabled: a,
              on: o === n[1].value
            }),
            children: n.map((c) => {
              const d = `${e}-${c.value}`;
              return /* @__PURE__ */ h.jsxs("li", { className: "hidden", children: [
                /* @__PURE__ */ h.jsx(
                  "input",
                  {
                    type: "radio",
                    id: d,
                    name: e,
                    value: c.value,
                    checked: o === c.value,
                    onChange: () => u(c.value),
                    disabled: a
                  }
                ),
                /* @__PURE__ */ h.jsx("label", { htmlFor: d, children: c.label })
              ] }, d);
            })
          }
        )
      ]
    }
  );
};
function cR({
  className: e = "",
  userId: t,
  userName: n,
  src: r,
  uploadImage: i,
  button: a,
  callback: s
}) {
  const o = ye(), l = "profileImageChange_", [u, c] = de(r), [d, f] = de(!1), [p, g] = de(!1), m = Ue(null), y = async (_) => {
    f(!0), g(!1);
    try {
      const T = _.target.files && _.target.files[0];
      if (!T || !t)
        throw f(!1), new Error("Image file or userID is missing");
      const x = await i({ fileObject: T, userId: t }), A = {
        thumbnail: x.thumbnailURL,
        full: x.originalURL
      };
      c(A), s(A);
    } catch {
      g(!0);
    } finally {
      f(!1);
    }
    f(!1);
  }, {
    upload: v = o.formatMessage({ id: `${l}cta_upload` }),
    change: E = o.formatMessage({ id: `${l}cta_change` }),
    uploading: b = o.formatMessage({ id: `${l}cta_uploading` })
  } = (a == null ? void 0 : a.text) || {};
  return /* @__PURE__ */ h.jsxs("div", { className: te("profile-image-change-figure", e), children: [
    /* @__PURE__ */ h.jsx(
      aa,
      {
        className: "profile-image-change-picture",
        name: n,
        src: u == null ? void 0 : u.thumbnail,
        showInitials: !1,
        alt: "",
        "data-testid": "profile-picture"
      }
    ),
    p && /* @__PURE__ */ h.jsx("p", { className: "error text-small", children: o.formatMessage({ id: `${l}error` }) }),
    /* @__PURE__ */ h.jsx(
      "input",
      {
        id: "file",
        type: "file",
        accept: "image/*",
        ref: m,
        onChange: y,
        hidden: !0,
        "data-testid": "file-input"
      }
    ),
    /* @__PURE__ */ h.jsx(
      je,
      {
        onClick: () => m.current && m.current.click(),
        variant: "secondary",
        "data-gtm-event-context": "ImageField",
        "data-gtm-event-type": `${u ? "change-photo" : "add-photo"}-click`,
        className: "gtm-trackable",
        disabled: d,
        children: d ? b : u ? E : v
      }
    )
  ] });
}
const dR = ({
  gtm: e,
  functions: { onSuccess: t = async () => {
  }, onFailure: n = () => {
  } }
}) => {
  const { context: r = "FooterContactUsForm", event: i = "contact-form-submit-click" } = e || {};
  return /* @__PURE__ */ h.jsx(
    ti,
    {
      id: "contact-us-form",
      fields: [
        {
          id: "name",
          type: "text",
          className: "short",
          validation: [{ condition: "required" }],
          autoComplete: "name"
        },
        {
          id: "email",
          type: "email",
          className: "short",
          validation: [{ condition: "required" }, { condition: "valid-email" }]
        },
        { id: "organisation", type: "text" },
        {
          id: "interests",
          type: "checkboxes",
          options: [
            { id: "publishingCourse", label: "Publishing or creating a course" },
            { id: "buyingCourse", label: "Buying courses for my team" },
            { id: "learningExperience", label: "Customised learning experiences" },
            { id: "somethingElse", label: "Something else" }
          ]
        },
        {
          id: "message",
          type: "textarea",
          limit: 1e3,
          validation: [{ condition: "required" }]
        }
      ],
      intlPath: "contactForm",
      gtm: { context: r, event: i },
      functions: { onSuccess: t, onFailure: n },
      button: { className: "new" }
    }
  );
};
const fR = ({ emails: e, setEmails: t, setIsDisabled: n }) => {
  const { formatMessage: r } = ye();
  return /* @__PURE__ */ h.jsx(
    b3,
    {
      id: "email-input",
      inputClassName: "email-input input",
      placeholder: r({ id: "inviteForm_email_placeholder" }),
      emails: e,
      onChange: (i) => {
        t(i), n(!i.length);
      },
      autoFocus: !1,
      getLabel: (i, a, s) => /* @__PURE__ */ h.jsxs("div", { className: "email text-medium", children: [
        /* @__PURE__ */ h.jsx("div", { "data-tag-item": !0, children: i }),
        /* @__PURE__ */ h.jsx(
          je,
          {
            variant: "tertiary",
            size: "small",
            icon: { icon: "close" },
            onClick: () => {
              s(a), n(!e.length);
            },
            className: "remove-email-button",
            screenreaderText: r({ id: "overlay_close" })
          }
        )
      ] }, a)
    }
  );
}, hR = ({
  title: e,
  label: t,
  messagePlaceholder: n,
  ctaMessage: r,
  titleColor: i,
  labelColor: a,
  backgroundColor: s,
  onClose: o,
  reportError: l,
  sendInvites: u,
  initialFormStatus: c = "NOT_SUBMITTED",
  gtm: d = { context: "Form", event: "form-submit-click" },
  secondaryActionButton: f,
  meta: p
}) => {
  const [g, m] = de([]), [y, v] = de(!0), [E, b] = de(c), { formatMessage: _ } = ye(), T = async (R) => {
    try {
      await u(g, R.message), m([]), b(
        "SUCCESS"
        /* SUCCESS */
      );
    } catch (P) {
      b(
        "ERROR"
        /* ERROR */
      ), l(P);
    }
  }, x = (R) => {
    R.preventDefault(), b(
      "NOT_SUBMITTED"
      /* NOT_SUBMITTED */
    ), v(!0), m([]);
  }, A = (R) => {
    R.preventDefault(), o(), b(
      "CLOSED"
      /* CLOSED */
    );
  };
  return E === "CLOSED" ? null : E === "ERROR" || E === "SUCCESS" && !(p != null && p.shouldHideDoneButtonOnSubmit) ? /* @__PURE__ */ h.jsxs("div", { className: "invite-form-wrapper", children: [
    /* @__PURE__ */ h.jsx("div", { className: "content centred", children: E === "SUCCESS" ? /* @__PURE__ */ h.jsx("h2", { className: "success-title", children: _({ id: "inviteForm_success" }) }) : /* @__PURE__ */ h.jsxs("h2", { className: "error-title", children: [
      " ",
      _({ id: "inviteForm_error" })
    ] }) }),
    /* @__PURE__ */ h.jsx(Zr, {}),
    /* @__PURE__ */ h.jsx("div", { className: "footer", children: E === "SUCCESS" ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx(je, { variant: "secondary", onClick: x, children: _({ id: "inviteForm_ctaSendMoreInvites" }) }),
      /* @__PURE__ */ h.jsx(je, { onClick: A, children: _({ id: "inviteForm_ctaDone" }) })
    ] }) : /* @__PURE__ */ h.jsx(je, { onClick: x, children: _({ id: "inviteForm_ctaTryAgain" }) }) })
  ] }) : /* @__PURE__ */ h.jsxs("div", { className: "invite-form-wrapper", style: { backgroundColor: s }, children: [
    /* @__PURE__ */ h.jsxs("div", { className: "content", children: [
      /* @__PURE__ */ h.jsx("h2", { className: "title", style: { color: i }, children: e }),
      /* @__PURE__ */ h.jsx("label", { htmlFor: "email-input", className: "label", style: { color: a }, children: t })
    ] }),
    /* @__PURE__ */ h.jsx(
      ti,
      {
        id: "invite-form",
        fields: [
          {
            component: fR,
            props: {
              emails: g,
              setEmails: m,
              setIsDisabled: v
            },
            required: !0
          },
          {
            id: "message",
            type: "textarea",
            label: _({ id: "inviteForm_message_label" }),
            placeholder: n || _({ id: "inviteForm_message_placeholder" })
          }
        ],
        functions: {
          onSuccess: T
        },
        button: {
          text: r,
          size: "medium",
          disabled: y
        },
        gtm: d,
        meta: p,
        secondaryActionButton: f
      }
    )
  ] });
}, Pd = (e) => e.map((t) => ({ condition: t }));
const Jn = {
  FORM_ID: "manage-account-password-change",
  NEW_PASSWORD: "newPassword",
  CONFIRMED_PASSWORD: "confirmedPassword",
  CURRENT_PASSWORD: "oldPassword"
}, rae = ({ functions: e, ...t }) => {
  const { formatMessage: n } = ye(), [r, i] = de(null), [a, s] = de(!1), [o, l] = de({
    isMoreThanEightCharacters: !1,
    includesNumberAndSymbol: !1,
    includesLowerAndUppercase: !1
  }), u = (p) => p[Jn.NEW_PASSWORD] !== p[Jn.CONFIRMED_PASSWORD] ? n({ id: "passwordRules_unmatched_text" }) : null, c = (p) => !x0(p[Jn.NEW_PASSWORD]).isValid, d = [
    {
      "data-testid": Jn.NEW_PASSWORD,
      id: Jn.NEW_PASSWORD,
      type: "password",
      autoComplete: "new-password",
      placeholder: "",
      label: n({ id: "passwordRules_newPassword_label" }),
      validation: Pd(["required", c]),
      functions: {
        onChange: (p) => l(x0(p).matchingRules),
        onFocus: () => s(!0),
        onBlur: () => s(!1)
      }
    },
    {
      "data-testid": Jn.CONFIRMED_PASSWORD,
      id: Jn.CONFIRMED_PASSWORD,
      type: "password",
      autoComplete: "new-password",
      placeholder: "",
      label: n({ id: "passwordRules_confirmPassword_label" }),
      validation: Pd(["required", u])
    }
  ];
  t.isPasswordChange && d.unshift({
    "data-testid": Jn.CURRENT_PASSWORD,
    id: Jn.CURRENT_PASSWORD,
    type: "password",
    autoComplete: "current-password",
    placeholder: "",
    label: n({ id: "passwordRules_currentPassword_label" }),
    validation: Pd(["required"])
  }), a && d.push({
    component: H6,
    props: { matchingRules: o }
  });
  const f = {
    id: Jn.FORM_ID,
    fields: d,
    functions: {
      ...e,
      onSuccess: async (p) => (e.createPassword(p), e.onSuccess && e.onSuccess(p)),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onCatch: (p) => i(p == null ? void 0 : p.statusCode),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onFailure: (p, g) => {
        (g.includes(Jn.NEW_PASSWORD) || g.includes(Jn.CONFIRMED_PASSWORD)) && s(!0);
      }
    },
    meta: {
      shouldReset: !0
    },
    ...t
  };
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(ti, { ...f }),
    r && /* @__PURE__ */ h.jsx(Ci, { variant: "error", text: r })
  ] });
};
const pR = ({
  isCreateProfile: e = !1,
  hooks: t,
  functions: n,
  meta: r = {},
  gtm: i,
  ...a
}) => {
  var R;
  const s = ye(), o = "profileForm_", l = We(zt), [u, c] = de(l.image), [d, f] = de(!1), {
    uploadImage: p = () => {
    },
    onSuccess: g = async (P) => {
    },
    onCancel: m = () => {
    },
    onFailure: y = () => {
    }
  } = n, { buildLocation: v, isValidPlace: E, predictPlaces: b } = t.useMaps(), { context: _ = "ProfileForm", event: T = "profile-form-submit-click" } = i || {}, x = [
    {
      id: "jobTitle",
      type: "text",
      label: s.formatMessage({ id: `${o}jobTitle` }),
      placeholder: s.formatMessage({ id: `${o}jobTitle_placeholder` }),
      value: l.jobTitle,
      validation: [{ condition: "required" }]
    },
    {
      id: "organization",
      type: "text",
      label: s.formatMessage({ id: `${o}organization` }),
      placeholder: s.formatMessage({
        id: `${o}organization_placeholder`
      }),
      value: l.organization,
      validation: [{ condition: "required" }]
    },
    {
      id: "location",
      type: "autocomplete",
      label: s.formatMessage({ id: `${o}location` }),
      placeholder: s.formatMessage({ id: `${o}location_placeholder` }),
      value: (R = l.location) == null ? void 0 : R.en,
      validation: [
        { condition: "required" },
        {
          condition: ({ location: P }) => P && !d ? !1 : !E(P),
          error: s.formatMessage({ id: `${o}location_error` })
        }
      ],
      functions: {
        onChange: () => {
          d || f(!0);
        },
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onKeyInput: b
      }
    }
  ], A = [
    {
      component: cR,
      props: {
        userName: l.name,
        userId: l.id,
        src: u,
        uploadImage: p,
        callback: c,
        button: {
          text: {
            upload: s.formatMessage({ id: `${o}image` })
          }
        }
      }
    },
    {
      id: "name",
      type: "text",
      label: s.formatMessage({ id: `${o}name` }),
      placeholder: s.formatMessage({ id: `${o}name_placeholder` }),
      value: l.name,
      autoComplete: "name",
      validation: [{ condition: "required" }]
    },
    ...x,
    {
      id: "biography",
      type: "textarea",
      label: s.formatMessage({ id: `${o}bio` }),
      placeholder: s.formatMessage({ id: `${o}bio_placeholder` }),
      limit: 1e3,
      value: l.biography
    },
    {
      component: Zr
    }
  ];
  return /* @__PURE__ */ h.jsx(
    ti,
    {
      id: "profile-details-form",
      fields: e ? x : A,
      meta: {
        shouldShowCancelButton: !e,
        shouldReset: !1,
        shouldHide: !1,
        showRequiredLabels: e,
        ...r
      },
      intlPath: o,
      gtm: { context: _, event: T },
      functions: {
        onSuccess: async (P) => {
          try {
            const L = {
              ...P,
              image: u || null,
              location: d ? await v(P == null ? void 0 : P.location) : l.location,
              ...e ? { onboardingState: "completed" } : {}
            };
            l.updateDetails && l.updateDetails((I) => ({ ...I, ...L })), await g(L);
          } catch {
            y();
          }
        },
        onCancel: m,
        onFailure: y
      },
      button: {
        size: "large",
        text: {
          default: s.formatMessage({ id: `${o}cta` }),
          submitting: s.formatMessage({ id: `${o}cta_submitting` }),
          submitted: s.formatMessage({ id: `${o}cta_submitted` })
        }
      },
      ...a
    }
  );
}, mR = () => {
  const e = ye(), [t, n] = de(0);
  return pe(() => {
    const r = setInterval(() => {
      n((i) => {
        if (i >= 95)
          return clearInterval(r), 95;
        const a = Math.round(Math.random() * 10);
        return Math.min(i + a, 95);
      });
    }, 800);
    return () => {
      clearInterval(r);
    };
  }, []), /* @__PURE__ */ h.jsx(
    V7,
    {
      progress: t,
      steps: {
        0: {
          icon: "layers",
          text: e.formatMessage({ id: "publishArticleForm_progressBar" })
        }
      }
    }
  );
};
function gR({ coverImage: e, setShowImagePicker: t }) {
  return e && e.url ? /* @__PURE__ */ h.jsx(
    Ci,
    {
      className: "cover-image-preview",
      text: /* @__PURE__ */ h.jsx(
        za,
        {
          className: "cover-image",
          image: {
            description: e.description || "",
            height: e.height,
            width: e.width,
            url: e.url,
            color: e.color,
            type: "image/jpeg"
          }
        }
      ),
      button: {
        component: /* @__PURE__ */ h.jsx(je, { variant: "tertiary", onClick: () => t(!0), children: /* @__PURE__ */ h.jsx(en, { id: "publishArticleForm_replaceImage_button" }) })
      }
    }
  ) : /* @__PURE__ */ h.jsx(
    Ci,
    {
      button: {
        component: /* @__PURE__ */ h.jsx(je, { variant: "secondary", onClick: () => t(!0), children: /* @__PURE__ */ h.jsx(en, { id: "publishArticleForm_selectImage_button" }) })
      }
    }
  );
}
var uT = /* @__PURE__ */ ((e) => (e.CitiesAndLocalGovernment = "topic_CitiesAndLocalGovernment", e.Climate = "topic_Climate", e.DigitalAndData = "topic_DigitalAndData", e.Education = "topic_Education", e.EquityJusticeAndInclusion = "topic_EquityJusticeAndInclusion", e.HealthAndSocialCare = "topic_HealthAndSocialCare", e.Innovation = "topic_Innovation", e.LeadershipAndSkills = "topic_LeadershipAndSkills", e.LifeInGovernment = "topic_LifeInGovernment", e.Policymaking = "topic_Policymaking", e.TransportAndInfrastructure = "topic_TransportAndInfrastructure", e.WorkingAndTheEconomy = "topic_WorkAndTheEconomy", e))(uT || {});
let Rd = null;
const Vt = "publishArticleForm_", a9 = {}, s9 = 10, iae = ({
  id: e = "publish-article-form",
  values: t = a9,
  setShowImagePicker: n,
  functions: r,
  meta: i,
  gtm: a,
  isEditMode: s = !1
}) => {
  var I;
  const o = ye(), l = We(zt), { create: u, edit: c, onSuccess: d = () => {
  }, onFailure: f = () => {
  } } = r || {}, { isInOverlay: p = !1 } = i || {}, [g, m] = de(!1), [y, v] = de(t.body || ""), [E, b] = de(!1), [_, T] = de("");
  pe(() => {
    Sc(t, a9) || hl(t.body) && t.body !== y && t.body !== void 0 && v(t.body);
  }, [t.body]);
  const x = () => {
    !l || !l.id ? b(o.formatMessage({ id: `${Vt}error_loggedOut` })) : E && b(!1);
  }, A = (O) => ({
    condition: (S) => {
      const F = S[O];
      return !F || typeof F != "string" ? !0 : F.length < s9;
    },
    error: o.formatMessage(
      { id: `${Vt}error_underMinLength` },
      { length: s9 }
    )
  }), R = !!y && hl(y), P = () => /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(Zr, {}),
    /* @__PURE__ */ h.jsx("p", { className: "text-medium", children: o.formatMessage({ id: `${Vt}disclaimer` }) })
  ] }), L = [
    {
      id: "title",
      type: "textarea",
      value: t.title || "",
      limit: 65,
      label: o.formatMessage({ id: `${Vt}title_label` }),
      placeholder: o.formatMessage({ id: `${Vt}title_placeholder` }),
      styling: {
        autosizeToFit: !0
      },
      functions: {
        onChange: x
      },
      validation: [{ condition: "required" }, A("title")]
    },
    {
      id: "subtitle",
      type: "textarea",
      value: t.subtitle,
      limit: 115,
      label: o.formatMessage({ id: `${Vt}subtitle_label` }),
      styling: {
        autosizeToFit: !0
      },
      placeholder: o.formatMessage({ id: `${Vt}subtitle_placeholder` }),
      functions: {
        onChange: x
      },
      validation: [{ condition: "required" }, A("subtitle")]
    },
    {
      component: Nh,
      props: {
        formID: e,
        label: {
          visible: o.formatMessage({ id: `${Vt}body_label` })
        },
        showLabel: !0
      }
    },
    {
      component: lT,
      props: {
        id: `${e}-input`,
        value: y,
        placeholder: o.formatMessage({ id: `${Vt}body_placeholder` }),
        meta: { isInOverlay: p },
        autoFocus: !1,
        functions: {
          onChange: (O) => {
            v(O), x();
          }
        },
        styling: {
          toolbar: {
            showHeadingOption: !0
          }
        },
        "aria-invalid": !!E,
        "aria-errormessage": "error-message"
      }
    },
    {
      id: "tags",
      label: o.formatMessage({ id: `${Vt}tags_label` }),
      type: "checkboxes",
      styling: { displayOptionsAsPills: !0 },
      options: Object.values(uT).map((O) => ({
        id: O,
        label: o.formatMessage({ id: `${Vt}_tags_${O}` })
      })),
      value: t.tags || [],
      multipleOptions: {
        limit: 3
      },
      validation: [
        {
          condition: "required",
          error: o.formatMessage({ id: `${Vt}tags_error_required` })
        },
        {
          condition: (O) => {
            var S;
            return ((S = O == null ? void 0 : O.tags) == null ? void 0 : S.length) > 3;
          },
          error: o.formatMessage({ id: `${Vt}tags_error_over_three` })
        }
      ]
    },
    {
      component: Nh,
      props: {
        formID: e,
        label: {
          visible: o.formatMessage({ id: `${Vt}cover_image_label` })
        },
        showLabel: !0
      }
    },
    {
      component: gR,
      props: {
        coverImage: t.coverImage || {},
        setShowImagePicker: n
      }
    }
  ];
  return g ? L.push({ component: Zr }) : L.push({ component: P }), /* @__PURE__ */ h.jsxs("section", { className: "publish-article-form", children: [
    /* @__PURE__ */ h.jsx(
      ti,
      {
        id: e,
        meta: {
          shouldReset: !1,
          shouldHide: !1,
          showRequiredLabels: !1,
          shouldScrollOnSuccess: !1
        },
        functions: {
          onSuccess: async (O) => {
            if (!l || !l.id || !R)
              return;
            Rd && clearTimeout(Rd), m(!0);
            const S = {
              ...O,
              body: y,
              coverImage: t.coverImage
            };
            try {
              s && c ? await c(S) : u && await u(S), Rd = setTimeout(() => {
                T(
                  o.formatMessage({
                    id: `${Vt}aria_success${s ? "_edit" : ""}`
                  })
                ), d(S);
              }, 500);
            } catch {
              b(o.formatMessage({ id: `${Vt}error` })), T(""), f();
            }
          },
          onFailure: f
        },
        fields: L,
        intlPath: Vt,
        button: {
          variant: "primary",
          size: { mobile: "small", 600: "medium" },
          "data-gtm-event-context": a == null ? void 0 : a.context,
          "data-gtm-event-type": "publish-article-click",
          disabled: !l || !l.id || !R || !((I = t == null ? void 0 : t.coverImage) != null && I.url),
          text: {
            default: o.formatMessage({
              id: `${Vt}cta_submit${s ? "_edit" : ""}`
            }),
            submitting: o.formatMessage({
              id: `${Vt}cta_submitting${s ? "_edit" : ""}`
            }),
            submitted: o.formatMessage({
              id: `${Vt}cta_submitted${s ? "_edit" : ""}`
            })
          },
          customOnSubmit: E ? /* @__PURE__ */ h.jsx(h.Fragment, {}) : /* @__PURE__ */ h.jsx(mR, {})
        },
        gtm: a
      }
    ),
    E && /* @__PURE__ */ h.jsx(pl, { id: "error-message", className: "error", children: typeof E == "string" && E.includes(" ") ? E : o.formatMessage({ id: `${Vt}error` }) }),
    _ && /* @__PURE__ */ h.jsx(ht, { "aria-live": "polite", showOnFocus: !1, children: _ })
  ] });
};
const vR = ({
  id: e = "search",
  className: t = "",
  handleToggle: n = !1,
  defaultValue: r = "",
  gtmContext: i = "search-bar",
  gtmEvent: a = "form-submission"
}) => {
  const { searchIsOpen: s = !0, isDesktopVersion: o = !1 } = n || {}, l = ye(), u = Ue(null);
  dl(() => {
    !n || o || !s || u.current && u.current.focus();
  }, [s]);
  const c = (d) => {
    d.preventDefault(), d.stopPropagation(), !(!u.current || !u.current.value || u.current.value.length < 1) && (window.location.href = `/search?search=${encodeURIComponent(u.current.value)}`);
  };
  return /* @__PURE__ */ h.jsx(
    "form",
    {
      onSubmit: c,
      className: te("search-form gtm-trackable", t),
      role: "search",
      "data-gtm-event-context": i,
      "data-gtm-event-type": a,
      children: /* @__PURE__ */ h.jsx("fieldset", { id: `${e}-form`, hidden: n ? !s : !1, children: /* @__PURE__ */ h.jsxs("p", { children: [
        /* @__PURE__ */ h.jsx(
          ht,
          {
            element: "label",
            htmlFor: e,
            children: l.formatMessage({ id: "search_label" })
          }
        ),
        /* @__PURE__ */ h.jsx(
          "input",
          {
            ref: u,
            type: "search",
            id: e,
            name: e,
            defaultValue: r,
            placeholder: l.formatMessage({ id: "search_placeholder" }),
            onKeyDown: (d) => {
              d.key === "Enter" && c(d);
            }
          }
        ),
        /* @__PURE__ */ h.jsx(
          "button",
          {
            className: "clear",
            onClick: (d) => {
              d.preventDefault(), d.stopPropagation(), u.current && u.current.value && (u.current.value = "");
            },
            children: /* @__PURE__ */ h.jsx(ht, { children: l.formatMessage({ id: "search_clear" }) })
          }
        ),
        /* @__PURE__ */ h.jsx("button", { className: "search", onClick: c, children: /* @__PURE__ */ h.jsx(ht, { children: l.formatMessage({ id: "search_cta" }) }) })
      ] }) })
    }
  );
}, o9 = async ({ ref: e, validateEmail: t, dispatch: n }) => {
  const r = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!e.current.validity.valid || !r.test(e.current.value))
    return n([{ type: "validFields.email", value: !1 }]);
  const i = e.current.value.toString().toLowerCase().trim(), a = {
    valid: !1,
    autoApproved: !1,
    exists: {
      auth: !1,
      engagement: !1,
      registration: !1,
      user: !1
    }
  };
  let s = Object.assign({}, a);
  try {
    s = await t(i), s === void 0 && (s = a);
  } catch {
    return n([
      { type: "shouldManuallyApprove", value: !0 },
      {
        type: "emailDetails",
        value: {
          email: i,
          boxType: "nonGov",
          isEnd2End: !1
        }
      },
      { type: "validFields.email", value: !1 }
    ]);
  }
  const { valid: o = !1, autoApproved: l = !1, exists: u } = s;
  let c = "";
  return o ? c = l ? "gov" : "nonGov" : u.registration ? u.engagement && !u.user ? c = u.auth ? "verify" : "pending" : c = "exists" : u.auth && (c = "exists"), n([
    { type: "shouldDisableButton", value: !1 },
    { type: "shouldManuallyApprove", value: !l },
    {
      type: "emailDetails",
      value: {
        email: i,
        boxType: c,
        isEnd2End: /testing\+[0-9]+@apolitical.co$/.test(i)
      }
    },
    { type: "validFields.email", value: !0 }
  ]);
}, yR = (e) => {
  const t = {};
  for (const n of e.entries())
    t[n[0]] = n[1];
  return {
    name: t.full_name.toString().trim(),
    email: t.email_address.toString().toLowerCase().trim(),
    jobTitle: t.job_title,
    organization: t.organization,
    bioLink: t.url,
    optIn: !0,
    // These emails are considered core to the service and no longer need an opt-in, but we have not updated the back-end yet
    expectation: t.expectation,
    page: window.location.pathname,
    "g-recaptcha-response": t["g-recaptcha-response"]
  };
}, ER = async ({
  refs: e,
  dataToSubmit: t,
  createAccount: n,
  onSuccess: r,
  dispatch: i,
  state: a
}) => {
  if (!e.form || !e.form.current)
    throw new Error("No refs.form");
  if (!e.form.current.checkValidity()) {
    e.hiddenValidation && e.hiddenValidation.current && e.hiddenValidation.current.click();
    return;
  }
  const s = yR(new FormData(e.form.current)), o = Object.assign(s, t);
  await n(o), sessionStorage.setItem(ZE.SESSION_STORAGE.EMAIL, s.email), r && r({ ...s, ...a.values }), i([{ type: "showSuccessMessage", value: !0 }]);
}, bR = ({
  shouldShow: e,
  placeholders: t,
  labels: n,
  functions: { validateEmail: r, resendVerificationCode: i },
  refs: a,
  state: s,
  dispatch: o,
  dataToSubmit: l,
  intl: u
  // We need to pass `intl` in as it's being used in a hook
}) => {
  const { emailDetails: c } = s, d = (p, g) => {
    p.current && s.validFields[g] !== p.current.validity.valid && o([{ type: `validFields.${g}`, value: p.current.validity.valid }]);
  }, f = [
    {
      id: "full_name",
      type: "text",
      inputRef: a.name,
      placeholder: u.formatMessage({ id: "signup_full_name_placeholder" }),
      functions: {
        onChange: () => d(a.name, "name"),
        onFocus: () => o([{ type: "loadRecaptcha", value: !0 }])
      },
      autoComplete: "name",
      validation: [{ condition: "required" }, { condition: "no-numbers" }],
      "data-testid": "signup-name-input"
    },
    {
      id: "email_address",
      type: "email",
      inputRef: a.email,
      placeholder: u.formatMessage({
        id: "signup_email_address_placeholder"
      }),
      "aria-describedby": "email-helper-textbox",
      functions: {
        onBlur: () => {
          o9({ ref: a.email, validateEmail: r, dispatch: o });
        },
        onChange: (p, g) => {
          o([{ type: "shouldDisableButton", value: !0 }]), g && g({
            type: "updateValue",
            payload: { key: "terms", value: !1 }
          });
        },
        onFocus: () => o([{ type: "loadRecaptcha", value: !0 }])
      },
      autoComplete: "email",
      validation: [{ condition: "required" }, { condition: "valid-email" }],
      "data-testid": "signup-email-input"
    },
    {
      component: N6,
      props: {
        email: c.email,
        type: c.boxType,
        resendVerificationCode: i
      }
    }
  ];
  return s.shouldManuallyApprove && (f.push(
    {
      id: "job_title",
      type: "text",
      inputRef: a.jobTitle,
      placeholder: u.formatMessage({ id: "signup_job_title_placeholder" }),
      functions: {
        onChange: () => d(a.jobTitle, "jobTitle")
      },
      validation: [{ condition: "required" }],
      "data-testid": "signup-job-input"
    },
    {
      id: "organization",
      type: "text",
      inputRef: a.organisation,
      placeholder: u.formatMessage({
        id: "signup_organization_placeholder"
      }),
      functions: {
        onChange: () => {
          d(a.organisation, "organisation");
        }
      },
      validation: [{ condition: "required" }],
      autoComplete: "organization",
      "data-testid": "signup-org-input"
    }
  ), e.url && f.push({
    id: "url",
    type: "text",
    label: u.formatMessage(
      { id: "signup_url" },
      {
        small: (p) => /* @__PURE__ */ h.jsx("small", { children: p })
      }
    ),
    placeholder: u.formatMessage({ id: "signup_url_placeholder" }),
    validation: [{ condition: "valid-url" }],
    "data-testid": "signup-url-input"
  })), e.expectation && f.push({
    id: "expectation",
    className: "expectation",
    type: "text",
    label: (n == null ? void 0 : n.expectation) || u.formatMessage(
      { id: "signup_expectation" },
      {
        small: (p) => /* @__PURE__ */ h.jsx("small", { className: "notes text-small", children: p })
      }
    ),
    placeholder: (t == null ? void 0 : t.expectation) || u.formatMessage({ id: "signup_expectation_placeholder" }),
    "data-testid": "signup-events-question"
  }), f.push({
    id: "terms",
    className: "text-small",
    type: "checkbox",
    inputRef: a.tc,
    label: u.formatMessage(
      { id: "signup_terms" },
      {
        terms: (p) => /* @__PURE__ */ h.jsx(
          "a",
          {
            href: "https://about.apolitical.co/terms-and-conditions",
            "data-gtm-event-context": "SignupForm",
            "data-gtm-event-type": "terms-of-service-click",
            className: "gtm-trackable",
            children: p
          }
        ),
        privacy: (p) => /* @__PURE__ */ h.jsx(
          "a",
          {
            href: "https://about.apolitical.co/privacy-policy",
            "data-gtm-event-context": "SignupForm",
            "data-gtm-event-type": "privacy-policy-click",
            className: "gtm-trackable",
            children: p
          }
        )
      }
    ),
    shownValue: "accepted",
    functions: {
      onChange: (p) => {
        if (!p)
          return;
        const g = [];
        ["name", "email"].forEach((m) => {
          s.validFields[m] !== a[m].current.validity.valid && (g.push({
            type: `validFields.${m}`,
            value: a[m].current.validity.valid
          }), m === "email" && o9({ ref: a.email, validateEmail: r, dispatch: o }));
        }), g.length && o(g);
      }
    },
    validation: [{ condition: "required" }],
    "data-testid": "signup-terms-checkbox"
  }), f;
};
const TR = ({ className: e = "" }) => /* @__PURE__ */ h.jsxs(
  "div",
  {
    className: te("success-message", e),
    "data-testid": "success-message",
    children: [
      /* @__PURE__ */ h.jsx("p", { className: "success-title", children: /* @__PURE__ */ h.jsx(en, { id: "signup_success_title" }) }),
      /* @__PURE__ */ h.jsx(
        en,
        {
          id: "signup_success_text",
          values: {
            p: (t) => /* @__PURE__ */ h.jsx("p", { children: t })
          }
        }
      )
    ]
  }
);
const _R = {
  validFields: {
    name: !1,
    email: !1,
    jobTitle: !1,
    organisation: !1
  },
  emailDetails: { email: "", boxType: "", isEnd2End: !1 },
  shouldManuallyApprove: !1,
  shouldDisableButton: !0,
  loadRecaptcha: !1,
  showSuccessMessage: !1,
  showError: !1
}, aae = ({
  className: e = "",
  labels: t = {},
  placeholders: n = {},
  functions: r = {
    validateEmail: () => Promise.resolve(),
    createAccount: () => Promise.resolve(),
    handleError: () => {
    },
    resendVerificationCode: () => Promise.resolve()
  },
  shouldShow: i = {},
  submitButton: a,
  dataToSubmit: s = { ref: "sign-up-form" },
  ...o
}) => {
  const l = ye(), u = window.location.pathname.includes("/signup") ? "/login" : `/login?returnTo=${window.location.pathname + window.location.search}`, {
    title: c = !0,
    expectation: d = !1,
    url: f = !0,
    logInButton: p = !0,
    successMessage: g = !0
  } = i, m = {
    title: c,
    expectation: d,
    url: f,
    logInButton: p,
    successMessage: g
  }, [y, v] = ra(Nl, _R), {
    validFields: E,
    emailDetails: b,
    shouldManuallyApprove: _,
    shouldDisableButton: T,
    showSuccessMessage: x,
    showError: A
  } = y, [R, P] = jE([
    "signup-this-session",
    "functional-cookie-consent"
  ]), L = {
    form: M.createRef(),
    name: M.createRef(),
    email: M.createRef(),
    jobTitle: M.createRef(),
    organisation: M.createRef(),
    tc: M.createRef(),
    hiddenValidation: M.createRef()
  };
  pe(() => {
    _ === !0 && L.jobTitle.current && L.jobTitle.current.focus();
  }, [_]), pe(() => {
    R["signup-this-session"] && v([{ type: "showSuccessMessage", value: !0 }]);
  }, [R]), pe(() => {
    x && R["functional-cookie-consent"] && P("signup-this-session", "true", {
      path: "/",
      maxAge: 3600
    });
  }, [x]);
  const I = Vn(() => bR({
    placeholders: n,
    labels: t,
    shouldShow: m,
    functions: r,
    refs: L,
    state: y,
    dispatch: v,
    dataToSubmit: s,
    intl: l
  }), [s, r, l, L, m, y]), O = T ? !0 : _ ? !Object.values(E).every((S) => S === !0) : !E.name || !E.email || ["exists", "pending", "verify"].includes(b.boxType);
  return m.successMessage && x ? /* @__PURE__ */ h.jsx(TR, { className: e }) : /* @__PURE__ */ h.jsxs(
    "fieldset",
    {
      className: te("signup-form-fieldset", e),
      "data-testid": "signup-form",
      children: [
        m.title && /* @__PURE__ */ h.jsx("p", { className: "signup-title", children: /* @__PURE__ */ h.jsx(en, { id: "signup_title" }) }),
        A && /* @__PURE__ */ h.jsx(
          Ci,
          {
            variant: "error",
            text: l.formatMessage({ id: "signup_error" })
          }
        ),
        /* @__PURE__ */ h.jsx(
          ti,
          {
            className: "signup-form",
            formRef: L.form,
            id: "sign-up-form",
            fields: I,
            intlPath: "signup",
            button: {
              variant: "primary",
              size: "medium",
              text: a || l.formatMessage({ id: "signup_button_join" }),
              disabled: O ? { isClickable: !0 } : !1,
              styling: { fullWidth: !0 },
              "data-testid": "signup-button"
            },
            secondaryActionButton: {
              className: "login-button",
              styling: { fullWidth: !0 },
              variant: "tertiary",
              size: "medium",
              href: u,
              "data-gtm-event-context": "SignupForm",
              "data-gtm-event-type": "login-click",
              text: l.formatMessage({ id: "signup_button_login" })
            },
            meta: {
              shouldReset: !1,
              showRequiredLabels: !1,
              shouldShowCancelButton: m.logInButton
            },
            gtm: {
              context: "SignupForm",
              event: "signup-submit-click"
            },
            functions: {
              onSuccess: async () => {
                await ER({
                  refs: L,
                  dataToSubmit: s,
                  createAccount: r.createAccount,
                  onSuccess: r.onSuccess,
                  dispatch: v,
                  state: y
                });
              },
              onCatch: (S) => {
                r.handleError(S), v([
                  { type: "showSuccessMessage", value: !1 },
                  { type: "showError", value: !0 }
                ]);
              }
            }
          }
        ),
        /* @__PURE__ */ h.jsx("button", { className: "validation-button", ref: L.hiddenValidation })
      ]
    }
  );
};
function CR({
  parentId: e,
  isMember: t,
  formFunctions: n,
  leave: r,
  join: i,
  meta: a
}) {
  const s = ye();
  return /* @__PURE__ */ h.jsx(
    QC,
    {
      form: {
        content: { type: et.Reply, slugs: {} },
        functions: n,
        meta: {
          isEditing: !1,
          isAutoFocused: !1,
          isPrepopulated: !1,
          showSuccessMessage: !1,
          ...a
        },
        placeholder: s.formatMessage({ id: "discussion_responses_placeholder" })
      },
      parentId: e,
      membershipRequiredToPost: {
        isMember: t,
        required: !0,
        join: i,
        leave: r,
        notMemberStateText: s.formatMessage({ id: "community_joinToPost" })
      }
    }
  );
}
function xR({
  hasNextPage: e,
  fetchNextPage: t,
  setFocusReplyIndex: n,
  totalReplies: r
}) {
  const i = ye(), a = () => {
    n(r), t();
  };
  return /* @__PURE__ */ h.jsx(
    c1,
    {
      hasNextPage: e,
      loadNextPage: a,
      icon: { icon: "arrow-down", position: "right" },
      messages: {
        button: i.formatMessage({ id: "loadMore_button" }),
        error: i.formatMessage({ id: "loadMore_error" })
      }
    }
  );
}
function wR({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  queryClient: r,
  queryKey: i,
  user: a
}) {
  const { mutate: s } = Ut({
    mutationFn: e,
    onMutate: (o) => t((l) => {
      const u = rg({ reply: a6(o), user: a });
      return Ls(u, l, {
        replace: !1,
        append: (o == null ? void 0 : o.replyId) !== void 0
      });
    }),
    onError: n,
    onSuccess: (o, l, u) => {
      const c = rg({ reply: o, user: a });
      r.setQueryData(
        i,
        Ls(c, u, { replace: !0, append: (l == null ? void 0 : l.replyId) !== void 0 })
      ), setTimeout(() => {
        Ap(c.id, "reply");
      }, 0);
    }
  });
  return s;
}
function AR({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n }
}) {
  const { mutate: r } = Ut({
    mutationFn: e,
    onMutate: ({ replyId: i, content: a }) => t((s) => {
      const o = Mn(i, s);
      return o && (o.data.content = a), s;
    }),
    onError: n
  });
  return r;
}
function SR({
  replies: e,
  user: t,
  replyType: n
}) {
  return !e || !(t != null && t.id) ? [] : e.map(
    ({
      id: r,
      own_children: i,
      latest_children: a,
      children_counts: s,
      data: o,
      created_at: l,
      parent: u,
      ...c
    }) => {
      var y, v, E, b;
      const d = (((y = i == null ? void 0 : i.like) == null ? void 0 : y.length) || 0) > 0, f = (((v = a == null ? void 0 : a.like) == null ? void 0 : v.length) || 0) > 0, p = d ? (E = i == null ? void 0 : i.like) == null ? void 0 : E.find((_) => {
        var T;
        return ((T = _ == null ? void 0 : _.user) == null ? void 0 : T.id) === (t == null ? void 0 : t.id);
      }) : !1, g = typeof p == "object" ? (p == null ? void 0 : p.id) ?? "" : "", m = f ? (b = a == null ? void 0 : a.like) == null ? void 0 : b.map((_) => {
        var T, x, A;
        return {
          id: (T = _ == null ? void 0 : _.user) == null ? void 0 : T.id,
          name: (A = (x = _ == null ? void 0 : _.user) == null ? void 0 : x.data) == null ? void 0 : A.name
        };
      }) : !1;
      return {
        user: c == null ? void 0 : c.user,
        body: n === Kt.Courses ? l6({
          content: o.content
        }) : DR(o),
        locale: o == null ? void 0 : o.locale,
        createdAt: l,
        data: kR(o),
        likeId: g,
        liked: f,
        likes: (s == null ? void 0 : s.like) || 0,
        peopleWhoLiked: m,
        replyId: r,
        parent: u,
        userLiked: !!p
      };
    }
  );
}
function kR(e) {
  if (!e || !e.mentioned_users)
    return {};
  const t = e == null ? void 0 : e.mentioned_users, n = (e == null ? void 0 : e.additional_data) || {};
  return {
    mentions: t,
    ...n
  };
}
function DR(e) {
  var t;
  return e ? typeof e.content == "string" ? e.content : ((t = e == null ? void 0 : e.content) == null ? void 0 : t.text) || "" : "";
}
function cT({
  queryFns: { create: e, edit: t, like: n, list: r, remove: i, unlike: a },
  queryKey: s,
  type: o = Kt.Communities
}) {
  const l = up(), u = gp(), c = { queryClient: l, queryKey: s }, d = {
    mutationHandlers: {
      error: _p(c),
      mutate: Cp(c)
    },
    user: u,
    ...c
  }, f = wR({ ...d, mutationFn: e }), p = AR({ ...d, mutationFn: t }), g = OR({ ...d, mutationFn: n }), m = IR({ ...d, mutationFn: i }), y = PR({ ...d, mutationFn: a }), { replies: v, ...E } = NR({ queryKey: s, queryFn: r });
  return {
    replies: SR({ replies: v, user: u, replyType: o }),
    mutations: {
      create: f,
      edit: p,
      remove: m,
      like: g,
      unlike: y
    },
    user: u,
    ...E
  };
}
function OR({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  queryClient: r,
  queryKey: i
}) {
  const { mutate: a } = Ut({
    mutationFn: e,
    onMutate: ({ replyId: s }) => t((o) => {
      const l = Mn(s, o);
      return l && ig({ reply: l }), o;
    }),
    onError: n,
    onSuccess: (s, { replyId: o }, l) => {
      const u = Mn(o, l);
      u && ig({ reply: u, reaction: s }), r.setQueryData(i, l);
    }
  });
  return a;
}
function NR({ queryFn: e, queryKey: t }) {
  const { data: n, error: r, isLoading: i, hasNextPage: a, fetchNextPage: s } = cp({
    queryKey: t,
    queryFn: e,
    initialPageParam: { next: "" },
    getNextPageParam: (o) => (o == null ? void 0 : o.next) || null
  });
  return {
    replies: wp(n),
    error: r,
    isLoading: i,
    hasNextPage: a,
    fetchNextPage: s
  };
}
function IR({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n }
}) {
  const { mutate: r } = Ut({
    mutationFn: e,
    onMutate: ({ replyId: i }) => t((a) => O4(i, a)),
    onError: n
  });
  return r;
}
function PR({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  user: r
}) {
  const { mutate: i } = Ut({
    mutationFn: e,
    onMutate: ({ replyId: a }) => t((s) => {
      const o = Mn(a, s);
      return o && s6({ reply: o, user: r }), s;
    }),
    onError: n
  });
  return i;
}
const RR = ({
  activityId: e,
  basePath: t,
  isMember: n,
  parentId: r,
  replyId: i,
  functions: { reactions: a, form: s, likes: o },
  type: l = Kt.Communities
}) => {
  const u = ye(), c = 3, {
    replies: d,
    fetchNextPage: f,
    hasNextPage: p,
    isLoading: g,
    mutations: { create: m, edit: y, like: v, remove: E, unlike: b }
  } = cT({
    queryKey: [t, r, e, i, "replies"],
    queryFns: {
      ...a,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      list: (x) => a.list({ ...x, reactionId: i })
    },
    type: l
  });
  VE([g]);
  const [_, T] = de(!0);
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    (d == null ? void 0 : d.length) >= c && /* @__PURE__ */ h.jsx(
      je,
      {
        className: "nested-replies-show-toggle",
        variant: "secondary",
        size: "small",
        styling: { muted: !0 },
        icon: {
          icon: `arrow_corner-${_ ? "up_left" : "down_right"}`,
          position: "left"
        },
        onClick: () => T(!_),
        children: u.formatMessage(
          {
            id: `discussion_thread_${_ ? "hide" : "show"}`
          },
          { count: d == null ? void 0 : d.length }
        )
      }
    ),
    _ && /* @__PURE__ */ h.jsx(
      Yre,
      {
        loadMore: { isLoading: g, hasNextPage: p, loadNextPage: () => f() },
        form: {
          parentId: r,
          content: {
            type: et.Reply,
            slugs: {
              question: `${t}/${r}`,
              answer: e,
              reply: i
            }
          },
          functions: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            create: (x, { body: A }) => m({ activityId: e, replyId: i, content: A }),
            ...s
          },
          meta: {
            isEditing: !1,
            isAutoFocused: !0,
            isPrepopulated: !1,
            showSuccessMessage: !1
          }
        },
        children: d && d.length > 0 ? d == null ? void 0 : d.map(
          ({
            replyId: x,
            likes: A,
            data: R,
            body: P,
            createdAt: L,
            userLiked: I,
            peopleWhoLiked: O,
            parent: S,
            user: F,
            likeId: H
          }) => /* @__PURE__ */ h.jsx(
            H1,
            {
              isCommunity: !0,
              content: {
                id: x,
                type: et.Reply,
                body: P,
                createdAt: L,
                slugs: {
                  question: `${t}/${r}`,
                  answer: e,
                  // Stop-gap solution to avoid having to change the DiscussionPost component
                  // The `reply` is currently used to define the form ID which handles the focus
                  reply: S
                },
                slug: "",
                author: Fl(F),
                userLiked: I,
                likes: A,
                peopleWhoLiked: l === Kt.Courses ? !1 : O,
                data: R
              },
              forceHide: { shareLink: l === Kt.Courses },
              userHasPermissions: n,
              functions: {
                content: {
                  createContent: () => null,
                  deleteContent: () => E({ replyId: x }),
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  updateContent: (q, { body: N }) => y({ replyId: x, content: N })
                },
                likes: {
                  createLike: () => v({ replyId: x }),
                  deleteLike: () => b({ replyId: x, reactionId: H }),
                  listLikes: (q) => o.list({ replyId: x, ...q })
                },
                comments: {},
                form: s
              },
              styling: { showShareLinkButton: !0 },
              badges: {
                showBadges: !0,
                scopes: [
                  {
                    scope: Cn.Communities,
                    area: r || ""
                  },
                  {
                    scope: Cn.Platform,
                    area: "all"
                  }
                ]
              },
              disableMentions: l === Kt.Courses,
              basePath: t,
              parentId: r
            },
            x
          )
        ) : null
      }
    )
  ] });
};
function FR({
  formFns: e,
  activityId: t,
  basePath: n,
  focus: r,
  isMember: i,
  parentId: a,
  reply: s,
  type: o = Kt.Communities
}) {
  const {
    body: l,
    data: u,
    likeId: c,
    likes: d,
    peopleWhoLiked: f,
    replyId: p,
    createdAt: g,
    user: m,
    userLiked: y
  } = s, { edit: v, like: E, remove: b, unlike: _ } = e.mutations;
  return /* @__PURE__ */ h.jsx(Rre, { children: /* @__PURE__ */ h.jsx(
    H1,
    {
      isCommunity: !0,
      content: {
        id: p,
        type: et.Reply,
        body: l,
        createdAt: g,
        slugs: {
          question: `${n}/${a}`,
          answer: t,
          reply: p
        },
        slug: p,
        author: Fl(m),
        userLiked: y,
        likes: d,
        peopleWhoLiked: o === Kt.Courses ? !1 : f,
        data: u
      },
      userHasPermissions: i,
      functions: {
        content: {
          createContent: () => null,
          deleteContent: () => b({ replyId: p }),
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          updateContent: (T, { body: x }) => v({ replyId: p, content: x })
        },
        likes: {
          createLike: () => E({ replyId: p }),
          deleteLike: () => _({ replyId: p, reactionId: c }),
          listLikes: (T) => e.likes.list({ replyId: p, ...T })
        },
        comments: {},
        form: e.form
      },
      forceHide: { shareLink: o === Kt.Courses },
      badges: {
        showBadges: !0,
        scopes: [
          {
            scope: Cn.Communities,
            area: a || ""
          },
          {
            scope: Cn.Platform,
            area: "all"
          }
        ]
      },
      disableMentions: o === Kt.Courses,
      children: /* @__PURE__ */ h.jsx(
        RR,
        {
          basePath: n,
          parentId: a,
          activityId: t,
          replyId: p,
          isMember: i,
          functions: e,
          type: o
        }
      ),
      styling: { showShareLinkButton: !0 },
      setFocus: r,
      basePath: n,
      parentId: a
    },
    p
  ) }, p);
}
const mu = "ALL", BR = ({
  activityId: e,
  basePath: t,
  parentId: n,
  activityTotalReplies: r,
  isMember: i,
  functions: { form: a, join: s, leave: o, likes: l, reactions: u },
  profile: c,
  showReplies: d,
  type: f = Kt.Communities,
  repliesFilters: p
}) => {
  const g = ye(), m = We(zt), {
    fetchNextPage: y,
    hasNextPage: v,
    isLoading: E,
    replies: b,
    mutations: { create: _, remove: T, edit: x, like: A, unlike: R }
  } = cT({
    queryKey: [t, n, e, "replies"],
    queryFns: u,
    type: f
  }), [P, L] = de(
    f === Kt.Courses && m.locale || mu
  ), [I, O] = de([]), S = Vn(() => b, [JSON.stringify(b)]);
  pe(() => {
    if (!S)
      return;
    const N = !P || P === mu || f !== Kt.Courses ? S : S.filter((Q) => Q.locale === P);
    O(N);
  }, [S, P]);
  const [F, H] = de(null);
  VE([E]), N4();
  const q = {
    create: (N, Q) => {
      const { body: J } = Q;
      _({ activityId: e, content: J });
    },
    ...a
  };
  return /* @__PURE__ */ h.jsxs("section", { className: "replies-feed", children: [
    /* @__PURE__ */ h.jsx(
      Gre,
      {
        type: "comment",
        responses: r,
        isLoading: E
      }
    ),
    d ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx(
        CR,
        {
          parentId: n,
          isMember: i,
          join: s,
          leave: o,
          formFunctions: q,
          meta: { isAutoFocused: f === Kt.Courses || !1 }
        }
      ),
      f === Kt.Courses && (p == null ? void 0 : p.isEnabled) && /* @__PURE__ */ h.jsxs(
        "section",
        {
          className: "replies-feed-language-switcher",
          style: { display: "flex" },
          children: [
            /* @__PURE__ */ h.jsx(
              ti,
              {
                id: "replies-feed-language-switcher",
                fields: [
                  {
                    id: "language",
                    label: !1,
                    type: "select",
                    initialValue: P,
                    options: [
                      {
                        id: mu,
                        label: g.formatMessage({
                          id: "activitySection_language_switcher_all_languages_option"
                        })
                      },
                      ...(p == null ? void 0 : p.options) || []
                    ],
                    functions: {
                      onChange: (N) => L(N)
                    }
                  }
                ],
                functions: {},
                button: {
                  hideButton: !0
                }
              }
            ),
            /* @__PURE__ */ h.jsx(
              je,
              {
                icon: "info-inside-circle",
                variant: "tertiary",
                className: "language-switcher-info-button",
                tooltip: g.formatMessage({
                  id: "activitySection_language_switcher_info"
                }),
                forceTooltip: !0,
                children: /* @__PURE__ */ h.jsx(ht, { children: g.formatMessage({
                  id: "activitySection_language_switcher_info"
                }) })
              }
            )
          ]
        }
      ),
      I == null ? void 0 : I.map((N, Q) => /* @__PURE__ */ h.jsx(
        FR,
        {
          activityId: e,
          basePath: t,
          focus: F === Q,
          formFns: {
            form: a,
            likes: l,
            reactions: u,
            mutations: { remove: T, edit: x, like: A, unlike: R }
          },
          isMember: i,
          parentId: n,
          reply: N,
          type: f
        },
        N.replyId
      )),
      E ? /* @__PURE__ */ h.jsx(h.Fragment, { children: " " }) : /* @__PURE__ */ h.jsx(
        xR,
        {
          hasNextPage: v,
          fetchNextPage: y,
          setFocusReplyIndex: H,
          totalReplies: b.length
        }
      )
    ] }) : /* @__PURE__ */ h.jsx(ur, { children: /* @__PURE__ */ h.jsx(en, { id: "replies_feed_missing_polls_vote_message" }) }),
    /* @__PURE__ */ h.jsx(XC, { form: c })
  ] });
};
function MR({ queryFn: e, queryKey: t }) {
  const { data: n, error: r, isLoading: i, hasNextPage: a, fetchNextPage: s, refetch: o } = cp({
    queryKey: t,
    queryFn: e,
    initialPageParam: { next: "" },
    getNextPageParam: (c) => (c == null ? void 0 : c.next) || null
  }), l = wp(n), u = `${l.length || 0}${a ? "+" : ""}`;
  return {
    likes: l,
    likesCount: u,
    error: r,
    isLoading: i,
    hasNextPage: a,
    fetchNextPage: s,
    refetch: o
  };
}
function LR({ queryFns: { list: e }, queryKey: t }) {
  const { likes: n, ...r } = MR({ queryKey: t, queryFn: e });
  return {
    likes: n,
    ...r
  };
}
function $R({
  basePath: e,
  parentId: t,
  activityId: n,
  likeCount: r,
  functions: i
}) {
  const { likes: a, fetchNextPage: s, hasNextPage: o, refetch: l } = LR({
    queryKey: [e, t, n, "likes"],
    queryFns: i.likes
  });
  pe(() => {
    l();
  }, [l]);
  const u = a.map(({ user: c }) => c).map((c) => c ? Fl(c) : void 0).filter((c) => c && typeof c != "string");
  return /* @__PURE__ */ h.jsx("section", { className: "likes-feed", children: /* @__PURE__ */ h.jsx(
    wre,
    {
      members: {
        data: u,
        total: r
      },
      showHeader: !1,
      showPlaceholders: !0,
      communitySlug: t,
      hasNextPage: o && u.length < r,
      loadNextPage: s
    }
  ) });
}
const jR = ({
  showModal: e = !0,
  functions: { onClose: t, likes: n },
  likeCount: r,
  className: i,
  ...a
}) => {
  const s = ye();
  return /* @__PURE__ */ h.jsx(
    sa,
    {
      id: "likes-modal",
      title: s.formatMessage({ id: "discussion_likes" }, { number: r }),
      isOpen: e,
      functions: {
        onClose: t
      },
      className: te("profile-modal in-portal", i, {
        open: e
      }),
      maxWidth: 600,
      children: /* @__PURE__ */ h.jsx(
        $R,
        {
          ...a,
          likeCount: r ?? 0,
          functions: {
            likes: n
          }
        }
      )
    }
  );
}, HR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jR
}, Symbol.toStringTag, { value: "Module" })), sae = {
  results: [
    {
      created_at: "2024-05-16T13:17:45.940899Z",
      updated_at: "2024-05-16T13:17:45.940899Z",
      id: "ab4b7ab0-f4fe-469f-a8e7-5a52b3e55333",
      user_id: "9ed21585-63be-4446-96ce-3e703820eb73",
      user: {
        id: "1234",
        data: {
          name: "Han Solo",
          thumbnail: "https://placehold.co/400x400",
          jobTitle: "Smuggler",
          organization: "Rebel Alliance",
          badges: {
            communities: {
              "endor-alumni": ["blue-badge"]
            }
          }
        }
      },
      kind: "like",
      activity_id: "869e5a90-0eba-11ef-8080-80017b714aaf",
      data: {
        mentioned_users: null
      },
      parent: "",
      latest_children: {},
      children_counts: {}
    },
    {
      created_at: "2024-05-16T13:17:45.940899Z",
      updated_at: "2024-05-16T13:17:45.940899Z",
      id: "db4b7ab0-f4fe-469f-a8e7-5a52b3e55373",
      user_id: "9ed21585-63be-4446-96ce-3e703820eb73",
      user: {
        created_at: "2023-08-22T11:56:10.585365Z",
        updated_at: "2024-03-13T11:31:49.447916Z",
        id: "9ed21585-63be-4446-96ce-3e703820eb73",
        data: {
          jobTitle: "Admiral",
          name: "Princess Leia",
          organization: "Rebela Alliance",
          thumbnail: "https://placehold.co/400x400",
          badges: {
            platform: {
              all: ["orange-badge"]
            }
          }
        }
      },
      kind: "pin",
      activity_id: "769e5a90-0eba-11ef-8080-80017b714aaf",
      data: {
        mentioned_users: null
      },
      parent: "",
      latest_children: {},
      children_counts: {}
    }
  ],
  next: "xy12345"
};
const UR = 3e3, zR = ({
  url: e,
  gtm: t = { context: "ShareLink", event: "copy-link-click" }
}) => {
  const n = ye(), r = "discussion_share_copy_link", [i, a] = de({
    isOpen: !1,
    isCopied: !1
  });
  return /* @__PURE__ */ h.jsxs("li", { className: "share-link-wrapper", children: [
    /* @__PURE__ */ h.jsx(
      Uo,
      {
        className: "gtm-trackable",
        icon: { icon: "link_chain" },
        onMouseOver: () => a({ ...i, isOpen: !0 }),
        onFocus: () => a({ ...i, isOpen: !0 }),
        onMouseOut: () => a({ isOpen: !1, isCopied: !1 }),
        onBlur: () => a({ isOpen: !1, isCopied: !1 }),
        onClick: () => {
          navigator.clipboard.writeText(e).then(() => {
            a({ isOpen: !0, isCopied: !0 });
            const s = new CustomEvent("ariaLive", {
              detail: {
                message: n.formatMessage({ id: `${r}_success` })
              }
            });
            document.dispatchEvent(s), setTimeout(() => {
              a({ isOpen: !1, isCopied: !1 });
            }, UR);
          });
        },
        "data-gtm-event-context": t.context,
        "data-gtm-event-type": t.event,
        "data-testid": "share-link",
        screenreaderText: n.formatMessage({
          id: r
        })
      }
    ),
    /* @__PURE__ */ h.jsx(
      Ys,
      {
        className: te({
          copied: i.isCopied
        }),
        isOpen: i.isOpen,
        styling: { hasPointer: "bottom", extraPadding: !1 },
        children: n.formatMessage({
          id: `${r}${i.isCopied ? "_success" : ""}`
        })
      }
    )
  ] });
};
const pa = "discussion_", qR = ({
  className: e,
  gtmContext: t,
  contentType: n,
  likes: r,
  comments: i,
  replies: a,
  edit: s,
  shareLink: o,
  moreMenu: l
}) => {
  const u = ye(), c = [];
  return l && l.reportData && c.push({
    text: u.formatMessage({ id: `${pa}moreMenu_report` }),
    onClick: (d) => {
      d.stopPropagation();
    },
    href: `mailto:community@apolitical.co?subject=${encodeURI(
      u.formatMessage({ id: `${pa}report_subject` })
    )}&body=${encodeURI(
      u.formatMessage(
        { id: `${pa}report_body` },
        {
          contentType: n || "",
          contentSlug: l && l.reportData && l.contentSlug || "",
          contentUrl: l && l.reportData && l.reportData.contentUrl || ""
        }
      )
    )}`,
    icon: "flag"
  }), /* @__PURE__ */ h.jsxs(
    "ul",
    {
      className: te("actions text-medium", e),
      "data-testid": `${n}-actions`,
      children: [
        r ? /* @__PURE__ */ h.jsx(
          v6,
          {
            element: "li",
            likes: r.count,
            isShort: !1,
            userLiked: r.userLiked,
            content: {
              type: n,
              slugs: r.content.slugs,
              slug: r.content.slug
            },
            canLike: r.canLike,
            peopleWhoLiked: r.peopleWhoLiked,
            activityId: r.activityId,
            functions: r.functions,
            basePath: r.basePath || "",
            parentId: r.parentId || ""
          }
        ) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
        i ? /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx(
          Uo,
          {
            shortText: `${i.count ?? 0}`,
            onClick: (d) => {
              d.preventDefault(), d.stopPropagation(), i.functions.onClick();
            },
            icon: { icon: "speech-bubble_square" },
            "data-testid": "comment",
            "data-gtm-event-context": t,
            "data-gtm-event-type": `answer-${n}-click`,
            screenreaderText: u.formatMessage(
              { id: `${pa}comments_screenReader` },
              { count: i.count }
            ),
            children: u.formatMessage(
              {
                id: `${pa}comments${i.count === null ? "_loading" : ""}`
              },
              { count: i.count }
            )
          }
        ) }) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
        a ? /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx(
          Uo,
          {
            styling: { muted: !0 },
            onClick: a.functions.onClick,
            icon: { icon: "speech-bubble_square" },
            "data-testid": "reply",
            disabled: !a.canReply,
            children: u.formatMessage({ id: `${pa}reply` })
          }
        ) }) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
        s ? /* @__PURE__ */ h.jsx("li", { className: "edit-button-item", children: /* @__PURE__ */ h.jsx(
          Uo,
          {
            styling: { muted: !0 },
            onClick: s.onClick,
            icon: { icon: "pencil-paper" },
            "data-testid": "edit",
            children: u.formatMessage({ id: `${pa}action_edit` })
          }
        ) }) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
        o ? /* @__PURE__ */ h.jsx(
          zR,
          {
            url: o.url,
            gtm: {
              context: t || "",
              event: `copy-link-${n}-click`
            }
          }
        ) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
        l ? /* @__PURE__ */ h.jsx(
          Ph,
          {
            element: "li",
            id: `more-${l.contentSlug}`,
            options: [...l.options || [], ...c]
          }
        ) : /* @__PURE__ */ h.jsx(h.Fragment, {})
      ]
    }
  );
};
const oae = ({ breadcrumbs: e, cutoff: t = 20, className: n = "" }) => {
  const r = ye();
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(
      ht,
      {
        element: "p",
        children: r.formatMessage({ id: "breadcrumbs_label" })
      }
    ),
    /* @__PURE__ */ h.jsx("ul", { className: te("breadcrumbs text-small", n), children: e.map(
      ({ text: i, href: a, current: s = !1 }, o) => {
        const l = {};
        return s && (l["aria-current"] = "location"), /* @__PURE__ */ h.jsxs("li", { children: [
          s && /* @__PURE__ */ h.jsx(
            ht,
            {
              element: "span",
              children: r.formatMessage({ id: "breadcrumbs_currentPage" })
            }
          ),
          /* @__PURE__ */ h.jsx(qa, { href: s ? void 0 : a, ...l, children: cl(i, t) })
        ] }, `${ia(i)}_${o}`);
      }
    ) })
  ] });
};
const dT = ({
  variant: e = "default",
  data: { image: t, url: n, title: r, description: i },
  onClick: a,
  gtm: s,
  ...o
}) => {
  if (!n)
    return /* @__PURE__ */ h.jsx(h.Fragment, {});
  let l = n.split("//");
  l.length > 1 ? l = l[1] : l = l[0], l = l.split("/"), l = l[0];
  const { context: u = "EnrichedLink", event: c = "enriched-link-click" } = s ?? {};
  return /* @__PURE__ */ h.jsxs(
    "aside",
    {
      className: te("enriched-url gtm-trackable", {
        "has-image": t,
        [e]: e !== "default"
      }),
      onClick: (d) => {
        if (d.preventDefault(), d.stopPropagation(), a) {
          a(d);
          return;
        }
        window.open(n, "_blank");
      },
      "data-gtm-event-context": u,
      "data-gtm-event-type": c,
      children: [
        /* @__PURE__ */ h.jsx("small", { children: l }),
        /* @__PURE__ */ h.jsx("p", { className: "title text-medium", children: /* @__PURE__ */ h.jsx("a", { ...o, href: n, target: "_blank", rel: "noreferrer", children: r }) }),
        i && e !== "condensed" ? /* @__PURE__ */ h.jsx("p", { className: "text-small", children: i }) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
        t && t.src ? /* @__PURE__ */ h.jsx("p", { className: "img", children: /* @__PURE__ */ h.jsx(
          "img",
          {
            src: t.src,
            alt: t.alt || "",
            loading: "lazy",
            fetchpriority: "low",
            width: t.width || "auto",
            height: t.height || "100%"
          }
        ) }) : /* @__PURE__ */ h.jsx(h.Fragment, {})
      ]
    }
  );
};
const WR = ({
  options: e,
  defaultOptions: t = [],
  allOption: n = !1,
  allowMultiple: r = !0,
  onChange: i = () => {
  },
  preventNoOptionSelected: a = !1,
  className: s = "",
  styling: o,
  gtm: l
}) => {
  const u = ye(), { muted: c, large: d } = o || {}, f = n ? [
    {
      id: "all",
      text: typeof n != "boolean" && n.text || u.formatMessage({ id: "filters_all" })
    },
    ...e
  ] : e, [p, g] = de(
    n ? ["all"] : t.length ? t.map((E) => E.id) : []
  ), [m, y] = de(0), v = (E, b) => {
    let _ = [];
    p.includes(E) && !a ? _ = p.filter((T) => T !== E) : E === "all" ? _ = ["all"] : r ? _ = [...p.filter((T) => T !== "all"), E] : _ = [E], g((T) => (i && typeof i == "function" && i({ current: _, previous: T }), _)), b && typeof b == "function" && b();
  };
  return /* @__PURE__ */ h.jsx("ul", { className: te("filters", s), children: f.map(
    ({ id: E, text: b, disabled: _ = !1, callback: T = () => {
    }, content: x }, A) => {
      let R = {
        tabIndex: m === A ? 0 : -1
      };
      return _ && (R = {
        disabled: !0,
        "aria-label": u.formatMessage(
          { id: "filters_disabled" },
          { name: b }
        )
      }), /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx(
        "button",
        {
          "data-gtm-event-context": (l == null ? void 0 : l.context) || "filters",
          "data-gtm-event-type": (l == null ? void 0 : l.type) || `${b.toLowerCase().replace(" ", "-")}-click`,
          className: te(E, {
            selected: p.includes(E),
            large: d,
            muted: c
          }),
          onClick: (P) => {
            P.preventDefault(), P.stopPropagation(), v(E, T);
          },
          onKeyDown: (P) => {
            var S, F;
            let L = A + 1, I, O;
            switch (P.code) {
              case "Enter":
              case "Space":
                P.preventDefault(), P.stopPropagation(), v(E, T);
                break;
              case "ArrowLeft":
              case "ArrowRight":
                P.preventDefault(), P.stopPropagation(), P.code === "ArrowLeft" ? (L = A - 1, L < 0 && (L = f.length - 1)) : L >= f.length && (L = 0), y(L), I = P.currentTarget.closest("li"), O = (S = I == null ? void 0 : I.parentElement) == null ? void 0 : S.children[L], (F = O == null ? void 0 : O.querySelector("button")) == null || F.focus();
                break;
            }
          },
          "aria-selected": p.includes(E),
          ...R,
          children: x || b
        }
      ) }, E);
    }
  ) });
}, VR = (e, t, n) => {
  const r = String(e);
  if (!n || !n.length)
    return t ? `/${r}/${t}` : `/${r}`;
  let i = "", a = !1;
  return n.forEach(({ url: s, position: o }) => {
    o === "before-lang" ? (i += `/${s}`, a = !0) : (i.includes(`/${r}/`) || (i += `/${r}`), i += `/${s}`);
  }), i.includes(`/${r}/`) || (i += `/${r}`), t && (i += `/${t}`), a ? {
    url: i,
    urlForRouter: `/${i.split("/").slice(2).join("/")}`
  } : i;
};
const gu = "languageSwitcher_", lae = ({
  currentLanguage: e,
  isOriginalLanguage: t = !1,
  isHumanTranslation: n = !1,
  translations: r,
  onChange: i,
  urlParts: a,
  variant: s = "default",
  label: o,
  className: l = ""
}) => {
  const u = ye(), { updateLanguage: c = () => {
  } } = We(r4), [d, f] = de(e);
  if (pe(() => {
    e !== d && f(e);
  }, [e]), !r || !Object.values(r).some(
    (y) => y && y.post_name
  ))
    return null;
  const g = Object.keys(r), m = d !== e;
  return /* @__PURE__ */ h.jsxs("div", { className: te("language-switcher text-small", s, l), children: [
    /* @__PURE__ */ h.jsxs("nav", { children: [
      s !== "short" && /* @__PURE__ */ h.jsx("p", { children: o || u.formatMessage({ id: `${gu}label` }) }),
      /* @__PURE__ */ h.jsx("ul", { children: g.map((y) => {
        var _;
        if (!v3.includes(y))
          return null;
        const v = (_ = r[y]) == null ? void 0 : _.post_name, E = y3.filter((T) => T.value === y)[0].title;
        let b = { className: y };
        if (d === y)
          b["aria-label"] = u.formatMessage(
            { id: `${gu}selected` },
            { language: E }
          );
        else {
          const T = VR(y, v, a);
          b = {
            ...b,
            href: typeof T == "string" ? T : T.url,
            onClick: (x) => {
              f(y), c(y), typeof i < "u" && (x.preventDefault(), x.stopPropagation(), i(
                y,
                typeof T == "string" ? T : T.urlForRouter
              ));
            }
          };
        }
        return /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx(qa, { ...b, fallbackElement: "span", children: E }) }, y);
      }) }),
      s !== "short" && !m && /* @__PURE__ */ h.jsx("p", { children: u.formatMessage({
        id: `${gu}translation_${t ? "original" : n ? "human" : "machine"}`
      }) })
    ] }),
    s !== "short" && !m && !t && !n && /* @__PURE__ */ h.jsx("small", {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // `values` are throwing a type error: https://github.com/formatjs/formatjs/issues/3633
      children: u.formatMessage(
        { id: `${gu}disclaimer` },
        {
          email: Io.support,
          link: (y) => {
            const v = `mailto:${y}`;
            return /* @__PURE__ */ h.jsx("a", { href: v, children: y });
          }
        }
      )
    })
  ] });
};
const Fd = u3({ locale: "en", messages: hn }), c1 = ({
  hasNextPage: e = !0,
  loadNextPage: t = () => {
  },
  isLoading: n = !1,
  variant: r = "secondary",
  size: i = "medium",
  styling: a = { muted: !1, fullWidth: !1 },
  icon: s = !1,
  messages: o = {
    button: Fd.formatMessage({ id: "loadMore_button" }),
    endOfFeed: Fd.formatMessage({ id: "loadMore_endOfFeed" }),
    error: Fd.formatMessage({ id: "loadMore_error" })
  },
  className: l = "",
  gtmContext: u = "LoadMore"
}) => {
  const [c, d] = de(""), f = async (p) => {
    if (!n)
      try {
        await t(p);
      } catch (g) {
        g instanceof Error ? d(g.message) : d("Unknown error");
      }
  };
  return !c && !e && !o.endOfFeed ? null : /* @__PURE__ */ h.jsx("footer", { className: te("load-more", l), children: !c && e ? /* @__PURE__ */ h.jsx(
    je,
    {
      variant: r,
      size: i,
      styling: a,
      icon: s,
      onClick: f,
      "data-gtm-event-context": u,
      "data-gtm-event-type": "load-more-click",
      disabled: n,
      className: "gtm-trackable",
      "data-testid": "load-more-button",
      children: o.button
    }
  ) : o.endOfFeed && (!c || c != null && c.includes("Cannot read items")) ? /* @__PURE__ */ h.jsx("p", { children: o.endOfFeed }) : c && /* @__PURE__ */ h.jsx("p", { className: "error", children: o.error }) });
};
const fT = ({
  variant: e = "default",
  version: t = "default",
  className: n = "",
  ...r
}) => {
  const i = fp();
  return /* @__PURE__ */ h.jsx("p", { className: "logo-wrapper", children: /* @__PURE__ */ h.jsx(
    "a",
    {
      href: i || "/home/",
      className: te("logo", e, t, n),
      ...r,
      children: /* @__PURE__ */ h.jsx(ht, { children: /* @__PURE__ */ h.jsx(en, { id: "apolitical" }) })
    }
  ) });
};
let vu = !1;
const Ph = ({
  element: e = "div",
  id: t = "more-menu",
  options: n,
  className: r = ""
}) => {
  const i = ye(), a = Ue(
    null
  ), [s, o] = de(!1), l = (u) => {
    a.current && u.target instanceof HTMLElement && !a.current.contains(u.target) && o(!1);
  };
  return pe(() => (document.addEventListener("click", l, !0), () => {
    document.removeEventListener("click", l, !0);
  })), M.createElement(e, {
    ref: a,
    className: te("more-menu text-medium", r),
    children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx(
        je,
        {
          variant: "tertiary",
          size: "medium",
          "data-testid": "more-menu",
          icon: { icon: "ellipsis" },
          onClick: () => o(!s),
          "aria-haspopup": "true",
          "aria-expanded": s,
          "aria-controls": t,
          screenreaderText: i.formatMessage({ id: "moreMenu" }),
          className: "more-menu-button"
        }
      ),
      /* @__PURE__ */ h.jsx("ul", { id: t, hidden: !s, children: n.map(({ href: u, onClick: c, text: d, icon: f, ...p }, g) => {
        const m = {
          ...p,
          onClick: (y) => {
            o(!1), typeof c == "function" && c(y);
          },
          onFocus: () => {
            vu && (clearTimeout(vu), vu = !1);
          },
          onBlur: () => {
            vu = setTimeout(() => {
              o(!1);
            }, 100);
          }
        };
        return u && (m.href = u), /* @__PURE__ */ h.jsx(
          "li",
          {
            className: "more-menu-list-item",
            children: /* @__PURE__ */ h.jsx(
              je,
              {
                variant: "tertiary",
                size: "medium",
                icon: f ? { icon: f, position: "left" } : !1,
                ...m,
                children: d
              }
            )
          },
          `${ia(d)}_${g}`
        );
      }) })
    ] })
  });
}, KR = (e, t = !1) => t ? e.replaceAll("/", "") === t : typeof window < "u" && window.location && window.location.pathname === e;
const GR = Gs(() => Promise.resolve().then(() => Q7)), l9 = [
  {
    key: "homepage",
    href: "/home/"
  },
  {
    key: "events",
    href: "/events/"
  },
  {
    key: "microcourses",
    href: "/microcourses/"
  },
  {
    key: "articles",
    href: "/solution-articles/"
  },
  {
    key: "communities",
    href: "/communities/"
  }
], YR = ({ activeLink: e, profile: t }) => {
  const n = ye(), r = We(zt), i = r && typeof r.id == "string", a = fp();
  return a && (l9[0].href = a), /* @__PURE__ */ h.jsxs("ul", { id: "navigation-menu", className: "text-medium", children: [
    l9.map(({ key: s, href: o }) => {
      const l = KR(o, e), u = {};
      return l && (u["aria-current"] = "page"), /* @__PURE__ */ h.jsx("li", { className: te(s, { active: l }), children: /* @__PURE__ */ h.jsx(
        "a",
        {
          href: o,
          "data-gtm-event-type": `${s}-click`,
          "data-gtm-event-context": "NavigationMenu",
          className: "gtm-trackable",
          ...u,
          children: n.formatMessage({ id: `navigationMenu_links_${s}` })
        }
      ) }, s);
    }),
    i && t && /* @__PURE__ */ h.jsx(
      GR,
      {
        element: "li",
        member: r,
        styling: { variant: "card", isCondensed: !1 },
        functions: { profile: t },
        className: "profile gtm-trackable",
        "data-testid": "profile-link",
        alt: "",
        gtmContext: "NavigationMenu",
        gtmType: "profile-click"
      }
    )
  ] });
}, po = (e, t, n) => `${e}?share=${t}${n ? `&uuid=${n}` : ""}`, ZR = ({
  title: e,
  link: t,
  referrer: n
}) => [
  {
    key: "linkedin",
    icon: "social_linkedin",
    url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
      `${po(t, "linkedin", n)}&src=linkedin`
    )}&title=${encodeURIComponent(e)}&source=Apolitical`
  },
  {
    key: "twitter",
    icon: "social_twitter",
    url: `https://twitter.com/share?ref_src=twsrc%5Etfw&url=${encodeURIComponent(
      `${po(t, "twitter", n)}&src=twitter`
    )}&text=${encodeURIComponent(e)}&via=${encodeURIComponent("apoliticalco")}`
  },
  {
    key: "facebook",
    icon: "social_facebook",
    url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      `${po(t, "facebook", n)}`
    )}&t=${e}`
  },
  {
    key: "email",
    icon: "share_email",
    url: `mailto:?subject=${encodeURIComponent(e)}&body=${encodeURIComponent(
      `${e}

${po(t, "mailto", n)}&src=email`
    )}`
  },
  {
    key: "clipboard-copy",
    icon: "share_copy-link",
    url: po(t, "copy", n),
    shouldRender: () => navigator && navigator.clipboard && navigator.clipboard.writeText,
    onClick: (r, i) => (r.preventDefault(), r.stopPropagation(), navigator.clipboard.writeText(i))
  }
];
const QR = "shareLinks_", uae = ({
  title: e,
  link: t,
  referrer: n,
  gtmContext: r = "ShareLinks",
  size: i = "large",
  variant: a = "default",
  className: s = ""
}) => {
  const o = ye(), l = ZR({ title: e, link: t, referrer: n });
  return /* @__PURE__ */ h.jsxs("aside", { className: te("share-links", i, a, s), children: [
    /* @__PURE__ */ h.jsx("p", { className: "text-small", children: o.formatMessage({ id: "shareLinks_label" }) }),
    /* @__PURE__ */ h.jsx("ul", { children: l.map(({ key: u, icon: c, url: d, shouldRender: f = !0, onClick: p }) => {
      if (typeof f == "function" && !f())
        return null;
      const g = {};
      return p && (g.onClick = (m) => p(m, d)), /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx(
        je,
        {
          size: i,
          variant: "tertiary",
          icon: { icon: c || u },
          href: d,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "gtm-trackable",
          "data-gtm-event-context": `${r}-SocialButtons`,
          "data-gtm-event-type": `${u}-click`,
          "data-testid": "link",
          screenreaderText: o.formatMessage({ id: `${QR}link_${u}` }),
          ...g
        }
      ) }, u);
    }) })
  ] });
};
const cae = ({ tabs: e, className: t = "", preventLocationChange: n }) => {
  var g;
  const r = (m, y, v) => (m || (m = `panel-${ia(y)}-${v}`), m), i = Ua(!0) || 0;
  let a = e.findIndex((m) => m.current === !0);
  if (a < 0 && (a = 0), window.location.hash) {
    const m = window.location.hash.replace("#", "");
    if (e.find((v) => v.id === m)) {
      for (let v = 0; v < e.length; v++)
        if (r(e[v].id, e[v].text, v) === m) {
          a = v;
          break;
        }
    }
  }
  const [s, o] = de(
    (g = e[a]) != null && g.id ? e[a].id : r(e[a].id, e[a].text, a)
  ), [l, u] = de(""), c = (m, y) => {
    switch (m.key) {
      case "ArrowLeft":
      case "ArrowRight": {
        m.preventDefault();
        let v = y;
        m.key === "ArrowLeft" ? y > 0 ? v = y - 1 : v = e.length - 1 : m.key === "ArrowRight" && (y < e.length - 1 ? v = y + 1 : v = 0);
        const E = r(e[v].id, e[v].text, v), b = document.getElementById(`tab-${E}`);
        b == null || b.focus(), u(E);
        break;
      }
      case "Enter":
        o(l), window.location.hash = `#${l}`;
        break;
    }
  }, d = (m) => {
    let y = !1;
    return m.target === "min-width" && i >= m.value && (y = !0), m.target === "max-width" && i <= m.value && (y = !0), y;
  };
  pe(() => {
    if (e[a].hasCarousel) {
      const m = new CustomEvent("hiddenSectionVisible", {
        detail: { id: s }
      });
      window.dispatchEvent(m);
    }
  }, [s]);
  const f = [], p = [];
  return e.forEach(
    ({ id: m, text: y, content: v, href: E, hasCarousel: b, breakpoint: _ }, T) => {
      if (_ && !d(_))
        return;
      m = r(m, y, T);
      const x = s === m, A = {};
      E || (A["aria-controls"] = m, A.onClick = (R) => {
        R.preventDefault(), R.stopPropagation(), o(m), !n && window.history.replaceState(null, "", `#${m}`);
      }, p.push(
        /* @__PURE__ */ h.jsx(
          "section",
          {
            id: m,
            hidden: !x,
            role: "tabpanel",
            "aria-labelledby": `tab-${m}`,
            "aria-live": x ? "assertive" : "off",
            children: typeof v == "string" ? /* @__PURE__ */ h.jsx("p", { children: v }) : v
          },
          `section-${m}`
        )
      )), f.push(
        /* @__PURE__ */ h.jsx("li", { "data-testid": "navigation-tab", children: /* @__PURE__ */ h.jsx(
          "a",
          {
            href: E || `#${m}`,
            id: `tab-${m}`,
            "aria-controls": m,
            className: te({ selected: x }),
            role: "tab",
            tabIndex: x ? 0 : -1,
            "aria-selected": x,
            onKeyDown: (R) => c(R, T),
            ...A,
            children: y
          }
        ) }, `tab-${m}`)
      );
    }
  ), /* @__PURE__ */ h.jsxs("div", { className: te("tabs-wrapper", t), children: [
    /* @__PURE__ */ h.jsx("ul", { className: "tabs", role: "tablist", children: f }),
    /* @__PURE__ */ h.jsx("div", { className: "tab-content", children: p })
  ] });
};
const XR = {
  "2-1": 901,
  "1-3": 769,
  "1-1": 769
}, JR = ({
  layout: e = "2-1",
  hideOnMobile: t = !1,
  hasCSSContainers: n = !1,
  className: r = "",
  children: i
}) => {
  const a = Ua(!0);
  let s = i;
  return M.Children.count(i) === 1 && (s = M.Children.toArray(i)[0], s.props && (s = s.props.children)), /* @__PURE__ */ h.jsx(
    "section",
    {
      className: te("columns", `layout-${e}`, r, {
        "has-containers": n
      }),
      children: M.Children.map(s, (o, l) => t !== !1 && l === t && a && a < XR[e] ? null : o)
    }
  );
};
const Va = ({
  children: e,
  className: t = "",
  styling: n = {},
  ...r
}) => {
  const { background: i = "default", padding: a = "none" } = n;
  return /* @__PURE__ */ h.jsx(
    "section",
    {
      className: te("full-width-section", t, {
        [i]: i !== "default",
        [a]: a !== "none"
      }),
      ...r,
      children: e
    }
  );
};
const dae = ({ text: e, buttons: t, className: n = "" }) => {
  const r = [];
  return t.forEach((i) => {
    r.push({
      href: i.link,
      variant: "secondary",
      size: { mobile: "medium", 1024: "large" },
      className: "gtm-trackable new",
      "data-gtm-event-type": "download-click",
      "data-gtm-event-context": i.eventContext || "Download",
      target: "_blank",
      children: i.text
    });
  }), /* @__PURE__ */ h.jsx(
    Va,
    {
      className: te("download-section", n),
      styling: { background: "dark" },
      children: /* @__PURE__ */ h.jsxs("div", { className: "content-default", children: [
        M.createElement(
          typeof e == "string" ? "h2" : e.element,
          { className: "text" },
          typeof e == "string" ? e : e.text
        ),
        /* @__PURE__ */ h.jsx(Il, { buttons: r })
      ] })
    }
  );
};
const Rh = "editSection_";
function hT({ href: e, setShowModal: t }) {
  typeof e != "string" && t(!0);
}
const eF = ({
  icon: e,
  description: t,
  ctaMessage: n,
  href: r,
  showEditButton: i,
  setShowModal: a
}) => {
  const { formatMessage: s } = ye();
  return /* @__PURE__ */ h.jsxs(ur, { variant: "muted", icon: e, children: [
    /* @__PURE__ */ h.jsx("p", { children: t || s({ id: `${Rh}placeholder_description` }) }),
    i && /* @__PURE__ */ h.jsx("p", { children: /* @__PURE__ */ h.jsx(
      je,
      {
        href: r,
        variant: "secondary",
        size: "small",
        onClick: () => hT({ href: r, setShowModal: a }),
        children: n || s({ id: `${Rh}placeholder_cta` })
      }
    ) })
  ] });
}, fae = ({
  children: e,
  className: t = "",
  formProps: n,
  formComponent: r,
  href: i,
  title: a,
  showTitle: s = !0,
  modalTitle: o,
  placeholder: l,
  showDivider: u = !0
}) => {
  const { formatMessage: c } = ye(), [d, f] = M.useState(!1), p = () => f(!1), g = !!n || !!r, m = typeof i == "string" || g;
  let y;
  return r && (y = M.cloneElement(r, {
    functions: {
      ...r.props.functions,
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      onSuccess: async (v) => {
        try {
          r.props.functions.onSuccess && await r.props.functions.onSuccess(v);
        } finally {
          p();
        }
      },
      onCancel: () => {
        r.props.functions.onCancel && r.props.functions.onCancel(), p();
      }
    }
  })), /* @__PURE__ */ h.jsxs("section", { className: te("edit-section", t), children: [
    g && /* @__PURE__ */ h.jsx(
      sa,
      {
        title: o || `Edit ${a}`,
        isOpen: d,
        showDivider: !1,
        showIcon: !1,
        functions: { onClose: p },
        className: te("edit-section-modal"),
        children: y || (n ? /* @__PURE__ */ h.jsx(
          ti,
          {
            ...n,
            fields: n.fields,
            meta: {
              ...n == null ? void 0 : n.meta,
              shouldShowCancelButton: !0,
              shouldReset: !1,
              showSuccessMessage: !0
            },
            functions: {
              ...n == null ? void 0 : n.functions,
              onSuccess: async (v) => {
                var E, b;
                (E = n == null ? void 0 : n.functions) != null && E.onSuccess && await ((b = n == null ? void 0 : n.functions) == null ? void 0 : b.onSuccess(v)), f(!1);
              },
              onCancel: p
            }
          }
        ) : /* @__PURE__ */ h.jsx(h.Fragment, {}))
      }
    ),
    /* @__PURE__ */ h.jsxs("div", { className: te("edit-section-header", { "no-title": !s }), children: [
      s && /* @__PURE__ */ h.jsx("h2", { className: "edit-section-header-title", children: a }),
      m && /* @__PURE__ */ h.jsx(
        je,
        {
          href: i,
          variant: "tertiary",
          size: "small",
          icon: "pencil",
          onClick: () => hT({ href: i, setShowModal: f }),
          children: c({ id: `${Rh}edit` })
        }
      )
    ] }),
    e || /* @__PURE__ */ h.jsx(
      eF,
      {
        ...l,
        href: i,
        setShowModal: f,
        showEditButton: m
      }
    ),
    u && /* @__PURE__ */ h.jsx(Zr, {})
  ] });
};
const hae = ({
  title: e = !1,
  text: t,
  logos: n = [],
  styling: r = {},
  className: i = ""
}) => {
  const a = n.length;
  if (a === 0)
    return null;
  const s = {
    element: typeof e == "object" ? e.element : "h2",
    text: typeof e == "string" ? e : typeof e == "object" ? e.text : "",
    className: typeof e == "object" ? e.className : ""
  }, { wrapLogos: o = !1, align: l = "center", display: u = "block" } = r;
  return /* @__PURE__ */ h.jsxs(
    "div",
    {
      className: te("logos", i, `align-${l}`, {
        [u]: u !== "block",
        "wrap-logos": o
      }),
      children: [
        e && M.createElement(
          s.element,
          { className: te("title", s.className) },
          s.text
        ),
        t && /* @__PURE__ */ h.jsx("p", { children: t }),
        /* @__PURE__ */ h.jsx(
          "ul",
          {
            className: te({
              "two-col": a === 2 || a === 4,
              "three-col": a === 5 || a <= 10 && a % 3 === 0
            }),
            children: n.map(({ logo: c, nameOfBusiness: d, link: f = !1, description: p = !1 }, g) => {
              if (!c || !c.url)
                return null;
              const m = /* @__PURE__ */ h.jsx(
                "img",
                {
                  src: c.url,
                  width: c.width || "auto",
                  height: c.height || "auto",
                  alt: d
                }
              );
              return /* @__PURE__ */ h.jsxs("li", { children: [
                /* @__PURE__ */ h.jsx("p", { className: "img-wrapper", children: f ? /* @__PURE__ */ h.jsx("a", { href: f, target: "_blank", rel: "nofollow noreferrer noopener", children: m }) : m }),
                p && /* @__PURE__ */ h.jsx("small", { children: p })
              ] }, `${c.url}_${g}`);
            })
          }
        )
      ]
    }
  );
};
let Bd;
const Md = "contactFooter_", pae = ({ onSuccess: e = async () => {
}, onFailure: t = () => {
} }) => {
  const n = Ue(null), [r, i] = M.useState(0), [a, s] = M.useState(!1), o = () => {
    n.current && i(n.current.clientHeight);
  }, l = () => {
    a || (s(!0), clearTimeout(Bd), Bd = setTimeout(() => {
      o(), s(!1);
    }, 500));
  };
  return pe(() => (o(), window.addEventListener("resize", l), () => {
    clearTimeout(Bd), window.removeEventListener("resize", l);
  }), []), /* @__PURE__ */ h.jsx(Va, { id: "contactForm", className: "contact-footer", children: /* @__PURE__ */ h.jsxs("div", { className: "inner-wrapper", children: [
    /* @__PURE__ */ h.jsx("h2", { children: /* @__PURE__ */ h.jsx(en, { id: `${Md}title` }) }),
    /* @__PURE__ */ h.jsxs(
      "div",
      {
        className: "content-wrapper",
        ref: n,
        "data-testid": "content-wrapper",
        style: a ? {} : { minHeight: r },
        children: [
          /* @__PURE__ */ h.jsxs("aside", { children: [
            /* @__PURE__ */ h.jsx("p", { children: /* @__PURE__ */ h.jsx(en, { id: `${Md}text` }) }),
            /* @__PURE__ */ h.jsx(qa, { className: "mailto-link", href: "mailto:hello@apolitical.co", children: /* @__PURE__ */ h.jsx(en, { id: `${Md}email` }) })
          ] }),
          /* @__PURE__ */ h.jsx(
            dR,
            {
              functions: { onSuccess: e, onFailure: t },
              gtm: { context: "FooterContactUsForm", event: "contact-form-submit-click" }
            }
          )
        ]
      }
    )
  ] }) });
}, mae = ({ activeLink: e, profile: t, ...n }) => /* @__PURE__ */ h.jsx(Va, { children: /* @__PURE__ */ h.jsx(JR, { layout: "1-3", children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
  /* @__PURE__ */ h.jsx(YR, { activeLink: e, profile: t }),
  /* @__PURE__ */ h.jsx(F7, { ...n })
] }) }) });
const Ld = "cookieBanner_", $d = [
  "apol-cookie-banner",
  "apolitical-performance-cookie-consent",
  "functional-cookie-consent"
], jd = new Date(Date.now() + 12 * 30 * 24 * 60 * 60 * 1e3), tF = () => {
  const e = ye(), [t, n, r] = jE($d), [i, a] = de(
    !t["apol-cookie-banner"]
  ), s = () => {
    $d.forEach((c) => {
      n(c, !0, {
        path: "/",
        expires: jd,
        domain: c === "apolitical-performance-cookie-consent" ? ".apolitical.co" : void 0
      });
    }), a(!1), window.location.reload();
  }, o = () => {
    n("apol-cookie-banner", !0, {
      path: "/",
      expires: jd
    }), $d.forEach((c) => {
      if (c === "apol-cookie-banner") {
        n(c, !0, {
          path: "/",
          expires: jd
        });
        return;
      }
      r(c);
    }), a(!1);
  };
  if (!i)
    return null;
  const l = [
    { id: "settings", href: "/pages/cookie-policy", gtmType: "policy-page" },
    { id: "reject", onClick: o, gtmType: "reject-all" },
    { id: "accept", onClick: s, gtmType: "accepted-all" }
  ], u = [];
  return l.forEach((c) => {
    u.push({
      variant: c.href ? "tertiary" : "primary",
      href: c.href,
      onClick: c.onClick,
      className: "gtm-trackable",
      "data-gtm-event-context": "cookie-banner",
      "data-gtm-event-type": `cookie-${c.gtmType}-click`,
      children: e.formatMessage({ id: `${Ld}buttons_${c.id}` })
    });
  }), /* @__PURE__ */ h.jsxs("aside", { id: "cookie-banner", className: "text-medium", children: [
    /* @__PURE__ */ h.jsx("h6", { children: e.formatMessage({ id: `${Ld}title` }) }),
    /* @__PURE__ */ h.jsx("p", { children: e.formatMessage({ id: `${Ld}text` }) }),
    /* @__PURE__ */ h.jsx(Il, { buttons: u })
  ] });
}, yi = {
  platform: {
    order: ["events", "courses", "articles", "communities"],
    // An array guarantees the right order
    events: { href: "/events/", gtmType: "events-click" },
    courses: { href: "/microcourses/", gtmType: "microcourses-click" },
    articles: { href: "/solution-articles/", gtmType: "articles-click" },
    communities: { href: "/communities/", gtmType: "communities-click" }
  },
  community: {
    order: ["support", "post", "join", "guidelines"],
    support: {
      name: "Support FAQ",
      href: "/pages/support-faq",
      gtmType: "support-faq-click"
    },
    post: { href: "/pages/post-an-article", gtmType: "post-an-article-click" },
    join: {
      href: "/pages/who-can-join-the-community",
      gtmType: "who-can-join-click"
    },
    guidelines: {
      href: "/pages/values-and-guidelines",
      gtmType: "guidelines-and-values-click"
    }
  },
  company: {
    order: ["news", "insights", "story", "team", "careers", "partner", "contact"],
    news: {
      href: "/learning-hub/updates/",
      gtmType: "news-click"
    },
    insights: {
      href: "/learning-hub/global-insights/",
      gtmType: "insights-click"
    },
    story: {
      href: "/pages/our-story",
      gtmType: "our-story-click"
    },
    team: {
      href: "/pages/meet-our-team",
      gtmType: "team-click"
    },
    careers: {
      href: "/pages/careers",
      gtmType: "careers-click"
    },
    partner: { href: "/partnerships/", gtmType: "partner-with-us-click" },
    contact: {
      href: "/pages/get-in-touch",
      gtmType: "contact-click"
    },
    child: "legal"
  },
  legal: {
    order: ["privacy", "terms", "cookie", "accessibility", "ai"],
    privacy: {
      href: "https://about.apolitical.co/privacy-policy",
      gtmType: "privacy-policy-link"
    },
    terms: {
      href: "https://about.apolitical.co/terms-and-conditions",
      gtmType: "terms-conditions-link"
    },
    cookie: { href: "/pages/cookie-policy", gtmType: "cookie-policy-link" },
    ai: {
      href: "/pages/ai-principles",
      gtmType: "ai-principles-link"
    },
    accessibility: {
      href: "/pages/accessibility-statement",
      gtmType: "accessibility-link"
    },
    text: {
      order: ["dataProtection", "euDataProtection"],
      dataProtection: {
        email: Io["data-protection"].default,
        gtmType: "email-dpo-link"
      },
      euDataProtection: {
        email: Io["data-protection"].eu,
        gtmType: "email-eu-dpo-link"
      }
    }
  },
  contact: {
    text: {
      order: [
        "london",
        "washington",
        "berlin",
        "registered",
        "support",
        "business"
      ],
      london: { address: !0 },
      washington: { address: !0 },
      registered: { address: !0 },
      berlin: { address: !0 },
      support: {
        email: Io.support,
        gtmType: "concierge-email-click"
      },
      business: { email: Io.general, gtmType: "hello-email-click" }
    }
  },
  social: {
    order: ["linkedin", "twitter", "facebook"],
    linkedin: { href: "https://www.linkedin.com/company/apolitical" },
    twitter: { href: "https://twitter.com/apoliticalco" },
    facebook: { href: "https://www.facebook.com/apoliticalco" }
  }
};
const xs = "footer_", qc = "SiteFooter", u9 = ({ group: e }) => {
  const t = yi[e].order || [];
  let n = !1;
  return "text" in yi[e] && (n = yi[e].text), /* @__PURE__ */ h.jsxs(ll, { children: [
    /* @__PURE__ */ h.jsx("p", { className: "pre-title", children: /* @__PURE__ */ h.jsx(en, { id: `${xs}${e}` }) }),
    Array.isArray(t) && t.length > 0 && /* @__PURE__ */ h.jsx("ul", { className: "text-medium", children: t.map((r) => {
      if (["order", "child", "text"].includes(r))
        return null;
      const { href: i, gtmType: a } = yi[e][r], s = {};
      return ["legal"].includes(e) && (s.target = "_blank", s.rel = "noopener"), /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx(
        "a",
        {
          href: i,
          className: "gtm-trackable",
          "data-gtm-event-context": qc,
          "data-gtm-event-type": a,
          ...s,
          children: /* @__PURE__ */ h.jsx(en, { id: `${xs}${e}_${r}` })
        }
      ) }, `${e}_${r}`);
    }) }),
    typeof n != "boolean" && "order" in n && Array.isArray(n.order) && /* @__PURE__ */ h.jsx("dl", { className: "text-medium", children: n.order.map((r) => /* @__PURE__ */ h.jsxs(ll, { children: [
      /* @__PURE__ */ h.jsx("dt", { children: /* @__PURE__ */ h.jsx(en, { id: `${xs}${e}_${r}` }) }),
      /* @__PURE__ */ h.jsxs("dd", { children: [
        typeof n != "boolean" && n[r].address && /* @__PURE__ */ h.jsx("address", { children: /* @__PURE__ */ h.jsx(
          en,
          {
            id: `${xs}${e}_${r}_address`,
            values: { br: /* @__PURE__ */ h.jsx("br", {}) }
          }
        ) }),
        typeof n != "boolean" && n[r].email && /* @__PURE__ */ h.jsx(
          "a",
          {
            href: `mailto:${n[r].email}`,
            className: "gtm-trackable",
            "data-gtm-event-context": qc,
            "data-gtm-event-type": n[r].gtmType,
            children: n[r].email
          }
        )
      ] })
    ] }, `dl-${e}-${r}`)) })
  ] }, e);
}, pT = () => /* @__PURE__ */ h.jsx("div", { id: "footer", children: /* @__PURE__ */ h.jsxs("div", { className: "wrapper", children: [
  /* @__PURE__ */ h.jsx(dp, { element: "hr" }),
  /* @__PURE__ */ h.jsx(
    fT,
    {
      variant: "inverted",
      version: "full",
      className: "gtm-trackable",
      "data-gtm-event-context": qc,
      "data-gtm-event-type": "logo-homepage-link"
    }
  ),
  /* @__PURE__ */ h.jsx("footer", { children: ["platform", "community", "company", "contact"].map((e) => /* @__PURE__ */ h.jsxs("div", { className: "group", children: [
    /* @__PURE__ */ h.jsx(u9, { group: e }),
    Object.keys(yi[e]).includes("child") && /* @__PURE__ */ h.jsx(u9, { group: yi[e].child })
  ] }, e)) }),
  /* @__PURE__ */ h.jsx("hr", {}),
  /* @__PURE__ */ h.jsxs("div", { className: "sub-footer", children: [
    /* @__PURE__ */ h.jsx("ul", { children: Array.isArray(yi.social.order) && yi.social.order.map((e) => {
      const t = yi.social[e];
      return /* @__PURE__ */ h.jsx("li", { className: e, children: /* @__PURE__ */ h.jsx(
        "a",
        {
          href: t.href,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "gtm-trackable",
          "data-gtm-event-context": qc,
          "data-gtm-event-type": "social-click",
          children: /* @__PURE__ */ h.jsx("span", { className: "hidden", children: /* @__PURE__ */ h.jsx(en, { id: `${xs}social_${e}` }) })
        }
      ) }, e);
    }) }),
    /* @__PURE__ */ h.jsx("small", { children: /* @__PURE__ */ h.jsx(
      en,
      {
        id: `${xs}copyright`,
        values: { currentYear: (/* @__PURE__ */ new Date()).getFullYear() }
      }
    ) })
  ] })
] }) }), Xr = /* @__PURE__ */ Object.create(null);
Xr.open = "0";
Xr.close = "1";
Xr.ping = "2";
Xr.pong = "3";
Xr.message = "4";
Xr.upgrade = "5";
Xr.noop = "6";
const hc = /* @__PURE__ */ Object.create(null);
Object.keys(Xr).forEach((e) => {
  hc[Xr[e]] = e;
});
const Fh = { type: "error", data: "parser error" }, mT = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", gT = typeof ArrayBuffer == "function", vT = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, tm = ({ type: e, data: t }, n, r) => mT && t instanceof Blob ? n ? r(t) : c9(t, r) : gT && (t instanceof ArrayBuffer || vT(t)) ? n ? r(t) : c9(new Blob([t]), r) : r(Xr[e] + (t || "")), c9 = (e, t) => {
  const n = new FileReader();
  return n.onload = function() {
    const r = n.result.split(",")[1];
    t("b" + (r || ""));
  }, n.readAsDataURL(e);
};
function d9(e) {
  return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
}
let Hd;
function nF(e, t) {
  if (mT && e.data instanceof Blob)
    return e.data.arrayBuffer().then(d9).then(t);
  if (gT && (e.data instanceof ArrayBuffer || vT(e.data)))
    return t(d9(e.data));
  tm(e, !1, (n) => {
    Hd || (Hd = new TextEncoder()), t(Hd.encode(n));
  });
}
const f9 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Bo = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let e = 0; e < f9.length; e++)
  Bo[f9.charCodeAt(e)] = e;
const rF = (e) => {
  let t = e.length * 0.75, n = e.length, r, i = 0, a, s, o, l;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  const u = new ArrayBuffer(t), c = new Uint8Array(u);
  for (r = 0; r < n; r += 4)
    a = Bo[e.charCodeAt(r)], s = Bo[e.charCodeAt(r + 1)], o = Bo[e.charCodeAt(r + 2)], l = Bo[e.charCodeAt(r + 3)], c[i++] = a << 2 | s >> 4, c[i++] = (s & 15) << 4 | o >> 2, c[i++] = (o & 3) << 6 | l & 63;
  return u;
}, iF = typeof ArrayBuffer == "function", nm = (e, t) => {
  if (typeof e != "string")
    return {
      type: "message",
      data: yT(e, t)
    };
  const n = e.charAt(0);
  return n === "b" ? {
    type: "message",
    data: aF(e.substring(1), t)
  } : hc[n] ? e.length > 1 ? {
    type: hc[n],
    data: e.substring(1)
  } : {
    type: hc[n]
  } : Fh;
}, aF = (e, t) => {
  if (iF) {
    const n = rF(e);
    return yT(n, t);
  } else
    return { base64: !0, data: e };
}, yT = (e, t) => {
  switch (t) {
    case "blob":
      return e instanceof Blob ? e : new Blob([e]);
    case "arraybuffer":
    default:
      return e instanceof ArrayBuffer ? e : e.buffer;
  }
}, ET = String.fromCharCode(30), sF = (e, t) => {
  const n = e.length, r = new Array(n);
  let i = 0;
  e.forEach((a, s) => {
    tm(a, !1, (o) => {
      r[s] = o, ++i === n && t(r.join(ET));
    });
  });
}, oF = (e, t) => {
  const n = e.split(ET), r = [];
  for (let i = 0; i < n.length; i++) {
    const a = nm(n[i], t);
    if (r.push(a), a.type === "error")
      break;
  }
  return r;
};
function lF() {
  return new TransformStream({
    transform(e, t) {
      nF(e, (n) => {
        const r = n.length;
        let i;
        if (r < 126)
          i = new Uint8Array(1), new DataView(i.buffer).setUint8(0, r);
        else if (r < 65536) {
          i = new Uint8Array(3);
          const a = new DataView(i.buffer);
          a.setUint8(0, 126), a.setUint16(1, r);
        } else {
          i = new Uint8Array(9);
          const a = new DataView(i.buffer);
          a.setUint8(0, 127), a.setBigUint64(1, BigInt(r));
        }
        e.data && typeof e.data != "string" && (i[0] |= 128), t.enqueue(i), t.enqueue(n);
      });
    }
  });
}
let Ud;
function yu(e) {
  return e.reduce((t, n) => t + n.length, 0);
}
function Eu(e, t) {
  if (e[0].length === t)
    return e.shift();
  const n = new Uint8Array(t);
  let r = 0;
  for (let i = 0; i < t; i++)
    n[i] = e[0][r++], r === e[0].length && (e.shift(), r = 0);
  return e.length && r < e[0].length && (e[0] = e[0].slice(r)), n;
}
function uF(e, t) {
  Ud || (Ud = new TextDecoder());
  const n = [];
  let r = 0, i = -1, a = !1;
  return new TransformStream({
    transform(s, o) {
      for (n.push(s); ; ) {
        if (r === 0) {
          if (yu(n) < 1)
            break;
          const l = Eu(n, 1);
          a = (l[0] & 128) === 128, i = l[0] & 127, i < 126 ? r = 3 : i === 126 ? r = 1 : r = 2;
        } else if (r === 1) {
          if (yu(n) < 2)
            break;
          const l = Eu(n, 2);
          i = new DataView(l.buffer, l.byteOffset, l.length).getUint16(0), r = 3;
        } else if (r === 2) {
          if (yu(n) < 8)
            break;
          const l = Eu(n, 8), u = new DataView(l.buffer, l.byteOffset, l.length), c = u.getUint32(0);
          if (c > Math.pow(2, 53 - 32) - 1) {
            o.enqueue(Fh);
            break;
          }
          i = c * Math.pow(2, 32) + u.getUint32(4), r = 3;
        } else {
          if (yu(n) < i)
            break;
          const l = Eu(n, i);
          o.enqueue(nm(a ? l : Ud.decode(l), t)), r = 0;
        }
        if (i === 0 || i > e) {
          o.enqueue(Fh);
          break;
        }
      }
    }
  });
}
const bT = 4;
function Qt(e) {
  if (e)
    return cF(e);
}
function cF(e) {
  for (var t in Qt.prototype)
    e[t] = Qt.prototype[t];
  return e;
}
Qt.prototype.on = Qt.prototype.addEventListener = function(e, t) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
};
Qt.prototype.once = function(e, t) {
  function n() {
    this.off(e, n), t.apply(this, arguments);
  }
  return n.fn = t, this.on(e, n), this;
};
Qt.prototype.off = Qt.prototype.removeListener = Qt.prototype.removeAllListeners = Qt.prototype.removeEventListener = function(e, t) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var n = this._callbacks["$" + e];
  if (!n)
    return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + e], this;
  for (var r, i = 0; i < n.length; i++)
    if (r = n[i], r === t || r.fn === t) {
      n.splice(i, 1);
      break;
    }
  return n.length === 0 && delete this._callbacks["$" + e], this;
};
Qt.prototype.emit = function(e) {
  this._callbacks = this._callbacks || {};
  for (var t = new Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  if (n) {
    n = n.slice(0);
    for (var r = 0, i = n.length; r < i; ++r)
      n[r].apply(this, t);
  }
  return this;
};
Qt.prototype.emitReserved = Qt.prototype.emit;
Qt.prototype.listeners = function(e) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
};
Qt.prototype.hasListeners = function(e) {
  return !!this.listeners(e).length;
};
const d1 = (() => typeof Promise == "function" && typeof Promise.resolve == "function" ? (t) => Promise.resolve().then(t) : (t, n) => n(t, 0))(), sr = (() => typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")())(), dF = "arraybuffer";
function TT(e, ...t) {
  return t.reduce((n, r) => (e.hasOwnProperty(r) && (n[r] = e[r]), n), {});
}
const fF = sr.setTimeout, hF = sr.clearTimeout;
function f1(e, t) {
  t.useNativeTimers ? (e.setTimeoutFn = fF.bind(sr), e.clearTimeoutFn = hF.bind(sr)) : (e.setTimeoutFn = sr.setTimeout.bind(sr), e.clearTimeoutFn = sr.clearTimeout.bind(sr));
}
const pF = 1.33;
function mF(e) {
  return typeof e == "string" ? gF(e) : Math.ceil((e.byteLength || e.size) * pF);
}
function gF(e) {
  let t = 0, n = 0;
  for (let r = 0, i = e.length; r < i; r++)
    t = e.charCodeAt(r), t < 128 ? n += 1 : t < 2048 ? n += 2 : t < 55296 || t >= 57344 ? n += 3 : (r++, n += 4);
  return n;
}
function _T() {
  return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
function vF(e) {
  let t = "";
  for (let n in e)
    e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
  return t;
}
function yF(e) {
  let t = {}, n = e.split("&");
  for (let r = 0, i = n.length; r < i; r++) {
    let a = n[r].split("=");
    t[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
  }
  return t;
}
class EF extends Error {
  constructor(t, n, r) {
    super(t), this.description = n, this.context = r, this.type = "TransportError";
  }
}
class rm extends Qt {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(t) {
    super(), this.writable = !1, f1(this, t), this.opts = t, this.query = t.query, this.socket = t.socket, this.supportsBinary = !t.forceBase64;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(t, n, r) {
    return super.emitReserved("error", new EF(t, n, r)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(t) {
    this.readyState === "open" && this.write(t);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(t) {
    const n = nm(t, this.socket.binaryType);
    this.onPacket(n);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(t) {
    super.emitReserved("packet", t);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(t) {
    this.readyState = "closed", super.emitReserved("close", t);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(t) {
  }
  createUri(t, n = {}) {
    return t + "://" + this._hostname() + this._port() + this.opts.path + this._query(n);
  }
  _hostname() {
    const t = this.opts.hostname;
    return t.indexOf(":") === -1 ? t : "[" + t + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && +(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(t) {
    const n = vF(t);
    return n.length ? "?" + n : "";
  }
}
class bF extends rm {
  constructor() {
    super(...arguments), this._polling = !1;
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this._poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(t) {
    this.readyState = "pausing";
    const n = () => {
      this.readyState = "paused", t();
    };
    if (this._polling || !this.writable) {
      let r = 0;
      this._polling && (r++, this.once("pollComplete", function() {
        --r || n();
      })), this.writable || (r++, this.once("drain", function() {
        --r || n();
      }));
    } else
      n();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  _poll() {
    this._polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(t) {
    const n = (r) => {
      if (this.readyState === "opening" && r.type === "open" && this.onOpen(), r.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(r);
    };
    oF(t, this.socket.binaryType).forEach(n), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const t = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? t() : this.once("open", t);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(t) {
    this.writable = !1, sF(t, (n) => {
      this.doWrite(n, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "https" : "http", n = this.query || {};
    return this.opts.timestampRequests !== !1 && (n[this.opts.timestampParam] = _T()), !this.supportsBinary && !n.sid && (n.b64 = 1), this.createUri(t, n);
  }
}
let CT = !1;
try {
  CT = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const TF = CT;
function _F() {
}
class CF extends bF {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(t) {
    if (super(t), typeof location < "u") {
      const n = location.protocol === "https:";
      let r = location.port;
      r || (r = n ? "443" : "80"), this.xd = typeof location < "u" && t.hostname !== location.hostname || r !== t.port;
    }
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(t, n) {
    const r = this.request({
      method: "POST",
      data: t
    });
    r.on("success", n), r.on("error", (i, a) => {
      this.onError("xhr post error", i, a);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const t = this.request();
    t.on("data", this.onData.bind(this)), t.on("error", (n, r) => {
      this.onError("xhr poll error", n, r);
    }), this.pollXhr = t;
  }
}
class Vr extends Qt {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(t, n, r) {
    super(), this.createRequest = t, f1(this, r), this._opts = r, this._method = r.method || "GET", this._uri = n, this._data = r.data !== void 0 ? r.data : null, this._create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  _create() {
    var t;
    const n = TT(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    n.xdomain = !!this._opts.xd;
    const r = this._xhr = this.createRequest(n);
    try {
      r.open(this._method, this._uri, !0);
      try {
        if (this._opts.extraHeaders) {
          r.setDisableHeaderCheck && r.setDisableHeaderCheck(!0);
          for (let i in this._opts.extraHeaders)
            this._opts.extraHeaders.hasOwnProperty(i) && r.setRequestHeader(i, this._opts.extraHeaders[i]);
        }
      } catch {
      }
      if (this._method === "POST")
        try {
          r.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        r.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (t = this._opts.cookieJar) === null || t === void 0 || t.addCookies(r), "withCredentials" in r && (r.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (r.timeout = this._opts.requestTimeout), r.onreadystatechange = () => {
        var i;
        r.readyState === 3 && ((i = this._opts.cookieJar) === null || i === void 0 || i.parseCookies(
          // @ts-ignore
          r.getResponseHeader("set-cookie")
        )), r.readyState === 4 && (r.status === 200 || r.status === 1223 ? this._onLoad() : this.setTimeoutFn(() => {
          this._onError(typeof r.status == "number" ? r.status : 0);
        }, 0));
      }, r.send(this._data);
    } catch (i) {
      this.setTimeoutFn(() => {
        this._onError(i);
      }, 0);
      return;
    }
    typeof document < "u" && (this._index = Vr.requestsCount++, Vr.requests[this._index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  _onError(t) {
    this.emitReserved("error", t, this._xhr), this._cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  _cleanup(t) {
    if (!(typeof this._xhr > "u" || this._xhr === null)) {
      if (this._xhr.onreadystatechange = _F, t)
        try {
          this._xhr.abort();
        } catch {
        }
      typeof document < "u" && delete Vr.requests[this._index], this._xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  _onLoad() {
    const t = this._xhr.responseText;
    t !== null && (this.emitReserved("data", t), this.emitReserved("success"), this._cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this._cleanup();
  }
}
Vr.requestsCount = 0;
Vr.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", h9);
  else if (typeof addEventListener == "function") {
    const e = "onpagehide" in sr ? "pagehide" : "unload";
    addEventListener(e, h9, !1);
  }
}
function h9() {
  for (let e in Vr.requests)
    Vr.requests.hasOwnProperty(e) && Vr.requests[e].abort();
}
const xF = function() {
  const e = xT({
    xdomain: !1
  });
  return e && e.responseType !== null;
}();
class wF extends CF {
  constructor(t) {
    super(t);
    const n = t && t.forceBase64;
    this.supportsBinary = xF && !n;
  }
  request(t = {}) {
    return Object.assign(t, { xd: this.xd }, this.opts), new Vr(xT, this.uri(), t);
  }
}
function xT(e) {
  const t = e.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!t || TF))
      return new XMLHttpRequest();
  } catch {
  }
  if (!t)
    try {
      return new sr[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
const wT = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class AF extends rm {
  get name() {
    return "websocket";
  }
  doOpen() {
    const t = this.uri(), n = this.opts.protocols, r = wT ? {} : TT(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (r.headers = this.opts.extraHeaders);
    try {
      this.ws = this.createSocket(t, n, r);
    } catch (i) {
      return this.emitReserved("error", i);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (t) => this.onClose({
      description: "websocket connection closed",
      context: t
    }), this.ws.onmessage = (t) => this.onData(t.data), this.ws.onerror = (t) => this.onError("websocket error", t);
  }
  write(t) {
    this.writable = !1;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], i = n === t.length - 1;
      tm(r, this.supportsBinary, (a) => {
        try {
          this.doWrite(r, a);
        } catch {
        }
        i && d1(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.onerror = () => {
    }, this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "wss" : "ws", n = this.query || {};
    return this.opts.timestampRequests && (n[this.opts.timestampParam] = _T()), this.supportsBinary || (n.b64 = 1), this.createUri(t, n);
  }
}
const zd = sr.WebSocket || sr.MozWebSocket;
class SF extends AF {
  createSocket(t, n, r) {
    return wT ? new zd(t, n, r) : n ? new zd(t, n) : new zd(t);
  }
  doWrite(t, n) {
    this.ws.send(n);
  }
}
class kF extends rm {
  get name() {
    return "webtransport";
  }
  doOpen() {
    try {
      this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
    } catch (t) {
      return this.emitReserved("error", t);
    }
    this._transport.closed.then(() => {
      this.onClose();
    }).catch((t) => {
      this.onError("webtransport error", t);
    }), this._transport.ready.then(() => {
      this._transport.createBidirectionalStream().then((t) => {
        const n = uF(Number.MAX_SAFE_INTEGER, this.socket.binaryType), r = t.readable.pipeThrough(n).getReader(), i = lF();
        i.readable.pipeTo(t.writable), this._writer = i.writable.getWriter();
        const a = () => {
          r.read().then(({ done: o, value: l }) => {
            o || (this.onPacket(l), a());
          }).catch((o) => {
          });
        };
        a();
        const s = { type: "open" };
        this.query.sid && (s.data = `{"sid":"${this.query.sid}"}`), this._writer.write(s).then(() => this.onOpen());
      });
    });
  }
  write(t) {
    this.writable = !1;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], i = n === t.length - 1;
      this._writer.write(r).then(() => {
        i && d1(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var t;
    (t = this._transport) === null || t === void 0 || t.close();
  }
}
const DF = {
  websocket: SF,
  webtransport: kF,
  polling: wF
}, OF = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, NF = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function Bh(e) {
  if (e.length > 8e3)
    throw "URI too long";
  const t = e, n = e.indexOf("["), r = e.indexOf("]");
  n != -1 && r != -1 && (e = e.substring(0, n) + e.substring(n, r).replace(/:/g, ";") + e.substring(r, e.length));
  let i = OF.exec(e || ""), a = {}, s = 14;
  for (; s--; )
    a[NF[s]] = i[s] || "";
  return n != -1 && r != -1 && (a.source = t, a.host = a.host.substring(1, a.host.length - 1).replace(/;/g, ":"), a.authority = a.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), a.ipv6uri = !0), a.pathNames = IF(a, a.path), a.queryKey = PF(a, a.query), a;
}
function IF(e, t) {
  const n = /\/{2,9}/g, r = t.replace(n, "/").split("/");
  return (t.slice(0, 1) == "/" || t.length === 0) && r.splice(0, 1), t.slice(-1) == "/" && r.splice(r.length - 1, 1), r;
}
function PF(e, t) {
  const n = {};
  return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(r, i, a) {
    i && (n[i] = a);
  }), n;
}
const Mh = typeof addEventListener == "function" && typeof removeEventListener == "function", pc = [];
Mh && addEventListener("offline", () => {
  pc.forEach((e) => e());
}, !1);
class Ji extends Qt {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(t, n) {
    if (super(), this.binaryType = dF, this.writeBuffer = [], this._prevBufferLen = 0, this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = 1 / 0, t && typeof t == "object" && (n = t, t = null), t) {
      const r = Bh(t);
      n.hostname = r.host, n.secure = r.protocol === "https" || r.protocol === "wss", n.port = r.port, r.query && (n.query = r.query);
    } else
      n.host && (n.hostname = Bh(n.host).host);
    f1(this, n), this.secure = n.secure != null ? n.secure : typeof location < "u" && location.protocol === "https:", n.hostname && !n.port && (n.port = this.secure ? "443" : "80"), this.hostname = n.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = n.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = [], this._transportsByName = {}, n.transports.forEach((r) => {
      const i = r.prototype.name;
      this.transports.push(i), this._transportsByName[i] = r;
    }), this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, n), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = yF(this.opts.query)), Mh && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = () => {
      this._onClose("transport close", {
        description: "network connection lost"
      });
    }, pc.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(t) {
    const n = Object.assign({}, this.opts.query);
    n.EIO = bT, n.transport = t, this.id && (n.sid = this.id);
    const r = Object.assign({}, this.opts, {
      query: n,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[t]);
    return new this._transportsByName[t](r);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  _open() {
    if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    }
    const t = this.opts.rememberUpgrade && Ji.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
    this.readyState = "opening";
    const n = this.createTransport(t);
    n.open(), this.setTransport(n);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(t) {
    this.transport && this.transport.removeAllListeners(), this.transport = t, t.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (n) => this._onClose("transport close", n));
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    this.readyState = "open", Ji.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush();
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  _onPacket(t) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", t), this.emitReserved("heartbeat"), t.type) {
        case "open":
          this.onHandshake(JSON.parse(t.data));
          break;
        case "ping":
          this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
          break;
        case "error":
          const n = new Error("server error");
          n.code = t.data, this._onError(n);
          break;
        case "message":
          this.emitReserved("data", t.data), this.emitReserved("message", t.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(t) {
    this.emitReserved("handshake", t), this.id = t.sid, this.transport.query.sid = t.sid, this._pingInterval = t.pingInterval, this._pingTimeout = t.pingTimeout, this._maxPayload = t.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  _resetPingTimeout() {
    this.clearTimeoutFn(this._pingTimeoutTimer);
    const t = this._pingInterval + this._pingTimeout;
    this._pingTimeoutTime = Date.now() + t, this._pingTimeoutTimer = this.setTimeoutFn(() => {
      this._onClose("ping timeout");
    }, t), this.opts.autoUnref && this._pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  _onDrain() {
    this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const t = this._getWritablePackets();
      this.transport.send(t), this._prevBufferLen = t.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  _getWritablePackets() {
    if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let n = 1;
    for (let r = 0; r < this.writeBuffer.length; r++) {
      const i = this.writeBuffer[r].data;
      if (i && (n += mF(i)), r > 0 && n > this._maxPayload)
        return this.writeBuffer.slice(0, r);
      n += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
   *
   * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
   * `write()` method then the message would not be buffered by the Socket.IO client.
   *
   * @return {boolean}
   * @private
   */
  /* private */
  _hasPingExpired() {
    if (!this._pingTimeoutTime)
      return !0;
    const t = Date.now() > this._pingTimeoutTime;
    return t && (this._pingTimeoutTime = 0, d1(() => {
      this._onClose("ping timeout");
    }, this.setTimeoutFn)), t;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  write(t, n, r) {
    return this._sendPacket("message", t, n, r), this;
  }
  /**
   * Sends a message. Alias of {@link Socket#write}.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @return {Socket} for chaining.
   */
  send(t, n, r) {
    return this._sendPacket("message", t, n, r), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  _sendPacket(t, n, r, i) {
    if (typeof n == "function" && (i = n, n = void 0), typeof r == "function" && (i = r, r = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    r = r || {}, r.compress = r.compress !== !1;
    const a = {
      type: t,
      data: n,
      options: r
    };
    this.emitReserved("packetCreate", a), this.writeBuffer.push(a), i && this.once("flush", i), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const t = () => {
      this._onClose("forced close"), this.transport.close();
    }, n = () => {
      this.off("upgrade", n), this.off("upgradeError", n), t();
    }, r = () => {
      this.once("upgrade", n), this.once("upgradeError", n);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? r() : t();
    }) : this.upgrading ? r() : t()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  _onError(t) {
    if (Ji.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening")
      return this.transports.shift(), this._open();
    this.emitReserved("error", t), this._onClose("transport error", t);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  _onClose(t, n) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
      if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), Mh && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
        const r = pc.indexOf(this._offlineEventListener);
        r !== -1 && pc.splice(r, 1);
      }
      this.readyState = "closed", this.id = null, this.emitReserved("close", t, n), this.writeBuffer = [], this._prevBufferLen = 0;
    }
  }
}
Ji.protocol = bT;
class RF extends Ji {
  constructor() {
    super(...arguments), this._upgrades = [];
  }
  onOpen() {
    if (super.onOpen(), this.readyState === "open" && this.opts.upgrade)
      for (let t = 0; t < this._upgrades.length; t++)
        this._probe(this._upgrades[t]);
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  _probe(t) {
    let n = this.createTransport(t), r = !1;
    Ji.priorWebsocketSuccess = !1;
    const i = () => {
      r || (n.send([{ type: "ping", data: "probe" }]), n.once("packet", (d) => {
        if (!r)
          if (d.type === "pong" && d.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", n), !n)
              return;
            Ji.priorWebsocketSuccess = n.name === "websocket", this.transport.pause(() => {
              r || this.readyState !== "closed" && (c(), this.setTransport(n), n.send([{ type: "upgrade" }]), this.emitReserved("upgrade", n), n = null, this.upgrading = !1, this.flush());
            });
          } else {
            const f = new Error("probe error");
            f.transport = n.name, this.emitReserved("upgradeError", f);
          }
      }));
    };
    function a() {
      r || (r = !0, c(), n.close(), n = null);
    }
    const s = (d) => {
      const f = new Error("probe error: " + d);
      f.transport = n.name, a(), this.emitReserved("upgradeError", f);
    };
    function o() {
      s("transport closed");
    }
    function l() {
      s("socket closed");
    }
    function u(d) {
      n && d.name !== n.name && a();
    }
    const c = () => {
      n.removeListener("open", i), n.removeListener("error", s), n.removeListener("close", o), this.off("close", l), this.off("upgrading", u);
    };
    n.once("open", i), n.once("error", s), n.once("close", o), this.once("close", l), this.once("upgrading", u), this._upgrades.indexOf("webtransport") !== -1 && t !== "webtransport" ? this.setTimeoutFn(() => {
      r || n.open();
    }, 200) : n.open();
  }
  onHandshake(t) {
    this._upgrades = this._filterUpgrades(t.upgrades), super.onHandshake(t);
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  _filterUpgrades(t) {
    const n = [];
    for (let r = 0; r < t.length; r++)
      ~this.transports.indexOf(t[r]) && n.push(t[r]);
    return n;
  }
}
let FF = class extends RF {
  constructor(t, n = {}) {
    const r = typeof t == "object" ? t : n;
    (!r.transports || r.transports && typeof r.transports[0] == "string") && (r.transports = (r.transports || ["polling", "websocket", "webtransport"]).map((i) => DF[i]).filter((i) => !!i)), super(t, r);
  }
};
function BF(e, t = "", n) {
  let r = e;
  n = n || typeof location < "u" && location, e == null && (e = n.protocol + "//" + n.host), typeof e == "string" && (e.charAt(0) === "/" && (e.charAt(1) === "/" ? e = n.protocol + e : e = n.host + e), /^(https?|wss?):\/\//.test(e) || (typeof n < "u" ? e = n.protocol + "//" + e : e = "https://" + e), r = Bh(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
  const a = r.host.indexOf(":") !== -1 ? "[" + r.host + "]" : r.host;
  return r.id = r.protocol + "://" + a + ":" + r.port + t, r.href = r.protocol + "://" + a + (n && n.port === r.port ? "" : ":" + r.port), r;
}
const MF = typeof ArrayBuffer == "function", LF = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, AT = Object.prototype.toString, $F = typeof Blob == "function" || typeof Blob < "u" && AT.call(Blob) === "[object BlobConstructor]", jF = typeof File == "function" || typeof File < "u" && AT.call(File) === "[object FileConstructor]";
function im(e) {
  return MF && (e instanceof ArrayBuffer || LF(e)) || $F && e instanceof Blob || jF && e instanceof File;
}
function mc(e, t) {
  if (!e || typeof e != "object")
    return !1;
  if (Array.isArray(e)) {
    for (let n = 0, r = e.length; n < r; n++)
      if (mc(e[n]))
        return !0;
    return !1;
  }
  if (im(e))
    return !0;
  if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1)
    return mc(e.toJSON(), !0);
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && mc(e[n]))
      return !0;
  return !1;
}
function HF(e) {
  const t = [], n = e.data, r = e;
  return r.data = Lh(n, t), r.attachments = t.length, { packet: r, buffers: t };
}
function Lh(e, t) {
  if (!e)
    return e;
  if (im(e)) {
    const n = { _placeholder: !0, num: t.length };
    return t.push(e), n;
  } else if (Array.isArray(e)) {
    const n = new Array(e.length);
    for (let r = 0; r < e.length; r++)
      n[r] = Lh(e[r], t);
    return n;
  } else if (typeof e == "object" && !(e instanceof Date)) {
    const n = {};
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (n[r] = Lh(e[r], t));
    return n;
  }
  return e;
}
function UF(e, t) {
  return e.data = $h(e.data, t), delete e.attachments, e;
}
function $h(e, t) {
  if (!e)
    return e;
  if (e && e._placeholder === !0) {
    if (typeof e.num == "number" && e.num >= 0 && e.num < t.length)
      return t[e.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(e))
    for (let n = 0; n < e.length; n++)
      e[n] = $h(e[n], t);
  else if (typeof e == "object")
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (e[n] = $h(e[n], t));
  return e;
}
const zF = [
  "connect",
  "connect_error",
  "disconnect",
  "disconnecting",
  "newListener",
  "removeListener"
  // used by the Node.js EventEmitter
], qF = 5;
var ct;
(function(e) {
  e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})(ct || (ct = {}));
class WF {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(t) {
    this.replacer = t;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(t) {
    return (t.type === ct.EVENT || t.type === ct.ACK) && mc(t) ? this.encodeAsBinary({
      type: t.type === ct.EVENT ? ct.BINARY_EVENT : ct.BINARY_ACK,
      nsp: t.nsp,
      data: t.data,
      id: t.id
    }) : [this.encodeAsString(t)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(t) {
    let n = "" + t.type;
    return (t.type === ct.BINARY_EVENT || t.type === ct.BINARY_ACK) && (n += t.attachments + "-"), t.nsp && t.nsp !== "/" && (n += t.nsp + ","), t.id != null && (n += t.id), t.data != null && (n += JSON.stringify(t.data, this.replacer)), n;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(t) {
    const n = HF(t), r = this.encodeAsString(n.packet), i = n.buffers;
    return i.unshift(r), i;
  }
}
function p9(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
class am extends Qt {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(t) {
    super(), this.reviver = t;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(t) {
    let n;
    if (typeof t == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      n = this.decodeString(t);
      const r = n.type === ct.BINARY_EVENT;
      r || n.type === ct.BINARY_ACK ? (n.type = r ? ct.EVENT : ct.ACK, this.reconstructor = new VF(n), n.attachments === 0 && super.emitReserved("decoded", n)) : super.emitReserved("decoded", n);
    } else if (im(t) || t.base64)
      if (this.reconstructor)
        n = this.reconstructor.takeBinaryData(t), n && (this.reconstructor = null, super.emitReserved("decoded", n));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + t);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(t) {
    let n = 0;
    const r = {
      type: Number(t.charAt(0))
    };
    if (ct[r.type] === void 0)
      throw new Error("unknown packet type " + r.type);
    if (r.type === ct.BINARY_EVENT || r.type === ct.BINARY_ACK) {
      const a = n + 1;
      for (; t.charAt(++n) !== "-" && n != t.length; )
        ;
      const s = t.substring(a, n);
      if (s != Number(s) || t.charAt(n) !== "-")
        throw new Error("Illegal attachments");
      r.attachments = Number(s);
    }
    if (t.charAt(n + 1) === "/") {
      const a = n + 1;
      for (; ++n && !(t.charAt(n) === "," || n === t.length); )
        ;
      r.nsp = t.substring(a, n);
    } else
      r.nsp = "/";
    const i = t.charAt(n + 1);
    if (i !== "" && Number(i) == i) {
      const a = n + 1;
      for (; ++n; ) {
        const s = t.charAt(n);
        if (s == null || Number(s) != s) {
          --n;
          break;
        }
        if (n === t.length)
          break;
      }
      r.id = Number(t.substring(a, n + 1));
    }
    if (t.charAt(++n)) {
      const a = this.tryParse(t.substr(n));
      if (am.isPayloadValid(r.type, a))
        r.data = a;
      else
        throw new Error("invalid payload");
    }
    return r;
  }
  tryParse(t) {
    try {
      return JSON.parse(t, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(t, n) {
    switch (t) {
      case ct.CONNECT:
        return p9(n);
      case ct.DISCONNECT:
        return n === void 0;
      case ct.CONNECT_ERROR:
        return typeof n == "string" || p9(n);
      case ct.EVENT:
      case ct.BINARY_EVENT:
        return Array.isArray(n) && (typeof n[0] == "number" || typeof n[0] == "string" && zF.indexOf(n[0]) === -1);
      case ct.ACK:
      case ct.BINARY_ACK:
        return Array.isArray(n);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class VF {
  constructor(t) {
    this.packet = t, this.buffers = [], this.reconPack = t;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(t) {
    if (this.buffers.push(t), this.buffers.length === this.reconPack.attachments) {
      const n = UF(this.reconPack, this.buffers);
      return this.finishedReconstruction(), n;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const KF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: am,
  Encoder: WF,
  get PacketType() {
    return ct;
  },
  protocol: qF
}, Symbol.toStringTag, { value: "Module" }));
function Ar(e, t, n) {
  return e.on(t, n), function() {
    e.off(t, n);
  };
}
const GF = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class ST extends Qt {
  /**
   * `Socket` constructor.
   */
  constructor(t, n, r) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = t, this.nsp = n, r && r.auth && (this.auth = r.auth), this._opts = Object.assign({}, r), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const t = this.io;
    this.subs = [
      Ar(t, "open", this.onopen.bind(this)),
      Ar(t, "packet", this.onpacket.bind(this)),
      Ar(t, "error", this.onerror.bind(this)),
      Ar(t, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...t) {
    return t.unshift("message"), this.emit.apply(this, t), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(t, ...n) {
    var r, i, a;
    if (GF.hasOwnProperty(t))
      throw new Error('"' + t.toString() + '" is a reserved event name');
    if (n.unshift(t), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(n), this;
    const s = {
      type: ct.EVENT,
      data: n
    };
    if (s.options = {}, s.options.compress = this.flags.compress !== !1, typeof n[n.length - 1] == "function") {
      const c = this.ids++, d = n.pop();
      this._registerAckCallback(c, d), s.id = c;
    }
    const o = (i = (r = this.io.engine) === null || r === void 0 ? void 0 : r.transport) === null || i === void 0 ? void 0 : i.writable, l = this.connected && !(!((a = this.io.engine) === null || a === void 0) && a._hasPingExpired());
    return this.flags.volatile && !o || (l ? (this.notifyOutgoingListeners(s), this.packet(s)) : this.sendBuffer.push(s)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(t, n) {
    var r;
    const i = (r = this.flags.timeout) !== null && r !== void 0 ? r : this._opts.ackTimeout;
    if (i === void 0) {
      this.acks[t] = n;
      return;
    }
    const a = this.io.setTimeoutFn(() => {
      delete this.acks[t];
      for (let o = 0; o < this.sendBuffer.length; o++)
        this.sendBuffer[o].id === t && this.sendBuffer.splice(o, 1);
      n.call(this, new Error("operation has timed out"));
    }, i), s = (...o) => {
      this.io.clearTimeoutFn(a), n.apply(this, o);
    };
    s.withError = !0, this.acks[t] = s;
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(t, ...n) {
    return new Promise((r, i) => {
      const a = (s, o) => s ? i(s) : r(o);
      a.withError = !0, n.push(a), this.emit(t, ...n);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(t) {
    let n;
    typeof t[t.length - 1] == "function" && (n = t.pop());
    const r = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: t,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    t.push((i, ...a) => r !== this._queue[0] ? void 0 : (i !== null ? r.tryCount > this._opts.retries && (this._queue.shift(), n && n(i)) : (this._queue.shift(), n && n(null, ...a)), r.pending = !1, this._drainQueue())), this._queue.push(r), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(t = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const n = this._queue[0];
    n.pending && !t || (n.pending = !0, n.tryCount++, this.flags = n.flags, this.emit.apply(this, n.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(t) {
    t.nsp = this.nsp, this.io._packet(t);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((t) => {
      this._sendConnectPacket(t);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(t) {
    this.packet({
      type: ct.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, t) : t
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(t) {
    this.connected || this.emitReserved("connect_error", t);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(t, n) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", t, n), this._clearAcks();
  }
  /**
   * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
   * the server.
   *
   * @private
   */
  _clearAcks() {
    Object.keys(this.acks).forEach((t) => {
      if (!this.sendBuffer.some((r) => String(r.id) === t)) {
        const r = this.acks[t];
        delete this.acks[t], r.withError && r.call(this, new Error("socket has been disconnected"));
      }
    });
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(t) {
    if (t.nsp === this.nsp)
      switch (t.type) {
        case ct.CONNECT:
          t.data && t.data.sid ? this.onconnect(t.data.sid, t.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case ct.EVENT:
        case ct.BINARY_EVENT:
          this.onevent(t);
          break;
        case ct.ACK:
        case ct.BINARY_ACK:
          this.onack(t);
          break;
        case ct.DISCONNECT:
          this.ondisconnect();
          break;
        case ct.CONNECT_ERROR:
          this.destroy();
          const r = new Error(t.data.message);
          r.data = t.data.data, this.emitReserved("connect_error", r);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(t) {
    const n = t.data || [];
    t.id != null && n.push(this.ack(t.id)), this.connected ? this.emitEvent(n) : this.receiveBuffer.push(Object.freeze(n));
  }
  emitEvent(t) {
    if (this._anyListeners && this._anyListeners.length) {
      const n = this._anyListeners.slice();
      for (const r of n)
        r.apply(this, t);
    }
    super.emit.apply(this, t), this._pid && t.length && typeof t[t.length - 1] == "string" && (this._lastOffset = t[t.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(t) {
    const n = this;
    let r = !1;
    return function(...i) {
      r || (r = !0, n.packet({
        type: ct.ACK,
        id: t,
        data: i
      }));
    };
  }
  /**
   * Called upon a server acknowledgement.
   *
   * @param packet
   * @private
   */
  onack(t) {
    const n = this.acks[t.id];
    typeof n == "function" && (delete this.acks[t.id], n.withError && t.data.unshift(null), n.apply(this, t.data));
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(t, n) {
    this.id = t, this.recovered = n && this._pid === n, this._pid = n, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((t) => this.emitEvent(t)), this.receiveBuffer = [], this.sendBuffer.forEach((t) => {
      this.notifyOutgoingListeners(t), this.packet(t);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((t) => t()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: ct.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(t) {
    return this.flags.compress = t, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(t) {
    return this.flags.timeout = t, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(t) {
    if (!this._anyListeners)
      return this;
    if (t) {
      const n = this._anyListeners;
      for (let r = 0; r < n.length; r++)
        if (t === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(t) {
    if (!this._anyOutgoingListeners)
      return this;
    if (t) {
      const n = this._anyOutgoingListeners;
      for (let r = 0; r < n.length; r++)
        if (t === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(t) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const n = this._anyOutgoingListeners.slice();
      for (const r of n)
        r.apply(this, t.data);
    }
  }
}
function Qs(e) {
  e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
Qs.prototype.duration = function() {
  var e = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var t = Math.random(), n = Math.floor(t * this.jitter * e);
    e = Math.floor(t * 10) & 1 ? e + n : e - n;
  }
  return Math.min(e, this.max) | 0;
};
Qs.prototype.reset = function() {
  this.attempts = 0;
};
Qs.prototype.setMin = function(e) {
  this.ms = e;
};
Qs.prototype.setMax = function(e) {
  this.max = e;
};
Qs.prototype.setJitter = function(e) {
  this.jitter = e;
};
class jh extends Qt {
  constructor(t, n) {
    var r;
    super(), this.nsps = {}, this.subs = [], t && typeof t == "object" && (n = t, t = void 0), n = n || {}, n.path = n.path || "/socket.io", this.opts = n, f1(this, n), this.reconnection(n.reconnection !== !1), this.reconnectionAttempts(n.reconnectionAttempts || 1 / 0), this.reconnectionDelay(n.reconnectionDelay || 1e3), this.reconnectionDelayMax(n.reconnectionDelayMax || 5e3), this.randomizationFactor((r = n.randomizationFactor) !== null && r !== void 0 ? r : 0.5), this.backoff = new Qs({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(n.timeout == null ? 2e4 : n.timeout), this._readyState = "closed", this.uri = t;
    const i = n.parser || KF;
    this.encoder = new i.Encoder(), this.decoder = new i.Decoder(), this._autoConnect = n.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(t) {
    return arguments.length ? (this._reconnection = !!t, t || (this.skipReconnect = !0), this) : this._reconnection;
  }
  reconnectionAttempts(t) {
    return t === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = t, this);
  }
  reconnectionDelay(t) {
    var n;
    return t === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = t, (n = this.backoff) === null || n === void 0 || n.setMin(t), this);
  }
  randomizationFactor(t) {
    var n;
    return t === void 0 ? this._randomizationFactor : (this._randomizationFactor = t, (n = this.backoff) === null || n === void 0 || n.setJitter(t), this);
  }
  reconnectionDelayMax(t) {
    var n;
    return t === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = t, (n = this.backoff) === null || n === void 0 || n.setMax(t), this);
  }
  timeout(t) {
    return arguments.length ? (this._timeout = t, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(t) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new FF(this.uri, this.opts);
    const n = this.engine, r = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const i = Ar(n, "open", function() {
      r.onopen(), t && t();
    }), a = (o) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", o), t ? t(o) : this.maybeReconnectOnOpen();
    }, s = Ar(n, "error", a);
    if (this._timeout !== !1) {
      const o = this._timeout, l = this.setTimeoutFn(() => {
        i(), a(new Error("timeout")), n.close();
      }, o);
      this.opts.autoUnref && l.unref(), this.subs.push(() => {
        this.clearTimeoutFn(l);
      });
    }
    return this.subs.push(i), this.subs.push(s), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(t) {
    return this.open(t);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const t = this.engine;
    this.subs.push(
      Ar(t, "ping", this.onping.bind(this)),
      Ar(t, "data", this.ondata.bind(this)),
      Ar(t, "error", this.onerror.bind(this)),
      Ar(t, "close", this.onclose.bind(this)),
      // @ts-ignore
      Ar(this.decoder, "decoded", this.ondecoded.bind(this))
    );
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(t) {
    try {
      this.decoder.add(t);
    } catch (n) {
      this.onclose("parse error", n);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(t) {
    d1(() => {
      this.emitReserved("packet", t);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(t) {
    this.emitReserved("error", t);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(t, n) {
    let r = this.nsps[t];
    return r ? this._autoConnect && !r.active && r.connect() : (r = new ST(this, t, n), this.nsps[t] = r), r;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(t) {
    const n = Object.keys(this.nsps);
    for (const r of n)
      if (this.nsps[r].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(t) {
    const n = this.encoder.encode(t);
    for (let r = 0; r < n.length; r++)
      this.engine.write(n[r], t.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((t) => t()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called when:
   *
   * - the low-level engine is closed
   * - the parser encountered a badly formatted packet
   * - all sockets are disconnected
   *
   * @private
   */
  onclose(t, n) {
    var r;
    this.cleanup(), (r = this.engine) === null || r === void 0 || r.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", t, n), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const t = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const n = this.backoff.duration();
      this._reconnecting = !0;
      const r = this.setTimeoutFn(() => {
        t.skipReconnect || (this.emitReserved("reconnect_attempt", t.backoff.attempts), !t.skipReconnect && t.open((i) => {
          i ? (t._reconnecting = !1, t.reconnect(), this.emitReserved("reconnect_error", i)) : t.onreconnect();
        }));
      }, n);
      this.opts.autoUnref && r.unref(), this.subs.push(() => {
        this.clearTimeoutFn(r);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const t = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", t);
  }
}
const mo = {};
function gc(e, t) {
  typeof e == "object" && (t = e, e = void 0), t = t || {};
  const n = BF(e, t.path || "/socket.io"), r = n.source, i = n.id, a = n.path, s = mo[i] && a in mo[i].nsps, o = t.forceNew || t["force new connection"] || t.multiplex === !1 || s;
  let l;
  return o ? l = new jh(r, t) : (mo[i] || (mo[i] = new jh(r, t)), l = mo[i]), n.query && !t.query && (t.query = n.queryKey), l.socket(n.path, t);
}
Object.assign(gc, {
  Manager: jh,
  Socket: ST,
  io: gc,
  connect: gc
});
const m9 = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (c, d) => {
    const f = typeof c == "function" ? c(t) : c;
    if (!Object.is(f, t)) {
      const p = t;
      t = d ?? (typeof f != "object" || f === null) ? f : Object.assign({}, t, f), n.forEach((g) => g(t, p));
    }
  }, i = () => t, l = { setState: r, getState: i, getInitialState: () => u, subscribe: (c) => (n.add(c), () => n.delete(c)), destroy: () => {
    n.clear();
  } }, u = t = e(r, i, l);
  return l;
}, kT = (e) => e ? m9(e) : m9;
function YF(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, n) {
    var r = e.get(t);
    r ? r.push(n) : e.set(t, [n]);
  }, off: function(t, n) {
    var r = e.get(t);
    r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, n) {
    var r = e.get(t);
    r && r.slice().map(function(i) {
      i(n);
    }), (r = e.get("*")) && r.slice().map(function(i) {
      i(t, n);
    });
  } };
}
function Wn() {
  return Wn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wn.apply(this, arguments);
}
class ZF extends Error {
  constructor(t) {
    super(t), this.name = void 0, this.name = "SuprSendError";
  }
}
function Oa() {
  return Math.round(Date.now());
}
function ma() {
  var e = (/* @__PURE__ */ new Date()).getTime(), t = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(n) {
    var r = (e + Math.random() * 16) % 16 | 0;
    return e = Math.floor(e / 16), (n == "x" ? r : r & 3 | 8).toString(16);
  });
  return t;
}
const Tn = kT()(() => ({
  apiUrl: "https://inboxs.live",
  collectorApiUrl: "https://hub.suprsend.com",
  socketUrl: "https://betainbox.suprsend.com",
  pageSize: 20
})), QF = {
  unseenCount: 0,
  stores: {},
  activeStoreId: null,
  pageNumber: 1,
  hasNext: !0,
  initialLoading: !1,
  fetchMoreLoading: !1,
  initialFetchTime: null
}, ut = kT()(() => QF);
class XF {
  constructor(t) {
    this.socket = void 0, this.config = void 0, this.config = t;
    const n = Tn.getState();
    this.socket = gc(n.socketUrl, {
      transports: ["websocket"],
      auth: {
        subscriber_id: this.config.subscriberId,
        distinct_id: this.config.distinctId,
        authorization: `${this.config.workspaceKey}:${ma()}`,
        tenant_id: this.config.tenantId
      },
      reconnectionAttempts: 25,
      reconnectionDelay: 5e3,
      reconnectionDelayMax: 1e4
    }), this._initializeSocketEvents();
  }
  orderNotifications(t, n) {
    if (t.is_pinned)
      return [t, ...n];
    {
      let r = !1, i = [];
      return n.forEach((a) => {
        a.is_pinned || r ? i.push(a) : (i.push(t), i.push(a), r = !0);
      }), r ? i : [...n, t];
    }
  }
  _initializeSocketEvents() {
    var t = this;
    this.socket.on("new_notification", async function(n) {
      n.n_id && setTimeout(async function() {
        try {
          const i = await (await t.getNotificationDetails(n.n_id)).json(), a = ut.getState();
          if (t.config.stores) {
            let s = !1;
            for (let o of t.config.stores) {
              const l = a.stores[o.storeId];
              t._notificationBelongToStore(i.data, o) && (s = !0, l.notifications = t.orderNotifications(i.data, l.notifications), l.unseenCount += 1);
            }
            s && (a.unseenCount += 1, t.config.emitter.emit("new_notification", i.data)), ut.setState({
              unseenCount: a.unseenCount,
              stores: Wn({}, a.stores)
            });
          } else {
            if (!a.activeStoreId)
              return;
            let s = a.stores[a.activeStoreId];
            a.unseenCount += 1, s.unseenCount += 1, s.notifications = t.orderNotifications(i.data, s.notifications), ut.setState({
              unseenCount: a.unseenCount,
              stores: Wn({}, a.stores)
            }), t.config.emitter.emit("new_notification", i.data);
          }
          t.config.emitter.emit("sync_notif_store");
        } catch (r) {
          console.log("SuprSend: error in new_notification event", r);
        }
      }, 1e3);
    }), this.socket.on("notification_updated", async function(n) {
      n.n_id && setTimeout(async function() {
        try {
          const a = await Promise.allSettled([t.getNotificationDetails(n.n_id), t.getNotificationsCount()]), s = ut.getState();
          let o = s.activeStoreId;
          if (a[0].status === "fulfilled") {
            var r;
            const u = await a[0].value.json(), c = u.data;
            if (!o)
              return;
            let d = s.stores[o];
            const f = (r = t.config.stores) == null ? void 0 : r.find((p) => p.storeId === o);
            if ((n == null ? void 0 : n.type) === "archive") {
              var i;
              f != null && (i = f.query) != null && i.archived ? t._notificationBelongToStore(c, f) && (s.stores[o].notifications = [c, ...d.notifications]) : s.stores[o].notifications = d.notifications.filter((p) => p.n_id !== n.n_id);
            } else
              s.stores[o].notifications = d.notifications.map((p) => p.n_id === n.n_id ? u.data : p);
            ut.setState({
              stores: Wn({}, s.stores)
            });
          }
          if (a[1].status === "fulfilled") {
            const u = await a[1].value.json();
            ut.setState((c) => {
              for (let d in c.stores) {
                const f = c.stores[d];
                f.unseenCount = u[d] || 0;
              }
              return {
                unseenCount: u.ss_bell_count,
                stores: Wn({}, c.stores)
              };
            });
          }
          t.config.emitter.emit("sync_notif_store");
        } catch (a) {
          console.log("SuprSend: error in notification_updated event", a);
        }
      }, 1e3);
    }), this.socket.on("update_badge", async function() {
      ut.setState({
        unseenCount: 0
      }), t.config.emitter.emit("sync_notif_store");
    }), this.socket.on("mark_all_read", async function() {
      const n = ut.getState(), r = Oa();
      for (let i in n.stores) {
        const a = n.stores[i];
        a.notifications.forEach((s) => {
          s.seen_on || (s.seen_on = r);
        }), a.unseenCount = 0;
      }
      ut.setState({
        stores: n.stores
      }), t.config.emitter.emit("sync_notif_store");
    });
  }
  _notificationBelongToStore(t, n) {
    var r, i, a, s;
    const o = !!t.seen_on, l = t.archived, u = t.tags, c = t.n_category, d = n == null || (r = n.query) == null ? void 0 : r.read, f = n == null || (i = n.query) == null ? void 0 : i.archived, p = n == null || (a = n.query) == null ? void 0 : a.tags, g = n == null || (s = n.query) == null ? void 0 : s.categories, m = !d || o === d, y = !f || l === f;
    let v, E;
    return Array.isArray(p) && p.length > 0 ? p.forEach((b) => {
      u != null && u.includes(b) && (v = !0);
    }) : v = !0, Array.isArray(g) && g.length > 0 ? g.includes(c) && (E = !0) : E = !0, m && v && E && y;
  }
  _getStoreQueryString(t) {
    const n = t == null ? void 0 : t.query;
    let r = (n == null ? void 0 : n.tags) || [], i = (n == null ? void 0 : n.categories) || [];
    const a = n == null ? void 0 : n.read, s = n == null ? void 0 : n.archived;
    return {
      store_id: t.storeId,
      query: {
        read: a,
        archived: s,
        tags: {
          or: r
        },
        categories: {
          or: i
        }
      }
    };
  }
  _getStoresQueryString() {
    const t = this.config.stores;
    return t == null ? void 0 : t.map((r) => this._getStoreQueryString(r));
  }
  getNotificationsCount() {
    const {
      apiUrl: t
    } = Tn.getState();
    let n = `/notification_count/?subscriber_id=${this.config.subscriberId}&distinct_id=${this.config.distinctId}&tenant_id=${this.config.tenantId}`;
    if (this.config.stores) {
      const r = this._getStoresQueryString();
      n += `&stores=${encodeURIComponent(JSON.stringify(r))}`;
    }
    return fetch(`${t}${n}`, {
      method: "GET",
      headers: {
        Authorization: `${this.config.workspaceKey}:${ma()}`
      }
    });
  }
  getNotifications(t, n, r = 20, i) {
    const {
      apiUrl: a
    } = Tn.getState();
    let s = `/notifications/?subscriber_id=${this.config.subscriberId}&distinct_id=${this.config.distinctId}&tenant_id=${this.config.tenantId}&page_no=${n}&page_size=${r}&before=${i}`;
    if (t) {
      const o = this._getStoreQueryString(t);
      s += `&store=${encodeURIComponent(JSON.stringify(o))}`;
    }
    return fetch(`${a}${s}`, {
      method: "GET",
      headers: {
        Authorization: `${this.config.workspaceKey}:${ma()}`
      }
    });
  }
  getNotificationDetails(t) {
    const {
      apiUrl: n
    } = Tn.getState(), r = `/notification/${t}/?subscriber_id=${this.config.subscriberId}&distinct_id=${this.config.distinctId}&tenant_id=${this.config.tenantId}`;
    return fetch(`${n}${r}`, {
      method: "GET",
      headers: {
        Authorization: `${this.config.workspaceKey}:${ma()}`
      }
    });
  }
  markBellClicked() {
    const {
      apiUrl: t
    } = Tn.getState(), n = "/bell-clicked/", r = JSON.stringify({
      time: Oa(),
      distinct_id: this.config.distinctId,
      subscriber_id: this.config.subscriberId,
      tenant_id: this.config.tenantId
    });
    return fetch(`${t}${n}`, {
      method: "POST",
      body: r,
      headers: {
        Authorization: `${this.config.workspaceKey}:${ma()}`,
        "Content-Type": "application/json"
      }
    });
  }
  markAllRead() {
    const {
      apiUrl: t
    } = Tn.getState(), n = "/mark-all-read/", r = JSON.stringify({
      time: Oa(),
      distinct_id: this.config.distinctId,
      subscriber_id: this.config.subscriberId,
      tenant_id: this.config.tenantId
    });
    return fetch(`${t}${n}`, {
      method: "POST",
      body: r,
      headers: {
        Authorization: `${this.config.workspaceKey}:${ma()}`,
        "Content-Type": "application/json"
      }
    });
  }
  markNotificationClicked(t) {
    const {
      collectorApiUrl: n
    } = Tn.getState(), r = {
      event: "$notification_clicked",
      env: this.config.workspaceKey,
      $insert_id: ma(),
      $time: Oa(),
      properties: {
        id: t
      }
    };
    return fetch(`${n}/event/`, {
      method: "POST",
      body: JSON.stringify(r),
      headers: {
        Authorization: `${this.config.workspaceKey}:`,
        "Content-Type": "application/json"
      }
    });
  }
  markNotificationRead(t) {
    const {
      apiUrl: n
    } = Tn.getState();
    return fetch(`${n}/notification/${t}/action`, {
      method: "POST",
      body: JSON.stringify({
        action: "read",
        distinct_id: this.config.distinctId,
        subscriber_id: this.config.subscriberId
      }),
      headers: {
        Authorization: `${this.config.workspaceKey}:`,
        "Content-Type": "application/json"
      }
    });
  }
  markNotificationUnRead(t) {
    const {
      apiUrl: n
    } = Tn.getState();
    return fetch(`${n}/notification/${t}/action`, {
      method: "POST",
      body: JSON.stringify({
        action: "unread",
        distinct_id: this.config.distinctId,
        subscriber_id: this.config.subscriberId
      }),
      headers: {
        Authorization: `${this.config.workspaceKey}:`,
        "Content-Type": "application/json"
      }
    });
  }
  markNotificationArchive(t) {
    const {
      apiUrl: n
    } = Tn.getState();
    return fetch(`${n}/notification/${t}/action`, {
      method: "POST",
      body: JSON.stringify({
        action: "archive",
        distinct_id: this.config.distinctId,
        subscriber_id: this.config.subscriberId
      }),
      headers: {
        Authorization: `${this.config.workspaceKey}:`,
        "Content-Type": "application/json"
      }
    });
  }
}
let g9 = class {
  constructor(t) {
    this.config = void 0, this.config = t;
  }
  _overallFirstApiCall() {
    const t = ut.getState();
    for (let n in t.stores)
      if (t.stores[n].isFirstCall === !1)
        return !1;
    return !0;
  }
  async fetchNotifications() {
    var t, n;
    const r = this.config.client, i = ut.getState(), a = Tn.getState(), s = i.activeStoreId;
    if (!s || !((t = i.stores) != null && t[s]))
      return;
    const o = i.stores[s], l = o.isFirstCall, u = i.initialFetchTime || Date.now(), c = (n = this.config.stores) == null ? void 0 : n.find((d) => d.storeId === s);
    try {
      if (!r || !i.hasNext)
        return;
      l ? (ut.setState({
        initialLoading: !0
      }), this._overallFirstApiCall() && this.getNotificationsCount()) : i.pageNumber > 1 && ut.setState({
        fetchMoreLoading: !0
      }), this.config.emitter.emit("sync_notif_store");
      const f = await (await r.getNotifications(c, i.pageNumber, a.pageSize, u)).json();
      let p;
      l || !l && i.pageNumber === 1 ? p = f.results : p = [...o.notifications, ...f.results], i.stores[s].notifications = p, i.stores[s].isFirstCall = !1, ut.setState({
        stores: i.stores,
        pageNumber: i.pageNumber + 1,
        hasNext: f.meta.current_page < f.meta.total_pages,
        initialFetchTime: u,
        initialLoading: !1,
        fetchMoreLoading: !1
      }), this.config.emitter.emit("sync_notif_store"), this.config._startExipryCheck();
    } catch (d) {
      console.log("SUPRSEND: error getting latest notifications", d), ut.setState({
        initialLoading: !1,
        fetchMoreLoading: !1
      }), this.config.emitter.emit("sync_notif_store");
    }
  }
  async getNotificationsCount() {
    const t = this.config.client;
    if (t)
      try {
        const r = await (await t.getNotificationsCount()).json();
        ut.setState((i) => {
          for (let a in i.stores) {
            const s = i.stores[a];
            s.unseenCount = r[a] || 0;
          }
          return {
            unseenCount: r.ss_bell_count,
            stores: Wn({}, i.stores)
          };
        }), this.config.emitter.emit("sync_notif_store");
      } catch (n) {
        console.log("SUPRSEND: error getting notifications count", n);
      }
  }
  async markClicked(t) {
    var n;
    const r = this.config.client, i = ut.getState(), a = i.activeStoreId;
    if (!a || !((n = i.stores) != null && n[a]))
      return;
    const l = i.stores[a].notifications.find((c) => c.n_id === t);
    if (l && (!l.interacted_on || !l.seen_on)) {
      if (!r)
        return;
      try {
        l.interacted_on ? l.seen_on || r.markNotificationRead(t) : r.markNotificationClicked(t);
        const c = Oa();
        if (l.interacted_on = c, !l.seen_on)
          for (let d in i == null ? void 0 : i.stores) {
            var u;
            const f = i.stores[d];
            (u = f.notifications) == null || u.forEach((p) => {
              p.n_id === l.n_id && (p.seen_on = c, p.interacted_on = c, f.unseenCount > 0 && (f.unseenCount -= 1));
            });
          }
        ut.setState(Wn({}, i)), this.config.emitter.emit("sync_notif_store");
      } catch (c) {
        console.log("SUPRSEND: error marking notification clicked", c);
      }
    }
  }
  async markAllSeen() {
    const t = this.config.client;
    try {
      if (!t)
        return;
      t.markBellClicked(), ut.setState({
        unseenCount: 0
      }), this.config.emitter.emit("sync_notif_store");
    } catch (n) {
      console.log("SUPRSEND: error marking all notifications seen", n);
    }
  }
  async markAllRead() {
    const t = this.config.client;
    try {
      if (!t)
        return;
      t.markAllRead();
      const n = ut.getState(), r = Oa();
      for (let i in n.stores) {
        const a = n.stores[i];
        a.notifications.forEach((s) => {
          s.seen_on || (s.seen_on = r);
        }), a.unseenCount = 0;
      }
      ut.setState({
        stores: n.stores
      }), this.config.emitter.emit("sync_notif_store");
    } catch (n) {
      console.log("SUPRSEND: error marking all notifications read", n);
    }
  }
  async markRead(t) {
    var n;
    const r = this.config.client, i = ut.getState(), a = i.activeStoreId;
    if (!a || !((n = i.stores) != null && n[a]))
      return;
    const l = i.stores[a].notifications.find((c) => c.n_id === t);
    if (l && !l.seen_on) {
      if (!r)
        return;
      try {
        r.markNotificationRead(t);
        const c = Oa();
        if (!l.seen_on)
          for (let d in i == null ? void 0 : i.stores) {
            var u;
            const f = i.stores[d];
            (u = f.notifications) == null || u.forEach((p) => {
              p.n_id === l.n_id && (p.seen_on = c, f.unseenCount > 0 && (f.unseenCount -= 1));
            });
          }
        ut.setState(Wn({}, i)), this.config.emitter.emit("sync_notif_store");
      } catch (c) {
        console.log("SUPRSEND: error marking notification read", c);
      }
    }
  }
  async markUnRead(t) {
    var n;
    const r = this.config.client, i = ut.getState(), a = i.activeStoreId;
    if (!a || !((n = i.stores) != null && n[a]))
      return;
    const l = i.stores[a].notifications.find((c) => c.n_id === t);
    if (l && l.seen_on) {
      if (!r)
        return;
      try {
        if (r.markNotificationUnRead(t), l.seen_on)
          for (let c in i == null ? void 0 : i.stores) {
            var u;
            const d = i.stores[c];
            (u = d.notifications) == null || u.forEach((f) => {
              f.n_id === l.n_id && (f.seen_on = void 0, d.unseenCount >= 0 && (d.unseenCount += 1));
            });
          }
        ut.setState(Wn({}, i)), this.config.emitter.emit("sync_notif_store");
      } catch (c) {
        console.log("SUPRSEND: error marking notification read", c);
      }
    }
  }
  markArchived(t) {
    var n;
    const r = this.config.client, i = ut.getState(), a = i.activeStoreId;
    if (!a || !((n = i.stores) != null && n[a]))
      return;
    const o = (i == null ? void 0 : i.stores)[a], l = o.notifications.find((u) => u.n_id === t);
    if (l && !l.archived) {
      if (!r)
        return;
      try {
        r.markNotificationArchive(t), o.notifications = o.notifications.filter((u) => u.n_id !== t), !l.seen_on && o.unseenCount > 0 && (o.unseenCount -= 1), ut.setState(Wn({}, i)), this.config.emitter.emit("sync_notif_store");
      } catch (u) {
        console.log("SUPRSEND: error marking notification archived", u);
      }
    }
  }
  get stores() {
    return this.config.stores;
  }
  get data() {
    const t = ut.getState(), n = t.activeStoreId, r = this.stores;
    if (n)
      return {
        unseenCount: t.unseenCount,
        activeStoreId: t.activeStoreId,
        stores: t.stores,
        hasStores: r ? (r == null ? void 0 : r.length) > 0 : !1,
        hasNext: t.hasNext,
        initialLoading: t.initialLoading,
        fetchMoreLoading: t.fetchMoreLoading
      };
  }
};
class JF {
  constructor(t, n) {
    this.workspaceKey = "", this.tenantId = void 0, this.stores = void 0, this.distinctId = void 0, this.subscriberId = void 0, this._client = void 0, this._expiryTimerId = void 0, this.feed = new g9(this), this.emitter = YF(), this._validateConfig(t), this._setConfigStoreState((n == null ? void 0 : n.host) || {}), this.tenantId = (n == null ? void 0 : n.tenantID) || "default", this._validateStore(n == null ? void 0 : n.stores), this._validatePageSize(n == null ? void 0 : n.pageSize), this._initializeStoreState();
  }
  _validateConfig(t) {
    if (t)
      this.workspaceKey = t;
    else
      throw new ZF("workspaceKey missing");
  }
  _validateStore(t) {
    if (!t || !Array.isArray(t))
      return;
    const n = [];
    t.forEach((r) => {
      if (!r.storeId) {
        console.log("SuprSendInbox: storeId is mandatory if stores are used");
        return;
      }
      const i = r == null ? void 0 : r.query;
      let a, s = [], o = [], l;
      typeof (i == null ? void 0 : i.read) == "boolean" && (a = i.read), typeof (i == null ? void 0 : i.archived) == "boolean" && (l = i.archived), typeof (i == null ? void 0 : i.tags) == "string" ? s = [i.tags] : Array.isArray(i == null ? void 0 : i.tags) && (s = i == null ? void 0 : i.tags.filter((u) => typeof u == "string")), typeof (i == null ? void 0 : i.categories) == "string" ? o = [i.categories] : Array.isArray(i == null ? void 0 : i.categories) && (o = i == null ? void 0 : i.categories.filter((u) => typeof u == "string")), n.push({
        storeId: r.storeId,
        label: r.label || r.storeId,
        query: {
          archived: l,
          read: a,
          tags: s,
          categories: o
        }
      });
    }), this.stores = n;
  }
  _validatePageSize(t) {
    if (t && typeof t == "number") {
      const r = t <= 50 ? t : 50;
      Tn.setState({
        pageSize: r
      });
    }
  }
  _setConfigStoreState(t) {
    t && (t != null && t.socketHost && Tn.setState({
      socketUrl: t.socketHost
    }), t != null && t.apiHost && Tn.setState({
      apiUrl: t.apiHost
    }), t != null && t.collectorHost && Tn.setState({
      collectorApiUrl: t.collectorHost
    }));
  }
  _initializeStoreState() {
    const t = "default_store", n = {
      notifications: [],
      unseenCount: 0,
      isFirstCall: !0
    };
    if (this.stores && Array.isArray(this.stores) && this.stores.length > 0) {
      const r = {};
      this.stores.map((i) => {
        r[i.storeId] = Wn({}, n);
      }), ut.setState({
        stores: r,
        activeStoreId: this.stores[0].storeId
      });
    } else
      ut.setState({
        stores: {
          [t]: Wn({}, n)
        },
        activeStoreId: t
      });
    setTimeout(() => {
      this.emitter.emit("sync_notif_store");
    }, 0);
  }
  _startExipryCheck() {
    var t = this;
    this._expiryTimerId || (this._expiryTimerId = setInterval(async function() {
      const r = ut.getState().stores;
      let i = !1;
      for (let a in r) {
        let s = r[a].notifications;
        s = s.filter((o) => (o.expiry ? Date.now() > o.expiry : !1) ? (i = !0, !1) : !0), r[a].notifications = s;
      }
      i && (ut.setState({
        stores: r
      }), await t.feed.getNotificationsCount(), t.emitter.emit("sync_notif_store"));
    }, 3e4));
  }
  get client() {
    return this.distinctId && this.subscriberId && (this._client || (this._client = new XF(this))), this._client;
  }
  identifyUser(t, n) {
    this.distinctId = t, this.subscriberId = n;
  }
  changeActiveStore(t) {
    var n;
    const r = ut.getState(), i = {};
    if (r.activeStoreId !== t && (n = r.stores) != null && n[t]) {
      for (let a in r.stores) {
        const s = r.stores[a], o = s.notifications.slice(0, 20);
        i[a] = {
          notifications: o,
          unseenCount: s.unseenCount,
          isFirstCall: s.isFirstCall
        };
      }
      ut.setState({
        activeStoreId: t,
        stores: i,
        pageNumber: 1,
        hasNext: !0,
        initialLoading: !1,
        fetchMoreLoading: !1,
        initialFetchTime: null
      }), this.client && this.feed.fetchNotifications();
    }
  }
  resetUser() {
    var t;
    ut.setState({
      unseenCount: 0,
      pageNumber: 1,
      hasNext: !0,
      initialLoading: !1,
      fetchMoreLoading: !1,
      initialFetchTime: null
    }), this._initializeStoreState(), (t = this._client) == null || t.socket.disconnect(), this.distinctId = void 0, this.subscriberId = void 0, this._client = void 0, clearInterval(this._expiryTimerId), this._expiryTimerId = void 0, this.feed = new g9(this);
  }
}
var v9 = function(t) {
  return t.reduce(function(n, r) {
    var i = r[0], a = r[1];
    return n[i] = a, n;
  }, {});
}, y9 = typeof window < "u" && window.document && window.document.createElement ? dn.useLayoutEffect : dn.useEffect, Fn = "top", hr = "bottom", pr = "right", Bn = "left", sm = "auto", Ll = [Fn, hr, pr, Bn], zs = "start", Cl = "end", eB = "clippingParents", DT = "viewport", go = "popper", tB = "reference", E9 = /* @__PURE__ */ Ll.reduce(function(e, t) {
  return e.concat([t + "-" + zs, t + "-" + Cl]);
}, []), OT = /* @__PURE__ */ [].concat(Ll, [sm]).reduce(function(e, t) {
  return e.concat([t, t + "-" + zs, t + "-" + Cl]);
}, []), nB = "beforeRead", rB = "read", iB = "afterRead", aB = "beforeMain", sB = "main", oB = "afterMain", lB = "beforeWrite", uB = "write", cB = "afterWrite", dB = [nB, rB, iB, aB, sB, oB, lB, uB, cB];
function Jr(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Zn(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ja(e) {
  var t = Zn(e).Element;
  return e instanceof t || e instanceof Element;
}
function dr(e) {
  var t = Zn(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function om(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Zn(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function fB(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, a = t.elements[n];
    !dr(a) || !Jr(a) || (Object.assign(a.style, r), Object.keys(i).forEach(function(s) {
      var o = i[s];
      o === !1 ? a.removeAttribute(s) : a.setAttribute(s, o === !0 ? "" : o);
    }));
  });
}
function hB(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], a = t.attributes[r] || {}, s = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), o = s.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !dr(i) || !Jr(i) || (Object.assign(i.style, o), Object.keys(a).forEach(function(l) {
        i.removeAttribute(l);
      }));
    });
  };
}
const pB = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: fB,
  effect: hB,
  requires: ["computeStyles"]
};
function Kr(e) {
  return e.split("-")[0];
}
var Fa = Math.max, Wc = Math.min, qs = Math.round;
function Hh() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function NT() {
  return !/^((?!chrome|android).)*safari/i.test(Hh());
}
function Ws(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, a = 1;
  t && dr(e) && (i = e.offsetWidth > 0 && qs(r.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && qs(r.height) / e.offsetHeight || 1);
  var s = ja(e) ? Zn(e) : window, o = s.visualViewport, l = !NT() && n, u = (r.left + (l && o ? o.offsetLeft : 0)) / i, c = (r.top + (l && o ? o.offsetTop : 0)) / a, d = r.width / i, f = r.height / a;
  return {
    width: d,
    height: f,
    top: c,
    right: u + d,
    bottom: c + f,
    left: u,
    x: u,
    y: c
  };
}
function lm(e) {
  var t = Ws(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function IT(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && om(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Ai(e) {
  return Zn(e).getComputedStyle(e);
}
function mB(e) {
  return ["table", "td", "th"].indexOf(Jr(e)) >= 0;
}
function ua(e) {
  return ((ja(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function h1(e) {
  return Jr(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (om(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ua(e)
  );
}
function b9(e) {
  return !dr(e) || // https://github.com/popperjs/popper-core/issues/837
  Ai(e).position === "fixed" ? null : e.offsetParent;
}
function gB(e) {
  var t = /firefox/i.test(Hh()), n = /Trident/i.test(Hh());
  if (n && dr(e)) {
    var r = Ai(e);
    if (r.position === "fixed")
      return null;
  }
  var i = h1(e);
  for (om(i) && (i = i.host); dr(i) && ["html", "body"].indexOf(Jr(i)) < 0; ) {
    var a = Ai(i);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function $l(e) {
  for (var t = Zn(e), n = b9(e); n && mB(n) && Ai(n).position === "static"; )
    n = b9(n);
  return n && (Jr(n) === "html" || Jr(n) === "body" && Ai(n).position === "static") ? t : n || gB(e) || t;
}
function um(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Zo(e, t, n) {
  return Fa(e, Wc(t, n));
}
function vB(e, t, n) {
  var r = Zo(e, t, n);
  return r > n ? n : r;
}
function PT() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function RT(e) {
  return Object.assign({}, PT(), e);
}
function FT(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var yB = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, RT(typeof t != "number" ? t : FT(t, Ll));
};
function EB(e) {
  var t, n = e.state, r = e.name, i = e.options, a = n.elements.arrow, s = n.modifiersData.popperOffsets, o = Kr(n.placement), l = um(o), u = [Bn, pr].indexOf(o) >= 0, c = u ? "height" : "width";
  if (!(!a || !s)) {
    var d = yB(i.padding, n), f = lm(a), p = l === "y" ? Fn : Bn, g = l === "y" ? hr : pr, m = n.rects.reference[c] + n.rects.reference[l] - s[l] - n.rects.popper[c], y = s[l] - n.rects.reference[l], v = $l(a), E = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, b = m / 2 - y / 2, _ = d[p], T = E - f[c] - d[g], x = E / 2 - f[c] / 2 + b, A = Zo(_, x, T), R = l;
    n.modifiersData[r] = (t = {}, t[R] = A, t.centerOffset = A - x, t);
  }
}
function bB(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || IT(t.elements.popper, i) && (t.elements.arrow = i));
}
const TB = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: EB,
  effect: bB,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Vs(e) {
  return e.split("-")[1];
}
var _B = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function CB(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: qs(n * i) / i || 0,
    y: qs(r * i) / i || 0
  };
}
function T9(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, a = e.variation, s = e.offsets, o = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, d = e.isFixed, f = s.x, p = f === void 0 ? 0 : f, g = s.y, m = g === void 0 ? 0 : g, y = typeof c == "function" ? c({
    x: p,
    y: m
  }) : {
    x: p,
    y: m
  };
  p = y.x, m = y.y;
  var v = s.hasOwnProperty("x"), E = s.hasOwnProperty("y"), b = Bn, _ = Fn, T = window;
  if (u) {
    var x = $l(n), A = "clientHeight", R = "clientWidth";
    if (x === Zn(n) && (x = ua(n), Ai(x).position !== "static" && o === "absolute" && (A = "scrollHeight", R = "scrollWidth")), x = x, i === Fn || (i === Bn || i === pr) && a === Cl) {
      _ = hr;
      var P = d && x === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        x[A]
      );
      m -= P - r.height, m *= l ? 1 : -1;
    }
    if (i === Bn || (i === Fn || i === hr) && a === Cl) {
      b = pr;
      var L = d && x === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        x[R]
      );
      p -= L - r.width, p *= l ? 1 : -1;
    }
  }
  var I = Object.assign({
    position: o
  }, u && _B), O = c === !0 ? CB({
    x: p,
    y: m
  }, Zn(n)) : {
    x: p,
    y: m
  };
  if (p = O.x, m = O.y, l) {
    var S;
    return Object.assign({}, I, (S = {}, S[_] = E ? "0" : "", S[b] = v ? "0" : "", S.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + m + "px)" : "translate3d(" + p + "px, " + m + "px, 0)", S));
  }
  return Object.assign({}, I, (t = {}, t[_] = E ? m + "px" : "", t[b] = v ? p + "px" : "", t.transform = "", t));
}
function xB(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, a = n.adaptive, s = a === void 0 ? !0 : a, o = n.roundOffsets, l = o === void 0 ? !0 : o, u = {
    placement: Kr(t.placement),
    variation: Vs(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, T9(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, T9(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const wB = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: xB,
  data: {}
};
var bu = {
  passive: !0
};
function AB(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, a = i === void 0 ? !0 : i, s = r.resize, o = s === void 0 ? !0 : s, l = Zn(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && u.forEach(function(c) {
    c.addEventListener("scroll", n.update, bu);
  }), o && l.addEventListener("resize", n.update, bu), function() {
    a && u.forEach(function(c) {
      c.removeEventListener("scroll", n.update, bu);
    }), o && l.removeEventListener("resize", n.update, bu);
  };
}
const SB = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: AB,
  data: {}
};
var kB = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function vc(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return kB[t];
  });
}
var DB = {
  start: "end",
  end: "start"
};
function _9(e) {
  return e.replace(/start|end/g, function(t) {
    return DB[t];
  });
}
function cm(e) {
  var t = Zn(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function dm(e) {
  return Ws(ua(e)).left + cm(e).scrollLeft;
}
function OB(e, t) {
  var n = Zn(e), r = ua(e), i = n.visualViewport, a = r.clientWidth, s = r.clientHeight, o = 0, l = 0;
  if (i) {
    a = i.width, s = i.height;
    var u = NT();
    (u || !u && t === "fixed") && (o = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: o + dm(e),
    y: l
  };
}
function NB(e) {
  var t, n = ua(e), r = cm(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, a = Fa(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = Fa(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), o = -r.scrollLeft + dm(e), l = -r.scrollTop;
  return Ai(i || n).direction === "rtl" && (o += Fa(n.clientWidth, i ? i.clientWidth : 0) - a), {
    width: a,
    height: s,
    x: o,
    y: l
  };
}
function fm(e) {
  var t = Ai(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function BT(e) {
  return ["html", "body", "#document"].indexOf(Jr(e)) >= 0 ? e.ownerDocument.body : dr(e) && fm(e) ? e : BT(h1(e));
}
function Qo(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = BT(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = Zn(r), s = i ? [a].concat(a.visualViewport || [], fm(r) ? r : []) : r, o = t.concat(s);
  return i ? o : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    o.concat(Qo(h1(s)))
  );
}
function Uh(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function IB(e, t) {
  var n = Ws(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function C9(e, t, n) {
  return t === DT ? Uh(OB(e, n)) : ja(t) ? IB(t, n) : Uh(NB(ua(e)));
}
function PB(e) {
  var t = Qo(h1(e)), n = ["absolute", "fixed"].indexOf(Ai(e).position) >= 0, r = n && dr(e) ? $l(e) : e;
  return ja(r) ? t.filter(function(i) {
    return ja(i) && IT(i, r) && Jr(i) !== "body";
  }) : [];
}
function RB(e, t, n, r) {
  var i = t === "clippingParents" ? PB(e) : [].concat(t), a = [].concat(i, [n]), s = a[0], o = a.reduce(function(l, u) {
    var c = C9(e, u, r);
    return l.top = Fa(c.top, l.top), l.right = Wc(c.right, l.right), l.bottom = Wc(c.bottom, l.bottom), l.left = Fa(c.left, l.left), l;
  }, C9(e, s, r));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function MT(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? Kr(r) : null, a = r ? Vs(r) : null, s = t.x + t.width / 2 - n.width / 2, o = t.y + t.height / 2 - n.height / 2, l;
  switch (i) {
    case Fn:
      l = {
        x: s,
        y: t.y - n.height
      };
      break;
    case hr:
      l = {
        x: s,
        y: t.y + t.height
      };
      break;
    case pr:
      l = {
        x: t.x + t.width,
        y: o
      };
      break;
    case Bn:
      l = {
        x: t.x - n.width,
        y: o
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = i ? um(i) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (a) {
      case zs:
        l[u] = l[u] - (t[c] / 2 - n[c] / 2);
        break;
      case Cl:
        l[u] = l[u] + (t[c] / 2 - n[c] / 2);
        break;
    }
  }
  return l;
}
function xl(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, a = n.strategy, s = a === void 0 ? e.strategy : a, o = n.boundary, l = o === void 0 ? eB : o, u = n.rootBoundary, c = u === void 0 ? DT : u, d = n.elementContext, f = d === void 0 ? go : d, p = n.altBoundary, g = p === void 0 ? !1 : p, m = n.padding, y = m === void 0 ? 0 : m, v = RT(typeof y != "number" ? y : FT(y, Ll)), E = f === go ? tB : go, b = e.rects.popper, _ = e.elements[g ? E : f], T = RB(ja(_) ? _ : _.contextElement || ua(e.elements.popper), l, c, s), x = Ws(e.elements.reference), A = MT({
    reference: x,
    element: b,
    strategy: "absolute",
    placement: i
  }), R = Uh(Object.assign({}, b, A)), P = f === go ? R : x, L = {
    top: T.top - P.top + v.top,
    bottom: P.bottom - T.bottom + v.bottom,
    left: T.left - P.left + v.left,
    right: P.right - T.right + v.right
  }, I = e.modifiersData.offset;
  if (f === go && I) {
    var O = I[i];
    Object.keys(L).forEach(function(S) {
      var F = [pr, hr].indexOf(S) >= 0 ? 1 : -1, H = [Fn, hr].indexOf(S) >= 0 ? "y" : "x";
      L[S] += O[H] * F;
    });
  }
  return L;
}
function FB(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, a = n.rootBoundary, s = n.padding, o = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? OT : l, c = Vs(r), d = c ? o ? E9 : E9.filter(function(g) {
    return Vs(g) === c;
  }) : Ll, f = d.filter(function(g) {
    return u.indexOf(g) >= 0;
  });
  f.length === 0 && (f = d);
  var p = f.reduce(function(g, m) {
    return g[m] = xl(e, {
      placement: m,
      boundary: i,
      rootBoundary: a,
      padding: s
    })[Kr(m)], g;
  }, {});
  return Object.keys(p).sort(function(g, m) {
    return p[g] - p[m];
  });
}
function BB(e) {
  if (Kr(e) === sm)
    return [];
  var t = vc(e);
  return [_9(e), t, _9(t)];
}
function MB(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, a = i === void 0 ? !0 : i, s = n.altAxis, o = s === void 0 ? !0 : s, l = n.fallbackPlacements, u = n.padding, c = n.boundary, d = n.rootBoundary, f = n.altBoundary, p = n.flipVariations, g = p === void 0 ? !0 : p, m = n.allowedAutoPlacements, y = t.options.placement, v = Kr(y), E = v === y, b = l || (E || !g ? [vc(y)] : BB(y)), _ = [y].concat(b).reduce(function(j, z) {
      return j.concat(Kr(z) === sm ? FB(t, {
        placement: z,
        boundary: c,
        rootBoundary: d,
        padding: u,
        flipVariations: g,
        allowedAutoPlacements: m
      }) : z);
    }, []), T = t.rects.reference, x = t.rects.popper, A = /* @__PURE__ */ new Map(), R = !0, P = _[0], L = 0; L < _.length; L++) {
      var I = _[L], O = Kr(I), S = Vs(I) === zs, F = [Fn, hr].indexOf(O) >= 0, H = F ? "width" : "height", q = xl(t, {
        placement: I,
        boundary: c,
        rootBoundary: d,
        altBoundary: f,
        padding: u
      }), N = F ? S ? pr : Bn : S ? hr : Fn;
      T[H] > x[H] && (N = vc(N));
      var Q = vc(N), J = [];
      if (a && J.push(q[O] <= 0), o && J.push(q[N] <= 0, q[Q] <= 0), J.every(function(j) {
        return j;
      })) {
        P = I, R = !1;
        break;
      }
      A.set(I, J);
    }
    if (R)
      for (var D = g ? 3 : 1, C = function(z) {
        var U = _.find(function($) {
          var ae = A.get($);
          if (ae)
            return ae.slice(0, z).every(function(Y) {
              return Y;
            });
        });
        if (U)
          return P = U, "break";
      }, Z = D; Z > 0; Z--) {
        var B = C(Z);
        if (B === "break")
          break;
      }
    t.placement !== P && (t.modifiersData[r]._skip = !0, t.placement = P, t.reset = !0);
  }
}
const LB = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: MB,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function x9(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function w9(e) {
  return [Fn, pr, hr, Bn].some(function(t) {
    return e[t] >= 0;
  });
}
function $B(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, a = t.modifiersData.preventOverflow, s = xl(t, {
    elementContext: "reference"
  }), o = xl(t, {
    altBoundary: !0
  }), l = x9(s, r), u = x9(o, i, a), c = w9(l), d = w9(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const jB = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: $B
};
function HB(e, t, n) {
  var r = Kr(e), i = [Bn, Fn].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = a[0], o = a[1];
  return s = s || 0, o = (o || 0) * i, [Bn, pr].indexOf(r) >= 0 ? {
    x: o,
    y: s
  } : {
    x: s,
    y: o
  };
}
function UB(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, a = i === void 0 ? [0, 0] : i, s = OT.reduce(function(c, d) {
    return c[d] = HB(d, t.rects, a), c;
  }, {}), o = s[t.placement], l = o.x, u = o.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = s;
}
const zB = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: UB
};
function qB(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = MT({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const WB = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: qB,
  data: {}
};
function VB(e) {
  return e === "x" ? "y" : "x";
}
function KB(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, a = i === void 0 ? !0 : i, s = n.altAxis, o = s === void 0 ? !1 : s, l = n.boundary, u = n.rootBoundary, c = n.altBoundary, d = n.padding, f = n.tether, p = f === void 0 ? !0 : f, g = n.tetherOffset, m = g === void 0 ? 0 : g, y = xl(t, {
    boundary: l,
    rootBoundary: u,
    padding: d,
    altBoundary: c
  }), v = Kr(t.placement), E = Vs(t.placement), b = !E, _ = um(v), T = VB(_), x = t.modifiersData.popperOffsets, A = t.rects.reference, R = t.rects.popper, P = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, L = typeof P == "number" ? {
    mainAxis: P,
    altAxis: P
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, P), I = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, O = {
    x: 0,
    y: 0
  };
  if (x) {
    if (a) {
      var S, F = _ === "y" ? Fn : Bn, H = _ === "y" ? hr : pr, q = _ === "y" ? "height" : "width", N = x[_], Q = N + y[F], J = N - y[H], D = p ? -R[q] / 2 : 0, C = E === zs ? A[q] : R[q], Z = E === zs ? -R[q] : -A[q], B = t.elements.arrow, j = p && B ? lm(B) : {
        width: 0,
        height: 0
      }, z = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : PT(), U = z[F], $ = z[H], ae = Zo(0, A[q], j[q]), Y = b ? A[q] / 2 - D - ae - U - L.mainAxis : C - ae - U - L.mainAxis, ee = b ? -A[q] / 2 + D + ae + $ + L.mainAxis : Z + ae + $ + L.mainAxis, se = t.elements.arrow && $l(t.elements.arrow), re = se ? _ === "y" ? se.clientTop || 0 : se.clientLeft || 0 : 0, Ae = (S = I == null ? void 0 : I[_]) != null ? S : 0, Oe = N + Y - Ae - re, Ce = N + ee - Ae, ue = Zo(p ? Wc(Q, Oe) : Q, N, p ? Fa(J, Ce) : J);
      x[_] = ue, O[_] = ue - N;
    }
    if (o) {
      var fe, Se = _ === "x" ? Fn : Bn, Fe = _ === "x" ? hr : pr, nt = x[T], mt = T === "y" ? "height" : "width", Ze = nt + y[Se], rt = nt - y[Fe], Qe = [Fn, Bn].indexOf(v) !== -1, ie = (fe = I == null ? void 0 : I[T]) != null ? fe : 0, me = Qe ? Ze : nt - A[mt] - R[mt] - ie + L.altAxis, Pe = Qe ? nt + A[mt] + R[mt] - ie - L.altAxis : rt, ge = p && Qe ? vB(me, nt, Pe) : Zo(p ? me : Ze, nt, p ? Pe : rt);
      x[T] = ge, O[T] = ge - nt;
    }
    t.modifiersData[r] = O;
  }
}
const GB = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: KB,
  requiresIfExists: ["offset"]
};
function YB(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function ZB(e) {
  return e === Zn(e) || !dr(e) ? cm(e) : YB(e);
}
function QB(e) {
  var t = e.getBoundingClientRect(), n = qs(t.width) / e.offsetWidth || 1, r = qs(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function XB(e, t, n) {
  n === void 0 && (n = !1);
  var r = dr(t), i = dr(t) && QB(t), a = ua(t), s = Ws(e, i, n), o = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Jr(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  fm(a)) && (o = ZB(t)), dr(t) ? (l = Ws(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : a && (l.x = dm(a))), {
    x: s.left + o.scrollLeft - l.x,
    y: s.top + o.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function JB(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function i(a) {
    n.add(a.name);
    var s = [].concat(a.requires || [], a.requiresIfExists || []);
    s.forEach(function(o) {
      if (!n.has(o)) {
        var l = t.get(o);
        l && i(l);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || i(a);
  }), r;
}
function eM(e) {
  var t = JB(e);
  return dB.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function tM(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function nM(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var A9 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function S9() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function rM(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, a = i === void 0 ? A9 : i;
  return function(o, l, u) {
    u === void 0 && (u = a);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, A9, a),
      modifiersData: {},
      elements: {
        reference: o,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, p = {
      state: c,
      setOptions: function(v) {
        var E = typeof v == "function" ? v(c.options) : v;
        m(), c.options = Object.assign({}, a, c.options, E), c.scrollParents = {
          reference: ja(o) ? Qo(o) : o.contextElement ? Qo(o.contextElement) : [],
          popper: Qo(l)
        };
        var b = eM(nM([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = b.filter(function(_) {
          return _.enabled;
        }), g(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var v = c.elements, E = v.reference, b = v.popper;
          if (S9(E, b)) {
            c.rects = {
              reference: XB(E, $l(b), c.options.strategy === "fixed"),
              popper: lm(b)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(L) {
              return c.modifiersData[L.name] = Object.assign({}, L.data);
            });
            for (var _ = 0; _ < c.orderedModifiers.length; _++) {
              if (c.reset === !0) {
                c.reset = !1, _ = -1;
                continue;
              }
              var T = c.orderedModifiers[_], x = T.fn, A = T.options, R = A === void 0 ? {} : A, P = T.name;
              typeof x == "function" && (c = x({
                state: c,
                options: R,
                name: P,
                instance: p
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: tM(function() {
        return new Promise(function(y) {
          p.forceUpdate(), y(c);
        });
      }),
      destroy: function() {
        m(), f = !0;
      }
    };
    if (!S9(o, l))
      return p;
    p.setOptions(u).then(function(y) {
      !f && u.onFirstUpdate && u.onFirstUpdate(y);
    });
    function g() {
      c.orderedModifiers.forEach(function(y) {
        var v = y.name, E = y.options, b = E === void 0 ? {} : E, _ = y.effect;
        if (typeof _ == "function") {
          var T = _({
            state: c,
            name: v,
            instance: p,
            options: b
          }), x = function() {
          };
          d.push(T || x);
        }
      });
    }
    function m() {
      d.forEach(function(y) {
        return y();
      }), d = [];
    }
    return p;
  };
}
var iM = [SB, WB, wB, pB, zB, LB, GB, TB, jB], aM = /* @__PURE__ */ rM({
  defaultModifiers: iM
}), sM = typeof Element < "u", oM = typeof Map == "function", lM = typeof Set == "function", uM = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function yc(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, i;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!yc(e[r], t[r]))
          return !1;
      return !0;
    }
    var a;
    if (oM && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!yc(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (lM && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (a = e.entries(); !(r = a.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (uM && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, i[r]))
        return !1;
    if (sM && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((i[r] === "_owner" || i[r] === "__v" || i[r] === "__o") && e.$$typeof) && !yc(e[i[r]], t[i[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var cM = function(t, n) {
  try {
    return yc(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const dM = /* @__PURE__ */ Or(cM);
var fM = [], hM = function(t, n, r) {
  r === void 0 && (r = {});
  var i = dn.useRef(null), a = {
    onFirstUpdate: r.onFirstUpdate,
    placement: r.placement || "bottom",
    strategy: r.strategy || "absolute",
    modifiers: r.modifiers || fM
  }, s = dn.useState({
    styles: {
      popper: {
        position: a.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), o = s[0], l = s[1], u = dn.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(p) {
        var g = p.state, m = Object.keys(g.elements);
        d3.flushSync(function() {
          l({
            styles: v9(m.map(function(y) {
              return [y, g.styles[y] || {}];
            })),
            attributes: v9(m.map(function(y) {
              return [y, g.attributes[y]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = dn.useMemo(function() {
    var f = {
      onFirstUpdate: a.onFirstUpdate,
      placement: a.placement,
      strategy: a.strategy,
      modifiers: [].concat(a.modifiers, [u, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return dM(i.current, f) ? i.current || f : (i.current = f, f);
  }, [a.onFirstUpdate, a.placement, a.strategy, a.modifiers, u]), d = dn.useRef();
  return y9(function() {
    d.current && d.current.setOptions(c);
  }, [c]), y9(function() {
    if (!(t == null || n == null)) {
      var f = r.createPopper || aM, p = f(t, n, c);
      return d.current = p, function() {
        p.destroy(), d.current = null;
      };
    }
  }, [t, n, r.createPopper]), {
    state: d.current ? d.current.state : null,
    styles: o.styles,
    attributes: o.attributes,
    update: d.current ? d.current.update : null,
    forceUpdate: d.current ? d.current.forceUpdate : null
  };
};
function zh() {
  return zh = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zh.apply(this, arguments);
}
function LT(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var pM = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, mM = /* @__PURE__ */ LT(
  function(e) {
    return pM.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), gM = !1;
function vM(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function yM(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var EM = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(i) {
      var a;
      r.tags.length === 0 ? r.insertionPoint ? a = r.insertionPoint.nextSibling : r.prepend ? a = r.container.firstChild : a = r.before : a = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, a), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? !gM : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(yM(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = vM(i);
      try {
        a.insertRule(r, a.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var i;
      return (i = r.parentNode) == null ? void 0 : i.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), pn = "-ms-", Vc = "-moz-", yt = "-webkit-", $T = "comm", hm = "rule", pm = "decl", bM = "@import", jT = "@keyframes", TM = "@layer", _M = Math.abs, p1 = String.fromCharCode, CM = Object.assign;
function xM(e, t) {
  return cn(e, 0) ^ 45 ? (((t << 2 ^ cn(e, 0)) << 2 ^ cn(e, 1)) << 2 ^ cn(e, 2)) << 2 ^ cn(e, 3) : 0;
}
function HT(e) {
  return e.trim();
}
function wM(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Et(e, t, n) {
  return e.replace(t, n);
}
function qh(e, t) {
  return e.indexOf(t);
}
function cn(e, t) {
  return e.charCodeAt(t) | 0;
}
function wl(e, t, n) {
  return e.slice(t, n);
}
function Hr(e) {
  return e.length;
}
function mm(e) {
  return e.length;
}
function Tu(e, t) {
  return t.push(e), e;
}
function AM(e, t) {
  return e.map(t).join("");
}
var m1 = 1, Ks = 1, UT = 0, Ln = 0, Zt = 0, Xs = "";
function g1(e, t, n, r, i, a, s) {
  return { value: e, root: t, parent: n, type: r, props: i, children: a, line: m1, column: Ks, length: s, return: "" };
}
function vo(e, t) {
  return CM(g1("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function SM() {
  return Zt;
}
function kM() {
  return Zt = Ln > 0 ? cn(Xs, --Ln) : 0, Ks--, Zt === 10 && (Ks = 1, m1--), Zt;
}
function Kn() {
  return Zt = Ln < UT ? cn(Xs, Ln++) : 0, Ks++, Zt === 10 && (Ks = 1, m1++), Zt;
}
function Gr() {
  return cn(Xs, Ln);
}
function Ec() {
  return Ln;
}
function jl(e, t) {
  return wl(Xs, e, t);
}
function Al(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function zT(e) {
  return m1 = Ks = 1, UT = Hr(Xs = e), Ln = 0, [];
}
function qT(e) {
  return Xs = "", e;
}
function bc(e) {
  return HT(jl(Ln - 1, Wh(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function DM(e) {
  for (; (Zt = Gr()) && Zt < 33; )
    Kn();
  return Al(e) > 2 || Al(Zt) > 3 ? "" : " ";
}
function OM(e, t) {
  for (; --t && Kn() && !(Zt < 48 || Zt > 102 || Zt > 57 && Zt < 65 || Zt > 70 && Zt < 97); )
    ;
  return jl(e, Ec() + (t < 6 && Gr() == 32 && Kn() == 32));
}
function Wh(e) {
  for (; Kn(); )
    switch (Zt) {
      case e:
        return Ln;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Wh(Zt);
        break;
      case 40:
        e === 41 && Wh(e);
        break;
      case 92:
        Kn();
        break;
    }
  return Ln;
}
function NM(e, t) {
  for (; Kn() && e + Zt !== 47 + 10; )
    if (e + Zt === 42 + 42 && Gr() === 47)
      break;
  return "/*" + jl(t, Ln - 1) + "*" + p1(e === 47 ? e : Kn());
}
function IM(e) {
  for (; !Al(Gr()); )
    Kn();
  return jl(e, Ln);
}
function PM(e) {
  return qT(Tc("", null, null, null, [""], e = zT(e), 0, [0], e));
}
function Tc(e, t, n, r, i, a, s, o, l) {
  for (var u = 0, c = 0, d = s, f = 0, p = 0, g = 0, m = 1, y = 1, v = 1, E = 0, b = "", _ = i, T = a, x = r, A = b; y; )
    switch (g = E, E = Kn()) {
      case 40:
        if (g != 108 && cn(A, d - 1) == 58) {
          qh(A += Et(bc(E), "&", "&\f"), "&\f") != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += bc(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += DM(g);
        break;
      case 92:
        A += OM(Ec() - 1, 7);
        continue;
      case 47:
        switch (Gr()) {
          case 42:
          case 47:
            Tu(RM(NM(Kn(), Ec()), t, n), l);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * m:
        o[u++] = Hr(A) * v;
      case 125 * m:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            y = 0;
          case 59 + c:
            v == -1 && (A = Et(A, /\f/g, "")), p > 0 && Hr(A) - d && Tu(p > 32 ? D9(A + ";", r, n, d - 1) : D9(Et(A, " ", "") + ";", r, n, d - 2), l);
            break;
          case 59:
            A += ";";
          default:
            if (Tu(x = k9(A, t, n, u, c, i, o, b, _ = [], T = [], d), a), E === 123)
              if (c === 0)
                Tc(A, t, x, x, _, a, d, o, T);
              else
                switch (f === 99 && cn(A, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Tc(e, x, x, r && Tu(k9(e, x, x, 0, 0, i, o, b, i, _ = [], d), T), i, T, d, o, r ? _ : T);
                    break;
                  default:
                    Tc(A, x, x, x, [""], T, 0, o, T);
                }
        }
        u = c = p = 0, m = v = 1, b = A = "", d = s;
        break;
      case 58:
        d = 1 + Hr(A), p = g;
      default:
        if (m < 1) {
          if (E == 123)
            --m;
          else if (E == 125 && m++ == 0 && kM() == 125)
            continue;
        }
        switch (A += p1(E), E * m) {
          case 38:
            v = c > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            o[u++] = (Hr(A) - 1) * v, v = 1;
            break;
          case 64:
            Gr() === 45 && (A += bc(Kn())), f = Gr(), c = d = Hr(b = A += IM(Ec())), E++;
            break;
          case 45:
            g === 45 && Hr(A) == 2 && (m = 0);
        }
    }
  return a;
}
function k9(e, t, n, r, i, a, s, o, l, u, c) {
  for (var d = i - 1, f = i === 0 ? a : [""], p = mm(f), g = 0, m = 0, y = 0; g < r; ++g)
    for (var v = 0, E = wl(e, d + 1, d = _M(m = s[g])), b = e; v < p; ++v)
      (b = HT(m > 0 ? f[v] + " " + E : Et(E, /&\f/g, f[v]))) && (l[y++] = b);
  return g1(e, t, n, i === 0 ? hm : o, l, u, c);
}
function RM(e, t, n) {
  return g1(e, t, n, $T, p1(SM()), wl(e, 2, -2), 0);
}
function D9(e, t, n, r) {
  return g1(e, t, n, pm, wl(e, 0, r), wl(e, r + 1, -1), r);
}
function Ds(e, t) {
  for (var n = "", r = mm(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function FM(e, t, n, r) {
  switch (e.type) {
    case TM:
      if (e.children.length)
        break;
    case bM:
    case pm:
      return e.return = e.return || e.value;
    case $T:
      return "";
    case jT:
      return e.return = e.value + "{" + Ds(e.children, r) + "}";
    case hm:
      e.value = e.props.join(",");
  }
  return Hr(n = Ds(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function BM(e) {
  var t = mm(e);
  return function(n, r, i, a) {
    for (var s = "", o = 0; o < t; o++)
      s += e[o](n, r, i, a) || "";
    return s;
  };
}
function MM(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var LM = function(t, n, r) {
  for (var i = 0, a = 0; i = a, a = Gr(), i === 38 && a === 12 && (n[r] = 1), !Al(a); )
    Kn();
  return jl(t, Ln);
}, $M = function(t, n) {
  var r = -1, i = 44;
  do
    switch (Al(i)) {
      case 0:
        i === 38 && Gr() === 12 && (n[r] = 1), t[r] += LM(Ln - 1, n, r);
        break;
      case 2:
        t[r] += bc(i);
        break;
      case 4:
        if (i === 44) {
          t[++r] = Gr() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += p1(i);
    }
  while (i = Kn());
  return t;
}, jM = function(t, n) {
  return qT($M(zT(t), n));
}, O9 = /* @__PURE__ */ new WeakMap(), HM = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, i = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !O9.get(r)) && !i) {
      O9.set(t, !0);
      for (var a = [], s = jM(n, a), o = r.props, l = 0, u = 0; l < s.length; l++)
        for (var c = 0; c < o.length; c++, u++)
          t.props[u] = a[l] ? s[l].replace(/&\f/g, o[c]) : o[c] + " " + s[l];
    }
  }
}, UM = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function WT(e, t) {
  switch (xM(e, t)) {
    case 5103:
      return yt + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return yt + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return yt + e + Vc + e + pn + e + e;
    case 6828:
    case 4268:
      return yt + e + pn + e + e;
    case 6165:
      return yt + e + pn + "flex-" + e + e;
    case 5187:
      return yt + e + Et(e, /(\w+).+(:[^]+)/, yt + "box-$1$2" + pn + "flex-$1$2") + e;
    case 5443:
      return yt + e + pn + "flex-item-" + Et(e, /flex-|-self/, "") + e;
    case 4675:
      return yt + e + pn + "flex-line-pack" + Et(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return yt + e + pn + Et(e, "shrink", "negative") + e;
    case 5292:
      return yt + e + pn + Et(e, "basis", "preferred-size") + e;
    case 6060:
      return yt + "box-" + Et(e, "-grow", "") + yt + e + pn + Et(e, "grow", "positive") + e;
    case 4554:
      return yt + Et(e, /([^-])(transform)/g, "$1" + yt + "$2") + e;
    case 6187:
      return Et(Et(Et(e, /(zoom-|grab)/, yt + "$1"), /(image-set)/, yt + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Et(e, /(image-set\([^]*)/, yt + "$1$`$1");
    case 4968:
      return Et(Et(e, /(.+:)(flex-)?(.*)/, yt + "box-pack:$3" + pn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + yt + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Et(e, /(.+)-inline(.+)/, yt + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Hr(e) - 1 - t > 6)
        switch (cn(e, t + 1)) {
          case 109:
            if (cn(e, t + 4) !== 45)
              break;
          case 102:
            return Et(e, /(.+:)(.+)-([^]+)/, "$1" + yt + "$2-$3$1" + Vc + (cn(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~qh(e, "stretch") ? WT(Et(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (cn(e, t + 1) !== 115)
        break;
    case 6444:
      switch (cn(e, Hr(e) - 3 - (~qh(e, "!important") && 10))) {
        case 107:
          return Et(e, ":", ":" + yt) + e;
        case 101:
          return Et(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + yt + (cn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + yt + "$2$3$1" + pn + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (cn(e, t + 11)) {
        case 114:
          return yt + e + pn + Et(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return yt + e + pn + Et(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return yt + e + pn + Et(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return yt + e + pn + e + e;
  }
  return e;
}
var zM = function(t, n, r, i) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case pm:
        t.return = WT(t.value, t.length);
        break;
      case jT:
        return Ds([vo(t, {
          value: Et(t.value, "@", "@" + yt)
        })], i);
      case hm:
        if (t.length)
          return AM(t.props, function(a) {
            switch (wM(a, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Ds([vo(t, {
                  props: [Et(a, /:(read-\w+)/, ":" + Vc + "$1")]
                })], i);
              case "::placeholder":
                return Ds([vo(t, {
                  props: [Et(a, /:(plac\w+)/, ":" + yt + "input-$1")]
                }), vo(t, {
                  props: [Et(a, /:(plac\w+)/, ":" + Vc + "$1")]
                }), vo(t, {
                  props: [Et(a, /:(plac\w+)/, pn + "input-$1")]
                })], i);
            }
            return "";
          });
    }
}, qM = [zM], WM = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(m) {
      var y = m.getAttribute("data-emotion");
      y.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || qM, a = {}, s, o = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(m) {
      for (var y = m.getAttribute("data-emotion").split(" "), v = 1; v < y.length; v++)
        a[y[v]] = !0;
      o.push(m);
    }
  );
  var l, u = [HM, UM];
  {
    var c, d = [FM, MM(function(m) {
      c.insert(m);
    })], f = BM(u.concat(i, d)), p = function(y) {
      return Ds(PM(y), f);
    };
    l = function(y, v, E, b) {
      c = E, p(y ? y + "{" + v.styles + "}" : v.styles), b && (g.inserted[v.name] = !0);
    };
  }
  var g = {
    key: n,
    sheet: new EM({
      key: n,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: l
  };
  return g.sheet.hydrate(o), g;
}, VT = Ep(), VM = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, KM = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, KT = {};
KT[VT.ForwardRef] = VM;
KT[VT.Memo] = KM;
var GM = !0;
function YM(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : i && (r += i + " ");
  }), r;
}
var GT = function(t, n, r) {
  var i = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  GM === !1) && t.registered[i] === void 0 && (t.registered[i] = n.styles);
}, ZM = function(t, n, r) {
  GT(t, n, r);
  var i = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var a = n;
    do
      t.insert(n === a ? "." + i : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function QM(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var XM = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, JM = !1, eL = /[A-Z]|^ms/g, tL = /_EMO_([^_]+?)_([^]*?)_EMO_/g, YT = function(t) {
  return t.charCodeAt(1) === 45;
}, N9 = function(t) {
  return t != null && typeof t != "boolean";
}, qd = /* @__PURE__ */ LT(function(e) {
  return YT(e) ? e : e.replace(eL, "-$&").toLowerCase();
}), I9 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(tL, function(r, i, a) {
          return Ur = {
            name: i,
            styles: a,
            next: Ur
          }, i;
        });
  }
  return XM[t] !== 1 && !YT(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, nL = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Sl(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return Ur = {
          name: i.name,
          styles: i.styles,
          next: Ur
        }, i.name;
      var a = n;
      if (a.styles !== void 0) {
        var s = a.next;
        if (s !== void 0)
          for (; s !== void 0; )
            Ur = {
              name: s.name,
              styles: s.styles,
              next: Ur
            }, s = s.next;
        var o = a.styles + ";";
        return o;
      }
      return rL(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var l = Ur, u = n(e);
        return Ur = l, Sl(e, t, u);
      }
      break;
    }
  }
  var c = n;
  if (t == null)
    return c;
  var d = t[c];
  return d !== void 0 ? d : c;
}
function rL(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += Sl(e, t, n[i]) + ";";
  else
    for (var a in n) {
      var s = n[a];
      if (typeof s != "object") {
        var o = s;
        t != null && t[o] !== void 0 ? r += a + "{" + t[o] + "}" : N9(o) && (r += qd(a) + ":" + I9(a, o) + ";");
      } else {
        if (a === "NO_COMPONENT_SELECTOR" && JM)
          throw new Error(nL);
        if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
          for (var l = 0; l < s.length; l++)
            N9(s[l]) && (r += qd(a) + ":" + I9(a, s[l]) + ";");
        else {
          var u = Sl(e, t, s);
          switch (a) {
            case "animation":
            case "animationName": {
              r += qd(a) + ":" + u + ";";
              break;
            }
            default:
              r += a + "{" + u + "}";
          }
        }
      }
    }
  return r;
}
var P9 = /label:\s*([^\s;{]+)\s*(;|$)/g, Ur;
function ZT(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  Ur = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    r = !1, i += Sl(n, t, a);
  else {
    var s = a;
    i += s[0];
  }
  for (var o = 1; o < e.length; o++)
    if (i += Sl(n, t, e[o]), r) {
      var l = a;
      i += l[o];
    }
  P9.lastIndex = 0;
  for (var u = "", c; (c = P9.exec(i)) !== null; )
    u += "-" + c[1];
  var d = QM(i) + u;
  return {
    name: d,
    styles: i,
    next: Ur
  };
}
var iL = function(t) {
  return t();
}, aL = dn["useInsertionEffect"] ? dn["useInsertionEffect"] : !1, sL = aL || iL, QT = /* @__PURE__ */ dn.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ WM({
    key: "css"
  }) : null
);
QT.Provider;
var oL = function(t) {
  return /* @__PURE__ */ Ol(function(n, r) {
    var i = We(QT);
    return t(n, i, r);
  });
}, lL = /* @__PURE__ */ dn.createContext({});
function uL() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return ZT(t);
}
var cL = function() {
  var t = uL.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, dL = mM, fL = function(t) {
  return t !== "theme";
}, R9 = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? dL : fL;
}, F9 = function(t, n, r) {
  var i;
  if (n) {
    var a = n.shouldForwardProp;
    i = t.__emotion_forwardProp && a ? function(s) {
      return t.__emotion_forwardProp(s) && a(s);
    } : a;
  }
  return typeof i != "function" && r && (i = t.__emotion_forwardProp), i;
}, hL = !1, pL = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return GT(n, r, i), sL(function() {
    return ZM(n, r, i);
  }), null;
}, mL = function e(t, n) {
  var r = t.__emotion_real === t, i = r && t.__emotion_base || t, a, s;
  n !== void 0 && (a = n.label, s = n.target);
  var o = F9(t, n, r), l = o || R9(i), u = !l("as");
  return function() {
    var c = arguments, d = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (a !== void 0 && d.push("label:" + a + ";"), c[0] == null || c[0].raw === void 0)
      d.push.apply(d, c);
    else {
      d.push(c[0][0]);
      for (var f = c.length, p = 1; p < f; p++)
        d.push(c[p], c[0][p]);
    }
    var g = oL(function(m, y, v) {
      var E = u && m.as || i, b = "", _ = [], T = m;
      if (m.theme == null) {
        T = {};
        for (var x in m)
          T[x] = m[x];
        T.theme = dn.useContext(lL);
      }
      typeof m.className == "string" ? b = YM(y.registered, _, m.className) : m.className != null && (b = m.className + " ");
      var A = ZT(d.concat(_), y.registered, T);
      b += y.key + "-" + A.name, s !== void 0 && (b += " " + s);
      var R = u && o === void 0 ? R9(E) : l, P = {};
      for (var L in m)
        u && L === "as" || R(L) && (P[L] = m[L]);
      return P.className = b, v && (P.ref = v), /* @__PURE__ */ dn.createElement(dn.Fragment, null, /* @__PURE__ */ dn.createElement(pL, {
        cache: y,
        serialized: A,
        isStringTag: typeof E == "string"
      }), /* @__PURE__ */ dn.createElement(E, P));
    });
    return g.displayName = a !== void 0 ? a : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", g.defaultProps = t.defaultProps, g.__emotion_real = g, g.__emotion_base = i, g.__emotion_styles = d, g.__emotion_forwardProp = o, Object.defineProperty(g, "toString", {
      value: function() {
        return s === void 0 && hL ? "NO_COMPONENT_SELECTOR" : "." + s;
      }
    }), g.withComponent = function(m, y) {
      return e(m, zh({}, n, y, {
        shouldForwardProp: F9(g, y, !0)
      })).apply(void 0, d);
    }, g;
  };
}, gL = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Be = mL.bind();
gL.forEach(function(e) {
  Be[e] = Be(e);
});
var as = {}.hasOwnProperty, XT = vL;
function vL(e) {
  return !e || typeof e != "object" ? "" : as.call(e, "position") || as.call(e, "type") ? B9(e.position) : as.call(e, "start") || as.call(e, "end") ? B9(e) : as.call(e, "line") || as.call(e, "column") ? Vh(e) : "";
}
function Vh(e) {
  return (!e || typeof e != "object") && (e = {}), M9(e.line) + ":" + M9(e.column);
}
function B9(e) {
  return (!e || typeof e != "object") && (e = {}), Vh(e.start) + "-" + Vh(e.end);
}
function M9(e) {
  return e && typeof e == "number" ? e : 1;
}
var yL = XT, EL = gm;
function JT() {
}
JT.prototype = Error.prototype;
gm.prototype = new JT();
var ca = gm.prototype;
ca.file = "";
ca.name = "";
ca.reason = "";
ca.message = "";
ca.stack = "";
ca.fatal = null;
ca.column = null;
ca.line = null;
function gm(e, t, n) {
  var r, i, a;
  typeof t == "string" && (n = t, t = null), r = bL(n), i = yL(t) || "1:1", a = {
    start: { line: null, column: null },
    end: { line: null, column: null }
  }, t && t.position && (t = t.position), t && (t.start ? (a = t, t = t.start) : a.start = t), e.stack && (this.stack = e.stack, e = e.message), this.message = e, this.name = i, this.reason = e, this.line = t ? t.line : null, this.column = t ? t.column : null, this.location = a, this.source = r[0], this.ruleId = r[1];
}
function bL(e) {
  var t = [null, null], n;
  return typeof e == "string" && (n = e.indexOf(":"), n === -1 ? t[1] = e : (t[0] = e.slice(0, n), t[1] = e.slice(n + 1))), t;
}
var Js = {};
Js.basename = TL;
Js.dirname = _L;
Js.extname = CL;
Js.join = xL;
Js.sep = "/";
function TL(e, t) {
  var n = 0, r = -1, i, a, s, o;
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  if (Hl(e), i = e.length, t === void 0 || !t.length || t.length > e.length) {
    for (; i--; )
      if (e.charCodeAt(i) === 47) {
        if (s) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (s = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  for (a = -1, o = t.length - 1; i--; )
    if (e.charCodeAt(i) === 47) {
      if (s) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (s = !0, a = i + 1), o > -1 && (e.charCodeAt(i) === t.charCodeAt(o--) ? o < 0 && (r = i) : (o = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function _L(e) {
  var t, n, r;
  if (Hl(e), !e.length)
    return ".";
  for (t = -1, r = e.length; --r; )
    if (e.charCodeAt(r) === 47) {
      if (n) {
        t = r;
        break;
      }
    } else
      n || (n = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function CL(e) {
  var t = -1, n = 0, r = -1, i = 0, a, s, o;
  for (Hl(e), o = e.length; o--; ) {
    if (s = e.charCodeAt(o), s === 47) {
      if (a) {
        n = o + 1;
        break;
      }
      continue;
    }
    r < 0 && (a = !0, r = o + 1), s === 46 ? t < 0 ? t = o : i !== 1 && (i = 1) : t > -1 && (i = -1);
  }
  return t < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && t === r - 1 && t === n + 1 ? "" : e.slice(t, r);
}
function xL() {
  for (var e = -1, t; ++e < arguments.length; )
    Hl(arguments[e]), arguments[e] && (t = t === void 0 ? arguments[e] : t + "/" + arguments[e]);
  return t === void 0 ? "." : wL(t);
}
function wL(e) {
  var t, n;
  return Hl(e), t = e.charCodeAt(0) === 47, n = AL(e, !t), !n.length && !t && (n = "."), n.length && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function AL(e, t) {
  for (var n = "", r = 0, i = -1, a = 0, s = -1, o, l; ++s <= e.length; ) {
    if (s < e.length)
      o = e.charCodeAt(s);
    else {
      if (o === 47)
        break;
      o = 47;
    }
    if (o === 47) {
      if (!(i === s - 1 || a === 1))
        if (i !== s - 1 && a === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (l = n.lastIndexOf("/"), l !== n.length - 1) {
                l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), i = s, a = 0;
                continue;
              }
            } else if (n.length) {
              n = "", r = 0, i = s, a = 0;
              continue;
            }
          }
          t && (n = n.length ? n + "/.." : "..", r = 2);
        } else
          n.length ? n += "/" + e.slice(i + 1, s) : n = e.slice(i + 1, s), r = s - i - 1;
      i = s, a = 0;
    } else
      o === 46 && a > -1 ? a++ : a = -1;
  }
  return n;
}
function Hl(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
var e8 = {};
e8.cwd = SL;
function SL() {
  return "/";
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var t8 = function(t) {
  return t != null && t.constructor != null && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}, ei = Js, kL = e8, DL = t8, OL = Si, NL = {}.hasOwnProperty, Wd = ["history", "path", "basename", "stem", "extname", "dirname"];
Si.prototype.toString = UL;
Object.defineProperty(Si.prototype, "path", { get: IL, set: PL });
Object.defineProperty(Si.prototype, "dirname", {
  get: RL,
  set: FL
});
Object.defineProperty(Si.prototype, "basename", {
  get: BL,
  set: ML
});
Object.defineProperty(Si.prototype, "extname", {
  get: LL,
  set: $L
});
Object.defineProperty(Si.prototype, "stem", { get: jL, set: HL });
function Si(e) {
  var t, n;
  if (!e)
    e = {};
  else if (typeof e == "string" || DL(e))
    e = { contents: e };
  else if ("message" in e && "messages" in e)
    return e;
  if (!(this instanceof Si))
    return new Si(e);
  for (this.data = {}, this.messages = [], this.history = [], this.cwd = kL.cwd(), n = -1; ++n < Wd.length; )
    t = Wd[n], NL.call(e, t) && (this[t] = e[t]);
  for (t in e)
    Wd.indexOf(t) < 0 && (this[t] = e[t]);
}
function IL() {
  return this.history[this.history.length - 1];
}
function PL(e) {
  ym(e, "path"), this.path !== e && this.history.push(e);
}
function RL() {
  return typeof this.path == "string" ? ei.dirname(this.path) : void 0;
}
function FL(e) {
  n8(this.path, "dirname"), this.path = ei.join(e || "", this.basename);
}
function BL() {
  return typeof this.path == "string" ? ei.basename(this.path) : void 0;
}
function ML(e) {
  ym(e, "basename"), vm(e, "basename"), this.path = ei.join(this.dirname || "", e);
}
function LL() {
  return typeof this.path == "string" ? ei.extname(this.path) : void 0;
}
function $L(e) {
  if (vm(e, "extname"), n8(this.path, "extname"), e) {
    if (e.charCodeAt(0) !== 46)
      throw new Error("`extname` must start with `.`");
    if (e.indexOf(".", 1) > -1)
      throw new Error("`extname` cannot contain multiple dots");
  }
  this.path = ei.join(this.dirname, this.stem + (e || ""));
}
function jL() {
  return typeof this.path == "string" ? ei.basename(this.path, this.extname) : void 0;
}
function HL(e) {
  ym(e, "stem"), vm(e, "stem"), this.path = ei.join(this.dirname || "", e + (this.extname || ""));
}
function UL(e) {
  return (this.contents || "").toString(e);
}
function vm(e, t) {
  if (e && e.indexOf(ei.sep) > -1)
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + ei.sep + "`"
    );
}
function ym(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function n8(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
var zL = EL, v1 = OL, qL = v1;
v1.prototype.message = WL;
v1.prototype.info = KL;
v1.prototype.fail = VL;
function WL(e, t, n) {
  var r = new zL(e, t, n);
  return this.path && (r.name = this.path + ":" + r.name, r.file = this.path), r.fatal = !1, this.messages.push(r), r;
}
function VL() {
  var e = this.message.apply(this, arguments);
  throw e.fatal = !0, e;
}
function KL() {
  var e = this.message.apply(this, arguments);
  return e.fatal = null, e;
}
var r8 = qL, GL = YL;
function YL(e) {
  if (e)
    throw e;
}
var ZL = (e) => {
  if (Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}, QL = [].slice, XL = JL;
function JL(e, t) {
  var n;
  return r;
  function r() {
    var s = QL.call(arguments, 0), o = e.length > s.length, l;
    o && s.push(i);
    try {
      l = e.apply(null, s);
    } catch (u) {
      if (o && n)
        throw u;
      return i(u);
    }
    o || (l && typeof l.then == "function" ? l.then(a, i) : l instanceof Error ? i(l) : a(l));
  }
  function i() {
    n || (n = !0, t.apply(null, arguments));
  }
  function a(s) {
    i(null, s);
  }
}
var i8 = XL, e$ = a8;
a8.wrap = i8;
var L9 = [].slice;
function a8() {
  var e = [], t = {};
  return t.run = n, t.use = r, t;
  function n() {
    var i = -1, a = L9.call(arguments, 0, -1), s = arguments[arguments.length - 1];
    if (typeof s != "function")
      throw new Error("Expected function as last argument, not " + s);
    o.apply(null, [null].concat(a));
    function o(l) {
      var u = e[++i], c = L9.call(arguments, 0), d = c.slice(1), f = a.length, p = -1;
      if (l) {
        s(l);
        return;
      }
      for (; ++p < f; )
        (d[p] === null || d[p] === void 0) && (d[p] = a[p]);
      a = d, u ? i8(u, o).apply(null, a) : s.apply(null, [null].concat(a));
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new Error("Expected `fn` to be a function, not " + i);
    return e.push(i), t;
  }
}
var $9 = GL, t$ = t8, _u = Ib, j9 = ZL, s8 = e$, yo = r8, n$ = o8().freeze(), r$ = [].slice, i$ = {}.hasOwnProperty, a$ = s8().use(s$).use(o$).use(l$);
function s$(e, t) {
  t.tree = e.parse(t.file);
}
function o$(e, t, n) {
  e.run(t.tree, t.file, r);
  function r(i, a, s) {
    i ? n(i) : (t.tree = a, t.file = s, n());
  }
}
function l$(e, t) {
  var n = e.stringify(t.tree, t.file);
  n == null || (typeof n == "string" || t$(n) ? ("value" in t.file && (t.file.value = n), t.file.contents = n) : t.file.result = n);
}
function o8() {
  var e = [], t = s8(), n = {}, r = -1, i;
  return a.data = o, a.freeze = s, a.attachers = e, a.use = l, a.parse = c, a.stringify = p, a.run = d, a.runSync = f, a.process = g, a.processSync = m, a;
  function a() {
    for (var y = o8(), v = -1; ++v < e.length; )
      y.use.apply(null, e[v]);
    return y.data(_u(!0, {}, n)), y;
  }
  function s() {
    var y, v;
    if (i)
      return a;
    for (; ++r < e.length; )
      y = e[r], y[1] !== !1 && (y[1] === !0 && (y[1] = void 0), v = y[0].apply(a, y.slice(1)), typeof v == "function" && t.use(v));
    return i = !0, r = 1 / 0, a;
  }
  function o(y, v) {
    return typeof y == "string" ? arguments.length === 2 ? (Gd("data", i), n[y] = v, a) : i$.call(n, y) && n[y] || null : y ? (Gd("data", i), n = y, a) : n;
  }
  function l(y) {
    var v;
    if (Gd("use", i), y != null)
      if (typeof y == "function")
        T.apply(null, arguments);
      else if (typeof y == "object")
        "length" in y ? _(y) : E(y);
      else
        throw new Error("Expected usable value, not `" + y + "`");
    return v && (n.settings = _u(n.settings || {}, v)), a;
    function E(x) {
      _(x.plugins), x.settings && (v = _u(v || {}, x.settings));
    }
    function b(x) {
      if (typeof x == "function")
        T(x);
      else if (typeof x == "object")
        "length" in x ? T.apply(null, x) : E(x);
      else
        throw new Error("Expected usable value, not `" + x + "`");
    }
    function _(x) {
      var A = -1;
      if (x != null)
        if (typeof x == "object" && "length" in x)
          for (; ++A < x.length; )
            b(x[A]);
        else
          throw new Error("Expected a list of plugins, not `" + x + "`");
    }
    function T(x, A) {
      var R = u(x);
      R ? (j9(R[1]) && j9(A) && (A = _u(!0, R[1], A)), R[1] = A) : e.push(r$.call(arguments));
    }
  }
  function u(y) {
    for (var v = -1; ++v < e.length; )
      if (e[v][0] === y)
        return e[v];
  }
  function c(y) {
    var v = yo(y), E;
    return s(), E = a.Parser, Vd("parse", E), H9(E, "parse") ? new E(String(v), v).parse() : E(String(v), v);
  }
  function d(y, v, E) {
    if (U9(y), s(), !E && typeof v == "function" && (E = v, v = null), !E)
      return new Promise(b);
    b(null, E);
    function b(_, T) {
      t.run(y, yo(v), x);
      function x(A, R, P) {
        R = R || y, A ? T(A) : _ ? _(R) : E(null, R, P);
      }
    }
  }
  function f(y, v) {
    var E, b;
    return d(y, v, _), z9("runSync", "run", b), E;
    function _(T, x) {
      b = !0, E = x, $9(T);
    }
  }
  function p(y, v) {
    var E = yo(v), b;
    return s(), b = a.Compiler, Kd("stringify", b), U9(y), H9(b, "compile") ? new b(y, E).compile() : b(y, E);
  }
  function g(y, v) {
    if (s(), Vd("process", a.Parser), Kd("process", a.Compiler), !v)
      return new Promise(E);
    E(null, v);
    function E(b, _) {
      var T = yo(y);
      a$.run(a, { file: T }, x);
      function x(A) {
        A ? _(A) : b ? b(T) : v(null, T);
      }
    }
  }
  function m(y) {
    var v, E;
    return s(), Vd("processSync", a.Parser), Kd("processSync", a.Compiler), v = yo(y), g(v, b), z9("processSync", "process", E), v;
    function b(_) {
      E = !0, $9(_);
    }
  }
}
function H9(e, t) {
  return typeof e == "function" && e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  (u$(e.prototype) || t in e.prototype);
}
function u$(e) {
  var t;
  for (t in e)
    return !0;
  return !1;
}
function Vd(e, t) {
  if (typeof t != "function")
    throw new Error("Cannot `" + e + "` without `Parser`");
}
function Kd(e, t) {
  if (typeof t != "function")
    throw new Error("Cannot `" + e + "` without `Compiler`");
}
function Gd(e, t) {
  if (t)
    throw new Error(
      "Cannot invoke `" + e + "` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`."
    );
}
function U9(e) {
  if (!e || typeof e.type != "string")
    throw new Error("Expected node, got `" + e + "`");
}
function z9(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
var c$ = l8;
function l8(e) {
  return e && (e.value || e.alt || e.title || "children" in e && q9(e.children) || "length" in e && q9(e)) || "";
}
function q9(e) {
  for (var t = [], n = -1; ++n < e.length; )
    t[n] = l8(e[n]);
  return t.join("");
}
var d$ = Object.assign, Ul = d$, f$ = {}.hasOwnProperty, u8 = f$;
function h$(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
var Em = h$, p$ = String.fromCharCode, y1 = p$, m$ = y1;
function g$(e, t) {
  var n = parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of the basic block and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || // Out of range
    n > 1114111 ? "�" : m$(n)
  );
}
var v$ = g$, bm = {};
function y$(e) {
  return e < -2;
}
var Xt = y$;
function E$(e) {
  return e === -2 || e === -1 || e === 32;
}
var Ni = E$, W9 = Ni;
function b$(e, t, n, r) {
  var i = r ? r - 1 : 1 / 0, a = 0;
  return s;
  function s(l) {
    return W9(l) ? (e.enter(n), o(l)) : t(l);
  }
  function o(l) {
    return W9(l) && a++ < i ? (e.consume(l), o) : (e.exit(n), t(l));
  }
}
var tn = b$;
Object.defineProperty(bm, "__esModule", { value: !0 });
var T$ = Xt, _$ = tn, C$ = x$;
function x$(e) {
  var t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  ), n;
  return t;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), _$(e, t, "linePrefix");
  }
  function i(o) {
    return e.enter("paragraph"), a(o);
  }
  function a(o) {
    var l = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = l), n = l, s(o);
  }
  function s(o) {
    if (o === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(o);
      return;
    }
    return T$(o) ? (e.consume(o), e.exit("chunkText"), a) : (e.consume(o), s);
  }
}
bm.tokenize = C$;
var Tm = {}, w$ = Xt, A$ = tn, S$ = {
  tokenize: k$,
  partial: !0
};
function k$(e, t, n) {
  return A$(e, r, "linePrefix");
  function r(i) {
    return i === null || w$(i) ? t(i) : n(i);
  }
}
var E1 = S$;
Object.defineProperty(Tm, "__esModule", { value: !0 });
var D$ = Xt, c8 = tn, O$ = E1, N$ = P$, Yd = {
  tokenize: R$
}, I$ = {
  tokenize: F$
};
function P$(e) {
  var t = this, n = [], r = 0, i = {
    tokenize: v,
    partial: !0
  }, a, s, o;
  return l;
  function l(E) {
    return r < n.length ? (t.containerState = n[r][1], e.attempt(
      n[r][0].continuation,
      u,
      c
    )(E)) : c(E);
  }
  function u(E) {
    return r++, l(E);
  }
  function c(E) {
    return a && a.flowContinue ? f(E) : (t.interrupt = s && s.currentConstruct && s.currentConstruct.interruptible, t.containerState = {}, e.attempt(
      Yd,
      d,
      f
    )(E));
  }
  function d(E) {
    return n.push([t.currentConstruct, t.containerState]), t.containerState = void 0, c(E);
  }
  function f(E) {
    if (E === null) {
      y(0, !0), e.consume(E);
      return;
    }
    return s = s || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: s
    }), p(E);
  }
  function p(E) {
    return E === null ? (m(e.exit("chunkFlow")), f(E)) : D$(E) ? (e.consume(E), m(e.exit("chunkFlow")), e.check(i, g)) : (e.consume(E), p);
  }
  function g(E) {
    return y(
      a.continued,
      a && a.flowEnd
    ), r = 0, l(E);
  }
  function m(E) {
    o && (o.next = E), o = E, s.lazy = a && a.lazy, s.defineSkip(E.start), s.write(t.sliceStream(E));
  }
  function y(E, b) {
    var _ = n.length;
    for (s && b && (s.write([null]), o = s = void 0); _-- > E; )
      t.containerState = n[_][1], n[_][0].exit.call(t, e);
    n.length = E;
  }
  function v(E, b) {
    var _ = 0;
    return a = {}, T;
    function T(I) {
      return _ < n.length ? (t.containerState = n[_][1], E.attempt(
        n[_][0].continuation,
        x,
        A
      )(I)) : s.currentConstruct && s.currentConstruct.concrete ? (a.flowContinue = !0, L(I)) : (t.interrupt = s.currentConstruct && s.currentConstruct.interruptible, t.containerState = {}, E.attempt(
        Yd,
        P,
        L
      )(I));
    }
    function x(I) {
      return _++, t.containerState._closeFlow ? P(I) : T(I);
    }
    function A(I) {
      return s.currentConstruct && s.currentConstruct.lazy ? (t.containerState = {}, E.attempt(
        Yd,
        P,
        // Maybe flow, or a blank line?
        E.attempt(
          I$,
          P,
          E.check(O$, P, R)
        )
      )(I)) : P(I);
    }
    function R(I) {
      return _ = n.length, a.lazy = !0, a.flowContinue = !0, L(I);
    }
    function P(I) {
      return a.flowEnd = !0, L(I);
    }
    function L(I) {
      return a.continued = _, t.interrupt = t.containerState = void 0, b(I);
    }
  }
}
function R$(e, t, n) {
  return c8(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
  );
}
function F$(e, t, n) {
  return c8(
    e,
    e.lazy(this.parser.constructs.flow, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
  );
}
Tm.tokenize = N$;
var _m = {};
function B$(e) {
  for (var t = -1, n = 0; ++t < e.length; )
    n += typeof e[t] == "string" ? e[t].length : 1;
  return n;
}
var d8 = B$, M$ = d8;
function L$(e, t) {
  var n = e[e.length - 1];
  return !n || n[1].type !== t ? 0 : M$(n[2].sliceStream(n[1]));
}
var zl = L$, $$ = [].splice, j$ = $$, Zd = j$;
function H$(e, t, n, r) {
  var i = e.length, a = 0, s;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    s = Array.from(r), s.unshift(t, n), Zd.apply(e, s);
  else
    for (n && Zd.apply(e, [t, n]); a < r.length; )
      s = r.slice(a, a + 1e4), s.unshift(t, 0), Zd.apply(e, s), a += 1e4, t += 1e4;
}
var Ii = H$, U$ = Ul;
function z$(e) {
  return U$({}, e);
}
var Ka = z$, q$ = Ul, f8 = Ii, W$ = Ka;
function V$(e) {
  for (var t = {}, n = -1, r, i, a, s, o, l, u; ++n < e.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = e[n], n && r[1].type === "chunkFlow" && e[n - 1][1].type === "listItemPrefix" && (l = r[1]._tokenizer.events, a = 0, a < l.length && l[a][1].type === "lineEndingBlank" && (a += 2), a < l.length && l[a][1].type === "content"))
      for (; ++a < l.length && l[a][1].type !== "content"; )
        l[a][1].type === "chunkText" && (l[a][1].isInFirstContentOfListItem = !0, a++);
    if (r[0] === "enter")
      r[1].contentType && (q$(t, K$(e, n)), n = t[n], u = !0);
    else if (r[1]._container || r[1]._movePreviousLineEndings) {
      for (a = n, i = void 0; a-- && (s = e[a], s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (i && (e[i][1].type = "lineEndingBlank"), s[1].type = "lineEnding", i = a);
      i && (r[1].end = W$(e[i][1].start), o = e.slice(i, n), o.unshift(r), f8(e, i, n - i + 1, o));
    }
  }
  return !u;
}
function K$(e, t) {
  for (var n = e[t][1], r = e[t][2], i = t - 1, a = [], s = n._tokenizer || r.parser[n.contentType](n.start), o = s.events, l = [], u = {}, c, d, f, p, g, m; n; ) {
    for (; e[++i][1] !== n; )
      ;
    a.push(i), n._tokenizer || (c = r.sliceStream(n), n.next || c.push(null), d && s.defineSkip(n.start), n.isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(c), n.isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), d = n, n = n.next;
  }
  for (n = d, f = o.length; f--; )
    o[f][0] === "enter" ? p = !0 : (
      // Find a void token that includes a break.
      p && o[f][1].type === o[f - 1][1].type && o[f][1].start.line !== o[f][1].end.line && (y(o.slice(f + 1, g)), n._tokenizer = n.next = void 0, n = n.previous, g = f + 1)
    );
  for (s.events = n._tokenizer = n.next = void 0, y(o.slice(0, g)), f = -1, m = 0; ++f < l.length; )
    u[m + l[f][0]] = m + l[f][1], m += l[f][1] - l[f][0] - 1;
  return u;
  function y(v) {
    var E = a.pop();
    l.unshift([E, E + v.length - 1]), f8(e, E, 2, v);
  }
}
var h8 = V$, p8 = Xt, G$ = zl, Y$ = h8, Z$ = tn, Q$ = {
  tokenize: ej,
  resolve: J$,
  interruptible: !0,
  lazy: !0
}, X$ = {
  tokenize: tj,
  partial: !0
};
function J$(e) {
  return Y$(e), e;
}
function ej(e, t) {
  var n;
  return r;
  function r(o) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(o);
  }
  function i(o) {
    return o === null ? a(o) : p8(o) ? e.check(
      X$,
      s,
      a
    )(o) : (e.consume(o), i);
  }
  function a(o) {
    return e.exit("chunkContent"), e.exit("content"), t(o);
  }
  function s(o) {
    return e.consume(o), e.exit("chunkContent"), n = n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), i;
  }
}
function tj(e, t, n) {
  var r = this;
  return i;
  function i(s) {
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), Z$(e, a, "linePrefix");
  }
  function a(s) {
    return s === null || p8(s) ? n(s) : r.parser.constructs.disable.null.indexOf("codeIndented") > -1 || G$(r.events, "linePrefix") < 4 ? e.interrupt(r.parser.constructs.flow, n, t)(s) : t(s);
  }
}
var nj = Q$;
Object.defineProperty(_m, "__esModule", { value: !0 });
var rj = nj, ij = tn, aj = E1, sj = oj;
function oj(e) {
  var t = this, n = e.attempt(
    // Try to parse a blank line.
    aj,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      ij(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(rj, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
_m.tokenize = sj;
var eo = {};
Object.defineProperty(eo, "__esModule", { value: !0 });
var lj = Ul, V9 = Ka, uj = m8("text"), cj = m8("string"), dj = {
  resolveAll: g8()
};
function m8(e) {
  return {
    tokenize: t,
    resolveAll: g8(
      e === "text" ? fj : void 0
    )
  };
  function t(n) {
    var r = this, i = this.parser.constructs[e], a = n.attempt(i, s, o);
    return s;
    function s(c) {
      return u(c) ? a(c) : o(c);
    }
    function o(c) {
      if (c === null) {
        n.consume(c);
        return;
      }
      return n.enter("data"), n.consume(c), l;
    }
    function l(c) {
      return u(c) ? (n.exit("data"), a(c)) : (n.consume(c), l);
    }
    function u(c) {
      var d = i[c], f = -1;
      if (c === null)
        return !0;
      if (d) {
        for (; ++f < d.length; )
          if (!d[f].previous || d[f].previous.call(r, r.previous))
            return !0;
      }
    }
  }
}
function g8(e) {
  return t;
  function t(n, r) {
    for (var i = -1, a; ++i <= n.length; )
      a === void 0 ? n[i] && n[i][1].type === "data" && (a = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== a + 2 && (n[a][1].end = n[i - 1][1].end, n.splice(a + 2, i - a - 2), i = a + 2), a = void 0);
    return e ? e(n, r) : n;
  }
}
function fj(e, t) {
  for (var n = -1, r, i, a, s, o, l, u, c; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      for (i = e[n - 1][1], r = t.sliceStream(i), s = r.length, o = -1, l = 0, u = void 0; s--; )
        if (a = r[s], typeof a == "string") {
          for (o = a.length; a.charCodeAt(o - 1) === 32; )
            l++, o--;
          if (o)
            break;
          o = -1;
        } else if (a === -2)
          u = !0, l++;
        else if (a !== -1) {
          s++;
          break;
        }
      l && (c = {
        type: n === e.length || u || l < 2 ? "lineSuffix" : "hardBreakTrailing",
        start: {
          line: i.end.line,
          column: i.end.column - l,
          offset: i.end.offset - l,
          _index: i.start._index + s,
          _bufferIndex: s ? o : i.start._bufferIndex + o
        },
        end: V9(i.end)
      }, i.end = V9(c.start), i.start.offset === i.end.offset ? lj(i, c) : (e.splice(
        n,
        0,
        ["enter", c, t],
        ["exit", c, t]
      ), n += 2)), n++;
    }
  return e;
}
eo.resolver = dj;
eo.string = cj;
eo.text = uj;
function hj(e) {
  return e == null ? [] : "length" in e ? e : [e];
}
var Cm = hj, K9 = u8, pj = Ii, mj = Cm;
function gj(e) {
  for (var t = {}, n = -1; ++n < e.length; )
    vj(t, e[n]);
  return t;
}
function vj(e, t) {
  var n, r, i, a;
  for (n in t) {
    r = K9.call(e, n) ? e[n] : e[n] = {}, i = t[n];
    for (a in i)
      r[a] = yj(
        mj(i[a]),
        K9.call(r, a) ? r[a] : []
      );
  }
}
function yj(e, t) {
  for (var n = -1, r = []; ++n < e.length; )
    (e[n].add === "after" ? t : r).push(e[n]);
  return pj(t, 0, 0, r), t;
}
var v8 = gj, Ej = Ii;
function bj(e, t) {
  return e.length ? (Ej(e, e.length, 0, t), e) : t;
}
var xm = bj;
function Tj(e, t, n) {
  for (var r = [], i = -1, a; ++i < e.length; )
    a = e[i].resolveAll, a && r.indexOf(a) < 0 && (t = a(t, n), r.push(a));
  return t;
}
var b1 = Tj, _j = y1;
function Cj(e) {
  for (var t = -1, n = [], r, i, a; ++t < e.length; ) {
    if (r = e[t], typeof r == "string")
      i = r;
    else if (r === -5)
      i = "\r";
    else if (r === -4)
      i = `
`;
    else if (r === -3)
      i = `\r
`;
    else if (r === -2)
      i = "	";
    else if (r === -1) {
      if (a)
        continue;
      i = " ";
    } else
      i = _j(r);
    a = r === -2, n.push(i);
  }
  return n.join("");
}
var xj = Cj;
function wj(e, t) {
  var n = t.start._index, r = t.start._bufferIndex, i = t.end._index, a = t.end._bufferIndex, s;
  return n === i ? s = [e[n].slice(r, a)] : (s = e.slice(n, i), r > -1 && (s[0] = s[0].slice(r)), a > 0 && s.push(e[i].slice(0, a))), s;
}
var Aj = wj, Sj = Ul, kj = Xt, Dj = xm, Oj = Ii, Qd = Cm, Nj = b1, Ij = xj, G9 = Ka, Pj = Aj;
function Rj(e, t, n) {
  var r = n ? G9(n) : {
    line: 1,
    column: 1,
    offset: 0
  }, i = {}, a = [], s = [], o = [], l = {
    consume: E,
    enter: b,
    exit: _,
    attempt: A(T),
    check: A(x),
    interrupt: A(x, {
      interrupt: !0
    }),
    lazy: A(x, {
      lazy: !0
    })
  }, u = {
    previous: null,
    events: [],
    parser: e,
    sliceStream: p,
    sliceSerialize: f,
    now: g,
    defineSkip: m,
    write: d
  }, c = t.tokenize.call(u, l);
  return t.resolveAll && a.push(t), r._index = 0, r._bufferIndex = -1, u;
  function d(I) {
    return s = Dj(s, I), y(), s[s.length - 1] !== null ? [] : (R(t, 0), u.events = Nj(a, u.events, u), u.events);
  }
  function f(I) {
    return Ij(p(I));
  }
  function p(I) {
    return Pj(s, I);
  }
  function g() {
    return G9(r);
  }
  function m(I) {
    i[I.line] = I.column, L();
  }
  function y() {
    for (var I, O; r._index < s.length; )
      if (O = s[r._index], typeof O == "string")
        for (I = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === I && r._bufferIndex < O.length; )
          v(O.charCodeAt(r._bufferIndex));
      else
        v(O);
  }
  function v(I) {
    c = c(I);
  }
  function E(I) {
    kj(I) ? (r.line++, r.column = 1, r.offset += I === -3 ? 2 : 1, L()) : I !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === s[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = I;
  }
  function b(I, O) {
    var S = O || {};
    return S.type = I, S.start = g(), u.events.push(["enter", S, u]), o.push(S), S;
  }
  function _(I) {
    var O = o.pop();
    return O.end = g(), u.events.push(["exit", O, u]), O;
  }
  function T(I, O) {
    R(I, O.from);
  }
  function x(I, O) {
    O.restore();
  }
  function A(I, O) {
    return S;
    function S(F, H, q) {
      var N, Q, J, D;
      return F.tokenize || "length" in F ? Z(Qd(F)) : C;
      function C(U) {
        return U in F || null in F ? Z(
          F.null ? (
            /* c8 ignore next */
            Qd(F[U]).concat(Qd(F.null))
          ) : F[U]
        )(U) : q(U);
      }
      function Z(U) {
        return N = U, Q = 0, B(U[Q]);
      }
      function B(U) {
        return $;
        function $(ae) {
          return D = P(), J = U, U.partial || (u.currentConstruct = U), U.name && u.parser.constructs.disable.null.indexOf(U.name) > -1 ? z() : U.tokenize.call(
            O ? Sj({}, u, O) : u,
            l,
            j,
            z
          )(ae);
        }
      }
      function j(U) {
        return I(J, D), H;
      }
      function z(U) {
        return D.restore(), ++Q < N.length ? B(N[Q]) : q;
      }
    }
  }
  function R(I, O) {
    I.resolveAll && a.indexOf(I) < 0 && a.push(I), I.resolve && Oj(
      u.events,
      O,
      u.events.length - O,
      I.resolve(u.events.slice(O), u)
    ), I.resolveTo && (u.events = I.resolveTo(u.events, u));
  }
  function P() {
    var I = g(), O = u.previous, S = u.currentConstruct, F = u.events.length, H = Array.from(o);
    return {
      restore: q,
      from: F
    };
    function q() {
      r = I, u.previous = O, u.currentConstruct = S, u.events.length = F, o = H, L();
    }
  }
  function L() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
var Fj = Rj, ni = {};
function Bj(e) {
  return e < 0 || e === 32;
}
var Pi = Bj, Mj = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, Lj = Mj, $j = y1;
function jj(e) {
  return t;
  function t(n) {
    return e.test($j(n));
  }
}
var da = jj, Hj = Lj, Uj = da, zj = Uj(Hj), wm = zj, qj = da, Wj = qj(/\s/), Am = Wj, Vj = Pi, Kj = wm, Gj = Am;
function Yj(e) {
  if (e === null || Vj(e) || Gj(e))
    return 1;
  if (Kj(e))
    return 2;
}
var y8 = Yj;
function Zj(e, t) {
  return e.column += t, e.offset += t, e._bufferIndex += t, e;
}
var Qj = Zj, Eo = xm, Xj = Ii, Y9 = y8, Z9 = Qj, Jj = b1, Mr = Ka, eH = {
  name: "attention",
  tokenize: nH,
  resolveAll: tH
};
function tH(e, t) {
  for (var n = -1, r, i, a, s, o, l, u, c; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          l = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1, s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: Z9(Mr(e[r][1].end), -l),
            end: Mr(e[r][1].end)
          }, o = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: Mr(e[n][1].start),
            end: Z9(Mr(e[n][1].start), l)
          }, a = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: Mr(e[r][1].end),
            end: Mr(e[n][1].start)
          }, i = {
            type: l > 1 ? "strong" : "emphasis",
            start: Mr(s.start),
            end: Mr(o.end)
          }, e[r][1].end = Mr(s.start), e[n][1].start = Mr(o.end), u = [], e[r][1].end.offset - e[r][1].start.offset && (u = Eo(u, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])), u = Eo(u, [
            ["enter", i, t],
            ["enter", s, t],
            ["exit", s, t],
            ["enter", a, t]
          ]), u = Eo(
            u,
            Jj(
              t.parser.constructs.insideSpan.null,
              e.slice(r + 1, n),
              t
            )
          ), u = Eo(u, [
            ["exit", a, t],
            ["enter", o, t],
            ["exit", o, t],
            ["exit", i, t]
          ]), e[n][1].end.offset - e[n][1].start.offset ? (c = 2, u = Eo(u, [
            ["enter", e[n][1], t],
            ["exit", e[n][1], t]
          ])) : c = 0, Xj(e, r - 1, n - r + 3, u), n = r + u.length - c - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function nH(e, t) {
  var n = Y9(this.previous), r;
  return i;
  function i(s) {
    return e.enter("attentionSequence"), r = s, a(s);
  }
  function a(s) {
    var o, l, u, c;
    return s === r ? (e.consume(s), a) : (o = e.exit("attentionSequence"), l = Y9(s), u = !l || l === 2 && n, c = !n || n === 2 && l, o._open = r === 42 ? u : u && (n || !c), o._close = r === 42 ? c : c && (l || !u), t(s));
  }
}
var rH = eH, iH = da, aH = iH(/[A-Za-z]/), T1 = aH, sH = da, oH = sH(/[\dA-Za-z]/), ql = oH, lH = da, uH = lH(/[#-'*+\--9=?A-Z^-~]/), cH = uH;
function dH(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e < 32 || e === 127
  );
}
var Sm = dH, fH = T1, Cu = ql, Q9 = cH, hH = Sm, pH = {
  name: "autolink",
  tokenize: mH
};
function mH(e, t, n) {
  var r = 1;
  return i;
  function i(g) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(g) {
    return fH(g) ? (e.consume(g), s) : Q9(g) ? u(g) : n(g);
  }
  function s(g) {
    return g === 43 || g === 45 || g === 46 || Cu(g) ? o(g) : u(g);
  }
  function o(g) {
    return g === 58 ? (e.consume(g), l) : (g === 43 || g === 45 || g === 46 || Cu(g)) && r++ < 32 ? (e.consume(g), o) : u(g);
  }
  function l(g) {
    return g === 62 ? (e.exit("autolinkProtocol"), p(g)) : g === 32 || g === 60 || hH(g) ? n(g) : (e.consume(g), l);
  }
  function u(g) {
    return g === 64 ? (e.consume(g), r = 0, c) : Q9(g) ? (e.consume(g), u) : n(g);
  }
  function c(g) {
    return Cu(g) ? d(g) : n(g);
  }
  function d(g) {
    return g === 46 ? (e.consume(g), r = 0, c) : g === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", p(g)) : f(g);
  }
  function f(g) {
    return (g === 45 || Cu(g)) && r++ < 63 ? (e.consume(g), g === 45 ? f : d) : n(g);
  }
  function p(g) {
    return e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), t;
  }
}
var gH = pH, vH = Ni, yH = tn, E8 = {
  name: "blockQuote",
  tokenize: EH,
  continuation: {
    tokenize: bH
  },
  exit: TH
};
function EH(e, t, n) {
  var r = this;
  return i;
  function i(s) {
    return s === 62 ? (r.containerState.open || (e.enter("blockQuote", {
      _container: !0
    }), r.containerState.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), a) : n(s);
  }
  function a(s) {
    return vH(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(s));
  }
}
function bH(e, t, n) {
  return yH(
    e,
    e.attempt(E8, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
  );
}
function TH(e) {
  e.exit("blockQuote");
}
var _H = E8, CH = da, xH = CH(/[!-/:-@[-`{-~]/), wH = xH, AH = wH, SH = {
  name: "characterEscape",
  tokenize: kH
};
function kH(e, t, n) {
  return r;
  function r(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), i;
  }
  function i(a) {
    return AH(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(a);
  }
}
var DH = SH, xu, OH = 59, b8 = NH;
function NH(e) {
  var t = "&" + e + ";", n;
  return xu = xu || document.createElement("i"), xu.innerHTML = t, n = xu.textContent, n.charCodeAt(n.length - 1) === OH && e !== "semi" || n === t ? !1 : n;
}
var IH = da, PH = IH(/\d/), T8 = PH, RH = da, FH = RH(/[\dA-Fa-f]/), BH = FH, MH = b8, X9 = ql, LH = T8, $H = BH;
function jH(e) {
  return e && typeof e == "object" && "default" in e ? e : { default: e };
}
var HH = /* @__PURE__ */ jH(MH), UH = {
  name: "characterReference",
  tokenize: zH
};
function zH(e, t, n) {
  var r = this, i = 0, a, s;
  return o;
  function o(d) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), l;
  }
  function l(d) {
    return d === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(d), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), a = 31, s = X9, c(d));
  }
  function u(d) {
    return d === 88 || d === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(d), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, s = $H, c) : (e.enter("characterReferenceValue"), a = 7, s = LH, c(d));
  }
  function c(d) {
    var f;
    return d === 59 && i ? (f = e.exit("characterReferenceValue"), s === X9 && !HH.default(r.sliceSerialize(f)) ? n(d) : (e.enter("characterReferenceMarker"), e.consume(d), e.exit("characterReferenceMarker"), e.exit("characterReference"), t)) : s(d) && i++ < a ? (e.consume(d), c) : n(d);
  }
}
var qH = UH, ss = Xt, WH = Pi, VH = zl, bo = tn, KH = {
  name: "codeFenced",
  tokenize: GH,
  concrete: !0
};
function GH(e, t, n) {
  var r = this, i = {
    tokenize: E,
    partial: !0
  }, a = VH(this.events, "linePrefix"), s = 0, o;
  return l;
  function l(b) {
    return e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), o = b, u(b);
  }
  function u(b) {
    return b === o ? (e.consume(b), s++, u) : (e.exit("codeFencedFenceSequence"), s < 3 ? n(b) : bo(e, c, "whitespace")(b));
  }
  function c(b) {
    return b === null || ss(b) ? g(b) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), d(b));
  }
  function d(b) {
    return b === null || WH(b) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), bo(e, f, "whitespace")(b)) : b === 96 && b === o ? n(b) : (e.consume(b), d);
  }
  function f(b) {
    return b === null || ss(b) ? g(b) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), p(b));
  }
  function p(b) {
    return b === null || ss(b) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), g(b)) : b === 96 && b === o ? n(b) : (e.consume(b), p);
  }
  function g(b) {
    return e.exit("codeFencedFence"), r.interrupt ? t(b) : m(b);
  }
  function m(b) {
    return b === null ? v(b) : ss(b) ? (e.enter("lineEnding"), e.consume(b), e.exit("lineEnding"), e.attempt(
      i,
      v,
      a ? bo(e, m, "linePrefix", a + 1) : m
    )) : (e.enter("codeFlowValue"), y(b));
  }
  function y(b) {
    return b === null || ss(b) ? (e.exit("codeFlowValue"), m(b)) : (e.consume(b), y);
  }
  function v(b) {
    return e.exit("codeFenced"), t(b);
  }
  function E(b, _, T) {
    var x = 0;
    return bo(
      b,
      A,
      "linePrefix",
      this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
    );
    function A(L) {
      return b.enter("codeFencedFence"), b.enter("codeFencedFenceSequence"), R(L);
    }
    function R(L) {
      return L === o ? (b.consume(L), x++, R) : x < s ? T(L) : (b.exit("codeFencedFenceSequence"), bo(b, P, "whitespace")(L));
    }
    function P(L) {
      return L === null || ss(L) ? (b.exit("codeFencedFence"), _(L)) : T(L);
    }
  }
}
var YH = KH, Kh = Xt, J9 = Ii, ZH = zl, e5 = tn, QH = {
  name: "codeIndented",
  tokenize: JH,
  resolve: XH
}, t5 = {
  tokenize: eU,
  partial: !0
};
function XH(e, t) {
  var n = {
    type: "codeIndented",
    start: e[0][1].start,
    end: e[e.length - 1][1].end
  };
  return J9(e, 0, 0, [["enter", n, t]]), J9(e, e.length, 0, [["exit", n, t]]), e;
}
function JH(e, t, n) {
  return e.attempt(t5, r, n);
  function r(a) {
    return a === null ? t(a) : Kh(a) ? e.attempt(t5, r, t)(a) : (e.enter("codeFlowValue"), i(a));
  }
  function i(a) {
    return a === null || Kh(a) ? (e.exit("codeFlowValue"), r(a)) : (e.consume(a), i);
  }
}
function eU(e, t, n) {
  var r = this;
  return e5(e, i, "linePrefix", 4 + 1);
  function i(a) {
    return Kh(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e5(e, i, "linePrefix", 4 + 1)) : ZH(r.events, "linePrefix") < 4 ? n(a) : t(a);
  }
}
var tU = QH, n5 = Xt, nU = {
  name: "codeText",
  tokenize: aU,
  resolve: rU,
  previous: iU
};
function rU(e) {
  var t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[t][1].type = e[n][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function iU(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function aU(e, t, n) {
  var r = 0, i, a;
  return s;
  function s(d) {
    return e.enter("codeText"), e.enter("codeTextSequence"), o(d);
  }
  function o(d) {
    return d === 96 ? (e.consume(d), r++, o) : (e.exit("codeTextSequence"), l(d));
  }
  function l(d) {
    return d === null ? n(d) : d === 96 ? (a = e.enter("codeTextSequence"), i = 0, c(d)) : d === 32 ? (e.enter("space"), e.consume(d), e.exit("space"), l) : n5(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), l) : (e.enter("codeTextData"), u(d));
  }
  function u(d) {
    return d === null || d === 32 || d === 96 || n5(d) ? (e.exit("codeTextData"), l(d)) : (e.consume(d), u);
  }
  function c(d) {
    return d === 96 ? (e.consume(d), i++, c) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(d)) : (a.type = "codeTextData", u(d));
  }
}
var sU = nU, r5 = Sm, oU = Pi, lU = Xt;
function uU(e, t, n, r, i, a, s, o, l) {
  var u = l || 1 / 0, c = 0;
  return d;
  function d(v) {
    return v === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(v), e.exit(a), f) : r5(v) || v === 41 ? n(v) : (e.enter(r), e.enter(s), e.enter(o), e.enter("chunkString", {
      contentType: "string"
    }), m(v));
  }
  function f(v) {
    return v === 62 ? (e.enter(a), e.consume(v), e.exit(a), e.exit(i), e.exit(r), t) : (e.enter(o), e.enter("chunkString", {
      contentType: "string"
    }), p(v));
  }
  function p(v) {
    return v === 62 ? (e.exit("chunkString"), e.exit(o), f(v)) : v === null || v === 60 || lU(v) ? n(v) : (e.consume(v), v === 92 ? g : p);
  }
  function g(v) {
    return v === 60 || v === 62 || v === 92 ? (e.consume(v), p) : p(v);
  }
  function m(v) {
    return v === 40 ? ++c > u ? n(v) : (e.consume(v), m) : v === 41 ? c-- ? (e.consume(v), m) : (e.exit("chunkString"), e.exit(o), e.exit(s), e.exit(r), t(v)) : v === null || oU(v) ? c ? n(v) : (e.exit("chunkString"), e.exit(o), e.exit(s), e.exit(r), t(v)) : r5(v) ? n(v) : (e.consume(v), v === 92 ? y : m);
  }
  function y(v) {
    return v === 40 || v === 41 || v === 92 ? (e.consume(v), m) : m(v);
  }
}
var _8 = uU, i5 = Xt, cU = Ni;
function dU(e, t, n, r, i, a) {
  var s = this, o = 0, l;
  return u;
  function u(p) {
    return e.enter(r), e.enter(i), e.consume(p), e.exit(i), e.enter(a), c;
  }
  function c(p) {
    return p === null || p === 91 || p === 93 && !l || /* c8 ignore next */
    p === 94 && /* c8 ignore next */
    !o && /* c8 ignore next */
    "_hiddenFootnoteSupport" in s.parser.constructs || o > 999 ? n(p) : p === 93 ? (e.exit(a), e.enter(i), e.consume(p), e.exit(i), e.exit(r), t) : i5(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), c) : (e.enter("chunkString", {
      contentType: "string"
    }), d(p));
  }
  function d(p) {
    return p === null || p === 91 || p === 93 || i5(p) || o++ > 999 ? (e.exit("chunkString"), c(p)) : (e.consume(p), l = l || !cU(p), p === 92 ? f : d);
  }
  function f(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), o++, d) : d(p);
  }
}
var C8 = dU, fU = Xt, hU = Ni, pU = tn;
function mU(e, t) {
  var n;
  return r;
  function r(i) {
    return fU(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : hU(i) ? pU(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
var x8 = mU, a5 = Xt, gU = tn;
function vU(e, t, n, r, i, a) {
  var s;
  return o;
  function o(f) {
    return e.enter(r), e.enter(i), e.consume(f), e.exit(i), s = f === 40 ? 41 : f, l;
  }
  function l(f) {
    return f === s ? (e.enter(i), e.consume(f), e.exit(i), e.exit(r), t) : (e.enter(a), u(f));
  }
  function u(f) {
    return f === s ? (e.exit(a), l(s)) : f === null ? n(f) : a5(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), gU(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), c(f));
  }
  function c(f) {
    return f === s || f === null || a5(f) ? (e.exit("chunkString"), u(f)) : (e.consume(f), f === 92 ? d : c);
  }
  function d(f) {
    return f === s || f === 92 ? (e.consume(f), c) : c(f);
  }
}
var w8 = vU, A8 = Xt, yU = Pi, EU = Em, bU = _8, TU = C8, Gh = tn, S8 = x8, _U = w8, CU = {
  name: "definition",
  tokenize: wU
}, xU = {
  tokenize: AU,
  partial: !0
};
function wU(e, t, n) {
  var r = this, i;
  return a;
  function a(l) {
    return e.enter("definition"), TU.call(
      r,
      e,
      s,
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(l);
  }
  function s(l) {
    return i = EU(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), l === 58 ? (e.enter("definitionMarker"), e.consume(l), e.exit("definitionMarker"), S8(
      e,
      bU(
        e,
        e.attempt(
          xU,
          Gh(e, o, "whitespace"),
          Gh(e, o, "whitespace")
        ),
        n,
        "definitionDestination",
        "definitionDestinationLiteral",
        "definitionDestinationLiteralMarker",
        "definitionDestinationRaw",
        "definitionDestinationString"
      )
    )) : n(l);
  }
  function o(l) {
    return l === null || A8(l) ? (e.exit("definition"), r.parser.defined.indexOf(i) < 0 && r.parser.defined.push(i), t(l)) : n(l);
  }
}
function AU(e, t, n) {
  return r;
  function r(s) {
    return yU(s) ? S8(e, i)(s) : n(s);
  }
  function i(s) {
    return s === 34 || s === 39 || s === 40 ? _U(
      e,
      Gh(e, a, "whitespace"),
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(s) : n(s);
  }
  function a(s) {
    return s === null || A8(s) ? t(s) : n(s);
  }
}
var SU = CU, kU = Xt, DU = {
  name: "hardBreakEscape",
  tokenize: OU
};
function OU(e, t, n) {
  return r;
  function r(a) {
    return e.enter("hardBreakEscape"), e.enter("escapeMarker"), e.consume(a), i;
  }
  function i(a) {
    return kU(a) ? (e.exit("escapeMarker"), e.exit("hardBreakEscape"), t(a)) : n(a);
  }
}
var NU = DU, IU = Xt, s5 = Pi, PU = Ni, RU = Ii, FU = tn, BU = {
  name: "headingAtx",
  tokenize: LU,
  resolve: MU
};
function MU(e, t) {
  var n = e.length - 2, r = 3, i, a;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, a = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, RU(e, r, n - r + 1, [
    ["enter", i, t],
    ["enter", a, t],
    ["exit", a, t],
    ["exit", i, t]
  ])), e;
}
function LU(e, t, n) {
  var r = this, i = 0;
  return a;
  function a(c) {
    return e.enter("atxHeading"), e.enter("atxHeadingSequence"), s(c);
  }
  function s(c) {
    return c === 35 && i++ < 6 ? (e.consume(c), s) : c === null || s5(c) ? (e.exit("atxHeadingSequence"), r.interrupt ? t(c) : o(c)) : n(c);
  }
  function o(c) {
    return c === 35 ? (e.enter("atxHeadingSequence"), l(c)) : c === null || IU(c) ? (e.exit("atxHeading"), t(c)) : PU(c) ? FU(e, o, "whitespace")(c) : (e.enter("atxHeadingText"), u(c));
  }
  function l(c) {
    return c === 35 ? (e.consume(c), l) : (e.exit("atxHeadingSequence"), o(c));
  }
  function u(c) {
    return c === null || c === 35 || s5(c) ? (e.exit("atxHeadingText"), o(c)) : (e.consume(c), u);
  }
}
var $U = BU, jU = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "section",
  "source",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], HU = jU, UU = ["pre", "script", "style", "textarea"], zU = UU, To = T1, o5 = ql, os = Xt, l5 = Pi, ls = Ni, wu = y1, qU = HU, u5 = zU, WU = E1, VU = {
  name: "htmlFlow",
  tokenize: YU,
  resolveTo: GU,
  concrete: !0
}, KU = {
  tokenize: ZU,
  partial: !0
};
function GU(e) {
  for (var t = e.length; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function YU(e, t, n) {
  var r = this, i, a, s, o, l;
  return u;
  function u(C) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(C), c;
  }
  function c(C) {
    return C === 33 ? (e.consume(C), d) : C === 47 ? (e.consume(C), g) : C === 63 ? (e.consume(C), i = 3, r.interrupt ? t : Q) : To(C) ? (e.consume(C), s = wu(C), a = !0, m) : n(C);
  }
  function d(C) {
    return C === 45 ? (e.consume(C), i = 2, f) : C === 91 ? (e.consume(C), i = 5, s = "CDATA[", o = 0, p) : To(C) ? (e.consume(C), i = 4, r.interrupt ? t : Q) : n(C);
  }
  function f(C) {
    return C === 45 ? (e.consume(C), r.interrupt ? t : Q) : n(C);
  }
  function p(C) {
    return C === s.charCodeAt(o++) ? (e.consume(C), o === s.length ? r.interrupt ? t : I : p) : n(C);
  }
  function g(C) {
    return To(C) ? (e.consume(C), s = wu(C), m) : n(C);
  }
  function m(C) {
    return C === null || C === 47 || C === 62 || l5(C) ? C !== 47 && a && u5.indexOf(s.toLowerCase()) > -1 ? (i = 1, r.interrupt ? t(C) : I(C)) : qU.indexOf(s.toLowerCase()) > -1 ? (i = 6, C === 47 ? (e.consume(C), y) : r.interrupt ? t(C) : I(C)) : (i = 7, r.interrupt ? n(C) : a ? E(C) : v(C)) : C === 45 || o5(C) ? (e.consume(C), s += wu(C), m) : n(C);
  }
  function y(C) {
    return C === 62 ? (e.consume(C), r.interrupt ? t : I) : n(C);
  }
  function v(C) {
    return ls(C) ? (e.consume(C), v) : P(C);
  }
  function E(C) {
    return C === 47 ? (e.consume(C), P) : C === 58 || C === 95 || To(C) ? (e.consume(C), b) : ls(C) ? (e.consume(C), E) : P(C);
  }
  function b(C) {
    return C === 45 || C === 46 || C === 58 || C === 95 || o5(C) ? (e.consume(C), b) : _(C);
  }
  function _(C) {
    return C === 61 ? (e.consume(C), T) : ls(C) ? (e.consume(C), _) : E(C);
  }
  function T(C) {
    return C === null || C === 60 || C === 61 || C === 62 || C === 96 ? n(C) : C === 34 || C === 39 ? (e.consume(C), l = C, x) : ls(C) ? (e.consume(C), T) : (l = void 0, A(C));
  }
  function x(C) {
    return C === l ? (e.consume(C), R) : C === null || os(C) ? n(C) : (e.consume(C), x);
  }
  function A(C) {
    return C === null || C === 34 || C === 39 || C === 60 || C === 61 || C === 62 || C === 96 || l5(C) ? _(C) : (e.consume(C), A);
  }
  function R(C) {
    return C === 47 || C === 62 || ls(C) ? E(C) : n(C);
  }
  function P(C) {
    return C === 62 ? (e.consume(C), L) : n(C);
  }
  function L(C) {
    return ls(C) ? (e.consume(C), L) : C === null || os(C) ? I(C) : n(C);
  }
  function I(C) {
    return C === 45 && i === 2 ? (e.consume(C), F) : C === 60 && i === 1 ? (e.consume(C), H) : C === 62 && i === 4 ? (e.consume(C), J) : C === 63 && i === 3 ? (e.consume(C), Q) : C === 93 && i === 5 ? (e.consume(C), N) : os(C) && (i === 6 || i === 7) ? e.check(
      KU,
      J,
      O
    )(C) : C === null || os(C) ? O(C) : (e.consume(C), I);
  }
  function O(C) {
    return e.exit("htmlFlowData"), S(C);
  }
  function S(C) {
    return C === null ? D(C) : os(C) ? (e.enter("lineEnding"), e.consume(C), e.exit("lineEnding"), S) : (e.enter("htmlFlowData"), I(C));
  }
  function F(C) {
    return C === 45 ? (e.consume(C), Q) : I(C);
  }
  function H(C) {
    return C === 47 ? (e.consume(C), s = "", q) : I(C);
  }
  function q(C) {
    return C === 62 && u5.indexOf(s.toLowerCase()) > -1 ? (e.consume(C), J) : To(C) && s.length < 8 ? (e.consume(C), s += wu(C), q) : I(C);
  }
  function N(C) {
    return C === 93 ? (e.consume(C), Q) : I(C);
  }
  function Q(C) {
    return C === 62 ? (e.consume(C), J) : I(C);
  }
  function J(C) {
    return C === null || os(C) ? (e.exit("htmlFlowData"), D(C)) : (e.consume(C), J);
  }
  function D(C) {
    return e.exit("htmlFlow"), t(C);
  }
}
function ZU(e, t, n) {
  return r;
  function r(i) {
    return e.exit("htmlFlowData"), e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), e.attempt(WU, t, n);
  }
}
var QU = VU, Au = T1, Xd = ql, si = Xt, Jd = Pi, Su = Ni, XU = tn, JU = {
  name: "htmlText",
  tokenize: ez
};
function ez(e, t, n) {
  var r = this, i, a, s, o;
  return l;
  function l(C) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(C), u;
  }
  function u(C) {
    return C === 33 ? (e.consume(C), c) : C === 47 ? (e.consume(C), A) : C === 63 ? (e.consume(C), T) : Au(C) ? (e.consume(C), L) : n(C);
  }
  function c(C) {
    return C === 45 ? (e.consume(C), d) : C === 91 ? (e.consume(C), a = "CDATA[", s = 0, y) : Au(C) ? (e.consume(C), _) : n(C);
  }
  function d(C) {
    return C === 45 ? (e.consume(C), f) : n(C);
  }
  function f(C) {
    return C === null || C === 62 ? n(C) : C === 45 ? (e.consume(C), p) : g(C);
  }
  function p(C) {
    return C === null || C === 62 ? n(C) : g(C);
  }
  function g(C) {
    return C === null ? n(C) : C === 45 ? (e.consume(C), m) : si(C) ? (o = g, Q(C)) : (e.consume(C), g);
  }
  function m(C) {
    return C === 45 ? (e.consume(C), D) : g(C);
  }
  function y(C) {
    return C === a.charCodeAt(s++) ? (e.consume(C), s === a.length ? v : y) : n(C);
  }
  function v(C) {
    return C === null ? n(C) : C === 93 ? (e.consume(C), E) : si(C) ? (o = v, Q(C)) : (e.consume(C), v);
  }
  function E(C) {
    return C === 93 ? (e.consume(C), b) : v(C);
  }
  function b(C) {
    return C === 62 ? D(C) : C === 93 ? (e.consume(C), b) : v(C);
  }
  function _(C) {
    return C === null || C === 62 ? D(C) : si(C) ? (o = _, Q(C)) : (e.consume(C), _);
  }
  function T(C) {
    return C === null ? n(C) : C === 63 ? (e.consume(C), x) : si(C) ? (o = T, Q(C)) : (e.consume(C), T);
  }
  function x(C) {
    return C === 62 ? D(C) : T(C);
  }
  function A(C) {
    return Au(C) ? (e.consume(C), R) : n(C);
  }
  function R(C) {
    return C === 45 || Xd(C) ? (e.consume(C), R) : P(C);
  }
  function P(C) {
    return si(C) ? (o = P, Q(C)) : Su(C) ? (e.consume(C), P) : D(C);
  }
  function L(C) {
    return C === 45 || Xd(C) ? (e.consume(C), L) : C === 47 || C === 62 || Jd(C) ? I(C) : n(C);
  }
  function I(C) {
    return C === 47 ? (e.consume(C), D) : C === 58 || C === 95 || Au(C) ? (e.consume(C), O) : si(C) ? (o = I, Q(C)) : Su(C) ? (e.consume(C), I) : D(C);
  }
  function O(C) {
    return C === 45 || C === 46 || C === 58 || C === 95 || Xd(C) ? (e.consume(C), O) : S(C);
  }
  function S(C) {
    return C === 61 ? (e.consume(C), F) : si(C) ? (o = S, Q(C)) : Su(C) ? (e.consume(C), S) : I(C);
  }
  function F(C) {
    return C === null || C === 60 || C === 61 || C === 62 || C === 96 ? n(C) : C === 34 || C === 39 ? (e.consume(C), i = C, H) : si(C) ? (o = F, Q(C)) : Su(C) ? (e.consume(C), F) : (e.consume(C), i = void 0, N);
  }
  function H(C) {
    return C === i ? (e.consume(C), q) : C === null ? n(C) : si(C) ? (o = H, Q(C)) : (e.consume(C), H);
  }
  function q(C) {
    return C === 62 || C === 47 || Jd(C) ? I(C) : n(C);
  }
  function N(C) {
    return C === null || C === 34 || C === 39 || C === 60 || C === 61 || C === 96 ? n(C) : C === 62 || Jd(C) ? I(C) : (e.consume(C), N);
  }
  function Q(C) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(C), e.exit("lineEnding"), XU(
      e,
      J,
      "linePrefix",
      r.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
    );
  }
  function J(C) {
    return e.enter("htmlTextData"), o(C);
  }
  function D(C) {
    return C === 62 ? (e.consume(C), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(C);
  }
}
var tz = JU, nz = Pi, us = xm, rz = Ii, k8 = Em, iz = b1, cs = Ka, az = _8, sz = C8, oz = w8, ef = x8, lz = {
  name: "labelEnd",
  tokenize: pz,
  resolveTo: hz,
  resolveAll: fz
}, uz = {
  tokenize: mz
}, cz = {
  tokenize: gz
}, dz = {
  tokenize: vz
};
function fz(e) {
  for (var t = -1, n; ++t < e.length; )
    n = e[t][1], !n._used && (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  return e;
}
function hz(e, t) {
  for (var n = e.length, r = 0, i, a, s, o, l, u, c; n--; )
    if (o = e[n][1], l) {
      if (o.type === "link" || o.type === "labelLink" && o._inactive)
        break;
      e[n][0] === "enter" && o.type === "labelLink" && (o._inactive = !0);
    } else if (u) {
      if (e[n][0] === "enter" && (o.type === "labelImage" || o.type === "labelLink") && !o._balanced && (l = n, o.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      o.type === "labelEnd" && (u = n);
  return i = {
    type: e[l][1].type === "labelLink" ? "link" : "image",
    start: cs(e[l][1].start),
    end: cs(e[e.length - 1][1].end)
  }, a = {
    type: "label",
    start: cs(e[l][1].start),
    end: cs(e[u][1].end)
  }, s = {
    type: "labelText",
    start: cs(e[l + r + 2][1].end),
    end: cs(e[u - 2][1].start)
  }, c = [
    ["enter", i, t],
    ["enter", a, t]
  ], c = us(c, e.slice(l + 1, l + r + 3)), c = us(c, [["enter", s, t]]), c = us(
    c,
    iz(
      t.parser.constructs.insideSpan.null,
      e.slice(l + r + 4, u - 3),
      t
    )
  ), c = us(c, [
    ["exit", s, t],
    e[u - 2],
    e[u - 1],
    ["exit", a, t]
  ]), c = us(c, e.slice(u + 1)), c = us(c, [["exit", i, t]]), rz(e, l, e.length, c), e;
}
function pz(e, t, n) {
  for (var r = this, i = r.events.length, a, s; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      a = r.events[i][1];
      break;
    }
  return o;
  function o(c) {
    return a ? a._inactive ? u(c) : (s = r.parser.defined.indexOf(
      k8(
        r.sliceSerialize({
          start: a.end,
          end: r.now()
        })
      )
    ) > -1, e.enter("labelEnd"), e.enter("labelMarker"), e.consume(c), e.exit("labelMarker"), e.exit("labelEnd"), l) : n(c);
  }
  function l(c) {
    return c === 40 ? e.attempt(
      uz,
      t,
      s ? t : u
    )(c) : c === 91 ? e.attempt(
      cz,
      t,
      s ? e.attempt(dz, t, u) : u
    )(c) : s ? t(c) : u(c);
  }
  function u(c) {
    return a._balanced = !0, n(c);
  }
}
function mz(e, t, n) {
  return r;
  function r(l) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(l), e.exit("resourceMarker"), ef(e, i);
  }
  function i(l) {
    return l === 41 ? o(l) : az(
      e,
      a,
      n,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      3
    )(l);
  }
  function a(l) {
    return nz(l) ? ef(e, s)(l) : o(l);
  }
  function s(l) {
    return l === 34 || l === 39 || l === 40 ? oz(
      e,
      ef(e, o),
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(l) : o(l);
  }
  function o(l) {
    return l === 41 ? (e.enter("resourceMarker"), e.consume(l), e.exit("resourceMarker"), e.exit("resource"), t) : n(l);
  }
}
function gz(e, t, n) {
  var r = this;
  return i;
  function i(s) {
    return sz.call(
      r,
      e,
      a,
      n,
      "reference",
      "referenceMarker",
      "referenceString"
    )(s);
  }
  function a(s) {
    return r.parser.defined.indexOf(
      k8(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) < 0 ? n(s) : t(s);
  }
}
function vz(e, t, n) {
  return r;
  function r(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), i;
  }
  function i(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), t) : n(a);
  }
}
var km = lz, yz = km, Ez = {
  name: "labelStartImage",
  tokenize: bz,
  resolveAll: yz.resolveAll
};
function bz(e, t, n) {
  var r = this;
  return i;
  function i(o) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(o), e.exit("labelImageMarker"), a;
  }
  function a(o) {
    return o === 91 ? (e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelImage"), s) : n(o);
  }
  function s(o) {
    return o === 94 && /* c8 ignore next */
    "_hiddenFootnoteSupport" in r.parser.constructs ? (
      /* c8 ignore next */
      n(o)
    ) : t(o);
  }
}
var Tz = Ez, _z = km, Cz = {
  name: "labelStartLink",
  tokenize: xz,
  resolveAll: _z.resolveAll
};
function xz(e, t, n) {
  var r = this;
  return i;
  function i(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(s) {
    return s === 94 && /* c8 ignore next */
    "_hiddenFootnoteSupport" in r.parser.constructs ? (
      /* c8 ignore next */
      n(s)
    ) : t(s);
  }
}
var wz = Cz, Az = tn, Sz = {
  name: "lineEnding",
  tokenize: kz
};
function kz(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), Az(e, t, "linePrefix");
  }
}
var Dz = Sz, Oz = Xt, Nz = Ni, Iz = tn, Pz = {
  name: "thematicBreak",
  tokenize: Rz
};
function Rz(e, t, n) {
  var r = 0, i;
  return a;
  function a(l) {
    return e.enter("thematicBreak"), i = l, s(l);
  }
  function s(l) {
    return l === i ? (e.enter("thematicBreakSequence"), o(l)) : Nz(l) ? Iz(e, s, "whitespace")(l) : r < 3 || l !== null && !Oz(l) ? n(l) : (e.exit("thematicBreak"), t(l));
  }
  function o(l) {
    return l === i ? (e.consume(l), r++, o) : (e.exit("thematicBreakSequence"), s(l));
  }
}
var D8 = Pz, c5 = T8, Dm = Ni, Om = zl, Fz = d8, Kc = tn, O8 = E1, Bz = D8, N8 = {
  name: "list",
  tokenize: $z,
  continuation: {
    tokenize: jz
  },
  exit: Uz
}, Mz = {
  tokenize: zz,
  partial: !0
}, Lz = {
  tokenize: Hz,
  partial: !0
};
function $z(e, t, n) {
  var r = this, i = Om(r.events, "linePrefix"), a = 0;
  return s;
  function s(f) {
    var p = r.containerState.type || (f === 42 || f === 43 || f === 45 ? "listUnordered" : "listOrdered");
    if (p === "listUnordered" ? !r.containerState.marker || f === r.containerState.marker : c5(f)) {
      if (r.containerState.type || (r.containerState.type = p, e.enter(p, {
        _container: !0
      })), p === "listUnordered")
        return e.enter("listItemPrefix"), f === 42 || f === 45 ? e.check(Bz, n, l)(f) : l(f);
      if (!r.interrupt || f === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), o(f);
    }
    return n(f);
  }
  function o(f) {
    return c5(f) && ++a < 10 ? (e.consume(f), o) : (!r.interrupt || a < 2) && (r.containerState.marker ? f === r.containerState.marker : f === 41 || f === 46) ? (e.exit("listItemValue"), l(f)) : n(f);
  }
  function l(f) {
    return e.enter("listItemMarker"), e.consume(f), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || f, e.check(
      O8,
      // Can’t be empty when interrupting.
      r.interrupt ? n : u,
      e.attempt(
        Mz,
        d,
        c
      )
    );
  }
  function u(f) {
    return r.containerState.initialBlankLine = !0, i++, d(f);
  }
  function c(f) {
    return Dm(f) ? (e.enter("listItemPrefixWhitespace"), e.consume(f), e.exit("listItemPrefixWhitespace"), d) : n(f);
  }
  function d(f) {
    return r.containerState.size = i + Fz(r.sliceStream(e.exit("listItemPrefix"))), t(f);
  }
}
function jz(e, t, n) {
  var r = this;
  return r.containerState._closeFlow = void 0, e.check(O8, i, a);
  function i(o) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Kc(
      e,
      t,
      "listItemIndent",
      r.containerState.size + 1
    )(o);
  }
  function a(o) {
    return r.containerState.furtherBlankLines || !Dm(o) ? (r.containerState.furtherBlankLines = r.containerState.initialBlankLine = void 0, s(o)) : (r.containerState.furtherBlankLines = r.containerState.initialBlankLine = void 0, e.attempt(Lz, t, s)(o));
  }
  function s(o) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Kc(
      e,
      e.attempt(N8, t, n),
      "linePrefix",
      r.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4
    )(o);
  }
}
function Hz(e, t, n) {
  var r = this;
  return Kc(
    e,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(a) {
    return Om(r.events, "listItemIndent") === r.containerState.size ? t(a) : n(a);
  }
}
function Uz(e) {
  e.exit(this.containerState.type);
}
function zz(e, t, n) {
  var r = this;
  return Kc(
    e,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? void 0 : 4 + 1
  );
  function i(a) {
    return Dm(a) || !Om(r.events, "listItemPrefixWhitespace") ? n(a) : t(a);
  }
}
var qz = N8, Wz = Xt, tf = Ka, Vz = tn, Kz = {
  name: "setextUnderline",
  tokenize: Yz,
  resolveTo: Gz
};
function Gz(e, t) {
  for (var n = e.length, r, i, a, s; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
  return s = {
    type: "setextHeading",
    start: tf(e[i][1].start),
    end: tf(e[e.length - 1][1].end)
  }, e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, ["enter", s, t]), e.splice(a + 1, 0, ["exit", e[r][1], t]), e[r][1].end = tf(e[a][1].end)) : e[r][1] = s, e.push(["exit", s, t]), e;
}
function Yz(e, t, n) {
  for (var r = this, i = r.events.length, a, s; i--; )
    if (r.events[i][1].type !== "lineEnding" && r.events[i][1].type !== "linePrefix" && r.events[i][1].type !== "content") {
      s = r.events[i][1].type === "paragraph";
      break;
    }
  return o;
  function o(c) {
    return !r.lazy && (r.interrupt || s) ? (e.enter("setextHeadingLine"), e.enter("setextHeadingLineSequence"), a = c, l(c)) : n(c);
  }
  function l(c) {
    return c === a ? (e.consume(c), l) : (e.exit("setextHeadingLineSequence"), Vz(e, u, "lineSuffix")(c));
  }
  function u(c) {
    return c === null || Wz(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
var Zz = Kz;
Object.defineProperty(ni, "__esModule", { value: !0 });
var Qz = eo, Yh = rH, Xz = gH, Jz = _H, I8 = DH, P8 = qH, d5 = YH, nf = tU, eq = sU, tq = SU, nq = NU, rq = $U, iq = QU, aq = tz, sq = km, oq = Tz, lq = wz, rf = Dz, Un = qz, f5 = Zz, af = D8, uq = {
  42: Un,
  // Asterisk
  43: Un,
  // Plus sign
  45: Un,
  // Dash
  48: Un,
  // 0
  49: Un,
  // 1
  50: Un,
  // 2
  51: Un,
  // 3
  52: Un,
  // 4
  53: Un,
  // 5
  54: Un,
  // 6
  55: Un,
  // 7
  56: Un,
  // 8
  57: Un,
  // 9
  62: Jz
  // Greater than
}, cq = {
  91: tq
  // Left square bracket
}, dq = {
  "-2": nf,
  // Horizontal tab
  "-1": nf,
  // Virtual space
  32: nf
  // Space
}, fq = {
  35: rq,
  // Number sign
  42: af,
  // Asterisk
  45: [f5, af],
  // Dash
  60: iq,
  // Less than
  61: f5,
  // Equals to
  95: af,
  // Underscore
  96: d5,
  // Grave accent
  126: d5
  // Tilde
}, hq = {
  38: P8,
  // Ampersand
  92: I8
  // Backslash
}, pq = {
  "-5": rf,
  // Carriage return
  "-4": rf,
  // Line feed
  "-3": rf,
  // Carriage return + line feed
  33: oq,
  // Exclamation mark
  38: P8,
  // Ampersand
  42: Yh,
  // Asterisk
  60: [Xz, aq],
  // Less than
  91: lq,
  // Left square bracket
  92: [nq, I8],
  // Backslash
  93: sq,
  // Right square bracket
  95: Yh,
  // Underscore
  96: eq
  // Grave accent
}, mq = {
  null: [Yh, Qz.resolver]
}, gq = {
  null: []
};
ni.contentInitial = cq;
ni.disable = gq;
ni.document = uq;
ni.flow = fq;
ni.flowInitial = dq;
ni.insideSpan = mq;
ni.string = hq;
ni.text = pq;
var vq = bm, yq = Tm, Eq = _m, h5 = eo, bq = v8, Tq = Fj, _q = Cm, Cq = ni;
function xq(e) {
  var t = e || {}, n = {
    defined: [],
    constructs: bq(
      [Cq].concat(_q(t.extensions))
    ),
    content: r(vq),
    document: r(yq),
    flow: r(Eq),
    string: r(h5.string),
    text: r(h5.text)
  };
  return n;
  function r(i) {
    return a;
    function a(s) {
      return Tq(n, i, s);
    }
  }
}
var wq = xq, p5 = /[\0\t\n\r]/g;
function Aq() {
  var e = !0, t = 1, n = "", r;
  return i;
  function i(a, s, o) {
    var l = [], u, c, d, f, p;
    for (a = n + a.toString(s), d = 0, n = "", e && (a.charCodeAt(0) === 65279 && d++, e = void 0); d < a.length; ) {
      if (p5.lastIndex = d, u = p5.exec(a), f = u ? u.index : a.length, p = a.charCodeAt(f), !u) {
        n = a.slice(d);
        break;
      }
      if (p === 10 && d === f && r)
        l.push(-3), r = void 0;
      else if (r && (l.push(-5), r = void 0), d < f && (l.push(a.slice(d, f)), t += f - d), p === 0)
        l.push(65533), t++;
      else if (p === 9)
        for (c = Math.ceil(t / 4) * 4, l.push(-2); t++ < c; )
          l.push(-1);
      else
        p === 10 ? (l.push(-4), t = 1) : (r = !0, t = 1);
      d = f + 1;
    }
    return o && (r && l.push(-5), n && l.push(n), l.push(null)), l;
  }
}
var Sq = Aq, kq = h8;
function Dq(e) {
  for (; !kq(e); )
    ;
  return e;
}
var Oq = Dq, Nq = $q, Iq = c$, Pq = Ul, R8 = u8, sf = Em, Rq = v$, Fq = wq, Bq = Sq, Mq = Oq, Lq = b8, ku = XT;
function $q(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), jq(n)(
    Mq(
      Fq(n).document().write(Bq()(e, t, !0))
    )
  );
}
function jq(e) {
  var t = e || {}, n = Hq(
    {
      transforms: [],
      canContainEols: [
        "emphasis",
        "fragment",
        "heading",
        "paragraph",
        "strong"
      ],
      enter: {
        autolink: u(Ze),
        autolinkProtocol: S,
        autolinkEmail: S,
        atxHeading: u(Se),
        blockQuote: u(Ae),
        characterEscape: S,
        characterReference: S,
        codeFenced: u(Oe),
        codeFencedFenceInfo: c,
        codeFencedFenceMeta: c,
        codeIndented: u(Oe, c),
        codeText: u(Ce, c),
        codeTextData: S,
        data: S,
        codeFlowValue: S,
        definition: u(ue),
        definitionDestinationString: c,
        definitionLabelString: c,
        definitionTitleString: c,
        emphasis: u(fe),
        hardBreakEscape: u(Fe),
        hardBreakTrailing: u(Fe),
        htmlFlow: u(nt, c),
        htmlFlowData: S,
        htmlText: u(nt, c),
        htmlTextData: S,
        image: u(mt),
        label: c,
        link: u(Ze),
        listItem: u(Qe),
        listItemValue: y,
        listOrdered: u(rt, m),
        listUnordered: u(rt),
        paragraph: u(ie),
        reference: $,
        referenceString: c,
        resourceDestinationString: c,
        resourceTitleString: c,
        setextHeading: u(Se),
        strong: u(me),
        thematicBreak: u(ge)
      },
      exit: {
        atxHeading: f(),
        atxHeadingSequence: P,
        autolink: f(),
        autolinkEmail: re,
        autolinkProtocol: se,
        blockQuote: f(),
        characterEscapeValue: F,
        characterReferenceMarkerHexadecimal: Y,
        characterReferenceMarkerNumeric: Y,
        characterReferenceValue: ee,
        codeFenced: f(_),
        codeFencedFence: b,
        codeFencedFenceInfo: v,
        codeFencedFenceMeta: E,
        codeFlowValue: F,
        codeIndented: f(T),
        codeText: f(J),
        codeTextData: F,
        data: F,
        definition: f(),
        definitionDestinationString: R,
        definitionLabelString: x,
        definitionTitleString: A,
        emphasis: f(),
        hardBreakEscape: f(q),
        hardBreakTrailing: f(q),
        htmlFlow: f(N),
        htmlFlowData: F,
        htmlText: f(Q),
        htmlTextData: F,
        image: f(C),
        label: B,
        labelText: Z,
        lineEnding: H,
        link: f(D),
        listItem: f(),
        listOrdered: f(),
        listUnordered: f(),
        paragraph: f(),
        referenceString: ae,
        resourceDestinationString: j,
        resourceTitleString: z,
        resource: U,
        setextHeading: f(O),
        setextHeadingLineSequence: I,
        setextHeadingText: L,
        strong: f(),
        thematicBreak: f()
      }
    },
    t.mdastExtensions || []
  ), r = {};
  return i;
  function i(X) {
    for (var xe = { type: "root", children: [] }, ve = [xe], Ne = [], Tt = [], Ge = -1, gt, qt, wt = {
      stack: ve,
      tokenStack: Ne,
      config: n,
      enter: d,
      exit: p,
      buffer: c,
      resume: g,
      setData: s,
      getData: o
    }; ++Ge < X.length; )
      (X[Ge][1].type === "listOrdered" || X[Ge][1].type === "listUnordered") && (X[Ge][0] === "enter" ? Tt.push(Ge) : (qt = Tt.pop(Ge), Ge = a(X, qt, Ge)));
    for (Ge = -1; ++Ge < X.length; )
      gt = n[X[Ge][0]], R8.call(gt, X[Ge][1].type) && gt[X[Ge][1].type].call(
        Pq({ sliceSerialize: X[Ge][2].sliceSerialize }, wt),
        X[Ge][1]
      );
    if (Ne.length)
      throw new Error(
        "Cannot close document, a token (`" + Ne[Ne.length - 1].type + "`, " + ku({
          start: Ne[Ne.length - 1].start,
          end: Ne[Ne.length - 1].end
        }) + ") is still open"
      );
    for (xe.position = {
      start: l(
        X.length ? X[0][1].start : { line: 1, column: 1, offset: 0 }
      ),
      end: l(
        X.length ? X[X.length - 2][1].end : { line: 1, column: 1, offset: 0 }
      )
    }, Ge = -1; ++Ge < n.transforms.length; )
      xe = n.transforms[Ge](xe) || xe;
    return xe;
  }
  function a(X, xe, ve) {
    for (var Ne = xe - 1, Tt = -1, Ge = !1, gt, qt, wt, wn, At, Rr, Qn; ++Ne <= ve; )
      if (At = X[Ne], At[1].type === "listUnordered" || At[1].type === "listOrdered" || At[1].type === "blockQuote" ? (At[0] === "enter" ? Tt++ : Tt--, Qn = void 0) : At[1].type === "lineEndingBlank" ? At[0] === "enter" && (gt && !Qn && !Tt && !Rr && (Rr = Ne), Qn = void 0) : At[1].type === "linePrefix" || At[1].type === "listItemValue" || At[1].type === "listItemMarker" || At[1].type === "listItemPrefix" || At[1].type === "listItemPrefixWhitespace" || (Qn = void 0), !Tt && At[0] === "enter" && At[1].type === "listItemPrefix" || Tt === -1 && At[0] === "exit" && (At[1].type === "listUnordered" || At[1].type === "listOrdered")) {
        if (gt) {
          for (qt = Ne, wt = void 0; qt--; )
            if (wn = X[qt], wn[1].type === "lineEnding" || wn[1].type === "lineEndingBlank") {
              if (wn[0] === "exit")
                continue;
              wt && (X[wt][1].type = "lineEndingBlank", Ge = !0), wn[1].type = "lineEnding", wt = qt;
            } else if (!(wn[1].type === "linePrefix" || wn[1].type === "blockQuotePrefix" || wn[1].type === "blockQuotePrefixWhitespace" || wn[1].type === "blockQuoteMarker" || wn[1].type === "listItemIndent"))
              break;
          Rr && (!wt || Rr < wt) && (gt._spread = !0), gt.end = l(
            wt ? X[wt][1].start : At[1].end
          ), X.splice(wt || Ne, 0, ["exit", gt, At[2]]), Ne++, ve++;
        }
        At[1].type === "listItemPrefix" && (gt = {
          type: "listItem",
          _spread: !1,
          start: l(At[1].start)
        }, X.splice(Ne, 0, ["enter", gt, At[2]]), Ne++, ve++, Rr = void 0, Qn = !0);
      }
    return X[xe][1]._spread = Ge, ve;
  }
  function s(X, xe) {
    r[X] = xe;
  }
  function o(X) {
    return r[X];
  }
  function l(X) {
    return { line: X.line, column: X.column, offset: X.offset };
  }
  function u(X, xe) {
    return ve;
    function ve(Ne) {
      d.call(this, X(Ne), Ne), xe && xe.call(this, Ne);
    }
  }
  function c() {
    this.stack.push({ type: "fragment", children: [] });
  }
  function d(X, xe) {
    return this.stack[this.stack.length - 1].children.push(X), this.stack.push(X), this.tokenStack.push(xe), X.position = { start: l(xe.start) }, X;
  }
  function f(X) {
    return xe;
    function xe(ve) {
      X && X.call(this, ve), p.call(this, ve);
    }
  }
  function p(X) {
    var xe = this.stack.pop(), ve = this.tokenStack.pop();
    if (ve) {
      if (ve.type !== X.type)
        throw new Error(
          "Cannot close `" + X.type + "` (" + ku({ start: X.start, end: X.end }) + "): a different token (`" + ve.type + "`, " + ku({ start: ve.start, end: ve.end }) + ") is open"
        );
    } else
      throw new Error(
        "Cannot close `" + X.type + "` (" + ku({ start: X.start, end: X.end }) + "): it’s not open"
      );
    return xe.position.end = l(X.end), xe;
  }
  function g() {
    return Iq(this.stack.pop());
  }
  function m() {
    s("expectingFirstListItemValue", !0);
  }
  function y(X) {
    o("expectingFirstListItemValue") && (this.stack[this.stack.length - 2].start = parseInt(
      this.sliceSerialize(X),
      10
    ), s("expectingFirstListItemValue"));
  }
  function v() {
    var X = this.resume();
    this.stack[this.stack.length - 1].lang = X;
  }
  function E() {
    var X = this.resume();
    this.stack[this.stack.length - 1].meta = X;
  }
  function b() {
    o("flowCodeInside") || (this.buffer(), s("flowCodeInside", !0));
  }
  function _() {
    var X = this.resume();
    this.stack[this.stack.length - 1].value = X.replace(
      /^(\r?\n|\r)|(\r?\n|\r)$/g,
      ""
    ), s("flowCodeInside");
  }
  function T() {
    var X = this.resume();
    this.stack[this.stack.length - 1].value = X;
  }
  function x(X) {
    var xe = this.resume();
    this.stack[this.stack.length - 1].label = xe, this.stack[this.stack.length - 1].identifier = sf(
      this.sliceSerialize(X)
    ).toLowerCase();
  }
  function A() {
    var X = this.resume();
    this.stack[this.stack.length - 1].title = X;
  }
  function R() {
    var X = this.resume();
    this.stack[this.stack.length - 1].url = X;
  }
  function P(X) {
    this.stack[this.stack.length - 1].depth || (this.stack[this.stack.length - 1].depth = this.sliceSerialize(
      X
    ).length);
  }
  function L() {
    s("setextHeadingSlurpLineEnding", !0);
  }
  function I(X) {
    this.stack[this.stack.length - 1].depth = this.sliceSerialize(X).charCodeAt(0) === 61 ? 1 : 2;
  }
  function O() {
    s("setextHeadingSlurpLineEnding");
  }
  function S(X) {
    var xe = this.stack[this.stack.length - 1].children, ve = xe[xe.length - 1];
    (!ve || ve.type !== "text") && (ve = Pe(), ve.position = { start: l(X.start) }, this.stack[this.stack.length - 1].children.push(ve)), this.stack.push(ve);
  }
  function F(X) {
    var xe = this.stack.pop();
    xe.value += this.sliceSerialize(X), xe.position.end = l(X.end);
  }
  function H(X) {
    var xe = this.stack[this.stack.length - 1];
    if (o("atHardBreak")) {
      xe.children[xe.children.length - 1].position.end = l(
        X.end
      ), s("atHardBreak");
      return;
    }
    !o("setextHeadingSlurpLineEnding") && n.canContainEols.indexOf(xe.type) > -1 && (S.call(this, X), F.call(this, X));
  }
  function q() {
    s("atHardBreak", !0);
  }
  function N() {
    var X = this.resume();
    this.stack[this.stack.length - 1].value = X;
  }
  function Q() {
    var X = this.resume();
    this.stack[this.stack.length - 1].value = X;
  }
  function J() {
    var X = this.resume();
    this.stack[this.stack.length - 1].value = X;
  }
  function D() {
    var X = this.stack[this.stack.length - 1];
    o("inReference") ? (X.type += "Reference", X.referenceType = o("referenceType") || "shortcut", delete X.url, delete X.title) : (delete X.identifier, delete X.label, delete X.referenceType), s("referenceType");
  }
  function C() {
    var X = this.stack[this.stack.length - 1];
    o("inReference") ? (X.type += "Reference", X.referenceType = o("referenceType") || "shortcut", delete X.url, delete X.title) : (delete X.identifier, delete X.label, delete X.referenceType), s("referenceType");
  }
  function Z(X) {
    this.stack[this.stack.length - 2].identifier = sf(
      this.sliceSerialize(X)
    ).toLowerCase();
  }
  function B() {
    var X = this.stack[this.stack.length - 1], xe = this.resume();
    this.stack[this.stack.length - 1].label = xe, s("inReference", !0), this.stack[this.stack.length - 1].type === "link" ? this.stack[this.stack.length - 1].children = X.children : this.stack[this.stack.length - 1].alt = xe;
  }
  function j() {
    var X = this.resume();
    this.stack[this.stack.length - 1].url = X;
  }
  function z() {
    var X = this.resume();
    this.stack[this.stack.length - 1].title = X;
  }
  function U() {
    s("inReference");
  }
  function $() {
    s("referenceType", "collapsed");
  }
  function ae(X) {
    var xe = this.resume();
    this.stack[this.stack.length - 1].label = xe, this.stack[this.stack.length - 1].identifier = sf(
      this.sliceSerialize(X)
    ).toLowerCase(), s("referenceType", "full");
  }
  function Y(X) {
    s("characterReferenceType", X.type);
  }
  function ee(X) {
    var xe = this.sliceSerialize(X), ve = o("characterReferenceType"), Ne, Tt;
    ve ? (Ne = Rq(
      xe,
      ve === "characterReferenceMarkerNumeric" ? 10 : 16
    ), s("characterReferenceType")) : Ne = Lq(xe), Tt = this.stack.pop(), Tt.value += Ne, Tt.position.end = l(X.end);
  }
  function se(X) {
    F.call(this, X), this.stack[this.stack.length - 1].url = this.sliceSerialize(X);
  }
  function re(X) {
    F.call(this, X), this.stack[this.stack.length - 1].url = "mailto:" + this.sliceSerialize(X);
  }
  function Ae() {
    return { type: "blockquote", children: [] };
  }
  function Oe() {
    return { type: "code", lang: null, meta: null, value: "" };
  }
  function Ce() {
    return { type: "inlineCode", value: "" };
  }
  function ue() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function fe() {
    return { type: "emphasis", children: [] };
  }
  function Se() {
    return { type: "heading", depth: void 0, children: [] };
  }
  function Fe() {
    return { type: "break" };
  }
  function nt() {
    return { type: "html", value: "" };
  }
  function mt() {
    return { type: "image", title: null, url: "", alt: null };
  }
  function Ze() {
    return { type: "link", title: null, url: "", children: [] };
  }
  function rt(X) {
    return {
      type: "list",
      ordered: X.type === "listOrdered",
      start: null,
      spread: X._spread,
      children: []
    };
  }
  function Qe(X) {
    return {
      type: "listItem",
      spread: X._spread,
      checked: null,
      children: []
    };
  }
  function ie() {
    return { type: "paragraph", children: [] };
  }
  function me() {
    return { type: "strong", children: [] };
  }
  function Pe() {
    return { type: "text", value: "" };
  }
  function ge() {
    return { type: "thematicBreak" };
  }
}
function Hq(e, t) {
  for (var n = -1; ++n < t.length; )
    Uq(e, t[n]);
  return e;
}
function Uq(e, t) {
  var n, r;
  for (n in t)
    r = R8.call(e, n) ? e[n] : e[n] = {}, n === "canContainEols" || n === "transforms" ? e[n] = [].concat(r, t[n]) : Object.assign(r, t[n]);
}
var zq = Nq, qq = Vq, Wq = zq;
function Vq(e) {
  var t = this;
  this.Parser = n;
  function n(r) {
    return Wq(
      r,
      Object.assign({}, t.data("settings"), e, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: t.data("micromarkExtensions") || [],
        mdastExtensions: t.data("fromMarkdownExtensions") || []
      })
    );
  }
}
var gr = Kq;
function Kq(e, t, n) {
  var r;
  return n == null && (typeof t != "object" || Array.isArray(t)) && (n = t, t = {}), r = Object.assign({ type: String(e) }, t), Array.isArray(n) ? r.children = n : n != null && (r.value = String(n)), r;
}
var F8 = B8;
function B8(e) {
  if (e == null)
    return Qq;
  if (typeof e == "string")
    return Zq(e);
  if (typeof e == "object")
    return "length" in e ? Yq(e) : Gq(e);
  if (typeof e == "function")
    return e;
  throw new Error("Expected function, string, or object as test");
}
function Gq(e) {
  return t;
  function t(n) {
    var r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function Yq(e) {
  for (var t = [], n = -1; ++n < e.length; )
    t[n] = B8(e[n]);
  return r;
  function r() {
    for (var i = -1; ++i < t.length; )
      if (t[i].apply(this, arguments))
        return !0;
    return !1;
  }
}
function Zq(e) {
  return t;
  function t(n) {
    return !!(n && n.type === e);
  }
}
function Qq() {
  return !0;
}
var Xq = Jq;
function Jq(e) {
  return e;
}
var M8 = _1, eW = F8, tW = Xq, L8 = !0, $8 = "skip", Zh = !1;
_1.CONTINUE = L8;
_1.SKIP = $8;
_1.EXIT = Zh;
function _1(e, t, n, r) {
  var i, a;
  typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), a = eW(t), i = r ? -1 : 1, s(e, null, [])();
  function s(o, l, u) {
    var c = typeof o == "object" && o !== null ? o : {}, d;
    return typeof c.type == "string" && (d = typeof c.tagName == "string" ? c.tagName : typeof c.name == "string" ? c.name : void 0, f.displayName = "node (" + tW(c.type + (d ? "<" + d + ">" : "")) + ")"), f;
    function f() {
      var p = u.concat(o), g = [], m, y;
      if ((!t || a(o, l, u[u.length - 1] || null)) && (g = nW(n(o, u)), g[0] === Zh))
        return g;
      if (o.children && g[0] !== $8)
        for (y = (r ? o.children.length : -1) + i; y > -1 && y < o.children.length; ) {
          if (m = s(o.children[y], y, p)(), m[0] === Zh)
            return m;
          y = typeof m[1] == "number" ? m[1] : y + i;
        }
      return g;
    }
  }
}
function nW(e) {
  return e !== null && typeof e == "object" && "length" in e ? e : typeof e == "number" ? [L8, e] : [e];
}
var Nm = x1, C1 = M8, rW = C1.CONTINUE, iW = C1.SKIP, aW = C1.EXIT;
x1.CONTINUE = rW;
x1.SKIP = iW;
x1.EXIT = aW;
function x1(e, t, n, r) {
  typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), C1(e, t, i, r);
  function i(a, s) {
    var o = s[s.length - 1], l = o ? o.children.indexOf(a) : null;
    return n(a, l, o);
  }
}
var j8 = z8("start"), H8 = z8("end"), U8 = Im;
Im.start = j8;
Im.end = H8;
function Im(e) {
  return { start: j8(e), end: H8(e) };
}
function z8(e) {
  return t.displayName = e, t;
  function t(n) {
    var r = n && n.position && n.position[e] || {};
    return {
      line: r.line || null,
      column: r.column || null,
      offset: isNaN(r.offset) ? null : r.offset
    };
  }
}
var sW = oW;
function oW(e) {
  return !e || !e.position || !e.position.start || !e.position.start.line || !e.position.start.column || !e.position.end || !e.position.end.line || !e.position.end.column;
}
var lW = Nm, uW = cW, q8 = {}.hasOwnProperty;
function cW(e, t) {
  return fW(dW(e));
}
function dW(e) {
  var t = {};
  if (!e || !e.type)
    throw new Error("mdast-util-definitions expected node");
  return lW(e, "definition", n), t;
  function n(r) {
    var i = W8(r.identifier);
    q8.call(t, i) || (t[i] = r);
  }
}
function fW(e) {
  return t;
  function t(n) {
    var r = n && W8(n);
    return r && q8.call(e, r) ? e[r] : null;
  }
}
function W8(e) {
  return e.toUpperCase();
}
var of, m5;
function jn() {
  if (m5)
    return of;
  m5 = 1, of = t;
  var e = V8();
  function t(n, r) {
    for (var i = r.children || [], a = i.length, s = [], o = -1, l, u; ++o < a; )
      l = e(n, i[o], r), l && (o && i[o - 1].type === "break" && (l.value && (l.value = l.value.replace(/^\s+/, "")), u = l.children && l.children[0], u && u.value && (u.value = u.value.replace(/^\s+/, ""))), s = s.concat(l));
    return s;
  }
  return of;
}
var lf, g5;
function V8() {
  if (g5)
    return lf;
  g5 = 1, lf = i;
  var e = gr, t = jn(), n = {}.hasOwnProperty;
  function r(o, l) {
    return a(l) ? o.augment(l, e("text", l.value)) : o(l, "div", t(o, l));
  }
  function i(o, l, u) {
    var c = l && l.type, d;
    if (!c)
      throw new Error("Expected node, got `" + l + "`");
    return n.call(o.handlers, c) ? d = o.handlers[c] : o.passThrough && o.passThrough.indexOf(c) > -1 ? d = s : d = o.unknownHandler, (typeof d == "function" ? d : r)(o, l, u);
  }
  function a(o) {
    var l = o.data || {};
    return n.call(l, "hName") || n.call(l, "hProperties") || n.call(l, "hChildren") ? !1 : "value" in o;
  }
  function s(o, l) {
    var u;
    return l.children ? (u = Object.assign({}, l), u.children = t(o, l), u) : l;
  }
  return lf;
}
var K8 = hW;
function hW(e, t) {
  return e(t, "hr");
}
var Wl = pW, uf = gr;
function pW(e, t) {
  var n = [], r = -1, i = e.length;
  for (t && n.push(uf("text", `
`)); ++r < i; )
    r && n.push(uf("text", `
`)), n.push(e[r]);
  return t && e.length > 0 && n.push(uf("text", `
`)), n;
}
var G8 = vW, mW = Wl, gW = jn();
function vW(e, t) {
  var n = {}, r = t.ordered ? "ol" : "ul", i, a = -1, s;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start), i = gW(e, t), s = i.length; ++a < s; )
    if (i[a].properties.className && i[a].properties.className.indexOf("task-list-item") !== -1) {
      n.className = ["contains-task-list"];
      break;
    }
  return e(t, r, n, mW(i, !0));
}
var yW = _W, EW = K8, bW = G8, TW = Wl;
function _W(e) {
  for (var t = e.footnoteById, n = e.footnoteOrder, r = n.length, i = -1, a = [], s, o, l, u; ++i < r; )
    s = t[n[i].toUpperCase()], s && (l = s.children.concat(), u = l[l.length - 1], o = {
      type: "link",
      url: "#fnref-" + s.identifier,
      data: { hProperties: { className: ["footnote-backref"] } },
      children: [{ type: "text", value: "↩" }]
    }, (!u || u.type !== "paragraph") && (u = { type: "paragraph", children: [] }, l.push(u)), u.children.push(o), a.push({
      type: "listItem",
      data: { hProperties: { id: "fn-" + s.identifier } },
      children: l,
      position: s.position
    }));
  return a.length === 0 ? null : e(
    null,
    "div",
    { className: ["footnotes"] },
    TW(
      [
        EW(e),
        bW(e, { type: "list", ordered: !0, children: a })
      ],
      !0
    )
  );
}
var CW = AW, xW = Wl, wW = jn();
function AW(e, t) {
  return e(t, "blockquote", xW(wW(e, t), !0));
}
var SW = DW, kW = gr;
function DW(e, t) {
  return [e(t, "br"), kW("text", `
`)];
}
var OW = IW, NW = gr;
function IW(e, t) {
  var n = t.value ? t.value + `
` : "", r = t.lang && t.lang.match(/^[^ \t]+(?=[ \t]|$)/), i = {}, a;
  return r && (i.className = ["language-" + r]), a = e(t, "code", i, [NW("text", n)]), t.meta && (a.data = { meta: t.meta }), e(t.position, "pre", [a]);
}
var PW = FW, RW = jn();
function FW(e, t) {
  return e(t, "del", RW(e, t));
}
var BW = LW, MW = jn();
function LW(e, t) {
  return e(t, "em", MW(e, t));
}
var Y8 = jW, $W = gr;
function jW(e, t) {
  var n = e.footnoteOrder, r = String(t.identifier);
  return n.indexOf(r) === -1 && n.push(r), e(t.position, "sup", { id: "fnref-" + r }, [
    e(t, "a", { href: "#fn-" + r, className: ["footnote-ref"] }, [
      $W("text", t.label || r)
    ])
  ]);
}
var HW = zW, UW = Y8;
function zW(e, t) {
  for (var n = e.footnoteById, r = e.footnoteOrder, i = 1; i in n; )
    i++;
  return i = String(i), r.push(i), n[i] = {
    type: "footnoteDefinition",
    identifier: i,
    children: [{ type: "paragraph", children: t.children }],
    position: t.position
  }, UW(e, {
    type: "footnoteReference",
    identifier: i,
    position: t.position
  });
}
var qW = VW, WW = jn();
function VW(e, t) {
  return e(t, "h" + t.depth, WW(e, t));
}
var KW = YW, GW = gr;
function YW(e, t) {
  return e.dangerous ? e.augment(t, GW("raw", t.value)) : null;
}
var v5 = {};
function ZW(e) {
  var t, n, r = v5[e];
  if (r)
    return r;
  for (r = v5[e] = [], t = 0; t < 128; t++)
    n = String.fromCharCode(t), /^[0-9a-z]$/i.test(n) ? r.push(n) : r.push("%" + ("0" + t.toString(16).toUpperCase()).slice(-2));
  for (t = 0; t < e.length; t++)
    r[e.charCodeAt(t)] = e[t];
  return r;
}
function w1(e, t, n) {
  var r, i, a, s, o, l = "";
  for (typeof t != "string" && (n = t, t = w1.defaultChars), typeof n > "u" && (n = !0), o = ZW(t), r = 0, i = e.length; r < i; r++) {
    if (a = e.charCodeAt(r), n && a === 37 && r + 2 < i && /^[0-9a-f]{2}$/i.test(e.slice(r + 1, r + 3))) {
      l += e.slice(r, r + 3), r += 2;
      continue;
    }
    if (a < 128) {
      l += o[a];
      continue;
    }
    if (a >= 55296 && a <= 57343) {
      if (a >= 55296 && a <= 56319 && r + 1 < i && (s = e.charCodeAt(r + 1), s >= 56320 && s <= 57343)) {
        l += encodeURIComponent(e[r] + e[r + 1]), r++;
        continue;
      }
      l += "%EF%BF%BD";
      continue;
    }
    l += encodeURIComponent(e[r]);
  }
  return l;
}
w1.defaultChars = ";/?:@&=+$,-_.!~*'()#";
w1.componentChars = "-_.!~*'()";
var A1 = w1, Z8 = XW, cf = gr, QW = jn();
function XW(e, t) {
  var n = t.referenceType, r = "]", i, a, s;
  return n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference" ? cf("text", "![" + t.alt + r) : (i = QW(e, t), a = i[0], a && a.type === "text" ? a.value = "[" + a.value : i.unshift(cf("text", "[")), s = i[i.length - 1], s && s.type === "text" ? s.value += r : i.push(cf("text", r)), i);
}
var JW = nV, eV = A1, tV = Z8;
function nV(e, t) {
  var n = e.definition(t.identifier), r;
  return n ? (r = { src: eV(n.url || ""), alt: t.alt }, n.title !== null && n.title !== void 0 && (r.title = n.title), e(t, "img", r)) : tV(e, t);
}
var rV = A1, iV = aV;
function aV(e, t) {
  var n = { src: rV(t.url), alt: t.alt };
  return t.title !== null && t.title !== void 0 && (n.title = t.title), e(t, "img", n);
}
var sV = lV, oV = gr;
function lV(e, t) {
  var n = t.value.replace(/\r?\n|\r/g, " ");
  return e(t, "code", [oV("text", n)]);
}
var uV = hV, cV = A1, dV = Z8, fV = jn();
function hV(e, t) {
  var n = e.definition(t.identifier), r;
  return n ? (r = { href: cV(n.url || "") }, n.title !== null && n.title !== void 0 && (r.title = n.title), e(t, "a", r, fV(e, t))) : dV(e, t);
}
var pV = A1, mV = jn(), gV = vV;
function vV(e, t) {
  var n = { href: pV(t.url) };
  return t.title !== null && t.title !== void 0 && (n.title = t.title), e(t, "a", n, mV(e, t));
}
var yV = bV, df = gr, EV = jn();
function bV(e, t, n) {
  var r = EV(e, t), i = r[0], a = n ? TV(n) : Q8(t), s = {}, o = [], l, u, c;
  for (typeof t.checked == "boolean" && ((!i || i.tagName !== "p") && (i = e(null, "p", []), r.unshift(i)), i.children.length > 0 && i.children.unshift(df("text", " ")), i.children.unshift(
    e(null, "input", {
      type: "checkbox",
      checked: t.checked,
      disabled: !0
    })
  ), s.className = ["task-list-item"]), l = r.length, u = -1; ++u < l; )
    c = r[u], (a || u !== 0 || c.tagName !== "p") && o.push(df("text", `
`)), c.tagName === "p" && !a ? o = o.concat(c.children) : o.push(c);
  return l && (a || c.tagName !== "p") && o.push(df("text", `
`)), e(t, "li", s, o);
}
function TV(e) {
  for (var t = e.spread, n = e.children, r = n.length, i = -1; !t && ++i < r; )
    t = Q8(n[i]);
  return t;
}
function Q8(e) {
  var t = e.spread;
  return t ?? e.children.length > 1;
}
var _V = xV, CV = jn();
function xV(e, t) {
  return e(t, "p", CV(e, t));
}
var wV = DV, AV = gr, SV = Wl, kV = jn();
function DV(e, t) {
  return e.augment(t, AV("root", SV(kV(e, t))));
}
var OV = IV, NV = jn();
function IV(e, t) {
  return e(t, "strong", NV(e, t));
}
var PV = FV, y5 = U8, Du = Wl, RV = jn();
function FV(e, t) {
  for (var n = t.children, r = n.length, i = t.align || [], a = i.length, s = [], o, l, u, c, d; r--; ) {
    for (l = n[r].children, c = r === 0 ? "th" : "td", o = a || l.length, u = []; o--; )
      d = l[o], u[o] = e(d, c, { align: i[o] }, d ? RV(e, d) : []);
    s[r] = e(n[r], "tr", Du(u, !0));
  }
  return e(
    t,
    "table",
    Du(
      [e(s[0].position, "thead", Du([s[0]], !0))].concat(
        s[1] ? e(
          {
            start: y5.start(s[1]),
            end: y5.end(s[s.length - 1])
          },
          "tbody",
          Du(s.slice(1), !0)
        ) : []
      ),
      !0
    )
  );
}
var BV = LV, MV = gr;
function LV(e, t) {
  return e.augment(
    t,
    MV("text", String(t.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, "$1"))
  );
}
var $V = {
  blockquote: CW,
  break: SW,
  code: OW,
  delete: PW,
  emphasis: BW,
  footnoteReference: Y8,
  footnote: HW,
  heading: qW,
  html: KW,
  imageReference: JW,
  image: iV,
  inlineCode: sV,
  linkReference: uV,
  link: gV,
  listItem: yV,
  list: G8,
  paragraph: _V,
  root: wV,
  strong: OV,
  table: PV,
  text: BV,
  thematicBreak: K8,
  toml: Ou,
  yaml: Ou,
  definition: Ou,
  footnoteDefinition: Ou
};
function Ou() {
  return null;
}
var jV = ZV, HV = gr, UV = Nm, E5 = U8, zV = sW, qV = uW, WV = V8(), VV = yW, KV = $V, GV = {}.hasOwnProperty, b5 = !1;
function YV(e, t) {
  var n = t || {};
  n.allowDangerousHTML !== void 0 && !b5 && (b5 = !0, console.warn(
    "mdast-util-to-hast: deprecation: `allowDangerousHTML` is nonstandard, use `allowDangerousHtml` instead"
  ));
  var r = n.allowDangerousHtml || n.allowDangerousHTML, i = {};
  return s.dangerous = r, s.definition = qV(e), s.footnoteById = i, s.footnoteOrder = [], s.augment = a, s.handlers = Object.assign({}, KV, n.handlers), s.unknownHandler = n.unknownHandler, s.passThrough = n.passThrough, UV(e, "footnoteDefinition", o), s;
  function a(l, u) {
    var c, d;
    return l && l.data && (c = l.data, c.hName && (u.type !== "element" && (u = {
      type: "element",
      tagName: "",
      properties: {},
      children: []
    }), u.tagName = c.hName), u.type === "element" && c.hProperties && (u.properties = Object.assign({}, u.properties, c.hProperties)), u.children && c.hChildren && (u.children = c.hChildren)), d = l && l.position ? l : { position: l }, zV(d) || (u.position = {
      start: E5.start(d),
      end: E5.end(d)
    }), u;
  }
  function s(l, u, c, d) {
    return d == null && typeof c == "object" && "length" in c && (d = c, c = {}), a(l, {
      type: "element",
      tagName: u,
      properties: c || {},
      children: d || []
    });
  }
  function o(l) {
    var u = String(l.identifier).toUpperCase();
    GV.call(i, u) || (i[u] = l);
  }
}
function ZV(e, t) {
  var n = YV(e, t), r = WV(n, e), i = VV(n);
  return i && (r.children = r.children.concat(HV("text", `
`), i)), r;
}
var QV = jV, X8 = QV, XV = JV;
function JV(e, t) {
  return e && !e.process && (t = e, e = null), e ? eK(e, t) : tK(t);
}
function eK(e, t) {
  return n;
  function n(r, i, a) {
    e.run(X8(r, t), i, s);
    function s(o) {
      a(o);
    }
  }
}
function tK(e) {
  return t;
  function t(n) {
    return X8(n, e);
  }
}
var nK = iK, rK = Object.prototype.hasOwnProperty;
function iK() {
  for (var e = {}, t = 0; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      rK.call(n, r) && (e[r] = n[r]);
  }
  return e;
}
var J8 = e_, Pm = e_.prototype;
Pm.space = null;
Pm.normal = {};
Pm.property = {};
function e_(e, t, n) {
  this.property = e, this.normal = t, n && (this.space = n);
}
var T5 = nK, aK = J8, t_ = sK;
function sK(e) {
  for (var t = e.length, n = [], r = [], i = -1, a, s; ++i < t; )
    a = e[i], n.push(a.property), r.push(a.normal), s = a.space;
  return new aK(
    T5.apply(null, n),
    T5.apply(null, r),
    s
  );
}
var n_ = oK;
function oK(e) {
  return e.toLowerCase();
}
var r_ = i_, vr = i_.prototype;
vr.space = null;
vr.attribute = null;
vr.property = null;
vr.boolean = !1;
vr.booleanish = !1;
vr.overloadedBoolean = !1;
vr.number = !1;
vr.commaSeparated = !1;
vr.spaceSeparated = !1;
vr.commaOrSpaceSeparated = !1;
vr.mustUseProperty = !1;
vr.defined = !1;
function i_(e, t) {
  this.property = e, this.attribute = t;
}
var Nr = {}, lK = 0;
Nr.boolean = Ga();
Nr.booleanish = Ga();
Nr.overloadedBoolean = Ga();
Nr.number = Ga();
Nr.spaceSeparated = Ga();
Nr.commaSeparated = Ga();
Nr.commaOrSpaceSeparated = Ga();
function Ga() {
  return Math.pow(2, ++lK);
}
var a_ = r_, _5 = Nr, s_ = Rm;
Rm.prototype = new a_();
Rm.prototype.defined = !0;
var o_ = [
  "boolean",
  "booleanish",
  "overloadedBoolean",
  "number",
  "commaSeparated",
  "spaceSeparated",
  "commaOrSpaceSeparated"
], uK = o_.length;
function Rm(e, t, n, r) {
  var i = -1, a;
  for (C5(this, "space", r), a_.call(this, e, t); ++i < uK; )
    a = o_[i], C5(this, a, (n & _5[a]) === _5[a]);
}
function C5(e, t, n) {
  n && (e[t] = n);
}
var x5 = n_, cK = J8, dK = s_, to = fK;
function fK(e) {
  var t = e.space, n = e.mustUseProperty || [], r = e.attributes || {}, i = e.properties, a = e.transform, s = {}, o = {}, l, u;
  for (l in i)
    u = new dK(
      l,
      a(r, l),
      i[l],
      t
    ), n.indexOf(l) !== -1 && (u.mustUseProperty = !0), s[l] = u, o[x5(l)] = l, o[x5(u.attribute)] = l;
  return new cK(s, o, t);
}
var hK = to, l_ = hK({
  space: "xlink",
  transform: pK,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});
function pK(e, t) {
  return "xlink:" + t.slice(5).toLowerCase();
}
var mK = to, u_ = mK({
  space: "xml",
  transform: gK,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
});
function gK(e, t) {
  return "xml:" + t.slice(3).toLowerCase();
}
var c_ = vK;
function vK(e, t) {
  return t in e ? e[t] : t;
}
var yK = c_, d_ = EK;
function EK(e, t) {
  return yK(e, t.toLowerCase());
}
var bK = to, TK = d_, f_ = bK({
  space: "xmlns",
  attributes: {
    xmlnsxlink: "xmlns:xlink"
  },
  transform: TK,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
}), Fm = Nr, _K = to, An = Fm.booleanish, er = Fm.number, ga = Fm.spaceSeparated, h_ = _K({
  transform: CK,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: An,
    ariaAutoComplete: null,
    ariaBusy: An,
    ariaChecked: An,
    ariaColCount: er,
    ariaColIndex: er,
    ariaColSpan: er,
    ariaControls: ga,
    ariaCurrent: null,
    ariaDescribedBy: ga,
    ariaDetails: null,
    ariaDisabled: An,
    ariaDropEffect: ga,
    ariaErrorMessage: null,
    ariaExpanded: An,
    ariaFlowTo: ga,
    ariaGrabbed: An,
    ariaHasPopup: null,
    ariaHidden: An,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ga,
    ariaLevel: er,
    ariaLive: null,
    ariaModal: An,
    ariaMultiLine: An,
    ariaMultiSelectable: An,
    ariaOrientation: null,
    ariaOwns: ga,
    ariaPlaceholder: null,
    ariaPosInSet: er,
    ariaPressed: An,
    ariaReadOnly: An,
    ariaRelevant: null,
    ariaRequired: An,
    ariaRoleDescription: ga,
    ariaRowCount: er,
    ariaRowIndex: er,
    ariaRowSpan: er,
    ariaSelected: An,
    ariaSetSize: er,
    ariaSort: null,
    ariaValueMax: er,
    ariaValueMin: er,
    ariaValueNow: er,
    ariaValueText: null,
    role: null
  }
});
function CK(e, t) {
  return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
}
var no = Nr, xK = to, wK = d_, it = no.boolean, AK = no.overloadedBoolean, _o = no.booleanish, Rt = no.number, En = no.spaceSeparated, Nu = no.commaSeparated, SK = xK({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: wK,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Nu,
    acceptCharset: En,
    accessKey: En,
    action: null,
    allow: null,
    allowFullScreen: it,
    allowPaymentRequest: it,
    allowUserMedia: it,
    alt: null,
    as: null,
    async: it,
    autoCapitalize: null,
    autoComplete: En,
    autoFocus: it,
    autoPlay: it,
    capture: it,
    charSet: null,
    checked: it,
    cite: null,
    className: En,
    cols: Rt,
    colSpan: null,
    content: null,
    contentEditable: _o,
    controls: it,
    controlsList: En,
    coords: Rt | Nu,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: it,
    defer: it,
    dir: null,
    dirName: null,
    disabled: it,
    download: AK,
    draggable: _o,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: it,
    formTarget: null,
    headers: En,
    height: Rt,
    hidden: it,
    high: Rt,
    href: null,
    hrefLang: null,
    htmlFor: En,
    httpEquiv: En,
    id: null,
    imageSizes: null,
    imageSrcSet: Nu,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: it,
    itemId: null,
    itemProp: En,
    itemRef: En,
    itemScope: it,
    itemType: En,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: it,
    low: Rt,
    manifest: null,
    max: null,
    maxLength: Rt,
    media: null,
    method: null,
    min: null,
    minLength: Rt,
    multiple: it,
    muted: it,
    name: null,
    nonce: null,
    noModule: it,
    noValidate: it,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextMenu: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: it,
    optimum: Rt,
    pattern: null,
    ping: En,
    placeholder: null,
    playsInline: it,
    poster: null,
    preload: null,
    readOnly: it,
    referrerPolicy: null,
    rel: En,
    required: it,
    reversed: it,
    rows: Rt,
    rowSpan: Rt,
    sandbox: En,
    scope: null,
    scoped: it,
    seamless: it,
    selected: it,
    shape: null,
    size: Rt,
    sizes: null,
    slot: null,
    span: Rt,
    spellCheck: _o,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: Nu,
    start: Rt,
    step: null,
    style: null,
    tabIndex: Rt,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: it,
    useMap: null,
    value: _o,
    width: Rt,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: En,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Rt,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Rt,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: it,
    // Lists. Use CSS to reduce space between items instead
    declare: it,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Rt,
    // `<img>` and `<object>`
    leftMargin: Rt,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Rt,
    // `<body>`
    marginWidth: Rt,
    // `<body>`
    noResize: it,
    // `<frame>`
    noHref: it,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: it,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: it,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Rt,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: _o,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Rt,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Rt,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: it,
    disableRemotePlayback: it,
    prefix: null,
    property: null,
    results: Rt,
    security: null,
    unselectable: null
  }
}), kK = t_, DK = l_, OK = u_, NK = f_, IK = h_, PK = SK, RK = kK([OK, DK, NK, IK, PK]);
const FK = Nm;
var BK = MK;
function MK(e) {
  if (e.allowedElements && e.disallowedElements)
    throw new TypeError(
      "Only one of `allowedElements` and `disallowedElements` should be defined"
    );
  if (e.allowedElements || e.disallowedElements || e.allowElement)
    return (n) => {
      FK(
        /** @type {Root} */
        n,
        "element",
        t
      );
    };
  function t(n, r, i) {
    const a = (
      /** @type {Element} */
      n
    ), s = (
      /** @type {Element|Root} */
      i
    );
    let o;
    if (e.allowedElements ? o = !e.allowedElements.includes(a.tagName) : e.disallowedElements && (o = e.disallowedElements.includes(a.tagName)), !o && e.allowElement && typeof r == "number" && (o = !e.allowElement(a, r, s)), o && typeof r == "number")
      return e.unwrapDisallowed && a.children ? s.children.splice(r, 1, ...a.children) : s.children.splice(r, 1), r;
  }
}
const w5 = ["http", "https", "mailto", "tel"];
var LK = $K;
function $K(e) {
  const t = (e || "").trim(), n = t.charAt(0);
  if (n === "#" || n === "/")
    return t;
  const r = t.indexOf(":");
  if (r === -1)
    return t;
  let i = -1;
  for (; ++i < w5.length; ) {
    const a = w5[i];
    if (r === a.length && t.slice(0, a.length).toLowerCase() === a)
      return t;
  }
  return i = t.indexOf("?"), i !== -1 && r > i || (i = t.indexOf("#"), i !== -1 && r > i) ? t : "javascript:void(0)";
}
var Bm = {}, Qh = { exports: {} }, St = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var A5;
function jK() {
  if (A5)
    return St;
  A5 = 1;
  var e = 60103, t = 60106, n = 60107, r = 60108, i = 60114, a = 60109, s = 60110, o = 60112, l = 60113, u = 60120, c = 60115, d = 60116, f = 60121, p = 60122, g = 60117, m = 60129, y = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var v = Symbol.for;
    e = v("react.element"), t = v("react.portal"), n = v("react.fragment"), r = v("react.strict_mode"), i = v("react.profiler"), a = v("react.provider"), s = v("react.context"), o = v("react.forward_ref"), l = v("react.suspense"), u = v("react.suspense_list"), c = v("react.memo"), d = v("react.lazy"), f = v("react.block"), p = v("react.server.block"), g = v("react.fundamental"), m = v("react.debug_trace_mode"), y = v("react.legacy_hidden");
  }
  function E(S) {
    if (typeof S == "object" && S !== null) {
      var F = S.$$typeof;
      switch (F) {
        case e:
          switch (S = S.type, S) {
            case n:
            case i:
            case r:
            case l:
            case u:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case s:
                case o:
                case d:
                case c:
                case a:
                  return S;
                default:
                  return F;
              }
          }
        case t:
          return F;
      }
    }
  }
  var b = a, _ = e, T = o, x = n, A = d, R = c, P = t, L = i, I = r, O = l;
  return St.ContextConsumer = s, St.ContextProvider = b, St.Element = _, St.ForwardRef = T, St.Fragment = x, St.Lazy = A, St.Memo = R, St.Portal = P, St.Profiler = L, St.StrictMode = I, St.Suspense = O, St.isAsyncMode = function() {
    return !1;
  }, St.isConcurrentMode = function() {
    return !1;
  }, St.isContextConsumer = function(S) {
    return E(S) === s;
  }, St.isContextProvider = function(S) {
    return E(S) === a;
  }, St.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === e;
  }, St.isForwardRef = function(S) {
    return E(S) === o;
  }, St.isFragment = function(S) {
    return E(S) === n;
  }, St.isLazy = function(S) {
    return E(S) === d;
  }, St.isMemo = function(S) {
    return E(S) === c;
  }, St.isPortal = function(S) {
    return E(S) === t;
  }, St.isProfiler = function(S) {
    return E(S) === i;
  }, St.isStrictMode = function(S) {
    return E(S) === r;
  }, St.isSuspense = function(S) {
    return E(S) === l;
  }, St.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === n || S === i || S === m || S === r || S === l || S === u || S === y || typeof S == "object" && S !== null && (S.$$typeof === d || S.$$typeof === c || S.$$typeof === a || S.$$typeof === s || S.$$typeof === o || S.$$typeof === g || S.$$typeof === f || S[0] === p);
  }, St.typeOf = E, St;
}
var kt = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S5;
function HK() {
  return S5 || (S5 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, n = 60107, r = 60108, i = 60114, a = 60109, s = 60110, o = 60112, l = 60113, u = 60120, c = 60115, d = 60116, f = 60121, p = 60122, g = 60117, m = 60129, y = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var v = Symbol.for;
      e = v("react.element"), t = v("react.portal"), n = v("react.fragment"), r = v("react.strict_mode"), i = v("react.profiler"), a = v("react.provider"), s = v("react.context"), o = v("react.forward_ref"), l = v("react.suspense"), u = v("react.suspense_list"), c = v("react.memo"), d = v("react.lazy"), f = v("react.block"), p = v("react.server.block"), g = v("react.fundamental"), v("react.scope"), v("react.opaque.id"), m = v("react.debug_trace_mode"), v("react.offscreen"), y = v("react.legacy_hidden");
    }
    var E = !1;
    function b(se) {
      return !!(typeof se == "string" || typeof se == "function" || se === n || se === i || se === m || se === r || se === l || se === u || se === y || E || typeof se == "object" && se !== null && (se.$$typeof === d || se.$$typeof === c || se.$$typeof === a || se.$$typeof === s || se.$$typeof === o || se.$$typeof === g || se.$$typeof === f || se[0] === p));
    }
    function _(se) {
      if (typeof se == "object" && se !== null) {
        var re = se.$$typeof;
        switch (re) {
          case e:
            var Ae = se.type;
            switch (Ae) {
              case n:
              case i:
              case r:
              case l:
              case u:
                return Ae;
              default:
                var Oe = Ae && Ae.$$typeof;
                switch (Oe) {
                  case s:
                  case o:
                  case d:
                  case c:
                  case a:
                    return Oe;
                  default:
                    return re;
                }
            }
          case t:
            return re;
        }
      }
    }
    var T = s, x = a, A = e, R = o, P = n, L = d, I = c, O = t, S = i, F = r, H = l, q = !1, N = !1;
    function Q(se) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function J(se) {
      return N || (N = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function D(se) {
      return _(se) === s;
    }
    function C(se) {
      return _(se) === a;
    }
    function Z(se) {
      return typeof se == "object" && se !== null && se.$$typeof === e;
    }
    function B(se) {
      return _(se) === o;
    }
    function j(se) {
      return _(se) === n;
    }
    function z(se) {
      return _(se) === d;
    }
    function U(se) {
      return _(se) === c;
    }
    function $(se) {
      return _(se) === t;
    }
    function ae(se) {
      return _(se) === i;
    }
    function Y(se) {
      return _(se) === r;
    }
    function ee(se) {
      return _(se) === l;
    }
    kt.ContextConsumer = T, kt.ContextProvider = x, kt.Element = A, kt.ForwardRef = R, kt.Fragment = P, kt.Lazy = L, kt.Memo = I, kt.Portal = O, kt.Profiler = S, kt.StrictMode = F, kt.Suspense = H, kt.isAsyncMode = Q, kt.isConcurrentMode = J, kt.isContextConsumer = D, kt.isContextProvider = C, kt.isElement = Z, kt.isForwardRef = B, kt.isFragment = j, kt.isLazy = z, kt.isMemo = U, kt.isPortal = $, kt.isProfiler = ae, kt.isStrictMode = Y, kt.isSuspense = ee, kt.isValidElementType = b, kt.typeOf = _;
  }()), kt;
}
process.env.NODE_ENV === "production" ? Qh.exports = jK() : Qh.exports = HK();
var UK = Qh.exports, Vl = Nr, zK = to, qK = c_, WK = Vl.boolean, $e = Vl.number, k5 = Vl.spaceSeparated, ff = Vl.commaSeparated, tr = Vl.commaOrSpaceSeparated, VK = zK({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: qK,
  properties: {
    about: tr,
    accentHeight: $e,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: $e,
    amplitude: $e,
    arabicForm: null,
    ascent: $e,
    attributeName: null,
    attributeType: null,
    azimuth: $e,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: $e,
    by: null,
    calcMode: null,
    capHeight: $e,
    className: k5,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: $e,
    diffuseConstant: $e,
    direction: null,
    display: null,
    dur: null,
    divisor: $e,
    dominantBaseline: null,
    download: WK,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: $e,
    enableBackground: null,
    end: null,
    event: null,
    exponent: $e,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: $e,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ff,
    g2: ff,
    glyphName: ff,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: $e,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: $e,
    horizOriginX: $e,
    horizOriginY: $e,
    id: null,
    ideographic: $e,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: $e,
    k: $e,
    k1: $e,
    k2: $e,
    k3: $e,
    k4: $e,
    kernelMatrix: tr,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: $e,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: $e,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: $e,
    overlineThickness: $e,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: $e,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: k5,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: $e,
    pointsAtY: $e,
    pointsAtZ: $e,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: tr,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: tr,
    rev: tr,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: tr,
    requiredFeatures: tr,
    requiredFonts: tr,
    requiredFormats: tr,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: $e,
    specularExponent: $e,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: $e,
    strikethroughThickness: $e,
    string: null,
    stroke: null,
    strokeDashArray: tr,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: $e,
    strokeOpacity: $e,
    strokeWidth: null,
    style: null,
    surfaceScale: $e,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: tr,
    tabIndex: $e,
    tableValues: null,
    target: null,
    targetX: $e,
    targetY: $e,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: tr,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: $e,
    underlineThickness: $e,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: $e,
    values: null,
    vAlphabetic: $e,
    vMathematical: $e,
    vectorEffect: null,
    vHanging: $e,
    vIdeographic: $e,
    version: null,
    vertAdvY: $e,
    vertOriginX: $e,
    vertOriginY: $e,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: $e,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), KK = t_, GK = l_, YK = u_, ZK = f_, QK = h_, XK = VK, JK = KK([YK, GK, ZK, QK, XK]), eG = n_, tG = s_, nG = r_, Mm = "data", rG = sG, iG = /^data[-\w.:]+$/i, p_ = /-[a-z]/g, aG = /[A-Z]/g;
function sG(e, t) {
  var n = eG(t), r = t, i = nG;
  return n in e.normal ? e.property[e.normal[n]] : (n.length > 4 && n.slice(0, 4) === Mm && iG.test(t) && (t.charAt(4) === "-" ? r = oG(t) : t = lG(t), i = tG), new i(r, t));
}
function oG(e) {
  var t = e.slice(5).replace(p_, cG);
  return Mm + t.charAt(0).toUpperCase() + t.slice(1);
}
function lG(e) {
  var t = e.slice(4);
  return p_.test(t) ? e : (t = t.replace(aG, uG), t.charAt(0) !== "-" && (t = "-" + t), Mm + t);
}
function uG(e) {
  return "-" + e.toLowerCase();
}
function cG(e) {
  return e.charAt(1).toUpperCase();
}
const dG = "classID", fG = "datatype", hG = "itemID", pG = "strokeDasharray", mG = "strokeDashoffset", gG = "strokeLinecap", vG = "strokeLinejoin", yG = "strokeMiterlimit", EG = "typeof", bG = "xlinkActuate", TG = "xlinkArcrole", _G = "xlinkHref", CG = "xlinkRole", xG = "xlinkShow", wG = "xlinkTitle", AG = "xlinkType", SG = "xmlnsXlink", kG = {
  classId: dG,
  dataType: fG,
  itemId: hG,
  strokeDashArray: pG,
  strokeDashOffset: mG,
  strokeLineCap: gG,
  strokeLineJoin: vG,
  strokeMiterLimit: yG,
  typeOf: EG,
  xLinkActuate: bG,
  xLinkArcRole: TG,
  xLinkHref: _G,
  xLinkRole: CG,
  xLinkShow: xG,
  xLinkTitle: wG,
  xLinkType: AG,
  xmlnsXLink: SG
};
var Lm = {};
Lm.parse = NG;
Lm.stringify = IG;
var D5 = "", DG = " ", OG = /[ \t\n\r\f]+/g;
function NG(e) {
  var t = String(e || D5).trim();
  return t === D5 ? [] : t.split(OG);
}
function IG(e) {
  return e.join(DG).trim();
}
var $m = {};
$m.parse = PG;
$m.stringify = RG;
var Xh = ",", O5 = " ", Mo = "";
function PG(e) {
  for (var t = [], n = String(e || Mo), r = n.indexOf(Xh), i = 0, a = !1, s; !a; )
    r === -1 && (r = n.length, a = !0), s = n.slice(i, r).trim(), (s || !a) && t.push(s), i = r + 1, r = n.indexOf(Xh, i);
  return t;
}
function RG(e, t) {
  var n = t || {}, r = n.padLeft === !1 ? Mo : O5, i = n.padRight ? O5 : Mo;
  return e[e.length - 1] === Mo && (e = e.concat(Mo)), e.join(i + Xh + r).trim();
}
var N5 = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, FG = /\n/g, BG = /^\s*/, MG = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, LG = /^:\s*/, $G = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, jG = /^[;\s]*/, HG = /^\s+|\s+$/g, UG = `
`, I5 = "/", P5 = "*", Sa = "", zG = "comment", qG = "declaration", WG = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function i(g) {
    var m = g.match(FG);
    m && (n += m.length);
    var y = g.lastIndexOf(UG);
    r = ~y ? g.length - y : r + g.length;
  }
  function a() {
    var g = { line: n, column: r };
    return function(m) {
      return m.position = new s(g), u(), m;
    };
  }
  function s(g) {
    this.start = g, this.end = { line: n, column: r }, this.source = t.source;
  }
  s.prototype.content = e;
  function o(g) {
    var m = new Error(
      t.source + ":" + n + ":" + r + ": " + g
    );
    if (m.reason = g, m.filename = t.source, m.line = n, m.column = r, m.source = e, !t.silent)
      throw m;
  }
  function l(g) {
    var m = g.exec(e);
    if (m) {
      var y = m[0];
      return i(y), e = e.slice(y.length), m;
    }
  }
  function u() {
    l(BG);
  }
  function c(g) {
    var m;
    for (g = g || []; m = d(); )
      m !== !1 && g.push(m);
    return g;
  }
  function d() {
    var g = a();
    if (!(I5 != e.charAt(0) || P5 != e.charAt(1))) {
      for (var m = 2; Sa != e.charAt(m) && (P5 != e.charAt(m) || I5 != e.charAt(m + 1)); )
        ++m;
      if (m += 2, Sa === e.charAt(m - 1))
        return o("End of comment missing");
      var y = e.slice(2, m - 2);
      return r += 2, i(y), e = e.slice(m), r += 2, g({
        type: zG,
        comment: y
      });
    }
  }
  function f() {
    var g = a(), m = l(MG);
    if (m) {
      if (d(), !l(LG))
        return o("property missing ':'");
      var y = l($G), v = g({
        type: qG,
        property: R5(m[0].replace(N5, Sa)),
        value: y ? R5(y[0].replace(N5, Sa)) : Sa
      });
      return l(jG), v;
    }
  }
  function p() {
    var g = [];
    c(g);
    for (var m; m = f(); )
      m !== !1 && (g.push(m), c(g));
    return g;
  }
  return u(), p();
};
function R5(e) {
  return e ? e.replace(HG, Sa) : Sa;
}
var VG = WG;
function KG(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  for (var r, i = VG(e), a = typeof t == "function", s, o, l = 0, u = i.length; l < u; l++)
    r = i[l], s = r.property, o = r.value, a ? t(s, o, r) : o && (n || (n = {}), n[s] = o);
  return n;
}
var GG = KG;
const hf = M, YG = UK, ZG = JK, QG = rG, F5 = kG, XG = Lm, JG = $m, eY = GG;
Bm.hastToReact = g_;
Bm.hastChildrenToReact = m_;
const Jh = {}.hasOwnProperty, tY = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function m_(e, t) {
  const n = [];
  let r = -1, i;
  for (; ++r < t.children.length; )
    i = t.children[r], i.type === "element" ? n.push(g_(e, i, r, t)) : i.type === "text" ? (t.type !== "element" || !tY.has(t.tagName) || i.value !== `
`) && n.push(i.value) : i.type === "raw" && !e.options.skipHtml && n.push(i.value);
  return n;
}
function g_(e, t, n, r) {
  const i = e.options, a = e.schema, s = t.tagName, o = {};
  let l = a, u;
  if (a.space === "html" && s === "svg" && (l = ZG, e.schema = l), t.properties)
    for (u in t.properties)
      Jh.call(t.properties, u) && rY(o, u, t.properties[u], e);
  (s === "ol" || s === "ul") && e.listDepth++;
  const c = m_(e, t);
  (s === "ol" || s === "ul") && e.listDepth--, e.schema = a;
  const d = t.position || {
    start: { line: null, column: null, offset: null },
    end: { line: null, column: null, offset: null }
  }, f = i.components && Jh.call(i.components, s) ? i.components[s] : s, p = typeof f == "string" || f === hf.Fragment;
  if (!YG.isValidElementType(f))
    throw new TypeError(
      `Component for name \`${s}\` not defined or is not renderable`
    );
  if (o.key = [
    s,
    d.start.line,
    d.start.column,
    n
  ].join("-"), s === "a" && i.linkTarget && (o.target = typeof i.linkTarget == "function" ? (
    // @ts-expect-error assume `href` is a string
    i.linkTarget(o.href, t.children, o.title)
  ) : i.linkTarget), s === "a" && i.transformLinkUri && (o.href = i.transformLinkUri(
    // @ts-expect-error assume `href` is a string
    o.href,
    t.children,
    o.title
  )), !p && s === "code" && r.type === "element" && r.tagName !== "pre" && (o.inline = !0), !p && (s === "h1" || s === "h2" || s === "h3" || s === "h4" || s === "h5" || s === "h6") && (o.level = parseInt(s.charAt(1), 10)), s === "img" && i.transformImageUri && (o.src = i.transformImageUri(
    // @ts-expect-error assume `src` is a string
    o.src,
    o.alt,
    o.title
  )), !p && s === "li" && r.type === "element") {
    const g = nY(t);
    o.checked = g && g.properties ? !!g.properties.checked : null, o.index = pf(r, t), o.ordered = r.tagName === "ol";
  }
  return !p && (s === "ol" || s === "ul") && (o.ordered = s === "ol", o.depth = e.listDepth), (s === "td" || s === "th") && (o.align && (o.style || (o.style = {}), o.style.textAlign = o.align, delete o.align), p || (o.isHeader = s === "th")), !p && s === "tr" && r.type === "element" && (o.isHeader = r.tagName === "thead"), i.sourcePos && (o["data-sourcepos"] = sY(d)), !p && i.rawSourcePos && (o.sourcePosition = t.position), !p && i.includeElementIndex && (o.index = pf(r, t), o.siblingCount = pf(r)), p || (o.node = t), c.length > 0 ? hf.createElement(f, o, c) : hf.createElement(f, o);
}
function nY(e) {
  let t = -1;
  for (; ++t < e.children.length; ) {
    const n = e.children[t];
    if (n.type === "element" && n.tagName === "input")
      return n;
  }
  return null;
}
function pf(e, t) {
  let n = -1, r = 0;
  for (; ++n < e.children.length && e.children[n] !== t; )
    e.children[n].type === "element" && r++;
  return r;
}
function rY(e, t, n, r) {
  const i = QG(r.schema, t);
  let a = n;
  a == null || a !== a || (a && typeof a == "object" && "length" in a && (a = (i.commaSeparated ? JG : XG).stringify(a)), i.property === "style" && typeof a == "string" && (a = iY(a)), i.space && i.property ? e[Jh.call(F5, i.property) ? F5[i.property] : i.property] = a : i.attribute && (e[i.attribute] = a));
}
function iY(e) {
  const t = {};
  try {
    eY(e, n);
  } catch {
  }
  return t;
  function n(r, i) {
    const a = r.slice(0, 4) === "-ms-" ? `ms-${r.slice(4)}` : r;
    t[a.replace(/-([a-z])/g, aY)] = i;
  }
}
function aY(e, t) {
  return t.toUpperCase();
}
function sY(e) {
  return [
    e.start.line,
    ":",
    e.start.column,
    "-",
    e.end.line,
    ":",
    e.end.column
  ].map((t) => String(t)).join("");
}
const mf = M, B5 = r8, oY = n$, lY = qq, uY = XV, ot = h4, cY = RK, dY = BK, v_ = LK, fY = Bm.hastChildrenToReact;
var hY = S1;
const M5 = {}.hasOwnProperty, pY = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Iu = {
  renderers: { to: "components", id: "change-renderers-to-components" },
  astPlugins: { id: "remove-buggy-html-in-markdown-parser" },
  allowDangerousHtml: { id: "remove-buggy-html-in-markdown-parser" },
  escapeHtml: { id: "remove-buggy-html-in-markdown-parser" },
  source: { to: "children", id: "change-source-to-children" },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};
function S1(e) {
  for (const a in Iu)
    if (M5.call(Iu, a) && M5.call(e, a)) {
      const s = Iu[a];
      console.warn(
        `[react-markdown] Warning: please ${s.to ? `use \`${s.to}\` instead of` : "remove"} \`${a}\` (see <${pY}#${s.id}> for more info)`
      ), delete Iu[a];
    }
  const t = oY().use(lY).use(e.remarkPlugins || e.plugins || []).use(uY, { allowDangerousHtml: !0 }).use(e.rehypePlugins || []).use(dY, e);
  let n;
  typeof e.children == "string" ? n = B5(e.children) : (e.children !== void 0 && e.children !== null && console.warn(
    `[react-markdown] Warning: please pass a string as \`children\` (not: \`${e.children}\`)`
  ), n = B5());
  const r = t.runSync(t.parse(n), n);
  if (r.type !== "root")
    throw new TypeError("Expected a `root` node");
  let i = mf.createElement(
    mf.Fragment,
    {},
    fY({ options: e, schema: cY, listDepth: 0 }, r)
  );
  return e.className && (i = mf.createElement("div", { className: e.className }, i)), i;
}
S1.defaultProps = { transformLinkUri: v_ };
S1.propTypes = {
  // Core options:
  children: ot.string,
  // Layout options:
  className: ot.string,
  // Filter options:
  allowElement: ot.func,
  allowedElements: ot.arrayOf(ot.string),
  disallowedElements: ot.arrayOf(ot.string),
  unwrapDisallowed: ot.bool,
  // Plugin options:
  // type-coverage:ignore-next-line
  remarkPlugins: ot.arrayOf(
    ot.oneOfType([
      ot.object,
      ot.func,
      ot.arrayOf(ot.oneOfType([ot.object, ot.func]))
    ])
  ),
  // type-coverage:ignore-next-line
  rehypePlugins: ot.arrayOf(
    ot.oneOfType([
      ot.object,
      ot.func,
      ot.arrayOf(ot.oneOfType([ot.object, ot.func]))
    ])
  ),
  // Transform options:
  sourcePos: ot.bool,
  rawSourcePos: ot.bool,
  skipHtml: ot.bool,
  includeElementIndex: ot.bool,
  transformLinkUri: ot.oneOfType([ot.func, ot.bool]),
  linkTarget: ot.oneOfType([ot.func, ot.string]),
  transformImageUri: ot.func,
  components: ot.object
};
S1.uriTransformer = v_;
const y_ = /* @__PURE__ */ Or(hY);
var E_ = {}, b_ = T1, T_ = ql, __ = Sm, mY = Xt, C_ = wm, x_ = Am, gY = { tokenize: bY, partial: !0 }, w_ = { tokenize: TY, partial: !0 }, A_ = { tokenize: _Y, partial: !0 }, Os = { tokenize: xY, partial: !0 }, S_ = {
  tokenize: CY,
  partial: !0
}, k_ = { tokenize: yY, previous: N_ }, D_ = { tokenize: EY, previous: Hm }, Ri = { tokenize: vY, previous: I_ }, ri = {};
E_.text = ri;
var va = 48;
for (; va < 123; )
  ri[va] = Ri, va++, va === 58 ? va = 65 : va === 91 && (va = 97);
ri[43] = Ri;
ri[45] = Ri;
ri[46] = Ri;
ri[95] = Ri;
ri[72] = [Ri, D_];
ri[104] = [Ri, D_];
ri[87] = [Ri, k_];
ri[119] = [Ri, k_];
function vY(e, t, n) {
  var r = this, i;
  return a;
  function a(f) {
    return !L5(f) || !I_(r.previous) || Um(r.events) ? n(f) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), s(f));
  }
  function s(f) {
    return L5(f) ? (e.consume(f), s) : f === 64 ? (e.consume(f), o) : n(f);
  }
  function o(f) {
    return f === 46 ? e.check(Os, d, l)(f) : (
      // `-`
      f === 45 || // `_`
      f === 95 ? e.check(Os, n, u)(f) : T_(f) ? (e.consume(f), o) : d(f)
    );
  }
  function l(f) {
    return e.consume(f), i = !0, o;
  }
  function u(f) {
    return e.consume(f), c;
  }
  function c(f) {
    return f === 46 ? e.check(Os, n, l)(f) : o(f);
  }
  function d(f) {
    return i ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(f)) : n(f);
  }
}
function yY(e, t, n) {
  var r = this;
  return i;
  function i(s) {
    return s !== 87 && s - 32 !== 87 || !N_(r.previous) || Um(r.events) ? n(s) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(
      gY,
      e.attempt(w_, e.attempt(A_, a), n),
      n
    )(s));
  }
  function a(s) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(s);
  }
}
function EY(e, t, n) {
  var r = this;
  return i;
  function i(g) {
    return g !== 72 && g - 32 !== 72 || !Hm(r.previous) || Um(r.events) ? n(g) : (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), e.consume(g), a);
  }
  function a(g) {
    return g === 84 || g - 32 === 84 ? (e.consume(g), s) : n(g);
  }
  function s(g) {
    return g === 84 || g - 32 === 84 ? (e.consume(g), o) : n(g);
  }
  function o(g) {
    return g === 80 || g - 32 === 80 ? (e.consume(g), l) : n(g);
  }
  function l(g) {
    return g === 83 || g - 32 === 83 ? (e.consume(g), u) : u(g);
  }
  function u(g) {
    return g === 58 ? (e.consume(g), c) : n(g);
  }
  function c(g) {
    return g === 47 ? (e.consume(g), d) : n(g);
  }
  function d(g) {
    return g === 47 ? (e.consume(g), f) : n(g);
  }
  function f(g) {
    return __(g) || x_(g) || C_(g) ? n(g) : e.attempt(w_, e.attempt(A_, p), n)(g);
  }
  function p(g) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(g);
  }
}
function bY(e, t, n) {
  return r;
  function r(l) {
    return e.consume(l), i;
  }
  function i(l) {
    return l === 87 || l - 32 === 87 ? (e.consume(l), a) : n(l);
  }
  function a(l) {
    return l === 87 || l - 32 === 87 ? (e.consume(l), s) : n(l);
  }
  function s(l) {
    return l === 46 ? (e.consume(l), o) : n(l);
  }
  function o(l) {
    return l === null || mY(l) ? n(l) : t(l);
  }
}
function TY(e, t, n) {
  var r, i;
  return a;
  function a(l) {
    return l === 38 ? e.check(
      S_,
      o,
      s
    )(l) : l === 46 || l === 95 ? e.check(Os, o, s)(l) : __(l) || x_(l) || l !== 45 && C_(l) ? o(l) : (e.consume(l), a);
  }
  function s(l) {
    return l === 46 ? (i = r, r = void 0, e.consume(l), a) : (l === 95 && (r = !0), e.consume(l), a);
  }
  function o(l) {
    return !i && !r ? t(l) : n(l);
  }
}
function _Y(e, t) {
  var n = 0;
  return r;
  function r(s) {
    return s === 38 ? e.check(
      S_,
      t,
      i
    )(s) : (s === 40 && n++, s === 41 ? e.check(
      Os,
      a,
      i
    )(s) : jm(s) ? t(s) : O_(s) ? e.check(Os, t, i)(s) : (e.consume(s), r));
  }
  function i(s) {
    return e.consume(s), r;
  }
  function a(s) {
    return n--, n < 0 ? t(s) : i(s);
  }
}
function CY(e, t, n) {
  return r;
  function r(s) {
    return e.consume(s), i;
  }
  function i(s) {
    return b_(s) ? (e.consume(s), i) : s === 59 ? (e.consume(s), a) : n(s);
  }
  function a(s) {
    return jm(s) ? t(s) : n(s);
  }
}
function xY(e, t, n) {
  return r;
  function r(a) {
    return e.consume(a), i;
  }
  function i(a) {
    return O_(a) ? (e.consume(a), i) : jm(a) ? t(a) : n(a);
  }
}
function O_(e) {
  return (
    // `!`
    e === 33 || // `"`
    e === 34 || // `'`
    e === 39 || // `)`
    e === 41 || // `*`
    e === 42 || // `,`
    e === 44 || // `.`
    e === 46 || // `:`
    e === 58 || // `;`
    e === 59 || // `<`
    e === 60 || // `?`
    e === 63 || // `_`.
    e === 95 || // `~`
    e === 126
  );
}
function jm(e) {
  return (
    // EOF.
    e === null || // CR, LF, CRLF, HT, VS.
    e < 0 || // Space.
    e === 32 || // `<`
    e === 60
  );
}
function L5(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || T_(e);
}
function N_(e) {
  return e === null || e < 0 || e === 32 || e === 40 || e === 42 || e === 95 || e === 126;
}
function Hm(e) {
  return e === null || !b_(e);
}
function I_(e) {
  return e !== 47 && Hm(e);
}
function Um(e) {
  for (var t = e.length; t--; )
    if ((e[t][1].type === "labelLink" || e[t][1].type === "labelImage") && !e[t][1]._balanced)
      return !0;
}
var wY = E_, AY = kY, $5 = y8, gf = Ii, SY = b1, Pu = Ka;
function kY(e) {
  var t = e || {}, n = t.singleTilde, r = {
    tokenize: s,
    resolveAll: i
  };
  return n == null && (n = !0), { text: { 126: r }, insideSpan: { null: r } };
  function i(o, l) {
    for (var u = -1, c, d, f, p; ++u < o.length; )
      if (o[u][0] === "enter" && o[u][1].type === "strikethroughSequenceTemporary" && o[u][1]._close) {
        for (f = u; f--; )
          if (o[f][0] === "exit" && o[f][1].type === "strikethroughSequenceTemporary" && o[f][1]._open && // If the sizes are the same:
          o[u][1].end.offset - o[u][1].start.offset === o[f][1].end.offset - o[f][1].start.offset) {
            o[u][1].type = "strikethroughSequence", o[f][1].type = "strikethroughSequence", c = {
              type: "strikethrough",
              start: Pu(o[f][1].start),
              end: Pu(o[u][1].end)
            }, d = {
              type: "strikethroughText",
              start: Pu(o[f][1].end),
              end: Pu(o[u][1].start)
            }, p = [
              ["enter", c, l],
              ["enter", o[f][1], l],
              ["exit", o[f][1], l],
              ["enter", d, l]
            ], gf(
              p,
              p.length,
              0,
              SY(
                l.parser.constructs.insideSpan.null,
                o.slice(f + 1, u),
                l
              )
            ), gf(p, p.length, 0, [
              ["exit", d, l],
              ["enter", o[u][1], l],
              ["exit", o[u][1], l],
              ["exit", c, l]
            ]), gf(o, f - 1, u - f + 3, p), u = f + p.length - 2;
            break;
          }
      }
    return a(o);
  }
  function a(o) {
    for (var l = -1, u = o.length; ++l < u; )
      o[l][1].type === "strikethroughSequenceTemporary" && (o[l][1].type = "data");
    return o;
  }
  function s(o, l, u) {
    var c = this.previous, d = this.events, f = 0;
    return p;
    function p(m) {
      return m !== 126 || c === 126 && d[d.length - 1][1].type !== "characterEscape" ? u(m) : (o.enter("strikethroughSequenceTemporary"), g(m));
    }
    function g(m) {
      var y = $5(c), v, E;
      return m === 126 ? f > 1 ? u(m) : (o.consume(m), f++, g) : f < 2 && !n ? u(m) : (v = o.exit("strikethroughSequenceTemporary"), E = $5(m), v._open = !E || E === 2 && y, v._close = !y || y === 2 && E, l(m));
    }
  }
}
var P_ = {};
P_.flow = {
  null: { tokenize: NY, resolve: OY, interruptible: !0 }
};
var vf = tn, DY = { tokenize: IY, partial: !0 }, j5 = { tokenize: PY, partial: !0 };
function OY(e, t) {
  for (var n = e.length, r = -1, i, a, s, o, l, u, c, d, f, p; ++r < n; )
    i = e[r][1], o && (i.type === "temporaryTableCellContent" && (d = d || r, f = r), // Combine separate content parts into one.
    (i.type === "tableCellDivider" || i.type === "tableRow") && f && (u = {
      type: "tableContent",
      start: e[d][1].start,
      end: e[f][1].end
    }, c = {
      type: "chunkText",
      start: u.start,
      end: u.end,
      contentType: "text"
    }, e.splice(
      d,
      f - d + 1,
      ["enter", u, t],
      ["enter", c, t],
      ["exit", c, t],
      ["exit", u, t]
    ), r -= f - d - 3, n = e.length, d = void 0, f = void 0)), e[r][0] === "exit" && p && p + 1 < r && (i.type === "tableCellDivider" || i.type === "tableRow" && (p + 3 < r || e[p][1].type !== "whitespace")) && (l = {
      type: s ? "tableDelimiter" : a ? "tableHeader" : "tableData",
      start: e[p][1].start,
      end: e[r][1].end
    }, e.splice(r + (i.type === "tableCellDivider" ? 1 : 0), 0, [
      "exit",
      l,
      t
    ]), e.splice(p, 0, ["enter", l, t]), r += 2, n = e.length, p = r + 1), i.type === "tableRow" && (o = e[r][0] === "enter", o && (p = r + 1)), i.type === "tableDelimiterRow" && (s = e[r][0] === "enter", s && (p = r + 1)), i.type === "tableHead" && (a = e[r][0] === "enter");
  return e;
}
function NY(e, t, n) {
  var r = [], i = 0, a, s;
  return o;
  function o(N) {
    return N === null || N === -5 || N === -4 || N === -3 ? n(N) : (e.enter("table")._align = r, e.enter("tableHead"), e.enter("tableRow"), N === 124 ? l(N) : (i++, e.enter("temporaryTableCellContent"), d(N)));
  }
  function l(N) {
    return e.enter("tableCellDivider"), e.consume(N), e.exit("tableCellDivider"), a = !0, u;
  }
  function u(N) {
    return N === null || N === -5 || N === -4 || N === -3 ? p(N) : N === -2 || N === -1 || N === 32 ? (e.enter("whitespace"), e.consume(N), c) : (a && (a = void 0, i++), N === 124 ? l(N) : (e.enter("temporaryTableCellContent"), d(N)));
  }
  function c(N) {
    return N === -2 || N === -1 || N === 32 ? (e.consume(N), c) : (e.exit("whitespace"), u(N));
  }
  function d(N) {
    return N === null || N < 0 || N === 32 || N === 124 ? (e.exit("temporaryTableCellContent"), u(N)) : (e.consume(N), N === 92 ? f : d);
  }
  function f(N) {
    return N === 92 || N === 124 ? (e.consume(N), d) : d(N);
  }
  function p(N) {
    return N === null ? n(N) : (e.exit("tableRow"), e.exit("tableHead"), e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), e.check(
      DY,
      n,
      // Support an indent before the delimiter row.
      vf(e, g, "linePrefix", 4)
    ));
  }
  function g(N) {
    return N === null || N < 0 || N === 32 ? n(N) : (e.enter("tableDelimiterRow"), m(N));
  }
  function m(N) {
    return N === null || N === -5 || N === -4 || N === -3 ? _(N) : N === -2 || N === -1 || N === 32 ? (e.enter("whitespace"), e.consume(N), y) : N === 45 ? (e.enter("tableDelimiterFiller"), e.consume(N), s = !0, r.push(null), v) : N === 58 ? (e.enter("tableDelimiterAlignment"), e.consume(N), e.exit("tableDelimiterAlignment"), r.push("left"), E) : N === 124 ? (e.enter("tableCellDivider"), e.consume(N), e.exit("tableCellDivider"), m) : n(N);
  }
  function y(N) {
    return N === -2 || N === -1 || N === 32 ? (e.consume(N), y) : (e.exit("whitespace"), m(N));
  }
  function v(N) {
    return N === 45 ? (e.consume(N), v) : (e.exit("tableDelimiterFiller"), N === 58 ? (e.enter("tableDelimiterAlignment"), e.consume(N), e.exit("tableDelimiterAlignment"), r[r.length - 1] = r[r.length - 1] === "left" ? "center" : "right", b) : m(N));
  }
  function E(N) {
    return N === 45 ? (e.enter("tableDelimiterFiller"), e.consume(N), s = !0, v) : n(N);
  }
  function b(N) {
    return N === null || N === -5 || N === -4 || N === -3 ? _(N) : N === -2 || N === -1 || N === 32 ? (e.enter("whitespace"), e.consume(N), y) : N === 124 ? (e.enter("tableCellDivider"), e.consume(N), e.exit("tableCellDivider"), m) : n(N);
  }
  function _(N) {
    return e.exit("tableDelimiterRow"), !s || i !== r.length ? n(N) : N === null ? T(N) : e.check(j5, T, x)(N);
  }
  function T(N) {
    return e.exit("table"), t(N);
  }
  function x(N) {
    return e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), vf(e, A, "linePrefix", 4);
  }
  function A(N) {
    return e.enter("tableBody"), R(N);
  }
  function R(N) {
    return e.enter("tableRow"), N === 124 ? P(N) : (e.enter("temporaryTableCellContent"), O(N));
  }
  function P(N) {
    return e.enter("tableCellDivider"), e.consume(N), e.exit("tableCellDivider"), L;
  }
  function L(N) {
    return N === null || N === -5 || N === -4 || N === -3 ? F(N) : N === -2 || N === -1 || N === 32 ? (e.enter("whitespace"), e.consume(N), I) : N === 124 ? P(N) : (e.enter("temporaryTableCellContent"), O(N));
  }
  function I(N) {
    return N === -2 || N === -1 || N === 32 ? (e.consume(N), I) : (e.exit("whitespace"), L(N));
  }
  function O(N) {
    return N === null || N < 0 || N === 32 || N === 124 ? (e.exit("temporaryTableCellContent"), L(N)) : (e.consume(N), N === 92 ? S : O);
  }
  function S(N) {
    return N === 92 || N === 124 ? (e.consume(N), O) : O(N);
  }
  function F(N) {
    return e.exit("tableRow"), N === null ? H(N) : e.check(
      j5,
      H,
      q
    )(N);
  }
  function H(N) {
    return e.exit("tableBody"), T(N);
  }
  function q(N) {
    return e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), vf(e, R, "linePrefix", 4);
  }
}
function IY(e, t, n) {
  return r;
  function r(s) {
    return s !== 45 ? n(s) : (e.enter("setextUnderline"), i(s));
  }
  function i(s) {
    return s === 45 ? (e.consume(s), i) : a(s);
  }
  function a(s) {
    return s === -2 || s === -1 || s === 32 ? (e.consume(s), a) : s === null || s === -5 || s === -4 || s === -3 ? t(s) : n(s);
  }
}
function PY(e, t, n) {
  var r = 0;
  return i;
  function i(s) {
    return e.enter("check"), e.consume(s), a;
  }
  function a(s) {
    return s === -1 || s === 32 ? (e.consume(s), r++, r === 4 ? t : a) : s === null || s < 0 ? t(s) : n(s);
  }
}
var RY = P_, R_ = {}, FY = Pi, BY = tn, MY = zl, LY = { tokenize: $Y };
R_.text = { 91: LY };
function $Y(e, t, n) {
  var r = this;
  return i;
  function i(o) {
    return (
      // Exit if not `[`.
      o !== 91 || // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(o) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(o), e.exit("taskListCheckMarker"), a)
    );
  }
  function a(o) {
    return o === -2 || o === 32 ? (e.enter("taskListCheckValueUnchecked"), e.consume(o), e.exit("taskListCheckValueUnchecked"), s) : o === 88 || o === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(o), e.exit("taskListCheckValueChecked"), s) : n(o);
  }
  function s(o) {
    return o === 93 ? (e.enter("taskListCheckMarker"), e.consume(o), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), e.check({ tokenize: jY }, t, n)) : n(o);
  }
}
function jY(e, t, n) {
  var r = this;
  return BY(e, i, "whitespace");
  function i(a) {
    return MY(r.events, "whitespace") && a !== null && !FY(a) ? t(a) : n(a);
  }
}
var HY = R_, UY = v8, zY = wY, qY = AY, WY = RY, VY = HY, KY = GY;
function GY(e) {
  return UY([zY, qY(e), WY, VY]);
}
var YY = KY, k1 = {}, ZY = QY;
function QY(e, t) {
  var n = String(e), r = 0, i;
  if (typeof t != "string")
    throw new Error("Expected character");
  for (i = n.indexOf(t); i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
var XY = (e) => {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}, JY = iZ, eZ = M8, tZ = F8, nZ = XY, rZ = [].splice;
function iZ(e, t, n, r) {
  var i, a;
  return typeof t == "string" || t && typeof t.exec == "function" ? a = [[t, n]] : (a = t, r = n), i = r || {}, H5(e, i, s(aZ(a))), e;
  function s(o) {
    var l = o[0];
    return u;
    function u(c, d) {
      var f = l[0], p = l[1], g = [], m = 0, y = d.children.indexOf(c), v, E, b, _;
      for (f.lastIndex = 0, E = f.exec(c.value); E && (v = E.index, _ = p.apply(
        null,
        [].concat(E, { index: E.index, input: E.input })
      ), _ !== !1 && (m !== v && g.push({ type: "text", value: c.value.slice(m, v) }), typeof _ == "string" && _.length > 0 && (_ = { type: "text", value: _ }), _ && (g = [].concat(g, _)), m = v + E[0].length), !!f.global); )
        E = f.exec(c.value);
      if (v === void 0 ? (g = [c], y--) : (m < c.value.length && g.push({ type: "text", value: c.value.slice(m) }), g.unshift(y, 1), rZ.apply(d.children, g)), o.length > 1)
        for (b = s(o.slice(1)), v = -1; ++v < g.length; )
          c = g[v], c.type === "text" ? b(c, d) : H5(c, i, b);
      return y + g.length + 1;
    }
  }
}
function H5(e, t, n) {
  var r = tZ(t.ignore || []), i = [];
  return eZ(e, "text", a), i;
  function a(s, o) {
    for (var l = -1, u, c; ++l < o.length; ) {
      if (u = o[l], r(
        u,
        c ? c.children.indexOf(u) : void 0,
        c
      ))
        return;
      c = u;
    }
    return n(s, c);
  }
}
function aZ(e) {
  var t = [], n, r;
  if (typeof e != "object")
    throw new Error("Expected array or object as schema");
  if ("length" in e)
    for (r = -1; ++r < e.length; )
      t.push([
        U5(e[r][0]),
        z5(e[r][1])
      ]);
  else
    for (n in e)
      t.push([U5(n), z5(e[n])]);
  return t;
}
function U5(e) {
  return typeof e == "string" ? new RegExp(nZ(e), "g") : e;
}
function z5(e) {
  return typeof e == "function" ? e : t;
  function t() {
    return e;
  }
}
var q5 = ZY, sZ = JY, oZ = wm, lZ = Am;
k1.transforms = [pZ];
k1.enter = {
  literalAutolink: uZ,
  literalAutolinkEmail: yf,
  literalAutolinkHttp: yf,
  literalAutolinkWww: yf
};
k1.exit = {
  literalAutolink: hZ,
  literalAutolinkEmail: fZ,
  literalAutolinkHttp: cZ,
  literalAutolinkWww: dZ
};
function uZ(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function yf(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function cZ(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function dZ(e) {
  this.config.exit.data.call(this, e), this.stack[this.stack.length - 1].url = "http://" + this.sliceSerialize(e);
}
function fZ(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function hZ(e) {
  this.exit(e);
}
function pZ(e) {
  sZ(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/i, mZ],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/, gZ]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function mZ(e, t, n, r, i) {
  var a = "", s, o;
  return !F_(i) || (/^w/i.test(t) && (n = t + n, t = "", a = "http://"), !vZ(n)) || (s = yZ(n + r), !s[0]) ? !1 : (o = {
    type: "link",
    title: null,
    url: a + t + s[0],
    children: [{ type: "text", value: t + s[0] }]
  }, s[1] && (o = [o, { type: "text", value: s[1] }]), o);
}
function gZ(e, t, n, r) {
  return !F_(r, !0) || /[_-]$/.test(n) ? !1 : {
    type: "link",
    title: null,
    url: "mailto:" + t + "@" + n,
    children: [{ type: "text", value: t + "@" + n }]
  };
}
function vZ(e) {
  var t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function yZ(e) {
  var t = /[!"&'),.:;<>?\]}]+$/.exec(e), n, r, i;
  if (t)
    for (e = e.slice(0, t.index), t = t[0], n = t.indexOf(")"), r = q5(e, "("), i = q5(e, ")"); n !== -1 && r > i; )
      e += t.slice(0, n + 1), t = t.slice(n + 1), n = t.indexOf(")"), i++;
  return [e, t];
}
function F_(e, t) {
  var n = e.input.charCodeAt(e.index - 1);
  return (n !== n || lZ(n) || oZ(n)) && (!t || n !== 47);
}
var D1 = {};
D1.canContainEols = ["delete"];
D1.enter = { strikethrough: EZ };
D1.exit = { strikethrough: bZ };
function EZ(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function bZ(e) {
  this.exit(e);
}
var zm = {};
zm.enter = {
  table: TZ,
  tableData: W5,
  tableHeader: W5,
  tableRow: CZ
};
zm.exit = {
  codeText: xZ,
  table: _Z,
  tableData: Ef,
  tableHeader: Ef,
  tableRow: Ef
};
function TZ(e) {
  this.enter({ type: "table", align: e._align, children: [] }, e), this.setData("inTable", !0);
}
function _Z(e) {
  this.exit(e), this.setData("inTable");
}
function CZ(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function Ef(e) {
  this.exit(e);
}
function W5(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function xZ(e) {
  var t = this.resume();
  this.getData("inTable") && (t = t.replace(/\\([\\|])/g, wZ)), this.stack[this.stack.length - 1].value = t, this.exit(e);
}
function wZ(e, t) {
  return t === "|" ? t : e;
}
var B_ = {};
B_.exit = {
  taskListCheckValueChecked: V5,
  taskListCheckValueUnchecked: V5,
  paragraph: AZ
};
function V5(e) {
  this.stack[this.stack.length - 2].checked = e.type === "taskListCheckValueChecked";
}
function AZ(e) {
  var t = this.stack[this.stack.length - 2], n = this.stack[this.stack.length - 1], r = t.children, i = n.children[0], a = -1, s;
  if (t && t.type === "listItem" && typeof t.checked == "boolean" && i && i.type === "text") {
    for (; ++a < r.length; )
      if (r[a].type === "paragraph") {
        s = r[a];
        break;
      }
    s === n && (i.value = i.value.slice(1), i.value.length === 0 ? n.children.shift() : (i.position.start.column++, i.position.start.offset++, n.position.start = Object.assign({}, i.position.start)));
  }
  this.exit(e);
}
var SZ = k1, kZ = D1, DZ = zm, OZ = B_, NZ = {}.hasOwnProperty, IZ = PZ([
  SZ,
  kZ,
  DZ,
  OZ
]);
function PZ(e) {
  for (var t = { transforms: [], canContainEols: [] }, n = e.length, r = -1; ++r < n; )
    RZ(t, e[r]);
  return t;
}
function RZ(e, t) {
  var n, r, i;
  for (n in t)
    r = NZ.call(e, n) ? e[n] : e[n] = {}, i = t[n], n === "canContainEols" || n === "transforms" ? e[n] = [].concat(r, i) : Object.assign(r, i);
}
var M_ = {}, bf = "phrasing", Tf = ["autolink", "link", "image", "label"];
M_.unsafe = [
  {
    character: "@",
    before: "[+\\-.\\w]",
    after: "[\\-.\\w]",
    inConstruct: bf,
    notInConstruct: Tf
  },
  {
    character: ".",
    before: "[Ww]",
    after: "[\\-.\\w]",
    inConstruct: bf,
    notInConstruct: Tf
  },
  {
    character: ":",
    before: "[ps]",
    after: "\\/",
    inConstruct: bf,
    notInConstruct: Tf
  }
];
var qm = {}, L_ = FZ;
function FZ(e, t, n) {
  for (var r = e.children || [], i = [], a = -1, s = n.before, o, l, u; ++a < r.length; )
    u = r[a], a + 1 < r.length ? (l = t.handle.handlers[r[a + 1].type], l && l.peek && (l = l.peek), o = l ? l(r[a + 1], e, t, {
      before: "",
      after: ""
    }).charAt(0) : "") : o = n.after, i.length > 0 && (s === "\r" || s === `
`) && u.type === "html" && (i[i.length - 1] = i[i.length - 1].replace(
      /(\r?\n|\r)$/,
      " "
    ), s = " "), i.push(
      t.handle(u, e, t, {
        before: s,
        after: o
      })
    ), s = i[i.length - 1].slice(-1);
  return i.join("");
}
var BZ = L_;
qm.unsafe = [{ character: "~", inConstruct: "phrasing" }];
qm.handlers = { delete: $_ };
$_.peek = MZ;
function $_(e, t, n) {
  var r = n.enter("emphasis"), i = BZ(e, n, { before: "~", after: "~" });
  return r(), "~~" + i + "~~";
}
function MZ() {
  return "~";
}
var LZ = $Z;
function $Z(e) {
  var t, n;
  return e._compiled || (t = e.before ? "(?:" + e.before + ")" : "", n = e.after ? "(?:" + e.after + ")" : "", e.atBreak && (t = "[\\r\\n][\\t ]*" + t), e._compiled = new RegExp(
    (t ? "(" + t + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(e.character) ? "\\" : "") + e.character + (n || ""),
    "g"
  )), e._compiled;
}
var jZ = j_;
j_.peek = UZ;
var HZ = LZ;
function j_(e, t, n) {
  for (var r = e.value || "", i = "`", a = -1, s, o, l, u; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/[ \r\n`]/.test(r.charAt(0)) || /[ \r\n`]/.test(r.charAt(r.length - 1))) && (r = " " + r + " "); ++a < n.unsafe.length; )
    if (s = n.unsafe[a], !!s.atBreak)
      for (o = HZ(s); l = o.exec(r); )
        u = l.index, r.charCodeAt(u) === 10 && r.charCodeAt(u - 1) === 13 && u--, r = r.slice(0, u) + " " + r.slice(l.index + 1);
  return i + r + i;
}
function UZ() {
  return "`";
}
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */
var oi = "", _f, Wm = zZ;
function zZ(e, t) {
  if (typeof e != "string")
    throw new TypeError("expected a string");
  if (t === 1)
    return e;
  if (t === 2)
    return e + e;
  var n = e.length * t;
  if (_f !== e || typeof _f > "u")
    _f = e, oi = "";
  else if (oi.length >= n)
    return oi.substr(0, n);
  for (; n > oi.length && t > 1; )
    t & 1 && (oi += e), t >>= 1, e += e;
  return oi += e, oi = oi.substr(0, n), oi;
}
var ds = Wm, qZ = QZ, WZ = / +$/, ya = " ", VZ = `
`, KZ = "-", Ru = ":", K5 = "|", G5 = 0, GZ = 67, YZ = 76, ZZ = 82, Gc = 99, ep = 108, Yc = 114;
function QZ(e, t) {
  for (var n = t || {}, r = n.padding !== !1, i = n.delimiterStart !== !1, a = n.delimiterEnd !== !1, s = (n.align || []).concat(), o = n.alignDelimiters !== !1, l = [], u = n.stringLength || JZ, c = -1, d = e.length, f = [], p = [], g = [], m = [], y = [], v = 0, E, b, _, T, x, A, R, P, L, I, O; ++c < d; ) {
    for (E = e[c], b = -1, _ = E.length, g = [], m = [], _ > v && (v = _); ++b < _; )
      A = XZ(E[b]), o === !0 && (x = u(A), m[b] = x, T = y[b], (T === void 0 || x > T) && (y[b] = x)), g.push(A);
    f[c] = g, p[c] = m;
  }
  if (b = -1, _ = v, typeof s == "object" && "length" in s)
    for (; ++b < _; )
      l[b] = Y5(s[b]);
  else
    for (O = Y5(s); ++b < _; )
      l[b] = O;
  for (b = -1, _ = v, g = [], m = []; ++b < _; )
    O = l[b], L = "", I = "", O === ep ? L = Ru : O === Yc ? I = Ru : O === Gc && (L = Ru, I = Ru), x = o ? Math.max(
      1,
      y[b] - L.length - I.length
    ) : 1, A = L + ds(KZ, x) + I, o === !0 && (x = L.length + x + I.length, x > y[b] && (y[b] = x), m[b] = x), g[b] = A;
  for (f.splice(1, 0, g), p.splice(1, 0, m), c = -1, d = f.length, R = []; ++c < d; ) {
    for (g = f[c], m = p[c], b = -1, _ = v, P = []; ++b < _; )
      A = g[b] || "", L = "", I = "", o === !0 && (x = y[b] - (m[b] || 0), O = l[b], O === Yc ? L = ds(ya, x) : O === Gc ? x % 2 === 0 ? (L = ds(ya, x / 2), I = L) : (L = ds(ya, x / 2 + 0.5), I = ds(ya, x / 2 - 0.5)) : I = ds(ya, x)), i === !0 && b === 0 && P.push(K5), r === !0 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(o === !1 && A === "") && (i === !0 || b !== 0) && P.push(ya), o === !0 && P.push(L), P.push(A), o === !0 && P.push(I), r === !0 && P.push(ya), (a === !0 || b !== _ - 1) && P.push(K5);
    P = P.join(""), a === !1 && (P = P.replace(WZ, "")), R.push(P);
  }
  return R.join(VZ);
}
function XZ(e) {
  return e == null ? "" : String(e);
}
function JZ(e) {
  return e.length;
}
function Y5(e) {
  var t = typeof e == "string" ? e.charCodeAt(0) : G5;
  return t === YZ || t === ep ? ep : t === ZZ || t === Yc ? Yc : t === GZ || t === Gc ? Gc : G5;
}
var eQ = L_, tQ = jZ, nQ = qZ, rQ = iQ;
function iQ(e) {
  var t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, i = t.stringLength, a = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      table: s,
      tableRow: o,
      tableCell: l,
      inlineCode: f
    }
  };
  function s(p, g, m) {
    return u(c(p, m), p.align);
  }
  function o(p, g, m) {
    var y = d(p, m), v = u([y]);
    return v.slice(0, v.indexOf(`
`));
  }
  function l(p, g, m) {
    var y = m.enter("tableCell"), v = eQ(p, m, { before: a, after: a });
    return y(), v;
  }
  function u(p, g) {
    return nQ(p, {
      align: g,
      alignDelimiters: r,
      padding: n,
      stringLength: i
    });
  }
  function c(p, g) {
    for (var m = p.children, y = -1, v = m.length, E = [], b = g.enter("table"); ++y < v; )
      E[y] = d(m[y], g);
    return b(), E;
  }
  function d(p, g) {
    for (var m = p.children, y = -1, v = m.length, E = [], b = g.enter("tableRow"); ++y < v; )
      E[y] = l(m[y], p, g);
    return b(), E;
  }
  function f(p, g, m) {
    var y = tQ(p, g, m);
    return m.stack.indexOf("tableCell") !== -1 && (y = y.replace(/\|/g, "\\$&")), y;
  }
}
var Vm = {}, aQ = sQ;
function sQ(e) {
  var t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
var oQ = lQ;
function lQ(e) {
  var t = e.options.listItemIndent || "tab";
  if (t === 1 || t === "1")
    return "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
var uQ = dQ, cQ = Wm;
function dQ(e, t) {
  for (var n = e.children || [], r = [], i = -1, a; ++i < n.length; )
    a = n[i], r.push(
      t.handle(a, e, t, { before: `
`, after: `
` })
    ), i + 1 < n.length && r.push(s(a, n[i + 1]));
  return r.join("");
  function s(o, l) {
    for (var u = -1, c; ++u < t.join.length && (c = t.join[u](o, l, e, t), !(c === !0 || c === 1)); ) {
      if (typeof c == "number")
        return cQ(`
`, 1 + Number(c));
      if (c === !1)
        return `

<!---->

`;
    }
    return `

`;
  }
}
var fQ = pQ, hQ = /\r?\n|\r/g;
function pQ(e, t) {
  for (var n = [], r = 0, i = 0, a; a = hQ.exec(e); )
    s(e.slice(r, a.index)), n.push(a[0]), r = a.index + a[0].length, i++;
  return s(e.slice(r)), n.join("");
  function s(o) {
    n.push(t(o, i, !o));
  }
}
var mQ = bQ, Z5 = Wm, gQ = aQ, vQ = oQ, yQ = uQ, EQ = fQ;
function bQ(e, t, n) {
  var r = gQ(n), i = vQ(n), a, s, o;
  return t && t.ordered && (r = (t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + "."), a = r.length + 1, (i === "tab" || i === "mixed" && (t && t.spread || e.spread)) && (a = Math.ceil(a / 4) * 4), o = n.enter("listItem"), s = EQ(yQ(e, n), l), o(), s;
  function l(u, c, d) {
    return c ? (d ? "" : Z5(" ", a)) + u : (d ? r : r + Z5(" ", a - r.length)) + u;
  }
}
var TQ = mQ;
Vm.unsafe = [{ atBreak: !0, character: "-", after: "[:|-]" }];
Vm.handlers = {
  listItem: _Q
};
function _Q(e, t, n) {
  var r = TQ(e, t, n), i = e.children[0];
  return typeof e.checked == "boolean" && i && i.type === "paragraph" && (r = r.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, a)), r;
  function a(s) {
    return s + "[" + (e.checked ? "x" : " ") + "] ";
  }
}
var CQ = H_;
function H_(e, t) {
  var n = -1, r;
  if (t.extensions)
    for (; ++n < t.extensions.length; )
      H_(e, t.extensions[n]);
  for (r in t)
    r === "extensions" || (r === "unsafe" || r === "join" ? e[r] = e[r].concat(t[r] || []) : r === "handlers" ? e[r] = Object.assign(e[r], t[r] || {}) : e.options[r] = t[r]);
  return e;
}
var xQ = M_, wQ = qm, AQ = rQ, SQ = Vm, kQ = CQ, DQ = OQ;
function OQ(e) {
  var t = kQ(
    { handlers: {}, join: [], unsafe: [], options: {} },
    {
      extensions: [xQ, wQ, AQ(e), SQ]
    }
  );
  return Object.assign(t.options, {
    handlers: t.handlers,
    join: t.join,
    unsafe: t.unsafe
  });
}
var NQ = YY, IQ = IZ, PQ = DQ, Q5, RQ = FQ;
function FQ(e) {
  var t = this.data();
  !Q5 && (this.Parser && this.Parser.prototype && this.Parser.prototype.blockTokenizers || this.Compiler && this.Compiler.prototype && this.Compiler.prototype.visitors) && (Q5 = !0, console.warn(
    "[remark-gfm] Warning: please upgrade to remark 13 to use this plugin"
  )), n("micromarkExtensions", NQ(e)), n("fromMarkdownExtensions", IQ), n("toMarkdownExtensions", PQ(e));
  function n(r, i) {
    t[r] ? t[r].push(i) : t[r] = [i];
  }
}
const U_ = /* @__PURE__ */ Or(RQ);
var Ir = {};
const BQ = [
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
];
Ir.REPLACEMENT_CHARACTER = "�";
Ir.CODE_POINTS = {
  EOF: -1,
  NULL: 0,
  TABULATION: 9,
  CARRIAGE_RETURN: 13,
  LINE_FEED: 10,
  FORM_FEED: 12,
  SPACE: 32,
  EXCLAMATION_MARK: 33,
  QUOTATION_MARK: 34,
  NUMBER_SIGN: 35,
  AMPERSAND: 38,
  APOSTROPHE: 39,
  HYPHEN_MINUS: 45,
  SOLIDUS: 47,
  DIGIT_0: 48,
  DIGIT_9: 57,
  SEMICOLON: 59,
  LESS_THAN_SIGN: 60,
  EQUALS_SIGN: 61,
  GREATER_THAN_SIGN: 62,
  QUESTION_MARK: 63,
  LATIN_CAPITAL_A: 65,
  LATIN_CAPITAL_F: 70,
  LATIN_CAPITAL_X: 88,
  LATIN_CAPITAL_Z: 90,
  RIGHT_SQUARE_BRACKET: 93,
  GRAVE_ACCENT: 96,
  LATIN_SMALL_A: 97,
  LATIN_SMALL_F: 102,
  LATIN_SMALL_X: 120,
  LATIN_SMALL_Z: 122,
  REPLACEMENT_CHARACTER: 65533
};
Ir.CODE_POINT_SEQUENCES = {
  DASH_DASH_STRING: [45, 45],
  //--
  DOCTYPE_STRING: [68, 79, 67, 84, 89, 80, 69],
  //DOCTYPE
  CDATA_START_STRING: [91, 67, 68, 65, 84, 65, 91],
  //[CDATA[
  SCRIPT_STRING: [115, 99, 114, 105, 112, 116],
  //script
  PUBLIC_STRING: [80, 85, 66, 76, 73, 67],
  //PUBLIC
  SYSTEM_STRING: [83, 89, 83, 84, 69, 77]
  //SYSTEM
};
Ir.isSurrogate = function(e) {
  return e >= 55296 && e <= 57343;
};
Ir.isSurrogatePair = function(e) {
  return e >= 56320 && e <= 57343;
};
Ir.getSurrogatePairCodePoint = function(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
};
Ir.isControlCodePoint = function(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
};
Ir.isUndefinedCodePoint = function(e) {
  return e >= 64976 && e <= 65007 || BQ.indexOf(e) > -1;
};
var Km = {
  controlCharacterInInputStream: "control-character-in-input-stream",
  noncharacterInInputStream: "noncharacter-in-input-stream",
  surrogateInInputStream: "surrogate-in-input-stream",
  nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
  endTagWithAttributes: "end-tag-with-attributes",
  endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
  unexpectedSolidusInTag: "unexpected-solidus-in-tag",
  unexpectedNullCharacter: "unexpected-null-character",
  unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
  invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
  unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
  missingEndTagName: "missing-end-tag-name",
  unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
  unknownNamedCharacterReference: "unknown-named-character-reference",
  missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
  unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
  unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
  eofBeforeTagName: "eof-before-tag-name",
  eofInTag: "eof-in-tag",
  missingAttributeValue: "missing-attribute-value",
  missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
  missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
  missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
  missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
  missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
  missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
  missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
  abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
  abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
  cdataInHtmlContent: "cdata-in-html-content",
  incorrectlyOpenedComment: "incorrectly-opened-comment",
  eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
  eofInDoctype: "eof-in-doctype",
  nestedComment: "nested-comment",
  abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
  eofInComment: "eof-in-comment",
  incorrectlyClosedComment: "incorrectly-closed-comment",
  eofInCdata: "eof-in-cdata",
  absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
  nullCharacterReference: "null-character-reference",
  surrogateCharacterReference: "surrogate-character-reference",
  characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
  controlCharacterReference: "control-character-reference",
  noncharacterCharacterReference: "noncharacter-character-reference",
  missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
  missingDoctypeName: "missing-doctype-name",
  invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
  duplicateAttribute: "duplicate-attribute",
  nonConformingDoctype: "non-conforming-doctype",
  missingDoctype: "missing-doctype",
  misplacedDoctype: "misplaced-doctype",
  endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
  closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
  disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
  openElementsLeftAfterEof: "open-elements-left-after-eof",
  abandonedHeadElementChild: "abandoned-head-element-child",
  misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
  nestedNoscriptInHead: "nested-noscript-in-head",
  eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
};
const ms = Ir, Cf = Km, Ea = ms.CODE_POINTS, MQ = 65536;
let LQ = class {
  constructor() {
    this.html = null, this.pos = -1, this.lastGapPos = -1, this.lastCharPos = -1, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = MQ;
  }
  _err() {
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.lastCharPos) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (ms.isSurrogatePair(n))
        return this.pos++, this._addGap(), ms.getSurrogatePairCodePoint(t, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, Ea.EOF;
    return this._err(Cf.surrogateInInputStream), t;
  }
  dropParsedChunk() {
    this.pos > this.bufferWaterline && (this.lastCharPos -= this.pos, this.html = this.html.substring(this.pos), this.pos = 0, this.lastGapPos = -1, this.gapStack = []);
  }
  write(t, n) {
    this.html ? this.html += t : this.html = t, this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1, this.html.length), this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1;
  }
  advance() {
    if (this.pos++, this.pos > this.lastCharPos)
      return this.endOfChunkHit = !this.lastChunkWritten, Ea.EOF;
    let t = this.html.charCodeAt(this.pos);
    return this.skipNextNewLine && t === Ea.LINE_FEED ? (this.skipNextNewLine = !1, this._addGap(), this.advance()) : t === Ea.CARRIAGE_RETURN ? (this.skipNextNewLine = !0, Ea.LINE_FEED) : (this.skipNextNewLine = !1, ms.isSurrogate(t) && (t = this._processSurrogate(t)), t > 31 && t < 127 || t === Ea.LINE_FEED || t === Ea.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    ms.isControlCodePoint(t) ? this._err(Cf.controlCharacterInInputStream) : ms.isUndefinedCodePoint(t) && this._err(Cf.noncharacterInInputStream);
  }
  retreat() {
    this.pos === this.lastGapPos && (this.lastGapPos = this.gapStack.pop(), this.pos--), this.pos--;
  }
};
var $Q = LQ, jQ = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4e3, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 1e4, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13e3, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204]);
const HQ = $Q, Dt = Ir, Na = jQ, he = Km, W = Dt.CODE_POINTS, ba = Dt.CODE_POINT_SEQUENCES, UQ = {
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, z_ = 1, q_ = 2, W_ = 4, zQ = z_ | q_ | W_, at = "DATA_STATE", gs = "RCDATA_STATE", Lo = "RAWTEXT_STATE", gi = "SCRIPT_DATA_STATE", V_ = "PLAINTEXT_STATE", X5 = "TAG_OPEN_STATE", J5 = "END_TAG_OPEN_STATE", xf = "TAG_NAME_STATE", e2 = "RCDATA_LESS_THAN_SIGN_STATE", t2 = "RCDATA_END_TAG_OPEN_STATE", n2 = "RCDATA_END_TAG_NAME_STATE", r2 = "RAWTEXT_LESS_THAN_SIGN_STATE", i2 = "RAWTEXT_END_TAG_OPEN_STATE", a2 = "RAWTEXT_END_TAG_NAME_STATE", s2 = "SCRIPT_DATA_LESS_THAN_SIGN_STATE", o2 = "SCRIPT_DATA_END_TAG_OPEN_STATE", l2 = "SCRIPT_DATA_END_TAG_NAME_STATE", u2 = "SCRIPT_DATA_ESCAPE_START_STATE", c2 = "SCRIPT_DATA_ESCAPE_START_DASH_STATE", Tr = "SCRIPT_DATA_ESCAPED_STATE", d2 = "SCRIPT_DATA_ESCAPED_DASH_STATE", wf = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE", Fu = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE", f2 = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE", h2 = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE", p2 = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE", li = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE", m2 = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE", g2 = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE", Bu = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE", v2 = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE", Lr = "BEFORE_ATTRIBUTE_NAME_STATE", Mu = "ATTRIBUTE_NAME_STATE", Af = "AFTER_ATTRIBUTE_NAME_STATE", Sf = "BEFORE_ATTRIBUTE_VALUE_STATE", Lu = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE", $u = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE", ju = "ATTRIBUTE_VALUE_UNQUOTED_STATE", kf = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE", ji = "SELF_CLOSING_START_TAG_STATE", Co = "BOGUS_COMMENT_STATE", y2 = "MARKUP_DECLARATION_OPEN_STATE", E2 = "COMMENT_START_STATE", b2 = "COMMENT_START_DASH_STATE", Hi = "COMMENT_STATE", T2 = "COMMENT_LESS_THAN_SIGN_STATE", _2 = "COMMENT_LESS_THAN_SIGN_BANG_STATE", C2 = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE", x2 = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE", Hu = "COMMENT_END_DASH_STATE", Uu = "COMMENT_END_STATE", w2 = "COMMENT_END_BANG_STATE", A2 = "DOCTYPE_STATE", zu = "BEFORE_DOCTYPE_NAME_STATE", qu = "DOCTYPE_NAME_STATE", S2 = "AFTER_DOCTYPE_NAME_STATE", k2 = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE", D2 = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE", Df = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE", Of = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE", Nf = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE", O2 = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE", N2 = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE", I2 = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE", xo = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE", wo = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE", If = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE", ui = "BOGUS_DOCTYPE_STATE", Wu = "CDATA_SECTION_STATE", P2 = "CDATA_SECTION_BRACKET_STATE", R2 = "CDATA_SECTION_END_STATE", fs = "CHARACTER_REFERENCE_STATE", F2 = "NAMED_CHARACTER_REFERENCE_STATE", B2 = "AMBIGUOS_AMPERSAND_STATE", M2 = "NUMERIC_CHARACTER_REFERENCE_STATE", L2 = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE", $2 = "DECIMAL_CHARACTER_REFERENCE_START_STATE", j2 = "HEXADEMICAL_CHARACTER_REFERENCE_STATE", H2 = "DECIMAL_CHARACTER_REFERENCE_STATE", Ao = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
function Ft(e) {
  return e === W.SPACE || e === W.LINE_FEED || e === W.TABULATION || e === W.FORM_FEED;
}
function Xo(e) {
  return e >= W.DIGIT_0 && e <= W.DIGIT_9;
}
function Cr(e) {
  return e >= W.LATIN_CAPITAL_A && e <= W.LATIN_CAPITAL_Z;
}
function Aa(e) {
  return e >= W.LATIN_SMALL_A && e <= W.LATIN_SMALL_Z;
}
function qi(e) {
  return Aa(e) || Cr(e);
}
function Pf(e) {
  return qi(e) || Xo(e);
}
function K_(e) {
  return e >= W.LATIN_CAPITAL_A && e <= W.LATIN_CAPITAL_F;
}
function G_(e) {
  return e >= W.LATIN_SMALL_A && e <= W.LATIN_SMALL_F;
}
function qQ(e) {
  return Xo(e) || K_(e) || G_(e);
}
function _c(e) {
  return e + 32;
}
function Ht(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(e >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | e & 1023));
}
function Ui(e) {
  return String.fromCharCode(_c(e));
}
function U2(e, t) {
  const n = Na[++e];
  let r = ++e, i = r + n - 1;
  for (; r <= i; ) {
    const a = r + i >>> 1, s = Na[a];
    if (s < t)
      r = a + 1;
    else if (s > t)
      i = a - 1;
    else
      return Na[a + n];
  }
  return -1;
}
let yr = class kn {
  constructor() {
    this.preprocessor = new HQ(), this.tokenQueue = [], this.allowCDATA = !1, this.state = at, this.returnState = "", this.charRefCode = -1, this.tempBuff = [], this.lastStartTagName = "", this.consumedAfterSnapshot = -1, this.active = !1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = null;
  }
  //Errors
  _err() {
  }
  _errOnNextCodePoint(t) {
    this._consume(), this._err(t), this._unconsume();
  }
  //API
  getNextToken() {
    for (; !this.tokenQueue.length && this.active; ) {
      this.consumedAfterSnapshot = 0;
      const t = this._consume();
      this._ensureHibernation() || this[this.state](t);
    }
    return this.tokenQueue.shift();
  }
  write(t, n) {
    this.active = !0, this.preprocessor.write(t, n);
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t);
  }
  //Hibernation
  _ensureHibernation() {
    if (this.preprocessor.endOfChunkHit) {
      for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
        this.preprocessor.retreat();
      return this.active = !1, this.tokenQueue.push({ type: kn.HIBERNATION_TOKEN }), !0;
    }
    return !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume() {
    this.consumedAfterSnapshot--, this.preprocessor.retreat();
  }
  _reconsumeInState(t) {
    this.state = t, this._unconsume();
  }
  _consumeSequenceIfMatch(t, n, r) {
    let i = 0, a = !0;
    const s = t.length;
    let o = 0, l = n, u;
    for (; o < s; o++) {
      if (o > 0 && (l = this._consume(), i++), l === W.EOF) {
        a = !1;
        break;
      }
      if (u = t[o], l !== u && (r || l !== _c(u))) {
        a = !1;
        break;
      }
    }
    if (!a)
      for (; i--; )
        this._unconsume();
    return a;
  }
  //Temp buffer
  _isTempBufferEqualToScriptString() {
    if (this.tempBuff.length !== ba.SCRIPT_STRING.length)
      return !1;
    for (let t = 0; t < this.tempBuff.length; t++)
      if (this.tempBuff[t] !== ba.SCRIPT_STRING[t])
        return !1;
    return !0;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: kn.START_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: []
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: kn.END_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      attrs: []
    };
  }
  _createCommentToken() {
    this.currentToken = {
      type: kn.COMMENT_TOKEN,
      data: ""
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: kn.DOCTYPE_TOKEN,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null
    };
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {
      type: t,
      chars: n
    };
  }
  _createEOFToken() {
    this.currentToken = { type: kn.EOF_TOKEN };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    };
  }
  _leaveAttrName(t) {
    kn.getTokenAttr(this.currentToken, this.currentAttr.name) === null ? this.currentToken.attrs.push(this.currentAttr) : this._err(he.duplicateAttribute), this.state = t;
  }
  _leaveAttrValue(t) {
    this.state = t;
  }
  //Token emission
  _emitCurrentToken() {
    this._emitCurrentCharacterToken();
    const t = this.currentToken;
    this.currentToken = null, t.type === kn.START_TAG_TOKEN ? this.lastStartTagName = t.tagName : t.type === kn.END_TAG_TOKEN && (t.attrs.length > 0 && this._err(he.endTagWithAttributes), t.selfClosing && this._err(he.endTagWithTrailingSolidus)), this.tokenQueue.push(t);
  }
  _emitCurrentCharacterToken() {
    this.currentCharacterToken && (this.tokenQueue.push(this.currentCharacterToken), this.currentCharacterToken = null);
  }
  _emitEOFToken() {
    this._createEOFToken(), this._emitCurrentToken();
  }
  //Characters emission
  //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, n) {
    this.currentCharacterToken && this.currentCharacterToken.type !== t && this._emitCurrentCharacterToken(), this.currentCharacterToken ? this.currentCharacterToken.chars += n : this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    let n = kn.CHARACTER_TOKEN;
    Ft(t) ? n = kn.WHITESPACE_CHARACTER_TOKEN : t === W.NULL && (n = kn.NULL_CHARACTER_TOKEN), this._appendCharToCurrentCharacterToken(n, Ht(t));
  }
  _emitSeveralCodePoints(t) {
    for (let n = 0; n < t.length; n++)
      this._emitCodePoint(t[n]);
  }
  //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
  //So we can avoid additional checks here.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(kn.CHARACTER_TOKEN, t);
  }
  // Character reference helpers
  _matchNamedCharacterReference(t) {
    let n = null, r = 1, i = U2(0, t);
    for (this.tempBuff.push(t); i > -1; ) {
      const a = Na[i], s = a < zQ;
      s && a & z_ && (n = a & q_ ? [Na[++i], Na[++i]] : [Na[++i]], r = 0);
      const l = this._consume();
      if (this.tempBuff.push(l), r++, l === W.EOF)
        break;
      s ? i = a & W_ ? U2(i, l) : -1 : i = l === a ? ++i : -1;
    }
    for (; r--; )
      this.tempBuff.pop(), this._unconsume();
    return n;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === Lu || this.returnState === $u || this.returnState === ju;
  }
  _isCharacterReferenceAttributeQuirk(t) {
    if (!t && this._isCharacterReferenceInAttribute()) {
      const n = this._consume();
      return this._unconsume(), n === W.EQUALS_SIGN || Pf(n);
    }
    return !1;
  }
  _flushCodePointsConsumedAsCharacterReference() {
    if (this._isCharacterReferenceInAttribute())
      for (let t = 0; t < this.tempBuff.length; t++)
        this.currentAttr.value += Ht(this.tempBuff[t]);
    else
      this._emitSeveralCodePoints(this.tempBuff);
    this.tempBuff = [];
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  [at](t) {
    this.preprocessor.dropParsedChunk(), t === W.LESS_THAN_SIGN ? this.state = X5 : t === W.AMPERSAND ? (this.returnState = at, this.state = fs) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this._emitCodePoint(t)) : t === W.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  //  RCDATA state
  //------------------------------------------------------------------
  [gs](t) {
    this.preprocessor.dropParsedChunk(), t === W.AMPERSAND ? (this.returnState = gs, this.state = fs) : t === W.LESS_THAN_SIGN ? this.state = e2 : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this._emitChars(Dt.REPLACEMENT_CHARACTER)) : t === W.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  [Lo](t) {
    this.preprocessor.dropParsedChunk(), t === W.LESS_THAN_SIGN ? this.state = r2 : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this._emitChars(Dt.REPLACEMENT_CHARACTER)) : t === W.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // Script data state
  //------------------------------------------------------------------
  [gi](t) {
    this.preprocessor.dropParsedChunk(), t === W.LESS_THAN_SIGN ? this.state = s2 : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this._emitChars(Dt.REPLACEMENT_CHARACTER)) : t === W.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  [V_](t) {
    this.preprocessor.dropParsedChunk(), t === W.NULL ? (this._err(he.unexpectedNullCharacter), this._emitChars(Dt.REPLACEMENT_CHARACTER)) : t === W.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // Tag open state
  //------------------------------------------------------------------
  [X5](t) {
    t === W.EXCLAMATION_MARK ? this.state = y2 : t === W.SOLIDUS ? this.state = J5 : qi(t) ? (this._createStartTagToken(), this._reconsumeInState(xf)) : t === W.QUESTION_MARK ? (this._err(he.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(), this._reconsumeInState(Co)) : t === W.EOF ? (this._err(he.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken()) : (this._err(he.invalidFirstCharacterOfTagName), this._emitChars("<"), this._reconsumeInState(at));
  }
  // End tag open state
  //------------------------------------------------------------------
  [J5](t) {
    qi(t) ? (this._createEndTagToken(), this._reconsumeInState(xf)) : t === W.GREATER_THAN_SIGN ? (this._err(he.missingEndTagName), this.state = at) : t === W.EOF ? (this._err(he.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken()) : (this._err(he.invalidFirstCharacterOfTagName), this._createCommentToken(), this._reconsumeInState(Co));
  }
  // Tag name state
  //------------------------------------------------------------------
  [xf](t) {
    Ft(t) ? this.state = Lr : t === W.SOLIDUS ? this.state = ji : t === W.GREATER_THAN_SIGN ? (this.state = at, this._emitCurrentToken()) : Cr(t) ? this.currentToken.tagName += Ui(t) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentToken.tagName += Dt.REPLACEMENT_CHARACTER) : t === W.EOF ? (this._err(he.eofInTag), this._emitEOFToken()) : this.currentToken.tagName += Ht(t);
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  [e2](t) {
    t === W.SOLIDUS ? (this.tempBuff = [], this.state = t2) : (this._emitChars("<"), this._reconsumeInState(gs));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  [t2](t) {
    qi(t) ? (this._createEndTagToken(), this._reconsumeInState(n2)) : (this._emitChars("</"), this._reconsumeInState(gs));
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  [n2](t) {
    if (Cr(t))
      this.currentToken.tagName += Ui(t), this.tempBuff.push(t);
    else if (Aa(t))
      this.currentToken.tagName += Ht(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Ft(t)) {
          this.state = Lr;
          return;
        }
        if (t === W.SOLIDUS) {
          this.state = ji;
          return;
        }
        if (t === W.GREATER_THAN_SIGN) {
          this.state = at, this._emitCurrentToken();
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(gs);
    }
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  [r2](t) {
    t === W.SOLIDUS ? (this.tempBuff = [], this.state = i2) : (this._emitChars("<"), this._reconsumeInState(Lo));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  [i2](t) {
    qi(t) ? (this._createEndTagToken(), this._reconsumeInState(a2)) : (this._emitChars("</"), this._reconsumeInState(Lo));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  [a2](t) {
    if (Cr(t))
      this.currentToken.tagName += Ui(t), this.tempBuff.push(t);
    else if (Aa(t))
      this.currentToken.tagName += Ht(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Ft(t)) {
          this.state = Lr;
          return;
        }
        if (t === W.SOLIDUS) {
          this.state = ji;
          return;
        }
        if (t === W.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = at;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Lo);
    }
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  [s2](t) {
    t === W.SOLIDUS ? (this.tempBuff = [], this.state = o2) : t === W.EXCLAMATION_MARK ? (this.state = u2, this._emitChars("<!")) : (this._emitChars("<"), this._reconsumeInState(gi));
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  [o2](t) {
    qi(t) ? (this._createEndTagToken(), this._reconsumeInState(l2)) : (this._emitChars("</"), this._reconsumeInState(gi));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  [l2](t) {
    if (Cr(t))
      this.currentToken.tagName += Ui(t), this.tempBuff.push(t);
    else if (Aa(t))
      this.currentToken.tagName += Ht(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Ft(t)) {
          this.state = Lr;
          return;
        } else if (t === W.SOLIDUS) {
          this.state = ji;
          return;
        } else if (t === W.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = at;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(gi);
    }
  }
  // Script data escape start state
  //------------------------------------------------------------------
  [u2](t) {
    t === W.HYPHEN_MINUS ? (this.state = c2, this._emitChars("-")) : this._reconsumeInState(gi);
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  [c2](t) {
    t === W.HYPHEN_MINUS ? (this.state = wf, this._emitChars("-")) : this._reconsumeInState(gi);
  }
  // Script data escaped state
  //------------------------------------------------------------------
  [Tr](t) {
    t === W.HYPHEN_MINUS ? (this.state = d2, this._emitChars("-")) : t === W.LESS_THAN_SIGN ? this.state = Fu : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this._emitChars(Dt.REPLACEMENT_CHARACTER)) : t === W.EOF ? (this._err(he.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  [d2](t) {
    t === W.HYPHEN_MINUS ? (this.state = wf, this._emitChars("-")) : t === W.LESS_THAN_SIGN ? this.state = Fu : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.state = Tr, this._emitChars(Dt.REPLACEMENT_CHARACTER)) : t === W.EOF ? (this._err(he.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = Tr, this._emitCodePoint(t));
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  [wf](t) {
    t === W.HYPHEN_MINUS ? this._emitChars("-") : t === W.LESS_THAN_SIGN ? this.state = Fu : t === W.GREATER_THAN_SIGN ? (this.state = gi, this._emitChars(">")) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.state = Tr, this._emitChars(Dt.REPLACEMENT_CHARACTER)) : t === W.EOF ? (this._err(he.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = Tr, this._emitCodePoint(t));
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  [Fu](t) {
    t === W.SOLIDUS ? (this.tempBuff = [], this.state = f2) : qi(t) ? (this.tempBuff = [], this._emitChars("<"), this._reconsumeInState(p2)) : (this._emitChars("<"), this._reconsumeInState(Tr));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  [f2](t) {
    qi(t) ? (this._createEndTagToken(), this._reconsumeInState(h2)) : (this._emitChars("</"), this._reconsumeInState(Tr));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  [h2](t) {
    if (Cr(t))
      this.currentToken.tagName += Ui(t), this.tempBuff.push(t);
    else if (Aa(t))
      this.currentToken.tagName += Ht(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Ft(t)) {
          this.state = Lr;
          return;
        }
        if (t === W.SOLIDUS) {
          this.state = ji;
          return;
        }
        if (t === W.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = at;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Tr);
    }
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  [p2](t) {
    Ft(t) || t === W.SOLIDUS || t === W.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? li : Tr, this._emitCodePoint(t)) : Cr(t) ? (this.tempBuff.push(_c(t)), this._emitCodePoint(t)) : Aa(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(Tr);
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  [li](t) {
    t === W.HYPHEN_MINUS ? (this.state = m2, this._emitChars("-")) : t === W.LESS_THAN_SIGN ? (this.state = Bu, this._emitChars("<")) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this._emitChars(Dt.REPLACEMENT_CHARACTER)) : t === W.EOF ? (this._err(he.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  [m2](t) {
    t === W.HYPHEN_MINUS ? (this.state = g2, this._emitChars("-")) : t === W.LESS_THAN_SIGN ? (this.state = Bu, this._emitChars("<")) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.state = li, this._emitChars(Dt.REPLACEMENT_CHARACTER)) : t === W.EOF ? (this._err(he.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = li, this._emitCodePoint(t));
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  [g2](t) {
    t === W.HYPHEN_MINUS ? this._emitChars("-") : t === W.LESS_THAN_SIGN ? (this.state = Bu, this._emitChars("<")) : t === W.GREATER_THAN_SIGN ? (this.state = gi, this._emitChars(">")) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.state = li, this._emitChars(Dt.REPLACEMENT_CHARACTER)) : t === W.EOF ? (this._err(he.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = li, this._emitCodePoint(t));
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  [Bu](t) {
    t === W.SOLIDUS ? (this.tempBuff = [], this.state = v2, this._emitChars("/")) : this._reconsumeInState(li);
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  [v2](t) {
    Ft(t) || t === W.SOLIDUS || t === W.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? Tr : li, this._emitCodePoint(t)) : Cr(t) ? (this.tempBuff.push(_c(t)), this._emitCodePoint(t)) : Aa(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(li);
  }
  // Before attribute name state
  //------------------------------------------------------------------
  [Lr](t) {
    Ft(t) || (t === W.SOLIDUS || t === W.GREATER_THAN_SIGN || t === W.EOF ? this._reconsumeInState(Af) : t === W.EQUALS_SIGN ? (this._err(he.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = Mu) : (this._createAttr(""), this._reconsumeInState(Mu)));
  }
  // Attribute name state
  //------------------------------------------------------------------
  [Mu](t) {
    Ft(t) || t === W.SOLIDUS || t === W.GREATER_THAN_SIGN || t === W.EOF ? (this._leaveAttrName(Af), this._unconsume()) : t === W.EQUALS_SIGN ? this._leaveAttrName(Sf) : Cr(t) ? this.currentAttr.name += Ui(t) : t === W.QUOTATION_MARK || t === W.APOSTROPHE || t === W.LESS_THAN_SIGN ? (this._err(he.unexpectedCharacterInAttributeName), this.currentAttr.name += Ht(t)) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentAttr.name += Dt.REPLACEMENT_CHARACTER) : this.currentAttr.name += Ht(t);
  }
  // After attribute name state
  //------------------------------------------------------------------
  [Af](t) {
    Ft(t) || (t === W.SOLIDUS ? this.state = ji : t === W.EQUALS_SIGN ? this.state = Sf : t === W.GREATER_THAN_SIGN ? (this.state = at, this._emitCurrentToken()) : t === W.EOF ? (this._err(he.eofInTag), this._emitEOFToken()) : (this._createAttr(""), this._reconsumeInState(Mu)));
  }
  // Before attribute value state
  //------------------------------------------------------------------
  [Sf](t) {
    Ft(t) || (t === W.QUOTATION_MARK ? this.state = Lu : t === W.APOSTROPHE ? this.state = $u : t === W.GREATER_THAN_SIGN ? (this._err(he.missingAttributeValue), this.state = at, this._emitCurrentToken()) : this._reconsumeInState(ju));
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  [Lu](t) {
    t === W.QUOTATION_MARK ? this.state = kf : t === W.AMPERSAND ? (this.returnState = Lu, this.state = fs) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentAttr.value += Dt.REPLACEMENT_CHARACTER) : t === W.EOF ? (this._err(he.eofInTag), this._emitEOFToken()) : this.currentAttr.value += Ht(t);
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  [$u](t) {
    t === W.APOSTROPHE ? this.state = kf : t === W.AMPERSAND ? (this.returnState = $u, this.state = fs) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentAttr.value += Dt.REPLACEMENT_CHARACTER) : t === W.EOF ? (this._err(he.eofInTag), this._emitEOFToken()) : this.currentAttr.value += Ht(t);
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  [ju](t) {
    Ft(t) ? this._leaveAttrValue(Lr) : t === W.AMPERSAND ? (this.returnState = ju, this.state = fs) : t === W.GREATER_THAN_SIGN ? (this._leaveAttrValue(at), this._emitCurrentToken()) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentAttr.value += Dt.REPLACEMENT_CHARACTER) : t === W.QUOTATION_MARK || t === W.APOSTROPHE || t === W.LESS_THAN_SIGN || t === W.EQUALS_SIGN || t === W.GRAVE_ACCENT ? (this._err(he.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += Ht(t)) : t === W.EOF ? (this._err(he.eofInTag), this._emitEOFToken()) : this.currentAttr.value += Ht(t);
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  [kf](t) {
    Ft(t) ? this._leaveAttrValue(Lr) : t === W.SOLIDUS ? this._leaveAttrValue(ji) : t === W.GREATER_THAN_SIGN ? (this._leaveAttrValue(at), this._emitCurrentToken()) : t === W.EOF ? (this._err(he.eofInTag), this._emitEOFToken()) : (this._err(he.missingWhitespaceBetweenAttributes), this._reconsumeInState(Lr));
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  [ji](t) {
    t === W.GREATER_THAN_SIGN ? (this.currentToken.selfClosing = !0, this.state = at, this._emitCurrentToken()) : t === W.EOF ? (this._err(he.eofInTag), this._emitEOFToken()) : (this._err(he.unexpectedSolidusInTag), this._reconsumeInState(Lr));
  }
  // Bogus comment state
  //------------------------------------------------------------------
  [Co](t) {
    t === W.GREATER_THAN_SIGN ? (this.state = at, this._emitCurrentToken()) : t === W.EOF ? (this._emitCurrentToken(), this._emitEOFToken()) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentToken.data += Dt.REPLACEMENT_CHARACTER) : this.currentToken.data += Ht(t);
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  [y2](t) {
    this._consumeSequenceIfMatch(ba.DASH_DASH_STRING, t, !0) ? (this._createCommentToken(), this.state = E2) : this._consumeSequenceIfMatch(ba.DOCTYPE_STRING, t, !1) ? this.state = A2 : this._consumeSequenceIfMatch(ba.CDATA_START_STRING, t, !0) ? this.allowCDATA ? this.state = Wu : (this._err(he.cdataInHtmlContent), this._createCommentToken(), this.currentToken.data = "[CDATA[", this.state = Co) : this._ensureHibernation() || (this._err(he.incorrectlyOpenedComment), this._createCommentToken(), this._reconsumeInState(Co));
  }
  // Comment start state
  //------------------------------------------------------------------
  [E2](t) {
    t === W.HYPHEN_MINUS ? this.state = b2 : t === W.GREATER_THAN_SIGN ? (this._err(he.abruptClosingOfEmptyComment), this.state = at, this._emitCurrentToken()) : this._reconsumeInState(Hi);
  }
  // Comment start dash state
  //------------------------------------------------------------------
  [b2](t) {
    t === W.HYPHEN_MINUS ? this.state = Uu : t === W.GREATER_THAN_SIGN ? (this._err(he.abruptClosingOfEmptyComment), this.state = at, this._emitCurrentToken()) : t === W.EOF ? (this._err(he.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Hi));
  }
  // Comment state
  //------------------------------------------------------------------
  [Hi](t) {
    t === W.HYPHEN_MINUS ? this.state = Hu : t === W.LESS_THAN_SIGN ? (this.currentToken.data += "<", this.state = T2) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentToken.data += Dt.REPLACEMENT_CHARACTER) : t === W.EOF ? (this._err(he.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.data += Ht(t);
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  [T2](t) {
    t === W.EXCLAMATION_MARK ? (this.currentToken.data += "!", this.state = _2) : t === W.LESS_THAN_SIGN ? this.currentToken.data += "!" : this._reconsumeInState(Hi);
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  [_2](t) {
    t === W.HYPHEN_MINUS ? this.state = C2 : this._reconsumeInState(Hi);
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  [C2](t) {
    t === W.HYPHEN_MINUS ? this.state = x2 : this._reconsumeInState(Hu);
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  [x2](t) {
    t !== W.GREATER_THAN_SIGN && t !== W.EOF && this._err(he.nestedComment), this._reconsumeInState(Uu);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  [Hu](t) {
    t === W.HYPHEN_MINUS ? this.state = Uu : t === W.EOF ? (this._err(he.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Hi));
  }
  // Comment end state
  //------------------------------------------------------------------
  [Uu](t) {
    t === W.GREATER_THAN_SIGN ? (this.state = at, this._emitCurrentToken()) : t === W.EXCLAMATION_MARK ? this.state = w2 : t === W.HYPHEN_MINUS ? this.currentToken.data += "-" : t === W.EOF ? (this._err(he.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--", this._reconsumeInState(Hi));
  }
  // Comment end bang state
  //------------------------------------------------------------------
  [w2](t) {
    t === W.HYPHEN_MINUS ? (this.currentToken.data += "--!", this.state = Hu) : t === W.GREATER_THAN_SIGN ? (this._err(he.incorrectlyClosedComment), this.state = at, this._emitCurrentToken()) : t === W.EOF ? (this._err(he.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--!", this._reconsumeInState(Hi));
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  [A2](t) {
    Ft(t) ? this.state = zu : t === W.GREATER_THAN_SIGN ? this._reconsumeInState(zu) : t === W.EOF ? (this._err(he.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(he.missingWhitespaceBeforeDoctypeName), this._reconsumeInState(zu));
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  [zu](t) {
    Ft(t) || (Cr(t) ? (this._createDoctypeToken(Ui(t)), this.state = qu) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this._createDoctypeToken(Dt.REPLACEMENT_CHARACTER), this.state = qu) : t === W.GREATER_THAN_SIGN ? (this._err(he.missingDoctypeName), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = at) : t === W.EOF ? (this._err(he.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._createDoctypeToken(Ht(t)), this.state = qu));
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  [qu](t) {
    Ft(t) ? this.state = S2 : t === W.GREATER_THAN_SIGN ? (this.state = at, this._emitCurrentToken()) : Cr(t) ? this.currentToken.name += Ui(t) : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentToken.name += Dt.REPLACEMENT_CHARACTER) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.name += Ht(t);
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  [S2](t) {
    Ft(t) || (t === W.GREATER_THAN_SIGN ? (this.state = at, this._emitCurrentToken()) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this._consumeSequenceIfMatch(ba.PUBLIC_STRING, t, !1) ? this.state = k2 : this._consumeSequenceIfMatch(ba.SYSTEM_STRING, t, !1) ? this.state = N2 : this._ensureHibernation() || (this._err(he.invalidCharacterSequenceAfterDoctypeName), this.currentToken.forceQuirks = !0, this._reconsumeInState(ui)));
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  [k2](t) {
    Ft(t) ? this.state = D2 : t === W.QUOTATION_MARK ? (this._err(he.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Df) : t === W.APOSTROPHE ? (this._err(he.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Of) : t === W.GREATER_THAN_SIGN ? (this._err(he.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = at, this._emitCurrentToken()) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(he.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ui));
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  [D2](t) {
    Ft(t) || (t === W.QUOTATION_MARK ? (this.currentToken.publicId = "", this.state = Df) : t === W.APOSTROPHE ? (this.currentToken.publicId = "", this.state = Of) : t === W.GREATER_THAN_SIGN ? (this._err(he.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = at, this._emitCurrentToken()) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(he.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ui)));
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  [Df](t) {
    t === W.QUOTATION_MARK ? this.state = Nf : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentToken.publicId += Dt.REPLACEMENT_CHARACTER) : t === W.GREATER_THAN_SIGN ? (this._err(he.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = at) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += Ht(t);
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  [Of](t) {
    t === W.APOSTROPHE ? this.state = Nf : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentToken.publicId += Dt.REPLACEMENT_CHARACTER) : t === W.GREATER_THAN_SIGN ? (this._err(he.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = at) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += Ht(t);
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  [Nf](t) {
    Ft(t) ? this.state = O2 : t === W.GREATER_THAN_SIGN ? (this.state = at, this._emitCurrentToken()) : t === W.QUOTATION_MARK ? (this._err(he.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = xo) : t === W.APOSTROPHE ? (this._err(he.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = wo) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(he.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ui));
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  [O2](t) {
    Ft(t) || (t === W.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = at) : t === W.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = xo) : t === W.APOSTROPHE ? (this.currentToken.systemId = "", this.state = wo) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(he.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ui)));
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  [N2](t) {
    Ft(t) ? this.state = I2 : t === W.QUOTATION_MARK ? (this._err(he.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = xo) : t === W.APOSTROPHE ? (this._err(he.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = wo) : t === W.GREATER_THAN_SIGN ? (this._err(he.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = at, this._emitCurrentToken()) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(he.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ui));
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  [I2](t) {
    Ft(t) || (t === W.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = xo) : t === W.APOSTROPHE ? (this.currentToken.systemId = "", this.state = wo) : t === W.GREATER_THAN_SIGN ? (this._err(he.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = at, this._emitCurrentToken()) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(he.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(ui)));
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  [xo](t) {
    t === W.QUOTATION_MARK ? this.state = If : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentToken.systemId += Dt.REPLACEMENT_CHARACTER) : t === W.GREATER_THAN_SIGN ? (this._err(he.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = at) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += Ht(t);
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  [wo](t) {
    t === W.APOSTROPHE ? this.state = If : t === W.NULL ? (this._err(he.unexpectedNullCharacter), this.currentToken.systemId += Dt.REPLACEMENT_CHARACTER) : t === W.GREATER_THAN_SIGN ? (this._err(he.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = at) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += Ht(t);
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  [If](t) {
    Ft(t) || (t === W.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = at) : t === W.EOF ? (this._err(he.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(he.unexpectedCharacterAfterDoctypeSystemIdentifier), this._reconsumeInState(ui)));
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  [ui](t) {
    t === W.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = at) : t === W.NULL ? this._err(he.unexpectedNullCharacter) : t === W.EOF && (this._emitCurrentToken(), this._emitEOFToken());
  }
  // CDATA section state
  //------------------------------------------------------------------
  [Wu](t) {
    t === W.RIGHT_SQUARE_BRACKET ? this.state = P2 : t === W.EOF ? (this._err(he.eofInCdata), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  [P2](t) {
    t === W.RIGHT_SQUARE_BRACKET ? this.state = R2 : (this._emitChars("]"), this._reconsumeInState(Wu));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  [R2](t) {
    t === W.GREATER_THAN_SIGN ? this.state = at : t === W.RIGHT_SQUARE_BRACKET ? this._emitChars("]") : (this._emitChars("]]"), this._reconsumeInState(Wu));
  }
  // Character reference state
  //------------------------------------------------------------------
  [fs](t) {
    this.tempBuff = [W.AMPERSAND], t === W.NUMBER_SIGN ? (this.tempBuff.push(t), this.state = M2) : Pf(t) ? this._reconsumeInState(F2) : (this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Named character reference state
  //------------------------------------------------------------------
  [F2](t) {
    const n = this._matchNamedCharacterReference(t);
    if (this._ensureHibernation())
      this.tempBuff = [W.AMPERSAND];
    else if (n) {
      const r = this.tempBuff[this.tempBuff.length - 1] === W.SEMICOLON;
      this._isCharacterReferenceAttributeQuirk(r) || (r || this._errOnNextCodePoint(he.missingSemicolonAfterCharacterReference), this.tempBuff = n), this._flushCodePointsConsumedAsCharacterReference(), this.state = this.returnState;
    } else
      this._flushCodePointsConsumedAsCharacterReference(), this.state = B2;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  [B2](t) {
    Pf(t) ? this._isCharacterReferenceInAttribute() ? this.currentAttr.value += Ht(t) : this._emitCodePoint(t) : (t === W.SEMICOLON && this._err(he.unknownNamedCharacterReference), this._reconsumeInState(this.returnState));
  }
  // Numeric character reference state
  //------------------------------------------------------------------
  [M2](t) {
    this.charRefCode = 0, t === W.LATIN_SMALL_X || t === W.LATIN_CAPITAL_X ? (this.tempBuff.push(t), this.state = L2) : this._reconsumeInState($2);
  }
  // Hexademical character reference start state
  //------------------------------------------------------------------
  [L2](t) {
    qQ(t) ? this._reconsumeInState(j2) : (this._err(he.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Decimal character reference start state
  //------------------------------------------------------------------
  [$2](t) {
    Xo(t) ? this._reconsumeInState(H2) : (this._err(he.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Hexademical character reference state
  //------------------------------------------------------------------
  [j2](t) {
    K_(t) ? this.charRefCode = this.charRefCode * 16 + t - 55 : G_(t) ? this.charRefCode = this.charRefCode * 16 + t - 87 : Xo(t) ? this.charRefCode = this.charRefCode * 16 + t - 48 : t === W.SEMICOLON ? this.state = Ao : (this._err(he.missingSemicolonAfterCharacterReference), this._reconsumeInState(Ao));
  }
  // Decimal character reference state
  //------------------------------------------------------------------
  [H2](t) {
    Xo(t) ? this.charRefCode = this.charRefCode * 10 + t - 48 : t === W.SEMICOLON ? this.state = Ao : (this._err(he.missingSemicolonAfterCharacterReference), this._reconsumeInState(Ao));
  }
  // Numeric character reference end state
  //------------------------------------------------------------------
  [Ao]() {
    if (this.charRefCode === W.NULL)
      this._err(he.nullCharacterReference), this.charRefCode = W.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(he.characterReferenceOutsideUnicodeRange), this.charRefCode = W.REPLACEMENT_CHARACTER;
    else if (Dt.isSurrogate(this.charRefCode))
      this._err(he.surrogateCharacterReference), this.charRefCode = W.REPLACEMENT_CHARACTER;
    else if (Dt.isUndefinedCodePoint(this.charRefCode))
      this._err(he.noncharacterCharacterReference);
    else if (Dt.isControlCodePoint(this.charRefCode) || this.charRefCode === W.CARRIAGE_RETURN) {
      this._err(he.controlCharacterReference);
      const t = UQ[this.charRefCode];
      t && (this.charRefCode = t);
    }
    this.tempBuff = [this.charRefCode], this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState);
  }
};
yr.CHARACTER_TOKEN = "CHARACTER_TOKEN";
yr.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN";
yr.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN";
yr.START_TAG_TOKEN = "START_TAG_TOKEN";
yr.END_TAG_TOKEN = "END_TAG_TOKEN";
yr.COMMENT_TOKEN = "COMMENT_TOKEN";
yr.DOCTYPE_TOKEN = "DOCTYPE_TOKEN";
yr.EOF_TOKEN = "EOF_TOKEN";
yr.HIBERNATION_TOKEN = "HIBERNATION_TOKEN";
yr.MODE = {
  DATA: at,
  RCDATA: gs,
  RAWTEXT: Lo,
  SCRIPT_DATA: gi,
  PLAINTEXT: V_
};
yr.getTokenAttr = function(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--)
    if (e.attrs[n].name === t)
      return e.attrs[n].value;
  return null;
};
var O1 = yr, Pr = {};
const Rf = Pr.NAMESPACES = {
  HTML: "http://www.w3.org/1999/xhtml",
  MATHML: "http://www.w3.org/1998/Math/MathML",
  SVG: "http://www.w3.org/2000/svg",
  XLINK: "http://www.w3.org/1999/xlink",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
};
Pr.ATTRS = {
  TYPE: "type",
  ACTION: "action",
  ENCODING: "encoding",
  PROMPT: "prompt",
  NAME: "name",
  COLOR: "color",
  FACE: "face",
  SIZE: "size"
};
Pr.DOCUMENT_MODE = {
  NO_QUIRKS: "no-quirks",
  QUIRKS: "quirks",
  LIMITED_QUIRKS: "limited-quirks"
};
const _e = Pr.TAG_NAMES = {
  A: "a",
  ADDRESS: "address",
  ANNOTATION_XML: "annotation-xml",
  APPLET: "applet",
  AREA: "area",
  ARTICLE: "article",
  ASIDE: "aside",
  B: "b",
  BASE: "base",
  BASEFONT: "basefont",
  BGSOUND: "bgsound",
  BIG: "big",
  BLOCKQUOTE: "blockquote",
  BODY: "body",
  BR: "br",
  BUTTON: "button",
  CAPTION: "caption",
  CENTER: "center",
  CODE: "code",
  COL: "col",
  COLGROUP: "colgroup",
  DD: "dd",
  DESC: "desc",
  DETAILS: "details",
  DIALOG: "dialog",
  DIR: "dir",
  DIV: "div",
  DL: "dl",
  DT: "dt",
  EM: "em",
  EMBED: "embed",
  FIELDSET: "fieldset",
  FIGCAPTION: "figcaption",
  FIGURE: "figure",
  FONT: "font",
  FOOTER: "footer",
  FOREIGN_OBJECT: "foreignObject",
  FORM: "form",
  FRAME: "frame",
  FRAMESET: "frameset",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  HEAD: "head",
  HEADER: "header",
  HGROUP: "hgroup",
  HR: "hr",
  HTML: "html",
  I: "i",
  IMG: "img",
  IMAGE: "image",
  INPUT: "input",
  IFRAME: "iframe",
  KEYGEN: "keygen",
  LABEL: "label",
  LI: "li",
  LINK: "link",
  LISTING: "listing",
  MAIN: "main",
  MALIGNMARK: "malignmark",
  MARQUEE: "marquee",
  MATH: "math",
  MENU: "menu",
  META: "meta",
  MGLYPH: "mglyph",
  MI: "mi",
  MO: "mo",
  MN: "mn",
  MS: "ms",
  MTEXT: "mtext",
  NAV: "nav",
  NOBR: "nobr",
  NOFRAMES: "noframes",
  NOEMBED: "noembed",
  NOSCRIPT: "noscript",
  OBJECT: "object",
  OL: "ol",
  OPTGROUP: "optgroup",
  OPTION: "option",
  P: "p",
  PARAM: "param",
  PLAINTEXT: "plaintext",
  PRE: "pre",
  RB: "rb",
  RP: "rp",
  RT: "rt",
  RTC: "rtc",
  RUBY: "ruby",
  S: "s",
  SCRIPT: "script",
  SECTION: "section",
  SELECT: "select",
  SOURCE: "source",
  SMALL: "small",
  SPAN: "span",
  STRIKE: "strike",
  STRONG: "strong",
  STYLE: "style",
  SUB: "sub",
  SUMMARY: "summary",
  SUP: "sup",
  TABLE: "table",
  TBODY: "tbody",
  TEMPLATE: "template",
  TEXTAREA: "textarea",
  TFOOT: "tfoot",
  TD: "td",
  TH: "th",
  THEAD: "thead",
  TITLE: "title",
  TR: "tr",
  TRACK: "track",
  TT: "tt",
  U: "u",
  UL: "ul",
  SVG: "svg",
  VAR: "var",
  WBR: "wbr",
  XMP: "xmp"
};
Pr.SPECIAL_ELEMENTS = {
  [Rf.HTML]: {
    [_e.ADDRESS]: !0,
    [_e.APPLET]: !0,
    [_e.AREA]: !0,
    [_e.ARTICLE]: !0,
    [_e.ASIDE]: !0,
    [_e.BASE]: !0,
    [_e.BASEFONT]: !0,
    [_e.BGSOUND]: !0,
    [_e.BLOCKQUOTE]: !0,
    [_e.BODY]: !0,
    [_e.BR]: !0,
    [_e.BUTTON]: !0,
    [_e.CAPTION]: !0,
    [_e.CENTER]: !0,
    [_e.COL]: !0,
    [_e.COLGROUP]: !0,
    [_e.DD]: !0,
    [_e.DETAILS]: !0,
    [_e.DIR]: !0,
    [_e.DIV]: !0,
    [_e.DL]: !0,
    [_e.DT]: !0,
    [_e.EMBED]: !0,
    [_e.FIELDSET]: !0,
    [_e.FIGCAPTION]: !0,
    [_e.FIGURE]: !0,
    [_e.FOOTER]: !0,
    [_e.FORM]: !0,
    [_e.FRAME]: !0,
    [_e.FRAMESET]: !0,
    [_e.H1]: !0,
    [_e.H2]: !0,
    [_e.H3]: !0,
    [_e.H4]: !0,
    [_e.H5]: !0,
    [_e.H6]: !0,
    [_e.HEAD]: !0,
    [_e.HEADER]: !0,
    [_e.HGROUP]: !0,
    [_e.HR]: !0,
    [_e.HTML]: !0,
    [_e.IFRAME]: !0,
    [_e.IMG]: !0,
    [_e.INPUT]: !0,
    [_e.LI]: !0,
    [_e.LINK]: !0,
    [_e.LISTING]: !0,
    [_e.MAIN]: !0,
    [_e.MARQUEE]: !0,
    [_e.MENU]: !0,
    [_e.META]: !0,
    [_e.NAV]: !0,
    [_e.NOEMBED]: !0,
    [_e.NOFRAMES]: !0,
    [_e.NOSCRIPT]: !0,
    [_e.OBJECT]: !0,
    [_e.OL]: !0,
    [_e.P]: !0,
    [_e.PARAM]: !0,
    [_e.PLAINTEXT]: !0,
    [_e.PRE]: !0,
    [_e.SCRIPT]: !0,
    [_e.SECTION]: !0,
    [_e.SELECT]: !0,
    [_e.SOURCE]: !0,
    [_e.STYLE]: !0,
    [_e.SUMMARY]: !0,
    [_e.TABLE]: !0,
    [_e.TBODY]: !0,
    [_e.TD]: !0,
    [_e.TEMPLATE]: !0,
    [_e.TEXTAREA]: !0,
    [_e.TFOOT]: !0,
    [_e.TH]: !0,
    [_e.THEAD]: !0,
    [_e.TITLE]: !0,
    [_e.TR]: !0,
    [_e.TRACK]: !0,
    [_e.UL]: !0,
    [_e.WBR]: !0,
    [_e.XMP]: !0
  },
  [Rf.MATHML]: {
    [_e.MI]: !0,
    [_e.MO]: !0,
    [_e.MN]: !0,
    [_e.MS]: !0,
    [_e.MTEXT]: !0,
    [_e.ANNOTATION_XML]: !0
  },
  [Rf.SVG]: {
    [_e.TITLE]: !0,
    [_e.FOREIGN_OBJECT]: !0,
    [_e.DESC]: !0
  }
};
const Y_ = Pr, we = Y_.TAG_NAMES, Ot = Y_.NAMESPACES;
function z2(e) {
  switch (e.length) {
    case 1:
      return e === we.P;
    case 2:
      return e === we.RB || e === we.RP || e === we.RT || e === we.DD || e === we.DT || e === we.LI;
    case 3:
      return e === we.RTC;
    case 6:
      return e === we.OPTION;
    case 8:
      return e === we.OPTGROUP;
  }
  return !1;
}
function WQ(e) {
  switch (e.length) {
    case 1:
      return e === we.P;
    case 2:
      return e === we.RB || e === we.RP || e === we.RT || e === we.DD || e === we.DT || e === we.LI || e === we.TD || e === we.TH || e === we.TR;
    case 3:
      return e === we.RTC;
    case 5:
      return e === we.TBODY || e === we.TFOOT || e === we.THEAD;
    case 6:
      return e === we.OPTION;
    case 7:
      return e === we.CAPTION;
    case 8:
      return e === we.OPTGROUP || e === we.COLGROUP;
  }
  return !1;
}
function Vu(e, t) {
  switch (e.length) {
    case 2:
      if (e === we.TD || e === we.TH)
        return t === Ot.HTML;
      if (e === we.MI || e === we.MO || e === we.MN || e === we.MS)
        return t === Ot.MATHML;
      break;
    case 4:
      if (e === we.HTML)
        return t === Ot.HTML;
      if (e === we.DESC)
        return t === Ot.SVG;
      break;
    case 5:
      if (e === we.TABLE)
        return t === Ot.HTML;
      if (e === we.MTEXT)
        return t === Ot.MATHML;
      if (e === we.TITLE)
        return t === Ot.SVG;
      break;
    case 6:
      return (e === we.APPLET || e === we.OBJECT) && t === Ot.HTML;
    case 7:
      return (e === we.CAPTION || e === we.MARQUEE) && t === Ot.HTML;
    case 8:
      return e === we.TEMPLATE && t === Ot.HTML;
    case 13:
      return e === we.FOREIGN_OBJECT && t === Ot.SVG;
    case 14:
      return e === we.ANNOTATION_XML && t === Ot.MATHML;
  }
  return !1;
}
let VQ = class {
  constructor(t, n) {
    this.stackTop = -1, this.items = [], this.current = t, this.currentTagName = null, this.currentTmplContent = null, this.tmplCount = 0, this.treeAdapter = n;
  }
  //Index of element
  _indexOf(t) {
    let n = -1;
    for (let r = this.stackTop; r >= 0; r--)
      if (this.items[r] === t) {
        n = r;
        break;
      }
    return n;
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagName === we.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === Ot.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagName = this.current && this.treeAdapter.getTagName(this.current), this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
  }
  //Mutations
  push(t) {
    this.items[++this.stackTop] = t, this._updateCurrentElement(), this._isInTemplate() && this.tmplCount++;
  }
  pop() {
    this.stackTop--, this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this._updateCurrentElement();
  }
  replace(t, n) {
    const r = this._indexOf(t);
    this.items[r] = n, r === this.stackTop && this._updateCurrentElement();
  }
  insertAfter(t, n) {
    const r = this._indexOf(t) + 1;
    this.items.splice(r, 0, n), r === ++this.stackTop && this._updateCurrentElement();
  }
  popUntilTagNamePopped(t) {
    for (; this.stackTop > -1; ) {
      const n = this.currentTagName, r = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), n === t && r === Ot.HTML)
        break;
    }
  }
  popUntilElementPopped(t) {
    for (; this.stackTop > -1; ) {
      const n = this.current;
      if (this.pop(), n === t)
        break;
    }
  }
  popUntilNumberedHeaderPopped() {
    for (; this.stackTop > -1; ) {
      const t = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), t === we.H1 || t === we.H2 || t === we.H3 || t === we.H4 || t === we.H5 || t === we.H6 && n === Ot.HTML)
        break;
    }
  }
  popUntilTableCellPopped() {
    for (; this.stackTop > -1; ) {
      const t = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), t === we.TD || t === we.TH && n === Ot.HTML)
        break;
    }
  }
  popAllUpToHtmlElement() {
    this.stackTop = 0, this._updateCurrentElement();
  }
  clearBackToTableContext() {
    for (; this.currentTagName !== we.TABLE && this.currentTagName !== we.TEMPLATE && this.currentTagName !== we.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Ot.HTML; )
      this.pop();
  }
  clearBackToTableBodyContext() {
    for (; this.currentTagName !== we.TBODY && this.currentTagName !== we.TFOOT && this.currentTagName !== we.THEAD && this.currentTagName !== we.TEMPLATE && this.currentTagName !== we.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Ot.HTML; )
      this.pop();
  }
  clearBackToTableRowContext() {
    for (; this.currentTagName !== we.TR && this.currentTagName !== we.TEMPLATE && this.currentTagName !== we.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Ot.HTML; )
      this.pop();
  }
  remove(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.items[n] === t) {
        this.items.splice(n, 1), this.stackTop--, this._updateCurrentElement();
        break;
      }
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    const t = this.items[1];
    return t && this.treeAdapter.getTagName(t) === we.BODY ? t : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    let n = this._indexOf(t);
    return --n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.currentTagName === we.HTML;
  }
  //Element in scope
  hasInScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === t && i === Ot.HTML)
        return !0;
      if (Vu(r, i))
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]), r = this.treeAdapter.getNamespaceURI(this.items[t]);
      if ((n === we.H1 || n === we.H2 || n === we.H3 || n === we.H4 || n === we.H5 || n === we.H6) && r === Ot.HTML)
        return !0;
      if (Vu(n, r))
        return !1;
    }
    return !0;
  }
  hasInListItemScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === t && i === Ot.HTML)
        return !0;
      if ((r === we.UL || r === we.OL) && i === Ot.HTML || Vu(r, i))
        return !1;
    }
    return !0;
  }
  hasInButtonScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]), i = this.treeAdapter.getNamespaceURI(this.items[n]);
      if (r === t && i === Ot.HTML)
        return !0;
      if (r === we.BUTTON && i === Ot.HTML || Vu(r, i))
        return !1;
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]);
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === Ot.HTML) {
        if (r === t)
          return !0;
        if (r === we.TABLE || r === we.TEMPLATE || r === we.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]);
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === Ot.HTML) {
        if (n === we.TBODY || n === we.THEAD || n === we.TFOOT)
          return !0;
        if (n === we.TABLE || n === we.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(t) {
    for (let n = this.stackTop; n >= 0; n--) {
      const r = this.treeAdapter.getTagName(this.items[n]);
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === Ot.HTML) {
        if (r === t)
          return !0;
        if (r !== we.OPTION && r !== we.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; z2(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; WQ(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; z2(this.currentTagName) && this.currentTagName !== t; )
      this.pop();
  }
};
var KQ = VQ;
const Ku = 3;
let Gm = class Wi {
  constructor(t) {
    this.length = 0, this.entries = [], this.treeAdapter = t, this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t) {
    const n = [];
    if (this.length >= Ku) {
      const r = this.treeAdapter.getAttrList(t).length, i = this.treeAdapter.getTagName(t), a = this.treeAdapter.getNamespaceURI(t);
      for (let s = this.length - 1; s >= 0; s--) {
        const o = this.entries[s];
        if (o.type === Wi.MARKER_ENTRY)
          break;
        const l = o.element, u = this.treeAdapter.getAttrList(l);
        this.treeAdapter.getTagName(l) === i && this.treeAdapter.getNamespaceURI(l) === a && u.length === r && n.push({ idx: s, attrs: u });
      }
    }
    return n.length < Ku ? [] : n;
  }
  _ensureNoahArkCondition(t) {
    const n = this._getNoahArkConditionCandidates(t);
    let r = n.length;
    if (r) {
      const i = this.treeAdapter.getAttrList(t), a = i.length, s = /* @__PURE__ */ Object.create(null);
      for (let o = 0; o < a; o++) {
        const l = i[o];
        s[l.name] = l.value;
      }
      for (let o = 0; o < a; o++)
        for (let l = 0; l < r; l++) {
          const u = n[l].attrs[o];
          if (s[u.name] !== u.value && (n.splice(l, 1), r--), n.length < Ku)
            return;
        }
      for (let o = r - 1; o >= Ku - 1; o--)
        this.entries.splice(n[o].idx, 1), this.length--;
    }
  }
  //Mutations
  insertMarker() {
    this.entries.push({ type: Wi.MARKER_ENTRY }), this.length++;
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.push({
      type: Wi.ELEMENT_ENTRY,
      element: t,
      token: n
    }), this.length++;
  }
  insertElementAfterBookmark(t, n) {
    let r = this.length - 1;
    for (; r >= 0 && this.entries[r] !== this.bookmark; r--)
      ;
    this.entries.splice(r + 1, 0, {
      type: Wi.ELEMENT_ENTRY,
      element: t,
      token: n
    }), this.length++;
  }
  removeEntry(t) {
    for (let n = this.length - 1; n >= 0; n--)
      if (this.entries[n] === t) {
        this.entries.splice(n, 1), this.length--;
        break;
      }
  }
  clearToLastMarker() {
    for (; this.length; ) {
      const t = this.entries.pop();
      if (this.length--, t.type === Wi.MARKER_ENTRY)
        break;
    }
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    for (let n = this.length - 1; n >= 0; n--) {
      const r = this.entries[n];
      if (r.type === Wi.MARKER_ENTRY)
        return null;
      if (this.treeAdapter.getTagName(r.element) === t)
        return r;
    }
    return null;
  }
  getElementEntry(t) {
    for (let n = this.length - 1; n >= 0; n--) {
      const r = this.entries[n];
      if (r.type === Wi.ELEMENT_ENTRY && r.element === t)
        return r;
    }
    return null;
  }
};
Gm.MARKER_ENTRY = "MARKER_ENTRY";
Gm.ELEMENT_ENTRY = "ELEMENT_ENTRY";
var GQ = Gm;
let Z_ = class {
  constructor(t) {
    const n = {}, r = this._getOverriddenMethods(this, n);
    for (const i of Object.keys(r))
      typeof r[i] == "function" && (n[i] = t[i], t[i] = r[i]);
  }
  _getOverriddenMethods() {
    throw new Error("Not implemented");
  }
};
Z_.install = function(e, t, n) {
  e.__mixins || (e.__mixins = []);
  for (let i = 0; i < e.__mixins.length; i++)
    if (e.__mixins[i].constructor === t)
      return e.__mixins[i];
  const r = new t(e, n);
  return e.__mixins.push(r), r;
};
var Fi = Z_;
const YQ = Fi;
let ZQ = class extends YQ {
  constructor(t) {
    super(t), this.preprocessor = t, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.offset = 0, this.col = 0, this.line = 1;
  }
  _getOverriddenMethods(t, n) {
    return {
      advance() {
        const r = this.pos + 1, i = this.html[r];
        return t.isEol && (t.isEol = !1, t.line++, t.lineStartPos = r), (i === `
` || i === "\r" && this.html[r + 1] !== `
`) && (t.isEol = !0), t.col = r - t.lineStartPos + 1, t.offset = t.droppedBufferSize + r, n.advance.call(this);
      },
      retreat() {
        n.retreat.call(this), t.isEol = !1, t.col = this.pos - t.lineStartPos + 1;
      },
      dropParsedChunk() {
        const r = this.pos;
        n.dropParsedChunk.call(this);
        const i = r - this.pos;
        t.lineStartPos -= i, t.droppedBufferSize += i, t.offset = t.droppedBufferSize + this.pos;
      }
    };
  }
};
var Q_ = ZQ;
const q2 = Fi, Ff = O1, QQ = Q_;
let XQ = class extends q2 {
  constructor(t) {
    super(t), this.tokenizer = t, this.posTracker = q2.install(t.preprocessor, QQ), this.currentAttrLocation = null, this.ctLoc = null;
  }
  _getCurrentLocation() {
    return {
      startLine: this.posTracker.line,
      startCol: this.posTracker.col,
      startOffset: this.posTracker.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
  }
  _attachCurrentAttrLocationInfo() {
    this.currentAttrLocation.endLine = this.posTracker.line, this.currentAttrLocation.endCol = this.posTracker.col, this.currentAttrLocation.endOffset = this.posTracker.offset;
    const t = this.tokenizer.currentToken, n = this.tokenizer.currentAttr;
    t.location.attrs || (t.location.attrs = /* @__PURE__ */ Object.create(null)), t.location.attrs[n.name] = this.currentAttrLocation;
  }
  _getOverriddenMethods(t, n) {
    const r = {
      _createStartTagToken() {
        n._createStartTagToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createEndTagToken() {
        n._createEndTagToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createCommentToken() {
        n._createCommentToken.call(this), this.currentToken.location = t.ctLoc;
      },
      _createDoctypeToken(i) {
        n._createDoctypeToken.call(this, i), this.currentToken.location = t.ctLoc;
      },
      _createCharacterToken(i, a) {
        n._createCharacterToken.call(this, i, a), this.currentCharacterToken.location = t.ctLoc;
      },
      _createEOFToken() {
        n._createEOFToken.call(this), this.currentToken.location = t._getCurrentLocation();
      },
      _createAttr(i) {
        n._createAttr.call(this, i), t.currentAttrLocation = t._getCurrentLocation();
      },
      _leaveAttrName(i) {
        n._leaveAttrName.call(this, i), t._attachCurrentAttrLocationInfo();
      },
      _leaveAttrValue(i) {
        n._leaveAttrValue.call(this, i), t._attachCurrentAttrLocationInfo();
      },
      _emitCurrentToken() {
        const i = this.currentToken.location;
        this.currentCharacterToken && (this.currentCharacterToken.location.endLine = i.startLine, this.currentCharacterToken.location.endCol = i.startCol, this.currentCharacterToken.location.endOffset = i.startOffset), this.currentToken.type === Ff.EOF_TOKEN ? (i.endLine = i.startLine, i.endCol = i.startCol, i.endOffset = i.startOffset) : (i.endLine = t.posTracker.line, i.endCol = t.posTracker.col + 1, i.endOffset = t.posTracker.offset + 1), n._emitCurrentToken.call(this);
      },
      _emitCurrentCharacterToken() {
        const i = this.currentCharacterToken && this.currentCharacterToken.location;
        i && i.endOffset === -1 && (i.endLine = t.posTracker.line, i.endCol = t.posTracker.col, i.endOffset = t.posTracker.offset), n._emitCurrentCharacterToken.call(this);
      }
    };
    return Object.keys(Ff.MODE).forEach((i) => {
      const a = Ff.MODE[i];
      r[a] = function(s) {
        t.ctLoc = t._getCurrentLocation(), n[a].call(this, s);
      };
    }), r;
  }
};
var X_ = XQ;
const JQ = Fi;
let eX = class extends JQ {
  constructor(t, n) {
    super(t), this.onItemPop = n.onItemPop;
  }
  _getOverriddenMethods(t, n) {
    return {
      pop() {
        t.onItemPop(this.current), n.pop.call(this);
      },
      popAllUpToHtmlElement() {
        for (let r = this.stackTop; r > 0; r--)
          t.onItemPop(this.items[r]);
        n.popAllUpToHtmlElement.call(this);
      },
      remove(r) {
        t.onItemPop(this.current), n.remove.call(this, r);
      }
    };
  }
};
var tX = eX;
const Bf = Fi, W2 = O1, nX = X_, rX = tX, iX = Pr, Mf = iX.TAG_NAMES;
let aX = class extends Bf {
  constructor(t) {
    super(t), this.parser = t, this.treeAdapter = this.parser.treeAdapter, this.posTracker = null, this.lastStartTagToken = null, this.lastFosterParentingLocation = null, this.currentToken = null;
  }
  _setStartLocation(t) {
    let n = null;
    this.lastStartTagToken && (n = Object.assign({}, this.lastStartTagToken.location), n.startTag = this.lastStartTagToken.location), this.treeAdapter.setNodeSourceCodeLocation(t, n);
  }
  _setEndLocation(t, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && n.location) {
      const i = n.location, a = this.treeAdapter.getTagName(t), s = n.type === W2.END_TAG_TOKEN && a === n.tagName, o = {};
      s ? (o.endTag = Object.assign({}, i), o.endLine = i.endLine, o.endCol = i.endCol, o.endOffset = i.endOffset) : (o.endLine = i.startLine, o.endCol = i.startCol, o.endOffset = i.startOffset), this.treeAdapter.updateNodeSourceCodeLocation(t, o);
    }
  }
  _getOverriddenMethods(t, n) {
    return {
      _bootstrap(r, i) {
        n._bootstrap.call(this, r, i), t.lastStartTagToken = null, t.lastFosterParentingLocation = null, t.currentToken = null;
        const a = Bf.install(this.tokenizer, nX);
        t.posTracker = a.posTracker, Bf.install(this.openElements, rX, {
          onItemPop: function(s) {
            t._setEndLocation(s, t.currentToken);
          }
        });
      },
      _runParsingLoop(r) {
        n._runParsingLoop.call(this, r);
        for (let i = this.openElements.stackTop; i >= 0; i--)
          t._setEndLocation(this.openElements.items[i], t.currentToken);
      },
      //Token processing
      _processTokenInForeignContent(r) {
        t.currentToken = r, n._processTokenInForeignContent.call(this, r);
      },
      _processToken(r) {
        if (t.currentToken = r, n._processToken.call(this, r), r.type === W2.END_TAG_TOKEN && (r.tagName === Mf.HTML || r.tagName === Mf.BODY && this.openElements.hasInScope(Mf.BODY)))
          for (let a = this.openElements.stackTop; a >= 0; a--) {
            const s = this.openElements.items[a];
            if (this.treeAdapter.getTagName(s) === r.tagName) {
              t._setEndLocation(s, r);
              break;
            }
          }
      },
      //Doctype
      _setDocumentType(r) {
        n._setDocumentType.call(this, r);
        const i = this.treeAdapter.getChildNodes(this.document), a = i.length;
        for (let s = 0; s < a; s++) {
          const o = i[s];
          if (this.treeAdapter.isDocumentTypeNode(o)) {
            this.treeAdapter.setNodeSourceCodeLocation(o, r.location);
            break;
          }
        }
      },
      //Elements
      _attachElementToTree(r) {
        t._setStartLocation(r), t.lastStartTagToken = null, n._attachElementToTree.call(this, r);
      },
      _appendElement(r, i) {
        t.lastStartTagToken = r, n._appendElement.call(this, r, i);
      },
      _insertElement(r, i) {
        t.lastStartTagToken = r, n._insertElement.call(this, r, i);
      },
      _insertTemplate(r) {
        t.lastStartTagToken = r, n._insertTemplate.call(this, r);
        const i = this.treeAdapter.getTemplateContent(this.openElements.current);
        this.treeAdapter.setNodeSourceCodeLocation(i, null);
      },
      _insertFakeRootElement() {
        n._insertFakeRootElement.call(this), this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
      },
      //Comments
      _appendCommentNode(r, i) {
        n._appendCommentNode.call(this, r, i);
        const a = this.treeAdapter.getChildNodes(i), s = a[a.length - 1];
        this.treeAdapter.setNodeSourceCodeLocation(s, r.location);
      },
      //Text
      _findFosterParentingLocation() {
        return t.lastFosterParentingLocation = n._findFosterParentingLocation.call(this), t.lastFosterParentingLocation;
      },
      _insertCharacters(r) {
        n._insertCharacters.call(this, r);
        const i = this._shouldFosterParentOnInsertion(), a = i && t.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current, s = this.treeAdapter.getChildNodes(a), o = i && t.lastFosterParentingLocation.beforeElement ? s.indexOf(t.lastFosterParentingLocation.beforeElement) - 1 : s.length - 1, l = s[o];
        if (this.treeAdapter.getNodeSourceCodeLocation(l)) {
          const { endLine: c, endCol: d, endOffset: f } = r.location;
          this.treeAdapter.updateNodeSourceCodeLocation(l, { endLine: c, endCol: d, endOffset: f });
        } else
          this.treeAdapter.setNodeSourceCodeLocation(l, r.location);
      }
    };
  }
};
var sX = aX;
const oX = Fi;
let lX = class extends oX {
  constructor(t, n) {
    super(t), this.posTracker = null, this.onParseError = n.onParseError;
  }
  _setErrorLocation(t) {
    t.startLine = t.endLine = this.posTracker.line, t.startCol = t.endCol = this.posTracker.col, t.startOffset = t.endOffset = this.posTracker.offset;
  }
  _reportError(t) {
    const n = {
      code: t,
      startLine: -1,
      startCol: -1,
      startOffset: -1,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    this._setErrorLocation(n), this.onParseError(n);
  }
  _getOverriddenMethods(t) {
    return {
      _err(n) {
        t._reportError(n);
      }
    };
  }
};
var Ym = lX;
const uX = Ym, cX = Q_, dX = Fi;
let fX = class extends uX {
  constructor(t, n) {
    super(t, n), this.posTracker = dX.install(t, cX), this.lastErrOffset = -1;
  }
  _reportError(t) {
    this.lastErrOffset !== this.posTracker.offset && (this.lastErrOffset = this.posTracker.offset, super._reportError(t));
  }
};
var hX = fX;
const pX = Ym, mX = hX, gX = Fi;
let vX = class extends pX {
  constructor(t, n) {
    super(t, n);
    const r = gX.install(t.preprocessor, mX, n);
    this.posTracker = r.posTracker;
  }
};
var yX = vX;
const EX = Ym, bX = yX, TX = X_, V2 = Fi;
let _X = class extends EX {
  constructor(t, n) {
    super(t, n), this.opts = n, this.ctLoc = null, this.locBeforeToken = !1;
  }
  _setErrorLocation(t) {
    this.ctLoc && (t.startLine = this.ctLoc.startLine, t.startCol = this.ctLoc.startCol, t.startOffset = this.ctLoc.startOffset, t.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine, t.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol, t.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset);
  }
  _getOverriddenMethods(t, n) {
    return {
      _bootstrap(r, i) {
        n._bootstrap.call(this, r, i), V2.install(this.tokenizer, bX, t.opts), V2.install(this.tokenizer, TX);
      },
      _processInputToken(r) {
        t.ctLoc = r.location, n._processInputToken.call(this, r);
      },
      _err(r, i) {
        t.locBeforeToken = i && i.beforeToken, t._reportError(r);
      }
    };
  }
};
var CX = _X, pt = {};
const { DOCUMENT_MODE: xX } = Pr;
pt.createDocument = function() {
  return {
    nodeName: "#document",
    mode: xX.NO_QUIRKS,
    childNodes: []
  };
};
pt.createDocumentFragment = function() {
  return {
    nodeName: "#document-fragment",
    childNodes: []
  };
};
pt.createElement = function(e, t, n) {
  return {
    nodeName: e,
    tagName: e,
    attrs: n,
    namespaceURI: t,
    childNodes: [],
    parentNode: null
  };
};
pt.createCommentNode = function(e) {
  return {
    nodeName: "#comment",
    data: e,
    parentNode: null
  };
};
const J_ = function(e) {
  return {
    nodeName: "#text",
    value: e,
    parentNode: null
  };
}, eC = pt.appendChild = function(e, t) {
  e.childNodes.push(t), t.parentNode = e;
}, wX = pt.insertBefore = function(e, t, n) {
  const r = e.childNodes.indexOf(n);
  e.childNodes.splice(r, 0, t), t.parentNode = e;
};
pt.setTemplateContent = function(e, t) {
  e.content = t;
};
pt.getTemplateContent = function(e) {
  return e.content;
};
pt.setDocumentType = function(e, t, n, r) {
  let i = null;
  for (let a = 0; a < e.childNodes.length; a++)
    if (e.childNodes[a].nodeName === "#documentType") {
      i = e.childNodes[a];
      break;
    }
  i ? (i.name = t, i.publicId = n, i.systemId = r) : eC(e, {
    nodeName: "#documentType",
    name: t,
    publicId: n,
    systemId: r
  });
};
pt.setDocumentMode = function(e, t) {
  e.mode = t;
};
pt.getDocumentMode = function(e) {
  return e.mode;
};
pt.detachNode = function(e) {
  if (e.parentNode) {
    const t = e.parentNode.childNodes.indexOf(e);
    e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
  }
};
pt.insertText = function(e, t) {
  if (e.childNodes.length) {
    const n = e.childNodes[e.childNodes.length - 1];
    if (n.nodeName === "#text") {
      n.value += t;
      return;
    }
  }
  eC(e, J_(t));
};
pt.insertTextBefore = function(e, t, n) {
  const r = e.childNodes[e.childNodes.indexOf(n) - 1];
  r && r.nodeName === "#text" ? r.value += t : wX(e, J_(t), n);
};
pt.adoptAttributes = function(e, t) {
  const n = [];
  for (let r = 0; r < e.attrs.length; r++)
    n.push(e.attrs[r].name);
  for (let r = 0; r < t.length; r++)
    n.indexOf(t[r].name) === -1 && e.attrs.push(t[r]);
};
pt.getFirstChild = function(e) {
  return e.childNodes[0];
};
pt.getChildNodes = function(e) {
  return e.childNodes;
};
pt.getParentNode = function(e) {
  return e.parentNode;
};
pt.getAttrList = function(e) {
  return e.attrs;
};
pt.getTagName = function(e) {
  return e.tagName;
};
pt.getNamespaceURI = function(e) {
  return e.namespaceURI;
};
pt.getTextNodeContent = function(e) {
  return e.value;
};
pt.getCommentNodeContent = function(e) {
  return e.data;
};
pt.getDocumentTypeNodeName = function(e) {
  return e.name;
};
pt.getDocumentTypeNodePublicId = function(e) {
  return e.publicId;
};
pt.getDocumentTypeNodeSystemId = function(e) {
  return e.systemId;
};
pt.isTextNode = function(e) {
  return e.nodeName === "#text";
};
pt.isCommentNode = function(e) {
  return e.nodeName === "#comment";
};
pt.isDocumentTypeNode = function(e) {
  return e.nodeName === "#documentType";
};
pt.isElementNode = function(e) {
  return !!e.tagName;
};
pt.setNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = t;
};
pt.getNodeSourceCodeLocation = function(e) {
  return e.sourceCodeLocation;
};
pt.updateNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = Object.assign(e.sourceCodeLocation, t);
};
var AX = function(t, n) {
  return n = n || /* @__PURE__ */ Object.create(null), [t, n].reduce((r, i) => (Object.keys(i).forEach((a) => {
    r[a] = i[a];
  }), r), /* @__PURE__ */ Object.create(null));
}, N1 = {};
const { DOCUMENT_MODE: hs } = Pr, tC = "html", SX = "about:legacy-compat", kX = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", nC = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], DX = nC.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]), OX = ["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"], rC = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], NX = rC.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]);
function K2(e) {
  const t = e.indexOf('"') !== -1 ? "'" : '"';
  return t + e + t;
}
function G2(e, t) {
  for (let n = 0; n < t.length; n++)
    if (e.indexOf(t[n]) === 0)
      return !0;
  return !1;
}
N1.isConforming = function(e) {
  return e.name === tC && e.publicId === null && (e.systemId === null || e.systemId === SX);
};
N1.getDocumentMode = function(e) {
  if (e.name !== tC)
    return hs.QUIRKS;
  const t = e.systemId;
  if (t && t.toLowerCase() === kX)
    return hs.QUIRKS;
  let n = e.publicId;
  if (n !== null) {
    if (n = n.toLowerCase(), OX.indexOf(n) > -1)
      return hs.QUIRKS;
    let r = t === null ? DX : nC;
    if (G2(n, r))
      return hs.QUIRKS;
    if (r = t === null ? rC : NX, G2(n, r))
      return hs.LIMITED_QUIRKS;
  }
  return hs.NO_QUIRKS;
};
N1.serializeContent = function(e, t, n) {
  let r = "!DOCTYPE ";
  return e && (r += e), t ? r += " PUBLIC " + K2(t) : n && (r += " SYSTEM"), n !== null && (r += " " + K2(n)), r;
};
var fa = {};
const Lf = O1, Zm = Pr, Le = Zm.TAG_NAMES, ln = Zm.NAMESPACES, Cc = Zm.ATTRS, Y2 = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, IX = "definitionurl", PX = "definitionURL", RX = {
  attributename: "attributeName",
  attributetype: "attributeType",
  basefrequency: "baseFrequency",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  clippathunits: "clipPathUnits",
  diffuseconstant: "diffuseConstant",
  edgemode: "edgeMode",
  filterunits: "filterUnits",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  limitingconeangle: "limitingConeAngle",
  markerheight: "markerHeight",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textlength: "textLength",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  xchannelselector: "xChannelSelector",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan"
}, FX = {
  "xlink:actuate": { prefix: "xlink", name: "actuate", namespace: ln.XLINK },
  "xlink:arcrole": { prefix: "xlink", name: "arcrole", namespace: ln.XLINK },
  "xlink:href": { prefix: "xlink", name: "href", namespace: ln.XLINK },
  "xlink:role": { prefix: "xlink", name: "role", namespace: ln.XLINK },
  "xlink:show": { prefix: "xlink", name: "show", namespace: ln.XLINK },
  "xlink:title": { prefix: "xlink", name: "title", namespace: ln.XLINK },
  "xlink:type": { prefix: "xlink", name: "type", namespace: ln.XLINK },
  "xml:base": { prefix: "xml", name: "base", namespace: ln.XML },
  "xml:lang": { prefix: "xml", name: "lang", namespace: ln.XML },
  "xml:space": { prefix: "xml", name: "space", namespace: ln.XML },
  xmlns: { prefix: "", name: "xmlns", namespace: ln.XMLNS },
  "xmlns:xlink": { prefix: "xmlns", name: "xlink", namespace: ln.XMLNS }
}, BX = fa.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient",
  textpath: "textPath"
}, MX = {
  [Le.B]: !0,
  [Le.BIG]: !0,
  [Le.BLOCKQUOTE]: !0,
  [Le.BODY]: !0,
  [Le.BR]: !0,
  [Le.CENTER]: !0,
  [Le.CODE]: !0,
  [Le.DD]: !0,
  [Le.DIV]: !0,
  [Le.DL]: !0,
  [Le.DT]: !0,
  [Le.EM]: !0,
  [Le.EMBED]: !0,
  [Le.H1]: !0,
  [Le.H2]: !0,
  [Le.H3]: !0,
  [Le.H4]: !0,
  [Le.H5]: !0,
  [Le.H6]: !0,
  [Le.HEAD]: !0,
  [Le.HR]: !0,
  [Le.I]: !0,
  [Le.IMG]: !0,
  [Le.LI]: !0,
  [Le.LISTING]: !0,
  [Le.MENU]: !0,
  [Le.META]: !0,
  [Le.NOBR]: !0,
  [Le.OL]: !0,
  [Le.P]: !0,
  [Le.PRE]: !0,
  [Le.RUBY]: !0,
  [Le.S]: !0,
  [Le.SMALL]: !0,
  [Le.SPAN]: !0,
  [Le.STRONG]: !0,
  [Le.STRIKE]: !0,
  [Le.SUB]: !0,
  [Le.SUP]: !0,
  [Le.TABLE]: !0,
  [Le.TT]: !0,
  [Le.U]: !0,
  [Le.UL]: !0,
  [Le.VAR]: !0
};
fa.causesExit = function(e) {
  const t = e.tagName;
  return t === Le.FONT && (Lf.getTokenAttr(e, Cc.COLOR) !== null || Lf.getTokenAttr(e, Cc.SIZE) !== null || Lf.getTokenAttr(e, Cc.FACE) !== null) ? !0 : MX[t];
};
fa.adjustTokenMathMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === IX) {
      e.attrs[t].name = PX;
      break;
    }
};
fa.adjustTokenSVGAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = RX[e.attrs[t].name];
    n && (e.attrs[t].name = n);
  }
};
fa.adjustTokenXMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = FX[e.attrs[t].name];
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
};
fa.adjustTokenSVGTagName = function(e) {
  const t = BX[e.tagName];
  t && (e.tagName = t);
};
function LX(e, t) {
  return t === ln.MATHML && (e === Le.MI || e === Le.MO || e === Le.MN || e === Le.MS || e === Le.MTEXT);
}
function $X(e, t, n) {
  if (t === ln.MATHML && e === Le.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++)
      if (n[r].name === Cc.ENCODING) {
        const i = n[r].value.toLowerCase();
        return i === Y2.TEXT_HTML || i === Y2.APPLICATION_XML;
      }
  }
  return t === ln.SVG && (e === Le.FOREIGN_OBJECT || e === Le.DESC || e === Le.TITLE);
}
fa.isIntegrationPoint = function(e, t, n, r) {
  return !!((!r || r === ln.HTML) && $X(e, t, n) || (!r || r === ln.MATHML) && LX(e, t));
};
const G = O1, jX = KQ, Z2 = GQ, HX = sX, UX = CX, Q2 = Fi, zX = pt, qX = AX, X2 = N1, qr = fa, fn = Km, WX = Ir, Ya = Pr, w = Ya.TAG_NAMES, Re = Ya.NAMESPACES, iC = Ya.ATTRS, VX = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  onParseError: null,
  treeAdapter: zX
}, aC = "hidden", KX = 8, GX = 3, sC = "INITIAL_MODE", Qm = "BEFORE_HTML_MODE", I1 = "BEFORE_HEAD_MODE", ro = "IN_HEAD_MODE", oC = "IN_HEAD_NO_SCRIPT_MODE", P1 = "AFTER_HEAD_MODE", Yr = "IN_BODY_MODE", Zc = "TEXT_MODE", mn = "IN_TABLE_MODE", lC = "IN_TABLE_TEXT_MODE", R1 = "IN_CAPTION_MODE", Kl = "IN_COLUMN_GROUP_MODE", fr = "IN_TABLE_BODY_MODE", ki = "IN_ROW_MODE", F1 = "IN_CELL_MODE", Xm = "IN_SELECT_MODE", Jm = "IN_SELECT_IN_TABLE_MODE", Qc = "IN_TEMPLATE_MODE", e0 = "AFTER_BODY_MODE", B1 = "IN_FRAMESET_MODE", uC = "AFTER_FRAMESET_MODE", cC = "AFTER_AFTER_BODY_MODE", dC = "AFTER_AFTER_FRAMESET_MODE", YX = {
  [w.TR]: ki,
  [w.TBODY]: fr,
  [w.THEAD]: fr,
  [w.TFOOT]: fr,
  [w.CAPTION]: R1,
  [w.COLGROUP]: Kl,
  [w.TABLE]: mn,
  [w.BODY]: Yr,
  [w.FRAMESET]: B1
}, ZX = {
  [w.CAPTION]: mn,
  [w.COLGROUP]: mn,
  [w.TBODY]: mn,
  [w.TFOOT]: mn,
  [w.THEAD]: mn,
  [w.COL]: Kl,
  [w.TR]: fr,
  [w.TD]: ki,
  [w.TH]: ki
}, J2 = {
  [sC]: {
    [G.CHARACTER_TOKEN]: ko,
    [G.NULL_CHARACTER_TOKEN]: ko,
    [G.WHITESPACE_CHARACTER_TOKEN]: lt,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: sJ,
    [G.START_TAG_TOKEN]: ko,
    [G.END_TAG_TOKEN]: ko,
    [G.EOF_TOKEN]: ko
  },
  [Qm]: {
    [G.CHARACTER_TOKEN]: Jo,
    [G.NULL_CHARACTER_TOKEN]: Jo,
    [G.WHITESPACE_CHARACTER_TOKEN]: lt,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: oJ,
    [G.END_TAG_TOKEN]: lJ,
    [G.EOF_TOKEN]: Jo
  },
  [I1]: {
    [G.CHARACTER_TOKEN]: el,
    [G.NULL_CHARACTER_TOKEN]: el,
    [G.WHITESPACE_CHARACTER_TOKEN]: lt,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: Gu,
    [G.START_TAG_TOKEN]: uJ,
    [G.END_TAG_TOKEN]: cJ,
    [G.EOF_TOKEN]: el
  },
  [ro]: {
    [G.CHARACTER_TOKEN]: tl,
    [G.NULL_CHARACTER_TOKEN]: tl,
    [G.WHITESPACE_CHARACTER_TOKEN]: Dn,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: Gu,
    [G.START_TAG_TOKEN]: an,
    [G.END_TAG_TOKEN]: Za,
    [G.EOF_TOKEN]: tl
  },
  [oC]: {
    [G.CHARACTER_TOKEN]: nl,
    [G.NULL_CHARACTER_TOKEN]: nl,
    [G.WHITESPACE_CHARACTER_TOKEN]: Dn,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: Gu,
    [G.START_TAG_TOKEN]: dJ,
    [G.END_TAG_TOKEN]: fJ,
    [G.EOF_TOKEN]: nl
  },
  [P1]: {
    [G.CHARACTER_TOKEN]: rl,
    [G.NULL_CHARACTER_TOKEN]: rl,
    [G.WHITESPACE_CHARACTER_TOKEN]: Dn,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: Gu,
    [G.START_TAG_TOKEN]: hJ,
    [G.END_TAG_TOKEN]: pJ,
    [G.EOF_TOKEN]: rl
  },
  [Yr]: {
    [G.CHARACTER_TOKEN]: Yu,
    [G.NULL_CHARACTER_TOKEN]: lt,
    [G.WHITESPACE_CHARACTER_TOKEN]: Ta,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: Hn,
    [G.END_TAG_TOKEN]: t0,
    [G.EOF_TOKEN]: di
  },
  [Zc]: {
    [G.CHARACTER_TOKEN]: Dn,
    [G.NULL_CHARACTER_TOKEN]: Dn,
    [G.WHITESPACE_CHARACTER_TOKEN]: Dn,
    [G.COMMENT_TOKEN]: lt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: lt,
    [G.END_TAG_TOKEN]: WJ,
    [G.EOF_TOKEN]: VJ
  },
  [mn]: {
    [G.CHARACTER_TOKEN]: fi,
    [G.NULL_CHARACTER_TOKEN]: fi,
    [G.WHITESPACE_CHARACTER_TOKEN]: fi,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: n0,
    [G.END_TAG_TOKEN]: r0,
    [G.EOF_TOKEN]: di
  },
  [lC]: {
    [G.CHARACTER_TOKEN]: nee,
    [G.NULL_CHARACTER_TOKEN]: lt,
    [G.WHITESPACE_CHARACTER_TOKEN]: tee,
    [G.COMMENT_TOKEN]: Do,
    [G.DOCTYPE_TOKEN]: Do,
    [G.START_TAG_TOKEN]: Do,
    [G.END_TAG_TOKEN]: Do,
    [G.EOF_TOKEN]: Do
  },
  [R1]: {
    [G.CHARACTER_TOKEN]: Yu,
    [G.NULL_CHARACTER_TOKEN]: lt,
    [G.WHITESPACE_CHARACTER_TOKEN]: Ta,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: ree,
    [G.END_TAG_TOKEN]: iee,
    [G.EOF_TOKEN]: di
  },
  [Kl]: {
    [G.CHARACTER_TOKEN]: Xc,
    [G.NULL_CHARACTER_TOKEN]: Xc,
    [G.WHITESPACE_CHARACTER_TOKEN]: Dn,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: aee,
    [G.END_TAG_TOKEN]: see,
    [G.EOF_TOKEN]: di
  },
  [fr]: {
    [G.CHARACTER_TOKEN]: fi,
    [G.NULL_CHARACTER_TOKEN]: fi,
    [G.WHITESPACE_CHARACTER_TOKEN]: fi,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: oee,
    [G.END_TAG_TOKEN]: lee,
    [G.EOF_TOKEN]: di
  },
  [ki]: {
    [G.CHARACTER_TOKEN]: fi,
    [G.NULL_CHARACTER_TOKEN]: fi,
    [G.WHITESPACE_CHARACTER_TOKEN]: fi,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: uee,
    [G.END_TAG_TOKEN]: cee,
    [G.EOF_TOKEN]: di
  },
  [F1]: {
    [G.CHARACTER_TOKEN]: Yu,
    [G.NULL_CHARACTER_TOKEN]: lt,
    [G.WHITESPACE_CHARACTER_TOKEN]: Ta,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: dee,
    [G.END_TAG_TOKEN]: fee,
    [G.EOF_TOKEN]: di
  },
  [Xm]: {
    [G.CHARACTER_TOKEN]: Dn,
    [G.NULL_CHARACTER_TOKEN]: lt,
    [G.WHITESPACE_CHARACTER_TOKEN]: Dn,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: fC,
    [G.END_TAG_TOKEN]: hC,
    [G.EOF_TOKEN]: di
  },
  [Jm]: {
    [G.CHARACTER_TOKEN]: Dn,
    [G.NULL_CHARACTER_TOKEN]: lt,
    [G.WHITESPACE_CHARACTER_TOKEN]: Dn,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: hee,
    [G.END_TAG_TOKEN]: pee,
    [G.EOF_TOKEN]: di
  },
  [Qc]: {
    [G.CHARACTER_TOKEN]: Yu,
    [G.NULL_CHARACTER_TOKEN]: lt,
    [G.WHITESPACE_CHARACTER_TOKEN]: Ta,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: mee,
    [G.END_TAG_TOKEN]: gee,
    [G.EOF_TOKEN]: pC
  },
  [e0]: {
    [G.CHARACTER_TOKEN]: Jc,
    [G.NULL_CHARACTER_TOKEN]: Jc,
    [G.WHITESPACE_CHARACTER_TOKEN]: Ta,
    [G.COMMENT_TOKEN]: aJ,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: vee,
    [G.END_TAG_TOKEN]: yee,
    [G.EOF_TOKEN]: So
  },
  [B1]: {
    [G.CHARACTER_TOKEN]: lt,
    [G.NULL_CHARACTER_TOKEN]: lt,
    [G.WHITESPACE_CHARACTER_TOKEN]: Dn,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: Eee,
    [G.END_TAG_TOKEN]: bee,
    [G.EOF_TOKEN]: So
  },
  [uC]: {
    [G.CHARACTER_TOKEN]: lt,
    [G.NULL_CHARACTER_TOKEN]: lt,
    [G.WHITESPACE_CHARACTER_TOKEN]: Dn,
    [G.COMMENT_TOKEN]: Jt,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: Tee,
    [G.END_TAG_TOKEN]: _ee,
    [G.EOF_TOKEN]: So
  },
  [cC]: {
    [G.CHARACTER_TOKEN]: xc,
    [G.NULL_CHARACTER_TOKEN]: xc,
    [G.WHITESPACE_CHARACTER_TOKEN]: Ta,
    [G.COMMENT_TOKEN]: ey,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: Cee,
    [G.END_TAG_TOKEN]: xc,
    [G.EOF_TOKEN]: So
  },
  [dC]: {
    [G.CHARACTER_TOKEN]: lt,
    [G.NULL_CHARACTER_TOKEN]: lt,
    [G.WHITESPACE_CHARACTER_TOKEN]: Ta,
    [G.COMMENT_TOKEN]: ey,
    [G.DOCTYPE_TOKEN]: lt,
    [G.START_TAG_TOKEN]: xee,
    [G.END_TAG_TOKEN]: lt,
    [G.EOF_TOKEN]: So
  }
};
class QX {
  constructor(t) {
    this.options = qX(VX, t), this.treeAdapter = this.options.treeAdapter, this.pendingScript = null, this.options.sourceCodeLocationInfo && Q2.install(this, HX), this.options.onParseError && Q2.install(this, UX, { onParseError: this.options.onParseError });
  }
  // API
  parse(t) {
    const n = this.treeAdapter.createDocument();
    return this._bootstrap(n, null), this.tokenizer.write(t, !0), this._runParsingLoop(null), n;
  }
  parseFragment(t, n) {
    n || (n = this.treeAdapter.createElement(w.TEMPLATE, Re.HTML, []));
    const r = this.treeAdapter.createElement("documentmock", Re.HTML, []);
    this._bootstrap(r, n), this.treeAdapter.getTagName(n) === w.TEMPLATE && this._pushTmplInsertionMode(Qc), this._initTokenizerForFragmentParsing(), this._insertFakeRootElement(), this._resetInsertionMode(), this._findFormInFragmentContext(), this.tokenizer.write(t, !0), this._runParsingLoop(null);
    const i = this.treeAdapter.getFirstChild(r), a = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(i, a), a;
  }
  //Bootstrap parser
  _bootstrap(t, n) {
    this.tokenizer = new G(this.options), this.stopped = !1, this.insertionMode = sC, this.originalInsertionMode = "", this.document = t, this.fragmentContext = n, this.headElement = null, this.formElement = null, this.openElements = new jX(this.document, this.treeAdapter), this.activeFormattingElements = new Z2(this.treeAdapter), this.tmplInsertionModeStack = [], this.tmplInsertionModeStackTop = -1, this.currentTmplInsertionMode = null, this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1;
  }
  //Errors
  _err() {
  }
  //Parsing loop
  _runParsingLoop(t) {
    for (; !this.stopped; ) {
      this._setupTokenizerCDATAMode();
      const n = this.tokenizer.getNextToken();
      if (n.type === G.HIBERNATION_TOKEN)
        break;
      if (this.skipNextNewLine && (this.skipNextNewLine = !1, n.type === G.WHITESPACE_CHARACTER_TOKEN && n.chars[0] === `
`)) {
        if (n.chars.length === 1)
          continue;
        n.chars = n.chars.substr(1);
      }
      if (this._processInputToken(n), t && this.pendingScript)
        break;
    }
  }
  runParsingLoopForCurrentChunk(t, n) {
    if (this._runParsingLoop(n), n && this.pendingScript) {
      const r = this.pendingScript;
      this.pendingScript = null, n(r);
      return;
    }
    t && t();
  }
  //Text parsing
  _setupTokenizerCDATAMode() {
    const t = this._getAdjustedCurrentElement();
    this.tokenizer.allowCDATA = t && t !== this.document && this.treeAdapter.getNamespaceURI(t) !== Re.HTML && !this._isIntegrationPoint(t);
  }
  _switchToTextParsing(t, n) {
    this._insertElement(t, Re.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = Zc;
  }
  switchToPlaintextParsing() {
    this.insertionMode = Zc, this.originalInsertionMode = Yr, this.tokenizer.state = G.MODE.PLAINTEXT;
  }
  //Fragment parsing
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    do {
      if (this.treeAdapter.getTagName(t) === w.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    } while (t);
  }
  _initTokenizerForFragmentParsing() {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === Re.HTML) {
      const t = this.treeAdapter.getTagName(this.fragmentContext);
      t === w.TITLE || t === w.TEXTAREA ? this.tokenizer.state = G.MODE.RCDATA : t === w.STYLE || t === w.XMP || t === w.IFRAME || t === w.NOEMBED || t === w.NOFRAMES || t === w.NOSCRIPT ? this.tokenizer.state = G.MODE.RAWTEXT : t === w.SCRIPT ? this.tokenizer.state = G.MODE.SCRIPT_DATA : t === w.PLAINTEXT && (this.tokenizer.state = G.MODE.PLAINTEXT);
    }
  }
  //Tree mutation
  _setDocumentType(t) {
    const n = t.name || "", r = t.publicId || "", i = t.systemId || "";
    this.treeAdapter.setDocumentType(this.document, n, r, i);
  }
  _attachElementToTree(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.appendChild(n, t);
    }
  }
  _appendElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r);
  }
  _insertElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r), this.openElements.push(r);
  }
  _insertFakeElement(t) {
    const n = this.treeAdapter.createElement(t, Re.HTML, []);
    this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, Re.HTML, t.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(w.HTML, Re.HTML, []);
    this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t);
  }
  _appendCommentNode(t, n) {
    const r = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, r);
  }
  _insertCharacters(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentText(t.chars);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.insertText(n, t.chars);
    }
  }
  _adoptNodes(t, n) {
    for (let r = this.treeAdapter.getFirstChild(t); r; r = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
  }
  //Token processing
  _shouldProcessTokenInForeignContent(t) {
    const n = this._getAdjustedCurrentElement();
    if (!n || n === this.document)
      return !1;
    const r = this.treeAdapter.getNamespaceURI(n);
    if (r === Re.HTML || this.treeAdapter.getTagName(n) === w.ANNOTATION_XML && r === Re.MATHML && t.type === G.START_TAG_TOKEN && t.tagName === w.SVG)
      return !1;
    const i = t.type === G.CHARACTER_TOKEN || t.type === G.NULL_CHARACTER_TOKEN || t.type === G.WHITESPACE_CHARACTER_TOKEN;
    return (t.type === G.START_TAG_TOKEN && t.tagName !== w.MGLYPH && t.tagName !== w.MALIGNMARK || i) && this._isIntegrationPoint(n, Re.MATHML) || (t.type === G.START_TAG_TOKEN || i) && this._isIntegrationPoint(n, Re.HTML) ? !1 : t.type !== G.EOF_TOKEN;
  }
  _processToken(t) {
    J2[this.insertionMode][t.type](this, t);
  }
  _processTokenInBodyMode(t) {
    J2[Yr][t.type](this, t);
  }
  _processTokenInForeignContent(t) {
    t.type === G.CHARACTER_TOKEN ? Aee(this, t) : t.type === G.NULL_CHARACTER_TOKEN ? wee(this, t) : t.type === G.WHITESPACE_CHARACTER_TOKEN ? Dn(this, t) : t.type === G.COMMENT_TOKEN ? Jt(this, t) : t.type === G.START_TAG_TOKEN ? See(this, t) : t.type === G.END_TAG_TOKEN && kee(this, t);
  }
  _processInputToken(t) {
    this._shouldProcessTokenInForeignContent(t) ? this._processTokenInForeignContent(t) : this._processToken(t), t.type === G.START_TAG_TOKEN && t.selfClosing && !t.ackSelfClosing && this._err(fn.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  //Integration points
  _isIntegrationPoint(t, n) {
    const r = this.treeAdapter.getTagName(t), i = this.treeAdapter.getNamespaceURI(t), a = this.treeAdapter.getAttrList(t);
    return qr.isIntegrationPoint(r, i, a, n);
  }
  //Active formatting elements reconstruction
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.length;
    if (t) {
      let n = t, r = null;
      do
        if (n--, r = this.activeFormattingElements.entries[n], r.type === Z2.MARKER_ENTRY || this.openElements.contains(r.element)) {
          n++;
          break;
        }
      while (n > 0);
      for (let i = n; i < t; i++)
        r = this.activeFormattingElements.entries[i], this._insertElement(r.token, this.treeAdapter.getNamespaceURI(r.element)), r.element = this.openElements.current;
    }
  }
  //Close elements
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = ki;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(w.P), this.openElements.popUntilTagNamePopped(w.P);
  }
  //Insertion modes
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop, n = !1; t >= 0; t--) {
      let r = this.openElements.items[t];
      t === 0 && (n = !0, this.fragmentContext && (r = this.fragmentContext));
      const i = this.treeAdapter.getTagName(r), a = YX[i];
      if (a) {
        this.insertionMode = a;
        break;
      } else if (!n && (i === w.TD || i === w.TH)) {
        this.insertionMode = F1;
        break;
      } else if (!n && i === w.HEAD) {
        this.insertionMode = ro;
        break;
      } else if (i === w.SELECT) {
        this._resetInsertionModeForSelect(t);
        break;
      } else if (i === w.TEMPLATE) {
        this.insertionMode = this.currentTmplInsertionMode;
        break;
      } else if (i === w.HTML) {
        this.insertionMode = this.headElement ? P1 : I1;
        break;
      } else if (n) {
        this.insertionMode = Yr;
        break;
      }
    }
  }
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let n = t - 1; n > 0; n--) {
        const r = this.openElements.items[n], i = this.treeAdapter.getTagName(r);
        if (i === w.TEMPLATE)
          break;
        if (i === w.TABLE) {
          this.insertionMode = Jm;
          return;
        }
      }
    this.insertionMode = Xm;
  }
  _pushTmplInsertionMode(t) {
    this.tmplInsertionModeStack.push(t), this.tmplInsertionModeStackTop++, this.currentTmplInsertionMode = t;
  }
  _popTmplInsertionMode() {
    this.tmplInsertionModeStack.pop(), this.tmplInsertionModeStackTop--, this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
  }
  //Foster parenting
  _isElementCausesFosterParenting(t) {
    const n = this.treeAdapter.getTagName(t);
    return n === w.TABLE || n === w.TBODY || n === w.TFOOT || n === w.THEAD || n === w.TR;
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
  }
  _findFosterParentingLocation() {
    const t = {
      parent: null,
      beforeElement: null
    };
    for (let n = this.openElements.stackTop; n >= 0; n--) {
      const r = this.openElements.items[n], i = this.treeAdapter.getTagName(r), a = this.treeAdapter.getNamespaceURI(r);
      if (i === w.TEMPLATE && a === Re.HTML) {
        t.parent = this.treeAdapter.getTemplateContent(r);
        break;
      } else if (i === w.TABLE) {
        t.parent = this.treeAdapter.getParentNode(r), t.parent ? t.beforeElement = r : t.parent = this.openElements.items[n - 1];
        break;
      }
    }
    return t.parent || (t.parent = this.openElements.items[0]), t;
  }
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  _fosterParentText(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertTextBefore(n.parent, t, n.beforeElement) : this.treeAdapter.insertText(n.parent, t);
  }
  //Special elements
  _isSpecialElement(t) {
    const n = this.treeAdapter.getTagName(t), r = this.treeAdapter.getNamespaceURI(t);
    return Ya.SPECIAL_ELEMENTS[r][n];
  }
}
var XX = QX;
function JX(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagName) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : xr(e, t), n;
}
function eJ(e, t) {
  let n = null;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const i = e.openElements.items[r];
    if (i === t.element)
      break;
    e._isSpecialElement(i) && (n = i);
  }
  return n || (e.openElements.popUntilElementPopped(t.element), e.activeFormattingElements.removeEntry(t)), n;
}
function tJ(e, t, n) {
  let r = t, i = e.openElements.getCommonAncestor(t);
  for (let a = 0, s = i; s !== n; a++, s = i) {
    i = e.openElements.getCommonAncestor(s);
    const o = e.activeFormattingElements.getElementEntry(s), l = o && a >= GX;
    !o || l ? (l && e.activeFormattingElements.removeEntry(o), e.openElements.remove(s)) : (s = nJ(e, o), r === t && (e.activeFormattingElements.bookmark = o), e.treeAdapter.detachNode(r), e.treeAdapter.appendChild(s, r), r = s);
  }
  return r;
}
function nJ(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), r = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, r), t.element = r, r;
}
function rJ(e, t, n) {
  if (e._isElementCausesFosterParenting(t))
    e._fosterParentElement(n);
  else {
    const r = e.treeAdapter.getTagName(t), i = e.treeAdapter.getNamespaceURI(t);
    r === w.TEMPLATE && i === Re.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function iJ(e, t, n) {
  const r = e.treeAdapter.getNamespaceURI(n.element), i = n.token, a = e.treeAdapter.createElement(i.tagName, r, i.attrs);
  e._adoptNodes(t, a), e.treeAdapter.appendChild(t, a), e.activeFormattingElements.insertElementAfterBookmark(a, n.token), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, a);
}
function Gi(e, t) {
  let n;
  for (let r = 0; r < KX && (n = JX(e, t), !!n); r++) {
    const i = eJ(e, n);
    if (!i)
      break;
    e.activeFormattingElements.bookmark = n;
    const a = tJ(e, i, n.element), s = e.openElements.getCommonAncestor(n.element);
    e.treeAdapter.detachNode(a), rJ(e, s, a), iJ(e, i, n);
  }
}
function lt() {
}
function Gu(e) {
  e._err(fn.misplacedDoctype);
}
function Jt(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContent || e.openElements.current);
}
function aJ(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function ey(e, t) {
  e._appendCommentNode(t, e.document);
}
function Dn(e, t) {
  e._insertCharacters(t);
}
function So(e) {
  e.stopped = !0;
}
function sJ(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? Ya.DOCUMENT_MODE.QUIRKS : X2.getDocumentMode(t);
  X2.isConforming(t) || e._err(fn.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = Qm;
}
function ko(e, t) {
  e._err(fn.missingDoctype, { beforeToken: !0 }), e.treeAdapter.setDocumentMode(e.document, Ya.DOCUMENT_MODE.QUIRKS), e.insertionMode = Qm, e._processToken(t);
}
function oJ(e, t) {
  t.tagName === w.HTML ? (e._insertElement(t, Re.HTML), e.insertionMode = I1) : Jo(e, t);
}
function lJ(e, t) {
  const n = t.tagName;
  (n === w.HTML || n === w.HEAD || n === w.BODY || n === w.BR) && Jo(e, t);
}
function Jo(e, t) {
  e._insertFakeRootElement(), e.insertionMode = I1, e._processToken(t);
}
function uJ(e, t) {
  const n = t.tagName;
  n === w.HTML ? Hn(e, t) : n === w.HEAD ? (e._insertElement(t, Re.HTML), e.headElement = e.openElements.current, e.insertionMode = ro) : el(e, t);
}
function cJ(e, t) {
  const n = t.tagName;
  n === w.HEAD || n === w.BODY || n === w.HTML || n === w.BR ? el(e, t) : e._err(fn.endTagWithoutMatchingOpenElement);
}
function el(e, t) {
  e._insertFakeElement(w.HEAD), e.headElement = e.openElements.current, e.insertionMode = ro, e._processToken(t);
}
function an(e, t) {
  const n = t.tagName;
  n === w.HTML ? Hn(e, t) : n === w.BASE || n === w.BASEFONT || n === w.BGSOUND || n === w.LINK || n === w.META ? (e._appendElement(t, Re.HTML), t.ackSelfClosing = !0) : n === w.TITLE ? e._switchToTextParsing(t, G.MODE.RCDATA) : n === w.NOSCRIPT ? e.options.scriptingEnabled ? e._switchToTextParsing(t, G.MODE.RAWTEXT) : (e._insertElement(t, Re.HTML), e.insertionMode = oC) : n === w.NOFRAMES || n === w.STYLE ? e._switchToTextParsing(t, G.MODE.RAWTEXT) : n === w.SCRIPT ? e._switchToTextParsing(t, G.MODE.SCRIPT_DATA) : n === w.TEMPLATE ? (e._insertTemplate(t, Re.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = Qc, e._pushTmplInsertionMode(Qc)) : n === w.HEAD ? e._err(fn.misplacedStartTagForHeadElement) : tl(e, t);
}
function Za(e, t) {
  const n = t.tagName;
  n === w.HEAD ? (e.openElements.pop(), e.insertionMode = P1) : n === w.BODY || n === w.BR || n === w.HTML ? tl(e, t) : n === w.TEMPLATE && e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagName !== w.TEMPLATE && e._err(fn.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(w.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode()) : e._err(fn.endTagWithoutMatchingOpenElement);
}
function tl(e, t) {
  e.openElements.pop(), e.insertionMode = P1, e._processToken(t);
}
function dJ(e, t) {
  const n = t.tagName;
  n === w.HTML ? Hn(e, t) : n === w.BASEFONT || n === w.BGSOUND || n === w.HEAD || n === w.LINK || n === w.META || n === w.NOFRAMES || n === w.STYLE ? an(e, t) : n === w.NOSCRIPT ? e._err(fn.nestedNoscriptInHead) : nl(e, t);
}
function fJ(e, t) {
  const n = t.tagName;
  n === w.NOSCRIPT ? (e.openElements.pop(), e.insertionMode = ro) : n === w.BR ? nl(e, t) : e._err(fn.endTagWithoutMatchingOpenElement);
}
function nl(e, t) {
  const n = t.type === G.EOF_TOKEN ? fn.openElementsLeftAfterEof : fn.disallowedContentInNoscriptInHead;
  e._err(n), e.openElements.pop(), e.insertionMode = ro, e._processToken(t);
}
function hJ(e, t) {
  const n = t.tagName;
  n === w.HTML ? Hn(e, t) : n === w.BODY ? (e._insertElement(t, Re.HTML), e.framesetOk = !1, e.insertionMode = Yr) : n === w.FRAMESET ? (e._insertElement(t, Re.HTML), e.insertionMode = B1) : n === w.BASE || n === w.BASEFONT || n === w.BGSOUND || n === w.LINK || n === w.META || n === w.NOFRAMES || n === w.SCRIPT || n === w.STYLE || n === w.TEMPLATE || n === w.TITLE ? (e._err(fn.abandonedHeadElementChild), e.openElements.push(e.headElement), an(e, t), e.openElements.remove(e.headElement)) : n === w.HEAD ? e._err(fn.misplacedStartTagForHeadElement) : rl(e, t);
}
function pJ(e, t) {
  const n = t.tagName;
  n === w.BODY || n === w.HTML || n === w.BR ? rl(e, t) : n === w.TEMPLATE ? Za(e, t) : e._err(fn.endTagWithoutMatchingOpenElement);
}
function rl(e, t) {
  e._insertFakeElement(w.BODY), e.insertionMode = Yr, e._processToken(t);
}
function Ta(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function Yu(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function mJ(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function gJ(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function vJ(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, Re.HTML), e.insertionMode = B1);
}
function ci(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, Re.HTML);
}
function yJ(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement();
  const n = e.openElements.currentTagName;
  (n === w.H1 || n === w.H2 || n === w.H3 || n === w.H4 || n === w.H5 || n === w.H6) && e.openElements.pop(), e._insertElement(t, Re.HTML);
}
function ty(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, Re.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function EJ(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, Re.HTML), n || (e.formElement = e.openElements.current));
}
function bJ(e, t) {
  e.framesetOk = !1;
  const n = t.tagName;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const i = e.openElements.items[r], a = e.treeAdapter.getTagName(i);
    let s = null;
    if (n === w.LI && a === w.LI ? s = w.LI : (n === w.DD || n === w.DT) && (a === w.DD || a === w.DT) && (s = a), s) {
      e.openElements.generateImpliedEndTagsWithExclusion(s), e.openElements.popUntilTagNamePopped(s);
      break;
    }
    if (a !== w.ADDRESS && a !== w.DIV && a !== w.P && e._isSpecialElement(i))
      break;
  }
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, Re.HTML);
}
function TJ(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, Re.HTML), e.tokenizer.state = G.MODE.PLAINTEXT;
}
function _J(e, t) {
  e.openElements.hasInScope(w.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(w.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, Re.HTML), e.framesetOk = !1;
}
function CJ(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(w.A);
  n && (Gi(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, Re.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function ps(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Re.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function xJ(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(w.NOBR) && (Gi(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, Re.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function ny(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Re.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function wJ(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== Ya.DOCUMENT_MODE.QUIRKS && e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, Re.HTML), e.framesetOk = !1, e.insertionMode = mn;
}
function vs(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, Re.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function AJ(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, Re.HTML);
  const n = G.getTokenAttr(t, iC.TYPE);
  (!n || n.toLowerCase() !== aC) && (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function ry(e, t) {
  e._appendElement(t, Re.HTML), t.ackSelfClosing = !0;
}
function SJ(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._appendElement(t, Re.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function kJ(e, t) {
  t.tagName = w.IMG, vs(e, t);
}
function DJ(e, t) {
  e._insertElement(t, Re.HTML), e.skipNextNewLine = !0, e.tokenizer.state = G.MODE.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = Zc;
}
function OJ(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, G.MODE.RAWTEXT);
}
function NJ(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, G.MODE.RAWTEXT);
}
function iy(e, t) {
  e._switchToTextParsing(t, G.MODE.RAWTEXT);
}
function IJ(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Re.HTML), e.framesetOk = !1, e.insertionMode === mn || e.insertionMode === R1 || e.insertionMode === fr || e.insertionMode === ki || e.insertionMode === F1 ? e.insertionMode = Jm : e.insertionMode = Xm;
}
function ay(e, t) {
  e.openElements.currentTagName === w.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, Re.HTML);
}
function sy(e, t) {
  e.openElements.hasInScope(w.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, Re.HTML);
}
function PJ(e, t) {
  e.openElements.hasInScope(w.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(w.RTC), e._insertElement(t, Re.HTML);
}
function RJ(e, t) {
  e.openElements.hasInButtonScope(w.P) && e._closePElement(), e._insertElement(t, Re.HTML);
}
function FJ(e, t) {
  e._reconstructActiveFormattingElements(), qr.adjustTokenMathMLAttrs(t), qr.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, Re.MATHML) : e._insertElement(t, Re.MATHML), t.ackSelfClosing = !0;
}
function BJ(e, t) {
  e._reconstructActiveFormattingElements(), qr.adjustTokenSVGAttrs(t), qr.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, Re.SVG) : e._insertElement(t, Re.SVG), t.ackSelfClosing = !0;
}
function nr(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, Re.HTML);
}
function Hn(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 1:
      n === w.I || n === w.S || n === w.B || n === w.U ? ps(e, t) : n === w.P ? ci(e, t) : n === w.A ? CJ(e, t) : nr(e, t);
      break;
    case 2:
      n === w.DL || n === w.OL || n === w.UL ? ci(e, t) : n === w.H1 || n === w.H2 || n === w.H3 || n === w.H4 || n === w.H5 || n === w.H6 ? yJ(e, t) : n === w.LI || n === w.DD || n === w.DT ? bJ(e, t) : n === w.EM || n === w.TT ? ps(e, t) : n === w.BR ? vs(e, t) : n === w.HR ? SJ(e, t) : n === w.RB ? sy(e, t) : n === w.RT || n === w.RP ? PJ(e, t) : n !== w.TH && n !== w.TD && n !== w.TR && nr(e, t);
      break;
    case 3:
      n === w.DIV || n === w.DIR || n === w.NAV ? ci(e, t) : n === w.PRE ? ty(e, t) : n === w.BIG ? ps(e, t) : n === w.IMG || n === w.WBR ? vs(e, t) : n === w.XMP ? OJ(e, t) : n === w.SVG ? BJ(e, t) : n === w.RTC ? sy(e, t) : n !== w.COL && nr(e, t);
      break;
    case 4:
      n === w.HTML ? mJ(e, t) : n === w.BASE || n === w.LINK || n === w.META ? an(e, t) : n === w.BODY ? gJ(e, t) : n === w.MAIN || n === w.MENU ? ci(e, t) : n === w.FORM ? EJ(e, t) : n === w.CODE || n === w.FONT ? ps(e, t) : n === w.NOBR ? xJ(e, t) : n === w.AREA ? vs(e, t) : n === w.MATH ? FJ(e, t) : n === w.MENU ? RJ(e, t) : n !== w.HEAD && nr(e, t);
      break;
    case 5:
      n === w.STYLE || n === w.TITLE ? an(e, t) : n === w.ASIDE ? ci(e, t) : n === w.SMALL ? ps(e, t) : n === w.TABLE ? wJ(e, t) : n === w.EMBED ? vs(e, t) : n === w.INPUT ? AJ(e, t) : n === w.PARAM || n === w.TRACK ? ry(e, t) : n === w.IMAGE ? kJ(e, t) : n !== w.FRAME && n !== w.TBODY && n !== w.TFOOT && n !== w.THEAD && nr(e, t);
      break;
    case 6:
      n === w.SCRIPT ? an(e, t) : n === w.CENTER || n === w.FIGURE || n === w.FOOTER || n === w.HEADER || n === w.HGROUP || n === w.DIALOG ? ci(e, t) : n === w.BUTTON ? _J(e, t) : n === w.STRIKE || n === w.STRONG ? ps(e, t) : n === w.APPLET || n === w.OBJECT ? ny(e, t) : n === w.KEYGEN ? vs(e, t) : n === w.SOURCE ? ry(e, t) : n === w.IFRAME ? NJ(e, t) : n === w.SELECT ? IJ(e, t) : n === w.OPTION ? ay(e, t) : nr(e, t);
      break;
    case 7:
      n === w.BGSOUND ? an(e, t) : n === w.DETAILS || n === w.ADDRESS || n === w.ARTICLE || n === w.SECTION || n === w.SUMMARY ? ci(e, t) : n === w.LISTING ? ty(e, t) : n === w.MARQUEE ? ny(e, t) : n === w.NOEMBED ? iy(e, t) : n !== w.CAPTION && nr(e, t);
      break;
    case 8:
      n === w.BASEFONT ? an(e, t) : n === w.FRAMESET ? vJ(e, t) : n === w.FIELDSET ? ci(e, t) : n === w.TEXTAREA ? DJ(e, t) : n === w.TEMPLATE ? an(e, t) : n === w.NOSCRIPT ? e.options.scriptingEnabled ? iy(e, t) : nr(e, t) : n === w.OPTGROUP ? ay(e, t) : n !== w.COLGROUP && nr(e, t);
      break;
    case 9:
      n === w.PLAINTEXT ? TJ(e, t) : nr(e, t);
      break;
    case 10:
      n === w.BLOCKQUOTE || n === w.FIGCAPTION ? ci(e, t) : nr(e, t);
      break;
    default:
      nr(e, t);
  }
}
function MJ(e) {
  e.openElements.hasInScope(w.BODY) && (e.insertionMode = e0);
}
function LJ(e, t) {
  e.openElements.hasInScope(w.BODY) && (e.insertionMode = e0, e._processToken(t));
}
function zi(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function $J(e) {
  const t = e.openElements.tmplCount > 0, n = e.formElement;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(w.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(w.FORM) : e.openElements.remove(n));
}
function jJ(e) {
  e.openElements.hasInButtonScope(w.P) || e._insertFakeElement(w.P), e._closePElement();
}
function HJ(e) {
  e.openElements.hasInListItemScope(w.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(w.LI), e.openElements.popUntilTagNamePopped(w.LI));
}
function UJ(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function zJ(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function oy(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function qJ(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(w.BR), e.openElements.pop(), e.framesetOk = !1;
}
function xr(e, t) {
  const n = t.tagName;
  for (let r = e.openElements.stackTop; r > 0; r--) {
    const i = e.openElements.items[r];
    if (e.treeAdapter.getTagName(i) === n) {
      e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilElementPopped(i);
      break;
    }
    if (e._isSpecialElement(i))
      break;
  }
}
function t0(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 1:
      n === w.A || n === w.B || n === w.I || n === w.S || n === w.U ? Gi(e, t) : n === w.P ? jJ(e) : xr(e, t);
      break;
    case 2:
      n === w.DL || n === w.UL || n === w.OL ? zi(e, t) : n === w.LI ? HJ(e) : n === w.DD || n === w.DT ? UJ(e, t) : n === w.H1 || n === w.H2 || n === w.H3 || n === w.H4 || n === w.H5 || n === w.H6 ? zJ(e) : n === w.BR ? qJ(e) : n === w.EM || n === w.TT ? Gi(e, t) : xr(e, t);
      break;
    case 3:
      n === w.BIG ? Gi(e, t) : n === w.DIR || n === w.DIV || n === w.NAV || n === w.PRE ? zi(e, t) : xr(e, t);
      break;
    case 4:
      n === w.BODY ? MJ(e) : n === w.HTML ? LJ(e, t) : n === w.FORM ? $J(e) : n === w.CODE || n === w.FONT || n === w.NOBR ? Gi(e, t) : n === w.MAIN || n === w.MENU ? zi(e, t) : xr(e, t);
      break;
    case 5:
      n === w.ASIDE ? zi(e, t) : n === w.SMALL ? Gi(e, t) : xr(e, t);
      break;
    case 6:
      n === w.CENTER || n === w.FIGURE || n === w.FOOTER || n === w.HEADER || n === w.HGROUP || n === w.DIALOG ? zi(e, t) : n === w.APPLET || n === w.OBJECT ? oy(e, t) : n === w.STRIKE || n === w.STRONG ? Gi(e, t) : xr(e, t);
      break;
    case 7:
      n === w.ADDRESS || n === w.ARTICLE || n === w.DETAILS || n === w.SECTION || n === w.SUMMARY || n === w.LISTING ? zi(e, t) : n === w.MARQUEE ? oy(e, t) : xr(e, t);
      break;
    case 8:
      n === w.FIELDSET ? zi(e, t) : n === w.TEMPLATE ? Za(e, t) : xr(e, t);
      break;
    case 10:
      n === w.BLOCKQUOTE || n === w.FIGCAPTION ? zi(e, t) : xr(e, t);
      break;
    default:
      xr(e, t);
  }
}
function di(e, t) {
  e.tmplInsertionModeStackTop > -1 ? pC(e, t) : e.stopped = !0;
}
function WJ(e, t) {
  t.tagName === w.SCRIPT && (e.pendingScript = e.openElements.current), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function VJ(e, t) {
  e._err(fn.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function fi(e, t) {
  const n = e.openElements.currentTagName;
  n === w.TABLE || n === w.TBODY || n === w.TFOOT || n === w.THEAD || n === w.TR ? (e.pendingCharacterTokens = [], e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = lC, e._processToken(t)) : rr(e, t);
}
function KJ(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, Re.HTML), e.insertionMode = R1;
}
function GJ(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, Re.HTML), e.insertionMode = Kl;
}
function YJ(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(w.COLGROUP), e.insertionMode = Kl, e._processToken(t);
}
function ZJ(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, Re.HTML), e.insertionMode = fr;
}
function QJ(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(w.TBODY), e.insertionMode = fr, e._processToken(t);
}
function XJ(e, t) {
  e.openElements.hasInTableScope(w.TABLE) && (e.openElements.popUntilTagNamePopped(w.TABLE), e._resetInsertionMode(), e._processToken(t));
}
function JJ(e, t) {
  const n = G.getTokenAttr(t, iC.TYPE);
  n && n.toLowerCase() === aC ? e._appendElement(t, Re.HTML) : rr(e, t), t.ackSelfClosing = !0;
}
function eee(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, Re.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function n0(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 2:
      n === w.TD || n === w.TH || n === w.TR ? QJ(e, t) : rr(e, t);
      break;
    case 3:
      n === w.COL ? YJ(e, t) : rr(e, t);
      break;
    case 4:
      n === w.FORM ? eee(e, t) : rr(e, t);
      break;
    case 5:
      n === w.TABLE ? XJ(e, t) : n === w.STYLE ? an(e, t) : n === w.TBODY || n === w.TFOOT || n === w.THEAD ? ZJ(e, t) : n === w.INPUT ? JJ(e, t) : rr(e, t);
      break;
    case 6:
      n === w.SCRIPT ? an(e, t) : rr(e, t);
      break;
    case 7:
      n === w.CAPTION ? KJ(e, t) : rr(e, t);
      break;
    case 8:
      n === w.COLGROUP ? GJ(e, t) : n === w.TEMPLATE ? an(e, t) : rr(e, t);
      break;
    default:
      rr(e, t);
  }
}
function r0(e, t) {
  const n = t.tagName;
  n === w.TABLE ? e.openElements.hasInTableScope(w.TABLE) && (e.openElements.popUntilTagNamePopped(w.TABLE), e._resetInsertionMode()) : n === w.TEMPLATE ? Za(e, t) : n !== w.BODY && n !== w.CAPTION && n !== w.COL && n !== w.COLGROUP && n !== w.HTML && n !== w.TBODY && n !== w.TD && n !== w.TFOOT && n !== w.TH && n !== w.THEAD && n !== w.TR && rr(e, t);
}
function rr(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, e._processTokenInBodyMode(t), e.fosterParentingEnabled = n;
}
function tee(e, t) {
  e.pendingCharacterTokens.push(t);
}
function nee(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function Do(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; n < e.pendingCharacterTokens.length; n++)
      rr(e, e.pendingCharacterTokens[n]);
  else
    for (; n < e.pendingCharacterTokens.length; n++)
      e._insertCharacters(e.pendingCharacterTokens[n]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function ree(e, t) {
  const n = t.tagName;
  n === w.CAPTION || n === w.COL || n === w.COLGROUP || n === w.TBODY || n === w.TD || n === w.TFOOT || n === w.TH || n === w.THEAD || n === w.TR ? e.openElements.hasInTableScope(w.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(w.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = mn, e._processToken(t)) : Hn(e, t);
}
function iee(e, t) {
  const n = t.tagName;
  n === w.CAPTION || n === w.TABLE ? e.openElements.hasInTableScope(w.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(w.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = mn, n === w.TABLE && e._processToken(t)) : n !== w.BODY && n !== w.COL && n !== w.COLGROUP && n !== w.HTML && n !== w.TBODY && n !== w.TD && n !== w.TFOOT && n !== w.TH && n !== w.THEAD && n !== w.TR && t0(e, t);
}
function aee(e, t) {
  const n = t.tagName;
  n === w.HTML ? Hn(e, t) : n === w.COL ? (e._appendElement(t, Re.HTML), t.ackSelfClosing = !0) : n === w.TEMPLATE ? an(e, t) : Xc(e, t);
}
function see(e, t) {
  const n = t.tagName;
  n === w.COLGROUP ? e.openElements.currentTagName === w.COLGROUP && (e.openElements.pop(), e.insertionMode = mn) : n === w.TEMPLATE ? Za(e, t) : n !== w.COL && Xc(e, t);
}
function Xc(e, t) {
  e.openElements.currentTagName === w.COLGROUP && (e.openElements.pop(), e.insertionMode = mn, e._processToken(t));
}
function oee(e, t) {
  const n = t.tagName;
  n === w.TR ? (e.openElements.clearBackToTableBodyContext(), e._insertElement(t, Re.HTML), e.insertionMode = ki) : n === w.TH || n === w.TD ? (e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(w.TR), e.insertionMode = ki, e._processToken(t)) : n === w.CAPTION || n === w.COL || n === w.COLGROUP || n === w.TBODY || n === w.TFOOT || n === w.THEAD ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = mn, e._processToken(t)) : n0(e, t);
}
function lee(e, t) {
  const n = t.tagName;
  n === w.TBODY || n === w.TFOOT || n === w.THEAD ? e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = mn) : n === w.TABLE ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = mn, e._processToken(t)) : (n !== w.BODY && n !== w.CAPTION && n !== w.COL && n !== w.COLGROUP || n !== w.HTML && n !== w.TD && n !== w.TH && n !== w.TR) && r0(e, t);
}
function uee(e, t) {
  const n = t.tagName;
  n === w.TH || n === w.TD ? (e.openElements.clearBackToTableRowContext(), e._insertElement(t, Re.HTML), e.insertionMode = F1, e.activeFormattingElements.insertMarker()) : n === w.CAPTION || n === w.COL || n === w.COLGROUP || n === w.TBODY || n === w.TFOOT || n === w.THEAD || n === w.TR ? e.openElements.hasInTableScope(w.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = fr, e._processToken(t)) : n0(e, t);
}
function cee(e, t) {
  const n = t.tagName;
  n === w.TR ? e.openElements.hasInTableScope(w.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = fr) : n === w.TABLE ? e.openElements.hasInTableScope(w.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = fr, e._processToken(t)) : n === w.TBODY || n === w.TFOOT || n === w.THEAD ? (e.openElements.hasInTableScope(n) || e.openElements.hasInTableScope(w.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = fr, e._processToken(t)) : (n !== w.BODY && n !== w.CAPTION && n !== w.COL && n !== w.COLGROUP || n !== w.HTML && n !== w.TD && n !== w.TH) && r0(e, t);
}
function dee(e, t) {
  const n = t.tagName;
  n === w.CAPTION || n === w.COL || n === w.COLGROUP || n === w.TBODY || n === w.TD || n === w.TFOOT || n === w.TH || n === w.THEAD || n === w.TR ? (e.openElements.hasInTableScope(w.TD) || e.openElements.hasInTableScope(w.TH)) && (e._closeTableCell(), e._processToken(t)) : Hn(e, t);
}
function fee(e, t) {
  const n = t.tagName;
  n === w.TD || n === w.TH ? e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = ki) : n === w.TABLE || n === w.TBODY || n === w.TFOOT || n === w.THEAD || n === w.TR ? e.openElements.hasInTableScope(n) && (e._closeTableCell(), e._processToken(t)) : n !== w.BODY && n !== w.CAPTION && n !== w.COL && n !== w.COLGROUP && n !== w.HTML && t0(e, t);
}
function fC(e, t) {
  const n = t.tagName;
  n === w.HTML ? Hn(e, t) : n === w.OPTION ? (e.openElements.currentTagName === w.OPTION && e.openElements.pop(), e._insertElement(t, Re.HTML)) : n === w.OPTGROUP ? (e.openElements.currentTagName === w.OPTION && e.openElements.pop(), e.openElements.currentTagName === w.OPTGROUP && e.openElements.pop(), e._insertElement(t, Re.HTML)) : n === w.INPUT || n === w.KEYGEN || n === w.TEXTAREA || n === w.SELECT ? e.openElements.hasInSelectScope(w.SELECT) && (e.openElements.popUntilTagNamePopped(w.SELECT), e._resetInsertionMode(), n !== w.SELECT && e._processToken(t)) : (n === w.SCRIPT || n === w.TEMPLATE) && an(e, t);
}
function hC(e, t) {
  const n = t.tagName;
  if (n === w.OPTGROUP) {
    const r = e.openElements.items[e.openElements.stackTop - 1], i = r && e.treeAdapter.getTagName(r);
    e.openElements.currentTagName === w.OPTION && i === w.OPTGROUP && e.openElements.pop(), e.openElements.currentTagName === w.OPTGROUP && e.openElements.pop();
  } else
    n === w.OPTION ? e.openElements.currentTagName === w.OPTION && e.openElements.pop() : n === w.SELECT && e.openElements.hasInSelectScope(w.SELECT) ? (e.openElements.popUntilTagNamePopped(w.SELECT), e._resetInsertionMode()) : n === w.TEMPLATE && Za(e, t);
}
function hee(e, t) {
  const n = t.tagName;
  n === w.CAPTION || n === w.TABLE || n === w.TBODY || n === w.TFOOT || n === w.THEAD || n === w.TR || n === w.TD || n === w.TH ? (e.openElements.popUntilTagNamePopped(w.SELECT), e._resetInsertionMode(), e._processToken(t)) : fC(e, t);
}
function pee(e, t) {
  const n = t.tagName;
  n === w.CAPTION || n === w.TABLE || n === w.TBODY || n === w.TFOOT || n === w.THEAD || n === w.TR || n === w.TD || n === w.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(w.SELECT), e._resetInsertionMode(), e._processToken(t)) : hC(e, t);
}
function mee(e, t) {
  const n = t.tagName;
  if (n === w.BASE || n === w.BASEFONT || n === w.BGSOUND || n === w.LINK || n === w.META || n === w.NOFRAMES || n === w.SCRIPT || n === w.STYLE || n === w.TEMPLATE || n === w.TITLE)
    an(e, t);
  else {
    const r = ZX[n] || Yr;
    e._popTmplInsertionMode(), e._pushTmplInsertionMode(r), e.insertionMode = r, e._processToken(t);
  }
}
function gee(e, t) {
  t.tagName === w.TEMPLATE && Za(e, t);
}
function pC(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(w.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode(), e._processToken(t)) : e.stopped = !0;
}
function vee(e, t) {
  t.tagName === w.HTML ? Hn(e, t) : Jc(e, t);
}
function yee(e, t) {
  t.tagName === w.HTML ? e.fragmentContext || (e.insertionMode = cC) : Jc(e, t);
}
function Jc(e, t) {
  e.insertionMode = Yr, e._processToken(t);
}
function Eee(e, t) {
  const n = t.tagName;
  n === w.HTML ? Hn(e, t) : n === w.FRAMESET ? e._insertElement(t, Re.HTML) : n === w.FRAME ? (e._appendElement(t, Re.HTML), t.ackSelfClosing = !0) : n === w.NOFRAMES && an(e, t);
}
function bee(e, t) {
  t.tagName === w.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagName !== w.FRAMESET && (e.insertionMode = uC));
}
function Tee(e, t) {
  const n = t.tagName;
  n === w.HTML ? Hn(e, t) : n === w.NOFRAMES && an(e, t);
}
function _ee(e, t) {
  t.tagName === w.HTML && (e.insertionMode = dC);
}
function Cee(e, t) {
  t.tagName === w.HTML ? Hn(e, t) : xc(e, t);
}
function xc(e, t) {
  e.insertionMode = Yr, e._processToken(t);
}
function xee(e, t) {
  const n = t.tagName;
  n === w.HTML ? Hn(e, t) : n === w.NOFRAMES && an(e, t);
}
function wee(e, t) {
  t.chars = WX.REPLACEMENT_CHARACTER, e._insertCharacters(t);
}
function Aee(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function See(e, t) {
  if (qr.causesExit(t) && !e.fragmentContext) {
    for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== Re.HTML && !e._isIntegrationPoint(e.openElements.current); )
      e.openElements.pop();
    e._processToken(t);
  } else {
    const n = e._getAdjustedCurrentElement(), r = e.treeAdapter.getNamespaceURI(n);
    r === Re.MATHML ? qr.adjustTokenMathMLAttrs(t) : r === Re.SVG && (qr.adjustTokenSVGTagName(t), qr.adjustTokenSVGAttrs(t)), qr.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, r) : e._insertElement(t, r), t.ackSelfClosing = !0;
  }
}
function kee(e, t) {
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const r = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(r) === Re.HTML) {
      e._processToken(t);
      break;
    }
    if (e.treeAdapter.getTagName(r).toLowerCase() === t.tagName) {
      e.openElements.popUntilElementPopped(r);
      break;
    }
  }
}
const Dee = /* @__PURE__ */ Or(XX), mC = gC("start"), Oee = gC("end");
function gC(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: r.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: r.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
const vC = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(e) {
    if (e == null)
      return Ree;
    if (typeof e == "string")
      return Pee(e);
    if (typeof e == "object")
      return Array.isArray(e) ? Nee(e) : Iee(e);
    if (typeof e == "function")
      return M1(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function Nee(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = vC(e[n]);
  return M1(r);
  function r(...i) {
    let a = -1;
    for (; ++a < t.length; )
      if (t[a].call(this, ...i))
        return !0;
    return !1;
  }
}
function Iee(e) {
  return M1(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function Pee(e) {
  return M1(t);
  function t(n) {
    return n && n.type === e;
  }
}
function M1(e) {
  return t;
  function t(n, ...r) {
    return !!(n && typeof n == "object" && "type" in n && e.call(this, n, ...r));
  }
}
function Ree() {
  return !0;
}
const Fee = !0, ly = !1, Bee = "skip", Mee = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
    const i = vC(t), a = r ? -1 : 1;
    s(e, void 0, [])();
    function s(o, l, u) {
      const c = o && typeof o == "object" ? o : {};
      if (typeof c.type == "string") {
        const f = (
          // `hast`
          typeof c.tagName == "string" ? c.tagName : (
            // `xast`
            typeof c.name == "string" ? c.name : void 0
          )
        );
        Object.defineProperty(d, "name", {
          value: "node (" + (o.type + (f ? "<" + f + ">" : "")) + ")"
        });
      }
      return d;
      function d() {
        let f = [], p, g, m;
        if ((!t || i(o, l, u[u.length - 1] || null)) && (f = Lee(n(o, u)), f[0] === ly))
          return f;
        if (o.children && f[0] !== Bee)
          for (g = (r ? o.children.length : -1) + a, m = u.concat(o); g > -1 && g < o.children.length; ) {
            if (p = s(o.children[g], g, m)(), p[0] === ly)
              return p;
            g = typeof p[1] == "number" ? p[1] : g + a;
          }
        return f;
      }
    }
  }
);
function Lee(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Fee, e] : [e];
}
const $ee = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), Mee(e, t, i, r);
    function i(a, s) {
      const o = s[s.length - 1];
      return n(
        a,
        o ? o.children.indexOf(a) : null,
        o
      );
    }
  }
);
class Gl {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
Gl.prototype.property = {};
Gl.prototype.normal = {};
Gl.prototype.space = null;
function yC(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new Gl(n, r, t);
}
function kl(e) {
  return e.toLowerCase();
}
class Er {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
Er.prototype.space = null;
Er.prototype.boolean = !1;
Er.prototype.booleanish = !1;
Er.prototype.overloadedBoolean = !1;
Er.prototype.number = !1;
Er.prototype.commaSeparated = !1;
Er.prototype.spaceSeparated = !1;
Er.prototype.commaOrSpaceSeparated = !1;
Er.prototype.mustUseProperty = !1;
Er.prototype.defined = !1;
let jee = 0;
const Ye = Qa(), Yt = Qa(), EC = Qa(), Te = Qa(), It = Qa(), Ns = Qa(), zn = Qa();
function Qa() {
  return 2 ** ++jee;
}
const tp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Ye,
  booleanish: Yt,
  commaOrSpaceSeparated: zn,
  commaSeparated: Ns,
  number: Te,
  overloadedBoolean: EC,
  spaceSeparated: It
}, Symbol.toStringTag, { value: "Module" })), $f = Object.keys(tp);
class i0 extends Er {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let a = -1;
    if (super(t, n), uy(this, "space", i), typeof r == "number")
      for (; ++a < $f.length; ) {
        const s = $f[a];
        uy(this, $f[a], (r & tp[s]) === tp[s]);
      }
  }
}
i0.prototype.defined = !0;
function uy(e, t, n) {
  n && (e[t] = n);
}
const Hee = {}.hasOwnProperty;
function io(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (Hee.call(e.properties, r)) {
      const i = e.properties[r], a = new i0(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[kl(r)] = r, n[kl(a.attribute)] = r;
    }
  return new Gl(t, n, e.space);
}
const bC = io({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), TC = io({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function _C(e, t) {
  return t in e ? e[t] : t;
}
function CC(e, t) {
  return _C(e, t.toLowerCase());
}
const xC = io({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: CC,
  properties: { xmlns: null, xmlnsXLink: null }
}), wC = io({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Yt,
    ariaAutoComplete: null,
    ariaBusy: Yt,
    ariaChecked: Yt,
    ariaColCount: Te,
    ariaColIndex: Te,
    ariaColSpan: Te,
    ariaControls: It,
    ariaCurrent: null,
    ariaDescribedBy: It,
    ariaDetails: null,
    ariaDisabled: Yt,
    ariaDropEffect: It,
    ariaErrorMessage: null,
    ariaExpanded: Yt,
    ariaFlowTo: It,
    ariaGrabbed: Yt,
    ariaHasPopup: null,
    ariaHidden: Yt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: It,
    ariaLevel: Te,
    ariaLive: null,
    ariaModal: Yt,
    ariaMultiLine: Yt,
    ariaMultiSelectable: Yt,
    ariaOrientation: null,
    ariaOwns: It,
    ariaPlaceholder: null,
    ariaPosInSet: Te,
    ariaPressed: Yt,
    ariaReadOnly: Yt,
    ariaRelevant: null,
    ariaRequired: Yt,
    ariaRoleDescription: It,
    ariaRowCount: Te,
    ariaRowIndex: Te,
    ariaRowSpan: Te,
    ariaSelected: Yt,
    ariaSetSize: Te,
    ariaSort: null,
    ariaValueMax: Te,
    ariaValueMin: Te,
    ariaValueNow: Te,
    ariaValueText: null,
    role: null
  }
}), Uee = io({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: CC,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Ns,
    acceptCharset: It,
    accessKey: It,
    action: null,
    allow: null,
    allowFullScreen: Ye,
    allowPaymentRequest: Ye,
    allowUserMedia: Ye,
    alt: null,
    as: null,
    async: Ye,
    autoCapitalize: null,
    autoComplete: It,
    autoFocus: Ye,
    autoPlay: Ye,
    blocking: It,
    capture: null,
    charSet: null,
    checked: Ye,
    cite: null,
    className: It,
    cols: Te,
    colSpan: null,
    content: null,
    contentEditable: Yt,
    controls: Ye,
    controlsList: It,
    coords: Te | Ns,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Ye,
    defer: Ye,
    dir: null,
    dirName: null,
    disabled: Ye,
    download: EC,
    draggable: Yt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Ye,
    formTarget: null,
    headers: It,
    height: Te,
    hidden: Ye,
    high: Te,
    href: null,
    hrefLang: null,
    htmlFor: It,
    httpEquiv: It,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Ye,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Ye,
    itemId: null,
    itemProp: It,
    itemRef: It,
    itemScope: Ye,
    itemType: It,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Ye,
    low: Te,
    manifest: null,
    max: null,
    maxLength: Te,
    media: null,
    method: null,
    min: null,
    minLength: Te,
    multiple: Ye,
    muted: Ye,
    name: null,
    nonce: null,
    noModule: Ye,
    noValidate: Ye,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Ye,
    optimum: Te,
    pattern: null,
    ping: It,
    placeholder: null,
    playsInline: Ye,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Ye,
    referrerPolicy: null,
    rel: It,
    required: Ye,
    reversed: Ye,
    rows: Te,
    rowSpan: Te,
    sandbox: It,
    scope: null,
    scoped: Ye,
    seamless: Ye,
    selected: Ye,
    shadowRootClonable: Ye,
    shadowRootDelegatesFocus: Ye,
    shadowRootMode: null,
    shape: null,
    size: Te,
    sizes: null,
    slot: null,
    span: Te,
    spellCheck: Yt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Te,
    step: null,
    style: null,
    tabIndex: Te,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Ye,
    useMap: null,
    value: Yt,
    width: Te,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: It,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Te,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Te,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Ye,
    // Lists. Use CSS to reduce space between items instead
    declare: Ye,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Te,
    // `<img>` and `<object>`
    leftMargin: Te,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Te,
    // `<body>`
    marginWidth: Te,
    // `<body>`
    noResize: Ye,
    // `<frame>`
    noHref: Ye,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Ye,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Ye,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Te,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Yt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Te,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Te,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Ye,
    disableRemotePlayback: Ye,
    prefix: null,
    property: null,
    results: Te,
    security: null,
    unselectable: null
  }
}), zee = io({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: _C,
  properties: {
    about: zn,
    accentHeight: Te,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Te,
    amplitude: Te,
    arabicForm: null,
    ascent: Te,
    attributeName: null,
    attributeType: null,
    azimuth: Te,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Te,
    by: null,
    calcMode: null,
    capHeight: Te,
    className: It,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Te,
    diffuseConstant: Te,
    direction: null,
    display: null,
    dur: null,
    divisor: Te,
    dominantBaseline: null,
    download: Ye,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Te,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Te,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Te,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Ns,
    g2: Ns,
    glyphName: Ns,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Te,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Te,
    horizOriginX: Te,
    horizOriginY: Te,
    id: null,
    ideographic: Te,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Te,
    k: Te,
    k1: Te,
    k2: Te,
    k3: Te,
    k4: Te,
    kernelMatrix: zn,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Te,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Te,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Te,
    overlineThickness: Te,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Te,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: It,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Te,
    pointsAtY: Te,
    pointsAtZ: Te,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: zn,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: zn,
    rev: zn,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: zn,
    requiredFeatures: zn,
    requiredFonts: zn,
    requiredFormats: zn,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Te,
    specularExponent: Te,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Te,
    strikethroughThickness: Te,
    string: null,
    stroke: null,
    strokeDashArray: zn,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Te,
    strokeOpacity: Te,
    strokeWidth: null,
    style: null,
    surfaceScale: Te,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: zn,
    tabIndex: Te,
    tableValues: null,
    target: null,
    targetX: Te,
    targetY: Te,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: zn,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Te,
    underlineThickness: Te,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Te,
    values: null,
    vAlphabetic: Te,
    vMathematical: Te,
    vectorEffect: null,
    vHanging: Te,
    vIdeographic: Te,
    version: null,
    vertAdvY: Te,
    vertOriginX: Te,
    vertOriginY: Te,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Te,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), qee = /^data[-\w.:]+$/i, cy = /-[a-z]/g, Wee = /[A-Z]/g;
function a0(e, t) {
  const n = kl(t);
  let r = t, i = Er;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && qee.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(cy, Kee);
      r = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!cy.test(a)) {
        let s = a.replace(Wee, Vee);
        s.charAt(0) !== "-" && (s = "-" + s), t = "data" + s;
      }
    }
    i = i0;
  }
  return new i(r, t);
}
function Vee(e) {
  return "-" + e.toLowerCase();
}
function Kee(e) {
  return e.charAt(1).toUpperCase();
}
const L1 = yC([TC, bC, xC, wC, Uee], "html"), Yl = yC([TC, bC, xC, wC, zee], "svg"), dy = /[#.]/g;
function Gee(e, t) {
  const n = e || "", r = {};
  let i = 0, a, s;
  for (; i < n.length; ) {
    dy.lastIndex = i;
    const o = dy.exec(n), l = n.slice(i, o ? o.index : n.length);
    l && (a ? a === "#" ? r.id = l : Array.isArray(r.className) ? r.className.push(l) : r.className = [l] : s = l, i += l.length), o && (a = o[0], i++);
  }
  return {
    type: "element",
    // @ts-expect-error: fine.
    tagName: s || t || "div",
    properties: r,
    children: []
  };
}
function fy(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function Yee(e) {
  return e.join(" ").trim();
}
function hy(e) {
  const t = [], n = String(e || "");
  let r = n.indexOf(","), i = 0, a = !1;
  for (; !a; ) {
    r === -1 && (r = n.length, a = !0);
    const s = n.slice(i, r).trim();
    (s || !a) && t.push(s), i = r + 1, r = n.indexOf(",", i);
  }
  return t;
}
function Zee(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const Qee = /* @__PURE__ */ new Set(["menu", "submit", "reset", "button"]), np = {}.hasOwnProperty;
function AC(e, t, n) {
  const r = n && tte(n);
  return (
    /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */
    /**
     * Hyperscript compatible DSL for creating virtual hast trees.
     *
     * @param {string | null} [selector]
     * @param {HProperties | HChild} [properties]
     * @param {Array<HChild>} children
     * @returns {HResult}
     */
    function(a, s, ...o) {
      let l = -1, u;
      if (a == null)
        u = { type: "root", children: [] }, o.unshift(s);
      else if (u = Gee(a, t), u.tagName = u.tagName.toLowerCase(), r && np.call(r, u.tagName) && (u.tagName = r[u.tagName]), Xee(s, u.tagName)) {
        let c;
        for (c in s)
          np.call(s, c) && Jee(e, u.properties, c, s[c]);
      } else
        o.unshift(s);
      for (; ++l < o.length; )
        rp(u.children, o[l]);
      return u.type === "element" && u.tagName === "template" && (u.content = { type: "root", children: u.children }, u.children = []), u;
    }
  );
}
function Xee(e, t) {
  return e == null || typeof e != "object" || Array.isArray(e) ? !1 : t === "input" || !e.type || typeof e.type != "string" ? !0 : "children" in e && Array.isArray(e.children) ? !1 : t === "button" ? Qee.has(e.type.toLowerCase()) : !("value" in e);
}
function Jee(e, t, n, r) {
  const i = a0(e, n);
  let a = -1, s;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r))
        return;
      s = r;
    } else
      typeof r == "boolean" ? s = r : typeof r == "string" ? i.spaceSeparated ? s = fy(r) : i.commaSeparated ? s = hy(r) : i.commaOrSpaceSeparated ? s = fy(hy(r).join(" ")) : s = py(i, i.property, r) : Array.isArray(r) ? s = r.concat() : s = i.property === "style" ? ete(r) : String(r);
    if (Array.isArray(s)) {
      const o = [];
      for (; ++a < s.length; )
        o[a] = py(i, i.property, s[a]);
      s = o;
    }
    i.property === "className" && Array.isArray(t.className) && (s = t.className.concat(s)), t[i.property] = s;
  }
}
function rp(e, t) {
  let n = -1;
  if (t != null)
    if (typeof t == "string" || typeof t == "number")
      e.push({ type: "text", value: String(t) });
    else if (Array.isArray(t))
      for (; ++n < t.length; )
        rp(e, t[n]);
    else if (typeof t == "object" && "type" in t)
      t.type === "root" ? rp(e, t.children) : e.push(t);
    else
      throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function py(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || kl(n) === kl(t)))
      return !0;
  }
  return n;
}
function ete(e) {
  const t = [];
  let n;
  for (n in e)
    np.call(e, n) && t.push([n, e[n]].join(": "));
  return t.join("; ");
}
function tte(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    t[e[n].toLowerCase()] = e[n];
  return t;
}
const nte = AC(L1, "div"), rte = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], ite = AC(Yl, "g", rte);
function ate(e) {
  const t = String(e), n = [], r = /\r?\n|\r/g;
  for (; r.test(t); )
    n.push(r.lastIndex);
  return n.push(t.length + 1), { toPoint: i, toOffset: a };
  function i(s) {
    let o = -1;
    if (typeof s == "number" && s > -1 && s < n[n.length - 1]) {
      for (; ++o < n.length; )
        if (n[o] > s)
          return {
            line: o + 1,
            column: s - (o > 0 ? n[o - 1] : 0) + 1,
            offset: s
          };
    }
    return { line: void 0, column: void 0, offset: void 0 };
  }
  function a(s) {
    const o = s && s.line, l = s && s.column;
    if (typeof o == "number" && typeof l == "number" && !Number.isNaN(o) && !Number.isNaN(l) && o - 1 in n) {
      const u = (n[o - 2] || 0) + l - 1 || 0;
      if (u > -1 && u < n[n.length - 1])
        return u;
    }
    return -1;
  }
}
const Dl = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, SC = {}.hasOwnProperty, ste = Object.prototype;
function ote(e, t) {
  const n = t || {};
  let r, i;
  return cte(n) ? (i = n, r = {}) : (i = n.file || void 0, r = n), s0(
    {
      schema: r.space === "svg" ? Yl : L1,
      file: i,
      verbose: r.verbose,
      location: !1
    },
    e
  );
}
function s0(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const r = (
        /** @type {P5Comment} */
        t
      );
      return n = { type: "comment", value: r.data }, wc(e, r, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const r = (
        /** @type {P5Document | P5DocumentFragment} */
        t
      ), i = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: kC(e, t.childNodes),
        data: { quirksMode: i }
      }, e.file && e.location) {
        const a = String(e.file), s = ate(a), o = s.toPoint(0), l = s.toPoint(a.length);
        n.position = { start: o, end: l };
      }
      return n;
    }
    case "#documentType": {
      const r = (
        /** @type {P5DocumentType} */
        t
      );
      return n = { type: "doctype" }, wc(e, r, n), n;
    }
    case "#text": {
      const r = (
        /** @type {P5Text} */
        t
      );
      return n = { type: "text", value: r.value }, wc(e, r, n), n;
    }
    default:
      return n = lte(
        e,
        /** @type {P5Element} */
        t
      ), n;
  }
}
function kC(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    r[n] = s0(e, t[n]);
  return r;
}
function lte(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === Dl.svg ? Yl : L1;
  let r = -1;
  const i = {};
  for (; ++r < t.attrs.length; ) {
    const o = t.attrs[r], l = (o.prefix ? o.prefix + ":" : "") + o.name;
    SC.call(ste, l) || (i[l] = o.value);
  }
  const s = (e.schema.space === "svg" ? ite : nte)(t.tagName, i, kC(e, t.childNodes));
  if (wc(e, t, s), s.tagName === "template") {
    const o = (
      /** @type {P5Template} */
      t
    ), l = o.sourceCodeLocation, u = l && l.startTag && ws(l.startTag), c = l && l.endTag && ws(l.endTag), d = s0(e, o.content);
    u && c && e.file && (d.position = { start: u.end, end: c.start }), s.content = d;
  }
  return e.schema = n, s;
}
function wc(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const r = ute(e, n, t.sourceCodeLocation);
    r && (e.location = !0, n.position = r);
  }
}
function ute(e, t, n) {
  const r = ws(n);
  if (t.type === "element") {
    const i = t.children[t.children.length - 1];
    if (r && !n.endTag && i && i.position && i.position.end && (r.end = Object.assign({}, i.position.end)), e.verbose) {
      const a = {};
      let s;
      if (n.attrs)
        for (s in n.attrs)
          SC.call(n.attrs, s) && (a[a0(e.schema, s).property] = ws(
            n.attrs[s]
          ));
      t.data = {
        position: {
          // @ts-expect-error: assume not `undefined`.
          opening: ws(n.startTag),
          closing: n.endTag ? ws(n.endTag) : null,
          properties: a
        }
      };
    }
  }
  return r;
}
function ws(e) {
  const t = my({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = my({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function my(e) {
  return e.line && e.column ? e : void 0;
}
function cte(e) {
  return "messages" in e;
}
const gy = {}.hasOwnProperty;
function DC(e, t) {
  const n = t || {};
  function r(i, ...a) {
    let s = r.invalid;
    const o = r.handlers;
    if (i && gy.call(i, e)) {
      const l = String(i[e]);
      s = gy.call(o, l) ? o[l] : r.unknown;
    }
    if (s)
      return s.call(this, i, ...a);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const dte = {}.hasOwnProperty, OC = DC("type", { handlers: { root: hte, element: yte, text: gte, comment: vte, doctype: mte } });
function fte(e, t) {
  const n = t && typeof t == "object" ? t.space : t;
  return OC(e, n === "svg" ? Yl : L1);
}
function hte(e, t) {
  const n = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return n.childNodes = o0(e.children, n, t), ao(e, n), n;
}
function pte(e, t) {
  const n = { nodeName: "#document-fragment", childNodes: [] };
  return n.childNodes = o0(e.children, n, t), ao(e, n), n;
}
function mte(e) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    // @ts-expect-error: change to `null` in a major?
    parentNode: void 0
  };
  return ao(e, t), t;
}
function gte(e) {
  const t = {
    nodeName: "#text",
    value: e.value,
    // @ts-expect-error: no `parentNode`
    parentNode: void 0
  };
  return ao(e, t), t;
}
function vte(e) {
  const t = {
    nodeName: "#comment",
    data: e.value,
    // @ts-expect-error: no `parentNode`
    parentNode: void 0
  };
  return ao(e, t), t;
}
function yte(e, t) {
  const n = t;
  let r = n;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && n.space === "html" && (r = Yl);
  const i = [];
  let a;
  if (e.properties) {
    for (a in e.properties)
      if (a !== "children" && dte.call(e.properties, a)) {
        const o = Ete(
          r,
          a,
          e.properties[a]
        );
        o && i.push(o);
      }
  }
  const s = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: i,
    // @ts-expect-error: html and svg both have a space.
    namespaceURI: Dl[r.space],
    childNodes: [],
    // @ts-expect-error: no `parentNode`
    parentNode: void 0
  };
  return s.childNodes = o0(e.children, s, r), ao(e, s), e.tagName === "template" && e.content && (s.content = pte(e.content, r)), s;
}
function Ete(e, t, n) {
  const r = a0(e, t);
  if (n == null || n === !1 || typeof n == "number" && Number.isNaN(n) || !n && r.boolean)
    return;
  Array.isArray(n) && (n = r.commaSeparated ? Zee(n) : Yee(n));
  const i = {
    name: r.attribute,
    value: n === !0 ? "" : String(n)
  };
  if (r.space && r.space !== "html" && r.space !== "svg") {
    const a = i.name.indexOf(":");
    a < 0 ? i.prefix = "" : (i.name = i.name.slice(a + 1), i.prefix = r.attribute.slice(0, a)), i.namespace = Dl[r.space];
  }
  return i;
}
function o0(e, t, n) {
  let r = -1;
  const i = [];
  if (e)
    for (; ++r < e.length; ) {
      const a = OC(e[r], n);
      a.parentNode = t, i.push(a);
    }
  return i;
}
function ao(e, t) {
  const n = e.position;
  n && n.start && n.end && (t.sourceCodeLocation = {
    startLine: n.start.line,
    startCol: n.start.column,
    // @ts-expect-error assume this is set.
    startOffset: n.start.offset,
    endLine: n.end.line,
    endCol: n.end.column,
    // @ts-expect-error assume this is set.
    endOffset: n.end.offset
  });
}
const bte = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "menuitem",
  "meta",
  "nextid",
  "param",
  "source",
  "track",
  "wbr"
], Tte = "IN_TEMPLATE_MODE", _te = "DATA_STATE", Cte = "CHARACTER_TOKEN", xte = "START_TAG_TOKEN", wte = "END_TAG_TOKEN", Ate = "COMMENT_TOKEN", Ste = "DOCTYPE_TOKEN", kte = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 }, NC = (
  /**
   * @type {(
   *   ((tree: Node, file: VFile|undefined, options?: Options) => Node) &
   *   ((tree: Node, options?: Options) => Node)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {VFile} [file]
   * @param {Options} [options]
   */
  function(e, t, n) {
    let r = -1;
    const i = new Dee(kte), a = DC("type", {
      handlers: { root: m, element: y, text: v, comment: b, doctype: E, raw: _ },
      // @ts-expect-error: hush.
      unknown: Ite
    });
    let s, o, l, u, c;
    if (Rte(t) && (n = t, t = void 0), n && n.passThrough)
      for (; ++r < n.passThrough.length; )
        a.handlers[n.passThrough[r]] = T;
    const d = ote(
      Pte(e) ? p() : f(),
      t
    );
    if (s && $ee(d, "comment", (A, R, P) => {
      const L = (
        /** @type {Stitch} */
        /** @type {unknown} */
        A
      );
      if (L.value.stitch && P !== null && R !== null)
        return P.children[R] = L.value.stitch, R;
    }), e.type !== "root" && d.type === "root" && d.children.length === 1)
      return d.children[0];
    return d;
    function f() {
      const A = {
        nodeName: "template",
        tagName: "template",
        attrs: [],
        namespaceURI: Dl.html,
        childNodes: []
      }, R = {
        nodeName: "documentmock",
        tagName: "documentmock",
        attrs: [],
        namespaceURI: Dl.html,
        childNodes: []
      }, P = { nodeName: "#document-fragment", childNodes: [] };
      if (i._bootstrap(R, A), i._pushTmplInsertionMode(Tte), i._initTokenizerForFragmentParsing(), i._insertFakeRootElement(), i._resetInsertionMode(), i._findFormInFragmentContext(), o = i.tokenizer, !o)
        throw new Error("Expected `tokenizer`");
      return l = o.preprocessor, c = o.__mixins[0], u = c.posTracker, a(e), x(), i._adoptNodes(R.childNodes[0], P), P;
    }
    function p() {
      const A = i.treeAdapter.createDocument();
      if (i._bootstrap(A, void 0), o = i.tokenizer, !o)
        throw new Error("Expected `tokenizer`");
      return l = o.preprocessor, c = o.__mixins[0], u = c.posTracker, a(e), x(), A;
    }
    function g(A) {
      let R = -1;
      if (A)
        for (; ++R < A.length; )
          a(A[R]);
    }
    function m(A) {
      g(A.children);
    }
    function y(A) {
      x(), i._processInputToken(Dte(A)), g(A.children), bte.includes(A.tagName) || (x(), i._processInputToken(Nte(A)));
    }
    function v(A) {
      x(), i._processInputToken({
        type: Cte,
        chars: A.value,
        location: As(A)
      });
    }
    function E(A) {
      x(), i._processInputToken({
        type: Ste,
        name: "html",
        forceQuirks: !1,
        publicId: "",
        systemId: "",
        location: As(A)
      });
    }
    function b(A) {
      x(), i._processInputToken({
        type: Ate,
        data: A.value,
        location: As(A)
      });
    }
    function _(A) {
      const R = mC(A), P = R.line || 1, L = R.column || 1, I = R.offset || 0;
      if (!l)
        throw new Error("Expected `preprocessor`");
      if (!o)
        throw new Error("Expected `tokenizer`");
      if (!u)
        throw new Error("Expected `posTracker`");
      if (!c)
        throw new Error("Expected `locationTracker`");
      l.html = void 0, l.pos = -1, l.lastGapPos = -1, l.lastCharPos = -1, l.gapStack = [], l.skipNextNewLine = !1, l.lastChunkWritten = !1, l.endOfChunkHit = !1, u.isEol = !1, u.lineStartPos = -L + 1, u.droppedBufferSize = I, u.offset = 0, u.col = 1, u.line = P, c.currentAttrLocation = void 0, c.ctLoc = As(A), o.write(A.value), i._runParsingLoop(null), (o.state === "NAMED_CHARACTER_REFERENCE_STATE" || o.state === "NUMERIC_CHARACTER_REFERENCE_END_STATE") && (l.lastChunkWritten = !0, o[o.state](o._consume()));
    }
    function T(A) {
      s = !0;
      let R;
      "children" in A ? R = {
        ...A,
        children: NC(
          { type: "root", children: A.children },
          t,
          n
          // @ts-expect-error Assume a given parent yields a parent.
        ).children
      } : R = { ...A }, b({ type: "comment", value: { stitch: R } });
    }
    function x() {
      if (!o)
        throw new Error("Expected `tokenizer`");
      if (!u)
        throw new Error("Expected `posTracker`");
      const A = o.currentCharacterToken;
      A && (A.location.endLine = u.line, A.location.endCol = u.col + 1, A.location.endOffset = u.offset + 1, i._processInputToken(A)), o.tokenQueue = [], o.state = _te, o.returnState = "", o.charRefCode = -1, o.tempBuff = [], o.lastStartTagName = "", o.consumedAfterSnapshot = -1, o.active = !1, o.currentCharacterToken = void 0, o.currentToken = void 0, o.currentAttr = void 0;
    }
  }
);
function Dte(e) {
  const t = Object.assign(As(e));
  return t.startTag = Object.assign({}, t), {
    type: xte,
    tagName: e.tagName,
    selfClosing: !1,
    attrs: Ote(e),
    location: t
  };
}
function Ote(e) {
  return fte({
    tagName: e.tagName,
    type: "element",
    properties: e.properties,
    children: []
    // @ts-expect-error Assume element.
  }).attrs;
}
function Nte(e) {
  const t = Object.assign(As(e));
  return t.startTag = Object.assign({}, t), {
    type: wte,
    tagName: e.tagName,
    attrs: [],
    location: t
  };
}
function Ite(e) {
  throw new Error("Cannot compile `" + e.type + "` node");
}
function Pte(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName === "html"));
}
function As(e) {
  const t = mC(e), n = Oee(e);
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: n.line,
    endCol: n.column,
    endOffset: n.offset
  };
}
function Rte(e) {
  return !!(e && !("message" in e && "messages" in e));
}
function IC(e = {}) {
  return (t, n) => (
    /** @type {Root} */
    NC(t, n, e)
  );
}
function Zu(e) {
  const t = new Date(e);
  if (!Number.isNaN(t.valueOf()))
    return t;
  const n = String(e).match(/\d+/g);
  if (n == null || n.length <= 2)
    return t;
  {
    const [r, i, ...a] = n.map((l) => parseInt(l)), s = [r, i - 1, ...a];
    return new Date(Date.UTC(...s));
  }
}
function vy(e, t, n) {
  const r = e !== 1 ? t + "s" : t;
  return e + " " + r + " " + n;
}
function ip() {
  return ip = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ip.apply(this, arguments);
}
const $o = 60, jo = $o * 60, Is = jo * 24, Qu = Is * 7, yy = Is * 30, Ey = Is * 365, Fte = () => Date.now();
function PC({
  date: e,
  formatter: t = vy,
  component: n = "time",
  live: r = !0,
  minPeriod: i = 0,
  maxPeriod: a = Qu,
  title: s,
  now: o = Fte,
  ...l
}) {
  const [u, c] = de(o());
  pe(() => {
    if (!r)
      return;
    const T = (() => {
      const x = Zu(e).valueOf();
      if (!x)
        return console.warn("[react-timeago] Invalid Date provided"), 0;
      const A = Math.round(Math.abs(u - x) / 1e3), R = A < $o ? 1e3 : A < jo ? 1e3 * $o : A < Is ? 1e3 * jo : 1e3 * Qu, P = Math.min(Math.max(R, i * 1e3), a * 1e3);
      return P ? setTimeout(() => {
        c(o());
      }, P) : 0;
    })();
    return () => {
      T && clearTimeout(T);
    };
  }, [e, r, a, i, o, u]);
  const d = n, f = Zu(e).valueOf();
  if (!f)
    return null;
  const p = Math.round(Math.abs(u - f) / 1e3), g = f < u ? "ago" : "from now", [m, y] = p < $o ? [Math.round(p), "second"] : p < jo ? [Math.round(p / $o), "minute"] : p < Is ? [Math.round(p / jo), "hour"] : p < Qu ? [Math.round(p / Is), "day"] : p < yy ? [Math.round(p / Qu), "week"] : p < Ey ? [Math.round(p / yy), "month"] : [Math.round(p / Ey), "year"], v = typeof s > "u" ? typeof e == "string" ? e : Zu(e).toISOString().substr(0, 16).replace("T", " ") : s, E = d === "time" ? {
    ...l,
    dateTime: Zu(e).toISOString()
  } : l, b = vy.bind(null, m, y, g);
  return /* @__PURE__ */ dn.createElement(d, ip({}, E, {
    title: v
  }), t(m, y, g, f, b, o));
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var ap = function(e, t) {
  return ap = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      r.hasOwnProperty(i) && (n[i] = r[i]);
  }, ap(e, t);
};
function Bte(e, t) {
  ap(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var il = function() {
  return il = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, il.apply(this, arguments);
};
function Mte(e, t, n, r) {
  var i, a = !1, s = 0;
  function o() {
    i && clearTimeout(i);
  }
  function l() {
    o(), a = !0;
  }
  typeof t != "boolean" && (r = n, n = t, t = void 0);
  function u() {
    var c = this, d = Date.now() - s, f = arguments;
    if (a)
      return;
    function p() {
      s = Date.now(), n.apply(c, f);
    }
    function g() {
      i = void 0;
    }
    r && !i && p(), o(), r === void 0 && d > e ? p() : t !== !0 && (i = setTimeout(r ? g : p, r === void 0 ? e - d : e));
  }
  return u.cancel = l, u;
}
var Ps = {
  Pixel: "Pixel",
  Percent: "Percent"
}, by = {
  unit: Ps.Percent,
  value: 0.8
};
function Ty(e) {
  return typeof e == "number" ? {
    unit: Ps.Percent,
    value: e * 100
  } : typeof e == "string" ? e.match(/^(\d*(\.\d+)?)px$/) ? {
    unit: Ps.Pixel,
    value: parseFloat(e)
  } : e.match(/^(\d*(\.\d+)?)%$/) ? {
    unit: Ps.Percent,
    value: parseFloat(e)
  } : (console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...'), by) : (console.warn("scrollThreshold should be string or number"), by);
}
var Lte = (
  /** @class */
  function(e) {
    Bte(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.lastScrollTop = 0, r.actionTriggered = !1, r.startY = 0, r.currentY = 0, r.dragging = !1, r.maxPullDownDistance = 0, r.getScrollableTarget = function() {
        return r.props.scrollableTarget instanceof HTMLElement ? r.props.scrollableTarget : typeof r.props.scrollableTarget == "string" ? document.getElementById(r.props.scrollableTarget) : (r.props.scrollableTarget === null && console.warn(`You are trying to pass scrollableTarget but it is null. This might
        happen because the element may not have been added to DOM yet.
        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.
      `), null);
      }, r.onStart = function(i) {
        r.lastScrollTop || (r.dragging = !0, i instanceof MouseEvent ? r.startY = i.pageY : i instanceof TouchEvent && (r.startY = i.touches[0].pageY), r.currentY = r.startY, r._infScroll && (r._infScroll.style.willChange = "transform", r._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)"));
      }, r.onMove = function(i) {
        r.dragging && (i instanceof MouseEvent ? r.currentY = i.pageY : i instanceof TouchEvent && (r.currentY = i.touches[0].pageY), !(r.currentY < r.startY) && (r.currentY - r.startY >= Number(r.props.pullDownToRefreshThreshold) && r.setState({
          pullToRefreshThresholdBreached: !0
        }), !(r.currentY - r.startY > r.maxPullDownDistance * 1.5) && r._infScroll && (r._infScroll.style.overflow = "visible", r._infScroll.style.transform = "translate3d(0px, " + (r.currentY - r.startY) + "px, 0px)")));
      }, r.onEnd = function() {
        r.startY = 0, r.currentY = 0, r.dragging = !1, r.state.pullToRefreshThresholdBreached && (r.props.refreshFunction && r.props.refreshFunction(), r.setState({
          pullToRefreshThresholdBreached: !1
        })), requestAnimationFrame(function() {
          r._infScroll && (r._infScroll.style.overflow = "auto", r._infScroll.style.transform = "none", r._infScroll.style.willChange = "unset");
        });
      }, r.onScrollListener = function(i) {
        typeof r.props.onScroll == "function" && setTimeout(function() {
          return r.props.onScroll && r.props.onScroll(i);
        }, 0);
        var a = r.props.height || r._scrollableNode ? i.target : document.documentElement.scrollTop ? document.documentElement : document.body;
        if (!r.actionTriggered) {
          var s = r.props.inverse ? r.isElementAtTop(a, r.props.scrollThreshold) : r.isElementAtBottom(a, r.props.scrollThreshold);
          s && r.props.hasMore && (r.actionTriggered = !0, r.setState({ showLoader: !0 }), r.props.next && r.props.next()), r.lastScrollTop = a.scrollTop;
        }
      }, r.state = {
        showLoader: !1,
        pullToRefreshThresholdBreached: !1,
        prevDataLength: n.dataLength
      }, r.throttledOnScrollListener = Mte(150, r.onScrollListener).bind(r), r.onStart = r.onStart.bind(r), r.onMove = r.onMove.bind(r), r.onEnd = r.onEnd.bind(r), r;
    }
    return t.prototype.componentDidMount = function() {
      if (typeof this.props.dataLength > "u")
        throw new Error('mandatory prop "dataLength" is missing. The prop is needed when loading more content. Check README.md for usage');
      if (this._scrollableNode = this.getScrollableTarget(), this.el = this.props.height ? this._infScroll : this._scrollableNode || window, this.el && this.el.addEventListener("scroll", this.throttledOnScrollListener), typeof this.props.initialScrollY == "number" && this.el && this.el instanceof HTMLElement && this.el.scrollHeight > this.props.initialScrollY && this.el.scrollTo(0, this.props.initialScrollY), this.props.pullDownToRefresh && this.el && (this.el.addEventListener("touchstart", this.onStart), this.el.addEventListener("touchmove", this.onMove), this.el.addEventListener("touchend", this.onEnd), this.el.addEventListener("mousedown", this.onStart), this.el.addEventListener("mousemove", this.onMove), this.el.addEventListener("mouseup", this.onEnd), this.maxPullDownDistance = this._pullDown && this._pullDown.firstChild && this._pullDown.firstChild.getBoundingClientRect().height || 0, this.forceUpdate(), typeof this.props.refreshFunction != "function"))
        throw new Error(`Mandatory prop "refreshFunction" missing.
          Pull Down To Refresh functionality will not work
          as expected. Check README.md for usage'`);
    }, t.prototype.componentWillUnmount = function() {
      this.el && (this.el.removeEventListener("scroll", this.throttledOnScrollListener), this.props.pullDownToRefresh && (this.el.removeEventListener("touchstart", this.onStart), this.el.removeEventListener("touchmove", this.onMove), this.el.removeEventListener("touchend", this.onEnd), this.el.removeEventListener("mousedown", this.onStart), this.el.removeEventListener("mousemove", this.onMove), this.el.removeEventListener("mouseup", this.onEnd)));
    }, t.prototype.componentDidUpdate = function(n) {
      this.props.dataLength !== n.dataLength && (this.actionTriggered = !1, this.setState({
        showLoader: !1
      }));
    }, t.getDerivedStateFromProps = function(n, r) {
      var i = n.dataLength !== r.prevDataLength;
      return i ? il(il({}, r), { prevDataLength: n.dataLength }) : null;
    }, t.prototype.isElementAtTop = function(n, r) {
      r === void 0 && (r = 0.8);
      var i = n === document.body || n === document.documentElement ? window.screen.availHeight : n.clientHeight, a = Ty(r);
      return a.unit === Ps.Pixel ? n.scrollTop <= a.value + i - n.scrollHeight + 1 : n.scrollTop <= a.value / 100 + i - n.scrollHeight + 1;
    }, t.prototype.isElementAtBottom = function(n, r) {
      r === void 0 && (r = 0.8);
      var i = n === document.body || n === document.documentElement ? window.screen.availHeight : n.clientHeight, a = Ty(r);
      return a.unit === Ps.Pixel ? n.scrollTop + i >= n.scrollHeight - a.value : n.scrollTop + i >= a.value / 100 * n.scrollHeight;
    }, t.prototype.render = function() {
      var n = this, r = il({ height: this.props.height || "auto", overflow: "auto", WebkitOverflowScrolling: "touch" }, this.props.style), i = this.props.hasChildren || !!(this.props.children && this.props.children instanceof Array && this.props.children.length), a = this.props.pullDownToRefresh && this.props.height ? { overflow: "auto" } : {};
      return M.createElement(
        "div",
        { style: a, className: "infinite-scroll-component__outerdiv" },
        M.createElement(
          "div",
          { className: "infinite-scroll-component " + (this.props.className || ""), ref: function(s) {
            return n._infScroll = s;
          }, style: r },
          this.props.pullDownToRefresh && M.createElement(
            "div",
            { style: { position: "relative" }, ref: function(s) {
              return n._pullDown = s;
            } },
            M.createElement("div", { style: {
              position: "absolute",
              left: 0,
              right: 0,
              top: -1 * this.maxPullDownDistance
            } }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)
          ),
          this.props.children,
          !this.state.showLoader && !i && this.props.hasMore && this.props.loader,
          this.state.showLoader && this.props.hasMore && this.props.loader,
          !this.props.hasMore && this.props.endMessage
        )
      );
    }, t;
  }(LE)
);
function RC(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = RC(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function Xi() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = RC(e)) && (r && (r += " "), r += t);
  return r;
}
function al(e) {
  return typeof e == "number" && !isNaN(e);
}
function Oo(e) {
  return typeof e == "boolean";
}
function Ha(e) {
  return typeof e == "string";
}
function Pn(e) {
  return typeof e == "function";
}
function Ac(e) {
  return Ha(e) || Pn(e) ? e : null;
}
function jf(e) {
  return e === 0 || e;
}
function Hf(e) {
  return ul(e) || Ha(e) || Pn(e) || al(e);
}
const FC = { TOP_LEFT: "top-left", TOP_RIGHT: "top-right", TOP_CENTER: "top-center", BOTTOM_LEFT: "bottom-left", BOTTOM_RIGHT: "bottom-right", BOTTOM_CENTER: "bottom-center" }, vi = { INFO: "info", SUCCESS: "success", WARNING: "warning", ERROR: "error", DEFAULT: "default" };
function $te(e, t, n) {
  n === void 0 && (n = 300);
  const { scrollHeight: r, style: i } = e;
  requestAnimationFrame(() => {
    i.minHeight = "initial", i.height = r + "px", i.transition = "all " + n + "ms", requestAnimationFrame(() => {
      i.height = "0", i.padding = "0", i.margin = "0", setTimeout(t, n);
    });
  });
}
function jte(e) {
  let { enter: t, exit: n, appendPosition: r = !1, collapse: i = !0, collapseDuration: a = 300 } = e;
  return function(s) {
    let { children: o, position: l, preventExitTransition: u, done: c, nodeRef: d, isIn: f } = s;
    const p = r ? t + "--" + l : t, g = r ? n + "--" + l : n, m = Ue(), y = Ue(0);
    function v(b) {
      if (b.target !== d.current)
        return;
      const _ = d.current;
      _.dispatchEvent(new Event("d")), _.removeEventListener("animationend", v), _.removeEventListener("animationcancel", v), y.current === 0 && b.type !== "animationcancel" && (_.className = m.current);
    }
    function E() {
      const b = d.current;
      b.removeEventListener("animationend", E), i ? $te(b, c, a) : c();
    }
    return ME(() => {
      (function() {
        const b = d.current;
        m.current = b.className, b.className += " " + p, b.addEventListener("animationend", v), b.addEventListener("animationcancel", v);
      })();
    }, []), pe(() => {
      f || (u ? E() : function() {
        y.current = 1;
        const b = d.current;
        b.className += " " + g, b.addEventListener("animationend", E);
      }());
    }, [f]), M.createElement(M.Fragment, null, o);
  };
}
function _y(e, t) {
  return { content: e.content, containerId: e.props.containerId, id: e.props.toastId, theme: e.props.theme, type: e.props.type, data: e.props.data || {}, isLoading: e.props.isLoading, icon: e.props.icon, status: t };
}
const ir = { list: /* @__PURE__ */ new Map(), emitQueue: /* @__PURE__ */ new Map(), on(e, t) {
  return this.list.has(e) || this.list.set(e, []), this.list.get(e).push(t), this;
}, off(e, t) {
  if (t) {
    const n = this.list.get(e).filter((r) => r !== t);
    return this.list.set(e, n), this;
  }
  return this.list.delete(e), this;
}, cancelEmit(e) {
  const t = this.emitQueue.get(e);
  return t && (t.forEach(clearTimeout), this.emitQueue.delete(e)), this;
}, emit(e) {
  this.list.has(e) && this.list.get(e).forEach((t) => {
    const n = setTimeout(() => {
      t(...[].slice.call(arguments, 1));
    }, 0);
    this.emitQueue.has(e) || this.emitQueue.set(e, []), this.emitQueue.get(e).push(n);
  });
} }, Xu = (e) => {
  let { theme: t, type: n, ...r } = e;
  return M.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: t === "colored" ? "currentColor" : "var(--toastify-icon-color-" + n + ")", ...r });
}, Uf = { info: function(e) {
  return M.createElement(Xu, { ...e }, M.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(e) {
  return M.createElement(Xu, { ...e }, M.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(e) {
  return M.createElement(Xu, { ...e }, M.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(e) {
  return M.createElement(Xu, { ...e }, M.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return M.createElement("div", { className: "Toastify__spinner" });
} };
function Hte(e) {
  const [, t] = ra((p) => p + 1, 0), [n, r] = de([]), i = Ue(null), a = Ue(/* @__PURE__ */ new Map()).current, s = (p) => n.indexOf(p) !== -1, o = Ue({ toastKey: 1, displayedToast: 0, count: 0, queue: [], props: e, containerId: null, isToastActive: s, getToast: (p) => a.get(p) }).current;
  function l(p) {
    let { containerId: g } = p;
    const { limit: m } = o.props;
    !m || g && o.containerId !== g || (o.count -= o.queue.length, o.queue = []);
  }
  function u(p) {
    r((g) => jf(p) ? g.filter((m) => m !== p) : []);
  }
  function c() {
    const { toastContent: p, toastProps: g, staleId: m } = o.queue.shift();
    f(p, g, m);
  }
  function d(p, g) {
    let { delay: m, staleId: y, ...v } = g;
    if (!Hf(p) || function(O) {
      return !i.current || o.props.enableMultiContainer && O.containerId !== o.props.containerId || a.has(O.toastId) && O.updateId == null;
    }(v))
      return;
    const { toastId: E, updateId: b, data: _ } = v, { props: T } = o, x = () => u(E), A = b == null;
    A && o.count++;
    const R = { toastId: E, updateId: b, data: _, containerId: v.containerId, isLoading: v.isLoading, theme: v.theme || T.theme, icon: v.icon != null ? v.icon : T.icon, isIn: !1, key: v.key || o.toastKey++, type: v.type, closeToast: x, closeButton: v.closeButton, rtl: T.rtl, position: v.position || T.position, transition: v.transition || T.transition, className: Ac(v.className || T.toastClassName), bodyClassName: Ac(v.bodyClassName || T.bodyClassName), style: v.style || T.toastStyle, bodyStyle: v.bodyStyle || T.bodyStyle, onClick: v.onClick || T.onClick, pauseOnHover: Oo(v.pauseOnHover) ? v.pauseOnHover : T.pauseOnHover, pauseOnFocusLoss: Oo(v.pauseOnFocusLoss) ? v.pauseOnFocusLoss : T.pauseOnFocusLoss, draggable: Oo(v.draggable) ? v.draggable : T.draggable, draggablePercent: v.draggablePercent || T.draggablePercent, draggableDirection: v.draggableDirection || T.draggableDirection, closeOnClick: Oo(v.closeOnClick) ? v.closeOnClick : T.closeOnClick, progressClassName: Ac(v.progressClassName || T.progressClassName), progressStyle: v.progressStyle || T.progressStyle, autoClose: !v.isLoading && (P = v.autoClose, L = T.autoClose, P === !1 || al(P) && P > 0 ? P : L), hideProgressBar: Oo(v.hideProgressBar) ? v.hideProgressBar : T.hideProgressBar, progress: v.progress, role: v.role || T.role, deleteToast() {
      const O = _y(a.get(E), "removed");
      a.delete(E), ir.emit(4, O);
      const S = o.queue.length;
      if (o.count = jf(E) ? o.count - 1 : o.count - o.displayedToast, o.count < 0 && (o.count = 0), S > 0) {
        const F = jf(E) ? 1 : o.props.limit;
        if (S === 1 || F === 1)
          o.displayedToast++, c();
        else {
          const H = F > S ? S : F;
          o.displayedToast = H;
          for (let q = 0; q < H; q++)
            c();
        }
      } else
        t();
    } };
    var P, L;
    R.iconOut = function(O) {
      let { theme: S, type: F, isLoading: H, icon: q } = O, N = null;
      const Q = { theme: S, type: F };
      return q === !1 || (Pn(q) ? N = q(Q) : ul(q) ? N = y0(q, Q) : Ha(q) || al(q) ? N = q : H ? N = Uf.spinner() : ((J) => J in Uf)(F) && (N = Uf[F](Q))), N;
    }(R), Pn(v.onOpen) && (R.onOpen = v.onOpen), Pn(v.onClose) && (R.onClose = v.onClose), R.closeButton = T.closeButton, v.closeButton === !1 || Hf(v.closeButton) ? R.closeButton = v.closeButton : v.closeButton === !0 && (R.closeButton = !Hf(T.closeButton) || T.closeButton);
    let I = p;
    ul(p) && !Ha(p.type) ? I = y0(p, { closeToast: x, toastProps: R, data: _ }) : Pn(p) && (I = p({ closeToast: x, toastProps: R, data: _ })), T.limit && T.limit > 0 && o.count > T.limit && A ? o.queue.push({ toastContent: I, toastProps: R, staleId: y }) : al(m) ? setTimeout(() => {
      f(I, R, y);
    }, m) : f(I, R, y);
  }
  function f(p, g, m) {
    const { toastId: y } = g;
    m && a.delete(m);
    const v = { content: p, props: g };
    a.set(y, v), r((E) => [...E, y].filter((b) => b !== m)), ir.emit(4, _y(v, v.props.updateId == null ? "added" : "updated"));
  }
  return pe(() => (o.containerId = e.containerId, ir.cancelEmit(3).on(0, d).on(1, (p) => i.current && u(p)).on(5, l).emit(2, o), () => ir.emit(3, o)), []), pe(() => {
    o.props = e, o.isToastActive = s, o.displayedToast = n.length;
  }), { getToastToRender: function(p) {
    const g = /* @__PURE__ */ new Map(), m = Array.from(a.values());
    return e.newestOnTop && m.reverse(), m.forEach((y) => {
      const { position: v } = y.props;
      g.has(v) || g.set(v, []), g.get(v).push(y);
    }), Array.from(g, (y) => p(y[0], y[1]));
  }, containerRef: i, isToastActive: s };
}
function Cy(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function xy(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function Ute(e) {
  const [t, n] = de(!1), [r, i] = de(!1), a = Ue(null), s = Ue({ start: 0, x: 0, y: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, boundingRect: null, didMove: !1 }).current, o = Ue(e), { autoClose: l, pauseOnHover: u, closeToast: c, onClick: d, closeOnClick: f } = e;
  function p(_) {
    if (e.draggable) {
      s.didMove = !1, document.addEventListener("mousemove", v), document.addEventListener("mouseup", E), document.addEventListener("touchmove", v), document.addEventListener("touchend", E);
      const T = a.current;
      s.canCloseOnClick = !0, s.canDrag = !0, s.boundingRect = T.getBoundingClientRect(), T.style.transition = "", s.x = Cy(_.nativeEvent), s.y = xy(_.nativeEvent), e.draggableDirection === "x" ? (s.start = s.x, s.removalDistance = T.offsetWidth * (e.draggablePercent / 100)) : (s.start = s.y, s.removalDistance = T.offsetHeight * (e.draggablePercent === 80 ? 1.5 * e.draggablePercent : e.draggablePercent / 100));
    }
  }
  function g() {
    if (s.boundingRect) {
      const { top: _, bottom: T, left: x, right: A } = s.boundingRect;
      e.pauseOnHover && s.x >= x && s.x <= A && s.y >= _ && s.y <= T ? y() : m();
    }
  }
  function m() {
    n(!0);
  }
  function y() {
    n(!1);
  }
  function v(_) {
    const T = a.current;
    s.canDrag && T && (s.didMove = !0, t && y(), s.x = Cy(_), s.y = xy(_), s.delta = e.draggableDirection === "x" ? s.x - s.start : s.y - s.start, s.start !== s.x && (s.canCloseOnClick = !1), T.style.transform = "translate" + e.draggableDirection + "(" + s.delta + "px)", T.style.opacity = "" + (1 - Math.abs(s.delta / s.removalDistance)));
  }
  function E() {
    document.removeEventListener("mousemove", v), document.removeEventListener("mouseup", E), document.removeEventListener("touchmove", v), document.removeEventListener("touchend", E);
    const _ = a.current;
    if (s.canDrag && s.didMove && _) {
      if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance)
        return i(!0), void e.closeToast();
      _.style.transition = "transform 0.2s, opacity 0.2s", _.style.transform = "translate" + e.draggableDirection + "(0)", _.style.opacity = "1";
    }
  }
  pe(() => {
    o.current = e;
  }), pe(() => (a.current && a.current.addEventListener("d", m, { once: !0 }), Pn(e.onOpen) && e.onOpen(ul(e.children) && e.children.props), () => {
    const _ = o.current;
    Pn(_.onClose) && _.onClose(ul(_.children) && _.children.props);
  }), []), pe(() => (e.pauseOnFocusLoss && (document.hasFocus() || y(), window.addEventListener("focus", m), window.addEventListener("blur", y)), () => {
    e.pauseOnFocusLoss && (window.removeEventListener("focus", m), window.removeEventListener("blur", y));
  }), [e.pauseOnFocusLoss]);
  const b = { onMouseDown: p, onTouchStart: p, onMouseUp: g, onTouchEnd: g };
  return l && u && (b.onMouseEnter = y, b.onMouseLeave = m), f && (b.onClick = (_) => {
    d && d(_), s.canCloseOnClick && c();
  }), { playToast: m, pauseToast: y, isRunning: t, preventExitTransition: r, toastRef: a, eventHandlers: b };
}
function BC(e) {
  let { closeToast: t, theme: n, ariaLabel: r = "close" } = e;
  return M.createElement("button", { className: "Toastify__close-button Toastify__close-button--" + n, type: "button", onClick: (i) => {
    i.stopPropagation(), t(i);
  }, "aria-label": r }, M.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, M.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function MC(e) {
  let { delay: t, isRunning: n, closeToast: r, type: i, hide: a, className: s, style: o, controlledProgress: l, progress: u, rtl: c, isIn: d, theme: f } = e;
  const p = { ...o, animationDuration: t + "ms", animationPlayState: n ? "running" : "paused", opacity: a ? 0 : 1 };
  l && (p.transform = "scaleX(" + u + ")");
  const g = Xi("Toastify__progress-bar", l ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--" + f, "Toastify__progress-bar--" + i, { "Toastify__progress-bar--rtl": c }), m = Pn(s) ? s({ rtl: c, type: i, defaultClassName: g }) : Xi(g, s);
  return M.createElement("div", { role: "progressbar", "aria-hidden": a ? "true" : "false", "aria-label": "notification timer", className: m, style: p, [l && u >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: l && u < 1 ? null : () => {
    d && r();
  } });
}
MC.defaultProps = { type: vi.DEFAULT, hide: !1 };
const zte = (e) => {
  const { isRunning: t, preventExitTransition: n, toastRef: r, eventHandlers: i } = Ute(e), { closeButton: a, children: s, autoClose: o, onClick: l, type: u, hideProgressBar: c, closeToast: d, transition: f, position: p, className: g, style: m, bodyClassName: y, bodyStyle: v, progressClassName: E, progressStyle: b, updateId: _, role: T, progress: x, rtl: A, toastId: R, deleteToast: P, isIn: L, isLoading: I, iconOut: O, theme: S } = e, F = Xi("Toastify__toast", "Toastify__toast-theme--" + S, "Toastify__toast--" + u, { "Toastify__toast--rtl": A }), H = Pn(g) ? g({ rtl: A, position: p, type: u, defaultClassName: F }) : Xi(F, g), q = !!x, N = { closeToast: d, type: u, theme: S };
  let Q = null;
  return a === !1 || (Q = Pn(a) ? a(N) : M.isValidElement(a) ? M.cloneElement(a, N) : BC(N)), M.createElement(f, { isIn: L, done: P, position: p, preventExitTransition: n, nodeRef: r }, M.createElement("div", { id: R, onClick: l, className: H, ...i, style: m, ref: r }, M.createElement("div", { ...L && { role: T }, className: Pn(y) ? y({ type: u }) : Xi("Toastify__toast-body", y), style: v }, O != null && M.createElement("div", { className: Xi("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !I }) }, O), M.createElement("div", null, s)), Q, (o || q) && M.createElement(MC, { ..._ && !q ? { key: "pb-" + _ } : {}, rtl: A, theme: S, delay: o, isRunning: t, isIn: L, closeToast: d, hide: c, type: u, style: b, className: E, controlledProgress: q, progress: x })));
}, qte = jte({ enter: "Toastify--animate Toastify__bounce-enter", exit: "Toastify--animate Toastify__bounce-exit", appendPosition: !0 }), sp = Ol((e, t) => {
  const { getToastToRender: n, containerRef: r, isToastActive: i } = Hte(e), { className: a, style: s, rtl: o, containerId: l } = e;
  function u(c) {
    const d = Xi("Toastify__toast-container", "Toastify__toast-container--" + c, { "Toastify__toast-container--rtl": o });
    return Pn(a) ? a({ position: c, rtl: o, defaultClassName: d }) : Xi(d, Ac(a));
  }
  return pe(() => {
    t && (t.current = r.current);
  }, []), M.createElement("div", { ref: r, className: "Toastify", id: l }, n((c, d) => {
    const f = d.length ? { ...s } : { ...s, pointerEvents: "none" };
    return M.createElement("div", { className: u(c), style: f, key: "container-" + c }, d.map((p, g) => {
      let { content: m, props: y } = p;
      return M.createElement(zte, { ...y, isIn: i(y.toastId), style: { ...y.style, "--nth": g + 1, "--len": d.length }, key: "toast-" + y.key }, m);
    }));
  }));
});
sp.displayName = "ToastContainer", sp.defaultProps = { position: FC.TOP_RIGHT, transition: qte, rtl: !1, autoClose: 5e3, hideProgressBar: !1, closeButton: BC, pauseOnHover: !0, pauseOnFocusLoss: !0, closeOnClick: !0, newestOnTop: !1, draggable: !0, draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
let zf, ys = /* @__PURE__ */ new Map(), op = [];
function LC() {
  return Math.random().toString(36).substring(2, 9);
}
function Wte(e) {
  return e && (Ha(e.toastId) || al(e.toastId)) ? e.toastId : LC();
}
function sl(e, t) {
  return ys.size > 0 ? ir.emit(0, e, t) : op.push({ content: e, options: t }), t.toastId;
}
function e1(e, t) {
  return { ...t, type: t && t.type || e, toastId: Wte(t) };
}
function Ju(e) {
  return (t, n) => sl(t, e1(e, n));
}
function Bt(e, t) {
  return sl(e, e1(vi.DEFAULT, t));
}
Bt.loading = (e, t) => sl(e, e1(vi.DEFAULT, { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...t })), Bt.promise = function(e, t, n) {
  let r, { pending: i, error: a, success: s } = t;
  i && (r = Ha(i) ? Bt.loading(i, n) : Bt.loading(i.render, { ...n, ...i }));
  const o = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null, delay: 100 }, l = (c, d, f) => {
    if (d == null)
      return void Bt.dismiss(r);
    const p = { type: c, ...o, ...n, data: f }, g = Ha(d) ? { render: d } : d;
    return r ? Bt.update(r, { ...p, ...g }) : Bt(g.render, { ...p, ...g }), f;
  }, u = Pn(e) ? e() : e;
  return u.then((c) => l("success", s, c)).catch((c) => l("error", a, c)), u;
}, Bt.success = Ju(vi.SUCCESS), Bt.info = Ju(vi.INFO), Bt.error = Ju(vi.ERROR), Bt.warning = Ju(vi.WARNING), Bt.warn = Bt.warning, Bt.dark = (e, t) => sl(e, e1(vi.DEFAULT, { theme: "dark", ...t })), Bt.dismiss = (e) => ir.emit(1, e), Bt.clearWaitingQueue = function(e) {
  return e === void 0 && (e = {}), ir.emit(5, e);
}, Bt.isActive = (e) => {
  let t = !1;
  return ys.forEach((n) => {
    n.isToastActive && n.isToastActive(e) && (t = !0);
  }), t;
}, Bt.update = function(e, t) {
  t === void 0 && (t = {}), setTimeout(() => {
    const n = function(r, i) {
      let { containerId: a } = i;
      const s = ys.get(a || zf);
      return s ? s.getToast(r) : null;
    }(e, t);
    if (n) {
      const { props: r, content: i } = n, a = { ...r, ...t, toastId: t.toastId || e, updateId: LC() };
      a.toastId !== e && (a.staleId = e);
      const s = a.render || i;
      delete a.render, sl(s, a);
    }
  }, 0);
}, Bt.done = (e) => {
  Bt.update(e, { progress: 1 });
}, Bt.onChange = (e) => (ir.on(4, e), () => {
  ir.off(4, e);
}), Bt.POSITION = FC, Bt.TYPE = vi, ir.on(2, (e) => {
  zf = e.containerId || e, ys.set(zf, e), op.forEach((t) => {
    ir.emit(0, t.content, t.options);
  }), op = [];
}).on(3, (e) => {
  ys.delete(e.containerId || e), ys.size === 0 && ir.off(0).off(1).off(5);
});
function tt() {
  return tt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tt.apply(this, arguments);
}
function Me(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}
var wy, Ay, Sy, Ke = {
  primary: "#2E70E8",
  primaryText: "#1E293B",
  secondaryText: "#475569",
  border: "#E2E8F0",
  main: "#FFFFFF",
  error: "#B42318"
}, Je = {
  primary: "#2E70E8",
  primaryText: "#EFEFEF",
  secondaryText: "#CBD5E1",
  border: "#3A4A61",
  main: "#1D2635",
  error: "#F97066"
}, Bi = Be.p(wy || (wy = Me([`
  font-size: 14px;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  line-height: 20px;
  color: `, `;
  margin: 0px;
`])), Ke.primaryText), $1 = Be(Bi)(Ay || (Ay = Me([`
  font-size: 12px;
  color: `, `;
`])), Ke.secondaryText), l0 = Be(Bi)(Sy || (Sy = Me([`
  font-size: 16px;
  font-weight: 500;
`]))), Vte = {
  bell: {
    color: "#fff"
  },
  badge: {
    backgroundColor: Je.primary
  },
  header: {
    container: {
      backgroundColor: Je.main,
      borderBottom: "0.5px solid " + Je.border,
      boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.5)"
    },
    headerText: {
      color: Je.primaryText
    },
    markAllReadText: {
      color: Je.primary
    }
  },
  tabs: {
    color: Je.primaryText,
    unselectedColor: Je.secondaryText + "D9",
    bottomColor: Je.primary,
    badgeColor: "rgba(100, 116, 139, 0.5)",
    badgeText: Je.primaryText
  },
  notificationsContainer: {
    container: {
      backgroundColor: Je.main,
      borderColor: Je.border
    },
    noNotificationsText: {
      color: Je.primaryText
    },
    noNotificationsSubtext: {
      color: Je.secondaryText
    },
    loader: {
      color: Je.primary
    }
  },
  notification: {
    container: {
      borderBottom: "1px solid " + Je.border,
      readBackgroundColor: Je.main,
      unreadBackgroundColor: "#273244",
      hoverBackgroundColor: "#2D3A4D"
    },
    pinnedText: {
      color: Je == null ? void 0 : Je.secondaryText
    },
    headerText: {
      color: Je.primaryText
    },
    bodyText: {
      color: Je.secondaryText,
      blockquoteColor: "rgba(100, 116, 139, 0.5)"
    },
    unseenDot: {
      backgroundColor: Je.primary
    },
    createdOnText: {
      color: Je.secondaryText
    },
    subtext: {
      color: "#94a3b8"
    },
    actions: [{
      container: {
        backgroundColor: Je.primary
      }
    }, {
      container: {
        borderColor: Je.border,
        backgroundColor: "transparent",
        hoverBackgroundColor: Je.main
      },
      text: {
        color: Je.secondaryText
      }
    }],
    expiresText: {
      backgroundColor: "rgba(100, 116, 139, 0.5)",
      color: Je.secondaryText,
      expiringBackgroundColor: "rgba(217, 45, 32, 0.15)",
      expiringColor: Je.error
    },
    actionsMenuIcon: {
      color: Je.secondaryText,
      hoverBackgroundColor: "rgba(100, 116, 139, 0.5)"
    },
    actionsMenu: {
      backgroundColor: Je.main,
      borderColor: Je.border
    },
    actionsMenuItem: {
      hoverBackgroundColor: "rgba(100, 116, 139, 0.2)"
    },
    actionsMenuItemIcon: {
      color: Je.secondaryText
    },
    actionsMenuItemText: {
      color: Je.secondaryText
    }
  },
  toast: {
    container: {
      backgroundColor: Je.main,
      borderColor: Je.border
    },
    headerText: {
      color: Je.primaryText
    },
    bodyText: {
      color: Je.secondaryText,
      blockquoteColor: Je.border,
      tableBorderColor: Je.border
    }
  }
}, Kte = function(t) {
  var n = t.style, r = (n == null ? void 0 : n.height) || 24, i = (n == null ? void 0 : n.width) || 24, a = (n == null ? void 0 : n.color) || Ke.primaryText;
  return (n == null ? void 0 : n.bellType) === "solid" ? /* @__PURE__ */ M.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: r,
    color: a,
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /* @__PURE__ */ M.createElement("path", {
    d: "M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
  })) : /* @__PURE__ */ M.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: r,
    color: a,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: "2"
  }, /* @__PURE__ */ M.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
  }));
}, $C = sn({}), jC = sn({});
function ha() {
  return We($C);
}
function Xa() {
  return We(jC);
}
function Gte() {
  var e = ha(), t = e.bellComponent, n = Xa(), r = n.bell;
  if (t) {
    var i = t;
    return /* @__PURE__ */ M.createElement(i, null);
  }
  return /* @__PURE__ */ M.createElement(Kte, {
    style: r
  });
}
var ky;
function Yte() {
  var e = ha(), t = e.notificationsData.count, n = e.badgeComponent, r = Xa(), i = r.badge;
  if (t > 0) {
    if (n) {
      var a = n;
      return /* @__PURE__ */ M.createElement(a, {
        count: t
      });
    }
    return /* @__PURE__ */ M.createElement(Zte, {
      style: i
    }, t);
  }
  return null;
}
var Zte = Be(Bi)(ky || (ky = Me([`
  position: absolute;
  right: -3px;
  top: -7px;
  display: inline-block;
  font-size: 10px;
  line-height: 1;
  padding: 3px 6px;
  border-radius: 50%;
  background-color: `, `;
  color: `, `;
  text-align: center;
`])), Ke.primary, Ke.main), HC = function(t) {
  try {
    if (t) {
      var n = new window.Image();
      return n.src = t, Promise.resolve(new Promise(function(r) {
        n.onerror = function() {
          return r(!1);
        }, n.onload = function() {
          return r(!0);
        };
      }));
    }
    return Promise.resolve();
  } catch (r) {
    return Promise.reject(r);
  }
};
function qf(e) {
  return e && typeof e == "object" && !Array.isArray(e);
}
function UC(e, t) {
  var n = Object.assign({}, e);
  return qf(e) && qf(t) && Object.keys(t).forEach(function(r) {
    if (qf(t[r])) {
      var i;
      r in e ? n[r] = UC(e[r], t[r]) : Object.assign(n, (i = {}, i[r] = t[r], i));
    } else {
      var a;
      Object.assign(n, (a = {}, a[r] = t[r], a));
    }
  }), n;
}
function Wf(e) {
  if (e)
    return e.startsWith("http") || e.startsWith("/") ? e : "https://" + e;
}
function Qte(e, t) {
  switch (t) {
    case "second":
      return "a minute";
    case "minute":
      return e === 1 ? e + " minute" : e + " minutes";
    case "hour":
      return e === 1 ? e + " hour" : e + " hours";
    case "day":
      return e === 1 ? e + " day" : e + " days";
    case "week":
      return e === 1 ? e + " week" : e + " weeks";
    case "month":
      return e === 1 ? e + " month" : e + " months";
    case "year":
      return e === 1 ? e + " year" : e + " years";
    default:
      return e;
  }
}
function Xte(e, t) {
  switch (t) {
    case "second":
      return "1m";
    case "minute":
      return e + "m";
    case "hour":
      return e + "h";
    case "day":
      return e + "d";
    case "week":
      return e + "w";
    case "month":
      return e + "mo";
    case "year":
      return e + "y";
    default:
      return e;
  }
}
var zC = function(t) {
  var n = t.type;
  return n === "dark" ? /* @__PURE__ */ M.createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ M.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "18",
    fill: "#334155"
  }), /* @__PURE__ */ M.createElement("path", {
    d: "M23.8641 14.2836C23.8641 17.3522 21.4556 19.8399 18.4844 19.8399C15.5132 19.8399 13.1047 17.3522 13.1047 14.2836C13.1047 11.215 15.5132 8.72754 18.4844 8.72754C21.4556 8.72754 23.8641 11.215 23.8641 14.2836Z",
    fill: "#94A3B8"
  }), /* @__PURE__ */ M.createElement("path", {
    d: "M23.8643 20.9316H13.1051C11.1039 20.9316 9.37694 22.0734 8.4502 23.75C10.6277 27.0754 14.3128 29.2659 18.4848 29.2659C22.6568 29.2659 26.3418 27.0754 28.5195 23.75C27.5913 22.0734 25.866 20.9316 23.8645 20.9316H23.8643Z",
    fill: "#94A3B8"
  })) : /* @__PURE__ */ M.createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ M.createElement("circle", {
    cx: "18",
    cy: "18",
    r: "18",
    fill: "#CBD5E1"
  }), /* @__PURE__ */ M.createElement("path", {
    d: "M23.8641 14.2836C23.8641 17.3522 21.4556 19.8399 18.4844 19.8399C15.5132 19.8399 13.1047 17.3522 13.1047 14.2836C13.1047 11.215 15.5132 8.72754 18.4844 8.72754C21.4556 8.72754 23.8641 11.215 23.8641 14.2836Z",
    fill: "white"
  }), /* @__PURE__ */ M.createElement("path", {
    d: "M23.8643 20.9316H13.1051C11.1039 20.9316 9.37694 22.0734 8.4502 23.75C10.6277 27.0754 14.3128 29.2659 18.4848 29.2659C22.6568 29.2659 26.3418 27.0754 28.5195 23.75C27.5913 22.0734 25.866 20.9316 23.8645 20.9316H23.8643Z",
    fill: "white"
  }));
}, Jte = function(t) {
  var n = t.style, r = (n == null ? void 0 : n.height) || 20, i = (n == null ? void 0 : n.width) || 20, a = (n == null ? void 0 : n.color) || Ke.secondaryText;
  return /* @__PURE__ */ M.createElement("svg", {
    width: i,
    height: r,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ M.createElement("path", {
    d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
    stroke: a,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ M.createElement("path", {
    d: "M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z",
    stroke: a,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ M.createElement("path", {
    d: "M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z",
    stroke: a,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, ene = function(t) {
  var n = t.style, r = (n == null ? void 0 : n.height) || 13, i = (n == null ? void 0 : n.width) || 13, a = (n == null ? void 0 : n.color) || "#DC6803";
  return /* @__PURE__ */ M.createElement("svg", {
    width: i,
    height: r,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ M.createElement("path", {
    d: "M7.58984 2.9305C7.38193 2.44536 7.27797 2.2028 7.10998 2.09261C6.96308 1.99626 6.78408 1.96179 6.6119 1.99669C6.415 2.03661 6.22839 2.22321 5.85518 2.59643L2.42642 6.02519C2.0532 6.39841 1.86659 6.58502 1.82668 6.78191C1.79177 6.95409 1.82624 7.13309 1.9226 7.28C2.03278 7.44799 2.27535 7.55194 2.76048 7.75986L4.42339 8.47253C4.49393 8.50277 4.5292 8.51788 4.56228 8.53678C4.59166 8.55356 4.61972 8.57256 4.64622 8.59361C4.67605 8.6173 4.70318 8.64444 4.75745 8.69871L5.79805 9.7393C5.88293 9.82418 5.92537 9.86662 5.95909 9.91498C5.98903 9.9579 6.0138 10.0042 6.03291 10.0529C6.05444 10.1078 6.06621 10.1666 6.08975 10.2844L6.57835 12.7273C6.70532 13.3622 6.76881 13.6796 6.93618 13.8281C7.08198 13.9575 7.27711 14.0166 7.47019 13.9898C7.69183 13.9591 7.92074 13.7302 8.37855 13.2724L13.1024 8.54856C13.5602 8.09075 13.7891 7.86185 13.8198 7.64021C13.8466 7.44713 13.7875 7.252 13.6581 7.10619C13.5096 6.93882 13.1922 6.87534 12.5573 6.74836L10.1143 6.25977C9.99663 6.23622 9.93777 6.22445 9.88289 6.20293C9.83418 6.18382 9.78788 6.15904 9.74496 6.12911C9.69661 6.09538 9.65416 6.05294 9.56928 5.96806L8.52869 4.92747C8.47442 4.8732 8.44729 4.84606 8.42359 4.81624C8.40255 4.78974 8.38355 4.76168 8.36676 4.73229C8.34787 4.69922 8.33275 4.66395 8.30252 4.5934L7.58984 2.9305Z",
    fill: a
  }), /* @__PURE__ */ M.createElement("path", {
    d: "M10.7405 10.9105L14.5117 14.6817M8.52869 4.92747L9.56928 5.96806C9.65416 6.05294 9.69661 6.09538 9.74496 6.12911C9.78788 6.15904 9.83418 6.18382 9.88289 6.20293C9.93777 6.22445 9.99663 6.23622 10.1143 6.25977L12.5573 6.74836C13.1922 6.87534 13.5096 6.93882 13.6581 7.10619C13.7875 7.252 13.8466 7.44713 13.8198 7.64021C13.7891 7.86185 13.5602 8.09075 13.1024 8.54856L8.37855 13.2724C7.92074 13.7302 7.69183 13.9591 7.47019 13.9898C7.27711 14.0166 7.08198 13.9575 6.93618 13.8281C6.76881 13.6796 6.70532 13.3622 6.57835 12.7273L6.08975 10.2844C6.06621 10.1666 6.05444 10.1078 6.03291 10.0529C6.0138 10.0042 5.98903 9.9579 5.95909 9.91498C5.92537 9.86662 5.88293 9.82418 5.79805 9.7393L4.75745 8.69871C4.70318 8.64444 4.67605 8.6173 4.64622 8.59361C4.61972 8.57256 4.59166 8.55356 4.56228 8.53678C4.5292 8.51788 4.49393 8.50277 4.42339 8.47253L2.76048 7.75986C2.27535 7.55194 2.03278 7.44799 1.9226 7.28C1.82624 7.13309 1.79177 6.95409 1.82668 6.78191C1.86659 6.58502 2.0532 6.39841 2.42642 6.02519L5.85517 2.59643C6.22839 2.22321 6.415 2.03661 6.6119 1.99669C6.78408 1.96179 6.96308 1.99626 7.10998 2.09261C7.27797 2.2028 7.38193 2.44536 7.58984 2.9305L8.30252 4.5934C8.33275 4.66395 8.34787 4.69922 8.36676 4.73229C8.38355 4.76168 8.40255 4.78974 8.42359 4.81624C8.44729 4.84606 8.47442 4.8732 8.52869 4.92747Z",
    stroke: a,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, tne = function(t) {
  var n = t.style, r = (n == null ? void 0 : n.height) || 16, i = (n == null ? void 0 : n.width) || 16, a = (n == null ? void 0 : n.color) || Ke.primaryText;
  return /* @__PURE__ */ M.createElement("svg", {
    width: i,
    height: r,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ M.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.416 3H4.00013C2.34327 3 1.00013 4.34315 1.00013 6V6.98313C0.999958 6.99375 0.999958 7.00437 1.00013 7.01499V18C1.00013 19.6569 2.34327 21 4.00013 21H20.0001C21.657 21 23.0001 19.6569 23.0001 18V9.21078H21.0001V18C21.0001 18.5523 20.5524 19 20.0001 19H4.00013C3.44784 19 3.00013 18.5523 3.00013 18V8.82027L10.4338 13.544L10.4392 13.5474C10.9071 13.8405 11.448 13.996 12.0001 13.996C12.5522 13.996 13.0932 13.8405 13.5611 13.5474L13.5665 13.544L19.5 9.21078H16.5L12.4992 11.8526L12.497 11.854C12.3479 11.9468 12.1758 11.996 12.0001 11.996C11.8245 11.996 11.6524 11.9468 11.5033 11.854L3.00013 6.45063V6C3.00013 5.44772 3.44784 5 4.00013 5H14.416V3Z",
    fill: a
  }), /* @__PURE__ */ M.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "4",
    fill: a
  }));
}, nne = function(t) {
  var n = t.style, r = (n == null ? void 0 : n.height) || 16, i = (n == null ? void 0 : n.width) || 16, a = (n == null ? void 0 : n.color) || Ke.primaryText;
  return /* @__PURE__ */ M.createElement("svg", {
    width: i,
    height: r,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ M.createElement("path", {
    d: "M14.1334 6.26471C14.4667 6.51805 14.6667 6.91138 14.6667 7.33138V13.998C14.6667 14.3517 14.5262 14.6908 14.2762 14.9409C14.0261 15.1909 13.687 15.3314 13.3334 15.3314H2.66671C2.31309 15.3314 1.97395 15.1909 1.7239 14.9409C1.47385 14.6908 1.33337 14.3517 1.33337 13.998V7.33138C1.33337 7.12439 1.38157 6.92024 1.47414 6.7351C1.56671 6.54995 1.70111 6.38891 1.86671 6.26471L7.20004 2.26471C7.43084 2.09162 7.71155 1.99805 8.00004 1.99805C8.28853 1.99805 8.56925 2.09162 8.80004 2.26471L14.1334 6.26471Z",
    stroke: a,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ M.createElement("path", {
    d: "M14.6667 7.33105L8.68668 11.1311C8.48086 11.26 8.24289 11.3284 8.00001 11.3284C7.75713 11.3284 7.51916 11.26 7.31334 11.1311L1.33334 7.33105",
    stroke: a,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, rne = function(t) {
  var n = t.style, r = (n == null ? void 0 : n.height) || 17, i = (n == null ? void 0 : n.width) || 16, a = (n == null ? void 0 : n.color) || Ke.secondaryText;
  return /* @__PURE__ */ M.createElement("svg", {
    width: i,
    height: r,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ M.createElement("path", {
    d: "M14 2.33789H1.99998C1.63179 2.33789 1.33331 2.63637 1.33331 3.00456V5.00456C1.33331 5.37275 1.63179 5.67122 1.99998 5.67122H14C14.3682 5.67122 14.6666 5.37275 14.6666 5.00456V3.00456C14.6666 2.63637 14.3682 2.33789 14 2.33789Z",
    stroke: a,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ M.createElement("path", {
    d: "M2.66669 5.67188V13.0052C2.66669 13.3588 2.80716 13.698 3.05721 13.948C3.30726 14.1981 3.6464 14.3385 4.00002 14.3385H12C12.3536 14.3385 12.6928 14.1981 12.9428 13.948C13.1929 13.698 13.3334 13.3588 13.3334 13.0052V5.67188",
    stroke: a,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /* @__PURE__ */ M.createElement("path", {
    d: "M6.66669 8.33789H9.33335",
    stroke: a,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, Dy, Oy, Ny, Iy, Py, Ry, Fy, By, My, Ly, $y, jy, Hy, Uy, zy, qy, Wy, Vy, Ky, Gy, Yy, Zy, Qy, Xy, Jy, eE, tE;
function ine(e) {
  var t = e.dateInput, n = e.style, r = t, i = de(Date.now()), a = i[1];
  pe(function() {
    var l = setInterval(function() {
      return a(Date.now());
    }, 1e4);
    return function() {
      clearInterval(l);
    };
  }, []);
  var s = r - Date.now() <= 36e5, o = Date.now() >= r;
  return typeof t == "number" ? /* @__PURE__ */ M.createElement("div", null, /* @__PURE__ */ M.createElement(dne, {
    style: tt({}, n, {
      color: s ? (n == null ? void 0 : n.expiringColor) || Ke.error : (n == null ? void 0 : n.color) || Ke.secondaryText,
      backgroundColor: s ? (n == null ? void 0 : n.expiringBackgroundColor) || "rgba(217, 45, 32, 0.09)" : (n == null ? void 0 : n.backgroundColor) || "rgba(100, 116, 139, 0.09)"
    })
  }, "Expires in", " ", o ? "a minute" : /* @__PURE__ */ M.createElement(PC, {
    date: r,
    live: !1,
    formatter: Qte
  }))) : null;
}
function ane(e) {
  var t, n, r, i, a, s, o, l, u, c, d, f, p, g, m, y, v, E, b, _, T = e.notificationData, x = e.handleActionClick, A = de(!1), R = A[0], P = A[1], L = de(!1), I = L[0], O = L[1], S = de(!1), F = S[0], H = S[1], q = T.message, N = T.seen_on, Q = T.created_on, J = ha(), D = J.notificationComponent, C = J.hideAvatar, Z = J.inbox, B = J.themeType, j = J.primaryActionClickHandler, z = J.secondaryActionClickHandler, U = Xa(), $ = U.notification, ae = ($ == null || (t = $.bodyText) === null || t === void 0 ? void 0 : t.tableBorderColor) || "rgba(100, 116, 139, 0.3)", Y = ($ == null || (n = $.bodyText) === null || n === void 0 ? void 0 : n.blockquoteColor) || "rgba(100, 116, 139, 0.3)", ee = ($ == null || (r = $.bodyText) === null || r === void 0 ? void 0 : r.linkColor) || Ke.primary, se = q == null || (i = q.actions) === null || i === void 0 ? void 0 : i[0], re = q == null || (a = q.actions) === null || a === void 0 ? void 0 : a[1], Ae = se || re;
  if (pe(function() {
    var Ce, ue = HC(q == null || (Ce = q.avatar) === null || Ce === void 0 ? void 0 : Ce.avatar_url);
    ue.then(function(fe) {
      return P(fe);
    });
  }, [T]), D) {
    var Oe = D;
    return /* @__PURE__ */ M.createElement(Oe, {
      notificationData: T,
      markRead: function(ue) {
        ue != null && ue.stopPropagation && ue.stopPropagation(), Z.feed.markRead(T.n_id);
      },
      markUnRead: function(ue) {
        ue != null && ue.stopPropagation && ue.stopPropagation(), Z.feed.markUnRead(T.n_id);
      },
      markArchived: function(ue) {
        ue != null && ue.stopPropagation && ue.stopPropagation(), Z.feed.markArchived(T.n_id);
      }
    });
  }
  return /* @__PURE__ */ M.createElement(sne, {
    style: $ == null ? void 0 : $.container,
    read: !!N,
    onMouseEnter: function() {
      O(!0), H(!1);
    },
    onMouseLeave: function() {
      O(!1), H(!1);
    },
    onClick: function(ue) {
      F && (ue.stopPropagation(), H(!1));
    }
  }, T.is_pinned && /* @__PURE__ */ M.createElement(one, {
    hideAvatar: C
  }, /* @__PURE__ */ M.createElement(ene, {
    style: $ == null ? void 0 : $.pinnedIcon
  }), /* @__PURE__ */ M.createElement(lne, {
    style: $ == null ? void 0 : $.pinnedText
  }, "Pinned")), /* @__PURE__ */ M.createElement(fne, null, /* @__PURE__ */ M.createElement(bne, null, /* @__PURE__ */ M.createElement(Tne, null, /* @__PURE__ */ M.createElement(mne, {
    style: $ == null ? void 0 : $.unseenDot,
    show: !N
  }), !C && /* @__PURE__ */ M.createElement(_ne, {
    onClick: function(ue) {
      var fe = q == null ? void 0 : q.avatar;
      x(ue, {
        type: "avatar",
        url: fe == null ? void 0 : fe.action_url,
        target: fe == null ? void 0 : fe.open_in_new_tab
      });
    }
  }, q != null && (s = q.avatar) !== null && s !== void 0 && s.avatar_url && R ? /* @__PURE__ */ M.createElement(wne, {
    src: q.avatar.avatar_url,
    alt: "avatar",
    style: $ == null ? void 0 : $.avatar
  }) : /* @__PURE__ */ M.createElement(zC, {
    type: B
  }))), /* @__PURE__ */ M.createElement(Cne, null, q.header && /* @__PURE__ */ M.createElement(hne, {
    style: $ == null ? void 0 : $.headerText
  }, q.header), /* @__PURE__ */ M.createElement(pne, {
    style: $ == null ? void 0 : $.bodyText
  }, /* @__PURE__ */ M.createElement(y_, {
    remarkPlugins: [U_],
    rehypePlugins: [IC],
    components: {
      a: function(ue) {
        var fe = ue.children, Se = ue.href, Fe = ue.style;
        return /* @__PURE__ */ M.createElement("span", {
          onClick: function(mt) {
            mt.preventDefault(), x(mt, {
              type: "markdown_link",
              url: Se
            });
          },
          style: tt({
            color: ee,
            textDecoration: "none"
          }, Fe || {})
        }, fe);
      },
      p: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("p", {
          style: tt({
            margin: 0,
            overflowWrap: "anywhere"
          }, Se || {})
        }, fe);
      },
      blockquote: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("blockquote", {
          style: tt({
            margin: 0,
            paddingLeft: 10,
            borderLeft: "3px " + Y + " solid",
            marginBottom: 5,
            marginTop: 5
          }, Se || {})
        }, fe);
      },
      ul: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("ul", {
          style: tt({
            whiteSpace: "normal",
            margin: 0,
            paddingLeft: 10
          }, Se || {})
        }, fe);
      },
      ol: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("ol", {
          style: tt({
            whiteSpace: "normal",
            margin: 0,
            paddingLeft: 10
          }, Se || {})
        }, fe);
      },
      img: function(ue) {
        return /* @__PURE__ */ M.createElement("img", tt({
          style: tt({
            maxWidth: "100%",
            objectFit: "contain"
          }, (ue == null ? void 0 : ue.style) || {})
        }, ue));
      },
      table: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("table", {
          style: tt({
            overflowWrap: "break-word",
            borderCollapse: "collapse"
          }, Se || {})
        }, fe);
      },
      th: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("th", {
          style: tt({
            textAlign: "left",
            whiteSpace: "nowrap",
            border: "1px solid " + ae,
            padding: 5
          }, Se || {})
        }, fe);
      },
      td: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("td", {
          style: tt({
            border: "1px solid " + ae,
            padding: 5
          }, Se || {})
        }, fe);
      },
      h1: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("h1", {
          style: tt({
            margin: 0
          }, Se || {})
        }, fe);
      },
      h2: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("h2", {
          style: tt({
            margin: 0
          }, Se || {})
        }, fe);
      },
      h3: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("h3", {
          style: tt({
            margin: 0
          }, Se || {})
        }, fe);
      },
      h4: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("h4", {
          style: tt({
            margin: 0
          }, Se || {})
        }, fe);
      },
      h5: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("h5", {
          style: tt({
            margin: 0
          }, Se || {})
        }, fe);
      },
      h6: function(ue) {
        var fe = ue.children, Se = ue.style;
        return /* @__PURE__ */ M.createElement("h6", {
          style: tt({
            margin: 0
          }, Se || {})
        }, fe);
      },
      script: function() {
        return null;
      },
      link: function() {
        return null;
      }
    }
  }, q == null || (o = q.text) === null || o === void 0 || (l = o.replaceAll(`\\
`, "&nbsp;")) === null || l === void 0 || (u = l.replaceAll(`
`, `  
`)) === null || u === void 0 ? void 0 : u.replaceAll("&nbsp;", `&nbsp;  
`))), !!(q != null && (c = q.subtext) !== null && c !== void 0 && c.text) && /* @__PURE__ */ M.createElement(cne, {
    link: q == null || (d = q.subtext) === null || d === void 0 ? void 0 : d.action_url,
    onClick: function(ue) {
      var fe = q == null ? void 0 : q.subtext;
      x(ue, {
        type: "subtext",
        url: fe == null ? void 0 : fe.action_url,
        target: fe == null ? void 0 : fe.open_in_new_tab
      });
    }
  }, /* @__PURE__ */ M.createElement(une, {
    style: $ == null ? void 0 : $.subtext
  }, q.subtext.text)), T.expiry && (T == null ? void 0 : T.is_expiry_visible) && /* @__PURE__ */ M.createElement(ine, {
    dateInput: T.expiry,
    style: $ == null ? void 0 : $.expiresText
  }), Ae && /* @__PURE__ */ M.createElement(vne, null, se && /* @__PURE__ */ M.createElement(qC, {
    style: $ == null || (f = $.actions) === null || f === void 0 || (p = f[0]) === null || p === void 0 ? void 0 : p.container,
    key: se.id,
    onClick: function(ue) {
      x(ue, {
        type: "primary_action_button",
        url: se.url,
        target: se.open_in_new_tab,
        customClickHandler: j
      });
    }
  }, /* @__PURE__ */ M.createElement(WC, {
    style: $ == null || (g = $.actions) === null || g === void 0 || (m = g[0]) === null || m === void 0 ? void 0 : m.text
  }, se.name)), re && /* @__PURE__ */ M.createElement(yne, {
    key: re.id,
    style: $ == null || (y = $.actions) === null || y === void 0 || (v = y[1]) === null || v === void 0 ? void 0 : v.container,
    onClick: function(ue) {
      x(ue, {
        type: "secondary_action_button",
        url: re.url,
        target: re.open_in_new_tab,
        customClickHandler: z
      });
    }
  }, /* @__PURE__ */ M.createElement(Ene, {
    style: $ == null || (E = $.actions) === null || E === void 0 || (b = E[1]) === null || b === void 0 ? void 0 : b.text
  }, re.name))))), /* @__PURE__ */ M.createElement(xne, null, /* @__PURE__ */ M.createElement(gne, {
    style: $ == null ? void 0 : $.createdOnText
  }, /* @__PURE__ */ M.createElement(PC, {
    date: Q,
    live: !1,
    formatter: Xte
  })), /* @__PURE__ */ M.createElement(Sne, {
    showMore: I
  }, /* @__PURE__ */ M.createElement(kne, {
    hoverBGColor: $ == null || (_ = $.actionsMenuIcon) === null || _ === void 0 ? void 0 : _.hoverBackgroundColor,
    onClick: function(ue) {
      ue.stopPropagation(), H(function(fe) {
        return !fe;
      });
    }
  }, /* @__PURE__ */ M.createElement(Jte, {
    style: $ == null ? void 0 : $.actionsMenuIcon
  })), /* @__PURE__ */ M.createElement(Ane, {
    moreOpen: F,
    style: $ == null ? void 0 : $.actionsMenu
  }, T.seen_on ? /* @__PURE__ */ M.createElement(Vf, {
    style: $ == null ? void 0 : $.actionsMenuItem,
    onClick: function(ue) {
      ue.stopPropagation(), Z.feed.markUnRead(T.n_id), H(!1);
    }
  }, /* @__PURE__ */ M.createElement(tne, {
    style: $ == null ? void 0 : $.actionsMenuItemIcon
  }), /* @__PURE__ */ M.createElement(Kf, {
    style: $ == null ? void 0 : $.actionsMenuItemText
  }, "Mark as unread")) : /* @__PURE__ */ M.createElement(Vf, {
    style: $ == null ? void 0 : $.actionsMenuItem,
    onClick: function(ue) {
      ue.stopPropagation(), Z.feed.markRead(T.n_id), H(!1);
    }
  }, /* @__PURE__ */ M.createElement(nne, {
    style: $ == null ? void 0 : $.actionsMenuItemIcon
  }), /* @__PURE__ */ M.createElement(Kf, {
    style: $ == null ? void 0 : $.actionsMenuItemText
  }, "Mark as read")), !(T != null && T.archived) && /* @__PURE__ */ M.createElement(Vf, {
    style: $ == null ? void 0 : $.actionsMenuItem,
    onClick: function(ue) {
      ue.stopPropagation(), Z.feed.markArchived(T.n_id);
    }
  }, /* @__PURE__ */ M.createElement(rne, {
    style: $ == null ? void 0 : $.actionsMenuItemIcon
  }), /* @__PURE__ */ M.createElement(Kf, {
    style: $ == null ? void 0 : $.actionsMenuItemText
  }, "Archive")))))));
}
var sne = Be.div(Dy || (Dy = Me([`
  padding: 16px;
  cursor: pointer;
  background-color: `, `;
  border-bottom: 0.5px solid `, `;
  &:hover {
    background-color: `, `
`])), function(e) {
  var t, n;
  return e.read ? (e == null || (t = e.style) === null || t === void 0 ? void 0 : t.readBackgroundColor) || Ke.main : (e == null || (n = e.style) === null || n === void 0 ? void 0 : n.unreadBackgroundColor) || "#edf3ff";
}, Ke.border, function(e) {
  var t;
  return (e == null || (t = e.style) === null || t === void 0 ? void 0 : t.hoverBackgroundColor) || "#DBE7FF";
}), one = Be.div(Oy || (Oy = Me([`
  display: flex;
  align-items: center;
  margin-left: `, `;
  gap: 4px;
`])), function(e) {
  return e.hideAvatar ? "0px" : "52px";
}), lne = Be($1)(Ny || (Ny = Me([""]))), une = Be($1)(Iy || (Iy = Me([`
  color: #64748b;
`]))), cne = Be.div(Py || (Py = Me([`
  text-decoration: none;
  overflow-wrap: anywhere;
  display: inline-block;
  &:hover {
    text-decoration: `, `;
    text-decoration-color: `, `;
  }
`])), function(e) {
  return e.link ? "underline" : "none";
}, Ke.secondaryText), dne = Be($1)(Ry || (Ry = Me([`
  margin-top: 8px;
  display: inline-block;
  padding: 1px 6px;
  border-radius: 4px;
`]))), fne = Be.div(Fy || (Fy = Me([`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`]))), hne = Be(Bi)(By || (By = Me([`
  margin: 8px 0px 0px 0px;
  overflow-wrap: anywhere;
  line-height: 18px;
  font-weight: 700;
`]))), pne = Be.div(My || (My = Me([`
  font-size: 14px;
  line-height: 20px;
  margin: 8px 0px 6px;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  color: `, `;
`])), Ke.secondaryText), mne = Be.div(Ly || (Ly = Me([`
  background-color: `, `;
  border-radius: 50%;
  width: 7px;
  height: 7px;
  visibility: `, `;
`])), Ke.primary, function(e) {
  return e.show ? "visible" : "hidden";
}), gne = Be($1)($y || ($y = Me([""]))), vne = Be.div(jy || (jy = Me([`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 6px;
  margin-top: 12px;
  overflow-wrap: anywhere;
`]))), qC = Be.div(Hy || (Hy = Me([`
  max-width: 50%;
  background: `, `;
  border-radius: 5px;
  text-decoration: none;
  padding: 4px 16px;
  &:hover {
    background-color: `, ` !important;
  }
`])), Ke.primary, function(e) {
  var t;
  return ((t = e.style) === null || t === void 0 ? void 0 : t.hoverBackgroundColor) || "#265cbf";
}), WC = Be(Bi)(Uy || (Uy = Me([`
  color: `, `;
  text-align: center;
  word-break: break-all;
  font-weight: 600;
  font-size: 13px;
`])), Ke.main), yne = Be(qC)(zy || (zy = Me([`
  background: `, `;
  border-color: `, `;
  border-style: solid;
  border-width: 1.2px;
  &:hover {
    background-color: `, ` !important;
  }
`])), Ke.main, Ke.border, function(e) {
  var t;
  return ((t = e.style) === null || t === void 0 ? void 0 : t.hoverBackgroundColor) || "#f7f7f9";
}), Ene = Be(WC)(qy || (qy = Me([`
  color: `, `;
`])), Ke.secondaryText), bne = Be.div(Wy || (Wy = Me([`
  display: flex;
  overflow-wrap: anywhere;
  flex-grow: 1;
`]))), Tne = Be.div(Vy || (Vy = Me([`
  display: flex;
  margin-top: 8px;
  margin-right: 12px;
`]))), _ne = Be.div(Ky || (Ky = Me([""]))), Cne = Be.div(Gy || (Gy = Me([`
  flex: 1;
`]))), xne = Be.div(Yy || (Yy = Me([`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5px;
  max-width: 40px;
  gap: 5px;
`]))), wne = Be.img(Zy || (Zy = Me([`
  height: 36px;
  width: 36px;
  border-radius: 100px;
`]))), Ane = Be.div(Qy || (Qy = Me([`
  position: absolute;
  right: 0px;
  display: `, `;
  min-width: 150px;
  padding: 2px;
  background-color: `, `;
  border: 1px solid;
  border-color: `, `;
  border-radius: 4px;
  box-shadow: 1px 1px 20px 1px rgba(0, 0, 0, 0.1);
  z-index: 100;
`])), function(e) {
  return e.moreOpen ? "block" : "none";
}, Ke.main, Ke.border), Vf = Be.div(Xy || (Xy = Me([`
  padding: 7px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background-color: `, `;
  }
`])), function(e) {
  var t;
  return (e == null || (t = e.style) === null || t === void 0 ? void 0 : t.hoverBackgroundColor) || "rgba(100, 116, 139, 0.09)";
}), Kf = Be(Bi)(Jy || (Jy = Me([""]))), Sne = Be.div(eE || (eE = Me([`
  position: relative;
  visibility: `, `;
`])), function(e) {
  return e != null && e.showMore ? "visible" : "hidden";
}), kne = Be.div(tE || (tE = Me([`
  height: 20px;
  width: 20px;
  &:hover {
    border-radius: 50%;
    background-color: `, `;
  }
`])), function(e) {
  return (e == null ? void 0 : e.hoverBGColor) || "rgba(100, 116, 139, 0.09)";
});
function Gf(e) {
  return e ? "_blank" : "_self";
}
function Dne(e) {
  var t = e.notificationData, n = ha(), r = n.notificationClickHandler, i = n.inbox, a = function() {
    if (typeof r == "function")
      r(t);
    else {
      var c = t == null ? void 0 : t.message;
      if (c != null && c.url) {
        var d = Gf(c == null ? void 0 : c.open_in_new_tab);
        window.open(Wf(c.url), d);
      }
    }
  }, s = function() {
    i.feed.markClicked(t.n_id);
  }, o = function(c) {
    var d;
    c.stopPropagation();
    var f = t.interacted_on, p = Gf(t == null || (d = t.message) === null || d === void 0 ? void 0 : d.open_in_new_tab);
    s(), !f && p === "_self" ? setTimeout(function() {
      a();
    }, 1e3) : a();
  }, l = function(c, d) {
    c.stopPropagation();
    var f = t.interacted_on, p = Gf(d == null ? void 0 : d.target);
    s(), !f && p === "_self" ? setTimeout(function() {
      d.customClickHandler ? d.customClickHandler(t) : d != null && d.url ? window.open(Wf(d.url), p) : a();
    }, 1e3) : d.customClickHandler ? d.customClickHandler(t) : d != null && d.url ? window.open(Wf(d.url), p) : a();
  };
  return /* @__PURE__ */ M.createElement("div", {
    onClick: o
  }, /* @__PURE__ */ M.createElement(ane, {
    notificationData: t,
    handleActionClick: l
  }));
}
var One = function(t) {
  return /* @__PURE__ */ Fr("svg", tt({
    width: 185,
    height: 114,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, t), /* @__PURE__ */ Fr("ellipse", {
    cx: 92.32,
    cy: 56.616,
    rx: 60.32,
    ry: 56.616,
    fill: "#9F9F9F",
    fillOpacity: 0.11
  }), /* @__PURE__ */ Fr("rect", {
    x: 69.174,
    y: 17.469,
    width: 115.826,
    height: 40.217,
    rx: 12.87,
    fill: "#9F9F9F"
  }), /* @__PURE__ */ Fr("rect", {
    x: 123.065,
    y: 29.533,
    width: 33.783,
    height: 5.63,
    rx: 2.815,
    fill: "#D9D9D9"
  }), /* @__PURE__ */ Fr("rect", {
    x: 95.717,
    y: 39.185,
    width: 59.522,
    height: 5.63,
    rx: 2.815,
    fill: "#D9D9D9"
  }), /* @__PURE__ */ Fr("ellipse", {
    cx: 170.924,
    cy: 37.577,
    rx: 8.446,
    ry: 8.043,
    fill: "#D9D9D9"
  }), /* @__PURE__ */ Fr("rect", {
    y: 51.25,
    width: 120.652,
    height: 40.217,
    rx: 12.87,
    fill: "#D9E9FF"
  }), /* @__PURE__ */ Fr("rect", {
    x: 30.565,
    y: 63.315,
    width: 33.783,
    height: 5.63,
    rx: 2.815,
    fill: "#93AFD6"
  }), /* @__PURE__ */ Fr("rect", {
    x: 30.565,
    y: 72.967,
    width: 59.522,
    height: 5.63,
    rx: 2.815,
    fill: "#93AFD6"
  }), /* @__PURE__ */ Fr("ellipse", {
    cx: 17.294,
    cy: 71.358,
    rx: 8.446,
    ry: 8.043,
    fill: "#93AFD6"
  }));
}, nE, rE, iE, aE, sE, oE, lE, uE;
function cE(e) {
  var t = e.style, n = e.size, r = t == null ? void 0 : t.color;
  return /* @__PURE__ */ M.createElement(Lne, null, /* @__PURE__ */ M.createElement(Mne, {
    style: t,
    color: r,
    size: n
  }));
}
function Nne() {
  var e, t = ha(), n = t.notificationsData, r = n.storeData, i = n.hasNext, a = n.initialLoading, s = n.activeStoreId, o = t.noNotificationsComponent, l = t.loaderComponent, u = t.pagination, c = t.changingActiveStore, d = t.inbox, f = Xa(), p = f.notificationsContainer, g = (r == null || (e = r[s]) === null || e === void 0 ? void 0 : e.notifications) || [];
  if (a)
    return /* @__PURE__ */ M.createElement($ne, null, /* @__PURE__ */ M.createElement(cE, {
      style: p == null ? void 0 : p.loader,
      size: "large"
    }));
  if (g.length <= 0) {
    if (o) {
      var m = o;
      return /* @__PURE__ */ M.createElement(m, null);
    }
    return /* @__PURE__ */ M.createElement(Pne, null, /* @__PURE__ */ M.createElement(One, null), /* @__PURE__ */ M.createElement(Rne, {
      style: p == null ? void 0 : p.noNotificationsText
    }, "No notifications yet"), /* @__PURE__ */ M.createElement(Fne, {
      style: p == null ? void 0 : p.noNotificationsSubtext
    }, "We'll let you know when we've got something new for you."));
  }
  return c ? null : /* @__PURE__ */ M.createElement(Ine, null, /* @__PURE__ */ M.createElement(Lte, {
    scrollableTarget: "ss-notification-container",
    dataLength: g.length,
    next: function() {
      d.feed.fetchNotifications();
    },
    hasMore: u && i,
    loader: (l == null ? void 0 : l()) || /* @__PURE__ */ M.createElement(cE, {
      style: p == null ? void 0 : p.loader
    })
  }, g.map(function(y) {
    return /* @__PURE__ */ M.createElement(Dne, {
      notificationData: y,
      key: y.n_id
    });
  })));
}
var Ine = Be.div(nE || (nE = Me([""]))), Pne = Be.div(rE || (rE = Me([`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 32px;
  margin-top: 40px;
`]))), Rne = Be(l0)(iE || (iE = Me([`
  font-weight: 600;
  text-align: center;
  background-color: transparent;
  margin: 20px 0px;
  margin-bottom: 16px;
  color: `, `;
`])), Ke.primaryText), Fne = Be(Bi)(aE || (aE = Me([`
  color: `, `;
  text-align: center;
`])), Ke.secondaryText), Bne = cL(sE || (sE = Me([`
0% {
  transform: rotate(0deg);
}
100% {
  transform: rotate(360deg);
}
`]))), Mne = Be.div(oE || (oE = Me([`
  border: `, `;
  border-top: `, `;
  border-top-color: `, `;
  border-radius: 50%;
  width: `, `;
  height: `, `;
  animation: `, ` 1s linear infinite;
  margin: 5px;
`])), function(e) {
  return e.size === "large" ? "5px solid " + Ke.border : "3px solid " + Ke.border;
}, function(e) {
  return e.size === "large" ? "5px solid" : "3px solid";
}, function(e) {
  return e.color ? e.color : Ke.primary;
}, function(e) {
  return e.size === "large" ? "20px" : "10px";
}, function(e) {
  return e.size === "large" ? "20px" : "10px";
}, Bne), Lne = Be.div(lE || (lE = Me([`
  display: flex;
  justify-content: center;
  align-items: center;
`]))), $ne = Be.div(uE || (uE = Me([`
  margin-top: 32px;
`]))), dE, fE, hE, pE, mE, gE, vE, yE, EE;
function jne(e) {
  var t = !1;
  for (var n in e) {
    var r, i = e[n];
    (i == null || (r = i.notifications) === null || r === void 0 ? void 0 : r.length) > 0 && (t = !0);
  }
  return t;
}
function Hne(e) {
  var t = e.isEmpty, n = e.header, r = e.inbox;
  return t ? null : /* @__PURE__ */ M.createElement(Yne, {
    style: n == null ? void 0 : n.markAllReadText,
    onClick: function(a) {
      a.stopPropagation(), r.feed.markAllRead();
    }
  }, "Mark all as read");
}
function Une() {
  var e = Xa(), t = e.header, n = e.tabs, r = ha(), i = r.inbox, a = r.notificationsData, s = r.activeStore, o = r.setActiveStore, l = r.setChangingActiveStore, u = r.showUnreadCountOnTabs, c = r.tabBadgeComponent, d = r.headerRightComponent, f = r.toggleInbox, p = !jne(a == null ? void 0 : a.storeData), g = i.feed.stores, m = (g == null ? void 0 : g.length) > 0, y = c, v = d;
  return /* @__PURE__ */ M.createElement(zne, {
    style: t == null ? void 0 : t.container
  }, /* @__PURE__ */ M.createElement(qne, {
    hasStores: m
  }, /* @__PURE__ */ M.createElement(Gne, {
    style: t == null ? void 0 : t.headerText
  }, "Notifications"), v ? /* @__PURE__ */ M.createElement(v, {
    markAllRead: function() {
      return i.feed.markAllRead();
    },
    closeInboxPopup: function() {
      f(!1);
    }
  }) : /* @__PURE__ */ M.createElement(Hne, {
    isEmpty: p,
    header: t,
    inbox: i
  })), g && g.length > 0 && /* @__PURE__ */ M.createElement(Wne, null, g.map(function(E, b) {
    var _, T, x = s === E.storeId, A = (a == null || (_ = a.storeData) === null || _ === void 0 || (T = _[E.storeId]) === null || T === void 0 ? void 0 : T.unseenCount) || 0, R = u && A > 0, P = x ? n == null ? void 0 : n.bottomColor : "none", L = x ? n == null ? void 0 : n.color : (n == null ? void 0 : n.unselectedColor) || (n == null ? void 0 : n.color);
    return /* @__PURE__ */ M.createElement(Vne, {
      style: {
        borderBottomColor: P
      },
      key: b,
      selected: x,
      onClick: function() {
        l(!0), o(E.storeId), i.changeActiveStore(E.storeId), setTimeout(function() {
          l(!1);
        }, 0);
      }
    }, /* @__PURE__ */ M.createElement(Kne, {
      selected: x,
      style: tt({}, n, {
        color: L
      })
    }, E.label), R && (y ? /* @__PURE__ */ M.createElement(y, {
      count: A
    }) : /* @__PURE__ */ M.createElement(Zne, {
      style: {
        backgroundColor: n == null ? void 0 : n.badgeColor,
        color: n == null ? void 0 : n.badgeText
      }
    }, /* @__PURE__ */ M.createElement(Qne, {
      count: A
    }, A))));
  })));
}
var zne = Be.div(dE || (dE = Me([`
  position: sticky;
  top: 0;
  padding: 16px;
  padding-bottom: 0px;
  z-index: 1000;
  background-color: `, `;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
`])), Ke.main), qne = Be.div(fE || (fE = Me([`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: `, `;
  padding-bottom: `, `;
`])), function(e) {
  return e.hasStores ? "16px" : "0px";
}, function(e) {
  return e.hasStores ? "0px" : "16px";
}), Wne = Be.div(hE || (hE = Me([`
  display: flex;
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`]))), Vne = Be.div(pE || (pE = Me([`
  padding: 5px 15px 3px 15px;
  border-bottom: `, `;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
`])), function(e) {
  return e.selected ? "2px solid " + Ke.primary : "none";
}), Kne = Be(Bi)(mE || (mE = Me([`
  font-size: 14px;
  font-weight: 600;
  color: `, `;
`])), function(e) {
  return e.selected ? Ke.primaryText : Ke.secondaryText + "D9";
}), Gne = Be(l0)(gE || (gE = Me([`
  font-weight: 600;
  font-size: 16px;
`]))), Yne = Be(l0)(vE || (vE = Me([`
  color: `, `;
  font-size: 12px;
  cursor: pointer;
`])), Ke.primary), Zne = Be.div(yE || (yE = Me([`
  height: 18px;
  width: 20px;
  border-radius: 50%;
  background-color: rgba(100, 116, 139, 0.09);
  display: flex;
  align-items: center;
  justify-content: center;
  color: `, `;
`])), Ke.primaryText), Qne = Be.p(EE || (EE = Me([`
  margin: 0px;
  padding: 0px;
  font-size: `, `;
  font-weight: 600;
  line-height: 1;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
`])), function(e) {
  return (e == null ? void 0 : e.count) > 99 ? "8px" : "10px";
}), bE;
function Xne() {
  var e = Xa(), t = e.notificationsContainer;
  return /* @__PURE__ */ M.createElement(Jne, {
    style: t == null ? void 0 : t.container,
    id: "ss-notification-container"
  }, /* @__PURE__ */ M.createElement(Une, null), /* @__PURE__ */ M.createElement(Nne, null));
}
var Jne = Be.div(bE || (bE = Me([`
  height: 500px;
  width: 450px;
  margin: 0px 15px;
  border-radius: 5px;
  background-color: `, `;
  border: 1px solid `, `;
  display: inline-block;
  overflow: scroll;
  box-shadow: 0 0px 7px 0 rgba(0, 0, 0, 0.1);
  @media (max-width: 425px) {
    width: 99.5vw;
    margin: 0px;
    border-radius: 0px;
  }
`])), Ke.main, Ke.border), ere = function(t, n) {
  pe(function() {
    var r = !1, i = !1, a = function(l) {
      r || !i || !t.current || t.current.contains(l.target) || n(l);
    }, s = function(l) {
      i = t.current, r = t.current && t.current.contains(l.target);
    };
    return document.addEventListener("mousedown", s), document.addEventListener("touchstart", s), document.addEventListener("click", a), function() {
      document.removeEventListener("mousedown", s), document.removeEventListener("touchstart", s), document.removeEventListener("click", a);
    };
  }, [t, n]);
}, TE, _E;
function tre(e) {
  var t = e.openInbox, n = e.toggleInbox, r = e.popperPosition, i = de(null), a = i[0], s = i[1], o = de(null), l = o[0], u = o[1], c = ha(), d = c.setNotificationsData;
  ere({
    current: l
  }, function() {
    n(function(y) {
      return !y;
    });
  });
  var f = hM(a, l, {
    placement: r,
    modifiers: [{
      name: "offset",
      options: {
        offset: [0, 5]
      }
    }]
  }), p = f.styles, g = f.attributes, m = function() {
    d(function(v) {
      return tt({}, v, {
        count: 0
      });
    }), n(function(v) {
      return !v;
    });
  };
  return /* @__PURE__ */ M.createElement(nre, null, /* @__PURE__ */ M.createElement(rre, {
    onClick: m,
    ref: s
  }, /* @__PURE__ */ M.createElement(Yte, null), /* @__PURE__ */ M.createElement(Gte, null)), t && /* @__PURE__ */ M.createElement("div", tt({
    ref: u,
    style: tt({}, p.popper, {
      zIndex: 999
    })
  }, g.popper), /* @__PURE__ */ M.createElement(Xne, null)));
}
var nre = Be.div(TE || (TE = Me([`
  position: relative;
  display: inline-block;
  background-color: transparent;
  line-height: 1;
`]))), rre = Be.div(_E || (_E = Me([`
  position: relative;
  margin-top: 12px;
  margin-right: 12px;
  cursor: pointer;
`]))), CE, xE, wE, AE, SE;
function ire(e) {
  var t, n, r, i, a, s, o, l = e.notificationData, u = e.closeToast, c = Xa(), d = c.toast, f = ha(), p = f.toggleInbox, g = f.themeType, m = l.message, y = de(!1), v = y[0], E = y[1];
  pe(function() {
    var x, A = HC(m == null || (x = m.avatar) === null || x === void 0 ? void 0 : x.avatar_url);
    A.then(function(R) {
      return E(R);
    });
  }, [l]);
  var b = (d == null || (t = d.bodyText) === null || t === void 0 ? void 0 : t.tableBorderColor) || Ke.border, _ = (d == null || (n = d.bodyText) === null || n === void 0 ? void 0 : n.blockquoteColor) || Ke.border, T = (d == null || (r = d.bodyText) === null || r === void 0 ? void 0 : r.linkColor) || Ke.primary;
  return /* @__PURE__ */ M.createElement(are, {
    style: d == null ? void 0 : d.container,
    onClick: function(A) {
      p(!0), u();
    }
  }, /* @__PURE__ */ M.createElement(ure, null, m != null && (i = m.avatar) !== null && i !== void 0 && i.avatar_url && v ? /* @__PURE__ */ M.createElement(lre, {
    src: m.avatar.avatar_url,
    alt: "avatar"
  }) : /* @__PURE__ */ M.createElement(zC, {
    type: g
  })), /* @__PURE__ */ M.createElement("div", null, /* @__PURE__ */ M.createElement(sre, {
    style: d == null ? void 0 : d.headerText
  }, m.header), /* @__PURE__ */ M.createElement(ore, {
    style: d == null ? void 0 : d.bodyText
  }, /* @__PURE__ */ M.createElement(y_, {
    remarkPlugins: [U_],
    rehypePlugins: [IC],
    components: {
      a: function(A) {
        var R = A.children, P = A.href, L = A.style;
        return /* @__PURE__ */ M.createElement("a", {
          href: P,
          style: tt({
            color: T,
            textDecoration: "none"
          }, L || {})
        }, R);
      },
      p: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("p", {
          style: tt({
            margin: 0,
            overflowWrap: "anywhere"
          }, P || {})
        }, R);
      },
      blockquote: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("blockquote", {
          style: tt({
            margin: 0,
            paddingLeft: 10,
            borderLeft: "3px solid " + _,
            marginBottom: 5,
            marginTop: 5
          }, P || {})
        }, R);
      },
      ul: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("ul", {
          style: tt({
            whiteSpace: "normal",
            margin: 0,
            paddingLeft: 10
          }, P || {})
        }, R);
      },
      ol: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("ol", {
          style: tt({
            whiteSpace: "normal",
            margin: 0,
            paddingLeft: 10
          }, P || {})
        }, R);
      },
      img: function(A) {
        return /* @__PURE__ */ M.createElement("img", tt({
          style: tt({
            maxWidth: "100%",
            objectFit: "contain"
          }, (A == null ? void 0 : A.style) || {})
        }, A));
      },
      table: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("table", {
          style: tt({
            overflowWrap: "break-word",
            borderCollapse: "collapse"
          }, P || {})
        }, R);
      },
      th: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("th", {
          style: tt({
            textAlign: "left",
            whiteSpace: "nowrap",
            border: "1px solid " + b,
            padding: 5
          }, P || {})
        }, R);
      },
      td: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("td", {
          style: tt({
            border: "1px solid " + b,
            padding: 5
          }, P || {})
        }, R);
      },
      h1: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("h1", {
          style: tt({
            margin: 0
          }, P || {})
        }, R);
      },
      h2: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("h2", {
          style: tt({
            margin: 0
          }, P || {})
        }, R);
      },
      h3: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("h3", {
          style: tt({
            margin: 0
          }, P || {})
        }, R);
      },
      h4: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("h4", {
          style: tt({
            margin: 0
          }, P || {})
        }, R);
      },
      h5: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("h5", {
          style: tt({
            margin: 0
          }, P || {})
        }, R);
      },
      h6: function(A) {
        var R = A.children, P = A.style;
        return /* @__PURE__ */ M.createElement("h6", {
          style: tt({
            margin: 0
          }, P || {})
        }, R);
      },
      script: function() {
        return null;
      },
      link: function() {
        return null;
      }
    }
  }, m == null || (a = m.text) === null || a === void 0 || (s = a.replaceAll(`\\
`, "&nbsp;")) === null || s === void 0 || (o = s.replaceAll(`
`, `  
`)) === null || o === void 0 ? void 0 : o.replaceAll("&nbsp;", `&nbsp;  
`)))));
}
var are = Be.div(CE || (CE = Me([`
  background-color: `, `;
  cursor: pointer;
  padding: 14px;
  display: flex;
  overflow-wrap: anywhere;
`])), Ke.main), sre = Be(Bi)(xE || (xE = Me([`
  font-size: 13px;
  line-height: 16px;
  font-weight: 700;
  margin: 10px 0px;
`]))), ore = Be.div(wE || (wE = Me([`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  color: `, `;
  margin: 10px 0px;
  color: `, `;
`])), Ke.primaryText, Ke.primaryText), lre = Be.img(AE || (AE = Me([`
  height: 36px;
  width: 36px;
  border-radius: 100px;
`]))), ure = Be.div(SE || (SE = Me([`
  margin-top: 8px;
  margin-right: 12px;
`]))), kE;
function cre(e) {
  var t = e.position, n = e.duration, r = e.limit, i = n || 3e3, a = r || 3, s = t || (window.innerWidth > 425 ? "bottom-right" : "bottom-center");
  return /* @__PURE__ */ M.createElement(fre, {
    autoClose: i,
    position: s,
    limit: a,
    hideProgressBar: !0,
    pauseOnHover: !1,
    closeButton: !1,
    pauseOnFocusLoss: !1
  });
}
function dre(e) {
  var t = e.notificationsData, n = e.toastProps, r = (n == null ? void 0 : n.toastComponent) || ire;
  if (!document.hidden)
    var i = Bt(/* @__PURE__ */ M.createElement(r, {
      notificationData: t,
      closeToast: function() {
        Bt.dismiss({
          id: i
        });
      }
    }));
}
var fre = Be(sp)(kE || (kE = Me([`
  &.Toastify__toast-container {
    max-width: 450px;
    min-width: 300px;
    padding: 0px;
    width: unset;
  }

  .Toastify__toast-theme--light,
  .Toastify__toast-theme--default,
  .Toastify__toast-theme--dark {
    padding: 0px;
    border-radius: 5px;
    background-color: transparent;
  }

  .Toastify__toast-body {
    padding: 0px;
  }
`]))), hre = {
  storeData: {},
  unseenCount: 0,
  hasNext: !1,
  initialLoading: !1,
  fetchMoreLoading: !1
};
sn({
  notificationsData: hre
});
function pre(e) {
  var t = e.workspaceKey, n = t === void 0 ? "" : t, r = e.tenantId, i = r === void 0 ? "" : r, a = e.distinctId, s = a === void 0 ? "" : a, o = e.subscriberId, l = o === void 0 ? "" : o, u = e.inboxId, c = u === void 0 ? "" : u, d = e.stores, f = e.toastProps, p = e.notificationClickHandler, g = e.primaryActionClickHandler, m = e.secondaryActionClickHandler, y = e.bellComponent, v = e.badgeComponent, E = e.notificationComponent, b = e.noNotificationsComponent, _ = e.loaderComponent, T = e.tabBadgeComponent, x = e.headerRightComponent, A = e.hideAvatar, R = A === void 0 ? !1 : A, P = e.hideInbox, L = e.hideToast, I = e.theme, O = e.themeType, S = O === void 0 ? "light" : O, F = e.pagination, H = F === void 0 ? !0 : F, q = e.pageSize, N = e.popperPosition, Q = N === void 0 ? "bottom" : N, J = e.showUnreadCountOnTabs, D = J === void 0 ? !0 : J, C = e.host;
  c && (l = c);
  var Z = de(!1), B = Z[0], j = Z[1], z = de(), U = z[0], $ = z[1], ae = de({
    storeData: {},
    count: 0
  }), Y = ae[0], ee = ae[1], se = de(""), re = se[0], Ae = se[1], Oe = de(!1), Ce = Oe[0], ue = Oe[1];
  pe(function() {
    var Se = new JF(n, {
      pageSize: q,
      tenantID: i,
      stores: d,
      host: C
    });
    return $(Se), Se.emitter.on("sync_notif_store", function() {
      var Fe = Se.feed.data;
      ee({
        storeData: (Fe == null ? void 0 : Fe.stores) || {},
        count: (Fe == null ? void 0 : Fe.unseenCount) || 0,
        hasNext: Fe == null ? void 0 : Fe.hasNext,
        initialLoading: Fe == null ? void 0 : Fe.initialLoading,
        activeStoreId: Fe == null ? void 0 : Fe.activeStoreId
      }), Ae(Fe == null ? void 0 : Fe.activeStoreId);
    }), Se.emitter.on("new_notification", function(Fe) {
      dre({
        notificationsData: Fe,
        toastProps: f
      });
    }), function() {
      Se.emitter.all.clear();
    };
  }, []), pe(function() {
    B && l && U && U.feed.markAllSeen();
  }, [B, l, U]), pe(function() {
    if (!(!l || !U))
      return ee({
        storeData: {},
        count: 0
      }), U.identifyUser(s, l), U.feed.fetchNotifications(), function() {
        U.resetUser();
      };
  }, [l, U]);
  var fe = S === "dark" ? UC(Vte, I) : I || {};
  return /* @__PURE__ */ M.createElement(jC.Provider, {
    value: fe
  }, /* @__PURE__ */ M.createElement($C.Provider, {
    value: {
      workspaceKey: n,
      notificationsData: Y,
      setNotificationsData: ee,
      notificationClickHandler: p,
      primaryActionClickHandler: g,
      secondaryActionClickHandler: m,
      bellComponent: y,
      badgeComponent: v,
      notificationComponent: E,
      noNotificationsComponent: b,
      tabBadgeComponent: T,
      headerRightComponent: x,
      toggleInbox: j,
      inbox: U,
      loaderComponent: _,
      pagination: H,
      hideAvatar: R,
      activeStore: re,
      setActiveStore: Ae,
      changingActiveStore: Ce,
      setChangingActiveStore: ue,
      showUnreadCountOnTabs: D,
      themeType: S
    }
  }, !P && /* @__PURE__ */ M.createElement(tre, {
    openInbox: B,
    toggleInbox: j,
    popperPosition: Q
  }), !L && /* @__PURE__ */ M.createElement(cre, f)));
}
const xt = {
  timeouts: {},
  handlerCalled: {},
  getIsDesktopVersion: (e, t) => {
    const n = {
      navigation: { loggedIn: 769, loggedOut: 881 },
      search: { loggedIn: 961, loggedOut: 1121 }
    }, r = (a) => {
      const s = `logged${e ? "In" : "Out"}`;
      return t >= n[a][s];
    };
    let i = {};
    return ["navigation", "search"].forEach((a) => {
      i[a] = r(a);
    }), i;
  },
  shouldChangeHeaderIsVisible: (e, t, n) => {
    Object.values(t).filter((i) => i === !0).length || n([{ type: "headerIsVisible", value: e }]);
  },
  handleMenus: ({ id: e, value: t, menus: n, dispatch: r, forceHandle: i = !1 }) => {
    if (!i && n[e] === t || !i && e === qn.ACCOUNT && t === !1 && n[qn.SITE] === !0)
      return;
    const a = Date.now();
    if (!i && !t && xt.handlerCalled[e] && a - xt.handlerCalled[e] < 500)
      return;
    xt.handlerCalled[e] = a;
    let s = [{ type: `menus.${e}`, value: t }];
    if (t === !0)
      Object.keys(n).forEach((o) => {
        o === e || n[o] === !1 || s.push({ type: `menus.${o}`, value: !1 });
      });
    else {
      let o = null;
      switch (e) {
        case qn.SITE:
          o = document.querySelector("#header .menu-button"), o || (o = document.querySelector("#navigation .navigation-button"));
          break;
        case qn.SEARCH:
          o = document.querySelector("#header .toggle-search-button");
          break;
        case qn.ACCOUNT:
          o = document.querySelector("#header .account-button");
          break;
        default:
          return;
      }
      o && o.focus();
    }
    r(s);
  },
  // Find the first child inside a ref that matches the `key` (and optional `value`) we're looking for,
  // so we can automatically focus on the first link inside a menu for accessibility.
  // E.g. a `key` of `href` will match the first child with an `href`. Passing a `value` will match
  // the first child with an `href` that includes `value`.
  // Using `ref` lets us call `focus()`
  findFirstChild: (e, t, n = !1) => {
    if (!e || !e[0])
      return !1;
    for (let r = 0; r <= e.length; r++) {
      if (!e[r])
        continue;
      if (e[r][t] && (!n || e[r][t].includes(n)))
        return e[r];
      if (!t.includes("."))
        continue;
      const i = UE(e[r], t);
      if (!(typeof i > "u") && (!n || i[t] && i[t].includes(n) || i.value && i.value.includes(n) || i.toString().includes(n)))
        return e[r];
    }
    return e[0].children ? xt.findFirstChild(e[0].children, t, n) : !1;
  },
  autoFocus: ({ menu: e, navigationRef: t, isDesktopVersion: n, focusElements: r, dispatch: i }) => {
    var l;
    if (!t.current || !t.current.children)
      return;
    const a = n ? "desktop" : "default";
    if (r[e][a]) {
      (l = document.querySelector(`#header ul a[href="${r[e][a]}"]:last-child`)) == null || l.focus();
      return;
    }
    let s, o;
    switch (e) {
      case qn.SITE:
        if (n) {
          const u = xt.findFirstChild(
            t.current.children,
            "className",
            "has-submenu parent"
          ), c = xt.findFirstChild(u.children, "id", qn.SITE);
          s = xt.findFirstChild(c.children, "href");
        } else
          s = xt.findFirstChild(t.current.children, "href");
        break;
      case qn.ACCOUNT:
        if (o = xt.findFirstChild(
          t.current.children,
          "className",
          "account"
        ), !o || !o.children)
          return;
        s = xt.findFirstChild(o.children, "href");
        break;
      default:
        return;
    }
    s && (i([
      { type: `focusElements.${e}.${a}`, value: s.attributes.href.value }
    ]), s.focus());
  },
  events: {
    onClick: (e, { id: t, callback: n, isOpen: r }) => {
      e.target && e.target.attributes && e.target.attributes.href || (e.preventDefault(), e.stopPropagation(), clearTimeout(xt.timeouts[t]), n(t, !r));
    },
    onFocus: ({ id: e }) => {
      clearTimeout(xt.timeouts[e]);
    },
    onMouseEnter: ({ id: e, callback: t }) => {
      clearTimeout(xt.timeouts[e]), t(e, !0);
    },
    onBlur: ({ id: e, callback: t }) => {
      xt.timeouts[e] = setTimeout(() => {
        t(e, !1);
      }, 250);
    }
  },
  readLocaleFromCookie: () => {
    if (!document || !document.cookie || !document.cookie.length)
      return null;
    const e = document.cookie.match(new RegExp("(^|;\\s*)apolitical_locale=([^;]*)"));
    return e ? decodeURIComponent(e[2]) : null;
  }
}, ol = {
  order: ["home", "communities", "topics", "partners", "account"],
  home: {
    href: "/home/",
    hasVariantText: !0,
    gtmType: "homepage-click"
  },
  communities: {
    href: "/communities/",
    gtmType: "communities-click",
    onlyShow: "logged-in"
  },
  topics: {
    onlyShow: "logged-in",
    order: ["explore", "topics"],
    menuId: "site-navigation",
    explore: {
      order: ["events", "courses", "articles", "communities"],
      events: { href: "/events/", className: "icon events" },
      courses: {
        href: "/microcourses/",
        gtmType: "microcourses-click",
        className: "icon courses"
      },
      articles: {
        href: "/solution-articles/",
        gtmType: "articles-click",
        className: "icon articles"
      },
      communities: {
        href: "/communities/",
        gtmType: "communities-click",
        className: "icon communities"
      }
    },
    topics: {
      order: [
        "cities-and-local-government",
        "digital-and-data",
        "education",
        "climate",
        "health-and-social-care",
        // this is now just 'inclusion' but in the BE its still the below
        "equity-justice-and-inclusion",
        "innovation",
        "leadership-and-skills",
        "life-in-government",
        "policymaking",
        "transport-and-infrastructure",
        "work-and-the-economy"
      ],
      className: "columns",
      climate: { href: "/topics/climate/" },
      "cities-and-local-government": { href: "/topics/cities-and-local-government/" },
      "digital-and-data": { href: "/topics/digital-and-data/" },
      education: { href: "/topics/education/" },
      "equity-justice-and-inclusion": { href: "/topics/equity-justice-and-inclusion/" },
      "health-and-social-care": { href: "/topics/health-and-social-care/" },
      innovation: { href: "/topics/innovation/" },
      "leadership-and-skills": { href: "/topics/leadership-and-skills/" },
      "life-in-government": { href: "/topics/life-in-government/" },
      policymaking: { href: "/topics/policymaking/" },
      "transport-and-infrastructure": { href: "/topics/transport-and-infrastructure/" },
      "work-and-the-economy": { href: "/topics/work-and-the-economy/" }
    }
  },
  partners: {
    href: "/partnerships/",
    onlyShow: "logged-out"
  },
  account: {
    menuId: "account-navigation",
    order: ["profile", "settings", "log-out"],
    className: "account",
    onlyShow: "logged-in",
    doTrack: !1,
    profile: { href: "/profiles/me" },
    settings: { href: "/profiles/me/manage-account" },
    "log-out": { href: "/logout", className: "divider" }
  },
  buttons: {
    order: ["login", "signup"],
    login: {
      href: "/login",
      withReturnTo: !0
    },
    signup: {
      href: "/signup?ref=header-banner",
      props: { variant: "primary" }
    }
  }
}, t1 = ({
  id: e,
  isLoggedIn: t = !1,
  isDesktopVersion: n = !1,
  menus: r = {},
  callback: i = () => {
  },
  doTrack: a = null,
  getHref: s
}) => {
  const o = ye(), l = UE(ol, e);
  if (!l || l.onlyShow && (l.onlyShow === "logged-in" && !t || l.onlyShow === "logged-out" && t))
    return null;
  const u = "doTrack" in l, c = a === null ? u ? l.doTrack : !0 : a, d = e.includes("buttons.");
  let f = `header_${e.replaceAll(".", "_")}`;
  l.hasVariantText && (f += `_logged${t ? "In" : "Out"}`);
  let p = !1;
  if (l.href) {
    let _ = l.gtmType || `${e}-click`;
    if (_.includes(".")) {
      const T = _.split("."), x = T[T.length - 2];
      _ = `${x === "topics" ? `${x}-` : ""}${T[T.length - 1]}`;
    }
    p = {
      href: s ? s(l.href) : l.withReturnTo ? `${l.href}?returnTo=${window.location.pathname + window.location.search}` : l.href
    }, c && (p = {
      ...p,
      className: "gtm-trackable",
      "data-gtm-event-type": _,
      "data-gtm-event-context": "HeaderButtons"
    }), d && (p = {
      ...p,
      variant: "secondary",
      size: { mobile: "small", 881: "large" },
      ...l.props || {}
    });
  }
  const g = l.order && l.order[0] && l[l.order[0]], m = g && l[l.order[0]].order, y = p && window.location.pathname === l.href;
  let v = {}, E = {}, b = {};
  if (y && (v = { ...v, "aria-current": "page" }), g) {
    const _ = l.menuId || e, T = {
      onClick: (x) => xt.events.onClick(x, { id: _, callback: i, isOpen: r[_] }),
      onFocus: () => xt.events.onFocus({ id: _ }),
      onBlur: () => xt.events.onBlur({ id: _, callback: i }),
      onMouseLeave: () => xt.events.onBlur({ id: _, callback: i }),
      onMouseEnter: () => xt.events.onMouseEnter({ id: _, callback: i })
    };
    E = {
      ...T,
      id: _ === qn.SITE ? qn.SITE : qn.ACCOUNT
    }, n && (m && (b = {
      ...T,
      className: "navigation-button",
      onKeyPress: (x) => {
        x.key === "Enter" && xt.events.onClick(x, { id: _, callback: i, isOpen: r[_] });
      },
      "aria-haspopup": !0,
      "aria-expanded": r[_],
      "aria-controls": _
    }), E = { ...E, hidden: _ in r ? !r[_] : !0 }), m || (E = {
      ...E
    });
  }
  return /* @__PURE__ */ h.jsxs(
    "li",
    {
      className: te({
        [l.className]: l.className,
        "has-submenu": g,
        parent: m,
        active: y
      }),
      ...v,
      children: [
        p ? M.createElement(
          d ? je : "a",
          p,
          o.formatMessage({ id: f })
        ) : n && l.order && m ? /* @__PURE__ */ h.jsxs("button", { ...b, children: [
          o.formatMessage({ id: f }),
          /* @__PURE__ */ h.jsx(ht, { children: o.formatMessage({
            id: `header_menu_${r[qn.SITE] ? "hide" : "show"}`
          }) })
        ] }) : o.formatMessage({ id: f }),
        l.order && /* @__PURE__ */ h.jsx("ul", { ...E, children: l.order.map((_) => {
          if (!l[_])
            return null;
          const T = {
            isLoggedIn: t,
            isDesktopVersion: n,
            menus: r,
            callback: i,
            doTrack: u ? c : null
          };
          return l[_].order ? /* @__PURE__ */ h.jsxs(
            "li",
            {
              className: te({
                [l[_].className]: l[_].className
              }),
              children: [
                o.formatMessage({ id: `${f}_${_}` }),
                /* @__PURE__ */ h.jsx("ul", { children: l[_].order.map((x) => /* @__PURE__ */ h.jsx(
                  t1,
                  {
                    id: `${e}.${_}.${x}`,
                    ...T
                  },
                  x
                )) })
              ]
            },
            _
          ) : /* @__PURE__ */ h.jsx(
            t1,
            {
              id: `${e}.${_}`,
              ...T
            },
            _
          );
        }) })
      ]
    },
    e
  );
};
const mre = ({ headerIsVisible: e, locale: t }) => {
  const n = ye();
  return /* @__PURE__ */ h.jsx(
    "div",
    {
      id: "language-unavailable-message",
      className: te({
        visible: e
      }),
      children: /* @__PURE__ */ h.jsx("p", { className: "text", children: n.formatMessage(
        { id: `header_language_unavailable_${t}` },
        {
          link: (r) => /* @__PURE__ */ h.jsx("a", { href: "/pages/multilingual-transition", children: r })
        }
      ) })
    }
  );
}, gre = {
  colors: {
    primary: "#4F43BA",
    primaryHover: "#7C72E1",
    error: "#C34141",
    icon: "#000000",
    text: {
      primary: "#151921",
      secondary: "#64748B"
    },
    background: {
      primary: "#FFFFFF",
      hover: "#F8FAFC"
    },
    border: "#E2E8F0"
  },
  typography: {
    fontSizes: {
      xs: "12px",
      sm: "14px",
      md: "16px",
      lg: "24px"
    },
    fontWeights: {
      medium: "medium",
      bold: "bold"
    }
  },
  spacing: {
    xs: "8px",
    sm: "12px",
    md: "16px"
  },
  borderRadius: {
    sm: "8px",
    md: "12px",
    full: "9999px"
  },
  shadows: {
    sm: "0px 4px 6px rgba(0, 0, 0, 0.1)"
  },
  circleSizes: {
    avatar: "40px",
    dot: "10px"
  }
}, {
  colors: { primary: No, primaryHover: vre, error: DE, text: hi, background: pi, border: Yf, icon: yre },
  typography: { fontSizes: mi, fontWeights: _a },
  spacing: Ca,
  borderRadius: ec,
  shadows: OE,
  circleSizes: NE
} = gre, Ere = {
  bell: {
    color: yre
  },
  badge: {
    backgroundColor: DE,
    color: pi.primary
  },
  header: {
    container: {
      backgroundColor: pi.primary,
      borderBottom: `1px solid ${Yf}`
    },
    headerText: {
      color: hi.primary,
      fontSize: mi.lg,
      fontWeight: _a.bold
    },
    markAllReadText: {
      color: No,
      fontWeight: _a.medium,
      fontSize: mi.sm
    }
  },
  notificationsContainer: {
    container: {
      borderRadius: ec.md,
      overflow: "auto",
      backgroundColor: pi.primary,
      boxShadow: OE.sm,
      border: "none"
    },
    loader: { color: No },
    noNotificationsText: {
      color: hi.primary,
      fontSize: mi.md,
      fontWeight: _a.medium
    },
    noNotificationsSubtext: {
      color: hi.secondary,
      fontSize: mi.sm
    }
  },
  notification: {
    unseenDot: {
      backgroundColor: DE,
      width: NE.dot,
      height: NE.dot,
      right: Ca.md,
      top: Ca.md
    },
    container: {
      unreadBackgroundColor: pi.primary,
      readBackgroundColor: pi.primary,
      hoverBackgroundColor: pi.hover,
      borderBottom: `1px solid ${Yf}`,
      padding: Ca.md
    },
    headerText: {
      color: hi.primary,
      fontSize: mi.md,
      fontWeight: _a.medium
    },
    bodyText: {
      color: hi.primary,
      fontSize: mi.md
    },
    subtext: {
      color: hi.secondary,
      fontSize: mi.sm
    },
    actions: [
      {
        container: {
          backgroundColor: No,
          color: pi.primary,
          borderRadius: ec.full,
          padding: `${Ca.xs} ${Ca.md}`,
          fontSize: mi.sm,
          fontWeight: _a.medium,
          hoverBackgroundColor: vre
        }
      },
      {
        container: {
          borderColor: No,
          color: hi.secondary,
          backgroundColor: pi.primary,
          borderRadius: ec.full,
          padding: `${Ca.xs} ${Ca.md}`,
          fontSize: mi.sm,
          fontWeight: _a.medium
        },
        text: {
          color: No
        }
      }
    ]
  },
  toast: {
    container: {
      backgroundColor: pi.primary,
      borderRadius: ec.sm,
      boxShadow: OE.sm,
      border: `1px solid ${Yf}`
    },
    headerText: {
      color: hi.primary,
      fontWeight: _a.medium
    },
    bodyText: {
      color: hi.secondary
    }
  }
};
const Zf = { height: 67, height_desktop: 83, additional_message_height: 40 };
var qn = /* @__PURE__ */ ((e) => (e.NAVIGATION = "navigation", e.SEARCH = "search", e.ACCOUNT = "account-navigation", e.SITE = "site-navigation", e))(qn || {});
const VC = ({
  showNavigation: e = !0,
  showLanguageUnavailableMessage: t = !0,
  showLanguageSwitcher: n = !0,
  onLanguageSwitcherClick: r,
  suprSendWorkspaceKey: i
}) => {
  var q, N;
  const a = ye(), s = We(zt), o = fp();
  o && (ol.home.href = o);
  const l = Ua(!0, !0), u = s && typeof s.id == "string", c = Vn(
    () => xt.getIsDesktopVersion(u, l),
    [u, l]
  ), d = O0("suprsend-notifications") && i, f = (N = (q = s == null ? void 0 : s.externalsMetadata) == null ? void 0 : q.suprsend) == null ? void 0 : N.subscriberId, p = t && !u, g = O0("language-switcher") && n && // Prevent the language switcher from being shown if the user is logged out in v1 UIs
  !p, [m, y] = de(!1);
  pe(() => {
    let Q = null;
    try {
      Q = xt.readLocaleFromCookie();
    } catch {
      Q = null;
    }
    t && g && (Q !== null && Q !== Ms) && y(!0);
  }, [t, g, s]);
  const [v, E] = ra(Nl, {
    headerIsVisible: !0,
    menus: {
      "site-navigation": !1,
      search: !1,
      "account-navigation": !1
    },
    focusElements: {
      "site-navigation": { desktop: !1, default: !1 },
      "account-navigation": { desktop: !1, default: !1 }
    }
  }), { headerIsVisible: b, menus: _, focusElements: T } = v, x = Ue(v);
  pe(() => {
    x.current = v;
  }, [v]), N3({
    scrollPosition: m ? Zf[`height${c.navigation ? "_desktop" : ""}`] + Zf.additional_message_height : Zf[`height${c.navigation ? "_desktop" : ""}`],
    callbacks: {
      scrollUp: () => {
        const Q = x.current.menus;
        !c && Q[
          "site-navigation"
          /* SITE */
        ] || xt.shouldChangeHeaderIsVisible(!0, Q, E);
      },
      scrollDown: () => {
        const Q = x.current.menus;
        !c && Q[
          "site-navigation"
          /* SITE */
        ] || xt.shouldChangeHeaderIsVisible(!1, Q, E);
      }
    }
  });
  const A = (Q, J, D = !1) => {
    xt.handleMenus({ id: Q, value: J, menus: x.current.menus, dispatch: E, forceHandle: D });
  }, R = Ue(null), P = (Q) => {
    Q.key === "Escape" && [
      "site-navigation",
      "search",
      "account-navigation"
      /* ACCOUNT */
    ].forEach(
      (J) => {
        x.current.menus[J] && A(J, !1, !0);
      }
    );
  };
  pe(() => {
    var Q;
    return (Q = document.getElementById("header")) == null || Q.addEventListener("keydown", P), () => {
      var J;
      (J = document.getElementById("header")) == null || J.removeEventListener("keydown", P);
    };
  }, []), dl(() => {
    _[
      "site-navigation"
      /* SITE */
    ] && xt.autoFocus({
      menu: "site-navigation",
      navigationRef: R,
      isDesktopVersion: c.navigation,
      focusElements: T,
      dispatch: E
    });
  }, [_[
    "site-navigation"
    /* SITE */
  ]]), dl(() => {
    _[
      "account-navigation"
      /* ACCOUNT */
    ] && xt.autoFocus({
      menu: "account-navigation",
      navigationRef: R,
      isDesktopVersion: c.navigation,
      focusElements: T,
      dispatch: E
    });
  }, [_[
    "account-navigation"
    /* ACCOUNT */
  ]]);
  const L = u && /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    !c.search && /* @__PURE__ */ h.jsx(
      "button",
      {
        className: "search toggle-search-button",
        onClick: (Q) => {
          Q.preventDefault(), Q.stopPropagation(), A("search", !_.search);
        },
        children: /* @__PURE__ */ h.jsx(
          ht,
          {
            children: a.formatMessage({
              id: `header_search_${_.search ? "hide" : "show"}`
            })
          }
        )
      }
    ),
    /* @__PURE__ */ h.jsx(
      vR,
      {
        id: "global-search",
        handleToggle: {
          searchIsOpen: _.search,
          isDesktopVersion: c.search
        },
        gtmContext: "search-bar-header",
        gtmEvent: "form-submission"
      }
    )
  ] }), I = /* @__PURE__ */ h.jsx(
    "button",
    {
      className: "language icon language-switcher-button",
      "aria-label": "Language switcher",
      onClick: (Q) => {
        Q.preventDefault(), Q.stopPropagation(), r ? r() : y(!m);
      },
      children: /* @__PURE__ */ h.jsx(
        ht,
        {
          children: a.formatMessage({
            id: "header_language_switcher"
          })
        }
      )
    }
  ), O = [
    d && f && /* @__PURE__ */ h.jsx("div", { id: "suprsend-notifications", children: /* @__PURE__ */ h.jsx(
      pre,
      {
        workspaceKey: i,
        distinctId: (s == null ? void 0 : s.id) ?? "",
        subscriberId: f,
        theme: Ere,
        bellComponent: () => /* @__PURE__ */ h.jsx("button", { className: "bell icon bell-button" })
      }
    ) })
  ], S = /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    !c.navigation && /* @__PURE__ */ h.jsx(
      "button",
      {
        className: "menu-button gtm-trackable",
        onClick: (Q) => {
          Q.preventDefault(), Q.stopPropagation(), A("site-navigation", !_[
            "site-navigation"
            /* SITE */
          ]);
        },
        "data-gtm-event-type": "open-tab-menu-click",
        "data-gtm-event-context": "HeaderLeft-Chevron",
        "aria-haspopup": "true",
        "aria-expanded": _[
          "site-navigation"
          /* SITE */
        ],
        "aria-controls": "site-navigation",
        children: /* @__PURE__ */ h.jsx(ht, { children: a.formatMessage({
          id: `header_menu_${_[
            "site-navigation"
            /* SITE */
          ] ? "hide" : "show"}`
        }) })
      }
    ),
    /* @__PURE__ */ h.jsx(
      "ul",
      {
        ref: R,
        id: "navigation",
        hidden: c.navigation || _[
          "account-navigation"
          /* ACCOUNT */
        ] ? !1 : !_[
          "site-navigation"
          /* SITE */
        ],
        "data-showing": !c.navigation && _[
          "account-navigation"
          /* ACCOUNT */
        ] ? "account" : "default",
        children: ol.order.map((Q) => /* @__PURE__ */ h.jsx(
          t1,
          {
            id: Q,
            isLoggedIn: u,
            isDesktopVersion: c.navigation,
            menus: {
              "site-navigation": _[
                "site-navigation"
                /* SITE */
              ],
              "account-navigation": _[
                "account-navigation"
                /* ACCOUNT */
              ]
            },
            callback: A
          },
          Q
        ))
      }
    )
  ] }), F = window.location.pathname.match(
    new RegExp("(courses/[^/]+/[^/]+|microcourses/[^/]+/[^/]+)")
  ), H = (Q) => {
    var U;
    const [J, D] = Q.split("?"), C = new URLSearchParams(D || ""), B = new URLSearchParams(window.location.search).get("ref");
    if (C.set("ref", B || "course-overview"), window.location.pathname) {
      const $ = window.location.pathname.match(
        new RegExp("(courses/([^/]+)/([^/]+)|microcourses/[^/]+/([^/]+))")
      );
      if ($) {
        const [, , ae, Y, ee] = $;
        ee ? C.set("courseSlug", ee) : (C.set("courseSlug", ae), C.set("journeySlug", Y)), C.set(
          "signupRedirectUrl",
          window.location.pathname + (window.location.search || "")
        );
      }
    }
    const j = ((U = window.location.pathname.match(/^\/([^/]+)\/courses/)) == null ? void 0 : U[1]) || "";
    return `${j ? `/${j}` : ""}${J}?${C.toString()}`;
  };
  return s && s.isLoading ? null : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsxs(
      "nav",
      {
        id: "header",
        className: te({
          "logged-in": u,
          "logged-out": !u,
          visible: b
        }),
        children: [
          /* @__PURE__ */ h.jsx(
            ht,
            {
              element: "a",
              href: "#content-of-page",
              children: a.formatMessage({ id: "header_skip" })
            }
          ),
          /* @__PURE__ */ h.jsx(fT, { variant: "monochrome" }),
          e ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
            c.navigation ? /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
              S,
              L,
              g && I,
              O
            ] }) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
              L,
              g && I,
              O,
              S
            ] }),
            u ? /* @__PURE__ */ h.jsxs(
              "button",
              {
                className: "account-button",
                onClick: (Q) => xt.events.onClick(Q, {
                  id: "account-navigation",
                  callback: A,
                  isOpen: _[
                    "account-navigation"
                    /* ACCOUNT */
                  ]
                }),
                onMouseEnter: () => xt.events.onMouseEnter({
                  id: "account-navigation",
                  callback: A
                }),
                onMouseLeave: () => xt.events.onBlur({
                  id: "account-navigation",
                  callback: A
                }),
                "aria-haspopup": "true",
                "aria-expanded": _[
                  "account-navigation"
                  /* ACCOUNT */
                ],
                "aria-controls": "account-navigation",
                children: [
                  /* @__PURE__ */ h.jsx(ht, { children: a.formatMessage({
                    id: `header_account_${_[
                      "account-navigation"
                      /* ACCOUNT */
                    ] ? "hide" : "show"}`
                  }) }),
                  /* @__PURE__ */ h.jsx(
                    aa,
                    {
                      name: s && s.name || "",
                      src: s && s.image && s.image.thumbnail || ""
                    }
                  )
                ]
              }
            ) : /* @__PURE__ */ h.jsx("ul", { className: "sign-in-buttons", children: ol.buttons.order.map((Q) => /* @__PURE__ */ h.jsx(
              t1,
              {
                id: `buttons.${Q}`,
                getHref: Q === "signup" && F ? H : void 0
              },
              Q
            )) })
          ] }) : g && I
        ]
      }
    ),
    m && /* @__PURE__ */ h.jsx(
      mre,
      {
        headerIsVisible: b,
        locale: (s == null ? void 0 : s.locale) || Ms
      }
    ),
    /* @__PURE__ */ h.jsx("hr", { id: "content-of-page" }),
    /* @__PURE__ */ h.jsx(
      "div",
      {
        className: te("overlay", {
          open: _[
            "site-navigation"
            /* SITE */
          ] || _[
            "account-navigation"
            /* ACCOUNT */
          ] || !c.search && _.search
        })
      }
    )
  ] });
};
const bre = () => {
  const e = ye();
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsx(VC, {}),
    /* @__PURE__ */ h.jsx("div", { id: "content", children: /* @__PURE__ */ h.jsx(
      Ci,
      {
        variant: "error",
        text: e.formatMessage({ id: "pageLayout_error" })
      }
    ) }),
    /* @__PURE__ */ h.jsx(pT, {})
  ] });
}, Tre = ({
  children: e,
  additionalContent: { prepended: t, appended: n } = {},
  reportError: r,
  forceShow: i = {},
  styling: a = {},
  className: s = "",
  locale: o = "en",
  suprSendWorkspaceKey: l
}) => {
  const u = ye(), { navigation: c = !0, footer: d = !0 } = i, {
    background: f = "default",
    variant: p = "default",
    circle: g = "default",
    modal: m = "default"
  } = a, y = D3(), [v, E] = de(""), b = (R) => {
    const {
      detail: { message: P }
    } = R;
    E(P);
  };
  pe(() => (window.scrollTo(0, 0), document.addEventListener("ariaLive", b), () => {
    document.removeEventListener("ariaLive", b);
  }), [y]);
  const _ = ac(e, { locale: o }), T = ac(t, {
    locale: o
  }), x = ac(n, {
    locale: o
  }), A = {};
  return f !== "default" && (A[f] = !0), p !== "default" && (A[p] = !0), g !== "default" && (A[g] = !0), /* @__PURE__ */ h.jsx(E3, { onError: r, fallback: /* @__PURE__ */ h.jsx(bre, {}), children: /* @__PURE__ */ h.jsxs(BE, { fallback: null, children: [
    /* @__PURE__ */ h.jsxs(
      "div",
      {
        id: "wrapper",
        className: te(s, A, { "has-footer": d }),
        "data-too-small": u.formatMessage({ id: "pageLayout_browserTooSmall" }),
        children: [
          /* @__PURE__ */ h.jsx(
            VC,
            {
              suprSendWorkspaceKey: l,
              showNavigation: c
            }
          ),
          /* @__PURE__ */ h.jsxs("main", { id: "content-wrapper", children: [
            T && /* @__PURE__ */ h.jsx(
              "div",
              {
                className: te("additional-content prepended", {
                  "large-modal": m === "large"
                }),
                children: T
              }
            ),
            M.createElement(f === "bold" ? d4 : "div", {
              id: "content",
              children: _,
              className: te({ "large-modal": m === "large" })
            })
          ] }),
          x && /* @__PURE__ */ h.jsx("div", { className: "additional-content appended", children: x }),
          d && /* @__PURE__ */ h.jsx(pT, {}),
          /* @__PURE__ */ h.jsx(tF, {})
        ]
      }
    ),
    v && /* @__PURE__ */ h.jsx(
      ht,
      {
        "aria-live": "polite",
        showOnFocus: !1,
        "data-testid": "layout-aria-live",
        children: v
      }
    )
  ] }) });
}, IE = {
  default: "tags_",
  headerTopics: "header_topics_topics_"
}, Qf = {
  topic: {
    Climate: "climate",
    CitiesAndLocalGovernment: "cities-and-local-government",
    DigitalAndData: "digital-and-data",
    Education: "education",
    EquityJusticeAndInclusion: "equity-justice-and-inclusion",
    HealthAndSocialCare: "health-and-social-care",
    Innovation: "innovation",
    LeadershipAndSkills: "leadership-and-skills",
    LifeInGovernment: "life-in-government",
    Policymaking: "policymaking",
    TransportAndInfrastructure: "transport-and-infrastructure",
    WorkAndTheEconomy: "work-and-the-economy"
  },
  "from the community": "community"
}, _re = {
  getTagDetails: (e) => {
    if (e.includes("topic_")) {
      if (e = Qf.topic[e.replace("topic_", "")], e) {
        const t = ol.topics.topics[e].href;
        return t ? { id: e, href: t, text: `${IE.headerTopics}${e}` } : null;
      }
      return null;
    }
    return Qf[e] ? (e = Qf[e], { id: e, text: `${IE.default}${e}` }) : null;
  }
};
const Dae = ({
  tags: e = [],
  color: t = "default",
  forceOneLine: n = !1,
  canHaveLinks: r = !0,
  className: i = "",
  gtmType: a = "tag-click",
  gtmContext: s = "tags"
}) => {
  const o = ye();
  if (!e || e.length < 1)
    return null;
  const l = [];
  return e.forEach((u) => {
    if (!u)
      return;
    const c = _re.getTagDetails(u);
    c && l.push(c);
  }), l.length < 1 ? null : /* @__PURE__ */ h.jsx(
    "ul",
    {
      className: te("tags text-small", t, i, {
        "one-line": n
      }),
      children: l.map((u) => {
        const c = o.formatMessage({ id: u.text });
        return /* @__PURE__ */ h.jsx("li", { children: u.href && r ? /* @__PURE__ */ h.jsx(
          "a",
          {
            href: u.href,
            className: "gtm-trackable",
            "data-gtm-event-type": a,
            "data-gtm-event-context": s,
            children: c
          }
        ) : c }, u.id);
      })
    }
  );
};
const Cre = 25, xre = ({
  members: { data: e = [], total: t = e.length },
  communitySlug: n,
  isMember: r = !1,
  hasNextPage: i = !1,
  loadNextPage: a = () => {
  },
  profile: s,
  gtmContext: o = "member",
  gtmType: l = "member-click",
  showHeader: u = !0,
  showPlaceholders: c = !1,
  className: d = ""
}) => {
  const f = ye(), p = "membersList", g = We(zt), [m, y] = de(!1);
  return e.length === 0 && !c ? null : /* @__PURE__ */ h.jsxs("div", { className: te("members-list", d), children: [
    u ? /* @__PURE__ */ h.jsxs("h1", { children: [
      f.formatMessage({ id: p }),
      /* @__PURE__ */ h.jsx("span", { className: "count", children: t })
    ] }) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
    /* @__PURE__ */ h.jsxs("ul", { children: [
      r ? /* @__PURE__ */ h.jsxs("li", { children: [
        /* @__PURE__ */ h.jsx(
          ea,
          {
            member: g,
            gtmContext: o,
            gtmType: l,
            badges: {
              showBadges: !0,
              scopes: [
                {
                  scope: Cn.Communities,
                  area: n || ""
                },
                {
                  scope: Cn.Platform,
                  area: "all"
                }
              ]
            }
          }
        ),
        /* @__PURE__ */ h.jsx(
          qa,
          {
            href: "/profiles/me",
            className: "text-small",
            onClick: (v) => {
              v == null || v.preventDefault(), v == null || v.stopPropagation(), y(!0);
            },
            children: f.formatMessage({ id: `${p}_profile` })
          }
        )
      ] }) : /* @__PURE__ */ h.jsx(h.Fragment, {}),
      e.map((v, E) => g && v.id === g.id ? /* @__PURE__ */ h.jsx(h.Fragment, {}) : /* @__PURE__ */ h.jsxs("li", { children: [
        /* @__PURE__ */ h.jsx(
          ea,
          {
            member: v,
            gtmContext: o,
            gtmType: l,
            badges: {
              showBadges: !0,
              scopes: [
                {
                  scope: Cn.Communities,
                  area: n || ""
                },
                {
                  scope: Cn.Platform,
                  area: "all"
                }
              ]
            }
          }
        ),
        v.isAdmin && /* @__PURE__ */ h.jsx(Ti, { children: f.formatMessage({ id: `${p}_admin` }) })
      ] }, E)),
      c && e.length === 0 && t > 0 ? [...new Array(Math.min(t, Cre))].map((v, E) => /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx(vp, { layout: "member" }) }, E)) : /* @__PURE__ */ h.jsx(h.Fragment, {})
    ] }),
    i && /* @__PURE__ */ h.jsx(
      c1,
      {
        hasNextPage: i,
        loadNextPage: a,
        icon: { icon: "arrow-down", position: "right" },
        messages: {
          button: f.formatMessage({ id: "loadMore_button" }),
          error: f.formatMessage({ id: "loadMore_error" })
        },
        gtmContext: o
      }
    ),
    s ? /* @__PURE__ */ h.jsx(
      c0,
      {
        form: s,
        showModal: m,
        content: { title: f.formatMessage({ id: `${p}_modal_title` }) },
        functions: {
          onClose: () => {
            y(!1);
          }
        }
      }
    ) : /* @__PURE__ */ h.jsx(h.Fragment, {})
  ] });
}, wre = xre, Are = ({ intlPath: e, showGuidelines: t, type: n, gtmContext: r }) => {
  const i = ye();
  return t ? /* @__PURE__ */ h.jsx("small", { children: wr(i.formatMessage, `${e}explainer`, n, "action", {
    a: (a) => /* @__PURE__ */ h.jsx(
      "a",
      {
        href: "https://about.apolitical.co/q-and-a-community-guidelines",
        target: "_blank",
        className: "gtm-trackable",
        "data-gtm-event-context": r,
        "data-gtm-event-type": "community-guidelines-link",
        rel: "noreferrer",
        children: a
      }
    )
  }) }) : /* @__PURE__ */ h.jsx(h.Fragment, {});
}, Sre = ({ intlPath: e, type: t, ...n }) => {
  const r = ye();
  return /* @__PURE__ */ h.jsx(
    Nh,
    {
      label: {
        visible: r.formatMessage({ id: `${e}label` }),
        screenreader: wr(
          r.formatMessage,
          `${e}label_action`,
          t,
          "action"
        )
      },
      ...n
    }
  );
}, PE = 5, RE = 2, kre = (e) => {
  var r;
  let t = 0;
  const n = [];
  return (r = e == null ? void 0 : e["poll-options"]) == null || r.forEach((i, a) => {
    i !== "" && (t++, n.push({
      position: t,
      description: { en: i }
    }));
  }), {
    title: { en: e.title },
    options: n,
    settings: {
      allow_multiple_votes: e["multiple-answers"] || !1
    }
  };
};
const $t = "discussion_form_", j1 = ({
  id: e,
  parentId: t,
  content: n = { type: et.Response, slugs: {} },
  userHasPermissions: r = !0,
  meta: i,
  placeholder: a,
  maxLength: s = 0,
  buttons: o,
  forceShow: l = {
    cancel: !1,
    error: !1
  },
  functions: u,
  data: c = {},
  gtmContext: d = "DiscussionForm"
}) => {
  var ie, me, Pe;
  const f = ye(), p = We(zt), [g, m] = de(
    n.type
  ), [y, v] = de(""), {
    isLoading: E = !1,
    isInWrapper: b = !1,
    isInOverlay: _ = !1,
    isAutoFocused: T = !1,
    isEditing: x = !1,
    hasTitleField: A = !1,
    canBePrepopulated: R = !1,
    isPrepopulated: P = !1,
    showTitle: L = !1,
    showGuidelines: I = !0,
    showDivider: O = !1,
    showSuccessMessage: S = !0,
    showPostType: F = !1,
    postCategories: H = []
  } = i || {}, {
    onChange: q = () => {
    },
    create: N = () => {
    },
    createPoll: Q = () => Promise,
    handleSaveEdit: J = () => {
    },
    handleCancel: D = () => {
    },
    callback: C = () => {
    },
    onMention: Z = () => {
    },
    listMembers: B = () => Promise.resolve([]),
    clickMentionFallback: j = () => {
    },
    getLinkPreview: z = () => Promise.resolve({}),
    props: U = {
      create: { projectNames: ["questions-answers"] }
    }
  } = u, [$, ae] = de({
    body: x && x.text || P && P.text || "",
    data: c != null && c.link ? { link: c == null ? void 0 : c.link } : {}
  }), [Y, ee] = de(l.error || !1), se = {
    status: !1,
    title: A && A.text || "",
    polls: 0
  }, [re, Ae] = de(se);
  pe(() => {
    R && !x && P && P !== $.body && ae((ge) => ({ ...ge, body: P.text || "" }));
  }, [P]), pe(() => {
    m(n.type);
  }, [n.type]);
  const Oe = fl(
    (ge, X) => {
      ae((ve) => ({ ...ve, body: ge, data: { link: X } })), q({ body: ge });
      let xe;
      !p || !p.id ? xe = wr(
        f.formatMessage,
        `${$t}error_loggedOut`,
        g,
        "action"
      ) : r ? s > 0 && ge.length >= s && (xe = `${$t}error_tooLong`) : xe = wr(
        f.formatMessage,
        `${$t}error_noPermission`,
        g,
        "action"
      ), xe ? ee(xe) : Y && ee(!1);
    },
    50
  );
  let Ce = `${g}-form`;
  if (g === et.Response || g === et.Reply) {
    const ge = ((ie = n.slugs) == null ? void 0 : ie.reply) || ((me = n.slugs) == null ? void 0 : me.answer) || ((Pe = n.slugs) == null ? void 0 : Pe.question) || "";
    ge && (Ce = `${Ce}-${ge.slice(-15)}`);
  }
  e && (Ce = `${e}-${Ce}`);
  const ue = async (ge) => {
    if (!p || !p.id || !r || mt)
      throw new Error("You do not have permission to post.");
    Ae((xe) => ({ ...xe, status: "submitting" }));
    const X = window.location.pathname;
    try {
      let xe;
      switch (g) {
        case et.Post:
          xe = await N({
            title: ge.title,
            content: ge.body,
            categories: ge.postType,
            data: ge.data
          });
          break;
        case et.Poll:
          xe = await Q(kre(ge));
          break;
        case et.Question:
          xe = await N({
            title: ge.body,
            authorId: p && p.id,
            data: ge.data,
            ...U == null ? void 0 : U.create
          });
          break;
        case et.Response:
          xe = await N(
            { questionSlug: n.slugs.question },
            {
              body: ge.body,
              authorId: p && p.id,
              contentPath: X,
              data: ge.data
            }
          );
          break;
        case et.Reply:
          xe = await N(
            { questionSlug: n.slugs.question, answerSlug: n.slugs.answer },
            {
              body: ge.body,
              authorId: p && p.id,
              contentPath: X,
              data: ge.data
            }
          );
          break;
        default:
          break;
      }
      await C0(1e3), C && await C(xe), ae({
        body: "",
        data: {}
      }), m(n.type), Ae((Ne) => ({ ...Ne, status: "submitted" })), v(
        wr(f.formatMessage, `${$t}success`, g, "action")
      );
      const ve = new Event(rn.DISCUSSION_FORM_SUBMITTED);
      return document.dispatchEvent(ve), await fe(), xe;
    } catch (xe) {
      const ve = xe;
      let Ne = `${$t}error`;
      ve != null && ve.message.includes("entry already exists") && (Ne = wr(
        f.formatMessage,
        `${$t}error_alreadyExists`,
        g,
        "action"
      )), ve != null && ve.message.includes("429") ? Ne = wr(
        f.formatMessage,
        `${$t}error_tooMany`,
        g,
        "action"
      ) : ve != null && ve.message.includes("400") && (Ne = `${$t}error`), ee(Ne), await fe();
    }
  }, fe = async () => {
    await C0(5e3), ee(!1), Ae(se), v("");
  }, Se = fl(async (ge) => {
    const X = { ...$, ...ge };
    if (x) {
      Ae((xe) => ({ ...xe, status: "submitting" })), J(X);
      return;
    }
    try {
      if (!await ue(X))
        throw Error("No response from handleSubmit");
    } catch {
    }
  }, 100);
  if (E)
    return /* @__PURE__ */ h.jsx(
      Dr,
      {
        className: "discussion-card discussion-form",
        "data-testid": "loading-placeholder"
      }
    );
  const Fe = !$.body || !hl($.body), nt = !re.title || !hl(re.title);
  let mt = !1;
  g !== et.Poll && (mt = Fe), A && (mt = mt && nt);
  const Ze = re.status === "submitting", rt = [];
  g === et.Poll ? rt.push(
    {
      id: "poll-options",
      label: f.formatMessage({ id: `${$t}option_label` }),
      type: "multiple-inputs",
      element: "textarea",
      placeholder: f.formatMessage({ id: `${$t}option_placeholder` }),
      limit: 100,
      multipleInputs: {
        showCount: !0,
        defaultInputs: RE,
        maxInputs: PE,
        hasButton: {
          variant: "secondary",
          size: "small",
          styling: { muted: !0 },
          icon: "plus",
          children: f.formatMessage({ id: `${$t}option_cta` })
        }
      },
      styling: {
        autosizeToFit: !0
      },
      functions: {
        onChange: (ge) => {
          var xe;
          let X = 0;
          ge && Array.isArray(ge) && (X = ((xe = ge == null ? void 0 : ge.filter((ve) => ve !== "")) == null ? void 0 : xe.length) || 0), re.polls !== X && Ae((ve) => ({ ...ve, polls: X })), q({ polls: ge });
        }
      },
      validation: [{ condition: "required" }]
    },
    {
      type: "checkbox",
      id: "multiple-answers",
      label: f.formatMessage({ id: `${$t}multiplePollAnswers` }),
      className: "text-medium"
    }
  ) : rt.push(
    {
      component: Sre,
      props: {
        formID: Ce,
        intlPath: $t,
        showLabel: A !== !1,
        type: g
      }
    },
    {
      component: lT,
      props: {
        id: `${Ce}-input`,
        value: re.status === "submitting" && !Y ? "" : $.body,
        placeholder: a || wr(f.formatMessage, `${$t}placeholder`, g, "action"),
        maxLength: s,
        meta: {
          isInOverlay: _
        },
        functions: {
          onChange: Oe,
          onChangeData: (ge) => {
            ae((X) => ({ ...X, data: ge }));
          },
          onMention: Z,
          listMembers: B,
          clickMentionFallback: j,
          getLinkPreview: z
        },
        data: c,
        autoFocus: x !== !1 || T && !A,
        "aria-invalid": !!Y,
        "aria-errormessage": "error-message"
      }
    },
    {
      component: Are,
      props: {
        intlPath: $t,
        showGuidelines: I,
        type: g,
        gtmContext: d
      }
    }
  ), O && rt.push({ component: Zr }), A && rt.unshift({
    id: "title",
    type: "textarea",
    value: A.text,
    limit: 250,
    label: f.formatMessage({
      id: `${$t}${g === et.Poll ? "question" : "titleField"}_label`
    }),
    styling: {
      autosizeToFit: !0
    },
    placeholder: f.formatMessage({
      id: `${$t}${g === et.Poll ? "question" : "titleField"}_placeholder`
    }),
    functions: {
      onChange: (ge) => {
        Ae((X) => ({ ...X, title: ge })), q({ title: ge });
      }
    },
    validation: g === et.Poll ? [{ condition: "required" }] : []
  }), F && rt.unshift({
    id: "postType",
    type: "radio",
    value: "no-category",
    accessibilityOptions: {
      checkboxes: {
        navigateWithArrowKeys: !0
      }
    },
    styling: { displayOptionsAsPills: !0 },
    label: f.formatMessage({ id: `${$t}postType_label` }),
    options: H.map((ge) => ({
      id: ge.slug,
      label: ge.name
    })),
    validation: [
      {
        condition: "required"
      }
    ],
    functions: {
      onChange: (ge) => {
        q({ postType: ge }), ge.includes(et.Poll) ? m(et.Poll) : g !== et.Post && m(et.Post);
      }
    }
  });
  let Qe = !p || !p.id || !r || Ze;
  if (g === et.Poll) {
    const ge = re.polls;
    Qe = Qe || nt || ge < RE || ge > PE;
  } else
    Qe = Qe || mt, x && (A ? Qe = Qe || $.body === x.text && re.title === A.text : Qe = Qe || $.body === x.text);
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsxs(
      ti,
      {
        id: Ce,
        className: te("discussion-card discussion-form", {
          "no-styling": b && x
        }),
        meta: {
          shouldReset: !0,
          shouldHide: !1,
          showRequiredLabels: !1,
          shouldShowCancelButton: x && !Ze || l.cancel
        },
        functions: {
          onSuccess: async (ge) => {
            await Se(ge);
          },
          onCancel: D
        },
        fields: rt,
        intlPath: $t,
        button: {
          variant: "primary",
          size: { mobile: "small", 600: "medium" },
          "data-gtm-event-context": d,
          "data-gtm-event-type": `${x ? "save" : "submit"}-${g}-click`,
          "data-testid": "save-button",
          disabled: Qe,
          text: {
            default: !x && (o != null && o.submit) ? o == null ? void 0 : o.submit : f.formatMessage({
              id: `${$t}${x ? "save" : "post"}`
            }),
            submitting: f.formatMessage({
              id: `${$t}${x ? "saving" : "posting"}`
            })
          }
        },
        secondaryActionButton: {
          variant: "secondary",
          size: { mobile: "small", 600: "medium" },
          "data-gtm-event-context": d,
          "data-gtm-event-type": `cancel-${g}-click`,
          disabled: !l.cancel && (!p || !p.id || !$.body),
          text: o != null && o.cancel ? o == null ? void 0 : o.cancel : f.formatMessage({ id: `${$t}cancel` })
        },
        gtm: { context: d, event: `${g}-form` },
        "data-testid": `discussion-${g}-form`,
        children: [
          L && !x && g === et.Question && /* @__PURE__ */ h.jsx("h2", { children: wr(f.formatMessage, `${$t}title`, g, "action") }),
          /* @__PURE__ */ h.jsx(
            ea,
            {
              member: p ? { ...p, link: !1 } : "community",
              gtmContext: d,
              gtmType: "profile-click",
              badges: {
                showBadges: !0,
                scopes: [
                  {
                    scope: Cn.Communities,
                    area: t || ""
                  },
                  {
                    scope: Cn.Platform,
                    area: "all"
                  }
                ]
              }
            }
          )
        ]
      }
    ),
    re.status === "submitted" && S && /* @__PURE__ */ h.jsx(pl, { className: "success", "data-testid": "success", children: wr(f.formatMessage, `${$t}success`, g, "action") }),
    Y && /* @__PURE__ */ h.jsx(pl, { id: "error-message", className: "error", "data-testid": "error", children: l.error ? l.error : typeof Y == "string" ? Y.includes(" ") ? Y : f.formatMessage(
      { id: Y },
      {
        action: f.formatMessage({
          id: `discussion_action_${g}`
        }),
        maxLength: s
      }
    ) : Y }),
    y && /* @__PURE__ */ h.jsx(ht, { "aria-live": "polite", showOnFocus: !1, children: y })
  ] });
}, Dre = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j1
}, Symbol.toStringTag, { value: "Module" }));
function KC(e, t) {
  let n = t;
  const r = e.matchAll(Rs), i = e.matchAll(/\[([^\]]+)\]\(([^)]+)\)/g);
  for (const a of [r, i])
    for (const s of a)
      if (s.index !== void 0) {
        if (s.index >= n)
          break;
        if (s.index + s[0].length <= n)
          continue;
        n = s.index;
      }
  return e.length > n ? e.slice(0, n).trim() + "…" : e;
}
const GC = 280, Ore = (e, t, n) => {
  let r = t ? KC(
    e,
    typeof t == "number" ? t : GC
  ) : e;
  return r = r.trim(), r = r.replaceAll(Rs, (i, a) => {
    var s, o;
    return `[@${((o = (s = n == null ? void 0 : n[a]) == null ? void 0 : s.data) == null ? void 0 : o.name) || a}](/profiles/${a})`;
  }), r;
}, YC = async (e, t, n, r = () => Promise.resolve([])) => {
  let i = t ? KC(
    e,
    typeof t == "number" ? t : GC
  ) : e;
  i = i.trim();
  const a = `<br>

`;
  return i.slice(0, a.length) === a && (i = i.slice(a.length)), n ? await XE({
    text: i,
    template: "[@{{name}}](/profiles/{{id}})",
    mentions: n,
    listMembers: r
  }) : i;
}, ZC = (e, t) => t.length === 0 || e.length === 0 ? [] : e.map((n) => t.find((r) => r.slug === n)).filter((n) => n !== void 0), Nre = (e, t, n) => {
  let r = !1;
  function i(a) {
    let s = 30;
    for (; a || s <= 0; ) {
      if (t.some(
        (o) => Array.from(a == null ? void 0 : a.classList).includes(o)
      )) {
        r = !0;
        break;
      }
      if (Array.from(a == null ? void 0 : a.classList).includes(n))
        break;
      a = a.parentElement, s--;
    }
  }
  return i(e.target), r;
}, Ire = (e, t) => e ? typeof e == "string" ? e : e[t] : "";
const Pre = {
  showForm: !1
}, u0 = sn(Pre), Rre = ({ children: e }) => {
  const [t, n] = de({
    showForm: !1
  });
  return /* @__PURE__ */ h.jsx(u0.Provider, { value: { ...t, updateConversation: n }, children: e });
};
function Fre({
  author: e,
  originalAuthorId: t,
  createdAt: n,
  contentData: r,
  content: i,
  gtmContext: a,
  badges: s
}) {
  var d;
  const o = "discussion_", l = ye(), u = (d = i == null ? void 0 : i.componentProps) == null ? void 0 : d.member.additionalContent, c = u ? u.customMessage : void 0;
  return /* @__PURE__ */ h.jsxs("div", { className: "author-section", children: [
    /* @__PURE__ */ h.jsx(
      ea,
      {
        member: e,
        additionalContent: {
          createdAt: n,
          didEdit: r.didEdit,
          customMessage: c
        },
        className: te({
          highlighted: typeof e != "string" && e.id === t
        }),
        styling: {
          // Force the additional content onto a new line if there's a custom message
          // Otherwise, set this to false so the default details will render
          additionalContentNewLine: !!c
        },
        gtmContext: a,
        gtmType: "profile-click",
        badges: s
      }
    ),
    i.pinned && /* @__PURE__ */ h.jsx(Ti, { variant: "naked", size: "xlarge", icon: "pin", children: /* @__PURE__ */ h.jsx(ht, { children: l.formatMessage({ id: `${o}pinned_post` }) }) })
  ] });
}
const Xf = ({
  children: e,
  class: t,
  ...n
}) => {
  const r = {
    ...n,
    class: te("subtle", t)
  };
  return /* @__PURE__ */ h.jsx("blockquote", { ...r, children: e });
};
function Bre({ content: e }) {
  var t;
  return !e || !((t = e.categories) != null && t.length) ? /* @__PURE__ */ h.jsx(h.Fragment, {}) : /* @__PURE__ */ h.jsx("ul", { className: "categories-list", children: e.categories.map((n) => !n.slug || !n.name ? /* @__PURE__ */ h.jsx(h.Fragment, {}) : /* @__PURE__ */ h.jsx(Ti, { size: "small", element: "li", children: n.name }, n.slug)) });
}
var lp = /* @__PURE__ */ ((e) => (e.Always = "always", e.AfterVoting = "after-voting", e))(lp || {});
const Mre = (e, t, n) => n === void 0 ? 0 : e.some((i) => i.hasUserVoted) ? t ? e.findIndex((i) => !i.hasUserVoted) : e.findIndex((i) => i.hasUserVoted) : 0, Lre = (e, t, n, r = 0) => {
  if (!e)
    return { nextElement: null, nextIndex: 0 };
  let i = n === "next" ? e.nextElementSibling : e.previousElementSibling, a = r + (n === "next" ? 1 : -1);
  for (; i; ) {
    if (!i.classList.contains(t))
      return { nextElement: i, nextIndex: a };
    i = n === "next" ? i.nextElementSibling : i.previousElementSibling, a = a + (n === "next" ? 1 : -1);
  }
  const s = e.parentElement;
  if (s)
    for (i = n === "next" ? s.firstElementChild : s.lastElementChild, a = n === "next" ? 0 : s.childElementCount - 1; i && i !== e; ) {
      if (!i.classList.contains(t))
        return { nextElement: i, nextIndex: a };
      i = n === "next" ? i.nextElementSibling : i.previousElementSibling, a = a + (n === "next" ? 1 : -1);
    }
  return { nextElement: null, nextIndex: 0 };
};
const $re = ({
  user: e,
  option: t,
  optionIndex: n,
  totalPollVotes: r = 0,
  allowMultipleVotes: i = !1,
  showResults: a = !1,
  hasVotedOnPoll: s = !1,
  isTabbable: o = !1,
  functions: l
}) => {
  var y;
  const [u, c] = de(t.hasUserVoted);
  let d = 0, f = {};
  const p = (i || !s) && !t.hasUserVoted;
  a && (d = Math.round(t.numVotes / r * 100) || 0, f = {
    "--vote-perc": `${d}%`
  });
  const g = (v) => {
    v.stopPropagation(), p && (l == null || l.createVote(t), c(!0));
  }, m = {
    htmlFor: t.id,
    className: te({
      "can-vote": p
    }),
    tabIndex: o && p ? 0 : -1,
    "data-testid": "poll-option-label",
    "data-gtm-event-type": "poll-option-click",
    "data-gtm-event-context": "PollOption",
    "aria-selected": t.hasUserVoted,
    onClick: g,
    onKeyDown: (v) => {
      var E;
      if (v.code !== "Tab")
        switch (v.code) {
          case "Enter":
          case "Space":
            v.preventDefault(), v.stopPropagation(), g(v), c(!0);
            break;
          case "ArrowUp":
          case "ArrowDown":
            v.stopPropagation(), v.preventDefault();
            const b = v.code === "ArrowUp" ? "prev" : "next", { nextElement: _, nextIndex: T } = Lre(
              v.currentTarget.parentElement,
              "selected",
              b,
              n
            );
            _ && ((E = _.querySelector("label")) == null || E.focus(), l == null || l.setTabbableOption(T));
            break;
        }
    }
  };
  return /* @__PURE__ */ h.jsxs(
    "li",
    {
      "data-testid": "poll-option",
      style: f,
      className: te("poll-option text-small", {
        selected: t.hasUserVoted
      }),
      children: [
        /* @__PURE__ */ h.jsx("label", { ...m, children: /* @__PURE__ */ h.jsx("span", { children: t.label }) }),
        a && /* @__PURE__ */ h.jsxs("div", { className: "vote-details", children: [
          t.hasUserVoted && /* @__PURE__ */ h.jsx(
            aa,
            {
              className: "author-profile-picture",
              name: e.name,
              src: (y = e == null ? void 0 : e.image) == null ? void 0 : y.thumbnail
            }
          ),
          /* @__PURE__ */ h.jsxs("p", { className: "vote-perc text-medium", "data-testid": "vote-perc", children: [
            d,
            "%"
          ] })
        ] }),
        /* @__PURE__ */ h.jsx(
          "input",
          {
            type: i ? "radio" : "checkbox",
            id: t.id,
            name: t.id,
            checked: u,
            tabIndex: -1
          }
        )
      ]
    }
  );
};
const jre = ({ title: e, options: t, settings: n, functions: r }) => {
  const i = "poll_", a = ye(), s = We(zt), {
    showRemoveVote: o = !1,
    allowMultipleVotes: l = !1,
    resultsVisibility: u = lp.AfterVoting
  } = n || {}, [c, d] = de(
    Mre(t, l, s == null ? void 0 : s.id)
  ), f = t.reduce((v, E) => v + E.numVotes, 0), p = t.filter((v) => v.hasUserVoted).length, g = t.filter((v) => v.hasUserVoted), m = ft(async (v) => {
    await r.createVote({ reactionId: v.id });
  }, []), y = ft(async () => {
    t.forEach(async (v) => {
      v.hasUserVoted && v.userVote && r.removeVote({ reactionId: v.userVote.id });
    });
  }, [t]);
  return /* @__PURE__ */ h.jsxs("div", { className: "poll-wrapper", children: [
    /* @__PURE__ */ h.jsx("p", { className: "poll-title", children: e }),
    /* @__PURE__ */ h.jsxs("aside", { className: "poll-info", children: [
      /* @__PURE__ */ h.jsx("p", { className: "poll-instructions", "data-testid": "poll-instructions", children: /* @__PURE__ */ h.jsx("small", { children: a.formatMessage(
        { id: `${i}instructions` },
        { allowMultipleVotes: l }
      ) }) }),
      /* @__PURE__ */ h.jsx("p", { className: "poll-num-votes", children: /* @__PURE__ */ h.jsx("small", { "data-testid": "poll-total-votes", children: a.formatMessage({ id: `${i}num_votes` }, { number: f }) }) }),
      o && /* @__PURE__ */ h.jsx("p", { className: "poll-remove-vote", children: /* @__PURE__ */ h.jsx(
        je,
        {
          variant: "tertiary",
          onClick: y,
          "data-testid": "remove-votes-button",
          disabled: p === 0,
          children: /* @__PURE__ */ h.jsx("small", { children: a.formatMessage(
            { id: `${i}remove_vote_button` },
            { number: p }
          ) })
        }
      ) })
    ] }),
    t && /* @__PURE__ */ h.jsx("form", { children: /* @__PURE__ */ h.jsx("fieldset", { children: /* @__PURE__ */ h.jsx("ul", { className: "poll-options", children: t == null ? void 0 : t.map((v, E) => /* @__PURE__ */ h.jsx(
      $re,
      {
        isTabbable: c === E,
        user: s,
        option: v,
        optionIndex: E,
        totalPollVotes: f,
        showResults: u == lp.Always || !!p,
        allowMultipleVotes: l,
        hasVotedOnPoll: !!p,
        functions: {
          createVote: m,
          setTabbableOption: d
        }
      },
      v.id
    )) }) }) }),
    /* @__PURE__ */ h.jsxs(ht, { "aria-live": "polite", children: [
      a.formatMessage({ id: `${i}aria_votes` }, { number: p }),
      !!p && /* @__PURE__ */ h.jsx("ul", { children: g.map((v) => /* @__PURE__ */ h.jsx("li", { children: v.label })) })
    ] })
  ] });
};
function Hre({
  content: e,
  contentData: t,
  functions: n
}) {
  return /* @__PURE__ */ h.jsx(
    jre,
    {
      title: t.title,
      options: (e == null ? void 0 : e.pollOptions) || [],
      settings: (e == null ? void 0 : e.pollSettings) || {},
      functions: {
        createVote: n.createVote,
        removeVote: n.removeVote
      }
    }
  );
}
function Ure({
  links: e = {},
  contentData: t,
  postCutOff: n,
  content: r,
  gtmContext: i
}) {
  var a;
  return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    e.post ? /* @__PURE__ */ h.jsxs(
      "a",
      {
        href: e.post,
        className: "gtm-trackable gtm-visible",
        "data-gtm-event-type": `discussion-${r.type}`,
        "data-gtm-event-context": i,
        children: [
          (t == null ? void 0 : t.title) && /* @__PURE__ */ h.jsx("p", { className: "content-title", children: t == null ? void 0 : t.title }),
          t.postBody.length > n ? /* @__PURE__ */ h.jsx(
            p7,
            {
              text: t.postBody,
              markdownOptions: {
                overrides: { a: I0, blockquote: { component: Xf } }
              }
            }
          ) : /* @__PURE__ */ h.jsx(
            Fs,
            {
              options: {
                overrides: { a: I0, blockquote: { component: Xf } }
              },
              children: t.postBody
            }
          )
        ]
      }
    ) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      (t == null ? void 0 : t.title) && /* @__PURE__ */ h.jsx("p", { className: "content-title", children: t == null ? void 0 : t.title }),
      /* @__PURE__ */ h.jsx(
        Fs,
        {
          options: {
            wrapper: r.type === et.Question ? "h1" : M.Fragment,
            forceWrapper: r.type === et.Question,
            forceInline: r.type === et.Question,
            forceBlock: r.type !== et.Question,
            overrides: { blockquote: { component: Xf } }
          },
          children: t.postBody
        }
      )
    ] }),
    (a = t.data) != null && a.link ? /* @__PURE__ */ h.jsx(dT, { data: t.data.link }) : /* @__PURE__ */ h.jsx(h.Fragment, {})
  ] });
}
const _r = "discussion_", zre = 195;
let tc = null;
const H1 = ({
  element: e = "div",
  content: t,
  userHasPermissions: n = !0,
  userHasOwnerPermissions: r = !1,
  isLoading: i = !1,
  originalAuthorId: a,
  forceHide: s,
  functions: o,
  links: l = {},
  className: u,
  gtmContext: c = "DiscussionAnswer",
  children: d,
  isTruncated: f = !1,
  setFocus: p = !1,
  isCommunity: g = !1,
  badges: m,
  basePath: y,
  parentId: v,
  locale: E = "en",
  disableMentions: b
}) => {
  var Qe, ie, me, Pe, ge, X, xe;
  const _ = ye(), T = We(u0), x = We(zt), {
    createContent: A = async () => {
    },
    deleteContent: R = async () => {
    },
    updateContent: P = async () => {
    }
  } = o.content || {}, {
    createLike: L = () => {
    },
    deleteLike: I = () => {
    },
    listLikes: O = async () => ({})
  } = o.likes || {}, { openComments: S = () => {
  } } = o.comments || {}, { listMembers: F = () => Promise.resolve([]), clickMentionFallback: H = () => {
  } } = o.form || {}, {
    createVote: q = () => {
    },
    removeVote: N = () => {
    },
    removePoll: Q = () => {
    }
  } = o.polls || {}, { author: J, createdAt: D, id: C, likes: Z = 0, userLiked: B, comments: j = 0, data: z } = t, U = Ire(t.title, E), $ = x && x.id && typeof J != "string" && J.id && J.id === x.id || !1, ae = $ && (!t.createdAt || $3(t.createdAt, 10, "seconds")), Y = Ue(null), [ee, se] = de({
    title: t.body !== U && U || "",
    body: t && t.body || "",
    isEditing: !1,
    didEdit: t && t.isEdited || !1,
    postBody: t && t.body ? Ore(t.body, f, (Qe = t.data) == null ? void 0 : Qe.mentions) : "",
    data: t && t.data || {}
  }), [re, Ae] = de(!1), [Oe, Ce] = de(
    ae ? "highlighted" : "default"
    /* Default */
  ), [ue, fe] = de("");
  pe(() => {
    const ve = Y.current;
    if (!(!ve || Oe === "default"))
      return document.addEventListener(rn.DISCUSSION_FORM_SUBMITTED, Se), ve.addEventListener("transitionend", Fe), () => {
        document.removeEventListener(
          rn.DISCUSSION_FORM_SUBMITTED,
          Se
        ), ve.removeEventListener("transitionend", Fe);
      };
  }, []), pe(() => {
    se((ve) => ({
      ...ve,
      title: t && U || "",
      body: t && t.body || "",
      didEdit: t && t.isEdited || !1,
      data: t && t.data || {}
    }));
  }, [t.isEdited]), pe(() => {
    (async () => {
      const Ne = await YC(
        ee.body,
        f,
        z == null ? void 0 : z.mentions,
        F
      );
      se((Tt) => ({ ...Tt, postBody: Ne }));
    })();
  }, [ee.body, z == null ? void 0 : z.mentions]);
  const Se = () => {
    setTimeout(() => {
      Ce(
        "fading"
        /* Fading */
      );
    }, 1e3);
  }, Fe = ({ propertyName: ve }) => {
    ve === "background-color" && Ce((Ne) => (Ne === "default" && (document.removeEventListener(
      rn.DISCUSSION_FORM_SUBMITTED,
      Se
    ), Y.current && Y.current.removeEventListener("transitionend", Fe)), Ne === "fading" ? "default" : Ne));
  };
  if (i || !t || t.type === et.Answer && (!t.slugs || !t.slugs.question) || ee.postBody === "" && t.title === "")
    return /* @__PURE__ */ h.jsx(Dr, { className: "discussion-card" });
  const nt = async ({
    title: ve,
    body: Ne,
    data: Tt
  }) => {
    ve || (ve = ""), Ne || (Ne = ""), fe("");
    try {
      if (!Sc(ve, ee.title) || !Sc(Ne, ee.body)) {
        const Ge = t.type === et.Question ? { title: Ne } : { title: ve, body: Ne, data: Tt };
        await P(J0(t.slugs), Ge);
      }
      se((Ge) => ({
        ...Ge,
        title: ve || "",
        body: Ne || "",
        data: { ...Ge.data, ...Tt },
        isEditing: !1,
        didEdit: !0
      }));
    } catch {
      fe(`${_r}form_error`);
    }
  }, mt = () => {
    if (T && T.updateConversation) {
      const ve = { showForm: !0 }, Ne = t.author;
      Ne && Ne.id && !b && (g && (ve.prepopulateForm = `@{{${Ne.id}}}`), ve.mentionData = { id: Ne.id, name: Ne.name }), T.updateConversation(ve);
    }
    setTimeout(() => {
      var gt, qt, wt;
      const Ne = `reply-form-${(t.type === et.Answer ? t.slug : ((gt = t.slugs) == null ? void 0 : gt.reply) || ((qt = t.slugs) == null ? void 0 : qt.answer) || ((wt = t.slugs) == null ? void 0 : wt.question) || "").toLowerCase().slice(-15)}`, Tt = document.getElementById(Ne), Ge = document.getElementById(`${Ne}-input`);
      Ge && Ge.focus(), Tt && Tt.scrollIntoView({ behavior: "smooth" });
    }, 0);
  }, Ze = async () => {
    Ae(!1);
    try {
      t.type === et.Poll ? (await Q(), window.location.href = `${y}/${v}`) : await R(J0(t.slugs));
    } catch {
      fe("delete-error");
    }
  }, rt = [];
  return n && $ && (t.type !== et.Poll && rt.push({
    text: _.formatMessage({ id: `${_r}moreMenu_edit` }),
    onClick: () => se((ve) => ({ ...ve, isEditing: !0 })),
    icon: "pencil-paper",
    className: "gtm-trackable",
    "data-gtm-event-context": c,
    "data-gtm-event-type": `edit-${t.type}-click`
  }), rt.push({
    text: _.formatMessage({ id: `${_r}moreMenu_delete` }),
    onClick: (ve) => {
      ve.preventDefault(), ve.stopPropagation(), Ae(!0);
    },
    icon: "trash",
    className: "gtm-trackable",
    "data-gtm-event-context": c,
    "data-gtm-event-type": `delete-${t.type}-click`,
    ...Gx(`delete-${t.slug}-modal`, re)
  })), r && o.pins && rt.push({
    text: _.formatMessage({
      id: `${_r}moreMenu_${t.pinned ? "unpin" : "pin"}`
    }),
    onClick: t.pinned ? o.pins.deletePin : o.pins.createPin,
    icon: t.pinned ? "unpin" : "pin",
    className: "gtm-trackable",
    "data-gtm-event-context": c,
    "data-gtm-event-type": `edit-${t.type}-click`
  }), p && ((ie = Y == null ? void 0 : Y.current) == null || ie.focus(), (me = Y == null ? void 0 : Y.current) == null || me.scrollIntoView({ behavior: "smooth" })), M.createElement(e, {
    className: te("discussion-post", u, {
      [Oe]: !u || !u.includes("highlighted-text-box"),
      "has-link": l.post && !ee.isEditing,
      "is-pinned": (t == null ? void 0 : t.pinned) || !1
    }),
    ref: Y,
    tabIndex: p ? 0 : null,
    "data-testid": `discussion-${t.type}-thread`,
    "data-gtm-event-context": `${c}-post-click`,
    onClick: (ve) => {
      if (!l.post || ee.isEditing || t.type === et.Poll && Nre(ve, ["poll-options", "poll-info"], "discussion-post"))
        return;
      ve.preventDefault(), ve.stopPropagation(), tc && clearTimeout(tc), tc = setTimeout(() => {
        window.location.href = l.post;
      }, 150);
      const Ne = new CustomEvent(rn.DISCUSSION_POST_CLICKED, {
        detail: { link: l.post, timeout: tc }
      });
      document.dispatchEvent(Ne);
    },
    children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsxs(
        "div",
        {
          id: C || t.slug,
          className: te("discussion-card text-medium", t.type, {
            editing: ee.isEditing,
            "has-link": l.post && !ee.isEditing
          }),
          children: [
            !ee.isEditing && /* @__PURE__ */ h.jsx(
              Fre,
              {
                author: J,
                originalAuthorId: a,
                createdAt: D,
                contentData: { didEdit: ee.didEdit },
                content: t,
                gtmContext: c,
                badges: m
              }
            ),
            ee.isEditing ? /* @__PURE__ */ h.jsx(
              j1,
              {
                id: `editing-${t.slug}`,
                content: {
                  type: t.type,
                  slugs: t.slugs
                },
                userHasPermissions: n,
                meta: {
                  isLoading: i,
                  isInWrapper: !0,
                  hasTitleField: ee.title !== "" ? { text: ee.title } : !1,
                  isEditing: { text: ee.body, categories: [] },
                  canBePrepopulated: g,
                  isPrepopulated: !1
                },
                maxLength: t.type === et.Question ? 250 : 5e4,
                forceShow: {
                  error: ue !== "" && ue !== "delete-error" ? _.formatMessage(
                    { id: ue },
                    {
                      action: _.formatMessage({
                        id: `${_r}action_${t.type}`
                      })
                    }
                  ) : !1
                },
                functions: {
                  create: A,
                  handleSaveEdit: nt,
                  handleCancel: () => {
                    fe(""), se((ve) => ({ ...ve, isEditing: !1 }));
                  },
                  listMembers: F,
                  clickMentionFallback: H
                },
                gtmContext: `${c}Form`,
                data: z
              }
            ) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
              t.type === et.Poll ? /* @__PURE__ */ h.jsx(
                Hre,
                {
                  content: t,
                  contentData: ee,
                  functions: {
                    createVote: q,
                    removeVote: N
                  }
                }
              ) : /* @__PURE__ */ h.jsx(
                Ure,
                {
                  links: l,
                  contentData: ee,
                  postCutOff: zre,
                  content: t,
                  gtmContext: c
                }
              ),
              /* @__PURE__ */ h.jsx(Bre, { content: t })
            ] }),
            !ee.isEditing && !(s != null && s.actionBar) && /* @__PURE__ */ h.jsx(
              qR,
              {
                className: t.type,
                gtmContext: c,
                contentType: t.type,
                likes: s != null && s.likes ? !1 : {
                  count: Z || 0,
                  userLiked: B || !1,
                  canLike: n ?? !0,
                  peopleWhoLiked: t.peopleWhoLiked,
                  activityId: t.id || t.slug,
                  content: {
                    slugs: t.slugs || {},
                    slug: t.slug
                  },
                  functions: {
                    createLike: L,
                    deleteLike: I,
                    listLikes: O
                  },
                  basePath: y,
                  parentId: v
                },
                comments: !(s != null && s.comments) && ([et.Question, et.Post].includes(
                  t.type
                ) || l.comments) ? {
                  count: j || 0,
                  functions: {
                    onClick: () => {
                      l != null && l.comments && (window.location.href = l.comments), typeof S == "function" && S();
                    }
                  }
                } : !1,
                replies: t.type === "answer" || t.type === "reply" ? {
                  canReply: n ?? !0,
                  functions: { onClick: mt }
                } : !1,
                shareLink: !(s != null && s.shareLink) && {
                  url: `${window.location.origin}${(Pe = t.slugs) == null ? void 0 : Pe.question}/${(ge = t.slugs) == null ? void 0 : ge.answer}${(X = t.slugs) != null && X.reply ? `#${(xe = t.slugs) == null ? void 0 : xe.reply}` : ""}`
                },
                moreMenu: !(s != null && s.moreMenu) && {
                  options: rt,
                  contentSlug: t.slug,
                  reportData: {
                    contentUrl: `${window.origin}${typeof process < "u" && process.env.PUBLIC_URL || ""}/${t.slugs.question || ""}`
                  }
                }
              }
            )
          ]
        }
      ),
      d,
      /* @__PURE__ */ h.jsx(
        sa,
        {
          id: `delete-${t.slug}-modal`,
          isOpen: re,
          functions: { onOpen: () => {
          }, onClose: () => Ae(!1) },
          forceShow: {
            error: ue === "delete-error" ? _.formatMessage(
              { id: "${intlPath}delete_error" },
              {
                action: _.formatMessage({
                  id: `${_r}action_${t.type}`
                })
              }
            ) : !1
          },
          title: _.formatMessage(
            { id: `${_r}delete_title` },
            { action: _.formatMessage({ id: `${_r}action_${t.type}` }) }
          ),
          buttons: [
            {
              variant: "secondary",
              onClick: () => Ae(!1),
              children: _.formatMessage({ id: `${_r}delete_cancel` })
            },
            {
              variant: "primary",
              className: "destructive",
              onClick: Ze,
              children: _.formatMessage({ id: `${_r}delete_delete` })
            }
          ],
          gtmContext: `${(t.type || "").charAt(0).toUpperCase()}${(t.type || "").slice(1)}:${t.slug}`,
          children: /* @__PURE__ */ h.jsx(
            en,
            {
              id: "discussion_delete_text",
              values: {
                p: (ve) => /* @__PURE__ */ h.jsx("p", { children: ve }),
                action: _.formatMessage({
                  id: `${_r}action_${t.type}`
                })
              }
            }
          )
        }
      )
    ] })
  });
};
const qre = Gs(
  () => Promise.resolve().then(() => oie)
), Wre = 65, Vre = ({ forceShow: e, form: t, className: n }) => {
  const r = ye(), i = "discussionFormCard_", a = "DiscardDraftModal", o = We(zt) || "community", l = yp(o);
  l.name || (l.name = r.formatMessage({
    id: `member_${typeof o == "string" ? o : "community"}`
  }));
  const u = Ua(!0, !1), c = u ? u < 768 : 0, { modal: d = !1 } = e || {}, [f, p] = de({
    form: d || JE("showPost") === "true" || !1,
    warning: !1
  }), [g, m] = de({ showCachedText: !1 });
  pe(() => {
    if (!g.showCachedText)
      return;
    (async () => {
      const b = await YC(
        g.title || g.body || "",
        Wre,
        g.mentions
      );
      m((_) => ({ ..._, prettifiedText: b }));
    })();
  }, [g.showCachedText, g.title, g.body]);
  const y = (E) => {
    if (!g.showCachedText || typeof f.warning == "string")
      return;
    let b;
    if ("detail" in E && E.detail.link)
      E.detail.timeout && clearTimeout(E.detail.timeout), b = E.detail.link;
    else {
      const _ = E;
      _.preventDefault(), _.stopPropagation();
      const x = _.target.closest("a");
      b = x && x.getAttribute("href");
    }
    p((_) => ({ ..._, warning: b || !1 }));
  };
  pe(() => {
    if (!g.showCachedText) {
      document.removeEventListener(
        rn.DISCUSSION_POST_CLICKED,
        y
      ), document.removeEventListener(
        rn.MEMBER_CLICKED,
        y
      ), document.removeEventListener("click", y);
      return;
    }
    return document.addEventListener(
      rn.DISCUSSION_POST_CLICKED,
      y
    ), document.addEventListener(
      rn.MEMBER_CLICKED,
      y
    ), document.addEventListener("click", y), () => {
      document.removeEventListener(
        rn.DISCUSSION_POST_CLICKED,
        y
      ), document.removeEventListener(
        rn.MEMBER_CLICKED,
        y
      ), document.removeEventListener("click", y);
    };
  }, [g.showCachedText]), pe(() => {
    const E = (b) => {
      if (!(!g.showCachedText || f.warning !== !1))
        return b.preventDefault(), b.returnValue = "";
    };
    return window.addEventListener("beforeunload", E, { capture: !0 }), () => {
      window.removeEventListener("beforeunload", E, { capture: !0 });
    };
  }, [g.showCachedText, f.warning]);
  let v = r.formatMessage({
    id: `${i}placeholder${c ? "" : "_long"}`
  });
  return g.showCachedText && (g.title || g.body) && (v = g.prettifiedText || v), /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    /* @__PURE__ */ h.jsxs(
      "button",
      {
        className: te("discussion-form-card", n),
        onClick: (E) => {
          E.preventDefault(), E.stopPropagation(), p((b) => ({ ...b, form: !0 }));
        },
        "data-testid": "discussion-form-card",
        children: [
          /* @__PURE__ */ h.jsx(aa, { name: l.name, src: l.image, alt: "" }),
          /* @__PURE__ */ h.jsx(
            Fs,
            {
              className: te("input", { placeholder: !g.showCachedText }),
              element: "span",
              options: {
                forceInline: !0,
                overrides: {
                  a: br,
                  blockquote: br,
                  br,
                  em: br,
                  li: br,
                  ol: br,
                  p: br,
                  s: br,
                  span: br,
                  strong: br,
                  ul: br
                }
              },
              children: v
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ h.jsxs(Pl, { children: [
      /* @__PURE__ */ h.jsx(
        qre,
        {
          showModal: f.form,
          functions: {
            cacheText: m,
            onClose: () => {
              p((E) => ({ ...E, form: !1 }));
            }
          },
          form: t,
          cachedText: g,
          className: "in-portal"
        }
      ),
      /* @__PURE__ */ h.jsx(
        sa,
        {
          id: t.id ? `${t.id}-warning` : "discussion-form-card-warning",
          className: "in-portal",
          isOpen: f.warning !== !1,
          functions: {
            onClose: () => {
              p((E) => ({ ...E, warning: !1 }));
            }
          },
          title: r.formatMessage({ id: `${i}overlay_title` }),
          buttons: [
            {
              variant: "secondary",
              children: r.formatMessage({ id: `${i}overlay_cta_discard` }),
              onClick: (E) => {
                E.preventDefault(), E.stopPropagation(), typeof f.warning == "string" && (window.location.href = f.warning);
              },
              "data-gtm-event-type": "discard-click",
              "data-gtm-event-context": a
            },
            {
              variant: "primary",
              children: r.formatMessage({ id: `${i}overlay_cta_continue` }),
              onClick: () => {
                p({ form: !0, warning: !1 });
              },
              "data-gtm-event-type": "continue-editing-click",
              "data-gtm-event-context": a
            }
          ],
          children: /* @__PURE__ */ h.jsx("p", { children: r.formatMessage({ id: `${i}overlay_text` }) })
        }
      )
    ] })
  ] });
}, Kre = Gs(() => Promise.resolve().then(() => Dre)), QC = ({
  isCard: e = !1,
  form: t,
  parentId: n,
  categories: r,
  membershipRequiredToPost: { isMember: i, required: a, join: s, leave: o, notMemberStateText: l },
  locale: u = Ms
}) => {
  const c = ye();
  if (a && !i)
    return /* @__PURE__ */ h.jsx(
      Ci,
      {
        text: l,
        button: {
          breakpoints: { mobile: !0, 901: !1 },
          component: /* @__PURE__ */ h.jsx(C4, { isShort: !0, functions: { join: s, leave: o } })
        }
      }
    );
  const { content: d, functions: f, meta: p, ...g } = t, m = {
    content: { type: (d == null ? void 0 : d.type) || "reply", slugs: (d == null ? void 0 : d.slugs) || {} },
    functions: {
      ...f,
      create: (f == null ? void 0 : f.create) || (() => {
      })
    },
    parentId: n,
    meta: {
      ...p,
      isEditing: (p == null ? void 0 : p.isEditing) || !1,
      isPrepopulated: !1,
      showSuccessMessage: !1,
      postCategories: [
        {
          name: c.formatMessage({
            id: "discussion_form__postType_no-category",
            defaultMessage: "Post"
          }),
          slug: "no-category"
        },
        ...r || []
      ]
    },
    ...g,
    id: `add-post-${g.id || ""}`
  };
  return e ? /* @__PURE__ */ h.jsx(Vre, { form: m }) : /* @__PURE__ */ h.jsx(Kre, { ...m });
}, XC = ({ form: e }) => {
  const t = We(zt), n = ye(), [r, i] = de(!1), a = () => {
    i7(t) || i(!0);
  };
  pe(() => {
    if (e && !(e != null && e.isDisabled) || (e == null ? void 0 : e.isDisabled) === void 0)
      return document.addEventListener(rn.DISCUSSION_POST_ADDED, a), () => {
        document.removeEventListener(
          rn.DISCUSSION_POST_ADDED,
          a
        );
      };
  });
  const s = {};
  return ["successMessage", "title", "text"].forEach((o) => {
    s[o] = n.formatMessage({ id: `profileModalLauncher_${o}` });
  }), /* @__PURE__ */ h.jsx(
    c0,
    {
      form: e,
      showModal: r,
      functions: {
        onClose: () => {
          i(!1);
        }
      },
      content: s
    }
  );
};
const Jf = "discussion_responses_", Gre = ({
  type: e = "answer",
  responses: t = 0,
  isLoading: n = !1
}) => {
  const r = ye();
  return t = parseInt(t), /* @__PURE__ */ h.jsxs("div", { className: "responses-heading", children: [
    /* @__PURE__ */ h.jsx("h4", { children: r.formatMessage(
      { id: `${Jf}title` },
      { action: r.formatMessage({ id: `${Jf}${e}` }), count: t }
    ) }),
    !n && t === 0 && /* @__PURE__ */ h.jsx("p", { children: wr(r.formatMessage, `${Jf}empty`, e, e) })
  ] });
};
const Yre = ({
  loadMore: { isLoading: e, hasNextPage: t, loadNextPage: n } = {
    isLoading: !1,
    hasNextPage: !1,
    loadNextPage: () => {
    }
  },
  form: r,
  children: i
}) => {
  const a = ye(), s = We(u0), o = ac(i, {
    element: "li"
  });
  if (s.prepopulateForm && (r != null && r.meta) && (r.meta.isPrepopulated = { text: s.prepopulateForm }, s.mentionData)) {
    const l = r.data || {};
    l.mentions || (l.mentions = {});
    const u = s.mentionData.id || "1";
    l.mentions[u] = {
      created_at: "",
      updated_at: "",
      id: u,
      data: s.mentionData
    }, r.data = l, r.meta.isAutoFocused = !0;
  }
  return /* @__PURE__ */ h.jsxs(
    "div",
    {
      className: te("thread-wrapper", {
        "empty-thread": !o
      }),
      children: [
        !Object.is(o, null) && /* @__PURE__ */ h.jsx("ul", { className: "thread", children: o }),
        !e && /* @__PURE__ */ h.jsx(
          c1,
          {
            hasNextPage: t,
            loadNextPage: n,
            size: "small",
            styling: { muted: !0 },
            icon: { icon: "arrow_corner-down_right", position: "left" },
            messages: {
              button: a.formatMessage({ id: "discussion_thread_loadMore" }),
              error: a.formatMessage({ id: "loadMore_error" })
            }
          }
        ),
        r && s.showForm && /* @__PURE__ */ h.jsx(j1, { ...r })
      ]
    }
  );
};
function Zre(e) {
  var n, r;
  let t = !1;
  return (r = (n = e.latest_reactions) == null ? void 0 : n["poll-option"]) == null || r.forEach((i) => {
    var a, s;
    (s = (a = i.own_children) == null ? void 0 : a["poll-vote"]) != null && s.length && (t = !0);
  }), t;
}
function Qre({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  queryClient: r,
  queryKey: i,
  user: a
}) {
  const { mutate: s } = Ut({
    mutationFn: e,
    onMutate: ({ reactionId: o }) => t((l) => (w4({ activity: l, reactionId: o, user: a }), l)),
    onError: n,
    onSuccess: (o, { reactionId: l }, u) => {
      u && A4({
        activity: u,
        reactionId: l,
        // @ts-expect-error: Working with API response no Reaction
        correctReactionId: o.body.id,
        user: a
      }), r.setQueryData(i, u);
    }
  });
  return s;
}
function Xre({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n }
}) {
  const { mutate: r } = Ut({
    mutationFn: e,
    onMutate: ({ content: i, title: a }) => t((s) => (s && (i != null && (s.content = i), a != null && (s.title = a)), s)),
    onError: n
  });
  return r;
}
function Jre({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  queryClient: r,
  queryKey: i
}) {
  const { mutate: a } = Ut({
    mutationFn: e,
    onMutate: (s) => t((o) => (o && Fc({ activity: o }), o)),
    onError: n,
    onSuccess: (s, o, l) => {
      l && Fc({ activity: l, reaction: s }), r.setQueryData(i, l);
    }
  });
  return a;
}
function eie({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  queryClient: r,
  queryKey: i
}) {
  const { mutate: a } = Ut({
    mutationFn: e,
    onMutate: (s) => t((o) => (o && Bc({ activity: o }), o)),
    onError: n,
    onSuccess: (s, o, l) => {
      l && Bc({ activity: l, reaction: s }), r.setQueryData(i, l);
    }
  });
  return a;
}
function tie({ queryFn: e, queryKey: t }) {
  const { data: n, error: r, isLoading: i, isFetching: a } = p3({
    queryFn: e,
    queryKey: t
  });
  return {
    activity: n,
    error: r,
    isLoading: i,
    isFetching: a
  };
}
function nie({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  user: r
}) {
  const { mutate: i } = Ut({
    mutationFn: e,
    onMutate: ({ reactionId: a }) => t((s) => (S4({ activity: s, reactionId: a }), s)),
    onError: n
  });
  return i;
}
function rie({
  queryFns: { read: e, edit: t, like: n, unlike: r, pin: i, unpin: a, createVote: s, removeVote: o },
  queryKey: l
}) {
  const u = up(), c = gp(), d = { queryClient: u, queryKey: l }, f = {
    mutationHandlers: {
      error: _p(d),
      mutate: Cp(d)
    },
    user: c,
    ...d
  }, p = Xre({ ...f, mutationFn: t }), g = Jre({ ...f, mutationFn: n }), m = iie({ ...f, mutationFn: r }), y = eie({ ...f, mutationFn: i }), v = aie({ ...f, mutationFn: a }), E = Qre({
    ...f,
    mutationFn: s
  }), b = nie({
    ...f,
    mutationFn: o
  }), { activity: _, ...T } = tie({ queryKey: l, queryFn: e });
  return {
    activity: _,
    mutations: {
      edit: p,
      like: g,
      unlike: m,
      pin: y,
      unpin: v,
      createVote: E,
      removeVote: b
    },
    user: c,
    ...T
  };
}
function iie({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  user: r
}) {
  const { mutate: i } = Ut({
    mutationFn: e,
    onMutate: (a) => t((s) => (s && k4({ activity: s, user: r }), s)),
    onError: n
  });
  return i;
}
function aie({
  mutationFn: e,
  mutationHandlers: { mutate: t, error: n },
  user: r
}) {
  const { mutate: i } = Ut({
    mutationFn: e,
    onMutate: (a) => (console.log("unpin"), t((s) => (s && D4({ activity: s, user: r }), s))),
    onError: n
  });
  return i;
}
const Oae = ({
  basePath: e,
  parentId: t,
  activityId: n,
  isMember: r,
  isOwner: i,
  functions: {
    activities: { remove: a, ...s },
    likes: o,
    reactions: l,
    form: u,
    join: c,
    leave: d,
    polls: f
  },
  profile: p,
  categories: g,
  locale: m = Ms,
  type: y = Kt.Communities,
  repliesFilters: v
}) => {
  var z, U, $, ae, Y, ee, se, re, Ae, Oe, Ce, ue;
  const E = ye(), b = We(zt), _ = {
    ...s,
    ...f
  }, {
    activity: T,
    error: x,
    isLoading: A,
    mutations: { edit: R, like: P, unlike: L, pin: I, unpin: O, createVote: S, removeVote: F }
  } = rie({
    queryFns: _,
    queryKey: [e, t, n]
  });
  if (A)
    return /* @__PURE__ */ h.jsx(
      Dr,
      {
        style: {
          height: "400px",
          width: y === Kt.Courses ? "100%" : "initial"
        }
      }
    );
  if (x || !T)
    return /* @__PURE__ */ h.jsx(
      Ci,
      {
        variant: "error",
        text: E.formatMessage({ id: "activitySection_notFoundError" })
      }
    );
  const {
    own_reactions: H,
    verb: q,
    latest_reactions: N,
    mentioned_users: Q,
    additional_data: J
  } = T, D = (((z = N == null ? void 0 : N.like) == null ? void 0 : z.length) || 0) > 0, C = !!((U = H == null ? void 0 : H.like) != null && U.find((fe) => {
    var Se;
    return ((Se = fe.user) == null ? void 0 : Se.id) === (b == null ? void 0 : b.id);
  })), Z = C ? H == null ? void 0 : H.like[0].id : "", B = D ? ($ = N == null ? void 0 : N.like) == null ? void 0 : $.map((fe) => {
    var Se, Fe, nt;
    return {
      id: (Se = fe == null ? void 0 : fe.user) == null ? void 0 : Se.id,
      name: (nt = (Fe = fe == null ? void 0 : fe.user) == null ? void 0 : Fe.data) == null ? void 0 : nt.name
    };
  }) : !1, j = T == null ? void 0 : T.actor;
  return /* @__PURE__ */ h.jsxs("section", { className: "activity-section", children: [
    /* @__PURE__ */ h.jsx(
      H1,
      {
        className: "highlighted-text-box subtle",
        isCommunity: !0,
        content: {
          id: n,
          type: q,
          title: T == null ? void 0 : T.title,
          body: y === Kt.Courses ? o6({
            content: T.content,
            locale: m
          }) : T == null ? void 0 : T.content,
          categories: ZC(
            (T == null ? void 0 : T.categories) || [],
            g || []
          ),
          createdAt: (T == null ? void 0 : T.time) || "",
          slugs: {
            question: `${e}/${t}`,
            answer: T == null ? void 0 : T.id
          },
          slug: n,
          author: Fl(j),
          userLiked: C,
          likes: ((ae = T == null ? void 0 : T.reaction_counts) == null ? void 0 : ae.like) || 0,
          comments: (T == null ? void 0 : T.total_replies) || 0,
          peopleWhoLiked: y === Kt.Courses ? !1 : B,
          data: {
            mentions: Q,
            ...J || {}
          },
          pinned: ((Y = T == null ? void 0 : T.reaction_counts) == null ? void 0 : Y.pin) && ((ee = T == null ? void 0 : T.reaction_counts) == null ? void 0 : ee.pin) > 0 || !1,
          pollOptions: x4(T, m),
          pollSettings: {
            showRemoveVote: (se = T == null ? void 0 : T.settings) == null ? void 0 : se.show_remove_vote,
            allowMultipleVotes: (re = T == null ? void 0 : T.settings) == null ? void 0 : re.allow_multiple_votes,
            deadlineAt: (Ae = T == null ? void 0 : T.settings) == null ? void 0 : Ae.deadline_at,
            hideParticipants: (Oe = T == null ? void 0 : T.settings) == null ? void 0 : Oe.hide_participants,
            numberOfWinners: (Ce = T == null ? void 0 : T.settings) == null ? void 0 : Ce.number_of_winners,
            resultsVisibility: (ue = T == null ? void 0 : T.settings) == null ? void 0 : ue.results_visibility
          }
        },
        originalAuthorId: j == null ? void 0 : j.id,
        forceHide: { comments: !0, shareLink: y === Kt.Courses },
        functions: {
          content: {
            createContent: () => null,
            deleteContent: a,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            updateContent: (fe, { title: Se, body: Fe }) => R({ title: Se, content: Fe })
          },
          likes: {
            createLike: () => P({ activityId: n }),
            deleteLike: () => L({ activityId: n, reactionId: Z }),
            listLikes: (fe) => o.list({ activityId: n, ...fe })
          },
          comments: {
            openComments: () => {
            }
          },
          pins: {
            createPin: () => I({ activityId: n }),
            // there will only ever be one pin so we can just grab the first one
            deletePin: () => {
              var fe;
              return O({ activityId: n, reactionId: (fe = N == null ? void 0 : N.pin) == null ? void 0 : fe[0].id });
            }
          },
          polls: {
            createVote: ({ reactionId: fe }) => S({ reactionId: fe }),
            removeVote: ({ reactionId: fe }) => F({ reactionId: fe }),
            removePoll: () => f.removePoll({ activityId: n })
          },
          form: u
        },
        styling: { showShareLinkButton: !0 },
        userHasPermissions: r,
        userHasOwnerPermissions: i,
        badges: {
          showBadges: !0,
          scopes: [
            {
              scope: Cn.Communities,
              area: t || ""
            },
            {
              scope: Cn.Platform,
              area: "all"
            }
          ]
        },
        basePath: e,
        parentId: t
      },
      n
    ),
    /* @__PURE__ */ h.jsx(
      BR,
      {
        basePath: e,
        parentId: t,
        activityId: n,
        showReplies: q === et.Poll ? Zre(T) : !0,
        activityTotalReplies: (T == null ? void 0 : T.total_replies) || 0,
        isMember: r,
        functions: {
          reactions: l,
          likes: o,
          form: u,
          join: c,
          leave: d
        },
        profile: p,
        type: y,
        repliesFilters: v
      }
    )
  ] });
};
const sie = ({
  showModal: e = !0,
  functions: t,
  form: n,
  cachedText: r,
  className: i
}) => {
  const a = ye(), s = "discussionFormModal_", { onClose: o = () => {
  }, cacheText: l = () => {
  } } = t, { data: u, meta: c, functions: d } = n, { title: f = "", body: p = "", mentions: g } = r || {}, m = "discussion-form-modal";
  return /* @__PURE__ */ h.jsx(
    sa,
    {
      id: m,
      title: a.formatMessage({ id: `${s}title` }),
      isOpen: e,
      functions: {
        onClose: () => {
          (f !== "" || p !== "") && l((y) => ({ ...y, showCachedText: !0 })), o();
        }
      },
      className: te("discussion-form-modal", i),
      children: /* @__PURE__ */ h.jsx(
        j1,
        {
          ...n,
          data: { ...u, mentions: g || (u == null ? void 0 : u.mentions) },
          meta: {
            ...c,
            isAutoFocused: !0,
            isInOverlay: `${m}-overlay`,
            hasTitleField: { text: f },
            isPrepopulated: {
              text: p || (c == null ? void 0 : c.isPrepopulated) !== !1 && (c == null ? void 0 : c.isPrepopulated.text) || ""
            },
            showGuidelines: !1,
            showDivider: !0,
            showPostType: !0
          },
          buttons: { submit: a.formatMessage({ id: `${s}cta` }) },
          functions: {
            ...d,
            onChange: (y) => {
              l((v) => ({ ...v, ...y }));
            },
            onMention: ({ id: y, name: v } = {}) => {
              if (!y || !v)
                return;
              const E = g || {};
              E[y] = {
                created_at: "",
                updated_at: "",
                id: y,
                data: { name: v }
              }, l(
                (b) => ({ ...b, mentions: E })
              );
            },
            create: async (y) => {
              o(), d.create && await d.create(y), l({
                showCachedText: !1
              });
            },
            createPoll: async (y) => {
              const v = () => {
                o(), l({
                  showCachedText: !1
                });
              };
              if (d.createPoll)
                try {
                  const E = await d.createPoll(y);
                  return new Promise((b) => (v(), b(E)));
                } catch {
                  return new Promise((b, _) => _());
                }
              else
                return v(), new Promise((E) => E({}));
            },
            handleSaveEdit: async (y) => {
              o(), d.handleSaveEdit && await d.handleSaveEdit(y), l({
                showCachedText: !1
              });
            }
          }
        }
      )
    }
  );
}, oie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sie
}, Symbol.toStringTag, { value: "Module" }));
const Nae = ({
  className: e,
  showModal: t = !0,
  title: n,
  messagePlaceholder: r,
  formTitle: i,
  formLabel: a,
  ctaMessage: s,
  showIcon: o,
  onClose: l,
  reportError: u = () => {
  },
  sendInvites: c
}) => {
  const d = ye();
  return i || (i = d.formatMessage({ id: "inviteModal_formTitle" })), a || (a = d.formatMessage({ id: "inviteModal_formLabel" })), s || (s = d.formatMessage({ id: "inviteModal_cta" })), /* @__PURE__ */ h.jsx(
    sa,
    {
      id: "invite-user-modal",
      title: n,
      isOpen: t,
      showDivider: !1,
      showIcon: o,
      functions: { onClose: l },
      className: te("invite-modal", e, { success: !!n }),
      children: /* @__PURE__ */ h.jsx(
        hR,
        {
          title: i,
          label: a,
          messagePlaceholder: r,
          ctaMessage: s,
          onClose: l,
          sendInvites: c,
          reportError: u
        }
      )
    }
  );
};
const lie = ({
  showModal: e = !0,
  content: { successMessage: t, title: n, text: r } = {},
  functions: i,
  form: a,
  className: s
}) => {
  const o = ye(), [l, u] = de(
    JE("showProfile") === "true" || e
  );
  pe(() => {
    u(e);
  }, [e]);
  const { onClose: c = () => {
  } } = i;
  return /* @__PURE__ */ h.jsx(
    sa,
    {
      id: "profile-form-modal",
      title: t || n || o.formatMessage({ id: "profileModal_title" }),
      isOpen: l,
      showDivider: !t,
      functions: {
        onClose: c
      },
      className: te("profile-modal", s, { success: !!t }),
      maxWidth: 700,
      children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        t && n || r ? /* @__PURE__ */ h.jsxs("div", { className: "intro", children: [
          t && n ? /* @__PURE__ */ h.jsx("h3", { children: n }) : "",
          r ? /* @__PURE__ */ h.jsx("p", { children: r }) : ""
        ] }) : null,
        /* @__PURE__ */ h.jsx(
          pR,
          {
            ...a,
            meta: { shouldShowCancelButton: !1 },
            functions: {
              ...(a == null ? void 0 : a.functions) || {},
              // eslint-disable-next-line  @typescript-eslint/no-explicit-any
              onSuccess: async (d) => {
                var f;
                try {
                  (f = a == null ? void 0 : a.functions) != null && f.onSuccess && await a.functions.onSuccess(d);
                } finally {
                  c();
                }
              }
            }
          }
        )
      ] })
    }
  );
}, c0 = lie, uie = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: c0
}, Symbol.toStringTag, { value: "Module" }));
const Iae = ({ members: e }) => {
  const [t, n] = de(!1), r = (i) => {
    const { fullName: a, jobTitle: s, organisation: o, photo: l } = i || {};
    return /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx(aa, { name: a, src: l }),
      /* @__PURE__ */ h.jsx("p", { children: a }),
      /* @__PURE__ */ h.jsx("small", { className: "text-medium", children: o ? `${s}, ${o}` : s })
    ] });
  };
  return /* @__PURE__ */ h.jsxs("div", { className: "directory-wrapper", children: [
    /* @__PURE__ */ h.jsx("ul", { className: "directory", children: e.map((i) => /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx(
      "button",
      {
        onClick: (a) => {
          a.preventDefault(), a.stopPropagation(), n(i);
        },
        children: r(i)
      }
    ) }, i.fullName)) }),
    /* @__PURE__ */ h.jsx(
      sa,
      {
        isOpen: t !== !1,
        children: t === !1 ? "" : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
          r(t),
          /* @__PURE__ */ h.jsx(Fs, { children: t.text })
        ] }),
        buttons: [
          {
            size: "small",
            variant: "tertiary",
            onClick: () => n(!1),
            children: "Close"
          }
        ],
        functions: { onClose: () => n(!1) }
      }
    )
  ] });
};
const Pae = ({ email: e, settings: t = {} }) => {
  const { formatMessage: n } = ye(), r = We(zt), { myProfile: i, isConnected: a, cannotConnect: s } = t, [o, l] = de(!1), [u, c] = de(!1);
  return r ? e && i ? /* @__PURE__ */ h.jsx(
    je,
    {
      icon: { icon: "info-inside-circle", position: "right" },
      size: "small",
      variant: "secondary",
      styling: { muted: !0 },
      tooltip: n({ id: "member_show_email_tooltip_mine" }),
      forceTooltip: !0,
      className: "show-email fake-button",
      children: e
    }
  ) : s ? /* @__PURE__ */ h.jsx(
    je,
    {
      icon: "email",
      size: "small",
      variant: "secondary",
      styling: { muted: !0 },
      tooltip: n({ id: "member_show_email_tooltip_private" }),
      forceTooltip: !0,
      className: "show-email fake-button",
      children: n({ id: "member_show_email_private" })
    }
  ) : a ? e && a ? /* @__PURE__ */ h.jsx(h.Fragment, { children: o ? /* @__PURE__ */ h.jsx(
    je,
    {
      icon: {
        icon: "copy",
        position: "right"
      },
      size: "small",
      variant: "secondary",
      styling: { muted: !0 },
      className: "show-email copy-button",
      tooltip: n({
        id: `member_show_email_tooltip${u ? "_copied" : ""}`
      }),
      forceTooltip: !0,
      "data-gtm-event-context": "connections-email-address-button",
      "data-gtm-event-type": "copy-email-click",
      onClick: () => {
        navigator.clipboard.writeText(e).then(() => {
          c(!0), setTimeout(() => {
            c(!1);
          }, 2e3);
        });
      },
      children: e
    }
  ) : /* @__PURE__ */ h.jsx(
    je,
    {
      icon: "email",
      size: "small",
      "data-gtm-event-context": "connections-email-address-button",
      "data-gtm-event-type": "show-email-click",
      onClick: () => l(!0),
      children: n({ id: "member_show_email_show" })
    }
  ) }) : /* @__PURE__ */ h.jsx(h.Fragment, {}) : /* @__PURE__ */ h.jsx(
    je,
    {
      icon: "email",
      size: "small",
      variant: "secondary",
      styling: { muted: !0 },
      className: "show-email fake-button",
      children: n({ id: "member_show_email_hide" })
    }
  ) : /* @__PURE__ */ h.jsx(h.Fragment, {});
};
const cie = ({
  author: e,
  authorCite: t,
  content: n,
  member: r,
  className: i = ""
}) => /* @__PURE__ */ h.jsxs("blockquote", { className: te("testimonial-block", i), children: [
  /* @__PURE__ */ h.jsx(Wr, { className: "testimonial", children: n }),
  r ? /* @__PURE__ */ h.jsx(ea, { member: r, styling: { size: "large" } }) : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
    e && /* @__PURE__ */ h.jsx(
      "p",
      {
        className: te("author", {
          "text-small": !i.includes("new")
        }),
        children: e
      }
    ),
    t && /* @__PURE__ */ h.jsx(
      "p",
      {
        className: te("author-cite", {
          "text-small": !i.includes("new")
        }),
        children: /* @__PURE__ */ h.jsx("cite", { children: t })
      }
    )
  ] })
] }), Rae = mr(cie);
const Fae = ({
  items: e = [],
  selector: t = "",
  className: n = ""
}) => {
  const r = ye(), [i, a] = de(e);
  return pe(() => {
    if (e.length)
      return;
    let s = "";
    Array(6).fill(0).forEach((u, c) => {
      s += `${c > 0 ? ", " : ""}${t} h${c + 1}`;
    });
    const l = Array.from(document.querySelectorAll(s)).filter(
      (u) => u.id
    ).map((u) => ({
      id: u.id,
      text: u.textContent || ""
    }));
    a(l);
  }, []), i && i.length > 0 && /* @__PURE__ */ h.jsxs(
    ur,
    {
      variant: "subtle",
      className: te("table-of-contents", n),
      children: [
        /* @__PURE__ */ h.jsx("h2", { children: r.formatMessage({ id: "tableOfContents" }) }),
        /* @__PURE__ */ h.jsx("nav", { children: /* @__PURE__ */ h.jsx("ul", { children: i.map(({ id: s, text: o }) => /* @__PURE__ */ h.jsx("li", { children: /* @__PURE__ */ h.jsx("a", { href: `#${s}`, children: o }) }, s)) }) })
      ]
    }
  );
};
const d0 = ({
  time: e,
  rangeTime: t,
  prependedText: n,
  appendedText: r,
  className: i = ""
}) => {
  const a = ye(), s = "timeToComplete_";
  if (!e || typeof e != "number")
    return null;
  const o = (c) => {
    const d = c / 60, f = Math.floor(d), p = (d - f) * 60, g = Math.round(p), m = `${a.formatMessage(
      { id: `${s}hours` },
      { time: f }
    )}${f > 0 && g > 0 ? ", " : ""}${a.formatMessage(
      { id: `${s}minutes` },
      { time: g }
    )}`;
    return { text: `${f > 0 ? `${a.formatMessage(
      { id: `${s}hours_short` },
      { time: f }
    )} ` : ""}${g > 0 ? a.formatMessage({ id: `${s}minutes_short` }, { time: g }) : ""}`, ariaText: m };
  };
  let { text: l, ariaText: u } = o(e);
  if (t) {
    const { text: c, ariaText: d } = o(e + t);
    l = a.formatMessage(
      { id: `${s}range` },
      { early: l, late: c }
    ), u = a.formatMessage(
      { id: `${s}range_aria` },
      { early: u, late: d }
    );
  }
  return n && (u = `${n} ${u}`, l = `${n} ${l}`), r && (u = `${u} ${r}`, l = `${l} ${r}`), /* @__PURE__ */ h.jsx("span", { className: te("time-to-complete", i), "aria-label": u, children: l });
};
const Bae = ({ className: e = "", image: t, ...n }) => t ? (typeof t == "string" && (t = {
  width: 1080,
  height: 200,
  type: "image/png",
  url: t
}), t.range = [
  { height: 124, width: 425 },
  { height: 200, width: 768 },
  { height: 200, width: 1368 }
], t.query = "fit=thumb&f=center", /* @__PURE__ */ h.jsx(
  za,
  {
    ...n,
    className: te("banner", e),
    image: { ...t, aspect: "banner" }
  }
)) : null;
const die = [
  "small",
  "span",
  "strong",
  "em",
  "p",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "blockquote",
  "q"
], fie = ({
  className: e = "",
  content: t,
  image: n,
  variant: r,
  spacing: i = "normal",
  styling: a,
  hideElements: s = {
    eyebrow: !1,
    title: !1,
    text: !1
  },
  cta: o,
  children: l
}) => {
  var g, m;
  const u = {
    imageFullWidth: !0,
    ...a
  };
  r || (r = u.imageFullWidth ? "default" : "light");
  const c = ["eyebrow", "title", "text"], d = { eyebrow: "small", title: "h1", text: "p" }, f = {};
  c.forEach((y) => {
    if (!t[y]) {
      f[y] = !1;
      return;
    }
    if (!s[y]) {
      if (typeof t[y] == "object") {
        f[y] = t[y];
        const { text: v, element: E } = t[y];
        if (E && die.includes(E.toLowerCase()))
          return;
        f[y] = {
          text: v,
          element: d[y]
        };
        return;
      }
      f[y] = {
        text: t[y],
        element: d[y]
      };
    }
  });
  const p = o && o.text && o.link;
  return p && o.link[0] === "#" && (o.props || (o.props = {}), o.props.onClick = (y) => {
    y.preventDefault(), y.stopPropagation();
    const v = document.getElementById(o.link.substring(1));
    v && v.scrollIntoView({ behavior: "smooth" });
  }), /* @__PURE__ */ h.jsx(
    Va,
    {
      className: te("banner-section", r, i, e, {
        "has-image": n,
        "image-full-width": n && u.imageFullWidth,
        "image-inline": n && !u.imageFullWidth,
        "has-cta": p,
        "has-extra-spacing": r !== "subtle" && i === "normal" && f.eyebrow && f.title
      }),
      children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        /* @__PURE__ */ h.jsxs("div", { className: "content-wrapper", children: [
          c.map((y) => {
            if (f[y] && typeof f[y] == "object") {
              const { text: v, element: E = "" } = f[y];
              return y === "text" ? /* @__PURE__ */ h.jsx(Fs, { overrideType: "text-only", className: "text", children: v }, y) : M.createElement(E, { key: y, className: y }, v);
            }
            return null;
          }),
          l,
          p && /* @__PURE__ */ h.jsx(
            je,
            {
              variant: n || ["light", "subtle"].includes(r) ? "primary" : "secondary",
              size: { mobile: "medium", 768: "large" },
              href: o.link,
              ...o.props,
              className: te({
                new: r === "subtle",
                [(g = o.props) == null ? void 0 : g.className]: (m = o.props) == null ? void 0 : m.className
              }),
              children: o.text
            }
          )
        ] }),
        n && /* @__PURE__ */ h.jsx(
          za,
          {
            image: {
              ...n,
              aspect: u.imageFullWidth ? "banner" : n.aspect || void 0
            }
          }
        )
      ] })
    }
  );
}, Mae = mr(fie);
const Lae = ({
  image: e,
  variant: t = "default",
  children: n,
  className: r = ""
}) => {
  const i = {};
  return e && (i["--image"] = `url(${e})`), /* @__PURE__ */ h.jsx(
    Va,
    {
      className: te("custom-content-banner", t, r, {
        "has-image": e
      }),
      style: i,
      children: /* @__PURE__ */ h.jsx("div", { className: "content-slim", children: n })
    }
  );
};
const hie = ({
  alignImage: e = "left",
  className: t,
  content: n,
  image: r
}) => {
  const i = typeof n == "string" ? /* @__PURE__ */ h.jsx(Fs, { children: n }) : n;
  return /* @__PURE__ */ h.jsxs(Va, { className: te("highlight-section", t), children: [
    r && /* @__PURE__ */ h.jsx(
      "div",
      {
        className: te("highlight-container highlight-image", {
          [`highlight-image-${e}`]: e === "right"
        }),
        children: /* @__PURE__ */ h.jsx(
          za,
          {
            image: {
              ...r,
              description: "",
              query: "q=85",
              aspect: "highlightSection"
            }
          }
        )
      }
    ),
    /* @__PURE__ */ h.jsx(
      "div",
      {
        className: te("highlight-container highlight-content-wrapper", {
          "no-image": !r
        }),
        children: /* @__PURE__ */ h.jsx(
          "div",
          {
            className: te("highlight-content", {
              "highlight-content-right": e === "left"
            }),
            children: r ? i : /* @__PURE__ */ h.jsx("div", { className: "content-default", children: i })
          }
        )
      }
    )
  ] });
}, $ae = mr(hie);
const jae = ({
  variant: e = "primary",
  button: t = null,
  title: n,
  text: r,
  gtmContext: i
}) => !n && !r ? null : /* @__PURE__ */ h.jsxs("aside", { className: te("marketing-block", e), children: [
  n && /* @__PURE__ */ h.jsx("p", { className: "title", children: n }),
  r && /* @__PURE__ */ h.jsx("p", { children: r }),
  t && /* @__PURE__ */ h.jsx(
    je,
    {
      variant: t.variant || "secondary",
      size: "medium",
      href: t.link,
      className: "gtm-trackable",
      "data-gtm-event-context": i,
      "data-gtm-event-type": "learn-more-click",
      children: t.text
    }
  )
] }), pie = ({ type: e, data: t }) => {
  const n = ye(), {
    answers: r,
    createdAt: i,
    dateHasPassed: a,
    isOngoingEvent: s,
    pill: o,
    readingTime: l,
    publishedDate: u,
    startDate: c
  } = t;
  if (e === "question") {
    const d = i && ih(i);
    return /* @__PURE__ */ h.jsxs("p", { className: "details answers", "data-testid": "question-answers", children: [
      n.formatMessage({ id: "card_answers" }, { number: r }),
      i && /* @__PURE__ */ h.jsxs("span", { "data-testid": "question-created-at", children: [
        " ",
        "·",
        " ",
        n.formatMessage(
          { id: "card_time_ago" },
          {
            time: d ? n.formatMessage(
              { id: `dates_${d.path}` },
              { number: d.number }
            ) : 0
          }
        )
      ] })
    ] });
  }
  if (c && !a || s)
    return /* @__PURE__ */ h.jsx("p", { className: "details", children: s ? n.formatMessage({ id: "card_bootcamp" }) : QE(c) });
  if (o)
    return /* @__PURE__ */ h.jsx(
      Ti,
      {
        variant: o === "free" ? "subtle" : "highlighted",
        className: o,
        "data-testid": "course-type",
        children: o
      }
    );
  if (l || u) {
    const d = u && ih(u);
    return /* @__PURE__ */ h.jsxs("ul", { className: "details", children: [
      l && /* @__PURE__ */ h.jsx("li", { "data-testid": "reading-time", children: n.formatMessage({ id: "card_time_read" }, { time: l }) }),
      u && /* @__PURE__ */ h.jsx("li", { "data-testid": "published-date", children: n.formatMessage(
        { id: "card_time_ago" },
        {
          time: d ? n.formatMessage(
            { id: `dates_${d.path}` },
            { number: d.number }
          ) : 0
        }
      ) })
    ] });
  }
  return null;
}, mie = {
  title: 66,
  text: 3e3,
  secondaryText: 1e3,
  partner: 34
}, n1 = {
  communityPage: {
    basePath: "/communities/",
    className: "communityPage",
    gtmEvent: "community"
  },
  customCard: {
    className: "custom",
    gtmEvent: "custom",
    length: {
      text: 335,
      secondaryText: 150
    }
  },
  event: {
    basePath: "/events/",
    className: "event",
    gtmEvent: "event"
  },
  microcourse: {
    basePath: "/microcourses/en/",
    className: "course",
    gtmEvent: "microcourse-overview"
    // 'overview' is needed for legacy reasons
  },
  courseJourney: {
    basePath: "/courses/",
    className: "course",
    gtmEvent: "microcourse-overview"
    // 'overview' is needed for legacy reasons
  },
  solutionArticle: {
    basePath: "/solution-articles/en/",
    className: "article",
    length: {
      title: 60
    },
    gtmEvent: "article"
  },
  qaQuestion: {
    basePath: "/questions-answers/",
    className: "question",
    length: {
      title: 190
    },
    gtmEvent: "q-and-a-question"
  },
  listPage: {
    basePath: "/list/en/",
    className: "list",
    gtmEvent: "list"
  },
  people: {
    basePath: "/profiles/",
    className: "people",
    length: {
      people: 1e3
    },
    gtmEvent: "person"
  },
  learningHub: {
    basePath: "/learning-hub/",
    className: "learning-hub",
    length: {
      title: 190
    },
    gtmEvent: "learning-hub"
  }
}, gie = ({ data: e, cta: t, link: n, gtmContext: r }) => {
  var m, y;
  const i = ye(), [a, s] = de({
    loading: !1,
    registered: e.registered || !1
  });
  pe(() => {
    e.registered && s((v) => ({ ...v, registered: !0 }));
  }, [e.registered]);
  const { customLinkText: o, startDate: l, dateHasPassed: u, pill: c, slug: d } = e, f = e.contentType;
  let p = "";
  if ((m = n1[f]) != null && m.gtmEvent && (p = n1[f].gtmEvent), l && u)
    return n ? /* @__PURE__ */ h.jsx(
      "a",
      {
        href: n,
        className: "details additional-link gtm-trackable",
        "data-gtm-event-context": `${r}-CarouselCard`,
        "data-gtm-event-type": `${p}-click`,
        children: o || i.formatMessage({ id: "card_watch" })
      }
    ) : null;
  if (f === "people")
    return n ? /* @__PURE__ */ h.jsx(
      je,
      {
        variant: "tertiary",
        size: "small",
        href: n,
        className: "gtm-trackable",
        "data-gtm-event-context": `${r}-Card-Button`,
        "data-gtm-event-type": `${p}-click`,
        children: o || i.formatMessage({ id: "card_cta_people" })
      }
    ) : null;
  const g = ["communityPage", "microcourse", "event"];
  if (t && t.onClick && g.includes(f) && c !== "premium") {
    const v = a.loading || a.registered || ((y = e == null ? void 0 : e.members) == null ? void 0 : y.isMember), E = async (b) => {
      var _;
      if (b.preventDefault(), b.stopPropagation(), window && // @ts-expect-error dataLayer is not in the TS for Window but definitely works as expected for GTM
      ((_ = window.dataLayer) == null || _.push({
        event: "gtm.click",
        "gtm.element": n,
        "gtm.elementClasses": "gtm-trackable",
        "gtm.elementUrl": n,
        EventType: `${r}-${f}-register-click`,
        EventContext: `${r}Page-${f}: ${d}`
      })), !(v || !t || !t.onClick)) {
        s((T) => ({ ...T, loading: !0 }));
        try {
          const T = await t.onClick(e);
          s(T === "success" ? () => ({ registered: !0, loading: !1 }) : (x) => ({ ...x, loading: !1 }));
        } catch {
          s((x) => ({ ...x, loading: !1 }));
        }
      }
    };
    return /* @__PURE__ */ h.jsx(
      "p",
      {
        className: te("cta-wrapper", {
          "has-member-section": e == null ? void 0 : e.members
        }),
        children: /* @__PURE__ */ h.jsx(
          je,
          {
            onClick: E,
            className: "gtm-trackable",
            size: "small",
            styling: { fullWidth: !0 },
            disabled: v,
            "data-gtm-event-context": `${r}Page-${f}: ${d}`,
            "data-gtm-event-type": `${r}-${f}-register-click`,
            "data-testid": "in-card-button",
            children: o || i.formatMessage({
              id: `card_cta_${f}${v ? `_${a.loading ? "loading" : "done"}` : ""}`
            })
          }
        )
      }
    );
  }
  return null;
};
function vie({ buildMemberData: e, communitySlug: t }) {
  const n = ye(), r = We(zt), [i, a] = de({
    count: "...",
    isMember: !1,
    memberType: ""
  });
  return pe(() => {
    e(t, typeof (r == null ? void 0 : r.id) < "u").then((s) => {
      if (!s)
        return;
      const { membersCount: o, role: l = "", pagination: u } = s;
      let c = 0;
      o ? c = o : u != null && u.total && (c = u == null ? void 0 : u.total), a({
        count: c.toString(),
        isMember: !!l,
        memberType: l
      });
    });
  }, [t, e]), /* @__PURE__ */ h.jsxs("span", { className: "member-information", children: [
    i.isMember && /* @__PURE__ */ h.jsx(
      Ti,
      {
        size: "small",
        variant: "registered",
        icon: (i == null ? void 0 : i.memberType) === "owner" ? "user" : "tick",
        children: n.formatMessage({ id: `card_member_type_${i.memberType}` })
      }
    ),
    /* @__PURE__ */ h.jsx("span", { className: "label member-count", children: n.formatMessage({ id: "card_member_count" }, { count: i.count }) })
  ] });
}
const JC = ({
  id: e = "",
  className: t = "",
  buildCardData: n,
  buildMemberData: r,
  card: i,
  cta: a,
  gtmContext: s = "Carousel",
  handleCardClick: o,
  meta: l
}) => {
  var S, F;
  const u = ye(), c = We(zt), d = !!(c != null && c.id), { isTabbable: f = !0, setFocus: p = !1 } = l || {}, g = M.useRef(null), [m, y] = de({
    data: null,
    isLoading: !0
  });
  pe(() => {
    n(i, d).then((H) => {
      y({ data: H, isLoading: !1 });
    }).catch(() => y((H) => ({ ...H, isLoading: !1 })));
  }, [i, d, n]);
  const { data: v, isLoading: E } = m;
  if (E || !v)
    return /* @__PURE__ */ h.jsx(
      Dr,
      {
        element: "li",
        className: "card-wrapper",
        "data-testid": "card-placeholder"
      }
    );
  o && !a && (a = {
    text: u.formatMessage({ id: `card_cta_${i.contentType}` }),
    onClick: o
  });
  const { contentType: b } = v;
  if (!b || !n1[b])
    return /* @__PURE__ */ h.jsx(Dr, { element: "li", className: "card-wrapper" });
  const {
    basePath: _ = "",
    className: T,
    length: x,
    gtmEvent: A
  } = n1[b];
  let R = f && v.slug ? `${v.locale ? `/${v.locale}` : ""}${_}${v.slug}` : !1;
  f && v.slug && (v.slug.slice(0, 4) === "http" || v.slug.slice(0, 2) === "//" || v.slug.slice(0, 6) === "mailto" || v.slug.slice(0, 3) === "tel") && (R = v.slug);
  const P = (H) => {
    if (R) {
      H.preventDefault(), H.stopPropagation();
      const q = H.currentTarget.getAttribute("data-url");
      window && // @ts-expect-error dataLayer is not in the TS for Window but definitely works as expected for GTM
      window.dataLayer.push({
        event: "gtm.click",
        "gtm.element": q,
        "gtm.elementClasses": "gtm-trackable",
        "gtm.elementUrl": q,
        EventType: `${s}-CarouselCard`,
        EventContext: `${A}-click`
      }), window.location.href = q;
    }
  }, L = { ...mie, ...x };
  let I = { className: "card" }, O = {};
  return R && (O = {
    href: R,
    className: "gtm-trackable",
    "data-gtm-event-context": `${s}-CarouselCard`,
    "data-gtm-event-type": `${A}-click`,
    "data-testid": "link"
  }, v.openInNewTab && (O.target = "_blank"), I = {
    onClick: P,
    className: "card gtm-trackable",
    "data-gtm-event-context": `${s}-CarouselCard`,
    "data-gtm-event-type": `${A}-click`
  }), p && (I = {
    ...I,
    tabIndex: "0"
  }, (S = g == null ? void 0 : g.current) == null || S.focus(), (F = g == null ? void 0 : g.current) == null || F.scrollIntoView({ behavior: "smooth" })), /* @__PURE__ */ h.jsx(
    "li",
    {
      className: te("card-wrapper text-medium", T, t, {
        "has-link": R,
        "no-link": !R,
        "has-image": v.banner
      }),
      "data-testid": `${b}-card`,
      children: /* @__PURE__ */ h.jsxs("div", { ...I, ref: g, "data-url": R, children: [
        /* @__PURE__ */ h.jsx(
          f7,
          {
            className: "card-label",
            contentType: b,
            customIcon: v.isPrivate ? "lock-locked" : v.customIcon,
            customLabel: v.customLabel
          }
        ),
        b === "communityPage" && (v == null ? void 0 : v.createdAt) && j3(v == null ? void 0 : v.createdAt, 60) && /* @__PURE__ */ h.jsx(Ti, { size: "small", variant: "information", "data-testid": "new-community", children: u.formatMessage({ id: "card_new" }) }),
        v.startDate && !v.isOngoingEvent && /* @__PURE__ */ h.jsx(
          Ti,
          {
            size: "small",
            variant: v.dateHasPassed ? "default" : "information",
            "data-testid": "date",
            children: v.dateHasPassed ? u.formatMessage({ id: "card_ended" }) : L3(v.startDate)
          }
        ),
        v.banner ? /* @__PURE__ */ h.jsxs("p", { className: "img", children: [
          v.registered && /* @__PURE__ */ h.jsx(Ti, { size: "small", variant: "registered", children: u.formatMessage({ id: "card_registered" }) }),
          /* @__PURE__ */ h.jsx(za, { image: { ...v.banner, description: "" } })
        ] }) : T === "people" ? /* @__PURE__ */ h.jsx(
          aa,
          {
            name: v.title || "",
            src: v.profile,
            "data-testid": "people-profile-picture"
          }
        ) : null,
        v.contributors && /* @__PURE__ */ h.jsx(
          c4,
          {
            contributors: { data: v.contributors },
            styling: {
              size: "small",
              showGap: T !== "question",
              showText: !0
            },
            multipleText: ["event", "solutionArticle"].includes(b) ? u.formatMessage({ id: `card_contributors_${b}` }) : void 0,
            "data-testid": "contributors"
          }
        ),
        v.partner && /* @__PURE__ */ h.jsx("p", { className: "partners", "data-testid": "partners", children: v.partner.length > 1 ? u.formatMessage(
          { id: "card_partner" },
          { partner: v.partner[0], number: v.partner.length - 1 }
        ) : cl(v.partner[0], L.partner) }),
        /* Text */
        ["title", "text", "secondaryText"].map((H) => {
          const q = v[H];
          if (!q)
            return null;
          const N = P3(H), Q = {
            key: H,
            className: N,
            "data-testid": N
          }, J = {
            wrapper: "p",
            forceWrapper: !0,
            forceInline: !0
          }, D = cl(
            q,
            L[H]
          );
          return ["title", "text"].includes(H) && R ? (J.wrapper = "a", /* @__PURE__ */ h.jsx("p", { ...Q, children: /* @__PURE__ */ h.jsx(Wr, { options: J, ...O, children: D }) })) : /* @__PURE__ */ h.jsx(Wr, { options: J, ...Q, children: D });
        }),
        i.contentType === "communityPage" && (i.slug || v.slug) && r && /* @__PURE__ */ h.jsx(
          vie,
          {
            communitySlug: i.slug || v.slug,
            buildMemberData: r
          }
        ),
        /* @__PURE__ */ h.jsx(pie, { type: T || "", data: v }),
        /* @__PURE__ */ h.jsx(gie, { data: v, cta: a, link: R || "", gtmContext: s })
      ] })
    }
  );
};
const yie = ({
  cards: e,
  cardTypes: t,
  className: n = "",
  gtmContext: r = "",
  ...i
}) => /* @__PURE__ */ h.jsx("ul", { className: te("card-block", n), children: e.map((a, s) => {
  const o = a.slug ? `${a.slug}-${t[s]}` : `${t[s]}-${s}`;
  return /* @__PURE__ */ h.jsx(
    JC,
    {
      id: o,
      card: { ...a, contentType: t[s] },
      meta: { setFocus: s === (i == null ? void 0 : i.focusCardIndex) },
      ...i
    },
    `${o}-${r}-${a.title}`
  );
}) }), Eie = (e, t, n, r) => {
  const i = t * n <= e, a = e < t * (n + 1), s = r.includes(Math.floor(e / t));
  return {
    inView: i && a,
    isLoaded: s
  };
}, bie = ({ id: e, title: t }) => {
  const n = ye();
  if (!t || !t.text)
    return null;
  const { text: r, element: i = "h2", variant: a = "default", size: s = "medium", link: o } = t;
  return M.createElement(i, {
    className: te("title", a, s, {
      "highlighted-title": a === "highlighted"
    }),
    children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      r,
      o && /* @__PURE__ */ h.jsx(
        "a",
        {
          href: o,
          className: "text-medium gtm-trackable",
          "data-gtm-event-context": "CarouselViewAll",
          "data-gtm-event-type": `${e || ia(r)}-view-all-click`,
          children: n.formatMessage({ id: "card_carousel_viewAll" })
        }
      )
    ] })
  });
};
const eh = {
  fourCards: 1024,
  threeCards: 769,
  twoCards: 480
};
let nc = null, th = null;
const Tie = ({
  id: e,
  cards: t,
  cardTypes: n,
  buildCardData: r,
  title: i,
  className: a,
  gtmContext: s,
  ...o
}) => {
  const l = ye(), u = "carousel_pagination_", [c, d] = de({
    cardsPerPage: 4,
    isLoading: !0
  }), { cardsPerPage: f, isLoading: p } = c, [g, m] = de({
    currentPage: 0,
    loadedPages: [0]
  }), { currentPage: y, loadedPages: v } = g, [E, b] = de(""), _ = t.length, T = Math.ceil(_ / f), x = Ue(null), A = Ua(!0, !0, x == null ? void 0 : x.current);
  pe(() => {
    let S = 1;
    A && (A >= eh.fourCards ? S = 4 : A >= eh.threeCards ? S = 3 : A >= eh.twoCards && (S = 2), S > _ && (S = _)), d((F) => ({
      ...F,
      cardsPerPage: S,
      isLoading: !1
    }));
  }, [A, _]);
  const R = (S = "next") => {
    th && clearTimeout(th);
    let F = y;
    if (typeof S == "string")
      if (S === "next")
        if (y < T - 1)
          F = y + 1;
        else
          return;
      else if (y > 0)
        F = y - 1;
      else
        return;
    else
      F = S;
    b(""), m((q) => ({
      ...q,
      currentPage: F,
      loadedPages: [.../* @__PURE__ */ new Set([...v, F])]
    }));
    const H = () => {
      const q = F * c.cardsPerPage, N = q + c.cardsPerPage;
      return t.slice(q, N).length;
    };
    th = setTimeout(() => {
      b(
        l.formatMessage(
          {
            id: `${u}ariaLive${typeof S == "string" ? "" : "_slide"}`
          },
          {
            direction: l.formatMessage({
              id: `${u}${typeof S == "string" ? S : "next"}`
            }),
            slide: typeof S == "string" ? 1 : S + 1,
            count: H()
          }
        )
      );
    }, 500);
  }, P = (S) => {
    nc = S.touches[0].clientX;
  }, L = (S) => {
    if (nc === null)
      return;
    const F = S.touches[0].clientX, H = nc - F;
    H > 5 ? R("next") : H < -5 && R("previous"), nc = null;
  }, I = {
    "--width": `${A || 0}px`,
    "--total-cards": _,
    "--cards-per-page": f,
    "--page": y
  };
  if (p)
    return /* @__PURE__ */ h.jsx(vp, { layout: `carousel${i ? "-with-title" : ""}` });
  const O = (S, F) => {
    var q;
    let H = null;
    return (q = S == null ? void 0 : S.sys) != null && q.id ? H = `card-${S.sys.id}` : S != null && S.slug ? H = `card-${S.slug}` : [n[F], S.contentType].includes("customCard") && (H = `card-${ia(`${S.title} ${S.createdAt}`)}-${F}`), H;
  };
  return /* @__PURE__ */ h.jsxs(
    "section",
    {
      ref: x,
      className: te("carousel-wrapper", a),
      "data-testid": "carousel",
      children: [
        /* @__PURE__ */ h.jsx(bie, { id: e, title: i }),
        /* @__PURE__ */ h.jsx(
          "ul",
          {
            className: "carousel",
            onTouchStart: P,
            onTouchMove: L,
            style: I,
            "data-testid": "carousel-list",
            children: t.map((S, F) => {
              let H = O(S, F);
              const { inView: q, isLoaded: N } = Eie(
                F,
                f,
                y,
                v
              );
              return H && (q || N) ? /* @__PURE__ */ h.jsx(
                JC,
                {
                  id: H,
                  card: { ...S, contentType: n[F] },
                  buildCardData: r,
                  gtmContext: s,
                  meta: { isTabbable: q },
                  ...o
                },
                H
              ) : (H = H || `${e}-card-${F}`, /* @__PURE__ */ h.jsx(
                Dr,
                {
                  element: "li",
                  className: "card-wrapper",
                  "data-testid": "card-placeholder"
                },
                H
              ));
            })
          }
        ),
        T <= 1 ? null : /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
          /* @__PURE__ */ h.jsxs("ul", { className: "controls", "data-testid": "carousel-controls", children: [
            /* @__PURE__ */ h.jsx("li", { className: "arrow previous", children: /* @__PURE__ */ h.jsx(
              je,
              {
                variant: "secondary",
                size: "large",
                icon: { icon: "chevron_left" },
                onClick: (S) => {
                  S.preventDefault(), S.stopPropagation(), R("previous");
                },
                screenreaderText: l.formatMessage({
                  id: `${u}previousSlide`
                }),
                disabled: y <= 0
              }
            ) }),
            [...Array(T)].map((S, F) => /* @__PURE__ */ h.jsx(
              "li",
              {
                "data-testid": "carousel-controls-button",
                children: /* @__PURE__ */ h.jsx(
                  "button",
                  {
                    className: te("page-indicator", {
                      selected: F === y
                    }),
                    onClick: (H) => {
                      H.preventDefault(), H.stopPropagation(), R(F);
                    },
                    children: /* @__PURE__ */ h.jsx(ht, { showOnFocus: !1, children: l.formatMessage(
                      { id: `${u}slide` },
                      { number: F + 1, total: T }
                    ) })
                  }
                )
              },
              `page-indicator-${F}`
            )),
            /* @__PURE__ */ h.jsx("li", { className: "arrow next", children: /* @__PURE__ */ h.jsx(
              je,
              {
                variant: "secondary",
                size: "large",
                icon: { icon: "chevron_right" },
                onClick: (S) => {
                  S.preventDefault(), S.stopPropagation(), R("next");
                },
                screenreaderText: l.formatMessage({
                  id: `${u}nextSlide`
                }),
                disabled: y >= T - 1
              }
            ) })
          ] }),
          /* @__PURE__ */ h.jsx(ht, { "aria-live": "polite", showOnFocus: !1, children: E })
        ] })
      ]
    }
  );
}, Hae = ({
  carousels: e = [],
  isLoading: t,
  title: n,
  className: r = "",
  ...i
}) => !e || !e.length ? null : e.map(
  ({ title: a, viewAllUrl: s, cards: o, cardsTypes: l }, u) => {
    const c = a ? ia(a) : `carousel-${u}`, d = u === e.length - 1;
    return t ? /* @__PURE__ */ h.jsxs(ll, { children: [
      /* @__PURE__ */ h.jsx(
        vp,
        {
          layout: `carousel${a ? "-with-title" : ""}`,
          "data-testid": "carousel-placeholder"
        }
      ),
      d ? null : /* @__PURE__ */ h.jsx(Zr, {})
    ] }, `placeholder-${c}`) : /* @__PURE__ */ h.jsxs(ll, { children: [
      /* @__PURE__ */ h.jsx(
        Tie,
        {
          cards: o,
          cardTypes: l,
          title: n != null && n.hidden ? {} : { ...n, text: a, link: s },
          ...i
        }
      ),
      d ? null : /* @__PURE__ */ h.jsx(Zr, {})
    ] }, `carousel-${c}`);
  }
);
const Uae = ({
  element: e = "div",
  className: t = "",
  card: n,
  gtmContext: r = "NarrowCard"
}) => {
  const { banner: i, title: a, text: s, isPrivate: o, slug: l } = n;
  let u = {};
  return l && (u = {
    onClick: (d) => {
      l && (d.preventDefault(), d.stopPropagation(), window.location.href = l);
    },
    tabIndex: "0",
    "data-gtm-event-context": `${r}-NarrowCard`,
    "data-gtm-event-type": `${r}-click`
  }), M.createElement(e, {
    className: te("narrow-card", t, {
      "has-link": l,
      "gtm-trackable": l,
      "no-link": !l
    }),
    ...u,
    children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx(
        "div",
        {
          className: te("img", {
            private: o,
            "no-image": !i
          }),
          children: i && /* @__PURE__ */ h.jsx(za, { image: i })
        }
      ),
      /* @__PURE__ */ h.jsxs("div", { className: "content", children: [
        a && /* @__PURE__ */ h.jsx("p", { className: "title text-medium", children: a }),
        s && /* @__PURE__ */ h.jsx("p", { className: "text text-medium", children: s })
      ] })
    ] })
  });
};
const zae = ({
  element: e = "p",
  data: {
    timeLeftToFinish: t,
    percentageCompleted: { inTime: n = 0, inLessons: r = 0 },
    shouldShowTimes: i = !0
  },
  graph: a,
  styling: s = {},
  className: o = ""
}) => {
  const l = ye();
  let u = i ? n : r;
  u > 99 ? u = 100 : u < 1 && (u = 0);
  const { highlightPercentage: c = !1 } = s;
  return M.createElement(e, {
    className: te("course-progression", o, {
      "highlight-percentage": c,
      "has-circle-graph": a === "circle"
    }),
    children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
      /* @__PURE__ */ h.jsx(
        o4,
        {
          progress: u,
          styling: {
            layout: a || "bar",
            size: a && a === "circle" ? "small" : "default"
          }
        }
      ),
      /* @__PURE__ */ h.jsx("span", { className: "percentage", children: l.formatMessage(
        { id: "courseProgression_done" },
        {
          percent: (d) => /* @__PURE__ */ h.jsx("strong", { children: d }),
          number: u
        }
      ) }),
      u < 100 && i && /* @__PURE__ */ h.jsx(
        d0,
        {
          time: t,
          appendedText: l.formatMessage({ id: "courseProgression_timeLeft" })
        }
      )
    ] })
  });
};
const _ie = ({
  element: e = "span",
  sectionId: t,
  subsectionId: n,
  title: r,
  className: i = ""
}) => M.createElement(e, {
  className: te("lesson-name", i),
  "data-number": `${t}.${n}`,
  children: r
});
const Cie = ({
  size: e = "default",
  completionTime: t,
  icon: n,
  optional: r,
  type: i,
  children: a
}) => {
  const s = ye(), o = hp(`lessonType_${i}`) ? s.formatMessage({ id: `lessonType_${i}` }) : F3(i || "");
  return /* @__PURE__ */ h.jsxs("small", { className: te("content-type", { [e]: e !== "default" }), children: [
    /* @__PURE__ */ h.jsx("span", { className: te("type", n), children: o }),
    " ",
    t > 0 && !r && /* @__PURE__ */ h.jsx(d0, { time: t }),
    " ",
    a ? /* @__PURE__ */ h.jsx("span", { className: "additional", children: a }) : null
  ] });
};
const qae = ({
  course: {
    articles: e,
    canAccessCourse: t,
    description: n,
    hideTimes: r,
    isEnrolled: i,
    sectionId: a,
    sectionTime: s,
    slug: o,
    timeLeft: l,
    title: u
  },
  quizScores: c
}) => {
  const d = ye(), f = "courseStructure_", p = u.toLowerCase().includes("course conclusion");
  return /* @__PURE__ */ h.jsxs(
    mp,
    {
      className: "course-structure",
      label: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
        /* @__PURE__ */ h.jsxs("small", { children: [
          d.formatMessage(
            { id: `${f}section${p ? "_end" : ""}` },
            { number: a }
          ),
          " ",
          !r && s >= 0 && /* @__PURE__ */ h.jsx("span", { className: "time", children: i && l === 0 ? d.formatMessage({ id: `${f}time_completed` }) : /* @__PURE__ */ h.jsx(
            d0,
            {
              time: s,
              appendedText: i ? d.formatMessage({ id: `${f}time_left` }) : ""
            }
          ) })
        ] }),
        /* @__PURE__ */ h.jsx("h3", { children: u })
      ] }),
      shouldAnimate: !0,
      children: [
        /* @__PURE__ */ h.jsx("p", { children: n }),
        /* @__PURE__ */ h.jsx("ol", { children: e && e.length > 0 && e.map(
          ({
            completed: g,
            completionTime: m,
            contentType: y,
            icon: v,
            image: E,
            isIntroduction: b,
            optional: _,
            slug: T,
            subsectionId: x,
            title: A,
            type: R
          }) => {
            const P = i && t || b, L = {};
            return E && (L.style = { "--image": `url(${E})` }), /* @__PURE__ */ h.jsx(
              "li",
              {
                className: te({
                  article: y === Ql.ARTICLE,
                  discussion: y === Ql.DISCUSSION,
                  quiz: y === Ql.QUIZ,
                  completed: g && y === Ql.ARTICLE,
                  locked: !P
                }),
                ...L,
                children: /* @__PURE__ */ h.jsx(
                  qa,
                  {
                    href: P ? `/microcourses/en/${o}/${T}` : void 0,
                    fallbackElement: "span",
                    className: "inner",
                    gtmContext: `MicrocourseOutline${R3(A)}`,
                    gtmType: "article-click",
                    children: /* @__PURE__ */ h.jsxs(h.Fragment, { children: [
                      /* @__PURE__ */ h.jsx(
                        _ie,
                        {
                          sectionId: a,
                          subsectionId: x,
                          title: A,
                          className: "course-title"
                        }
                      ),
                      " ",
                      /* @__PURE__ */ h.jsx(
                        Cie,
                        {
                          completionTime: m,
                          icon: v,
                          optional: _,
                          type: R,
                          children: c && c[T] && /* @__PURE__ */ h.jsx("span", { className: "quiz-score", children: `${c[T]}%` })
                        }
                      )
                    ] })
                  }
                )
              },
              T
            );
          }
        ) })
      ]
    }
  );
};
const Wae = ({
  isComplete: e = !1,
  onClick: t,
  ...n
}) => {
  const r = ye();
  return n["data-gtm-event-context"] || (n["data-gtm-event-context"] = "LessonIntroduction"), /* @__PURE__ */ h.jsx(
    je,
    {
      ...n,
      variant: "tertiary",
      icon: e ? { icon: "check-inside-circle_no-overlap_inverted" } : {
        icon: "check-inside-circle_no-overlap",
        hover: "check-inside-circle_no-overlap_inverted"
      },
      onClick: t,
      className: te("mark-complete-button center gtm-trackable", {
        completed: e
      }),
      "data-gtm-event-type": "mark-as-complete",
      disabled: e,
      children: r.formatMessage({ id: `markCompleteButton${e ? "_completed" : ""}` })
    }
  );
}, Vae = ({
  id: e,
  data: { jobTitle: t, name: n, organization: r, thumbnail: i }
}) => ({
  id: e,
  name: n,
  jobTitle: t,
  organization: r,
  image: { thumbnail: i }
}), FE = [
  {
    contentType: "solutionArticle",
    banner: {
      description: "",
      url: "//images.ctfassets.net/txbhe1wabmyx/kCcBdXurt3uOKu6NdTPm0/1b6d19179b21f98dbdadf2477c03d267/devin-avery-7gwqj0yyrhm-unsplash.jpg",
      width: 295,
      height: 180,
      type: "image/jpeg",
      aspect: "responsiveCard",
      query: "w=295&h=180&fit=thumb&f=center"
    },
    slug: "why-public-servants-must-learn-to-fail",
    contributors: ["community"]
  },
  {
    contentType: "solutionArticle",
    banner: {
      description: "",
      url: "//images.ctfassets.net/txbhe1wabmyx/12Y0W1K0zVcDKzgLZlbfyC/6eb0757a02cbeea19b1b42d7da04d553/ashkan-forouzani-m0l9nbcivuk-unsplash.jpg",
      width: 295,
      height: 180,
      type: "image/jpeg",
      aspect: "responsiveCard",
      query: "w=295&h=180&fit=thumb&f=center"
    },
    slug: "organisational-culture-change-and-failure",
    contributors: [{ name: "Mari-Liis", id: "bdb7509c-89ed-4633-8bc0-dbf11f5d9be1" }]
  },
  {
    contentType: "solutionArticle",
    banner: {
      description: "",
      url: "//images.ctfassets.net/txbhe1wabmyx/26TEwu0xVkbQDguuW89fY6/d54ce406cdd652d68979770d526398ab/nik-shuliahin-bunwp1bl0nc-unsplash.jpg",
      width: 295,
      height: 180,
      type: "image/jpeg",
      aspect: "responsiveCard",
      query: "w=295&h=180&fit=thumb&f=center"
    },
    slug: "how-to-learn-from-failure-without-causing-a-scandal",
    contributors: ["community"]
  }
];
const rc = "notFoundError_", Kae = () => {
  const e = ye(), t = [];
  return FE.forEach((n, r) => {
    n.title = e.formatMessage({ id: `${rc}post_${r + 1}` }), t.push("solutionArticle");
  }), /* @__PURE__ */ h.jsxs(
    Tre,
    {
      styling: { background: "bold", circle: "small", variant: "alt-2" },
      additionalContent: {
        appended: /* @__PURE__ */ h.jsxs(Va, { children: [
          /* @__PURE__ */ h.jsx(
            yie,
            {
              cards: FE,
              cardTypes: t,
              buildCardData: (n) => new Promise((r, i) => {
                r(n);
              })
            }
          ),
          /* @__PURE__ */ h.jsx(je, { href: "/solution-articles/", children: e.formatMessage({ id: `${rc}cta` }) })
        ] })
      },
      reportError: () => {
      },
      className: "not-found-error",
      children: [
        /* @__PURE__ */ h.jsx("h1", { children: e.formatMessage({ id: `${rc}title` }) }),
        /* @__PURE__ */ h.jsx("p", { children: e.formatMessage({ id: `${rc}text` }) })
      ]
    }
  );
};
export {
  _i as ASSETS_URL,
  qR as ActionBar,
  Uo as ActionButton,
  Qie as ActivitiesFeed,
  Oae as ActivitySection,
  Rl as ActivityType,
  QC as AddPost,
  L7 as Badge,
  Cn as BadgeScope,
  $7 as Badges,
  t4 as BadgesContext,
  T7 as BadgesProvider,
  Bae as Banner,
  Mae as BannerSection,
  oae as Breadcrumbs,
  Kie as Buckets,
  je as Button,
  Il as ButtonWrapper,
  Ql as COURSE_CONTENT_TYPES,
  _7 as CacheProvider,
  JC as Card,
  yie as CardBlock,
  Hae as Carousel,
  I4 as CharacterLimit,
  P4 as Checkbox,
  mp as CollapsibleSection,
  JR as Columns,
  Zie as CommunityDetails,
  z7 as ConnectionCta,
  s4 as ConnectionDirectionType,
  a4 as ConnectionStatusType,
  pae as ContactFooter,
  dR as ContactForm,
  f7 as ContentTypeLabel,
  c4 as Contributors,
  u0 as ConversationContext,
  tF as CookieBanner,
  zae as CourseProgression,
  qae as CourseStructure,
  Lae as CustomContentBanner,
  rn as CustomEvents,
  kc as DELETED_USER_ID,
  Iae as Directory,
  et as DiscussionContentType,
  Rre as DiscussionConversation,
  j1 as DiscussionForm,
  Vre as DiscussionFormCard,
  sie as DiscussionFormModal,
  H1 as DiscussionPost,
  Yre as DiscussionThread,
  Kt as DiscussionType,
  Zr as Divider,
  dae as DownloadSection,
  Io as EMAILS,
  fae as EditSection,
  N6 as EmailHelperTextBox,
  Ci as EmptyStateBox,
  dT as EnrichedUrl,
  A7 as FeatureFlags,
  WR as Filters,
  w7 as FlagsProvider,
  pT as Footer,
  ti as Form,
  ne as Formatting,
  br as Fragment,
  Va as FullWidthSection,
  _0 as GET_STREAM_USER_PREFIX,
  Yie as GlobalProviders,
  VC as Header,
  h7 as HelperTextBox,
  dp as HiddenFromScreenReaders,
  p7 as HideShowTextBox,
  $ae as HighlightSection,
  ur as HighlightedTextBox,
  B3 as INVALID_TOKEN,
  Gie as IconBulletedList,
  qie as ImageContainer,
  k7 as IntlProvider,
  hR as InviteForm,
  Nae as InviteModal,
  C4 as JoinButton,
  Nh as Label,
  r4 as LanguageContext,
  lae as LanguageSwitcher,
  _ie as LessonName,
  Cie as LessonType,
  v6 as LikesButton,
  $R as LikesFeed,
  jR as LikesModal,
  qa as Link,
  c1 as LoadMore,
  V7 as LoadingBlock,
  Dr as LoadingPlaceholder,
  vp as LoadingState,
  fT as Logo,
  hae as LogoSection,
  Cre as MEMBERS_PER_PAGE,
  M3 as MENTION_REGEX,
  Wae as MarkCompleteButton,
  Fs as MarkdownText,
  jae as MarketingBlock,
  Ei as Marks,
  ea as Member,
  wre as MembersList,
  d4 as Modal,
  Ph as MoreMenu,
  Uie as NUMBER_OF_COUNTRIES,
  Hie as NUMBER_OF_USERS,
  Uae as NarrowCard,
  YR as NavigationMenu,
  Kae as NotFoundError,
  sa as Overlay,
  i4 as OverlayContext,
  N7 as OverlayProvider,
  F7 as PageHeading,
  Tre as PageLayout,
  M6 as Password,
  rae as PasswordForm,
  H6 as PasswordRules,
  Ti as Pill,
  jre as Poll,
  l7 as Popover,
  Pl as Portal,
  pR as ProfileForm,
  cR as ProfileImageChange,
  c0 as ProfileModal,
  XC as ProfileModalLauncher,
  aa as ProfilePicture,
  o4 as ProgressBar,
  Wie as ProgressTracker,
  iae as PublishArticleForm,
  eae as Rating,
  BR as RepliesFeed,
  Gre as ResponsesHeading,
  za as ResponsiveImage,
  lp as ResultsVisibility,
  Vie as ReturnToNavButton,
  lT as RichTextEditor,
  ZE as STORAGE_KEYS,
  vR as SearchForm,
  zR as ShareLink,
  uae as ShareLinks,
  Pae as ShowEmail,
  aae as SignupForm,
  I0 as Span,
  pl as StatusBanner,
  Fae as TableOfContents,
  cae as Tabs,
  Dae as Tags,
  Rae as TestimonialBlock,
  d0 as TimeToComplete,
  nae as Toggle,
  Ys as Tooltip,
  mae as TopLevelPage,
  Rs as UUID_V4_REGEX,
  zt as UserContext,
  D7 as UserProvider,
  ht as VisuallyHidden,
  Gx as addAriaProps,
  Nl as basicReducer,
  P3 as camelCaseToDashCase,
  hp as checkIntlPathExists,
  t6 as constructActivityContent,
  Jie as courseDiscussionRepliesFeedMock,
  ZC as enrichPostCategories,
  Pd as generateConditions,
  zie as generateCssIcon,
  x4 as getActivityPollOptions,
  Fl as getAuthorData,
  O6 as getCharacterLimitProps,
  QE as getLongDate,
  yp as getMember,
  YC as getPostBody,
  L3 as getShortDate,
  kp as getValueLength,
  ol as headerData,
  sae as likesResponseMock,
  Vae as mapGetStreamData,
  r7 as pageReady,
  x0 as passwordValidator,
  Xie as repliesFeedMock,
  R3 as toCamelCase,
  jie as toCapitalisedCase,
  F3 as toSentenceCase,
  J0 as transformSlugs,
  _6 as useActivitiesFeed,
  k3 as useAutoResize,
  b7 as useBadges,
  D3 as useCurrentPath,
  dl as useEffectAfterMount,
  Ua as useElementWidth,
  fp as useHomepagePath,
  O7 as useOverlay,
  N3 as useScrollListener,
  VE as useScrollToHash,
  KE as useTooltips,
  gp as useUser
};
